export const DataForPreview = {'30 Largest Cities in 2018': {'headers': ['Index',
'Year',
'Rank\nOrder',
'Country\ncode',
'Country or Area',
'City code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
'Population (millions)'],
'data': [{'Index': 1,
 'Year': 1950,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 5.16614},
{'Index': 2,
 'Year': 1955,
 'Rank\nOrder': 5,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 5.910271},
{'Index': 3,
 'Year': 1960,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 6.761837},
{'Index': 4,
 'Year': 1965,
 'Rank\nOrder': 5,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 7.548511},
{'Index': 5,
 'Year': 1970,
 'Rank\nOrder': 5,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 8.41617},
{'Index': 6,
 'Year': 1975,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 9.143219},
{'Index': 7,
 'Year': 1980,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 9.919781},
{'Index': 8,
 'Year': 1985,
 'Rank\nOrder': 7,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 10.523442},
{'Index': 9,
 'Year': 1990,
 'Rank\nOrder': 7,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 11.147566},
{'Index': 10,
 'Year': 1995,
 'Rank\nOrder': 10,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 11.806407},
{'Index': 11,
 'Year': 2000,
 'Rank\nOrder': 11,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 12.503871},
{'Index': 12,
 'Year': 2005,
 'Rank\nOrder': 11,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 13.32954},
{'Index': 13,
 'Year': 2010,
 'Rank\nOrder': 12,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 14.245871},
{'Index': 14,
 'Year': 2015,
 'Rank\nOrder': 12,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 14.705533},
{'Index': 15,
 'Year': 2020,
 'Rank\nOrder': 15,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 15.153729},
{'Index': 16,
 'Year': 2025,
 'Rank\nOrder': 18,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 15.752275},
{'Index': 17,
 'Year': 2030,
 'Rank\nOrder': 20,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 16.456115},
{'Index': 18,
 'Year': 2035,
 'Rank\nOrder': 21,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 1.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 17.127741},
{'Index': 19,
 'Year': 1950,
 'Rank\nOrder': 27,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 0.33576},
{'Index': 20,
 'Year': 1955,
 'Rank\nOrder': 28,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 0.408866},
{'Index': 21,
 'Year': 1960,
 'Rank\nOrder': 28,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 0.507921},
{'Index': 22,
 'Year': 1965,
 'Rank\nOrder': 28,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 0.82074},
{'Index': 23,
 'Year': 1970,
 'Rank\nOrder': 28,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 1.373718},
{'Index': 24,
 'Year': 1975,
 'Rank\nOrder': 25,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 2.221055},
{'Index': 25,
 'Year': 1980,
 'Rank\nOrder': 23,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 3.265663},
{'Index': 26,
 'Year': 1985,
 'Rank\nOrder': 21,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 4.660384},
{'Index': 27,
 'Year': 1990,
 'Rank\nOrder': 20,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 6.620697},
{'Index': 28,
 'Year': 1995,
 'Rank\nOrder': 19,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 8.332474},
{'Index': 29,
 'Year': 2000,
 'Rank\nOrder': 15,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 10.284947},
{'Index': 30,
 'Year': 2005,
 'Rank\nOrder': 13,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 12.330879},
{'Index': 31,
 'Year': 2010,
 'Rank\nOrder': 11,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 14.730537},
{'Index': 32,
 'Year': 2015,
 'Rank\nOrder': 11,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 17.597177},
{'Index': 33,
 'Year': 2020,
 'Rank\nOrder': 6,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 21.00586},
{'Index': 34,
 'Year': 2025,
 'Rank\nOrder': 4,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 24.652864},
{'Index': 35,
 'Year': 2030,
 'Rank\nOrder': 4,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 28.07566},
{'Index': 36,
 'Year': 2035,
 'Rank\nOrder': 4,
 'Country\ncode': 50,
 'Country or Area': 'Bangladesh',
 'City code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 2.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (millions)': 31.233651},
{'Index': 37,
 'Year': 1950,
 'Rank\nOrder': 12,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 3.026195},
{'Index': 38,
 'Year': 1955,
 'Rank\nOrder': 12,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 3.687344},
{'Index': 39,
 'Year': 1960,
 'Rank\nOrder': 11,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 4.493182},
{'Index': 40,
 'Year': 1965,
 'Rank\nOrder': 11,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 5.522674},
{'Index': 41,
 'Year': 1970,
 'Rank\nOrder': 11,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 6.790519},
{'Index': 42,
 'Year': 1975,
 'Rank\nOrder': 10,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 7.733429},
{'Index': 43,
 'Year': 1980,
 'Rank\nOrder': 10,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 8.78387},
{'Index': 44,
 'Year': 1985,
 'Rank\nOrder': 10,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 9.241709},
{'Index': 45,
 'Year': 1990,
 'Rank\nOrder': 11,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 9.697487},
{'Index': 46,
 'Year': 1995,
 'Rank\nOrder': 13,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 10.431518},
{'Index': 47,
 'Year': 2000,
 'Rank\nOrder': 13,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 11.306768},
{'Index': 48,
 'Year': 2005,
 'Rank\nOrder': 15,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 11.831807},
{'Index': 49,
 'Year': 2010,
 'Rank\nOrder': 16,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 12.373884},
{'Index': 50,
 'Year': 2015,
 'Rank\nOrder': 17,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 12.940796},
{'Index': 51,
 'Year': 2020,
 'Rank\nOrder': 21,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 13.458075},
{'Index': 52,
 'Year': 2025,
 'Rank\nOrder': 24,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 13.923245},
{'Index': 53,
 'Year': 2030,
 'Rank\nOrder': 25,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 14.408259},
{'Index': 54,
 'Year': 2035,
 'Rank\nOrder': 25,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 14.81018},
{'Index': 55,
 'Year': 1950,
 'Rank\nOrder': 15,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 2.334038},
{'Index': 56,
 'Year': 1955,
 'Rank\nOrder': 13,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 3.043828},
{'Index': 57,
 'Year': 1960,
 'Rank\nOrder': 13,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 3.969759},
{'Index': 58,
 'Year': 1965,
 'Rank\nOrder': 12,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 5.49415},
{'Index': 59,
 'Year': 1970,
 'Rank\nOrder': 8,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 7.62049},
{'Index': 60,
 'Year': 1975,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 9.614016},
{'Index': 61,
 'Year': 1980,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 12.089454},
{'Index': 62,
 'Year': 1985,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 13.394815},
{'Index': 63,
 'Year': 1990,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 14.77584},
{'Index': 64,
 'Year': 1995,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 15.913473},
{'Index': 65,
 'Year': 2000,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 17.014078},
{'Index': 66,
 'Year': 2005,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 18.288134},
{'Index': 67,
 'Year': 2010,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 19.659808},
{'Index': 68,
 'Year': 2015,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 20.883046},
{'Index': 69,
 'Year': 2020,
 'Rank\nOrder': 4,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 22.043028},
{'Index': 70,
 'Year': 2025,
 'Rank\nOrder': 6,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 22.990007},
{'Index': 71,
 'Year': 2030,
 'Rank\nOrder': 9,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 23.824223},
{'Index': 72,
 'Year': 2035,
 'Rank\nOrder': 10,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 24.490136},
{'Index': 73,
 'Year': 1950,
 'Rank\nOrder': 16,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 1.671365},
{'Index': 74,
 'Year': 1955,
 'Rank\nOrder': 16,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 2.364625},
{'Index': 75,
 'Year': 1960,
 'Rank\nOrder': 14,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 3.900441},
{'Index': 76,
 'Year': 1965,
 'Rank\nOrder': 15,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 4.582017},
{'Index': 77,
 'Year': 1970,
 'Rank\nOrder': 15,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 4.426045},
{'Index': 78,
 'Year': 1975,
 'Rank\nOrder': 16,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 4.827973},
{'Index': 79,
 'Year': 1980,
 'Rank\nOrder': 18,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 5.366372},
{'Index': 80,
 'Year': 1985,
 'Rank\nOrder': 19,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 6.017488},
{'Index': 81,
 'Year': 1990,
 'Rank\nOrder': 19,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 6.787737},
{'Index': 82,
 'Year': 1995,
 'Rank\nOrder': 18,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 8.355148},
{'Index': 83,
 'Year': 2000,
 'Rank\nOrder': 14,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 10.285091},
{'Index': 84,
 'Year': 2005,
 'Rank\nOrder': 12,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 12.991292},
{'Index': 85,
 'Year': 2010,
 'Rank\nOrder': 10,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 16.441252},
{'Index': 86,
 'Year': 2015,
 'Rank\nOrder': 10,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 18.421198},
{'Index': 87,
 'Year': 2020,
 'Rank\nOrder': 8,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 20.46261},
{'Index': 88,
 'Year': 2025,
 'Rank\nOrder': 8,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 22.596455},
{'Index': 89,
 'Year': 2030,
 'Rank\nOrder': 7,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 24.281913},
{'Index': 90,
 'Year': 2035,
 'Rank\nOrder': 9,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 3.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 25.36592},
{'Index': 91,
 'Year': 1950,
 'Rank\nOrder': 17,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 1.566966},
{'Index': 92,
 'Year': 1955,
 'Rank\nOrder': 18,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 1.913248},
{'Index': 93,
 'Year': 1960,
 'Rank\nOrder': 19,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 2.275158},
{'Index': 94,
 'Year': 1965,
 'Rank\nOrder': 21,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 2.188064},
{'Index': 95,
 'Year': 1970,
 'Rank\nOrder': 23,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 2.237344},
{'Index': 96,
 'Year': 1975,
 'Rank\nOrder': 23,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 2.544566},
{'Index': 97,
 'Year': 1980,
 'Rank\nOrder': 24,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 2.9614},
{'Index': 98,
 'Year': 1985,
 'Rank\nOrder': 25,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 3.44623},
{'Index': 99,
 'Year': 1990,
 'Rank\nOrder': 26,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 4.010602},
{'Index': 100,
 'Year': 1995,
 'Rank\nOrder': 24,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 5.615367},
{'Index': 101,
 'Year': 2000,
 'Rank\nOrder': 22,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 7.862976},
{'Index': 102,
 'Year': 2005,
 'Rank\nOrder': 21,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 9.454076},
{'Index': 103,
 'Year': 2010,
 'Rank\nOrder': 20,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 11.243667},
{'Index': 104,
 'Year': 2015,
 'Rank\nOrder': 16,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 13.372015},
{'Index': 105,
 'Year': 2020,
 'Rank\nOrder': 13,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 15.872179},
{'Index': 106,
 'Year': 2025,
 'Rank\nOrder': 12,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 18.171198},
{'Index': 107,
 'Year': 2030,
 'Rank\nOrder': 14,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 19.649097},
{'Index': 108,
 'Year': 2035,
 'Rank\nOrder': 14,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20484,
 'Urban Agglomeration': 'Chongqing',
 'Note': 4.0,
 'Latitude': 29.56278,
 'Longitude': 106.55278,
 'Population (millions)': 20.531266}]},
'30 Largest Cities': {'headers': ['Index',
'Year',
'Rank\nOrder',
'Country\ncode',
'Country or Area',
'City code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
'Population (millions)'],
'data': [{'Index': 1,
 'Year': 1950,
 'Rank\nOrder': 1,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 12.338471},
{'Index': 2,
 'Year': 1950,
 'Rank\nOrder': 2,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 11.274641},
{'Index': 3,
 'Year': 1950,
 'Rank\nOrder': 3,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 8.360847},
{'Index': 4,
 'Year': 1950,
 'Rank\nOrder': 4,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 7.005284},
{'Index': 5,
 'Year': 1950,
 'Rank\nOrder': 5,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 6.283018},
{'Index': 6,
 'Year': 1950,
 'Rank\nOrder': 6,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 5.356392},
{'Index': 7,
 'Year': 1950,
 'Rank\nOrder': 7,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 5.16614},
{'Index': 8,
 'Year': 1950,
 'Rank\nOrder': 8,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 4.99906},
{'Index': 9,
 'Year': 1950,
 'Rank\nOrder': 9,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 4.604143},
{'Index': 10,
 'Year': 1950,
 'Rank\nOrder': 10,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 4.288091},
{'Index': 11,
 'Year': 1950,
 'Rank\nOrder': 11,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 4.045514},
{'Index': 12,
 'Year': 1950,
 'Rank\nOrder': 12,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 3.365081},
{'Index': 13,
 'Year': 1950,
 'Rank\nOrder': 13,
 'Country\ncode': 276,
 'Country or Area': 'Germany',
 'City code': 204296,
 'Urban Agglomeration': 'Berlin',
 'Note': '',
 'Latitude': 52.52437,
 'Longitude': 13.41053,
 'Population (millions)': 3.337621},
{'Index': 14,
 'Year': 1950,
 'Rank\nOrder': 14,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 3.127806},
{'Index': 15,
 'Year': 1950,
 'Rank\nOrder': 15,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 3.088811},
{'Index': 16,
 'Year': 1950,
 'Rank\nOrder': 16,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 3.026195},
{'Index': 17,
 'Year': 1950,
 'Rank\nOrder': 17,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 2.902789},
{'Index': 18,
 'Year': 1950,
 'Rank\nOrder': 18,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22974,
 'Urban Agglomeration': 'Detroit',
 'Note': '',
 'Latitude': 42.387137,
 'Longitude': -83.102641,
 'Population (millions)': 2.769254},
{'Index': 19,
 'Year': 1950,
 'Rank\nOrder': 19,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22939,
 'Urban Agglomeration': 'Boston',
 'Note': '',
 'Latitude': 42.347919,
 'Longitude': -71.06453,
 'Population (millions)': 2.550818},
{'Index': 20,
 'Year': 1950,
 'Rank\nOrder': 20,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 2.493514},
{'Index': 21,
 'Year': 1950,
 'Rank\nOrder': 21,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20689,
 'Urban Agglomeration': 'Tianjin',
 'Note': 5.0,
 'Latitude': 39.108842,
 'Longitude': 117.18862,
 'Population (millions)': 2.467096},
{'Index': 22,
 'Year': 1950,
 'Rank\nOrder': 22,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22862,
 'Urban Agglomeration': 'Manchester',
 'Note': 8.0,
 'Latitude': 53.48095,
 'Longitude': -2.23743,
 'Population (millions)': 2.422246},
{'Index': 23,
 'Year': 1950,
 'Rank\nOrder': 23,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 2.334038},
{'Index': 24,
 'Year': 1950,
 'Rank\nOrder': 24,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 2.236878},
{'Index': 25,
 'Year': 1950,
 'Rank\nOrder': 25,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22835,
 'Urban Agglomeration': 'Birmingham (West Midlands)',
 'Note': 8.0,
 'Latitude': 52.4814,
 'Longitude': -1.8998,
 'Population (millions)': 2.228915},
{'Index': 26,
 'Year': 1950,
 'Rank\nOrder': 26,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20666,
 'Urban Agglomeration': 'Shenyang',
 'Note': 5.0,
 'Latitude': 41.79222,
 'Longitude': 123.43278,
 'Population (millions)': 2.147522},
{'Index': 27,
 'Year': 1950,
 'Rank\nOrder': 27,
 'Country\ncode': 380,
 'Country or Area': 'Italy',
 'City code': 21588,
 'Urban Agglomeration': 'Roma (Rome)',
 'Note': 9.0,
 'Latitude': 41.894743,
 'Longitude': 12.481142,
 'Population (millions)': 1.884065},
{'Index': 28,
 'Year': 1950,
 'Rank\nOrder': 28,
 'Country\ncode': 380,
 'Country or Area': 'Italy',
 'City code': 21571,
 'Urban Agglomeration': 'Milano (Milan)',
 'Note': 10.0,
 'Latitude': 45.55307,
 'Longitude': 9.18344,
 'Population (millions)': 1.88342},
{'Index': 29,
 'Year': 1950,
 'Rank\nOrder': 29,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23130,
 'Urban Agglomeration': 'San Francisco-Oakland',
 'Note': '',
 'Latitude': 37.759881,
 'Longitude': -122.437392,
 'Population (millions)': 1.855207},
{'Index': 30,
 'Year': 1950,
 'Rank\nOrder': 30,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22525,
 'Urban Agglomeration': 'Barcelona',
 'Note': '',
 'Latitude': 41.38879,
 'Longitude': 2.15899,
 'Population (millions)': 1.80939},
{'Index': 31,
 'Year': 1955,
 'Rank\nOrder': 1,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 13.712679},
{'Index': 32,
 'Year': 1955,
 'Rank\nOrder': 2,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 13.219362},
{'Index': 33,
 'Year': 1955,
 'Rank\nOrder': 3,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 8.622976},
{'Index': 34,
 'Year': 1955,
 'Rank\nOrder': 4,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 8.277908},
{'Index': 35,
 'Year': 1955,
 'Rank\nOrder': 5,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 6.796437},
{'Index': 36,
 'Year': 1955,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 5.910271},
{'Index': 37,
 'Year': 1955,
 'Rank\nOrder': 7,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 5.748746},
{'Index': 38,
 'Year': 1955,
 'Rank\nOrder': 8,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 5.712858},
{'Index': 39,
 'Year': 1955,
 'Rank\nOrder': 9,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 5.564573},
{'Index': 40,
 'Year': 1955,
 'Rank\nOrder': 10,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 5.219086},
{'Index': 41,
 'Year': 1955,
 'Rank\nOrder': 11,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 5.154301},
{'Index': 42,
 'Year': 1955,
 'Rank\nOrder': 12,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 4.293878},
{'Index': 43,
 'Year': 1955,
 'Rank\nOrder': 13,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 3.72621},
{'Index': 44,
 'Year': 1955,
 'Rank\nOrder': 14,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 3.687344},
{'Index': 45,
 'Year': 1955,
 'Rank\nOrder': 15,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 3.511099},
{'Index': 46,
 'Year': 1955,
 'Rank\nOrder': 16,
 'Country\ncode': 276,
 'Country or Area': 'Germany',
 'City code': 204296,
 'Urban Agglomeration': 'Berlin',
 'Note': '',
 'Latitude': 52.52437,
 'Longitude': 13.41053,
 'Population (millions)': 3.298503},
{'Index': 47,
 'Year': 1955,
 'Rank\nOrder': 17,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 3.140826},
{'Index': 48,
 'Year': 1955,
 'Rank\nOrder': 18,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22974,
 'Urban Agglomeration': 'Detroit',
 'Note': '',
 'Latitude': 42.387137,
 'Longitude': -83.102641,
 'Population (millions)': 3.139718},
{'Index': 49,
 'Year': 1955,
 'Rank\nOrder': 19,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 3.100066},
{'Index': 50,
 'Year': 1955,
 'Rank\nOrder': 20,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 3.043828},
{'Index': 51,
 'Year': 1955,
 'Rank\nOrder': 21,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 3.029198},
{'Index': 52,
 'Year': 1955,
 'Rank\nOrder': 22,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20689,
 'Urban Agglomeration': 'Tianjin',
 'Note': 5.0,
 'Latitude': 39.108842,
 'Longitude': 117.18862,
 'Population (millions)': 2.760676},
{'Index': 53,
 'Year': 1955,
 'Rank\nOrder': 23,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22939,
 'Urban Agglomeration': 'Boston',
 'Note': '',
 'Latitude': 42.347919,
 'Longitude': -71.06453,
 'Population (millions)': 2.680181},
{'Index': 54,
 'Year': 1955,
 'Rank\nOrder': 24,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22862,
 'Urban Agglomeration': 'Manchester',
 'Note': 8.0,
 'Latitude': 53.48095,
 'Longitude': -2.23743,
 'Population (millions)': 2.424868},
{'Index': 55,
 'Year': 1955,
 'Rank\nOrder': 25,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20666,
 'Urban Agglomeration': 'Shenyang',
 'Note': 5.0,
 'Latitude': 41.79222,
 'Longitude': 123.43278,
 'Population (millions)': 2.407477},
{'Index': 56,
 'Year': 1955,
 'Rank\nOrder': 26,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 11.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 2.364625},
{'Index': 57,
 'Year': 1955,
 'Rank\nOrder': 27,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22835,
 'Urban Agglomeration': 'Birmingham (West Midlands)',
 'Note': 8.0,
 'Latitude': 52.4814,
 'Longitude': -1.8998,
 'Population (millions)': 2.282582},
{'Index': 58,
 'Year': 1955,
 'Rank\nOrder': 28,
 'Country\ncode': 380,
 'Country or Area': 'Italy',
 'City code': 21588,
 'Urban Agglomeration': 'Roma (Rome)',
 'Note': 9.0,
 'Latitude': 41.894743,
 'Longitude': 12.481142,
 'Population (millions)': 2.142917},
{'Index': 59,
 'Year': 1955,
 'Rank\nOrder': 29,
 'Country\ncode': 344,
 'Country or Area': 'China, Hong Kong SAR',
 'City code': 21137,
 'Urban Agglomeration': 'Hong Kong',
 'Note': 12.0,
 'Latitude': 22.279588,
 'Longitude': 114.188697,
 'Population (millions)': 2.121568},
{'Index': 60,
 'Year': 1955,
 'Rank\nOrder': 30,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22525,
 'Urban Agglomeration': 'Barcelona',
 'Note': '',
 'Latitude': 41.38879,
 'Longitude': 2.15899,
 'Population (millions)': 2.102799},
{'Index': 61,
 'Year': 1960,
 'Rank\nOrder': 1,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 16.678821},
{'Index': 62,
 'Year': 1960,
 'Rank\nOrder': 2,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 14.163521},
{'Index': 63,
 'Year': 1960,
 'Rank\nOrder': 3,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 10.614841},
{'Index': 64,
 'Year': 1960,
 'Rank\nOrder': 4,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 8.195769},
{'Index': 65,
 'Year': 1960,
 'Rank\nOrder': 5,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 7.410735},
{'Index': 66,
 'Year': 1960,
 'Rank\nOrder': 6,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 6.865312},
{'Index': 67,
 'Year': 1960,
 'Rank\nOrder': 7,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 6.761837},
{'Index': 68,
 'Year': 1960,
 'Rank\nOrder': 8,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 6.529638},
{'Index': 69,
 'Year': 1960,
 'Rank\nOrder': 9,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 6.183153},
{'Index': 70,
 'Year': 1960,
 'Rank\nOrder': 10,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 6.169961},
{'Index': 71,
 'Year': 1960,
 'Rank\nOrder': 11,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 5.91021},
{'Index': 72,
 'Year': 1960,
 'Rank\nOrder': 12,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 5.479184},
{'Index': 73,
 'Year': 1960,
 'Rank\nOrder': 13,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 4.493182},
{'Index': 74,
 'Year': 1960,
 'Rank\nOrder': 14,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 4.414904},
{'Index': 75,
 'Year': 1960,
 'Rank\nOrder': 15,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 4.296736},
{'Index': 76,
 'Year': 1960,
 'Rank\nOrder': 16,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 3.969759},
{'Index': 77,
 'Year': 1960,
 'Rank\nOrder': 17,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 3.930026},
{'Index': 78,
 'Year': 1960,
 'Rank\nOrder': 18,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 11.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 3.900441},
{'Index': 79,
 'Year': 1960,
 'Rank\nOrder': 19,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 3.68016},
{'Index': 80,
 'Year': 1960,
 'Rank\nOrder': 20,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22974,
 'Urban Agglomeration': 'Detroit',
 'Note': '',
 'Latitude': 42.387137,
 'Longitude': -83.102641,
 'Population (millions)': 3.547879},
{'Index': 81,
 'Year': 1960,
 'Rank\nOrder': 21,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 3.398457},
{'Index': 82,
 'Year': 1960,
 'Rank\nOrder': 22,
 'Country\ncode': 276,
 'Country or Area': 'Germany',
 'City code': 204296,
 'Urban Agglomeration': 'Berlin',
 'Note': '',
 'Latitude': 52.52437,
 'Longitude': 13.41053,
 'Population (millions)': 3.259833},
{'Index': 83,
 'Year': 1960,
 'Rank\nOrder': 23,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20689,
 'Urban Agglomeration': 'Tianjin',
 'Note': 5.0,
 'Latitude': 39.108842,
 'Longitude': 117.18862,
 'Population (millions)': 2.935185},
{'Index': 84,
 'Year': 1960,
 'Rank\nOrder': 24,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22939,
 'Urban Agglomeration': 'Boston',
 'Note': '',
 'Latitude': 42.347919,
 'Longitude': -71.06453,
 'Population (millions)': 2.817995},
{'Index': 85,
 'Year': 1960,
 'Rank\nOrder': 25,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20666,
 'Urban Agglomeration': 'Shenyang',
 'Note': 5.0,
 'Latitude': 41.79222,
 'Longitude': 123.43278,
 'Population (millions)': 2.698983},
{'Index': 86,
 'Year': 1960,
 'Rank\nOrder': 26,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204586,
 'Urban Agglomeration': 'Kitakyushu-Fukuoka M.M.A.',
 'Note': '',
 'Latitude': 33.6064,
 'Longitude': 130.4181,
 'Population (millions)': 2.68078},
{'Index': 87,
 'Year': 1960,
 'Rank\nOrder': 27,
 'Country\ncode': 360,
 'Country or Area': 'Indonesia',
 'City code': 21454,
 'Urban Agglomeration': 'Jakarta',
 'Note': 13.0,
 'Latitude': -6.211831,
 'Longitude': 106.841646,
 'Population (millions)': 2.67874},
{'Index': 88,
 'Year': 1960,
 'Rank\nOrder': 28,
 'Country\ncode': 344,
 'Country or Area': 'China, Hong Kong SAR',
 'City code': 21137,
 'Urban Agglomeration': 'Hong Kong',
 'Note': 12.0,
 'Latitude': 22.279588,
 'Longitude': 114.188697,
 'Population (millions)': 2.611539},
{'Index': 89,
 'Year': 1960,
 'Rank\nOrder': 29,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22525,
 'Urban Agglomeration': 'Barcelona',
 'Note': '',
 'Latitude': 41.38879,
 'Longitude': 2.15899,
 'Population (millions)': 2.467926},
{'Index': 90,
 'Year': 1960,
 'Rank\nOrder': 30,
 'Country\ncode': 380,
 'Country or Area': 'Italy',
 'City code': 21588,
 'Urban Agglomeration': 'Roma (Rome)',
 'Note': 9.0,
 'Latitude': 41.894743,
 'Longitude': 12.481142,
 'Population (millions)': 2.455581},
{'Index': 91,
 'Year': 1965,
 'Rank\nOrder': 1,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 20.284371},
{'Index': 92,
 'Year': 1965,
 'Rank\nOrder': 2,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 15.176758},
{'Index': 93,
 'Year': 1965,
 'Rank\nOrder': 3,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 13.065322},
{'Index': 94,
 'Year': 1965,
 'Rank\nOrder': 4,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 7.868506},
{'Index': 95,
 'Year': 1965,
 'Rank\nOrder': 5,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 7.855185},
{'Index': 96,
 'Year': 1965,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 7.548511},
{'Index': 97,
 'Year': 1965,
 'Rank\nOrder': 7,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 7.407634},
{'Index': 98,
 'Year': 1965,
 'Rank\nOrder': 8,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 6.969157},
{'Index': 99,
 'Year': 1965,
 'Rank\nOrder': 9,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 6.638874},
{'Index': 100,
 'Year': 1965,
 'Rank\nOrder': 10,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 6.62178},
{'Index': 101,
 'Year': 1965,
 'Rank\nOrder': 11,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 6.589384},
{'Index': 102,
 'Year': 1965,
 'Rank\nOrder': 12,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 6.428131},
{'Index': 103,
 'Year': 1965,
 'Rank\nOrder': 13,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 5.954267},
{'Index': 104,
 'Year': 1965,
 'Rank\nOrder': 14,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 5.522674},
{'Index': 105,
 'Year': 1965,
 'Rank\nOrder': 15,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 5.49415},
{'Index': 106,
 'Year': 1965,
 'Rank\nOrder': 16,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 5.3143},
{'Index': 107,
 'Year': 1965,
 'Rank\nOrder': 17,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 4.737968},
{'Index': 108,
 'Year': 1965,
 'Rank\nOrder': 18,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 11.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 4.582017},
{'Index': 109,
 'Year': 1965,
 'Rank\nOrder': 19,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 4.160634},
{'Index': 110,
 'Year': 1965,
 'Rank\nOrder': 20,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22974,
 'Urban Agglomeration': 'Detroit',
 'Note': '',
 'Latitude': 42.387137,
 'Longitude': -83.102641,
 'Population (millions)': 3.758662},
{'Index': 111,
 'Year': 1965,
 'Rank\nOrder': 21,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204586,
 'Urban Agglomeration': 'Kitakyushu-Fukuoka M.M.A.',
 'Note': '',
 'Latitude': 33.6064,
 'Longitude': 130.4181,
 'Population (millions)': 3.704947},
{'Index': 112,
 'Year': 1965,
 'Rank\nOrder': 22,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 3.677061},
{'Index': 113,
 'Year': 1965,
 'Rank\nOrder': 23,
 'Country\ncode': 410,
 'Country or Area': 'Republic of Korea',
 'City code': 21758,
 'Urban Agglomeration': 'Seoul',
 'Note': 14.0,
 'Latitude': 37.56826,
 'Longitude': 126.97783,
 'Population (millions)': 3.452123},
{'Index': 114,
 'Year': 1965,
 'Rank\nOrder': 24,
 'Country\ncode': 360,
 'Country or Area': 'Indonesia',
 'City code': 21454,
 'Urban Agglomeration': 'Jakarta',
 'Note': 13.0,
 'Latitude': -6.211831,
 'Longitude': 106.841646,
 'Population (millions)': 3.296964},
{'Index': 115,
 'Year': 1965,
 'Rank\nOrder': 25,
 'Country\ncode': 276,
 'Country or Area': 'Germany',
 'City code': 204296,
 'Urban Agglomeration': 'Berlin',
 'Note': '',
 'Latitude': 52.52437,
 'Longitude': 13.41053,
 'Population (millions)': 3.232253},
{'Index': 116,
 'Year': 1965,
 'Rank\nOrder': 26,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20689,
 'Urban Agglomeration': 'Tianjin',
 'Note': 5.0,
 'Latitude': 39.108842,
 'Longitude': 117.18862,
 'Population (millions)': 3.12062},
{'Index': 117,
 'Year': 1965,
 'Rank\nOrder': 27,
 'Country\ncode': 344,
 'Country or Area': 'China, Hong Kong SAR',
 'City code': 21137,
 'Urban Agglomeration': 'Hong Kong',
 'Note': 12.0,
 'Latitude': 22.279588,
 'Longitude': 114.188697,
 'Population (millions)': 3.015435},
{'Index': 118,
 'Year': 1965,
 'Rank\nOrder': 28,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22939,
 'Urban Agglomeration': 'Boston',
 'Note': '',
 'Latitude': 42.347919,
 'Longitude': -71.06453,
 'Population (millions)': 3.000275},
{'Index': 119,
 'Year': 1965,
 'Rank\nOrder': 29,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22525,
 'Urban Agglomeration': 'Barcelona',
 'Note': '',
 'Latitude': 41.38879,
 'Longitude': 2.15899,
 'Population (millions)': 2.929523},
{'Index': 120,
 'Year': 1965,
 'Rank\nOrder': 30,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20666,
 'Urban Agglomeration': 'Shenyang',
 'Note': 5.0,
 'Latitude': 41.79222,
 'Longitude': 123.43278,
 'Population (millions)': 2.923968},
{'Index': 121,
 'Year': 1970,
 'Rank\nOrder': 1,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 23.297503},
{'Index': 122,
 'Year': 1970,
 'Rank\nOrder': 2,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 16.19118},
{'Index': 123,
 'Year': 1970,
 'Rank\nOrder': 3,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 15.27151},
{'Index': 124,
 'Year': 1970,
 'Rank\nOrder': 4,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 8.830947},
{'Index': 125,
 'Year': 1970,
 'Rank\nOrder': 5,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 8.41617},
{'Index': 126,
 'Year': 1970,
 'Rank\nOrder': 6,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 8.377685},
{'Index': 127,
 'Year': 1970,
 'Rank\nOrder': 7,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 8.208121},
{'Index': 128,
 'Year': 1970,
 'Rank\nOrder': 8,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 7.62049},
{'Index': 129,
 'Year': 1970,
 'Rank\nOrder': 9,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 7.509405},
{'Index': 130,
 'Year': 1970,
 'Rank\nOrder': 10,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 7.329372},
{'Index': 131,
 'Year': 1970,
 'Rank\nOrder': 11,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 7.106457},
{'Index': 132,
 'Year': 1970,
 'Rank\nOrder': 12,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 7.105799},
{'Index': 133,
 'Year': 1970,
 'Rank\nOrder': 13,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 6.790519},
{'Index': 134,
 'Year': 1970,
 'Rank\nOrder': 14,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 6.603381},
{'Index': 135,
 'Year': 1970,
 'Rank\nOrder': 15,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 6.412876},
{'Index': 136,
 'Year': 1970,
 'Rank\nOrder': 16,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 6.052468},
{'Index': 137,
 'Year': 1970,
 'Rank\nOrder': 17,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 5.584507},
{'Index': 138,
 'Year': 1970,
 'Rank\nOrder': 18,
 'Country\ncode': 410,
 'Country or Area': 'Republic of Korea',
 'City code': 21758,
 'Urban Agglomeration': 'Seoul',
 'Note': 14.0,
 'Latitude': 37.56826,
 'Longitude': 126.97783,
 'Population (millions)': 5.311569},
{'Index': 139,
 'Year': 1970,
 'Rank\nOrder': 19,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 11.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 4.426045},
{'Index': 140,
 'Year': 1970,
 'Rank\nOrder': 20,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 4.395851},
{'Index': 141,
 'Year': 1970,
 'Rank\nOrder': 21,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204586,
 'Urban Agglomeration': 'Kitakyushu-Fukuoka M.M.A.',
 'Note': '',
 'Latitude': 33.6064,
 'Longitude': 130.4181,
 'Population (millions)': 4.071699},
{'Index': 142,
 'Year': 1970,
 'Rank\nOrder': 22,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 3.980181},
{'Index': 143,
 'Year': 1970,
 'Rank\nOrder': 23,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22974,
 'Urban Agglomeration': 'Detroit',
 'Note': '',
 'Latitude': 42.387137,
 'Longitude': -83.102641,
 'Population (millions)': 3.966483},
{'Index': 144,
 'Year': 1970,
 'Rank\nOrder': 24,
 'Country\ncode': 360,
 'Country or Area': 'Indonesia',
 'City code': 21454,
 'Urban Agglomeration': 'Jakarta',
 'Note': 13.0,
 'Latitude': -6.211831,
 'Longitude': 106.841646,
 'Population (millions)': 3.915406},
{'Index': 145,
 'Year': 1970,
 'Rank\nOrder': 25,
 'Country\ncode': 608,
 'Country or Area': 'Philippines',
 'City code': 22109,
 'Urban Agglomeration': 'Manila',
 'Note': 15.0,
 'Latitude': 14.6042,
 'Longitude': 120.9822,
 'Population (millions)': 3.534309},
{'Index': 146,
 'Year': 1970,
 'Rank\nOrder': 26,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21228,
 'Urban Agglomeration': 'Delhi',
 'Note': 16.0,
 'Latitude': 28.66667,
 'Longitude': 77.21667,
 'Population (millions)': 3.530693},
{'Index': 147,
 'Year': 1970,
 'Rank\nOrder': 27,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22549,
 'Urban Agglomeration': 'Madrid',
 'Note': '',
 'Latitude': 40.4165,
 'Longitude': -3.70256,
 'Population (millions)': 3.520861},
{'Index': 148,
 'Year': 1970,
 'Rank\nOrder': 28,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22525,
 'Urban Agglomeration': 'Barcelona',
 'Note': '',
 'Latitude': 41.38879,
 'Longitude': 2.15899,
 'Population (millions)': 3.482047},
{'Index': 149,
 'Year': 1970,
 'Rank\nOrder': 29,
 'Country\ncode': 344,
 'Country or Area': 'China, Hong Kong SAR',
 'City code': 21137,
 'Urban Agglomeration': 'Hong Kong',
 'Note': 12.0,
 'Latitude': 22.279588,
 'Longitude': 114.188697,
 'Population (millions)': 3.397839},
{'Index': 150,
 'Year': 1970,
 'Rank\nOrder': 30,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20689,
 'Urban Agglomeration': 'Tianjin',
 'Note': 5.0,
 'Latitude': 39.108842,
 'Longitude': 117.18862,
 'Population (millions)': 3.317826},
{'Index': 151,
 'Year': 1975,
 'Rank\nOrder': 1,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 26.614733},
{'Index': 152,
 'Year': 1975,
 'Rank\nOrder': 2,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 16.298124},
{'Index': 153,
 'Year': 1975,
 'Rank\nOrder': 3,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 15.880271},
{'Index': 154,
 'Year': 1975,
 'Rank\nOrder': 4,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 10.73386},
{'Index': 155,
 'Year': 1975,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 9.614016},
{'Index': 156,
 'Year': 1975,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 9.143219},
{'Index': 157,
 'Year': 1975,
 'Rank\nOrder': 7,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 8.925518},
{'Index': 158,
 'Year': 1975,
 'Rank\nOrder': 8,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 8.557844},
{'Index': 159,
 'Year': 1975,
 'Rank\nOrder': 9,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 8.165629},
{'Index': 160,
 'Year': 1975,
 'Rank\nOrder': 10,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 7.733429},
{'Index': 161,
 'Year': 1975,
 'Rank\nOrder': 11,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 7.685346},
{'Index': 162,
 'Year': 1975,
 'Rank\nOrder': 12,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 7.622703},
{'Index': 163,
 'Year': 1975,
 'Rank\nOrder': 13,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 7.317947},
{'Index': 164,
 'Year': 1975,
 'Rank\nOrder': 14,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 7.160445},
{'Index': 165,
 'Year': 1975,
 'Rank\nOrder': 15,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 7.124383},
{'Index': 166,
 'Year': 1975,
 'Rank\nOrder': 16,
 'Country\ncode': 410,
 'Country or Area': 'Republic of Korea',
 'City code': 21758,
 'Urban Agglomeration': 'Seoul',
 'Note': 14.0,
 'Latitude': 37.56826,
 'Longitude': 126.97783,
 'Population (millions)': 6.807519},
{'Index': 167,
 'Year': 1975,
 'Rank\nOrder': 17,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 6.449922},
{'Index': 168,
 'Year': 1975,
 'Rank\nOrder': 18,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 5.658129},
{'Index': 169,
 'Year': 1975,
 'Rank\nOrder': 19,
 'Country\ncode': 608,
 'Country or Area': 'Philippines',
 'City code': 22109,
 'Urban Agglomeration': 'Manila',
 'Note': 15.0,
 'Latitude': 14.6042,
 'Longitude': 120.9822,
 'Population (millions)': 4.999303},
{'Index': 170,
 'Year': 1975,
 'Rank\nOrder': 20,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 11.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 4.827973},
{'Index': 171,
 'Year': 1975,
 'Rank\nOrder': 21,
 'Country\ncode': 360,
 'Country or Area': 'Indonesia',
 'City code': 21454,
 'Urban Agglomeration': 'Jakarta',
 'Note': 13.0,
 'Latitude': -6.211831,
 'Longitude': 106.841646,
 'Population (millions)': 4.813132},
{'Index': 172,
 'Year': 1975,
 'Rank\nOrder': 22,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204586,
 'Urban Agglomeration': 'Kitakyushu-Fukuoka M.M.A.',
 'Note': '',
 'Latitude': 33.6064,
 'Longitude': 130.4181,
 'Population (millions)': 4.609471},
{'Index': 173,
 'Year': 1975,
 'Rank\nOrder': 23,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 4.467008},
{'Index': 174,
 'Year': 1975,
 'Rank\nOrder': 24,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21228,
 'Urban Agglomeration': 'Delhi',
 'Note': 16.0,
 'Latitude': 28.66667,
 'Longitude': 77.21667,
 'Population (millions)': 4.436385},
{'Index': 175,
 'Year': 1975,
 'Rank\nOrder': 25,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 4.325423},
{'Index': 176,
 'Year': 1975,
 'Rank\nOrder': 26,
 'Country\ncode': 364,
 'Country or Area': 'Iran (Islamic Republic of)',
 'City code': 21523,
 'Urban Agglomeration': 'Tehran',
 'Note': '',
 'Latitude': 35.69439,
 'Longitude': 51.42151,
 'Population (millions)': 4.273048},
{'Index': 177,
 'Year': 1975,
 'Rank\nOrder': 27,
 'Country\ncode': 586,
 'Country or Area': 'Pakistan',
 'City code': 22044,
 'Urban Agglomeration': 'Karachi',
 'Note': '',
 'Latitude': 24.9056,
 'Longitude': 67.0822,
 'Population (millions)': 3.989191},
{'Index': 178,
 'Year': 1975,
 'Rank\nOrder': 28,
 'Country\ncode': 724,
 'Country or Area': 'Spain',
 'City code': 22549,
 'Urban Agglomeration': 'Madrid',
 'Note': '',
 'Latitude': 40.4165,
 'Longitude': -3.70256,
 'Population (millions)': 3.890208},
{'Index': 179,
 'Year': 1975,
 'Rank\nOrder': 29,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22974,
 'Urban Agglomeration': 'Detroit',
 'Note': '',
 'Latitude': 42.387137,
 'Longitude': -83.102641,
 'Population (millions)': 3.885119},
{'Index': 180,
 'Year': 1975,
 'Rank\nOrder': 30,
 'Country\ncode': 764,
 'Country or Area': 'Thailand',
 'City code': 22617,
 'Urban Agglomeration': 'Krung Thep (Bangkok)',
 'Note': '',
 'Latitude': 13.721964,
 'Longitude': 100.525248,
 'Population (millions)': 3.842023},
{'Index': 181,
 'Year': 1980,
 'Rank\nOrder': 1,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 21671,
 'Urban Agglomeration': 'Tokyo',
 'Note': 1.0,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (millions)': 28.548512},
{'Index': 182,
 'Year': 1980,
 'Rank\nOrder': 2,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 206459,
 'Urban Agglomeration': 'Kinki M.M.A. (Osaka)',
 'Note': 3.0,
 'Latitude': 34.675834,
 'Longitude': 135.553823,
 'Population (millions)': 17.027547},
{'Index': 183,
 'Year': 1980,
 'Rank\nOrder': 3,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23083,
 'Urban Agglomeration': 'New York-Newark',
 'Note': '',
 'Latitude': 40.717042,
 'Longitude': -74.003663,
 'Population (millions)': 15.601401},
{'Index': 184,
 'Year': 1980,
 'Rank\nOrder': 4,
 'Country\ncode': 484,
 'Country or Area': 'Mexico',
 'City code': 21853,
 'Urban Agglomeration': 'Ciudad de México (Mexico City)',
 'Note': 6.0,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (millions)': 13.02762},
{'Index': 185,
 'Year': 1980,
 'Rank\nOrder': 5,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20287,
 'Urban Agglomeration': 'São Paulo',
 'Note': '',
 'Latitude': -23.5475,
 'Longitude': -46.63611,
 'Population (millions)': 12.089454},
{'Index': 186,
 'Year': 1980,
 'Rank\nOrder': 6,
 'Country\ncode': 32,
 'Country or Area': 'Argentina',
 'City code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 4.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (millions)': 9.919781},
{'Index': 187,
 'Year': 1980,
 'Rank\nOrder': 7,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23052,
 'Urban Agglomeration': 'Los Angeles-Long Beach-Santa Ana',
 'Note': '',
 'Latitude': 34.031656,
 'Longitude': -118.241716,
 'Population (millions)': 9.511568},
{'Index': 188,
 'Year': 1980,
 'Rank\nOrder': 8,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21206,
 'Urban Agglomeration': 'Mumbai (Bombay)',
 'Note': '',
 'Latitude': 19.073975,
 'Longitude': 72.880838,
 'Population (millions)': 9.199543},
{'Index': 189,
 'Year': 1980,
 'Rank\nOrder': 9,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21211,
 'Urban Agglomeration': 'Kolkata (Calcutta)',
 'Note': '',
 'Latitude': 22.533455,
 'Longitude': 88.356045,
 'Population (millions)': 9.100166},
{'Index': 190,
 'Year': 1980,
 'Rank\nOrder': 10,
 'Country\ncode': 76,
 'Country or Area': 'Brazil',
 'City code': 20272,
 'Urban Agglomeration': 'Rio de Janeiro',
 'Note': '',
 'Latitude': -22.90278,
 'Longitude': -43.2075,
 'Population (millions)': 8.78387},
{'Index': 191,
 'Year': 1980,
 'Rank\nOrder': 11,
 'Country\ncode': 250,
 'Country or Area': 'France',
 'City code': 20985,
 'Urban Agglomeration': 'Paris',
 'Note': '',
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (millions)': 8.669349},
{'Index': 192,
 'Year': 1980,
 'Rank\nOrder': 12,
 'Country\ncode': 410,
 'Country or Area': 'Republic of Korea',
 'City code': 21758,
 'Urban Agglomeration': 'Seoul',
 'Note': 14.0,
 'Latitude': 37.56826,
 'Longitude': 126.97783,
 'Population (millions)': 8.244352},
{'Index': 193,
 'Year': 1980,
 'Rank\nOrder': 13,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22299,
 'Urban Agglomeration': 'Moskva (Moscow)',
 'Note': '',
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (millions)': 8.136141},
{'Index': 194,
 'Year': 1980,
 'Rank\nOrder': 14,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204583,
 'Urban Agglomeration': 'Chukyo M.M.A. (Nagoya)',
 'Note': '',
 'Latitude': 35.18147,
 'Longitude': 136.90641,
 'Population (millions)': 7.777328},
{'Index': 195,
 'Year': 1980,
 'Rank\nOrder': 15,
 'Country\ncode': 818,
 'Country or Area': 'Egypt',
 'City code': 22812,
 'Urban Agglomeration': 'Al-Qahirah (Cairo)',
 'Note': 7.0,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (millions)': 7.348778},
{'Index': 196,
 'Year': 1980,
 'Rank\nOrder': 16,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 22956,
 'Urban Agglomeration': 'Chicago',
 'Note': '',
 'Latitude': 41.85003,
 'Longitude': -87.65005,
 'Population (millions)': 7.21619},
{'Index': 197,
 'Year': 1980,
 'Rank\nOrder': 17,
 'Country\ncode': 826,
 'Country or Area': 'United Kingdom',
 'City code': 22860,
 'Urban Agglomeration': 'London',
 'Note': 2.0,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (millions)': 6.751196},
{'Index': 198,
 'Year': 1980,
 'Rank\nOrder': 18,
 'Country\ncode': 360,
 'Country or Area': 'Indonesia',
 'City code': 21454,
 'Urban Agglomeration': 'Jakarta',
 'Note': 13.0,
 'Latitude': -6.211831,
 'Longitude': 106.841646,
 'Population (millions)': 5.984256},
{'Index': 199,
 'Year': 1980,
 'Rank\nOrder': 19,
 'Country\ncode': 608,
 'Country or Area': 'Philippines',
 'City code': 22109,
 'Urban Agglomeration': 'Manila',
 'Note': 15.0,
 'Latitude': 14.6042,
 'Longitude': 120.9822,
 'Population (millions)': 5.954719},
{'Index': 200,
 'Year': 1980,
 'Rank\nOrder': 20,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20656,
 'Urban Agglomeration': 'Shanghai',
 'Note': 5.0,
 'Latitude': 31.22222,
 'Longitude': 121.45806,
 'Population (millions)': 5.927898},
{'Index': 201,
 'Year': 1980,
 'Rank\nOrder': 21,
 'Country\ncode': 356,
 'Country or Area': 'India',
 'City code': 21228,
 'Urban Agglomeration': 'Delhi',
 'Note': 16.0,
 'Latitude': 28.66667,
 'Longitude': 77.21667,
 'Population (millions)': 5.587014},
{'Index': 202,
 'Year': 1980,
 'Rank\nOrder': 22,
 'Country\ncode': 156,
 'Country or Area': 'China',
 'City code': 20464,
 'Urban Agglomeration': 'Beijing',
 'Note': 11.0,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (millions)': 5.366372},
{'Index': 203,
 'Year': 1980,
 'Rank\nOrder': 23,
 'Country\ncode': 364,
 'Country or Area': 'Iran (Islamic Republic of)',
 'City code': 21523,
 'Urban Agglomeration': 'Tehran',
 'Note': '',
 'Latitude': 35.69439,
 'Longitude': 51.42151,
 'Population (millions)': 5.079191},
{'Index': 204,
 'Year': 1980,
 'Rank\nOrder': 24,
 'Country\ncode': 586,
 'Country or Area': 'Pakistan',
 'City code': 22044,
 'Urban Agglomeration': 'Karachi',
 'Note': '',
 'Latitude': 24.9056,
 'Longitude': 67.0822,
 'Population (millions)': 5.047815},
{'Index': 205,
 'Year': 1980,
 'Rank\nOrder': 25,
 'Country\ncode': 392,
 'Country or Area': 'Japan',
 'City code': 204586,
 'Urban Agglomeration': 'Kitakyushu-Fukuoka M.M.A.',
 'Note': '',
 'Latitude': 33.6064,
 'Longitude': 130.4181,
 'Population (millions)': 4.725626},
{'Index': 206,
 'Year': 1980,
 'Rank\nOrder': 26,
 'Country\ncode': 764,
 'Country or Area': 'Thailand',
 'City code': 22617,
 'Urban Agglomeration': 'Krung Thep (Bangkok)',
 'Note': '',
 'Latitude': 13.721964,
 'Longitude': 100.525248,
 'Population (millions)': 4.723143},
{'Index': 207,
 'Year': 1980,
 'Rank\nOrder': 27,
 'Country\ncode': 643,
 'Country or Area': 'Russian Federation',
 'City code': 22365,
 'Urban Agglomeration': 'Sankt Peterburg (Saint Petersburg)',
 'Note': '',
 'Latitude': 59.929858,
 'Longitude': 30.326228,
 'Population (millions)': 4.644717},
{'Index': 208,
 'Year': 1980,
 'Rank\nOrder': 28,
 'Country\ncode': 840,
 'Country or Area': 'United States of America',
 'City code': 23098,
 'Urban Agglomeration': 'Philadelphia',
 'Note': '',
 'Latitude': 39.95234,
 'Longitude': -75.16379,
 'Population (millions)': 4.540082},
{'Index': 209,
 'Year': 1980,
 'Rank\nOrder': 29,
 'Country\ncode': 344,
 'Country or Area': 'China, Hong Kong SAR',
 'City code': 21137,
 'Urban Agglomeration': 'Hong Kong',
 'Note': 12.0,
 'Latitude': 22.279588,
 'Longitude': 114.188697,
 'Population (millions)': 4.496588},
{'Index': 210,
 'Year': 1980,
 'Rank\nOrder': 30,
 'Country\ncode': 604,
 'Country or Area': 'Peru',
 'City code': 22078,
 'Urban Agglomeration': 'Lima',
 'Note': 17.0,
 'Latitude': -12.04318,
 'Longitude': -77.02824,
 'Population (millions)': 4.437754}]},
'Age-specific fertility rates (births per 1,000 women)': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'Reference date (as of 1 July)',
'15-19',
'20-24'],
'data': [{'Index': 1,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2020-2025',
 '15-19': 39.6266,
 '20-24': 126.1131},
{'Index': 2,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2025-2030',
 '15-19': 36.6747,
 '20-24': 114.5528},
{'Index': 3,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2030-2035',
 '15-19': 34.5133,
 '20-24': 107.1929},
{'Index': 4,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2035-2040',
 '15-19': 32.6458,
 '20-24': 100.8854},
{'Index': 5,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2040-2045',
 '15-19': 31.1424,
 '20-24': 95.9042},
{'Index': 6,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2045-2050',
 '15-19': 29.694,
 '20-24': 91.9393},
{'Index': 7,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2050-2055',
 '15-19': 28.3213,
 '20-24': 88.6224},
{'Index': 8,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2055-2060',
 '15-19': 26.9594,
 '20-24': 85.7015},
{'Index': 9,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2060-2065',
 '15-19': 25.6038,
 '20-24': 82.8523},
{'Index': 10,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 'Reference date (as of 1 July)': '2065-2070',
 '15-19': 24.3027,
 '20-24': 80.076}]},
'Capital Cities': {'headers': ['Index',
'Country or area',
'Country code',
'Capital City',
'Note',
'Capital Type',
'City code',
'Latitude',
'Longitude',
'Population (thousands)'],
'data': [{'Index': 1,
 'Country or area': 'Afghanistan',
 'Country code': 4,
 'Capital City': 'Kabul',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20002,
 'Latitude': 34.528887,
 'Longitude': 69.17246,
 'Population (thousands)': 4011.77},
{'Index': 2,
 'Country or area': 'Albania',
 'Country code': 8,
 'Capital City': 'Tiranë (Tirana)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20005,
 'Latitude': 41.3275,
 'Longitude': 19.81889,
 'Population (thousands)': 475.577},
{'Index': 3,
 'Country or area': 'Algeria',
 'Country code': 12,
 'Capital City': 'El Djazaïr  (Algiers)',
 'Note': 1.0,
 'Capital Type': 'Capital',
 'City code': 20006,
 'Latitude': 36.7525,
 'Longitude': 3.04197,
 'Population (thousands)': 2693.542},
{'Index': 4,
 'Country or area': 'American Samoa',
 'Country code': 16,
 'Capital City': 'Pago Pago',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20047,
 'Latitude': -14.27806,
 'Longitude': -170.7025,
 'Population (thousands)': 48.526},
{'Index': 5,
 'Country or area': 'Andorra',
 'Country code': 20,
 'Capital City': 'Andorra la Vella',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20048,
 'Latitude': 42.50779,
 'Longitude': 1.52109,
 'Population (thousands)': 22.614},
{'Index': 6,
 'Country or area': 'Angola',
 'Country code': 24,
 'Capital City': 'Luanda',
 'Note': 2.0,
 'Capital Type': 'Capital',
 'City code': 20049,
 'Latitude': -8.83682,
 'Longitude': 13.23432,
 'Population (thousands)': 7774.2},
{'Index': 7,
 'Country or area': 'Anguilla',
 'Country code': 660,
 'Capital City': 'The Valley',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22407,
 'Latitude': 18.21704,
 'Longitude': -63.05783,
 'Population (thousands)': 1.402},
{'Index': 8,
 'Country or area': 'Antigua and Barbuda',
 'Country code': 28,
 'Capital City': "St. John's",
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20052,
 'Latitude': 17.11717,
 'Longitude': -61.84573,
 'Population (thousands)': 20.764},
{'Index': 9,
 'Country or area': 'Argentina',
 'Country code': 32,
 'Capital City': 'Buenos Aires',
 'Note': 3.0,
 'Capital Type': 'Capital',
 'City code': 20058,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 'Population (thousands)': 14966.53},
{'Index': 10,
 'Country or area': 'Armenia',
 'Country code': 51,
 'Capital City': 'Yerevan',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20140,
 'Latitude': 40.181998,
 'Longitude': 44.514619,
 'Population (thousands)': 1080.324},
{'Index': 11,
 'Country or area': 'Aruba',
 'Country code': 533,
 'Capital City': 'Oranjestad',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21954,
 'Latitude': 12.52398,
 'Longitude': -70.02703,
 'Population (thousands)': 29.877},
{'Index': 12,
 'Country or area': 'Australia',
 'Country code': 36,
 'Capital City': 'Canberra',
 'Note': 4.0,
 'Capital Type': 'Capital',
 'City code': 206175,
 'Latitude': -35.28346,
 'Longitude': 149.12807,
 'Population (thousands)': 447.692},
{'Index': 13,
 'Country or area': 'Austria',
 'Country code': 40,
 'Capital City': 'Wien (Vienna)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20107,
 'Latitude': 48.206443,
 'Longitude': 16.370725,
 'Population (thousands)': 1900.547},
{'Index': 14,
 'Country or area': 'Azerbaijan',
 'Country code': 31,
 'Capital City': 'Baku',
 'Note': 5.0,
 'Capital Type': 'Capital',
 'City code': 20053,
 'Latitude': 40.37767,
 'Longitude': 49.89201,
 'Population (thousands)': 2285.729},
{'Index': 15,
 'Country or area': 'Bahamas',
 'Country code': 44,
 'Capital City': 'Nassau',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20108,
 'Latitude': 25.05823,
 'Longitude': -77.34306,
 'Population (thousands)': 279.668},
{'Index': 16,
 'Country or area': 'Bahrain',
 'Country code': 48,
 'Capital City': 'Al-Manamah (Manama)',
 'Note': 6.0,
 'Capital Type': 'Capital',
 'City code': 20109,
 'Latitude': 26.21536,
 'Longitude': 50.5832,
 'Population (thousands)': 564.631},
{'Index': 17,
 'Country or area': 'Bangladesh',
 'Country code': 50,
 'Capital City': 'Dhaka',
 'Note': 7.0,
 'Capital Type': 'Capital',
 'City code': 20119,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 'Population (thousands)': 19578.421},
{'Index': 18,
 'Country or area': 'Barbados',
 'Country code': 52,
 'Capital City': 'Bridgetown',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20141,
 'Latitude': 13.1,
 'Longitude': -59.61667,
 'Population (thousands)': 89.201},
{'Index': 19,
 'Country or area': 'Belarus',
 'Country code': 112,
 'Capital City': 'Minsk',
 'Note': 5.0,
 'Capital Type': 'Capital',
 'City code': 20348,
 'Latitude': 53.9,
 'Longitude': 27.56667,
 'Population (thousands)': 2004.672},
{'Index': 20,
 'Country or area': 'Belgium',
 'Country code': 56,
 'Capital City': 'Bruxelles-Brussel',
 'Note': 8.0,
 'Capital Type': 'Capital',
 'City code': 20144,
 'Latitude': 50.846735,
 'Longitude': 4.349919,
 'Population (thousands)': 2049.51},
{'Index': 21,
 'Country or area': 'Belize',
 'Country code': 84,
 'Capital City': 'Belmopan',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20310,
 'Latitude': 17.25,
 'Longitude': -88.76667,
 'Population (thousands)': 22.964},
{'Index': 22,
 'Country or area': 'Benin',
 'Country code': 204,
 'Capital City': 'Cotonou',
 'Note': '',
 'Capital Type': 'Economic Capital',
 'City code': 20888,
 'Latitude': 6.36536,
 'Longitude': 2.41833,
 'Population (thousands)': 685.458},
{'Index': 23,
 'Country or area': 'Benin',
 'Country code': 204,
 'Capital City': 'Porto-Novo',
 'Note': '',
 'Capital Type': 'Constitutional Capital',
 'City code': 20891,
 'Latitude': 6.49646,
 'Longitude': 2.60359,
 'Population (thousands)': 285.328},
{'Index': 24,
 'Country or area': 'Bermuda',
 'Country code': 60,
 'Capital City': 'Hamilton',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20150,
 'Latitude': 32.29149,
 'Longitude': -64.77797,
 'Population (thousands)': 10.073},
{'Index': 25,
 'Country or area': 'Bhutan',
 'Country code': 64,
 'Capital City': 'Thimphu',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20151,
 'Latitude': 27.46609,
 'Longitude': 89.64191,
 'Population (thousands)': 203.297},
{'Index': 26,
 'Country or area': 'Bolivia (Plurinational State of)',
 'Country code': 68,
 'Capital City': 'La Paz',
 'Note': 9.0,
 'Capital Type': 'Seat of Government',
 'City code': 20153,
 'Latitude': -16.5,
 'Longitude': -68.15,
 'Population (thousands)': 1814.087},
{'Index': 27,
 'Country or area': 'Bolivia (Plurinational State of)',
 'Country code': 68,
 'Capital City': 'Sucre',
 'Note': '',
 'Capital Type': 'Constitutional Capital',
 'City code': 20158,
 'Latitude': -19.03332,
 'Longitude': -65.26274,
 'Population (thousands)': 277.91},
{'Index': 28,
 'Country or area': 'Bosnia and Herzegovina',
 'Country code': 70,
 'Capital City': 'Sarajevo',
 'Note': 10.0,
 'Capital Type': 'Capital',
 'City code': 20164,
 'Latitude': 43.84864,
 'Longitude': 18.35644,
 'Population (thousands)': 342.577},
{'Index': 29,
 'Country or area': 'Botswana',
 'Country code': 72,
 'Capital City': 'Gaborone',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20167,
 'Latitude': -24.65451,
 'Longitude': 25.90859,
 'Population (thousands)': 269.338},
{'Index': 30,
 'Country or area': 'Brazil',
 'Country code': 76,
 'Capital City': 'Brasília',
 'Note': 11.0,
 'Capital Type': 'Capital',
 'City code': 20187,
 'Latitude': -15.77972,
 'Longitude': -47.92972,
 'Population (thousands)': 4469.585},
{'Index': 31,
 'Country or area': 'British Virgin Islands',
 'Country code': 92,
 'Capital City': 'Road Town',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20313,
 'Latitude': 18.41667,
 'Longitude': -64.61667,
 'Population (thousands)': 15.137},
{'Index': 32,
 'Country or area': 'Brunei Darussalam',
 'Country code': 96,
 'Capital City': 'Bandar Seri Begawan',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20314,
 'Latitude': 4.94029,
 'Longitude': 114.94806,
 'Population (thousands)': 40.781},
{'Index': 33,
 'Country or area': 'Bulgaria',
 'Country code': 100,
 'Capital City': 'Sofia',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20327,
 'Latitude': 42.69751,
 'Longitude': 23.32415,
 'Population (thousands)': 1272.418},
{'Index': 34,
 'Country or area': 'Burkina Faso',
 'Country code': 854,
 'Capital City': 'Ouagadougou',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23192,
 'Latitude': 12.36423,
 'Longitude': -1.53834,
 'Population (thousands)': 2531.381},
{'Index': 35,
 'Country or area': 'Burundi',
 'Country code': 108,
 'Capital City': 'Bujumbura',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20340,
 'Latitude': -3.3822,
 'Longitude': 29.3644,
 'Population (thousands)': 898.968},
{'Index': 36,
 'Country or area': 'Cabo Verde',
 'Country code': 132,
 'Capital City': 'Praia',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20408,
 'Latitude': 14.92148,
 'Longitude': -23.50868,
 'Population (thousands)': 167.504},
{'Index': 37,
 'Country or area': 'Cambodia',
 'Country code': 116,
 'Capital City': 'Phnum Pénh (Phnom Penh)',
 'Note': 12.0,
 'Capital Type': 'Capital',
 'City code': 20357,
 'Latitude': 11.56245,
 'Longitude': 104.91601,
 'Population (thousands)': 1952.329},
{'Index': 38,
 'Country or area': 'Cameroon',
 'Country code': 120,
 'Capital City': 'Yaoundé',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20365,
 'Latitude': 3.86667,
 'Longitude': 11.51667,
 'Population (thousands)': 3655.656},
{'Index': 39,
 'Country or area': 'Canada',
 'Country code': 124,
 'Capital City': 'Ottawa-Gatineau',
 'Note': 13.0,
 'Capital Type': 'Capital',
 'City code': 20387,
 'Latitude': 45.416598,
 'Longitude': -75.697997,
 'Population (thousands)': 1363.159},
{'Index': 40,
 'Country or area': 'Caribbean Netherlands',
 'Country code': 535,
 'Capital City': 'Kralendijk',
 'Note': 14.0,
 'Capital Type': 'Capital',
 'City code': 206155,
 'Latitude': 12.15,
 'Longitude': -68.26667,
 'Population (thousands)': 11.313},
{'Index': 41,
 'Country or area': 'Cayman Islands',
 'Country code': 136,
 'Capital City': 'George Town',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20409,
 'Latitude': 19.2866,
 'Longitude': -81.37436,
 'Population (thousands)': 34.875},
{'Index': 42,
 'Country or area': 'Central African Republic',
 'Country code': 140,
 'Capital City': 'Bangui',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20410,
 'Latitude': 4.36122,
 'Longitude': 18.55496,
 'Population (thousands)': 850.946},
{'Index': 43,
 'Country or area': 'Chad',
 'Country code': 148,
 'Capital City': "N'Djaména",
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20420,
 'Latitude': 12.10672,
 'Longitude': 15.0444,
 'Population (thousands)': 1322.679},
{'Index': 44,
 'Country or area': 'Channel Islands',
 'Country code': 830,
 'Capital City': 'St. Helier',
 'Note': 15.0,
 'Capital Type': 'Capital',
 'City code': 22891,
 'Latitude': 49.188,
 'Longitude': -2.1049,
 'Population (thousands)': 34.386},
{'Index': 45,
 'Country or area': 'Channel Islands',
 'Country code': 830,
 'Capital City': 'St. Peter Port',
 'Note': 16.0,
 'Capital Type': 'Capital',
 'City code': 205428,
 'Latitude': 49.4598,
 'Longitude': -2.5353,
 'Population (thousands)': 16.271},
{'Index': 46,
 'Country or area': 'Chile',
 'Country code': 152,
 'Capital City': 'Santiago',
 'Note': 17.0,
 'Capital Type': 'Capital',
 'City code': 20439,
 'Latitude': -33.45694,
 'Longitude': -70.64827,
 'Population (thousands)': 6680.371},
{'Index': 47,
 'Country or area': 'China',
 'Country code': 156,
 'Capital City': 'Beijing',
 'Note': 18.0,
 'Capital Type': 'Capital',
 'City code': 20464,
 'Latitude': 39.9075,
 'Longitude': 116.39723,
 'Population (thousands)': 19617.963},
{'Index': 48,
 'Country or area': 'China, Hong Kong SAR',
 'Country code': 344,
 'Capital City': 'Hong Kong',
 'Note': 19.0,
 'Capital Type': 'Capital',
 'City code': 21137,
 'Latitude': 22.279588,
 'Longitude': 114.188697,
 'Population (thousands)': 7428.887},
{'Index': 49,
 'Country or area': 'China, Macao SAR',
 'Country code': 446,
 'Capital City': 'Macao',
 'Note': 20.0,
 'Capital Type': 'Capital',
 'City code': 21791,
 'Latitude': 22.20056,
 'Longitude': 113.54611,
 'Population (thousands)': 632.418},
{'Index': 50,
 'Country or area': 'China, Taiwan Province of China',
 'Country code': 158,
 'Capital City': 'Taibei',
 'Note': '',
 'Capital Type': 'Others',
 'City code': 895000149,
 'Latitude': 25.047009,
 'Longitude': 121.54568,
 'Population (thousands)': 2705.791},
{'Index': 51,
 'Country or area': 'Colombia',
 'Country code': 170,
 'Capital City': 'Bogotá',
 'Note': 21.0,
 'Capital Type': 'Capital',
 'City code': 20837,
 'Latitude': 4.60971,
 'Longitude': -74.08175,
 'Population (thousands)': 10574.409},
{'Index': 52,
 'Country or area': 'Comoros',
 'Country code': 174,
 'Capital City': 'Moroni',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20847,
 'Latitude': -11.70216,
 'Longitude': 43.25506,
 'Population (thousands)': 62.351},
{'Index': 53,
 'Country or area': 'Congo',
 'Country code': 178,
 'Capital City': 'Brazzaville',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20848,
 'Latitude': -4.26583,
 'Longitude': 15.28318,
 'Population (thousands)': 2229.693},
{'Index': 54,
 'Country or area': 'Cook Islands',
 'Country code': 184,
 'Capital City': 'Rarotonga',
 'Note': 22.0,
 'Capital Type': 'Capital',
 'City code': 20860,
 'Latitude': -21.23,
 'Longitude': -159.76,
 'Population (thousands)': 13.067},
{'Index': 55,
 'Country or area': 'Costa Rica',
 'Country code': 188,
 'Capital City': 'San José',
 'Note': 23.0,
 'Capital Type': 'Capital',
 'City code': 20861,
 'Latitude': 9.927817,
 'Longitude': -84.080685,
 'Population (thousands)': 1357.745},
{'Index': 56,
 'Country or area': "Côte d'Ivoire",
 'Country code': 384,
 'Capital City': 'Abidjan',
 'Note': '',
 'Capital Type': 'Administrative Capital',
 'City code': 21602,
 'Latitude': 5.345339,
 'Longitude': -4.026789,
 'Population (thousands)': 4920.776},
{'Index': 57,
 'Country or area': "Côte d'Ivoire",
 'Country code': 384,
 'Capital City': 'Yamoussoukro',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21606,
 'Latitude': 6.82055,
 'Longitude': -5.27674,
 'Population (thousands)': 231.072},
{'Index': 58,
 'Country or area': 'Croatia',
 'Country code': 191,
 'Capital City': 'Zagreb',
 'Note': 24.0,
 'Capital Type': 'Capital',
 'City code': 20865,
 'Latitude': 45.81444,
 'Longitude': 15.97798,
 'Population (thousands)': 685.587},
{'Index': 59,
 'Country or area': 'Cuba',
 'Country code': 192,
 'Capital City': 'La Habana (Havana)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20870,
 'Latitude': 23.119541,
 'Longitude': -82.378493,
 'Population (thousands)': 2136.468},
{'Index': 60,
 'Country or area': 'Curaçao',
 'Country code': 531,
 'Capital City': 'Willemstad',
 'Note': 25.0,
 'Capital Type': 'Capital',
 'City code': 21953,
 'Latitude': 12.1084,
 'Longitude': -68.93354,
 'Population (thousands)': 144.037},
{'Index': 61,
 'Country or area': 'Cyprus',
 'Country code': 196,
 'Capital City': 'Lefkosia (Nicosia)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20880,
 'Latitude': 35.159506,
 'Longitude': 33.366929,
 'Population (thousands)': 269.469},
{'Index': 62,
 'Country or area': 'Czechia',
 'Country code': 203,
 'Capital City': 'Praha (Prague)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20887,
 'Latitude': 50.08804,
 'Longitude': 14.42076,
 'Population (thousands)': 1291.552},
{'Index': 63,
 'Country or area': "Dem. People's Republic of Korea",
 'Country code': 408,
 'Capital City': "P'yongyang",
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21722,
 'Latitude': 39.03385,
 'Longitude': 125.75432,
 'Population (thousands)': 3037.862},
{'Index': 64,
 'Country or area': 'Democratic Republic of the Congo',
 'Country code': 180,
 'Capital City': 'Kinshasa',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20853,
 'Latitude': -4.32758,
 'Longitude': 15.31357,
 'Population (thousands)': 13171.256},
{'Index': 65,
 'Country or area': 'Denmark',
 'Country code': 208,
 'Capital City': 'København (Copenhagen)',
 'Note': 26.0,
 'Capital Type': 'Capital',
 'City code': 20894,
 'Latitude': 55.67594,
 'Longitude': 12.56553,
 'Population (thousands)': 1320.826},
{'Index': 66,
 'Country or area': 'Djibouti',
 'Country code': 262,
 'Capital City': 'Djibouti',
 'Note': 27.0,
 'Capital Type': 'Capital',
 'City code': 21005,
 'Latitude': 11.58767,
 'Longitude': 43.14468,
 'Population (thousands)': 561.564},
{'Index': 67,
 'Country or area': 'Dominica',
 'Country code': 212,
 'Capital City': 'Roseau',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20896,
 'Latitude': 15.30174,
 'Longitude': -61.38808,
 'Population (thousands)': 14.942},
{'Index': 68,
 'Country or area': 'Dominican Republic',
 'Country code': 214,
 'Capital City': 'Santo Domingo',
 'Note': 28.0,
 'Capital Type': 'Capital',
 'City code': 20898,
 'Latitude': 18.489591,
 'Longitude': -69.901805,
 'Population (thousands)': 3172.152},
{'Index': 69,
 'Country or area': 'Ecuador',
 'Country code': 218,
 'Capital City': 'Quito',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20910,
 'Latitude': -0.22985,
 'Longitude': -78.52495,
 'Population (thousands)': 1822.397},
{'Index': 70,
 'Country or area': 'Egypt',
 'Country code': 818,
 'Capital City': 'Al-Qahirah (Cairo)',
 'Note': 29.0,
 'Capital Type': 'Capital',
 'City code': 22812,
 'Latitude': 30.039173,
 'Longitude': 31.239411,
 'Population (thousands)': 20076.002},
{'Index': 71,
 'Country or area': 'El Salvador',
 'Country code': 222,
 'Capital City': 'San Salvador',
 'Note': 30.0,
 'Capital Type': 'Capital',
 'City code': 20917,
 'Latitude': 13.68935,
 'Longitude': -89.18718,
 'Population (thousands)': 1106.698},
{'Index': 72,
 'Country or area': 'Equatorial Guinea',
 'Country code': 226,
 'Capital City': 'Malabo',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20920,
 'Latitude': 3.75,
 'Longitude': 8.78333,
 'Population (thousands)': 296.77},
{'Index': 73,
 'Country or area': 'Eritrea',
 'Country code': 232,
 'Capital City': 'Asmara',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20931,
 'Latitude': 15.33333,
 'Longitude': 38.93333,
 'Population (thousands)': 895.863},
{'Index': 74,
 'Country or area': 'Estonia',
 'Country code': 233,
 'Capital City': 'Tallinn',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20932,
 'Latitude': 59.43696,
 'Longitude': 24.75353,
 'Population (thousands)': 437.027},
{'Index': 75,
 'Country or area': 'Ethiopia',
 'Country code': 231,
 'Capital City': 'Addis Ababa',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20921,
 'Latitude': 9.02497,
 'Longitude': 38.74689,
 'Population (thousands)': 4399.674},
{'Index': 76,
 'Country or area': 'Faeroe Islands',
 'Country code': 234,
 'Capital City': 'Tórshavn',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20934,
 'Latitude': 62.00973,
 'Longitude': -6.77164,
 'Population (thousands)': 20.817},
{'Index': 77,
 'Country or area': 'Falkland Islands (Malvinas)',
 'Country code': 238,
 'Capital City': 'Stanley',
 'Note': 31.0,
 'Capital Type': 'Others',
 'City code': 20935,
 'Latitude': -51.701172,
 'Longitude': -57.849351,
 'Population (thousands)': 2.269},
{'Index': 78,
 'Country or area': 'Fiji',
 'Country code': 242,
 'Capital City': 'Suva',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20936,
 'Latitude': -18.14161,
 'Longitude': 178.44149,
 'Population (thousands)': 178.339},
{'Index': 79,
 'Country or area': 'Finland',
 'Country code': 246,
 'Capital City': 'Helsinki',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20937,
 'Latitude': 60.169246,
 'Longitude': 24.940216,
 'Population (thousands)': 1279.096},
{'Index': 80,
 'Country or area': 'France',
 'Country code': 250,
 'Capital City': 'Paris',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20985,
 'Latitude': 48.85341,
 'Longitude': 2.3488,
 'Population (thousands)': 10900.952},
{'Index': 81,
 'Country or area': 'French Guiana',
 'Country code': 254,
 'Capital City': 'Cayenne',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21002,
 'Latitude': 4.93333,
 'Longitude': -52.33333,
 'Population (thousands)': 57.506},
{'Index': 82,
 'Country or area': 'French Polynesia',
 'Country code': 258,
 'Capital City': 'Papeete',
 'Note': 32.0,
 'Capital Type': 'Capital',
 'City code': 21004,
 'Latitude': -17.53333,
 'Longitude': -149.56667,
 'Population (thousands)': 136.005},
{'Index': 83,
 'Country or area': 'Gabon',
 'Country code': 266,
 'Capital City': 'Libreville',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21006,
 'Latitude': 0.3925,
 'Longitude': 9.45365,
 'Population (thousands)': 813.489},
{'Index': 84,
 'Country or area': 'Gambia',
 'Country code': 270,
 'Capital City': 'Banjul',
 'Note': 33.0,
 'Capital Type': 'Capital',
 'City code': 21012,
 'Latitude': 13.453099,
 'Longitude': -16.679433,
 'Population (thousands)': 437.161},
{'Index': 85,
 'Country or area': 'Georgia',
 'Country code': 268,
 'Capital City': 'Tbilisi',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21011,
 'Latitude': 41.69411,
 'Longitude': 44.83368,
 'Population (thousands)': 1077.333},
{'Index': 86,
 'Country or area': 'Germany',
 'Country code': 276,
 'Capital City': 'Berlin',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 204296,
 'Latitude': 52.52437,
 'Longitude': 13.41053,
 'Population (thousands)': 3552.123},
{'Index': 87,
 'Country or area': 'Ghana',
 'Country code': 288,
 'Capital City': 'Accra',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21107,
 'Latitude': 5.55602,
 'Longitude': -0.1969,
 'Population (thousands)': 2439.389},
{'Index': 88,
 'Country or area': 'Gibraltar',
 'Country code': 292,
 'Capital City': 'Gibraltar',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21111,
 'Latitude': 36.14474,
 'Longitude': -5.35257,
 'Population (thousands)': 34.733},
{'Index': 89,
 'Country or area': 'Greece',
 'Country code': 300,
 'Capital City': 'Athínai (Athens)',
 'Note': 34.0,
 'Capital Type': 'Capital',
 'City code': 21113,
 'Latitude': 37.95342,
 'Longitude': 23.74897,
 'Population (thousands)': 3155.6},
{'Index': 90,
 'Country or area': 'Greenland',
 'Country code': 304,
 'Capital City': 'Nuuk (Godthåb)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21119,
 'Latitude': 64.18347,
 'Longitude': -51.72157,
 'Population (thousands)': 18.406},
{'Index': 91,
 'Country or area': 'Grenada',
 'Country code': 308,
 'Capital City': "St.George's",
 'Note': 35.0,
 'Capital Type': 'Capital',
 'City code': 21120,
 'Latitude': 12.05644,
 'Longitude': -61.74849,
 'Population (thousands)': 39.297},
{'Index': 92,
 'Country or area': 'Guadeloupe',
 'Country code': 312,
 'Capital City': 'Basse-Terre',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21121,
 'Latitude': 15.99854,
 'Longitude': -61.72548,
 'Population (thousands)': 58.397},
{'Index': 93,
 'Country or area': 'Guam',
 'Country code': 316,
 'Capital City': 'Hagåtña',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21123,
 'Latitude': 13.47567,
 'Longitude': 144.74886,
 'Population (thousands)': 146.905},
{'Index': 94,
 'Country or area': 'Guatemala',
 'Country code': 320,
 'Capital City': 'Ciudad de Guatemala (Guatemala City)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21124,
 'Latitude': 14.612652,
 'Longitude': -90.530746,
 'Population (thousands)': 2851.104},
{'Index': 95,
 'Country or area': 'Guinea',
 'Country code': 324,
 'Capital City': 'Conakry',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21126,
 'Latitude': 9.571642,
 'Longitude': -13.647602,
 'Population (thousands)': 1843.121},
{'Index': 96,
 'Country or area': 'Guinea-Bissau',
 'Country code': 624,
 'Capital City': 'Bissau',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22171,
 'Latitude': 11.86357,
 'Longitude': -15.59767,
 'Population (thousands)': 558.399},
{'Index': 97,
 'Country or area': 'Guyana',
 'Country code': 328,
 'Capital City': 'Georgetown',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21131,
 'Latitude': 6.80448,
 'Longitude': -58.15527,
 'Population (thousands)': 109.934},
{'Index': 98,
 'Country or area': 'Haiti',
 'Country code': 332,
 'Capital City': 'Port-au-Prince',
 'Note': 36.0,
 'Capital Type': 'Capital',
 'City code': 21133,
 'Latitude': 18.53917,
 'Longitude': -72.335,
 'Population (thousands)': 2636.763},
{'Index': 99,
 'Country or area': 'Holy See',
 'Country code': 336,
 'Capital City': 'Vatican City',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21134,
 'Latitude': 41.90236,
 'Longitude': 12.45332,
 'Population (thousands)': 0.801},
{'Index': 100,
 'Country or area': 'Honduras',
 'Country code': 340,
 'Capital City': 'Tegucigalpa',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21136,
 'Latitude': 14.0818,
 'Longitude': -87.20681,
 'Population (thousands)': 1363.041},
{'Index': 101,
 'Country or area': 'Hungary',
 'Country code': 348,
 'Capital City': 'Budapest',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21138,
 'Latitude': 47.49801,
 'Longitude': 19.03991,
 'Population (thousands)': 1759.497},
{'Index': 102,
 'Country or area': 'Iceland',
 'Country code': 352,
 'Capital City': 'Reykjavík',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21147,
 'Latitude': 64.13548,
 'Longitude': -21.89541,
 'Population (thousands)': 216.364},
{'Index': 103,
 'Country or area': 'India',
 'Country code': 356,
 'Capital City': 'Delhi',
 'Note': 37.0,
 'Capital Type': 'Capital',
 'City code': 21228,
 'Latitude': 28.66667,
 'Longitude': 77.21667,
 'Population (thousands)': 28513.682},
{'Index': 104,
 'Country or area': 'Indonesia',
 'Country code': 360,
 'Capital City': 'Jakarta',
 'Note': 38.0,
 'Capital Type': 'Capital',
 'City code': 21454,
 'Latitude': -6.211831,
 'Longitude': 106.841646,
 'Population (thousands)': 10516.927},
{'Index': 105,
 'Country or area': 'Iran (Islamic Republic of)',
 'Country code': 364,
 'Capital City': 'Tehran',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21523,
 'Latitude': 35.69439,
 'Longitude': 51.42151,
 'Population (thousands)': 8895.947},
{'Index': 106,
 'Country or area': 'Iraq',
 'Country code': 368,
 'Capital City': 'Baghdad',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21529,
 'Latitude': 33.34058,
 'Longitude': 44.40088,
 'Population (thousands)': 6811.955},
{'Index': 107,
 'Country or area': 'Ireland',
 'Country code': 372,
 'Capital City': 'Dublin',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21542,
 'Latitude': 53.33306,
 'Longitude': -6.24889,
 'Population (thousands)': 1201.426},
{'Index': 108,
 'Country or area': 'Isle of Man',
 'Country code': 833,
 'Capital City': 'Douglas',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22892,
 'Latitude': 54.15,
 'Longitude': -4.48333,
 'Population (thousands)': 27.171},
{'Index': 109,
 'Country or area': 'Israel',
 'Country code': 376,
 'Capital City': 'Jerusalem',
 'Note': 39.0,
 'Capital Type': 'Capital',
 'City code': 21547,
 'Latitude': 31.76904,
 'Longitude': 35.21633,
 'Population (thousands)': 907.062},
{'Index': 110,
 'Country or area': 'Italy',
 'Country code': 380,
 'Capital City': 'Roma (Rome)',
 'Note': 40.0,
 'Capital Type': 'Capital',
 'City code': 21588,
 'Latitude': 41.894743,
 'Longitude': 12.481142,
 'Population (thousands)': 4209.71},
{'Index': 111,
 'Country or area': 'Jamaica',
 'Country code': 388,
 'Capital City': 'Kingston',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21607,
 'Latitude': 17.99702,
 'Longitude': -76.79358,
 'Population (thousands)': 589.083},
{'Index': 112,
 'Country or area': 'Japan',
 'Country code': 392,
 'Capital City': 'Tokyo',
 'Note': 41.0,
 'Capital Type': 'Capital',
 'City code': 21671,
 'Latitude': 35.6895,
 'Longitude': 139.69171,
 'Population (thousands)': 37468.302},
{'Index': 113,
 'Country or area': 'Jordan',
 'Country code': 400,
 'Capital City': 'Amman',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21700,
 'Latitude': 31.95522,
 'Longitude': 35.94503,
 'Population (thousands)': 2064.582},
{'Index': 114,
 'Country or area': 'Kazakhstan',
 'Country code': 398,
 'Capital City': 'Astana',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21679,
 'Latitude': 51.1801,
 'Longitude': 71.44598,
 'Population (thousands)': 1068.113},
{'Index': 115,
 'Country or area': 'Kenya',
 'Country code': 404,
 'Capital City': 'Nairobi',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21711,
 'Latitude': -1.28333,
 'Longitude': 36.81667,
 'Population (thousands)': 4385.853},
{'Index': 116,
 'Country or area': 'Kiribati',
 'Country code': 296,
 'Capital City': 'Tarawa',
 'Note': 42.0,
 'Capital Type': 'Capital',
 'City code': 21112,
 'Latitude': 1.327221,
 'Longitude': 172.981305,
 'Population (thousands)': 64.011},
{'Index': 117,
 'Country or area': 'Kuwait',
 'Country code': 414,
 'Capital City': 'Al Kuwayt (Kuwait City)',
 'Note': 43.0,
 'Capital Type': 'Capital',
 'City code': 21769,
 'Latitude': 29.36972,
 'Longitude': 47.9783,
 'Population (thousands)': 2989.27},
{'Index': 118,
 'Country or area': 'Kyrgyzstan',
 'Country code': 417,
 'Capital City': 'Bishkek',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21770,
 'Latitude': 42.87,
 'Longitude': 74.59,
 'Population (thousands)': 996.319},
{'Index': 119,
 'Country or area': "Lao People's Democratic Republic",
 'Country code': 418,
 'Capital City': 'Vientiane',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21772,
 'Latitude': 17.96667,
 'Longitude': 102.6,
 'Population (thousands)': 664.754},
{'Index': 120,
 'Country or area': 'Latvia',
 'Country code': 428,
 'Capital City': 'Riga',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21778,
 'Latitude': 56.946,
 'Longitude': 24.10589,
 'Population (thousands)': 637.089},
{'Index': 121,
 'Country or area': 'Lebanon',
 'Country code': 422,
 'Capital City': 'Bayrut (Beirut)',
 'Note': 44.0,
 'Capital Type': 'Capital',
 'City code': 21773,
 'Latitude': 33.9,
 'Longitude': 35.48333,
 'Population (thousands)': 2385.271},
{'Index': 122,
 'Country or area': 'Lesotho',
 'Country code': 426,
 'Capital City': 'Maseru',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21775,
 'Latitude': -29.31667,
 'Longitude': 27.48333,
 'Population (thousands)': 201.851},
{'Index': 123,
 'Country or area': 'Liberia',
 'Country code': 430,
 'Capital City': 'Monrovia',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21779,
 'Latitude': 6.30054,
 'Longitude': -10.7969,
 'Population (thousands)': 1418.3},
{'Index': 124,
 'Country or area': 'Libya',
 'Country code': 434,
 'Capital City': 'Tarabulus (Tripoli)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21782,
 'Latitude': 32.87519,
 'Longitude': 13.18746,
 'Population (thousands)': 1157.746},
{'Index': 125,
 'Country or area': 'Liechtenstein',
 'Country code': 438,
 'Capital City': 'Vaduz',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21783,
 'Latitude': 47.14151,
 'Longitude': 9.52154,
 'Population (thousands)': 5.47},
{'Index': 126,
 'Country or area': 'Lithuania',
 'Country code': 440,
 'Capital City': 'Vilnius',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21789,
 'Latitude': 54.68916,
 'Longitude': 25.2798,
 'Population (thousands)': 536.055},
{'Index': 127,
 'Country or area': 'Luxembourg',
 'Country code': 442,
 'Capital City': 'Luxembourg',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21790,
 'Latitude': 49.61167,
 'Longitude': 6.13,
 'Population (thousands)': 119.752},
{'Index': 128,
 'Country or area': 'Madagascar',
 'Country code': 450,
 'Capital City': 'Antananarivo',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21792,
 'Latitude': -18.91368,
 'Longitude': 47.53613,
 'Population (thousands)': 3058.387},
{'Index': 129,
 'Country or area': 'Malawi',
 'Country code': 454,
 'Capital City': 'Lilongwe',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21799,
 'Latitude': -13.96692,
 'Longitude': 33.78725,
 'Population (thousands)': 1029.639},
{'Index': 130,
 'Country or area': 'Malaysia',
 'Country code': 458,
 'Capital City': 'Kuala Lumpur',
 'Note': 45.0,
 'Capital Type': 'Capital',
 'City code': 206411,
 'Latitude': 3.1412,
 'Longitude': 101.68653,
 'Population (thousands)': 7563.912},
{'Index': 131,
 'Country or area': 'Maldives',
 'Country code': 462,
 'Capital City': 'Male',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21817,
 'Latitude': 4.1748,
 'Longitude': 73.50888,
 'Population (thousands)': 176.851},
{'Index': 132,
 'Country or area': 'Mali',
 'Country code': 466,
 'Capital City': 'Bamako',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21818,
 'Latitude': 12.65,
 'Longitude': -8.0,
 'Population (thousands)': 2446.749},
{'Index': 133,
 'Country or area': 'Malta',
 'Country code': 470,
 'Capital City': 'Valletta',
 'Note': 46.0,
 'Capital Type': 'Capital',
 'City code': 21819,
 'Latitude': 35.89972,
 'Longitude': 14.51472,
 'Population (thousands)': 212.768},
{'Index': 134,
 'Country or area': 'Marshall Islands',
 'Country code': 584,
 'Capital City': 'Majuro',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22033,
 'Latitude': 7.08971,
 'Longitude': 171.38027,
 'Population (thousands)': 30.661},
{'Index': 135,
 'Country or area': 'Martinique',
 'Country code': 474,
 'Capital City': 'Fort-de-France',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21820,
 'Latitude': 14.60892,
 'Longitude': -61.07334,
 'Population (thousands)': 79.361},
{'Index': 136,
 'Country or area': 'Mauritania',
 'Country code': 478,
 'Capital City': 'Nouakchott',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21821,
 'Latitude': 18.08581,
 'Longitude': -15.9785,
 'Population (thousands)': 1205.414},
{'Index': 137,
 'Country or area': 'Mauritius',
 'Country code': 480,
 'Capital City': 'Port Louis',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21822,
 'Latitude': -20.16194,
 'Longitude': 57.49889,
 'Population (thousands)': 149.365},
{'Index': 138,
 'Country or area': 'Mayotte',
 'Country code': 175,
 'Capital City': 'Mamoudzou',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 205636,
 'Latitude': -12.779444,
 'Longitude': 45.227222,
 'Population (thousands)': 6.18},
{'Index': 139,
 'Country or area': 'Mexico',
 'Country code': 484,
 'Capital City': 'Ciudad de México (Mexico City)',
 'Note': 47.0,
 'Capital Type': 'Capital',
 'City code': 21853,
 'Latitude': 19.427318,
 'Longitude': -99.141869,
 'Population (thousands)': 21580.827},
{'Index': 140,
 'Country or area': 'Micronesia (Fed. States of)',
 'Country code': 583,
 'Capital City': 'Palikir',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22032,
 'Latitude': 6.917423,
 'Longitude': 158.158791,
 'Population (thousands)': 6.996},
{'Index': 141,
 'Country or area': 'Monaco',
 'Country code': 492,
 'Capital City': 'Monaco',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21881,
 'Latitude': 43.73333,
 'Longitude': 7.41667,
 'Population (thousands)': 38.897},
{'Index': 142,
 'Country or area': 'Mongolia',
 'Country code': 496,
 'Capital City': 'Ulaanbaatar',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21882,
 'Latitude': 47.90771,
 'Longitude': 106.88324,
 'Population (thousands)': 1520.381},
{'Index': 143,
 'Country or area': 'Montenegro',
 'Country code': 499,
 'Capital City': 'Podgorica',
 'Note': 48.0,
 'Capital Type': 'Capital',
 'City code': 23256,
 'Latitude': 42.44111,
 'Longitude': 19.26361,
 'Population (thousands)': 177.177},
{'Index': 144,
 'Country or area': 'Montserrat',
 'Country code': 500,
 'Capital City': 'Brades Estate',
 'Note': 49.0,
 'Capital Type': 'Capital',
 'City code': 204440,
 'Latitude': 16.79183,
 'Longitude': -62.21058,
 'Population (thousands)': 0.472},
{'Index': 145,
 'Country or area': 'Morocco',
 'Country code': 504,
 'Capital City': 'Rabat',
 'Note': 50.0,
 'Capital Type': 'Capital',
 'City code': 21899,
 'Latitude': 34.01325,
 'Longitude': -6.83255,
 'Population (thousands)': 1846.661},
{'Index': 146,
 'Country or area': 'Mozambique',
 'Country code': 508,
 'Capital City': 'Maputo',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21910,
 'Latitude': -25.96528,
 'Longitude': 32.58917,
 'Population (thousands)': 1101.771},
{'Index': 147,
 'Country or area': 'Myanmar',
 'Country code': 104,
 'Capital City': 'Nay Pyi Taw',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 205588,
 'Latitude': 19.745,
 'Longitude': 96.12972,
 'Population (thousands)': 500.218},
{'Index': 148,
 'Country or area': 'Namibia',
 'Country code': 516,
 'Capital City': 'Windhoek',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21925,
 'Latitude': -22.55941,
 'Longitude': 17.08323,
 'Population (thousands)': 404.28},
{'Index': 149,
 'Country or area': 'Nauru',
 'Country code': 520,
 'Capital City': 'Nauru',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21926,
 'Latitude': -0.530801,
 'Longitude': 166.911192,
 'Population (thousands)': 11.312},
{'Index': 150,
 'Country or area': 'Nepal',
 'Country code': 524,
 'Capital City': 'Kathmandu',
 'Note': 51.0,
 'Capital Type': 'Capital',
 'City code': 21928,
 'Latitude': 27.70169,
 'Longitude': 85.3206,
 'Population (thousands)': 1329.732},
{'Index': 151,
 'Country or area': 'Netherlands',
 'Country code': 528,
 'Capital City': 'Amsterdam',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21930,
 'Latitude': 52.37403,
 'Longitude': 4.88969,
 'Population (thousands)': 1131.69},
{'Index': 152,
 'Country or area': 'Netherlands',
 'Country code': 528,
 'Capital City': 's-Gravenhage (The Hague)',
 'Note': 52.0,
 'Capital Type': 'Seat of Government',
 'City code': 205146,
 'Latitude': 52.0767,
 'Longitude': 4.2986,
 'Population (thousands)': 685.14},
{'Index': 153,
 'Country or area': 'New Caledonia',
 'Country code': 540,
 'Capital City': 'Nouméa',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21955,
 'Latitude': -22.27631,
 'Longitude': 166.4572,
 'Population (thousands)': 197.787},
{'Index': 154,
 'Country or area': 'New Zealand',
 'Country code': 554,
 'Capital City': 'Wellington',
 'Note': 53.0,
 'Capital Type': 'Capital',
 'City code': 21962,
 'Latitude': -41.28664,
 'Longitude': 174.77557,
 'Population (thousands)': 411.346},
{'Index': 155,
 'Country or area': 'Nicaragua',
 'Country code': 558,
 'Capital City': 'Managua',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21967,
 'Latitude': 12.13282,
 'Longitude': -86.2504,
 'Population (thousands)': 1047.923},
{'Index': 156,
 'Country or area': 'Niger',
 'Country code': 562,
 'Capital City': 'Niamey',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21972,
 'Latitude': 13.51366,
 'Longitude': 2.1098,
 'Population (thousands)': 1213.781},
{'Index': 157,
 'Country or area': 'Nigeria',
 'Country code': 566,
 'Capital City': 'Abuja',
 'Note': 54.0,
 'Capital Type': 'Capital',
 'City code': 21976,
 'Latitude': 9.05735,
 'Longitude': 7.48976,
 'Population (thousands)': 2918.518},
{'Index': 158,
 'Country or area': 'Niue',
 'Country code': 570,
 'Capital City': 'Alofi',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22025,
 'Latitude': -19.058498,
 'Longitude': -169.921281,
 'Population (thousands)': 0.727},
{'Index': 159,
 'Country or area': 'Northern Mariana Islands',
 'Country code': 580,
 'Capital City': 'Saipan',
 'Note': 55.0,
 'Capital Type': 'Capital',
 'City code': 22031,
 'Latitude': 15.21233,
 'Longitude': 145.7545,
 'Population (thousands)': 50.568},
{'Index': 160,
 'Country or area': 'Norway',
 'Country code': 578,
 'Capital City': 'Oslo',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22028,
 'Latitude': 59.91273,
 'Longitude': 10.74609,
 'Population (thousands)': 1012.225},
{'Index': 161,
 'Country or area': 'Oman',
 'Country code': 512,
 'Capital City': 'Masqat (Muscat)',
 'Note': 56.0,
 'Capital Type': 'Capital',
 'City code': 21922,
 'Latitude': 23.61387,
 'Longitude': 58.5922,
 'Population (thousands)': 1446.563},
{'Index': 162,
 'Country or area': 'Pakistan',
 'Country code': 586,
 'Capital City': 'Islamabad',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22042,
 'Latitude': 33.70351,
 'Longitude': 73.059373,
 'Population (thousands)': 1061.412},
{'Index': 163,
 'Country or area': 'Palau',
 'Country code': 585,
 'Capital City': 'Koror',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22034,
 'Latitude': 7.34257,
 'Longitude': 134.47888,
 'Population (thousands)': 11.41},
{'Index': 164,
 'Country or area': 'Panama',
 'Country code': 591,
 'Capital City': 'Ciudad de Panamá (Panama City)',
 'Note': 57.0,
 'Capital Type': 'Capital',
 'City code': 22063,
 'Latitude': 8.995816,
 'Longitude': -79.519572,
 'Population (thousands)': 1783.49},
{'Index': 165,
 'Country or area': 'Papua New Guinea',
 'Country code': 598,
 'Capital City': 'Port Moresby',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22064,
 'Latitude': -9.44314,
 'Longitude': 147.17972,
 'Population (thousands)': 366.862},
{'Index': 166,
 'Country or area': 'Paraguay',
 'Country code': 600,
 'Capital City': 'Asunción',
 'Note': 58.0,
 'Capital Type': 'Capital',
 'City code': 22065,
 'Latitude': -25.30066,
 'Longitude': -57.63591,
 'Population (thousands)': 3222.199},
{'Index': 167,
 'Country or area': 'Peru',
 'Country code': 604,
 'Capital City': 'Lima',
 'Note': 59.0,
 'Capital Type': 'Capital',
 'City code': 22078,
 'Latitude': -12.04318,
 'Longitude': -77.02824,
 'Population (thousands)': 10390.607},
{'Index': 168,
 'Country or area': 'Philippines',
 'Country code': 608,
 'Capital City': 'Manila',
 'Note': 60.0,
 'Capital Type': 'Capital',
 'City code': 22109,
 'Latitude': 14.6042,
 'Longitude': 120.9822,
 'Population (thousands)': 13482.468},
{'Index': 169,
 'Country or area': 'Poland',
 'Country code': 616,
 'Capital City': 'Warszawa (Warsaw)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22161,
 'Latitude': 52.22977,
 'Longitude': 21.01178,
 'Population (thousands)': 1767.798},
{'Index': 170,
 'Country or area': 'Portugal',
 'Country code': 620,
 'Capital City': 'Lisboa (Lisbon)',
 'Note': 61.0,
 'Capital Type': 'Capital',
 'City code': 22167,
 'Latitude': 38.71686,
 'Longitude': -9.139867,
 'Population (thousands)': 2927.316},
{'Index': 171,
 'Country or area': 'Puerto Rico',
 'Country code': 630,
 'Capital City': 'San Juan',
 'Note': 62.0,
 'Capital Type': 'Capital',
 'City code': 22177,
 'Latitude': 18.46633,
 'Longitude': -66.10572,
 'Population (thousands)': 2454.337},
{'Index': 172,
 'Country or area': 'Qatar',
 'Country code': 634,
 'Capital City': 'Ad-Dawhah (Doha)',
 'Note': 63.0,
 'Capital Type': 'Capital',
 'City code': 22179,
 'Latitude': 25.274724,
 'Longitude': 51.524472,
 'Population (thousands)': 633.401},
{'Index': 173,
 'Country or area': 'Republic of Korea',
 'Country code': 410,
 'Capital City': 'Seoul',
 'Note': 64.0,
 'Capital Type': 'Capital',
 'City code': 21758,
 'Latitude': 37.56826,
 'Longitude': 126.97783,
 'Population (thousands)': 9963.497},
{'Index': 174,
 'Country or area': 'Republic of Moldova',
 'Country code': 498,
 'Capital City': 'Chişinău',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21885,
 'Latitude': 47.00556,
 'Longitude': 28.8575,
 'Population (thousands)': 509.707},
{'Index': 175,
 'Country or area': 'Réunion',
 'Country code': 638,
 'Capital City': 'Saint-Denis',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22180,
 'Latitude': -20.88231,
 'Longitude': 55.4504,
 'Population (thousands)': 147.209},
{'Index': 176,
 'Country or area': 'Romania',
 'Country code': 642,
 'Capital City': 'Bucuresti (Bucharest)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22191,
 'Latitude': 44.432787,
 'Longitude': 26.104302,
 'Population (thousands)': 1821.38},
{'Index': 177,
 'Country or area': 'Russian Federation',
 'Country code': 643,
 'Capital City': 'Moskva (Moscow)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22299,
 'Latitude': 55.754996,
 'Longitude': 37.621849,
 'Population (thousands)': 12409.738},
{'Index': 178,
 'Country or area': 'Rwanda',
 'Country code': 646,
 'Capital City': 'Kigali',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22404,
 'Latitude': -1.947364,
 'Longitude': 30.057897,
 'Population (thousands)': 1057.836},
{'Index': 179,
 'Country or area': 'Saint Helena',
 'Country code': 654,
 'Capital City': 'Jamestown',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22405,
 'Latitude': -15.93872,
 'Longitude': -5.71675,
 'Population (thousands)': 0.603},
{'Index': 180,
 'Country or area': 'Saint Kitts and Nevis',
 'Country code': 659,
 'Capital City': 'Basseterre',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22406,
 'Latitude': 17.29484,
 'Longitude': -62.7261,
 'Population (thousands)': 14.434},
{'Index': 181,
 'Country or area': 'Saint Lucia',
 'Country code': 662,
 'Capital City': 'Castries',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22408,
 'Latitude': 14.006021,
 'Longitude': -60.99096,
 'Population (thousands)': 22.258},
{'Index': 182,
 'Country or area': 'Saint Pierre and Miquelon',
 'Country code': 666,
 'Capital City': 'Saint-Pierre',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22409,
 'Latitude': 46.77375,
 'Longitude': -56.181465,
 'Population (thousands)': 5.723},
{'Index': 183,
 'Country or area': 'Saint Vincent and the Grenadines',
 'Country code': 670,
 'Capital City': 'Kingstown',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22410,
 'Latitude': 13.15872,
 'Longitude': -61.22475,
 'Population (thousands)': 26.636},
{'Index': 184,
 'Country or area': 'Samoa',
 'Country code': 882,
 'Capital City': 'Apia',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23236,
 'Latitude': -13.83333,
 'Longitude': -171.76666,
 'Population (thousands)': 36.066},
{'Index': 185,
 'Country or area': 'San Marino',
 'Country code': 674,
 'Capital City': 'San Marino',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22411,
 'Latitude': 43.93333,
 'Longitude': 12.45,
 'Population (thousands)': 4.465},
{'Index': 186,
 'Country or area': 'Sao Tome and Principe',
 'Country code': 678,
 'Capital City': 'São Tomé',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22412,
 'Latitude': 0.33654,
 'Longitude': 6.72732,
 'Population (thousands)': 80.099},
{'Index': 187,
 'Country or area': 'Saudi Arabia',
 'Country code': 682,
 'Capital City': 'Ar-Riyadh (Riyadh)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22432,
 'Latitude': 24.690466,
 'Longitude': 46.709566,
 'Population (thousands)': 6906.595},
{'Index': 188,
 'Country or area': 'Senegal',
 'Country code': 686,
 'Capital City': 'Dakar',
 'Note': 65.0,
 'Capital Type': 'Capital',
 'City code': 22439,
 'Latitude': 14.6937,
 'Longitude': -17.44406,
 'Population (thousands)': 2978.419},
{'Index': 189,
 'Country or area': 'Serbia',
 'Country code': 688,
 'Capital City': 'Beograd (Belgrade)',
 'Note': 66.0,
 'Capital Type': 'Capital',
 'City code': 23241,
 'Latitude': 44.817649,
 'Longitude': 20.463309,
 'Population (thousands)': 1389.351},
{'Index': 190,
 'Country or area': 'Seychelles',
 'Country code': 690,
 'Capital City': 'Victoria',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22444,
 'Latitude': -4.61667,
 'Longitude': 55.45,
 'Population (thousands)': 28.091},
{'Index': 191,
 'Country or area': 'Sierra Leone',
 'Country code': 694,
 'Capital City': 'Freetown',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22445,
 'Latitude': 8.484,
 'Longitude': -13.22994,
 'Population (thousands)': 1135.949},
{'Index': 192,
 'Country or area': 'Singapore',
 'Country code': 702,
 'Capital City': 'Singapore',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22447,
 'Latitude': 1.28967,
 'Longitude': 103.85007,
 'Population (thousands)': 5791.901},
{'Index': 193,
 'Country or area': 'Sint Maarten (Dutch part)',
 'Country code': 534,
 'Capital City': 'Philipsburg',
 'Note': 67.0,
 'Capital Type': 'Capital',
 'City code': 206154,
 'Latitude': 18.026,
 'Longitude': -63.04582,
 'Population (thousands)': 40.552},
{'Index': 194,
 'Country or area': 'Slovakia',
 'Country code': 703,
 'Capital City': 'Bratislava',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22448,
 'Latitude': 48.14816,
 'Longitude': 17.10674,
 'Population (thousands)': 429.92},
{'Index': 195,
 'Country or area': 'Slovenia',
 'Country code': 705,
 'Capital City': 'Ljubljana',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22474,
 'Latitude': 46.05108,
 'Longitude': 14.50513,
 'Population (thousands)': 286.491},
{'Index': 196,
 'Country or area': 'Solomon Islands',
 'Country code': 90,
 'Capital City': 'Honiara',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 20311,
 'Latitude': -9.43333,
 'Longitude': 159.95,
 'Population (thousands)': 81.801},
{'Index': 197,
 'Country or area': 'Somalia',
 'Country code': 706,
 'Capital City': 'Muqdisho (Mogadishu)',
 'Note': 68.0,
 'Capital Type': 'Capital',
 'City code': 22477,
 'Latitude': 2.041636,
 'Longitude': 45.343492,
 'Population (thousands)': 2081.624},
{'Index': 198,
 'Country or area': 'South Africa',
 'Country code': 710,
 'Capital City': 'Bloemfontein',
 'Note': '',
 'Capital Type': 'Judiciary Capital',
 'City code': 22479,
 'Latitude': -29.12106,
 'Longitude': 26.214,
 'Population (thousands)': 545.875},
{'Index': 199,
 'Country or area': 'South Africa',
 'Country code': 710,
 'Capital City': 'Cape Town',
 'Note': '',
 'Capital Type': 'Legislative Capital',
 'City code': 22481,
 'Latitude': -33.92584,
 'Longitude': 18.42322,
 'Population (thousands)': 4430.367},
{'Index': 200,
 'Country or area': 'South Africa',
 'Country code': 710,
 'Capital City': 'Pretoria',
 'Note': '',
 'Capital Type': 'Administrative Capital',
 'City code': 22501,
 'Latitude': -25.74486,
 'Longitude': 28.18783,
 'Population (thousands)': 2378.35},
{'Index': 201,
 'Country or area': 'South Sudan',
 'Country code': 728,
 'Capital City': 'Juba',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22577,
 'Latitude': 4.85165,
 'Longitude': 31.58247,
 'Population (thousands)': 368.914},
{'Index': 202,
 'Country or area': 'Spain',
 'Country code': 724,
 'Capital City': 'Madrid',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22549,
 'Latitude': 40.4165,
 'Longitude': -3.70256,
 'Population (thousands)': 6497.124},
{'Index': 203,
 'Country or area': 'Sri Lanka',
 'Country code': 144,
 'Capital City': 'Colombo',
 'Note': 69.0,
 'Capital Type': 'Capital',
 'City code': 20414,
 'Latitude': 6.93194,
 'Longitude': 79.84778,
 'Population (thousands)': 599.821},
{'Index': 204,
 'Country or area': 'Sri Lanka',
 'Country code': 144,
 'Capital City': 'Sri Jayewardenepura Kotte',
 'Note': '',
 'Capital Type': 'Legislative Capital',
 'City code': 20418,
 'Latitude': 6.90278,
 'Longitude': 79.90833,
 'Population (thousands)': 103.248},
{'Index': 205,
 'Country or area': 'State of Palestine',
 'Country code': 275,
 'Capital City': 'Al-Quds[East Jerusalem]',
 'Note': 70.0,
 'Capital Type': 'Capital',
 'City code': 23562,
 'Latitude': 31.78336,
 'Longitude': 35.23388,
 'Population (thousands)': 275.086},
{'Index': 206,
 'Country or area': 'Sudan',
 'Country code': 729,
 'Capital City': 'Al-Khartum (Khartoum)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22579,
 'Latitude': 15.55177,
 'Longitude': 32.53241,
 'Population (thousands)': 5534.079},
{'Index': 207,
 'Country or area': 'Suriname',
 'Country code': 740,
 'Capital City': 'Paramaribo',
 'Note': 71.0,
 'Capital Type': 'Capital',
 'City code': 22587,
 'Latitude': 5.86638,
 'Longitude': -55.16682,
 'Population (thousands)': 239.457},
{'Index': 208,
 'Country or area': 'Swaziland',
 'Country code': 748,
 'Capital City': 'Mbabane',
 'Note': 72.0,
 'Capital Type': 'Capital',
 'City code': 22588,
 'Latitude': -26.31667,
 'Longitude': 31.13333,
 'Population (thousands)': 68.01},
{'Index': 209,
 'Country or area': 'Sweden',
 'Country code': 752,
 'Capital City': 'Stockholm',
 'Note': 73.0,
 'Capital Type': 'Capital',
 'City code': 22597,
 'Latitude': 59.33258,
 'Longitude': 18.0649,
 'Population (thousands)': 1582.968},
{'Index': 210,
 'Country or area': 'Switzerland',
 'Country code': 756,
 'Capital City': 'Bern',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22601,
 'Latitude': 46.94809,
 'Longitude': 7.44744,
 'Population (thousands)': 422.153},
{'Index': 211,
 'Country or area': 'Syrian Arab Republic',
 'Country code': 760,
 'Capital City': 'Dimashq (Damascus)',
 'Note': 74.0,
 'Capital Type': 'Capital',
 'City code': 22610,
 'Latitude': 33.508586,
 'Longitude': 36.308444,
 'Population (thousands)': 2319.545},
{'Index': 212,
 'Country or area': 'Tajikistan',
 'Country code': 762,
 'Capital City': 'Dushanbe',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22615,
 'Latitude': 38.53575,
 'Longitude': 68.77905,
 'Population (thousands)': 872.653},
{'Index': 213,
 'Country or area': 'TFYR Macedonia',
 'Country code': 807,
 'Capital City': 'Skopje',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22802,
 'Latitude': 42.0,
 'Longitude': 21.43333,
 'Population (thousands)': 584.208},
{'Index': 214,
 'Country or area': 'Thailand',
 'Country code': 764,
 'Capital City': 'Krung Thep (Bangkok)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22617,
 'Latitude': 13.721964,
 'Longitude': 100.525248,
 'Population (thousands)': 10156.316},
{'Index': 215,
 'Country or area': 'Timor-Leste',
 'Country code': 626,
 'Capital City': 'Dili',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22172,
 'Latitude': -8.560095,
 'Longitude': 125.566848,
 'Population (thousands)': 281.135},
{'Index': 216,
 'Country or area': 'Togo',
 'Country code': 768,
 'Capital City': 'Lomé',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22628,
 'Latitude': 6.13748,
 'Longitude': 1.21227,
 'Population (thousands)': 1745.744},
{'Index': 217,
 'Country or area': 'Tokelau',
 'Country code': 772,
 'Capital City': 'Tokelau',
 'Note': 75.0,
 'Capital Type': 'Others',
 'City code': 22629,
 'Latitude': -9.38,
 'Longitude': -171.25,
 'Population (thousands)': ''},
{'Index': 218,
 'Country or area': 'Tonga',
 'Country code': 776,
 'Capital City': "Nuku'alofa",
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22630,
 'Latitude': -21.139441,
 'Longitude': -175.203246,
 'Population (thousands)': 22.904},
{'Index': 219,
 'Country or area': 'Trinidad and Tobago',
 'Country code': 780,
 'Capital City': 'Port of Spain',
 'Note': 76.0,
 'Capital Type': 'Capital',
 'City code': 22631,
 'Latitude': 10.66617,
 'Longitude': -61.51657,
 'Population (thousands)': 544.417},
{'Index': 220,
 'Country or area': 'Tunisia',
 'Country code': 788,
 'Capital City': 'Tunis',
 'Note': 77.0,
 'Capital Type': 'Capital',
 'City code': 22646,
 'Latitude': 36.81897,
 'Longitude': 10.16579,
 'Population (thousands)': 2290.777},
{'Index': 221,
 'Country or area': 'Turkey',
 'Country code': 792,
 'Capital City': 'Ankara',
 'Note': 78.0,
 'Capital Type': 'Capital',
 'City code': 22656,
 'Latitude': 39.91987,
 'Longitude': 32.85427,
 'Population (thousands)': 4919.074},
{'Index': 222,
 'Country or area': 'Turkmenistan',
 'Country code': 795,
 'Capital City': 'Ashgabat',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22739,
 'Latitude': 37.95,
 'Longitude': 58.38333,
 'Population (thousands)': 810.186},
{'Index': 223,
 'Country or area': 'Turks and Caicos Islands',
 'Country code': 796,
 'Capital City': 'Cockburn Town',
 'Note': 79.0,
 'Capital Type': 'Capital',
 'City code': 22742,
 'Latitude': 21.46122,
 'Longitude': -71.14188,
 'Population (thousands)': 5.447},
{'Index': 224,
 'Country or area': 'Tuvalu',
 'Country code': 798,
 'Capital City': 'Funafuti',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22743,
 'Latitude': -8.518892,
 'Longitude': 179.199098,
 'Population (thousands)': 7.042},
{'Index': 225,
 'Country or area': 'Uganda',
 'Country code': 800,
 'Capital City': 'Kampala',
 'Note': 80.0,
 'Capital Type': 'Capital',
 'City code': 22744,
 'Latitude': 0.31628,
 'Longitude': 32.58219,
 'Population (thousands)': 2986.352},
{'Index': 226,
 'Country or area': 'Ukraine',
 'Country code': 804,
 'Capital City': 'Kyiv (Kiev)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22765,
 'Latitude': 50.445368,
 'Longitude': 30.518634,
 'Population (thousands)': 2956.706},
{'Index': 227,
 'Country or area': 'United Arab Emirates',
 'Country code': 784,
 'Capital City': 'Abu Zaby (Abu Dhabi)',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22632,
 'Latitude': 24.464778,
 'Longitude': 54.361781,
 'Population (thousands)': 1419.699},
{'Index': 228,
 'Country or area': 'United Kingdom',
 'Country code': 826,
 'Capital City': 'London',
 'Note': 81.0,
 'Capital Type': 'Capital',
 'City code': 22860,
 'Latitude': 51.50853,
 'Longitude': -0.12574,
 'Population (thousands)': 9046.485},
{'Index': 229,
 'Country or area': 'United Republic of Tanzania',
 'Country code': 834,
 'Capital City': 'Dodoma',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22895,
 'Latitude': -6.17221,
 'Longitude': 35.73947,
 'Population (thousands)': 261.645},
{'Index': 230,
 'Country or area': 'United States of America',
 'Country code': 840,
 'Capital City': 'Washington, D.C.',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23174,
 'Latitude': 38.89511,
 'Longitude': -77.03637,
 'Population (thousands)': 5206.593},
{'Index': 231,
 'Country or area': 'United States Virgin Islands',
 'Country code': 850,
 'Capital City': 'Charlotte Amalie',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23190,
 'Latitude': 18.3419,
 'Longitude': -64.9307,
 'Population (thousands)': 52.322},
{'Index': 232,
 'Country or area': 'Uruguay',
 'Country code': 858,
 'Capital City': 'Montevideo',
 'Note': 82.0,
 'Capital Type': 'Capital',
 'City code': 23193,
 'Latitude': -34.83346,
 'Longitude': -56.16735,
 'Population (thousands)': 1736.989},
{'Index': 233,
 'Country or area': 'Uzbekistan',
 'Country code': 860,
 'Capital City': 'Tashkent',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23209,
 'Latitude': 41.26465,
 'Longitude': 69.21627,
 'Population (thousands)': 2463.969},
{'Index': 234,
 'Country or area': 'Vanuatu',
 'Country code': 548,
 'Capital City': 'Port Vila',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 21956,
 'Latitude': -17.73381,
 'Longitude': 168.32188,
 'Population (thousands)': 52.69},
{'Index': 235,
 'Country or area': 'Venezuela (Bolivarian Republic of)',
 'Country code': 862,
 'Capital City': 'Caracas',
 'Note': 83.0,
 'Capital Type': 'Capital',
 'City code': 23217,
 'Latitude': 10.48801,
 'Longitude': -66.87919,
 'Population (thousands)': 2934.56},
{'Index': 236,
 'Country or area': 'Viet Nam',
 'Country code': 704,
 'Capital City': 'Hà Noi',
 'Note': 84.0,
 'Capital Type': 'Capital',
 'City code': 22457,
 'Latitude': 21.0245,
 'Longitude': 105.84117,
 'Population (thousands)': 4282.738},
{'Index': 237,
 'Country or area': 'Wallis and Futuna Islands',
 'Country code': 876,
 'Capital City': 'Matu-Utu',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23235,
 'Latitude': -13.28163,
 'Longitude': -176.17453,
 'Population (thousands)': 1.025},
{'Index': 238,
 'Country or area': 'Western Sahara',
 'Country code': 732,
 'Capital City': 'El Aaiún',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22571,
 'Latitude': 27.153164,
 'Longitude': -13.201359,
 'Population (thousands)': 232.388},
{'Index': 239,
 'Country or area': 'Yemen',
 'Country code': 887,
 'Capital City': "Sana'a'",
 'Note': 85.0,
 'Capital Type': 'Capital',
 'City code': 23239,
 'Latitude': 15.353115,
 'Longitude': 44.20782,
 'Population (thousands)': 2779.317},
{'Index': 240,
 'Country or area': 'Zambia',
 'Country code': 894,
 'Capital City': 'Lusaka',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 23277,
 'Latitude': -15.413374,
 'Longitude': 28.277148,
 'Population (thousands)': 2523.844},
{'Index': 241,
 'Country or area': 'Zimbabwe',
 'Country code': 716,
 'Capital City': 'Harare',
 'Note': '',
 'Capital Type': 'Capital',
 'City code': 22513,
 'Latitude': -17.82935,
 'Longitude': 31.05389,
 'Population (thousands)': 1515.016}]},
'CITIES IN EUROPE AND CENTRAL ASIA_ A SHIFTING STORY OF URBAN GROWTH AND DECLINE DATABASE': {'headers': ['country',
'uniqueid',
'nuts1',
'nuts2',
'nuts3',
'lat',
'lng',
'city',
'monotowns',
'year1',
'year2',
'year3',
'cen_1',
'cen_2',
'cen_3'],
'data': [{'country': 'Albania',
 'uniqueid': 'ALB1.29',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.803889,
 'lng': 19.914444,
 'city': 'KUCOVE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 21709,
 'cen_2': 18038,
 'cen_3': 12654},
{'country': 'Albania',
 'uniqueid': 'ALB1.4',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.708638,
 'lng': 19.943731,
 'city': 'BERAT',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 42957,
 'cen_2': 44040,
 'cen_3': 36496},
{'country': 'Albania',
 'uniqueid': 'ALB1.47',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.612222,
 'lng': 20.098056,
 'city': 'POLICAN',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 8961,
 'cen_2': 6623,
 'cen_3': 4318},
{'country': 'Albania',
 'uniqueid': 'ALB1.59',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.772063,
 'lng': 19.875258,
 'city': 'URA VAJGURORE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 4289,
 'cen_2': 9181,
 'cen_3': 7232},
{'country': 'Albania',
 'uniqueid': 'ALB1.9',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.503794,
 'lng': 20.226629,
 'city': 'COROVODE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 7544,
 'cen_2': 6546,
 'cen_3': 4051},
{'country': 'Albania',
 'uniqueid': 'ALB10.15',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.066667,
 'lng': 20.033333,
 'city': 'FUSHE ARREZ',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 2863,
 'cen_2': 4090,
 'cen_3': 2513},
{'country': 'Albania',
 'uniqueid': 'ALB10.26',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.213611,
 'lng': 19.436389,
 'city': 'KOPLIK',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 2448,
 'cen_2': 3126,
 'cen_3': 3734},
{'country': 'Albania',
 'uniqueid': 'ALB10.48',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.05,
 'lng': 19.9,
 'city': 'PUKE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 3028,
 'cen_2': 4579,
 'cen_3': 3607},
{'country': 'Albania',
 'uniqueid': 'ALB10.56',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.069299,
 'lng': 19.503256,
 'city': 'SHKODER',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 79920,
 'cen_2': 83274,
 'cen_3': 77075}]},
'Cities Over 300K Annual': {'headers': ['Index',
'Country Code',
'Country or area',
'City Code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
1950,
1951,
1952,
1953,
1954,
1955,
1956,
1957,
1958,
1959,
1960,
1961,
1962,
1963,
1964,
1965,
1966,
1967,
1968,
1969,
1970,
1971,
1972,
1973,
1974,
1975,
1976,
1977,
1978,
1979,
1980,
1981,
1982,
1983,
1984,
1985,
1986,
1987,
1988,
1989,
1990,
1991,
1992,
1993,
1994,
1995,
1996,
1997,
1998,
1999,
2000,
2001,
2002,
2003,
2004,
2005,
2006,
2007,
2008,
2009,
2010,
2011,
2012,
2013,
2014,
2015,
2016,
2017,
2018,
2019,
2020,
2021,
2022,
2023,
2024,
2025,
2026,
2027,
2028,
2029,
2030,
2031,
2032,
2033,
2034,
2035],
'data': [{'Index': 1,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20001,
 'Urban Agglomeration': 'Herat',
 'Note': '',
 'Latitude': 34.34817,
 'Longitude': 62.19967,
 '1950': 82.468,
 '1951': 83.114,
 '1952': 83.767,
 '1953': 84.422,
 '1954': 85.084,
 '1955': 85.751,
 '1956': 86.424,
 '1957': 87.101,
 '1958': 87.783,
 '1959': 88.472,
 '1960': 89.166,
 '1961': 89.864,
 '1962': 90.568,
 '1963': 91.278,
 '1964': 91.995,
 '1965': 92.715,
 '1966': 93.441,
 '1967': 94.878,
 '1968': 97.063,
 '1969': 99.292,
 '1970': 101.576,
 '1971': 103.912,
 '1972': 107.154,
 '1973': 111.371,
 '1974': 115.76,
 '1975': 120.323,
 '1976': 125.071,
 '1977': 129.994,
 '1978': 135.117,
 '1979': 140.398,
 '1980': 143.859,
 '1981': 147.396,
 '1982': 151.025,
 '1983': 154.744,
 '1984': 158.559,
 '1985': 162.457,
 '1986': 166.457,
 '1987': 170.555,
 '1988': 174.76,
 '1989': 179.057,
 '1990': 183.465,
 '1991': 187.983,
 '1992': 192.617,
 '1993': 197.353,
 '1994': 202.212,
 '1995': 207.19,
 '1996': 212.299,
 '1997': 217.518,
 '1998': 222.874,
 '1999': 228.361,
 '2000': 233.991,
 '2001': 239.744,
 '2002': 245.647,
 '2003': 251.695,
 '2004': 261.559,
 '2005': 275.678,
 '2006': 290.58,
 '2007': 306.287,
 '2008': 322.868,
 '2009': 340.296,
 '2010': 358.691,
 '2011': 378.081,
 '2012': 398.548,
 '2013': 420.061,
 '2014': 442.768,
 '2015': 466.703,
 '2016': 491.967,
 '2017': 518.599,
 '2018': 546.672,
 '2019': 575.806,
 '2020': 605.575,
 '2021': 635.579,
 '2022': 665.477,
 '2023': 695.043,
 '2024': 724.172,
 '2025': 752.91,
 '2026': 781.38,
 '2027': 809.8,
 '2028': 838.394,
 '2029': 867.422,
 '2030': 897.041,
 '2031': 927.393,
 '2032': 958.549,
 '2033': 990.635,
 '2034': 1023.636,
 '2035': 1057.573},
{'Index': 2,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20002,
 'Urban Agglomeration': 'Kabul',
 'Note': '',
 'Latitude': 34.528887,
 'Longitude': 69.17246,
 '1950': 170.784,
 '1951': 179.779,
 '1952': 189.26,
 '1953': 199.213,
 '1954': 209.705,
 '1955': 220.749,
 '1956': 232.391,
 '1957': 244.613,
 '1958': 257.496,
 '1959': 271.057,
 '1960': 285.352,
 '1961': 300.359,
 '1962': 316.177,
 '1963': 332.829,
 '1964': 350.382,
 '1965': 368.809,
 '1966': 388.232,
 '1967': 408.087,
 '1968': 428.363,
 '1969': 449.585,
 '1970': 471.891,
 '1971': 495.303,
 '1972': 528.508,
 '1973': 573.161,
 '1974': 621.656,
 '1975': 674.254,
 '1976': 731.385,
 '1977': 793.178,
 '1978': 860.289,
 '1979': 932.388,
 '1980': 977.824,
 '1981': 1025.339,
 '1982': 1075.233,
 '1983': 1127.555,
 '1984': 1182.5,
 '1985': 1239.961,
 '1986': 1300.299,
 '1987': 1358.525,
 '1988': 1419.444,
 '1989': 1482.916,
 '1990': 1549.32,
 '1991': 1618.697,
 '1992': 1691.283,
 '1993': 1766.91,
 '1994': 1846.031,
 '1995': 1928.694,
 '1996': 2015.181,
 '1997': 2105.292,
 '1998': 2199.565,
 '1999': 2298.059,
 '2000': 2401.109,
 '2001': 2508.477,
 '2002': 2620.804,
 '2003': 2738.161,
 '2004': 2834.061,
 '2005': 2905.178,
 '2006': 2978.181,
 '2007': 3053.018,
 '2008': 3129.844,
 '2009': 3208.383,
 '2010': 3289.005,
 '2011': 3371.653,
 '2012': 3456.496,
 '2013': 3543.232,
 '2014': 3632.269,
 '2015': 3723.543,
 '2016': 3817.241,
 '2017': 3913.297,
 '2018': 4011.77,
 '2019': 4114.03,
 '2020': 4221.532,
 '2021': 4335.77,
 '2022': 4457.882,
 '2023': 4588.666,
 '2024': 4728.384,
 '2025': 4877.024,
 '2026': 5034.106,
 '2027': 5199.155,
 '2028': 5371.55,
 '2029': 5551.063,
 '2030': 5737.138,
 '2031': 5929.531,
 '2032': 6127.953,
 '2033': 6332.756,
 '2034': 6543.594,
 '2035': 6760.5},
{'Index': 3,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20003,
 'Urban Agglomeration': 'Kandahar',
 'Note': '',
 'Latitude': 31.61332,
 'Longitude': 65.71013,
 '1950': 82.199,
 '1951': 83.663,
 '1952': 85.155,
 '1953': 86.67,
 '1954': 88.214,
 '1955': 89.785,
 '1956': 91.387,
 '1957': 93.012,
 '1958': 94.669,
 '1959': 96.355,
 '1960': 98.074,
 '1961': 99.818,
 '1962': 101.596,
 '1963': 103.406,
 '1964': 105.25,
 '1965': 107.123,
 '1966': 109.031,
 '1967': 112.297,
 '1968': 117.055,
 '1969': 122.002,
 '1970': 127.164,
 '1971': 132.545,
 '1972': 137.853,
 '1973': 143.036,
 '1974': 148.423,
 '1975': 154.012,
 '1976': 159.819,
 '1977': 165.829,
 '1978': 172.074,
 '1979': 178.504,
 '1980': 182.904,
 '1981': 187.399,
 '1982': 192.012,
 '1983': 196.738,
 '1984': 201.587,
 '1985': 206.542,
 '1986': 211.626,
 '1987': 216.834,
 '1988': 222.179,
 '1989': 227.64,
 '1990': 233.243,
 '1991': 238.983,
 '1992': 244.874,
 '1993': 250.893,
 '1994': 257.068,
 '1995': 263.395,
 '1996': 269.887,
 '1997': 276.521,
 '1998': 283.327,
 '1999': 290.3,
 '2000': 297.456,
 '2001': 304.767,
 '2002': 312.268,
 '2003': 319.954,
 '2004': 328.115,
 '2005': 336.746,
 '2006': 345.617,
 '2007': 354.721,
 '2008': 364.078,
 '2009': 373.655,
 '2010': 383.498,
 '2011': 393.6,
 '2012': 403.983,
 '2013': 414.61,
 '2014': 425.532,
 '2015': 436.741,
 '2016': 448.262,
 '2017': 460.087,
 '2018': 472.224,
 '2019': 484.812,
 '2020': 498.002,
 '2021': 511.949,
 '2022': 526.775,
 '2023': 542.565,
 '2024': 559.349,
 '2025': 577.128,
 '2026': 595.853,
 '2027': 615.48,
 '2028': 635.944,
 '2029': 657.23,
 '2030': 679.278,
 '2031': 702.066,
 '2032': 725.563,
 '2033': 749.814,
 '2034': 774.779,
 '2035': 800.461},
{'Index': 4,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20004,
 'Urban Agglomeration': 'Mazar-e Sharif',
 'Note': '',
 'Latitude': 36.70904,
 'Longitude': 67.11087,
 '1950': 30.0,
 '1951': 31.308,
 '1952': 32.676,
 '1953': 34.099,
 '1954': 35.586,
 '1955': 37.139,
 '1956': 38.761,
 '1957': 40.449,
 '1958': 42.213,
 '1959': 44.054,
 '1960': 45.979,
 '1961': 47.981,
 '1962': 50.074,
 '1963': 52.258,
 '1964': 54.541,
 '1965': 56.916,
 '1966': 59.399,
 '1967': 61.989,
 '1968': 64.697,
 '1969': 67.515,
 '1970': 70.46,
 '1971': 73.533,
 '1972': 76.745,
 '1973': 80.087,
 '1974': 83.58,
 '1975': 87.226,
 '1976': 91.036,
 '1977': 95.001,
 '1978': 99.144,
 '1979': 103.427,
 '1980': 105.977,
 '1981': 108.583,
 '1982': 111.256,
 '1983': 113.995,
 '1984': 116.805,
 '1985': 119.677,
 '1986': 122.623,
 '1987': 125.642,
 '1988': 128.74,
 '1989': 131.905,
 '1990': 135.153,
 '1991': 138.48,
 '1992': 141.894,
 '1993': 145.383,
 '1994': 148.962,
 '1995': 152.629,
 '1996': 156.392,
 '1997': 160.237,
 '1998': 164.182,
 '1999': 168.224,
 '2000': 172.372,
 '2001': 176.61,
 '2002': 180.958,
 '2003': 185.413,
 '2004': 193.721,
 '2005': 206.403,
 '2006': 219.935,
 '2007': 234.353,
 '2008': 249.739,
 '2009': 266.088,
 '2010': 283.532,
 '2011': 302.12,
 '2012': 321.955,
 '2013': 343.032,
 '2014': 365.52,
 '2015': 389.483,
 '2016': 415.053,
 '2017': 442.302,
 '2018': 471.339,
 '2019': 501.665,
 '2020': 532.689,
 '2021': 563.825,
 '2022': 594.551,
 '2023': 624.5,
 '2024': 653.486,
 '2025': 681.531,
 '2026': 708.798,
 '2027': 735.572,
 '2028': 762.162,
 '2029': 788.909,
 '2030': 816.04,
 '2031': 843.747,
 '2032': 872.137,
 '2033': 901.348,
 '2034': 931.381,
 '2035': 962.262},
{'Index': 5,
 'Country Code': 8,
 'Country or area': 'Albania',
 'City Code': 20005,
 'Urban Agglomeration': 'Tiranë (Tirana)',
 'Note': '',
 'Latitude': 41.3275,
 'Longitude': 19.81889,
 '1950': 84.513,
 '1951': 88.866,
 '1952': 93.08,
 '1953': 97.481,
 '1954': 102.097,
 '1955': 106.932,
 '1956': 112.001,
 '1957': 117.295,
 '1958': 122.847,
 '1959': 128.662,
 '1960': 134.761,
 '1961': 137.714,
 '1962': 139.561,
 '1963': 141.434,
 '1964': 143.334,
 '1965': 145.255,
 '1966': 147.203,
 '1967': 149.178,
 '1968': 151.183,
 '1969': 153.497,
 '1970': 156.734,
 '1971': 160.04,
 '1972': 163.42,
 '1973': 166.862,
 '1974': 170.381,
 '1975': 173.975,
 '1976': 177.649,
 '1977': 181.391,
 '1978': 185.217,
 '1979': 189.123,
 '1980': 193.644,
 '1981': 198.261,
 '1982': 202.994,
 '1983': 207.84,
 '1984': 212.809,
 '1985': 217.882,
 '1986': 223.084,
 '1987': 228.41,
 '1988': 233.87,
 '1989': 239.852,
 '1990': 247.27,
 '1991': 254.918,
 '1992': 262.814,
 '1993': 270.931,
 '1994': 279.311,
 '1995': 287.95,
 '1996': 296.869,
 '1997': 306.038,
 '1998': 315.503,
 '1999': 325.262,
 '2000': 335.336,
 '2001': 344.7,
 '2002': 351.285,
 '2003': 357.995,
 '2004': 364.843,
 '2005': 371.803,
 '2006': 378.905,
 '2007': 386.143,
 '2008': 393.529,
 '2009': 401.036,
 '2010': 408.697,
 '2011': 416.504,
 '2012': 424.471,
 '2013': 432.59,
 '2014': 440.865,
 '2015': 449.298,
 '2016': 457.892,
 '2017': 466.651,
 '2018': 475.577,
 '2019': 484.624,
 '2020': 493.712,
 '2021': 502.734,
 '2022': 511.559,
 '2023': 520.059,
 '2024': 528.127,
 '2025': 535.702,
 '2026': 542.74,
 '2027': 549.219,
 '2028': 555.132,
 '2029': 560.491,
 '2030': 565.301,
 '2031': 569.577,
 '2032': 573.332,
 '2033': 576.588,
 '2034': 579.349,
 '2035': 581.626},
{'Index': 6,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20009,
 'Urban Agglomeration': 'Annaba',
 'Note': '',
 'Latitude': 36.9,
 'Longitude': 7.76667,
 '1950': 99.741,
 '1951': 102.878,
 '1952': 106.118,
 '1953': 109.451,
 '1954': 112.893,
 '1955': 116.444,
 '1956': 120.111,
 '1957': 123.884,
 '1958': 127.78,
 '1959': 131.799,
 '1960': 135.95,
 '1961': 140.219,
 '1962': 144.629,
 '1963': 149.178,
 '1964': 153.876,
 '1965': 158.709,
 '1966': 164.035,
 '1967': 170.634,
 '1968': 177.507,
 '1969': 184.637,
 '1970': 192.064,
 '1971': 199.79,
 '1972': 207.838,
 '1973': 216.186,
 '1974': 224.882,
 '1975': 233.928,
 '1976': 243.351,
 '1977': 251.271,
 '1978': 256.377,
 '1979': 261.587,
 '1980': 266.91,
 '1981': 272.327,
 '1982': 277.861,
 '1983': 283.508,
 '1984': 289.277,
 '1985': 295.148,
 '1986': 301.146,
 '1987': 306.152,
 '1988': 308.383,
 '1989': 310.624,
 '1990': 312.885,
 '1991': 315.162,
 '1992': 317.459,
 '1993': 319.766,
 '1994': 322.093,
 '1995': 324.437,
 '1996': 326.801,
 '1997': 329.176,
 '1998': 331.554,
 '1999': 332.677,
 '2000': 333.805,
 '2001': 334.933,
 '2002': 336.067,
 '2003': 337.205,
 '2004': 338.348,
 '2005': 339.492,
 '2006': 340.641,
 '2007': 341.794,
 '2008': 342.953,
 '2009': 344.113,
 '2010': 345.278,
 '2011': 346.446,
 '2012': 347.618,
 '2013': 348.794,
 '2014': 349.974,
 '2015': 351.158,
 '2016': 352.346,
 '2017': 353.537,
 '2018': 354.733,
 '2019': 356.22,
 '2020': 358.241,
 '2021': 360.968,
 '2022': 364.484,
 '2023': 368.782,
 '2024': 373.779,
 '2025': 379.346,
 '2026': 385.315,
 '2027': 391.52,
 '2028': 397.814,
 '2029': 404.101,
 '2030': 410.307,
 '2031': 416.393,
 '2032': 422.336,
 '2033': 428.151,
 '2034': 433.842,
 '2035': 439.473},
{'Index': 7,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20011,
 'Urban Agglomeration': 'Batna',
 'Note': '',
 'Latitude': 35.55597,
 'Longitude': 6.17414,
 '1950': 13.046,
 '1951': 14.306,
 '1952': 15.689,
 '1953': 17.201,
 '1954': 18.862,
 '1955': 20.683,
 '1956': 22.683,
 '1957': 24.869,
 '1958': 27.27,
 '1959': 29.903,
 '1960': 32.794,
 '1961': 35.956,
 '1962': 39.427,
 '1963': 43.234,
 '1964': 47.414,
 '1965': 51.985,
 '1966': 56.513,
 '1967': 59.786,
 '1968': 63.254,
 '1969': 66.912,
 '1970': 70.787,
 '1971': 74.887,
 '1972': 79.231,
 '1973': 83.813,
 '1974': 88.667,
 '1975': 93.803,
 '1976': 99.243,
 '1977': 104.986,
 '1978': 111.077,
 '1979': 117.52,
 '1980': 124.347,
 '1981': 131.55,
 '1982': 139.181,
 '1983': 147.255,
 '1984': 155.81,
 '1985': 164.835,
 '1986': 174.397,
 '1987': 182.922,
 '1988': 187.685,
 '1989': 192.56,
 '1990': 197.568,
 '1991': 202.706,
 '1992': 207.985,
 '1993': 213.387,
 '1994': 218.937,
 '1995': 224.63,
 '1996': 230.481,
 '1997': 236.467,
 '1998': 242.569,
 '1999': 245.948,
 '2000': 249.379,
 '2001': 252.848,
 '2002': 256.37,
 '2003': 259.941,
 '2004': 263.567,
 '2005': 267.234,
 '2006': 270.956,
 '2007': 274.73,
 '2008': 278.563,
 '2009': 282.438,
 '2010': 286.372,
 '2011': 290.361,
 '2012': 294.406,
 '2013': 298.506,
 '2014': 302.664,
 '2015': 306.88,
 '2016': 311.155,
 '2017': 315.489,
 '2018': 319.884,
 '2019': 324.466,
 '2020': 329.333,
 '2021': 334.548,
 '2022': 340.12,
 '2023': 346.016,
 '2024': 352.163,
 '2025': 358.478,
 '2026': 364.859,
 '2027': 371.217,
 '2028': 377.479,
 '2029': 383.613,
 '2030': 389.593,
 '2031': 395.414,
 '2032': 401.077,
 '2033': 406.607,
 '2034': 412.015,
 '2035': 417.363},
{'Index': 8,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20015,
 'Urban Agglomeration': 'Blida',
 'Note': '',
 'Latitude': 36.480781,
 'Longitude': 2.831943,
 '1950': 33.97,
 '1951': 36.092,
 '1952': 38.349,
 '1953': 40.742,
 '1954': 43.286,
 '1955': 45.99,
 '1956': 48.867,
 '1957': 51.915,
 '1958': 55.158,
 '1959': 58.603,
 '1960': 62.269,
 '1961': 66.153,
 '1962': 70.286,
 '1963': 74.676,
 '1964': 79.347,
 '1965': 84.296,
 '1966': 89.114,
 '1967': 92.734,
 '1968': 96.505,
 '1969': 100.419,
 '1970': 104.497,
 '1971': 108.741,
 '1972': 113.164,
 '1973': 117.754,
 '1974': 122.536,
 '1975': 127.513,
 '1976': 132.699,
 '1977': 137.181,
 '1978': 140.321,
 '1979': 143.534,
 '1980': 146.825,
 '1981': 150.182,
 '1982': 153.62,
 '1983': 157.138,
 '1984': 160.74,
 '1985': 164.415,
 '1986': 168.18,
 '1987': 172.562,
 '1988': 178.464,
 '1989': 184.55,
 '1990': 190.852,
 '1991': 197.369,
 '1992': 204.119,
 '1993': 211.08,
 '1994': 218.288,
 '1995': 225.742,
 '1996': 233.462,
 '1997': 241.423,
 '1998': 249.652,
 '1999': 257.015,
 '2000': 264.604,
 '2001': 272.397,
 '2002': 280.43,
 '2003': 288.699,
 '2004': 297.225,
 '2005': 305.978,
 '2006': 315.001,
 '2007': 324.29,
 '2008': 333.867,
 '2009': 343.699,
 '2010': 353.834,
 '2011': 364.269,
 '2012': 375.012,
 '2013': 386.071,
 '2014': 397.457,
 '2015': 409.179,
 '2016': 421.246,
 '2017': 433.669,
 '2018': 446.458,
 '2019': 459.523,
 '2020': 472.733,
 '2021': 485.938,
 '2022': 498.969,
 '2023': 511.672,
 '2024': 523.92,
 '2025': 535.641,
 '2026': 546.792,
 '2027': 557.375,
 '2028': 567.423,
 '2029': 577.01,
 '2030': 586.199,
 '2031': 595.053,
 '2032': 603.617,
 '2033': 611.957,
 '2034': 620.102,
 '2035': 628.153},
{'Index': 9,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20006,
 'Urban Agglomeration': 'El Djazaïr  (Algiers)',
 'Note': 1.0,
 'Latitude': 36.7525,
 'Longitude': 3.04197,
 '1950': 516.45,
 '1951': 533.74,
 '1952': 551.632,
 '1953': 570.074,
 '1954': 589.158,
 '1955': 622.921,
 '1956': 666.263,
 '1957': 712.489,
 '1958': 761.992,
 '1959': 814.934,
 '1960': 871.636,
 '1961': 913.806,
 '1962': 953.095,
 '1963': 994.074,
 '1964': 1036.876,
 '1965': 1081.394,
 '1966': 1125.264,
 '1967': 1162.355,
 '1968': 1200.723,
 '1969': 1240.246,
 '1970': 1281.127,
 '1971': 1323.356,
 '1972': 1367.038,
 '1973': 1412.036,
 '1974': 1458.58,
 '1975': 1506.658,
 '1976': 1556.39,
 '1977': 1591.631,
 '1978': 1601.502,
 '1979': 1611.434,
 '1980': 1621.442,
 '1981': 1631.484,
 '1982': 1641.602,
 '1983': 1651.783,
 '1984': 1662.042,
 '1985': 1672.335,
 '1986': 1682.707,
 '1987': 1699.125,
 '1988': 1731.209,
 '1989': 1763.809,
 '1990': 1797.068,
 '1991': 1830.955,
 '1992': 1865.529,
 '1993': 1900.658,
 '1994': 1936.498,
 '1995': 1973.014,
 '1996': 2010.271,
 '1997': 2048.125,
 '1998': 2086.577,
 '1999': 2113.386,
 '2000': 2140.577,
 '2001': 2168.042,
 '2002': 2195.898,
 '2003': 2224.112,
 '2004': 2252.728,
 '2005': 2281.632,
 '2006': 2310.947,
 '2007': 2340.639,
 '2008': 2370.754,
 '2009': 2401.172,
 '2010': 2432.023,
 '2011': 2463.271,
 '2012': 2494.92,
 '2013': 2526.977,
 '2014': 2559.445,
 '2015': 2592.33,
 '2016': 2625.638,
 '2017': 2659.373,
 '2018': 2693.542,
 '2019': 2729.325,
 '2020': 2767.661,
 '2021': 2809.158,
 '2022': 2853.959,
 '2023': 2901.81,
 '2024': 2952.115,
 '2025': 3004.133,
 '2026': 3056.974,
 '2027': 3109.831,
 '2028': 3162.044,
 '2029': 3213.279,
 '2030': 3263.293,
 '2031': 3312.019,
 '2032': 3359.437,
 '2033': 3405.751,
 '2034': 3451.041,
 '2035': 3495.835},
{'Index': 10,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20020,
 'Urban Agglomeration': 'El Djelfa',
 'Note': '',
 'Latitude': 34.67279,
 'Longitude': 3.263,
 '1950': 10.45,
 '1951': 11.061,
 '1952': 11.708,
 '1953': 12.392,
 '1954': 13.117,
 '1955': 13.884,
 '1956': 14.697,
 '1957': 15.555,
 '1958': 16.465,
 '1959': 17.427,
 '1960': 18.448,
 '1961': 19.525,
 '1962': 20.667,
 '1963': 21.875,
 '1964': 23.156,
 '1965': 24.509,
 '1966': 25.942,
 '1967': 27.459,
 '1968': 29.067,
 '1969': 30.764,
 '1970': 32.563,
 '1971': 34.467,
 '1972': 36.486,
 '1973': 38.616,
 '1974': 40.875,
 '1975': 43.265,
 '1976': 45.798,
 '1977': 48.473,
 '1978': 51.307,
 '1979': 54.308,
 '1980': 57.488,
 '1981': 60.845,
 '1982': 64.403,
 '1983': 68.169,
 '1984': 72.161,
 '1985': 76.375,
 '1986': 80.841,
 '1987': 85.554,
 '1988': 90.509,
 '1989': 95.737,
 '1990': 101.274,
 '1991': 107.132,
 '1992': 113.337,
 '1993': 119.883,
 '1994': 126.817,
 '1995': 134.151,
 '1996': 141.922,
 '1997': 150.119,
 '1998': 158.793,
 '1999': 167.379,
 '2000': 176.441,
 '2001': 185.967,
 '2002': 196.022,
 '2003': 206.62,
 '2004': 217.807,
 '2005': 229.567,
 '2006': 241.979,
 '2007': 255.062,
 '2008': 268.872,
 '2009': 283.388,
 '2010': 298.71,
 '2011': 314.86,
 '2012': 331.883,
 '2013': 349.827,
 '2014': 368.74,
 '2015': 388.677,
 '2016': 409.691,
 '2017': 431.841,
 '2018': 455.189,
 '2019': 479.24,
 '2020': 503.397,
 '2021': 527.033,
 '2022': 549.565,
 '2023': 570.543,
 '2024': 589.697,
 '2025': 606.968,
 '2026': 622.45,
 '2027': 636.362,
 '2028': 648.976,
 '2029': 660.591,
 '2030': 671.455,
 '2031': 681.764,
 '2032': 691.652,
 '2033': 701.238,
 '2034': 710.582,
 '2035': 719.812},
{'Index': 11,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20019,
 'Urban Agglomeration': 'Qacentina',
 'Note': '',
 'Latitude': 36.354921,
 'Longitude': 6.607293,
 '1950': 88.001,
 '1951': 93.924,
 '1952': 100.254,
 '1953': 106.992,
 '1954': 114.193,
 '1955': 121.878,
 '1956': 130.092,
 '1957': 138.835,
 '1958': 148.179,
 '1959': 158.152,
 '1960': 168.811,
 '1961': 180.156,
 '1962': 192.281,
 '1963': 205.222,
 '1964': 219.053,
 '1965': 233.775,
 '1966': 247.49,
 '1967': 255.393,
 '1968': 263.56,
 '1969': 271.965,
 '1970': 280.65,
 '1971': 289.613,
 '1972': 298.874,
 '1973': 308.405,
 '1974': 318.254,
 '1975': 328.417,
 '1976': 338.92,
 '1977': 348.84,
 '1978': 357.584,
 '1979': 366.548,
 '1980': 375.749,
 '1981': 385.155,
 '1982': 394.81,
 '1983': 404.707,
 '1984': 414.866,
 '1985': 425.251,
 '1986': 435.911,
 '1987': 444.581,
 '1988': 447.623,
 '1989': 450.678,
 '1990': 453.758,
 '1991': 456.859,
 '1992': 459.985,
 '1993': 463.124,
 '1994': 466.289,
 '1995': 469.476,
 '1996': 472.689,
 '1997': 475.914,
 '1998': 479.077,
 '1999': 475.808,
 '2000': 472.556,
 '2001': 469.336,
 '2002': 466.133,
 '2003': 462.952,
 '2004': 459.789,
 '2005': 456.656,
 '2006': 453.539,
 '2007': 450.444,
 '2008': 447.366,
 '2009': 444.318,
 '2010': 441.286,
 '2011': 438.274,
 '2012': 435.283,
 '2013': 432.312,
 '2014': 429.361,
 '2015': 426.43,
 '2016': 423.52,
 '2017': 420.629,
 '2018': 417.758,
 '2019': 415.411,
 '2020': 414.011,
 '2021': 413.86,
 '2022': 415.11,
 '2023': 417.768,
 '2024': 421.714,
 '2025': 426.746,
 '2026': 432.6,
 '2027': 439.008,
 '2028': 445.725,
 '2029': 452.576,
 '2030': 459.425,
 '2031': 466.189,
 '2032': 472.821,
 '2033': 479.322,
 '2034': 485.69,
 '2035': 491.992},
{'Index': 12,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20037,
 'Urban Agglomeration': 'Sétif',
 'Note': '',
 'Latitude': 36.19112,
 'Longitude': 5.41373,
 '1950': 41.289,
 '1951': 43.327,
 '1952': 45.468,
 '1953': 47.709,
 '1954': 50.063,
 '1955': 52.534,
 '1956': 55.13,
 '1957': 57.847,
 '1958': 60.702,
 '1959': 63.698,
 '1960': 66.846,
 '1961': 70.14,
 '1962': 73.602,
 '1963': 77.234,
 '1964': 81.051,
 '1965': 85.045,
 '1966': 88.971,
 '1967': 92.189,
 '1968': 95.529,
 '1969': 98.979,
 '1970': 102.559,
 '1971': 106.269,
 '1972': 110.118,
 '1973': 114.096,
 '1974': 118.223,
 '1975': 122.499,
 '1976': 126.937,
 '1977': 131.088,
 '1978': 134.656,
 '1979': 138.322,
 '1980': 142.093,
 '1981': 145.955,
 '1982': 149.928,
 '1983': 154.01,
 '1984': 158.208,
 '1985': 162.509,
 '1986': 166.933,
 '1987': 171.118,
 '1988': 174.483,
 '1989': 177.904,
 '1990': 181.397,
 '1991': 184.959,
 '1992': 188.595,
 '1993': 192.293,
 '1994': 196.069,
 '1995': 199.918,
 '1996': 203.849,
 '1997': 207.846,
 '1998': 211.921,
 '1999': 215.716,
 '2000': 219.584,
 '2001': 223.51,
 '2002': 227.512,
 '2003': 231.586,
 '2004': 235.739,
 '2005': 239.954,
 '2006': 244.251,
 '2007': 248.624,
 '2008': 253.082,
 '2009': 257.608,
 '2010': 262.221,
 '2011': 266.916,
 '2012': 271.695,
 '2013': 276.56,
 '2014': 281.511,
 '2015': 286.552,
 '2016': 291.682,
 '2017': 296.905,
 '2018': 302.221,
 '2019': 307.703,
 '2020': 313.401,
 '2021': 319.333,
 '2022': 325.482,
 '2023': 331.801,
 '2024': 338.221,
 '2025': 344.671,
 '2026': 351.073,
 '2027': 357.365,
 '2028': 363.5,
 '2029': 369.467,
 '2030': 375.258,
 '2031': 380.881,
 '2032': 386.343,
 '2033': 391.672,
 '2034': 396.882,
 '2035': 402.034},
{'Index': 13,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20035,
 'Urban Agglomeration': 'Wahran (Oran)',
 'Note': '',
 'Latitude': 35.69111,
 'Longitude': -0.64167,
 '1950': 268.935,
 '1951': 272.335,
 '1952': 275.782,
 '1953': 279.263,
 '1954': 282.793,
 '1955': 286.368,
 '1956': 289.993,
 '1957': 293.653,
 '1958': 297.365,
 '1959': 301.124,
 '1960': 304.936,
 '1961': 308.785,
 '1962': 312.689,
 '1963': 316.641,
 '1964': 320.649,
 '1965': 324.697,
 '1966': 330.827,
 '1967': 343.652,
 '1968': 356.993,
 '1969': 370.813,
 '1970': 385.189,
 '1971': 400.121,
 '1972': 415.655,
 '1973': 431.746,
 '1974': 448.483,
 '1975': 465.87,
 '1976': 483.955,
 '1977': 499.928,
 '1978': 511.846,
 '1979': 524.049,
 '1980': 536.561,
 '1981': 549.335,
 '1982': 562.432,
 '1983': 575.841,
 '1984': 589.589,
 '1985': 603.626,
 '1986': 618.017,
 '1987': 631.029,
 '1988': 639.876,
 '1989': 648.822,
 '1990': 657.905,
 '1991': 667.116,
 '1992': 676.469,
 '1993': 685.927,
 '1994': 695.53,
 '1995': 705.268,
 '1996': 715.155,
 '1997': 725.154,
 '1998': 735.257,
 '1999': 741.94,
 '2000': 748.693,
 '2001': 755.489,
 '2002': 762.356,
 '2003': 769.286,
 '2004': 776.288,
 '2005': 783.334,
 '2006': 790.454,
 '2007': 797.639,
 '2008': 804.9,
 '2009': 812.206,
 '2010': 819.588,
 '2011': 827.038,
 '2012': 834.556,
 '2013': 842.142,
 '2014': 849.797,
 '2015': 857.521,
 '2016': 865.316,
 '2017': 873.182,
 '2018': 881.119,
 '2019': 889.644,
 '2020': 899.182,
 '2021': 910.03,
 '2022': 922.302,
 '2023': 935.947,
 '2024': 950.768,
 '2025': 966.494,
 '2026': 982.784,
 '2027': 999.314,
 '2028': 1015.811,
 '2029': 1032.11,
 '2030': 1048.089,
 '2031': 1063.698,
 '2032': 1078.908,
 '2033': 1093.775,
 '2034': 1108.317,
 '2035': 1122.702},
{'Index': 14,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000001,
 'Urban Agglomeration': 'Benguela',
 'Note': 2.0,
 'Latitude': -12.576,
 'Longitude': 13.405,
 '1950': 14.364,
 '1951': 15.042,
 '1952': 15.752,
 '1953': 16.493,
 '1954': 17.27,
 '1955': 18.085,
 '1956': 18.938,
 '1957': 19.83,
 '1958': 20.764,
 '1959': 21.743,
 '1960': 22.77,
 '1961': 23.968,
 '1962': 25.366,
 '1963': 26.845,
 '1964': 28.412,
 '1965': 30.067,
 '1966': 31.82,
 '1967': 33.676,
 '1968': 35.642,
 '1969': 37.718,
 '1970': 39.917,
 '1971': 43.393,
 '1972': 48.257,
 '1973': 53.65,
 '1974': 59.655,
 '1975': 66.332,
 '1976': 73.767,
 '1977': 82.012,
 '1978': 91.191,
 '1979': 101.397,
 '1980': 112.763,
 '1981': 125.366,
 '1982': 139.398,
 '1983': 155.0,
 '1984': 161.548,
 '1985': 168.354,
 '1986': 175.456,
 '1987': 182.858,
 '1988': 190.584,
 '1989': 198.612,
 '1990': 206.991,
 '1991': 215.724,
 '1992': 224.837,
 '1993': 234.309,
 '1994': 244.194,
 '1995': 254.496,
 '1996': 265.248,
 '1997': 276.422,
 '1998': 288.084,
 '1999': 300.237,
 '2000': 312.921,
 '2001': 326.104,
 '2002': 339.862,
 '2003': 354.199,
 '2004': 369.163,
 '2005': 384.715,
 '2006': 400.945,
 '2007': 417.86,
 '2008': 435.513,
 '2009': 453.861,
 '2010': 473.008,
 '2011': 492.963,
 '2012': 513.789,
 '2013': 535.434,
 '2014': 558.022,
 '2015': 581.564,
 '2016': 606.133,
 '2017': 631.668,
 '2018': 658.317,
 '2019': 686.121,
 '2020': 715.13,
 '2021': 745.372,
 '2022': 776.832,
 '2023': 809.468,
 '2024': 843.207,
 '2025': 878.004,
 '2026': 913.769,
 '2027': 950.447,
 '2028': 987.971,
 '2029': 1026.364,
 '2030': 1065.572,
 '2031': 1105.588,
 '2032': 1146.377,
 '2033': 1188.018,
 '2034': 1230.439,
 '2035': 1273.636},
{'Index': 15,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204043,
 'Urban Agglomeration': 'Cabinda',
 'Note': 3.0,
 'Latitude': -5.55,
 'Longitude': 12.2,
 '1950': 4.722,
 '1951': 4.71,
 '1952': 4.698,
 '1953': 4.687,
 '1954': 4.675,
 '1955': 4.663,
 '1956': 4.652,
 '1957': 4.64,
 '1958': 4.629,
 '1959': 4.617,
 '1960': 4.606,
 '1961': 4.965,
 '1962': 5.786,
 '1963': 6.744,
 '1964': 7.861,
 '1965': 9.16,
 '1966': 10.675,
 '1967': 12.442,
 '1968': 14.503,
 '1969': 16.899,
 '1970': 19.695,
 '1971': 22.227,
 '1972': 24.415,
 '1973': 26.813,
 '1974': 29.449,
 '1975': 32.345,
 '1976': 35.531,
 '1977': 39.02,
 '1978': 42.856,
 '1979': 47.071,
 '1980': 51.706,
 '1981': 56.783,
 '1982': 62.367,
 '1983': 68.5,
 '1984': 75.246,
 '1985': 82.634,
 '1986': 90.76,
 '1987': 99.685,
 '1988': 109.502,
 '1989': 120.254,
 '1990': 132.079,
 '1991': 145.067,
 '1992': 159.353,
 '1993': 175.0,
 '1994': 184.954,
 '1995': 195.473,
 '1996': 206.607,
 '1997': 218.342,
 '1998': 230.761,
 '1999': 243.886,
 '2000': 257.777,
 '2001': 272.418,
 '2002': 287.913,
 '2003': 304.289,
 '2004': 321.62,
 '2005': 339.887,
 '2006': 359.219,
 '2007': 379.651,
 '2008': 401.275,
 '2009': 424.067,
 '2010': 448.187,
 '2011': 473.678,
 '2012': 500.658,
 '2013': 529.094,
 '2014': 559.188,
 '2015': 590.993,
 '2016': 624.655,
 '2017': 660.134,
 '2018': 697.681,
 '2019': 736.984,
 '2020': 777.697,
 '2021': 819.452,
 '2022': 861.878,
 '2023': 904.676,
 '2024': 947.634,
 '2025': 990.695,
 '2026': 1033.86,
 '2027': 1077.231,
 '2028': 1120.931,
 '2029': 1165.172,
 '2030': 1210.051,
 '2031': 1255.676,
 '2032': 1302.086,
 '2033': 1349.417,
 '2034': 1397.614,
 '2035': 1446.685},
{'Index': 16,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000011,
 'Urban Agglomeration': 'Cuito',
 'Note': '',
 'Latitude': -12.383,
 'Longitude': 16.933,
 '1950': 8.632,
 '1951': 8.97,
 '1952': 9.322,
 '1953': 9.686,
 '1954': 10.066,
 '1955': 10.46,
 '1956': 10.87,
 '1957': 11.295,
 '1958': 11.738,
 '1959': 12.197,
 '1960': 12.676,
 '1961': 13.171,
 '1962': 13.687,
 '1963': 14.223,
 '1964': 14.781,
 '1965': 15.359,
 '1966': 15.96,
 '1967': 16.585,
 '1968': 17.236,
 '1969': 17.91,
 '1970': 18.611,
 '1971': 19.648,
 '1972': 21.022,
 '1973': 22.489,
 '1974': 24.06,
 '1975': 25.741,
 '1976': 27.542,
 '1977': 29.463,
 '1978': 31.522,
 '1979': 33.724,
 '1980': 36.084,
 '1981': 38.601,
 '1982': 41.298,
 '1983': 44.183,
 '1984': 47.274,
 '1985': 50.572,
 '1986': 54.105,
 '1987': 57.886,
 '1988': 61.935,
 '1989': 66.256,
 '1990': 70.885,
 '1991': 75.838,
 '1992': 81.143,
 '1993': 86.804,
 '1994': 92.869,
 '1995': 99.357,
 '1996': 106.308,
 '1997': 113.725,
 '1998': 121.67,
 '1999': 130.171,
 '2000': 139.278,
 '2001': 148.994,
 '2002': 159.404,
 '2003': 170.54,
 '2004': 182.472,
 '2005': 195.202,
 '2006': 208.84,
 '2007': 223.43,
 '2008': 239.062,
 '2009': 255.74,
 '2010': 273.607,
 '2011': 292.722,
 '2012': 313.202,
 '2013': 335.053,
 '2014': 358.461,
 '2015': 383.504,
 '2016': 410.336,
 '2017': 438.963,
 '2018': 469.63,
 '2019': 501.936,
 '2020': 535.407,
 '2021': 569.533,
 '2022': 603.814,
 '2023': 637.853,
 '2024': 671.387,
 '2025': 704.349,
 '2026': 736.784,
 '2027': 768.859,
 '2028': 800.779,
 '2029': 832.81,
 '2030': 865.116,
 '2031': 897.85,
 '2032': 931.086,
 '2033': 964.954,
 '2034': 999.427,
 '2035': 1034.52},
{'Index': 17,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20050,
 'Urban Agglomeration': 'Huambo',
 'Note': 4.0,
 'Latitude': -12.77611,
 'Longitude': 15.73917,
 '1950': 15.306,
 '1951': 16.721,
 '1952': 18.27,
 '1953': 19.957,
 '1954': 21.802,
 '1955': 23.818,
 '1956': 26.024,
 '1957': 28.427,
 '1958': 31.056,
 '1959': 33.927,
 '1960': 37.069,
 '1961': 39.664,
 '1962': 41.575,
 '1963': 43.577,
 '1964': 45.678,
 '1965': 47.875,
 '1966': 50.18,
 '1967': 52.597,
 '1968': 55.133,
 '1969': 57.785,
 '1970': 60.567,
 '1971': 65.148,
 '1972': 71.629,
 '1973': 78.734,
 '1974': 86.556,
 '1975': 95.155,
 '1976': 104.621,
 '1977': 115.0,
 '1978': 126.424,
 '1979': 138.984,
 '1980': 152.811,
 '1981': 167.969,
 '1982': 184.656,
 '1983': 203.0,
 '1984': 217.267,
 '1985': 232.492,
 '1986': 248.809,
 '1987': 266.27,
 '1988': 284.983,
 '1989': 304.954,
 '1990': 326.355,
 '1991': 349.259,
 '1992': 373.804,
 '1993': 400.0,
 '1994': 407.692,
 '1995': 415.532,
 '1996': 423.534,
 '1997': 431.668,
 '1998': 439.969,
 '1999': 448.43,
 '2000': 457.066,
 '2001': 465.843,
 '2002': 474.801,
 '2003': 483.932,
 '2004': 493.251,
 '2005': 502.724,
 '2006': 512.391,
 '2007': 522.245,
 '2008': 532.302,
 '2009': 542.524,
 '2010': 552.957,
 '2011': 563.591,
 '2012': 574.444,
 '2013': 585.476,
 '2014': 596.735,
 '2015': 608.21,
 '2016': 619.923,
 '2017': 631.828,
 '2018': 643.978,
 '2019': 656.977,
 '2020': 671.413,
 '2021': 687.795,
 '2022': 706.476,
 '2023': 727.641,
 '2024': 751.297,
 '2025': 777.336,
 '2026': 805.507,
 '2027': 835.521,
 '2028': 867.065,
 '2029': 899.922,
 '2030': 933.847,
 '2031': 968.691,
 '2032': 1004.327,
 '2033': 1040.766,
 '2034': 1077.913,
 '2035': 1115.75},
{'Index': 18,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000000,
 'Urban Agglomeration': 'Lobito',
 'Note': 5.0,
 'Latitude': -12.364,
 'Longitude': 13.536,
 '1950': 23.027,
 '1951': 24.801,
 '1952': 26.714,
 '1953': 28.769,
 '1954': 30.986,
 '1955': 33.373,
 '1956': 35.947,
 '1957': 38.713,
 '1958': 41.695,
 '1959': 44.907,
 '1960': 48.371,
 '1961': 50.63,
 '1962': 51.504,
 '1963': 52.394,
 '1964': 53.3,
 '1965': 54.219,
 '1966': 55.155,
 '1967': 56.107,
 '1968': 57.077,
 '1969': 58.061,
 '1970': 59.064,
 '1971': 61.956,
 '1972': 66.7,
 '1973': 71.793,
 '1974': 77.283,
 '1975': 83.193,
 '1976': 89.563,
 '1977': 96.402,
 '1978': 103.774,
 '1979': 111.709,
 '1980': 120.263,
 '1981': 129.446,
 '1982': 139.345,
 '1983': 150.0,
 '1984': 154.292,
 '1985': 158.694,
 '1986': 163.228,
 '1987': 167.892,
 '1988': 172.696,
 '1989': 177.623,
 '1990': 182.698,
 '1991': 187.918,
 '1992': 193.295,
 '1993': 198.81,
 '1994': 204.49,
 '1995': 210.333,
 '1996': 216.351,
 '1997': 222.523,
 '1998': 228.881,
 '1999': 235.421,
 '2000': 242.157,
 '2001': 249.066,
 '2002': 256.182,
 '2003': 263.502,
 '2004': 271.041,
 '2005': 278.774,
 '2006': 286.739,
 '2007': 294.932,
 '2008': 303.371,
 '2009': 312.026,
 '2010': 320.941,
 '2011': 330.111,
 '2012': 339.556,
 '2013': 349.245,
 '2014': 359.223,
 '2015': 369.487,
 '2016': 380.058,
 '2017': 390.902,
 '2018': 402.071,
 '2019': 413.795,
 '2020': 426.31,
 '2021': 439.82,
 '2022': 454.464,
 '2023': 470.316,
 '2024': 487.368,
 '2025': 505.576,
 '2026': 524.828,
 '2027': 545.002,
 '2028': 565.963,
 '2029': 587.634,
 '2030': 609.908,
 '2031': 632.725,
 '2032': 656.029,
 '2033': 679.842,
 '2034': 704.111,
 '2035': 728.829},
{'Index': 19,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20049,
 'Urban Agglomeration': 'Luanda',
 'Note': 6.0,
 'Latitude': -8.83682,
 'Longitude': 13.23432,
 '1950': 138.413,
 '1951': 144.939,
 '1952': 151.782,
 '1953': 158.928,
 '1954': 166.422,
 '1955': 174.268,
 '1956': 182.497,
 '1957': 191.089,
 '1958': 200.099,
 '1959': 209.533,
 '1960': 219.427,
 '1961': 233.134,
 '1962': 251.373,
 '1963': 271.039,
 '1964': 292.274,
 '1965': 315.108,
 '1966': 339.76,
 '1967': 366.341,
 '1968': 395.043,
 '1969': 425.905,
 '1970': 459.225,
 '1971': 488.59,
 '1972': 514.05,
 '1973': 540.761,
 '1974': 568.901,
 '1975': 598.504,
 '1976': 629.692,
 '1977': 662.412,
 '1978': 696.882,
 '1979': 733.145,
 '1980': 771.349,
 '1981': 811.43,
 '1982': 853.654,
 '1983': 898.124,
 '1984': 964.072,
 '1985': 1034.661,
 '1986': 1110.527,
 '1987': 1191.955,
 '1988': 1279.479,
 '1989': 1373.162,
 '1990': 1473.848,
 '1991': 1581.917,
 '1992': 1698.075,
 '1993': 1822.407,
 '1994': 1940.528,
 '1995': 2066.306,
 '1996': 2200.426,
 '1997': 2342.847,
 '1998': 2494.701,
 '1999': 2656.398,
 '2000': 2828.82,
 '2001': 3011.913,
 '2002': 3207.133,
 '2003': 3415.007,
 '2004': 3636.67,
 '2005': 3872.05,
 '2006': 4123.021,
 '2007': 4390.259,
 '2008': 4675.223,
 '2009': 4977.823,
 '2010': 5300.466,
 '2011': 5644.022,
 '2012': 6010.365,
 '2013': 6399.381,
 '2014': 6789.357,
 '2015': 7023.206,
 '2016': 7265.449,
 '2017': 7515.345,
 '2018': 7774.2,
 '2019': 8044.735,
 '2020': 8329.798,
 '2021': 8631.876,
 '2022': 8952.496,
 '2023': 9292.336,
 '2024': 9651.032,
 '2025': 10027.897,
 '2026': 10421.27,
 '2027': 10829.513,
 '2028': 11250.806,
 '2029': 11684.375,
 '2030': 12128.764,
 '2031': 12583.262,
 '2032': 13047.054,
 '2033': 13520.789,
 '2034': 14003.51,
 '2035': 14495.112},
{'Index': 20,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204044,
 'Urban Agglomeration': 'Lubango',
 'Note': 7.0,
 'Latitude': -14.91717,
 'Longitude': 13.4925,
 '1950': 11.555,
 '1951': 11.846,
 '1952': 12.146,
 '1953': 12.453,
 '1954': 12.767,
 '1955': 13.09,
 '1956': 13.421,
 '1957': 13.76,
 '1958': 14.107,
 '1959': 14.464,
 '1960': 14.83,
 '1961': 15.588,
 '1962': 16.801,
 '1963': 18.109,
 '1964': 19.521,
 '1965': 21.039,
 '1966': 22.677,
 '1967': 24.442,
 '1968': 26.347,
 '1969': 28.395,
 '1970': 30.606,
 '1971': 33.11,
 '1972': 35.935,
 '1973': 38.991,
 '1974': 42.313,
 '1975': 45.917,
 '1976': 49.834,
 '1977': 54.073,
 '1978': 58.679,
 '1979': 63.678,
 '1980': 69.11,
 '1981': 74.988,
 '1982': 81.376,
 '1983': 88.308,
 '1984': 95.841,
 '1985': 103.993,
 '1986': 112.852,
 '1987': 122.465,
 '1988': 132.912,
 '1989': 144.217,
 '1990': 156.502,
 '1991': 169.834,
 '1992': 184.321,
 '1993': 200.0,
 '1994': 210.821,
 '1995': 222.227,
 '1996': 234.267,
 '1997': 246.924,
 '1998': 260.283,
 '1999': 274.366,
 '2000': 289.231,
 '2001': 304.857,
 '2002': 321.351,
 '2003': 338.737,
 '2004': 357.09,
 '2005': 376.382,
 '2006': 396.746,
 '2007': 418.211,
 '2008': 440.87,
 '2009': 464.689,
 '2010': 489.83,
 '2011': 516.332,
 '2012': 544.306,
 '2013': 573.714,
 '2014': 604.754,
 '2015': 637.473,
 '2016': 672.011,
 '2017': 708.318,
 '2018': 746.64,
 '2019': 786.713,
 '2020': 828.248,
 '2021': 870.935,
 '2022': 914.456,
 '2023': 958.548,
 '2024': 1003.016,
 '2025': 1047.806,
 '2026': 1092.9,
 '2027': 1138.376,
 '2028': 1184.324,
 '2029': 1230.933,
 '2030': 1278.271,
 '2031': 1326.432,
 '2032': 1375.44,
 '2033': 1425.431,
 '2034': 1476.341,
 '2035': 1528.175},
{'Index': 21,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000004,
 'Urban Agglomeration': 'Malanje',
 'Note': 8.0,
 'Latitude': -9.54,
 'Longitude': 16.341,
 '1950': 9.176,
 '1951': 9.834,
 '1952': 10.541,
 '1953': 11.296,
 '1954': 12.107,
 '1955': 12.976,
 '1956': 13.909,
 '1957': 14.906,
 '1958': 15.976,
 '1959': 17.122,
 '1960': 18.353,
 '1961': 19.49,
 '1962': 20.512,
 '1963': 21.587,
 '1964': 22.72,
 '1965': 23.91,
 '1966': 25.163,
 '1967': 26.482,
 '1968': 27.872,
 '1969': 29.331,
 '1970': 30.869,
 '1971': 32.672,
 '1972': 34.75,
 '1973': 36.953,
 '1974': 39.299,
 '1975': 41.795,
 '1976': 44.452,
 '1977': 47.271,
 '1978': 50.272,
 '1979': 53.464,
 '1980': 56.864,
 '1981': 60.469,
 '1982': 64.309,
 '1983': 68.392,
 '1984': 72.741,
 '1985': 77.354,
 '1986': 82.265,
 '1987': 87.489,
 '1988': 93.052,
 '1989': 98.952,
 '1990': 105.235,
 '1991': 111.917,
 '1992': 119.033,
 '1993': 126.581,
 '1994': 134.618,
 '1995': 143.166,
 '1996': 152.269,
 '1997': 161.924,
 '1998': 172.206,
 '1999': 183.14,
 '2000': 194.785,
 '2001': 207.136,
 '2002': 220.288,
 '2003': 234.276,
 '2004': 249.173,
 '2005': 264.972,
 '2006': 281.796,
 '2007': 299.689,
 '2008': 318.746,
 '2009': 338.956,
 '2010': 360.478,
 '2011': 383.368,
 '2012': 407.744,
 '2013': 433.598,
 '2014': 461.13,
 '2015': 490.41,
 '2016': 521.593,
 '2017': 554.665,
 '2018': 589.885,
 '2019': 626.862,
 '2020': 665.15,
 '2021': 704.271,
 '2022': 743.76,
 '2023': 783.243,
 '2024': 822.471,
 '2025': 861.38,
 '2026': 900.002,
 '2027': 938.486,
 '2028': 977.013,
 '2029': 1015.839,
 '2030': 1055.109,
 '2031': 1094.963,
 '2032': 1135.466,
 '2033': 1176.754,
 '2034': 1218.789,
 '2035': 1261.582},
{'Index': 22,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000012,
 'Urban Agglomeration': 'Uige',
 'Note': '',
 'Latitude': -7.1069,
 'Longitude': 15.4406,
 '1950': 3.201,
 '1951': 3.414,
 '1952': 3.642,
 '1953': 3.884,
 '1954': 4.143,
 '1955': 4.418,
 '1956': 4.713,
 '1957': 5.027,
 '1958': 5.362,
 '1959': 5.719,
 '1960': 6.1,
 '1961': 6.506,
 '1962': 6.939,
 '1963': 7.401,
 '1964': 7.895,
 '1965': 8.42,
 '1966': 8.981,
 '1967': 9.579,
 '1968': 10.218,
 '1969': 10.898,
 '1970': 11.624,
 '1971': 12.475,
 '1972': 13.46,
 '1973': 14.519,
 '1974': 15.663,
 '1975': 16.898,
 '1976': 18.231,
 '1977': 19.666,
 '1978': 21.216,
 '1979': 22.888,
 '1980': 24.694,
 '1981': 26.638,
 '1982': 28.737,
 '1983': 31.002,
 '1984': 33.449,
 '1985': 36.082,
 '1986': 38.925,
 '1987': 41.993,
 '1988': 45.307,
 '1989': 48.873,
 '1990': 52.725,
 '1991': 56.88,
 '1992': 61.37,
 '1993': 66.199,
 '1994': 71.417,
 '1995': 77.045,
 '1996': 83.126,
 '1997': 89.668,
 '1998': 96.735,
 '1999': 104.359,
 '2000': 112.596,
 '2001': 121.457,
 '2002': 131.03,
 '2003': 141.357,
 '2004': 152.513,
 '2005': 164.516,
 '2006': 177.482,
 '2007': 191.47,
 '2008': 206.582,
 '2009': 222.84,
 '2010': 240.402,
 '2011': 259.349,
 '2012': 279.819,
 '2013': 301.84,
 '2014': 325.629,
 '2015': 351.293,
 '2016': 379.019,
 '2017': 408.848,
 '2018': 441.071,
 '2019': 475.198,
 '2020': 510.631,
 '2021': 546.706,
 '2022': 582.775,
 '2023': 618.313,
 '2024': 652.976,
 '2025': 686.667,
 '2026': 719.452,
 '2027': 751.551,
 '2028': 783.239,
 '2029': 814.852,
 '2030': 846.615,
 '2031': 878.725,
 '2032': 911.289,
 '2033': 944.45,
 '2034': 978.196,
 '2035': 1012.545},
{'Index': 23,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20057,
 'Urban Agglomeration': 'Bahia Blanca',
 'Note': '',
 'Latitude': -38.7196,
 'Longitude': -62.27243,
 '1950': 115.752,
 '1951': 116.774,
 '1952': 117.807,
 '1953': 118.846,
 '1954': 119.895,
 '1955': 120.954,
 '1956': 122.024,
 '1957': 123.1,
 '1958': 124.188,
 '1959': 125.284,
 '1960': 126.392,
 '1961': 130.168,
 '1962': 134.984,
 '1963': 139.979,
 '1964': 145.165,
 '1965': 150.529,
 '1966': 156.099,
 '1967': 161.874,
 '1968': 167.872,
 '1969': 174.075,
 '1970': 180.515,
 '1971': 184.979,
 '1972': 188.81,
 '1973': 192.71,
 '1974': 196.695,
 '1975': 200.764,
 '1976': 204.922,
 '1977': 209.154,
 '1978': 213.48,
 '1979': 217.895,
 '1980': 222.408,
 '1981': 225.741,
 '1982': 228.559,
 '1983': 231.412,
 '1984': 234.304,
 '1985': 237.224,
 '1986': 240.185,
 '1987': 243.183,
 '1988': 246.222,
 '1989': 249.291,
 '1990': 252.403,
 '1991': 255.347,
 '1992': 256.924,
 '1993': 258.506,
 '1994': 260.099,
 '1995': 261.703,
 '1996': 263.319,
 '1997': 264.94,
 '1998': 266.574,
 '1999': 268.217,
 '2000': 269.873,
 '2001': 271.535,
 '2002': 274.016,
 '2003': 277.028,
 '2004': 280.077,
 '2005': 283.152,
 '2006': 286.264,
 '2007': 289.411,
 '2008': 292.596,
 '2009': 295.808,
 '2010': 299.059,
 '2011': 301.154,
 '2012': 302.693,
 '2013': 304.237,
 '2014': 305.79,
 '2015': 307.351,
 '2016': 308.922,
 '2017': 310.497,
 '2018': 312.08,
 '2019': 313.739,
 '2020': 315.533,
 '2021': 317.507,
 '2022': 319.681,
 '2023': 322.057,
 '2024': 324.616,
 '2025': 327.329,
 '2026': 330.154,
 '2027': 333.052,
 '2028': 335.984,
 '2029': 338.924,
 '2030': 341.833,
 '2031': 344.694,
 '2032': 347.522,
 '2033': 350.315,
 '2034': 353.068,
 '2035': 355.78},
{'Index': 24,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 9.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 '1950': 5166.14,
 '1951': 5307.065,
 '1952': 5452.036,
 '1953': 5600.553,
 '1954': 5753.328,
 '1955': 5910.271,
 '1956': 6071.72,
 '1957': 6237.117,
 '1958': 6407.257,
 '1959': 6582.038,
 '1960': 6761.837,
 '1961': 6919.245,
 '1962': 7071.464,
 '1963': 7227.032,
 '1964': 7386.244,
 '1965': 7548.511,
 '1966': 7714.574,
 '1967': 7884.29,
 '1968': 8057.981,
 '1969': 8235.005,
 '1970': 8416.17,
 '1971': 8566.128,
 '1972': 8707.088,
 '1973': 8849.971,
 '1974': 8995.4,
 '1975': 9143.219,
 '1976': 9293.676,
 '1977': 9446.184,
 '1978': 9601.411,
 '1979': 9759.188,
 '1980': 9919.781,
 '1981': 10049.398,
 '1982': 10165.869,
 '1983': 10283.689,
 '1984': 10403.04,
 '1985': 10523.442,
 '1986': 10645.407,
 '1987': 10768.785,
 '1988': 10893.766,
 '1989': 11019.848,
 '1990': 11147.566,
 '1991': 11276.696,
 '1992': 11407.033,
 '1993': 11538.512,
 '1994': 11671.691,
 '1995': 11806.407,
 '1996': 11942.867,
 '1997': 12080.522,
 '1998': 12219.957,
 '1999': 12361.001,
 '2000': 12503.871,
 '2001': 12647.992,
 '2002': 12808.282,
 '2003': 12979.73,
 '2004': 13153.713,
 '2005': 13329.54,
 '2006': 13507.965,
 '2007': 13688.779,
 '2008': 13872.267,
 '2009': 14057.699,
 '2010': 14245.871,
 '2011': 14364.449,
 '2012': 14449.088,
 '2013': 14533.991,
 '2014': 14619.51,
 '2015': 14705.533,
 '2016': 14792.181,
 '2017': 14879.1,
 '2018': 14966.53,
 '2019': 15057.273,
 '2020': 15153.729,
 '2021': 15257.673,
 '2022': 15369.919,
 '2023': 15490.415,
 '2024': 15618.288,
 '2025': 15752.275,
 '2026': 15890.628,
 '2027': 16031.641,
 '2028': 16173.701,
 '2029': 16315.759,
 '2030': 16456.115,
 '2031': 16593.948,
 '2032': 16730.161,
 '2033': 16864.622,
 '2034': 16997.163,
 '2035': 17127.741},
{'Index': 25,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20059,
 'Urban Agglomeration': 'Córdoba',
 'Note': 10.0,
 'Latitude': -31.4135,
 'Longitude': -64.18105,
 '1950': 429.249,
 '1951': 444.257,
 '1952': 459.811,
 '1953': 475.865,
 '1954': 492.502,
 '1955': 509.722,
 '1956': 527.568,
 '1957': 545.987,
 '1958': 565.076,
 '1959': 584.833,
 '1960': 605.309,
 '1961': 623.915,
 '1962': 642.256,
 '1963': 661.137,
 '1964': 680.601,
 '1965': 700.581,
 '1966': 721.176,
 '1967': 742.377,
 '1968': 764.232,
 '1969': 786.668,
 '1970': 809.794,
 '1971': 829.163,
 '1972': 847.518,
 '1973': 866.227,
 '1974': 885.376,
 '1975': 904.947,
 '1976': 924.98,
 '1977': 945.399,
 '1978': 966.297,
 '1979': 987.658,
 '1980': 1009.521,
 '1981': 1028.459,
 '1982': 1046.255,
 '1983': 1064.359,
 '1984': 1082.802,
 '1985': 1101.512,
 '1986': 1120.572,
 '1987': 1139.962,
 '1988': 1159.715,
 '1989': 1179.754,
 '1990': 1200.168,
 '1991': 1219.976,
 '1992': 1233.55,
 '1993': 1247.237,
 '1994': 1261.096,
 '1995': 1275.108,
 '1996': 1289.296,
 '1997': 1303.602,
 '1998': 1318.087,
 '1999': 1332.732,
 '2000': 1347.561,
 '2001': 1362.514,
 '2002': 1374.616,
 '2003': 1384.923,
 '2004': 1395.322,
 '2005': 1405.769,
 '2006': 1416.31,
 '2007': 1426.929,
 '2008': 1437.643,
 '2009': 1448.408,
 '2010': 1459.268,
 '2011': 1470.13,
 '2012': 1481.051,
 '2013': 1492.023,
 '2014': 1503.091,
 '2015': 1514.241,
 '2016': 1525.49,
 '2017': 1536.791,
 '2018': 1548.176,
 '2019': 1559.84,
 '2020': 1571.944,
 '2021': 1584.599,
 '2022': 1597.844,
 '2023': 1611.651,
 '2024': 1625.937,
 '2025': 1640.599,
 '2026': 1655.498,
 '2027': 1670.505,
 '2028': 1685.5,
 '2029': 1700.412,
 '2030': 1715.096,
 '2031': 1729.489,
 '2032': 1743.698,
 '2033': 1757.717,
 '2034': 1771.533,
 '2035': 1785.143},
{'Index': 26,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20063,
 'Urban Agglomeration': 'Corrientes',
 'Note': 11.0,
 'Latitude': -27.4806,
 'Longitude': -58.8341,
 '1950': 64.256,
 '1951': 66.925,
 '1952': 69.708,
 '1953': 72.598,
 '1954': 75.613,
 '1955': 78.753,
 '1956': 82.028,
 '1957': 85.429,
 '1958': 88.977,
 '1959': 92.672,
 '1960': 96.526,
 '1961': 100.022,
 '1962': 103.476,
 '1963': 107.05,
 '1964': 110.752,
 '1965': 114.571,
 '1966': 118.528,
 '1967': 122.622,
 '1968': 126.862,
 '1969': 131.237,
 '1970': 135.77,
 '1971': 139.783,
 '1972': 143.689,
 '1973': 147.693,
 '1974': 151.815,
 '1975': 156.052,
 '1976': 160.413,
 '1977': 164.884,
 '1978': 169.485,
 '1979': 174.215,
 '1980': 179.084,
 '1981': 184.858,
 '1982': 191.19,
 '1983': 197.739,
 '1984': 204.522,
 '1985': 211.517,
 '1986': 218.763,
 '1987': 226.256,
 '1988': 234.017,
 '1989': 242.022,
 '1990': 250.312,
 '1991': 258.418,
 '1992': 263.543,
 '1993': 268.755,
 '1994': 274.078,
 '1995': 279.506,
 '1996': 285.049,
 '1997': 290.687,
 '1998': 296.444,
 '1999': 302.315,
 '2000': 308.31,
 '2001': 314.408,
 '2002': 319.446,
 '2003': 323.816,
 '2004': 328.252,
 '2005': 332.736,
 '2006': 337.287,
 '2007': 341.901,
 '2008': 346.585,
 '2009': 351.319,
 '2010': 356.125,
 '2011': 360.996,
 '2012': 365.941,
 '2013': 370.94,
 '2014': 376.014,
 '2015': 381.158,
 '2016': 386.379,
 '2017': 391.657,
 '2018': 397.007,
 '2019': 402.381,
 '2020': 407.725,
 '2021': 412.989,
 '2022': 418.126,
 '2023': 423.104,
 '2024': 427.904,
 '2025': 432.527,
 '2026': 436.98,
 '2027': 441.281,
 '2028': 445.447,
 '2029': 449.505,
 '2030': 453.448,
 '2031': 457.282,
 '2032': 461.052,
 '2033': 464.764,
 '2034': 468.419,
 '2035': 472.019},
{'Index': 27,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20065,
 'Urban Agglomeration': 'La Plata',
 'Note': 12.0,
 'Latitude': -34.92145,
 'Longitude': -57.95453,
 '1950': 299.505,
 '1951': 308.388,
 '1952': 317.548,
 '1953': 326.954,
 '1954': 336.652,
 '1955': 346.637,
 '1956': 356.933,
 '1957': 367.505,
 '1958': 378.406,
 '1959': 389.63,
 '1960': 401.203,
 '1961': 409.756,
 '1962': 417.38,
 '1963': 425.146,
 '1964': 433.068,
 '1965': 441.115,
 '1966': 449.323,
 '1967': 457.684,
 '1968': 466.212,
 '1969': 474.874,
 '1970': 483.711,
 '1971': 491.419,
 '1972': 498.826,
 '1973': 506.324,
 '1974': 513.944,
 '1975': 521.68,
 '1976': 529.543,
 '1977': 537.502,
 '1978': 545.592,
 '1979': 553.804,
 '1980': 562.151,
 '1981': 569.403,
 '1982': 576.217,
 '1983': 583.112,
 '1984': 590.099,
 '1985': 597.15,
 '1986': 604.295,
 '1987': 611.526,
 '1988': 618.854,
 '1989': 626.249,
 '1990': 633.742,
 '1991': 640.837,
 '1992': 644.68,
 '1993': 648.536,
 '1994': 652.421,
 '1995': 656.329,
 '1996': 660.265,
 '1997': 664.215,
 '1998': 668.193,
 '1999': 672.195,
 '2000': 676.227,
 '2001': 680.272,
 '2002': 688.767,
 '2003': 700.166,
 '2004': 711.771,
 '2005': 723.535,
 '2006': 735.51,
 '2007': 747.684,
 '2008': 760.076,
 '2009': 772.639,
 '2010': 785.427,
 '2011': 795.883,
 '2012': 805.264,
 '2013': 814.729,
 '2014': 824.318,
 '2015': 834.021,
 '2016': 843.851,
 '2017': 853.77,
 '2018': 863.806,
 '2019': 873.918,
 '2020': 884.054,
 '2021': 894.159,
 '2022': 904.17,
 '2023': 914.036,
 '2024': 923.715,
 '2025': 933.193,
 '2026': 942.456,
 '2027': 951.508,
 '2028': 960.357,
 '2029': 969.028,
 '2030': 977.488,
 '2031': 985.735,
 '2032': 993.853,
 '2033': 1001.852,
 '2034': 1009.729,
 '2035': 1017.488},
{'Index': 28,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20067,
 'Urban Agglomeration': 'Mar Del Plata',
 'Note': '',
 'Latitude': -38.00228,
 'Longitude': -57.55754,
 '1950': 132.415,
 '1951': 138.597,
 '1952': 145.075,
 '1953': 151.838,
 '1954': 158.926,
 '1955': 166.345,
 '1956': 174.121,
 '1957': 182.237,
 '1958': 190.744,
 '1959': 199.648,
 '1960': 208.981,
 '1961': 217.114,
 '1962': 225.023,
 '1963': 233.22,
 '1964': 241.727,
 '1965': 250.52,
 '1966': 259.646,
 '1967': 269.105,
 '1968': 278.921,
 '1969': 289.067,
 '1970': 299.597,
 '1971': 309.498,
 '1972': 319.393,
 '1973': 329.576,
 '1974': 340.098,
 '1975': 350.956,
 '1976': 362.177,
 '1977': 373.724,
 '1978': 385.656,
 '1979': 397.968,
 '1980': 410.692,
 '1981': 420.856,
 '1982': 429.947,
 '1983': 439.235,
 '1984': 448.737,
 '1985': 458.418,
 '1986': 468.321,
 '1987': 478.438,
 '1988': 488.788,
 '1989': 499.332,
 '1990': 510.119,
 '1991': 519.971,
 '1992': 522.031,
 '1993': 524.094,
 '1994': 526.167,
 '1995': 528.249,
 '1996': 530.342,
 '1997': 532.437,
 '1998': 534.544,
 '1999': 536.658,
 '2000': 538.785,
 '2001': 540.913,
 '2002': 546.045,
 '2003': 553.113,
 '2004': 560.282,
 '2005': 567.524,
 '2006': 574.87,
 '2007': 582.311,
 '2008': 589.858,
 '2009': 597.483,
 '2010': 605.216,
 '2011': 611.617,
 '2012': 617.403,
 '2013': 623.227,
 '2014': 629.115,
 '2015': 635.058,
 '2016': 641.065,
 '2017': 647.113,
 '2018': 653.218,
 '2019': 659.41,
 '2020': 665.707,
 '2021': 672.116,
 '2022': 678.623,
 '2023': 685.206,
 '2024': 691.831,
 '2025': 698.471,
 '2026': 705.089,
 '2027': 711.659,
 '2028': 718.154,
 '2029': 724.569,
 '2030': 730.858,
 '2031': 737.007,
 '2032': 743.068,
 '2033': 749.045,
 '2034': 754.934,
 '2035': 760.734},
{'Index': 29,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20068,
 'Urban Agglomeration': 'Mendoza',
 'Note': 13.0,
 'Latitude': -32.89084,
 'Longitude': -68.82717,
 '1950': 245.797,
 '1951': 253.018,
 '1952': 260.461,
 '1953': 268.103,
 '1954': 275.979,
 '1955': 284.087,
 '1956': 292.444,
 '1957': 301.024,
 '1958': 309.867,
 '1959': 318.971,
 '1960': 328.355,
 '1961': 339.981,
 '1962': 352.723,
 '1963': 365.943,
 '1964': 379.678,
 '1965': 393.888,
 '1966': 408.651,
 '1967': 423.967,
 '1968': 439.88,
 '1969': 456.343,
 '1970': 473.447,
 '1971': 486.763,
 '1972': 498.966,
 '1973': 511.442,
 '1974': 524.246,
 '1975': 537.372,
 '1976': 550.845,
 '1977': 564.617,
 '1978': 578.753,
 '1979': 593.243,
 '1980': 608.116,
 '1981': 622.175,
 '1982': 636.054,
 '1983': 650.243,
 '1984': 664.768,
 '1985': 679.577,
 '1986': 694.736,
 '1987': 710.234,
 '1988': 726.099,
 '1989': 742.274,
 '1990': 758.832,
 '1991': 774.437,
 '1992': 781.303,
 '1993': 788.21,
 '1994': 795.189,
 '1995': 802.228,
 '1996': 809.34,
 '1997': 816.496,
 '1998': 823.724,
 '1999': 831.017,
 '2000': 838.384,
 '2001': 845.796,
 '2002': 857.729,
 '2003': 872.648,
 '2004': 887.847,
 '2005': 903.268,
 '2006': 918.979,
 '2007': 934.963,
 '2008': 951.247,
 '2009': 967.769,
 '2010': 984.602,
 '2011': 1001.973,
 '2012': 1019.796,
 '2013': 1037.886,
 '2014': 1056.322,
 '2015': 1075.085,
 '2016': 1094.209,
 '2017': 1113.619,
 '2018': 1133.373,
 '2019': 1153.152,
 '2020': 1172.619,
 '2021': 1191.47,
 '2022': 1209.458,
 '2023': 1226.427,
 '2024': 1242.319,
 '2025': 1257.182,
 '2026': 1271.117,
 '2027': 1284.268,
 '2028': 1296.783,
 '2029': 1308.814,
 '2030': 1320.409,
 '2031': 1331.632,
 '2032': 1342.635,
 '2033': 1353.455,
 '2034': 1364.102,
 '2035': 1374.585},
{'Index': 30,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20070,
 'Urban Agglomeration': 'Neuquén-Plottier-Cipolletti',
 'Note': '',
 'Latitude': -38.95143,
 'Longitude': -68.064809,
 '1950': 13.911,
 '1951': 15.325,
 '1952': 16.886,
 '1953': 18.6,
 '1954': 20.492,
 '1955': 22.575,
 '1956': 24.874,
 '1957': 27.399,
 '1958': 30.185,
 '1959': 33.255,
 '1960': 36.641,
 '1961': 39.306,
 '1962': 41.799,
 '1963': 44.451,
 '1964': 47.275,
 '1965': 50.269,
 '1966': 53.458,
 '1967': 56.849,
 '1968': 60.46,
 '1969': 64.29,
 '1970': 68.369,
 '1971': 73.091,
 '1972': 78.285,
 '1973': 83.832,
 '1974': 89.78,
 '1975': 96.15,
 '1976': 102.983,
 '1977': 110.279,
 '1978': 118.104,
 '1979': 126.485,
 '1980': 135.472,
 '1981': 143.575,
 '1982': 151.468,
 '1983': 159.796,
 '1984': 168.594,
 '1985': 177.85,
 '1986': 187.628,
 '1987': 197.944,
 '1988': 208.842,
 '1989': 220.308,
 '1990': 232.421,
 '1991': 244.047,
 '1992': 248.227,
 '1993': 252.467,
 '1994': 256.786,
 '1995': 261.178,
 '1996': 265.651,
 '1997': 270.189,
 '1998': 274.81,
 '1999': 279.51,
 '2000': 284.298,
 '2001': 289.154,
 '2002': 294.256,
 '2003': 299.546,
 '2004': 304.939,
 '2005': 310.414,
 '2006': 315.995,
 '2007': 321.676,
 '2008': 327.468,
 '2009': 333.347,
 '2010': 339.34,
 '2011': 345.658,
 '2012': 352.206,
 '2013': 358.861,
 '2014': 365.651,
 '2015': 372.569,
 '2016': 379.627,
 '2017': 386.8,
 '2018': 394.109,
 '2019': 401.423,
 '2020': 408.609,
 '2021': 415.545,
 '2022': 422.131,
 '2023': 428.308,
 '2024': 434.053,
 '2025': 439.389,
 '2026': 444.357,
 '2027': 449.018,
 '2028': 453.432,
 '2029': 457.66,
 '2030': 461.726,
 '2031': 465.656,
 '2032': 469.506,
 '2033': 473.291,
 '2034': 477.014,
 '2035': 480.68},
{'Index': 31,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20072,
 'Urban Agglomeration': 'Posadas',
 'Note': '',
 'Latitude': -27.36708,
 'Longitude': -55.89608,
 '1950': 45.612,
 '1951': 47.815,
 '1952': 50.127,
 '1953': 52.544,
 '1954': 55.082,
 '1955': 57.742,
 '1956': 60.535,
 '1957': 63.454,
 '1958': 66.518,
 '1959': 69.73,
 '1960': 73.103,
 '1961': 75.514,
 '1962': 77.631,
 '1963': 79.807,
 '1964': 82.047,
 '1965': 84.343,
 '1966': 86.707,
 '1967': 89.137,
 '1968': 91.639,
 '1969': 94.204,
 '1970': 96.844,
 '1971': 100.386,
 '1972': 104.35,
 '1973': 108.458,
 '1974': 112.734,
 '1975': 117.179,
 '1976': 121.805,
 '1977': 126.601,
 '1978': 131.593,
 '1979': 136.781,
 '1980': 142.181,
 '1981': 147.546,
 '1982': 153.013,
 '1983': 158.682,
 '1984': 164.57,
 '1985': 170.658,
 '1986': 176.981,
 '1987': 183.539,
 '1988': 190.349,
 '1989': 197.391,
 '1990': 204.705,
 '1991': 212.027,
 '1992': 217.787,
 '1993': 223.687,
 '1994': 229.755,
 '1995': 235.988,
 '1996': 242.399,
 '1997': 248.966,
 '1998': 255.72,
 '1999': 262.657,
 '2000': 269.792,
 '2001': 277.101,
 '2002': 282.521,
 '2003': 286.724,
 '2004': 290.995,
 '2005': 295.318,
 '2006': 299.711,
 '2007': 304.17,
 '2008': 308.701,
 '2009': 313.287,
 '2010': 317.948,
 '2011': 323.924,
 '2012': 330.63,
 '2013': 337.456,
 '2014': 344.433,
 '2015': 351.554,
 '2016': 358.832,
 '2017': 366.24,
 '2018': 373.801,
 '2019': 381.367,
 '2020': 388.782,
 '2021': 395.909,
 '2022': 402.635,
 '2023': 408.892,
 '2024': 414.66,
 '2025': 419.963,
 '2026': 424.853,
 '2027': 429.401,
 '2028': 433.678,
 '2029': 437.753,
 '2030': 441.659,
 '2031': 445.426,
 '2032': 449.112,
 '2033': 452.734,
 '2034': 456.296,
 '2035': 459.803},
{'Index': 32,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20073,
 'Urban Agglomeration': 'Resistencia',
 'Note': 14.0,
 'Latitude': -27.46056,
 'Longitude': -58.98389,
 '1950': 72.574,
 '1951': 75.275,
 '1952': 78.081,
 '1953': 80.983,
 '1954': 83.998,
 '1955': 87.124,
 '1956': 90.372,
 '1957': 93.731,
 '1958': 97.22,
 '1959': 100.839,
 '1960': 104.597,
 '1961': 107.975,
 '1962': 111.292,
 '1963': 114.711,
 '1964': 118.24,
 '1965': 121.868,
 '1966': 125.612,
 '1967': 129.471,
 '1968': 133.454,
 '1969': 137.549,
 '1970': 141.774,
 '1971': 147.531,
 '1972': 154.018,
 '1973': 160.771,
 '1974': 167.83,
 '1975': 175.199,
 '1976': 182.902,
 '1977': 190.921,
 '1978': 199.304,
 '1979': 208.055,
 '1980': 217.203,
 '1981': 224.16,
 '1982': 230.171,
 '1983': 236.344,
 '1984': 242.692,
 '1985': 249.191,
 '1986': 255.875,
 '1987': 262.737,
 '1988': 269.793,
 '1989': 277.019,
 '1990': 284.448,
 '1991': 291.838,
 '1992': 297.773,
 '1993': 303.812,
 '1994': 309.982,
 '1995': 316.277,
 '1996': 322.71,
 '1997': 329.254,
 '1998': 335.941,
 '1999': 342.764,
 '2000': 349.735,
 '2001': 356.828,
 '2002': 361.334,
 '2003': 364.181,
 '2004': 367.054,
 '2005': 369.943,
 '2006': 372.857,
 '2007': 375.795,
 '2008': 378.76,
 '2009': 381.741,
 '2010': 384.749,
 '2011': 388.817,
 '2012': 393.437,
 '2013': 398.099,
 '2014': 402.822,
 '2015': 407.602,
 '2016': 412.445,
 '2017': 417.332,
 '2018': 422.277,
 '2019': 427.259,
 '2020': 432.25,
 '2021': 437.222,
 '2022': 442.144,
 '2023': 446.991,
 '2024': 451.741,
 '2025': 456.388,
 '2026': 460.926,
 '2027': 465.359,
 '2028': 469.69,
 '2029': 473.933,
 '2030': 478.071,
 '2031': 482.105,
 '2032': 486.076,
 '2033': 489.988,
 '2034': 493.841,
 '2035': 497.635},
{'Index': 33,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20075,
 'Urban Agglomeration': 'Rosario',
 'Note': 15.0,
 'Latitude': -32.94682,
 'Longitude': -60.63932,
 '1950': 554.483,
 '1951': 565.188,
 '1952': 576.115,
 '1953': 587.223,
 '1954': 598.56,
 '1955': 610.116,
 '1956': 621.912,
 '1957': 633.903,
 '1958': 646.141,
 '1959': 658.616,
 '1960': 671.349,
 '1961': 684.514,
 '1962': 698.031,
 '1963': 711.815,
 '1964': 725.89,
 '1965': 740.204,
 '1966': 754.821,
 '1967': 769.726,
 '1968': 784.946,
 '1969': 800.424,
 '1970': 816.23,
 '1971': 829.78,
 '1972': 842.708,
 '1973': 855.801,
 '1974': 869.116,
 '1975': 882.638,
 '1976': 896.39,
 '1977': 910.317,
 '1978': 924.48,
 '1979': 938.864,
 '1980': 953.491,
 '1981': 966.498,
 '1982': 978.879,
 '1983': 991.42,
 '1984': 1004.139,
 '1985': 1016.985,
 '1986': 1030.014,
 '1987': 1043.209,
 '1988': 1056.592,
 '1989': 1070.11,
 '1990': 1083.819,
 '1991': 1096.683,
 '1992': 1102.744,
 '1993': 1108.822,
 '1994': 1114.943,
 '1995': 1121.096,
 '1996': 1127.293,
 '1997': 1133.506,
 '1998': 1139.762,
 '1999': 1146.053,
 '2000': 1152.387,
 '2001': 1158.739,
 '2002': 1171.926,
 '2003': 1189.556,
 '2004': 1207.477,
 '2005': 1225.617,
 '2006': 1244.056,
 '2007': 1262.772,
 '2008': 1281.795,
 '2009': 1301.052,
 '2010': 1320.626,
 '2011': 1340.493,
 '2012': 1360.688,
 '2013': 1381.13,
 '2014': 1401.908,
 '2015': 1422.998,
 '2016': 1444.436,
 '2017': 1466.136,
 '2018': 1488.162,
 '2019': 1510.253,
 '2020': 1532.128,
 '2021': 1553.53,
 '2022': 1574.235,
 '2023': 1594.096,
 '2024': 1613.041,
 '2025': 1631.093,
 '2026': 1648.317,
 '2027': 1664.817,
 '2028': 1680.705,
 '2029': 1696.108,
 '2030': 1711.036,
 '2031': 1725.53,
 '2032': 1739.766,
 '2033': 1753.778,
 '2034': 1767.572,
 '2035': 1781.154},
{'Index': 34,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20076,
 'Urban Agglomeration': 'Salta',
 'Note': '',
 'Latitude': -24.7859,
 'Longitude': -65.41166,
 '1950': 77.248,
 '1951': 80.515,
 '1952': 83.926,
 '1953': 87.472,
 '1954': 91.172,
 '1955': 95.029,
 '1956': 99.055,
 '1957': 103.239,
 '1958': 107.607,
 '1959': 112.159,
 '1960': 116.91,
 '1961': 121.719,
 '1962': 126.686,
 '1963': 131.857,
 '1964': 137.246,
 '1965': 142.84,
 '1966': 148.669,
 '1967': 154.737,
 '1968': 161.062,
 '1969': 167.626,
 '1970': 174.467,
 '1971': 181.444,
 '1972': 188.66,
 '1973': 196.142,
 '1974': 203.932,
 '1975': 212.031,
 '1976': 220.463,
 '1977': 229.206,
 '1978': 238.309,
 '1979': 247.774,
 '1980': 257.628,
 '1981': 266.636,
 '1982': 275.414,
 '1983': 284.482,
 '1984': 293.861,
 '1985': 303.521,
 '1986': 313.514,
 '1987': 323.836,
 '1988': 334.512,
 '1989': 345.509,
 '1990': 356.884,
 '1991': 368.289,
 '1992': 377.676,
 '1993': 387.276,
 '1994': 397.133,
 '1995': 407.241,
 '1996': 417.621,
 '1997': 428.236,
 '1998': 439.136,
 '1999': 450.313,
 '2000': 461.791,
 '2001': 473.529,
 '2002': 483.853,
 '2003': 493.319,
 '2004': 502.984,
 '2005': 512.811,
 '2006': 522.844,
 '2007': 533.073,
 '2008': 543.517,
 '2009': 554.136,
 '2010': 564.977,
 '2011': 576.03,
 '2012': 587.316,
 '2013': 598.79,
 '2014': 610.505,
 '2015': 622.449,
 '2016': 634.644,
 '2017': 647.043,
 '2018': 659.684,
 '2019': 672.335,
 '2020': 684.751,
 '2021': 696.715,
 '2022': 708.049,
 '2023': 718.645,
 '2024': 728.468,
 '2025': 737.555,
 '2026': 745.986,
 '2027': 753.87,
 '2028': 761.316,
 '2029': 768.436,
 '2030': 775.274,
 '2031': 781.877,
 '2032': 788.344,
 '2033': 794.7,
 '2034': 800.953,
 '2035': 807.108},
{'Index': 35,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20078,
 'Urban Agglomeration': 'San Juan',
 'Note': 16.0,
 'Latitude': -31.5375,
 'Longitude': -68.53639,
 '1950': 108.151,
 '1951': 111.682,
 '1952': 115.334,
 '1953': 119.094,
 '1954': 122.983,
 '1955': 126.999,
 '1956': 131.151,
 '1957': 135.427,
 '1958': 139.849,
 '1959': 144.416,
 '1960': 149.138,
 '1961': 154.826,
 '1962': 161.024,
 '1963': 167.471,
 '1964': 174.185,
 '1965': 181.149,
 '1966': 188.401,
 '1967': 195.944,
 '1968': 203.8,
 '1969': 211.948,
 '1970': 220.433,
 '1971': 227.137,
 '1972': 233.333,
 '1973': 239.679,
 '1974': 246.208,
 '1975': 252.914,
 '1976': 259.812,
 '1977': 266.879,
 '1978': 274.148,
 '1979': 281.615,
 '1980': 289.297,
 '1981': 296.029,
 '1982': 302.407,
 '1983': 308.924,
 '1984': 315.589,
 '1985': 322.38,
 '1986': 329.326,
 '1987': 336.422,
 '1988': 343.681,
 '1989': 351.077,
 '1990': 358.641,
 '1991': 366.014,
 '1992': 371.041,
 '1993': 376.122,
 '1994': 381.281,
 '1995': 386.51,
 '1996': 391.819,
 '1997': 397.185,
 '1998': 402.632,
 '1999': 408.155,
 '2000': 413.76,
 '2001': 419.427,
 '2002': 426.497,
 '2003': 434.531,
 '2004': 442.728,
 '2005': 451.057,
 '2006': 459.554,
 '2007': 468.211,
 '2008': 477.043,
 '2009': 486.017,
 '2010': 495.172,
 '2011': 500.771,
 '2012': 504.647,
 '2013': 508.542,
 '2014': 512.472,
 '2015': 516.433,
 '2016': 520.43,
 '2017': 524.447,
 '2018': 528.495,
 '2019': 532.634,
 '2020': 536.913,
 '2021': 541.366,
 '2022': 546.001,
 '2023': 550.807,
 '2024': 555.758,
 '2025': 560.819,
 '2026': 565.946,
 '2027': 571.098,
 '2028': 576.237,
 '2029': 581.343,
 '2030': 586.367,
 '2031': 591.29,
 '2032': 596.149,
 '2033': 600.942,
 '2034': 605.665,
 '2035': 610.319},
{'Index': 36,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20081,
 'Urban Agglomeration': 'San Miguel de Tucumán',
 'Note': 17.0,
 'Latitude': -26.82414,
 'Longitude': -65.2226,
 '1950': 223.765,
 '1951': 230.505,
 '1952': 237.458,
 '1953': 244.601,
 '1954': 251.969,
 '1955': 259.559,
 '1956': 267.388,
 '1957': 275.432,
 '1958': 283.728,
 '1959': 292.275,
 '1960': 301.091,
 '1961': 307.649,
 '1962': 313.517,
 '1963': 319.496,
 '1964': 325.598,
 '1965': 331.8,
 '1966': 338.128,
 '1967': 344.576,
 '1968': 351.157,
 '1969': 357.845,
 '1970': 364.67,
 '1971': 374.911,
 '1972': 386.585,
 '1973': 398.588,
 '1974': 410.982,
 '1975': 423.76,
 '1976': 436.955,
 '1977': 450.522,
 '1978': 464.53,
 '1979': 478.974,
 '1980': 493.888,
 '1981': 505.853,
 '1982': 516.586,
 '1983': 527.547,
 '1984': 538.756,
 '1985': 550.171,
 '1986': 561.844,
 '1987': 573.765,
 '1988': 585.956,
 '1989': 598.371,
 '1990': 611.067,
 '1991': 623.654,
 '1992': 633.901,
 '1993': 644.288,
 '1994': 654.86,
 '1995': 665.605,
 '1996': 676.542,
 '1997': 687.628,
 '1998': 698.911,
 '1999': 710.379,
 '2000': 722.052,
 '2001': 733.883,
 '2002': 745.594,
 '2003': 757.283,
 '2004': 769.171,
 '2005': 781.213,
 '2006': 793.46,
 '2007': 805.899,
 '2008': 818.551,
 '2009': 831.366,
 '2010': 844.399,
 '2011': 857.637,
 '2012': 871.1,
 '2013': 884.738,
 '2014': 898.608,
 '2015': 912.695,
 '2016': 927.024,
 '2017': 941.536,
 '2018': 956.275,
 '2019': 971.05,
 '2020': 985.656,
 '2021': 999.907,
 '2022': 1013.645,
 '2023': 1026.767,
 '2024': 1039.226,
 '2025': 1051.043,
 '2026': 1062.27,
 '2027': 1072.987,
 '2028': 1083.277,
 '2029': 1093.233,
 '2030': 1102.87,
 '2031': 1112.219,
 '2032': 1121.399,
 '2033': 1130.432,
 '2034': 1139.323,
 '2035': 1148.078},
{'Index': 37,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20084,
 'Urban Agglomeration': 'San Salvador de Jujuy',
 'Note': 18.0,
 'Latitude': -24.19456,
 'Longitude': -65.29712,
 '1950': 33.863,
 '1951': 34.754,
 '1952': 35.669,
 '1953': 36.606,
 '1954': 37.569,
 '1955': 38.557,
 '1956': 39.573,
 '1957': 40.612,
 '1958': 41.681,
 '1959': 42.777,
 '1960': 43.904,
 '1961': 46.312,
 '1962': 49.304,
 '1963': 52.49,
 '1964': 55.886,
 '1965': 59.491,
 '1966': 63.334,
 '1967': 67.426,
 '1968': 71.789,
 '1969': 76.42,
 '1970': 81.357,
 '1971': 85.26,
 '1972': 88.888,
 '1973': 92.661,
 '1974': 96.599,
 '1975': 100.704,
 '1976': 104.99,
 '1977': 109.446,
 '1978': 114.098,
 '1979': 118.947,
 '1980': 124.009,
 '1981': 128.723,
 '1982': 133.369,
 '1983': 138.182,
 '1984': 143.176,
 '1985': 148.336,
 '1986': 153.69,
 '1987': 159.237,
 '1988': 164.992,
 '1989': 170.938,
 '1990': 177.107,
 '1991': 183.608,
 '1992': 191.124,
 '1993': 198.926,
 '1994': 207.058,
 '1995': 215.523,
 '1996': 224.345,
 '1997': 233.504,
 '1998': 243.049,
 '1999': 252.985,
 '2000': 263.341,
 '2001': 274.091,
 '2002': 280.752,
 '2003': 284.715,
 '2004': 288.74,
 '2005': 292.81,
 '2006': 296.943,
 '2007': 301.135,
 '2008': 305.392,
 '2009': 309.697,
 '2010': 314.069,
 '2011': 318.503,
 '2012': 323.005,
 '2013': 327.559,
 '2014': 332.183,
 '2015': 336.872,
 '2016': 341.634,
 '2017': 346.45,
 '2018': 351.334,
 '2019': 356.237,
 '2020': 361.106,
 '2021': 365.89,
 '2022': 370.546,
 '2023': 375.042,
 '2024': 379.361,
 '2025': 383.507,
 '2026': 387.488,
 '2027': 391.322,
 '2028': 395.03,
 '2029': 398.635,
 '2030': 402.135,
 '2031': 405.538,
 '2032': 408.882,
 '2033': 412.174,
 '2034': 415.416,
 '2035': 418.608},
{'Index': 38,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20085,
 'Urban Agglomeration': 'Santa Fe',
 'Note': 19.0,
 'Latitude': -31.632717,
 'Longitude': -60.698281,
 '1950': 214.298,
 '1951': 218.959,
 '1952': 223.728,
 '1953': 228.588,
 '1954': 233.559,
 '1955': 238.639,
 '1956': 243.837,
 '1957': 249.133,
 '1958': 254.552,
 '1959': 260.089,
 '1960': 265.753,
 '1961': 270.432,
 '1962': 274.832,
 '1963': 279.304,
 '1964': 283.854,
 '1965': 288.466,
 '1966': 293.159,
 '1967': 297.928,
 '1968': 302.782,
 '1969': 307.701,
 '1970': 312.707,
 '1971': 319.016,
 '1972': 325.877,
 '1973': 332.866,
 '1974': 340.015,
 '1975': 347.318,
 '1976': 354.787,
 '1977': 362.396,
 '1978': 370.179,
 '1979': 378.129,
 '1980': 386.262,
 '1981': 389.298,
 '1982': 390.015,
 '1983': 390.734,
 '1984': 391.454,
 '1985': 392.174,
 '1986': 392.897,
 '1987': 393.621,
 '1988': 394.347,
 '1989': 395.072,
 '1990': 395.8,
 '1991': 397.141,
 '1992': 402.673,
 '1993': 408.267,
 '1994': 413.947,
 '1995': 419.706,
 '1996': 425.552,
 '1997': 431.464,
 '1998': 437.467,
 '1999': 443.553,
 '2000': 449.732,
 '2001': 455.979,
 '2002': 460.876,
 '2003': 464.95,
 '2004': 469.064,
 '2005': 473.204,
 '2006': 477.387,
 '2007': 481.606,
 '2008': 485.868,
 '2009': 490.156,
 '2010': 494.488,
 '2011': 500.33,
 '2012': 506.961,
 '2013': 513.663,
 '2014': 520.462,
 '2015': 527.351,
 '2016': 534.341,
 '2017': 541.404,
 '2018': 548.56,
 '2019': 555.753,
 '2020': 562.917,
 '2021': 569.991,
 '2022': 576.917,
 '2023': 583.653,
 '2024': 590.172,
 '2025': 596.474,
 '2026': 602.564,
 '2027': 608.461,
 '2028': 614.186,
 '2029': 619.769,
 '2030': 625.199,
 '2031': 630.484,
 '2032': 635.68,
 '2033': 640.798,
 '2034': 645.837,
 '2035': 650.799},
{'Index': 39,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20086,
 'Urban Agglomeration': 'Santiago Del Estero',
 'Note': 20.0,
 'Latitude': -27.79511,
 'Longitude': -64.26149,
 '1950': 82.652,
 '1951': 84.538,
 '1952': 86.471,
 '1953': 88.442,
 '1954': 90.461,
 '1955': 92.526,
 '1956': 94.641,
 '1957': 96.799,
 '1958': 99.009,
 '1959': 101.269,
 '1960': 103.584,
 '1961': 106.478,
 '1962': 109.639,
 '1963': 112.894,
 '1964': 116.25,
 '1965': 119.696,
 '1966': 123.25,
 '1967': 126.909,
 '1968': 130.682,
 '1969': 134.556,
 '1970': 138.551,
 '1971': 143.268,
 '1972': 148.361,
 '1973': 153.621,
 '1974': 159.074,
 '1975': 164.722,
 '1976': 170.577,
 '1977': 176.625,
 '1978': 182.895,
 '1979': 189.388,
 '1980': 196.12,
 '1981': 202.002,
 '1982': 207.576,
 '1983': 213.304,
 '1984': 219.199,
 '1985': 225.239,
 '1986': 231.454,
 '1987': 237.841,
 '1988': 244.414,
 '1989': 251.149,
 '1990': 258.079,
 '1991': 264.973,
 '1992': 270.48,
 '1993': 276.086,
 '1994': 281.816,
 '1995': 287.666,
 '1996': 293.644,
 '1997': 299.731,
 '1998': 305.952,
 '1999': 312.302,
 '2000': 318.793,
 '2001': 325.4,
 '2002': 331.079,
 '2003': 336.178,
 '2004': 341.363,
 '2005': 346.613,
 '2006': 351.952,
 '2007': 357.372,
 '2008': 362.884,
 '2009': 368.466,
 '2010': 374.141,
 '2011': 379.903,
 '2012': 385.762,
 '2013': 391.696,
 '2014': 397.729,
 '2015': 403.854,
 '2016': 410.083,
 '2017': 416.39,
 '2018': 422.794,
 '2019': 429.215,
 '2020': 435.567,
 '2021': 441.772,
 '2022': 447.762,
 '2023': 453.495,
 '2024': 458.948,
 '2025': 464.131,
 '2026': 469.064,
 '2027': 473.78,
 '2028': 478.314,
 '2029': 482.705,
 '2030': 486.957,
 '2031': 491.084,
 '2032': 495.136,
 '2033': 499.124,
 '2034': 503.05,
 '2035': 506.916},
{'Index': 40,
 'Country Code': 51,
 'Country or area': 'Armenia',
 'City Code': 20140,
 'Urban Agglomeration': 'Yerevan',
 'Note': '',
 'Latitude': 40.181998,
 'Longitude': 44.514619,
 '1950': 341.432,
 '1951': 357.799,
 '1952': 374.974,
 '1953': 392.923,
 '1954': 411.757,
 '1955': 431.494,
 '1956': 452.207,
 '1957': 473.853,
 '1958': 496.566,
 '1959': 518.087,
 '1960': 537.759,
 '1961': 558.12,
 '1962': 579.282,
 '1963': 601.247,
 '1964': 624.076,
 '1965': 647.706,
 '1966': 672.265,
 '1967': 697.755,
 '1968': 724.248,
 '1969': 751.671,
 '1970': 778.158,
 '1971': 803.112,
 '1972': 828.904,
 '1973': 855.448,
 '1974': 882.882,
 '1975': 911.195,
 '1976': 940.457,
 '1977': 970.575,
 '1978': 1001.7,
 '1979': 1026.03,
 '1980': 1041.587,
 '1981': 1057.335,
 '1982': 1073.344,
 '1983': 1089.596,
 '1984': 1106.116,
 '1985': 1122.84,
 '1986': 1139.841,
 '1987': 1157.099,
 '1988': 1174.643,
 '1989': 1181.04,
 '1990': 1174.524,
 '1991': 1168.044,
 '1992': 1161.591,
 '1993': 1155.191,
 '1994': 1148.818,
 '1995': 1142.48,
 '1996': 1136.168,
 '1997': 1129.908,
 '1998': 1123.674,
 '1999': 1117.475,
 '2000': 1111.301,
 '2001': 1105.179,
 '2002': 1100.296,
 '2003': 1095.897,
 '2004': 1091.51,
 '2005': 1087.153,
 '2006': 1082.807,
 '2007': 1078.479,
 '2008': 1074.162,
 '2009': 1069.873,
 '2010': 1065.597,
 '2011': 1061.337,
 '2012': 1062.281,
 '2013': 1065.265,
 '2014': 1068.261,
 '2015': 1071.265,
 '2016': 1074.282,
 '2017': 1077.299,
 '2018': 1080.324,
 '2019': 1083.323,
 '2020': 1086.275,
 '2021': 1089.181,
 '2022': 1092.028,
 '2023': 1094.813,
 '2024': 1097.542,
 '2025': 1100.237,
 '2026': 1102.915,
 '2027': 1105.596,
 '2028': 1108.305,
 '2029': 1111.072,
 '2030': 1113.926,
 '2031': 1116.887,
 '2032': 1119.962,
 '2033': 1123.177,
 '2034': 1126.551,
 '2035': 1130.102},
{'Index': 41,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206171,
 'Urban Agglomeration': 'Adelaide',
 'Note': 21.0,
 'Latitude': -34.92866,
 'Longitude': 138.59863,
 '1950': 429.277,
 '1951': 442.74,
 '1952': 455.963,
 '1953': 469.543,
 '1954': 483.545,
 '1955': 497.246,
 '1956': 511.355,
 '1957': 525.824,
 '1958': 540.723,
 '1959': 556.045,
 '1960': 571.822,
 '1961': 588.025,
 '1962': 613.515,
 '1963': 640.11,
 '1964': 667.897,
 '1965': 696.809,
 '1966': 727.008,
 '1967': 755.999,
 '1968': 786.189,
 '1969': 817.496,
 '1970': 850.095,
 '1971': 883.93,
 '1972': 894.907,
 '1973': 905.99,
 '1974': 917.225,
 '1975': 928.6,
 '1976': 940.121,
 '1977': 947.94,
 '1978': 955.835,
 '1979': 963.796,
 '1980': 971.834,
 '1981': 979.924,
 '1982': 990.698,
 '1983': 1001.59,
 '1984': 1012.618,
 '1985': 1023.736,
 '1986': 1034.991,
 '1987': 1046.448,
 '1988': 1058.048,
 '1989': 1069.744,
 '1990': 1081.585,
 '1991': 1093.537,
 '1992': 1098.047,
 '1993': 1102.564,
 '1994': 1107.105,
 '1995': 1111.665,
 '1996': 1116.241,
 '1997': 1117.57,
 '1998': 1118.902,
 '1999': 1120.236,
 '2000': 1121.573,
 '2001': 1122.927,
 '2002': 1130.827,
 '2003': 1138.783,
 '2004': 1146.806,
 '2005': 1154.863,
 '2006': 1163.005,
 '2007': 1177.394,
 '2008': 1191.982,
 '2009': 1206.709,
 '2010': 1221.639,
 '2011': 1236.744,
 '2012': 1248.361,
 '2013': 1260.055,
 '2014': 1271.874,
 '2015': 1283.805,
 '2016': 1295.864,
 '2017': 1308.036,
 '2018': 1320.323,
 '2019': 1328.119,
 '2020': 1336.403,
 '2021': 1345.445,
 '2022': 1355.522,
 '2023': 1366.783,
 '2024': 1379.28,
 '2025': 1392.943,
 '2026': 1407.599,
 '2027': 1423.011,
 '2028': 1438.942,
 '2029': 1455.17,
 '2030': 1471.525,
 '2031': 1487.9,
 '2032': 1504.248,
 '2033': 1520.55,
 '2034': 1536.809,
 '2035': 1553.036},
{'Index': 42,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206170,
 'Urban Agglomeration': 'Brisbane',
 'Note': 21.0,
 'Latitude': -27.46794,
 'Longitude': 153.02809,
 '1950': 441.718,
 '1951': 456.108,
 '1952': 471.054,
 '1953': 486.447,
 '1954': 502.362,
 '1955': 517.881,
 '1956': 533.903,
 '1957': 550.374,
 '1958': 567.376,
 '1959': 584.904,
 '1960': 602.999,
 '1961': 621.6,
 '1962': 639.997,
 '1963': 658.94,
 '1964': 678.47,
 '1965': 698.523,
 '1966': 719.253,
 '1967': 761.698,
 '1968': 806.712,
 '1969': 854.251,
 '1970': 904.663,
 '1971': 957.952,
 '1972': 977.225,
 '1973': 996.831,
 '1974': 1016.859,
 '1975': 1037.288,
 '1976': 1058.151,
 '1977': 1076.782,
 '1978': 1095.769,
 '1979': 1115.09,
 '1980': 1134.779,
 '1981': 1154.763,
 '1982': 1176.047,
 '1983': 1197.723,
 '1984': 1219.829,
 '1985': 1242.281,
 '1986': 1265.19,
 '1987': 1293.251,
 '1988': 1321.974,
 '1989': 1351.254,
 '1990': 1381.223,
 '1991': 1411.85,
 '1992': 1440.412,
 '1993': 1469.47,
 '1994': 1499.156,
 '1995': 1529.441,
 '1996': 1560.33,
 '1997': 1572.929,
 '1998': 1585.647,
 '1999': 1598.468,
 '2000': 1611.411,
 '2001': 1624.491,
 '2002': 1663.375,
 '2003': 1703.189,
 '2004': 1744.014,
 '2005': 1785.7,
 '2006': 1828.442,
 '2007': 1871.939,
 '2008': 1916.532,
 '2009': 1962.061,
 '2010': 2008.737,
 '2011': 2056.493,
 '2012': 2094.577,
 '2013': 2133.258,
 '2014': 2172.709,
 '2015': 2212.889,
 '2016': 2253.869,
 '2017': 2295.608,
 '2018': 2338.12,
 '2019': 2372.335,
 '2020': 2406.182,
 '2021': 2439.467,
 '2022': 2472.222,
 '2023': 2504.505,
 '2024': 2536.449,
 '2025': 2568.173,
 '2026': 2599.738,
 '2027': 2631.146,
 '2028': 2662.389,
 '2029': 2693.429,
 '2030': 2724.233,
 '2031': 2754.807,
 '2032': 2785.189,
 '2033': 2815.42,
 '2034': 2845.541,
 '2035': 2875.593},
{'Index': 43,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206175,
 'Urban Agglomeration': 'Canberra',
 'Note': 21.0,
 'Latitude': -35.28346,
 'Longitude': 149.12807,
 '1950': 19.921,
 '1951': 21.777,
 '1952': 23.81,
 '1953': 26.025,
 '1954': 28.467,
 '1955': 31.393,
 '1956': 34.624,
 '1957': 38.178,
 '1958': 42.102,
 '1959': 46.429,
 '1960': 51.208,
 '1961': 56.465,
 '1962': 62.435,
 '1963': 69.038,
 '1964': 76.349,
 '1965': 84.411,
 '1966': 93.336,
 '1967': 102.791,
 '1968': 113.218,
 '1969': 124.671,
 '1970': 137.3,
 '1971': 151.195,
 '1972': 161.131,
 '1973': 171.69,
 '1974': 182.957,
 '1975': 194.964,
 '1976': 207.75,
 '1977': 211.429,
 '1978': 215.179,
 '1979': 218.995,
 '1980': 222.885,
 '1981': 226.837,
 '1982': 232.801,
 '1983': 238.921,
 '1984': 245.211,
 '1985': 251.649,
 '1986': 258.262,
 '1987': 264.063,
 '1988': 270.004,
 '1989': 276.061,
 '1990': 282.263,
 '1991': 288.597,
 '1992': 292.693,
 '1993': 296.835,
 '1994': 301.042,
 '1995': 305.308,
 '1996': 309.651,
 '1997': 317.811,
 '1998': 326.198,
 '1999': 334.807,
 '2000': 343.655,
 '2001': 352.695,
 '2002': 356.058,
 '2003': 359.452,
 '2004': 362.884,
 '2005': 366.339,
 '2006': 369.84,
 '2007': 376.615,
 '2008': 383.523,
 '2009': 390.539,
 '2010': 397.692,
 '2011': 404.973,
 '2012': 410.821,
 '2013': 416.737,
 '2014': 422.747,
 '2015': 428.843,
 '2016': 435.036,
 '2017': 441.318,
 '2018': 447.692,
 '2019': 452.497,
 '2020': 457.33,
 '2021': 462.213,
 '2022': 467.194,
 '2023': 472.304,
 '2024': 477.567,
 '2025': 482.986,
 '2026': 488.541,
 '2027': 494.197,
 '2028': 499.915,
 '2029': 505.659,
 '2030': 511.397,
 '2031': 517.115,
 '2032': 522.809,
 '2033': 528.48,
 '2034': 534.132,
 '2035': 539.773},
{'Index': 44,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 895000015,
 'Urban Agglomeration': 'Central Coast',
 'Note': 21.0,
 'Latitude': -33.42,
 'Longitude': 151.39583,
 '1950': 71.768,
 '1951': 73.745,
 '1952': 75.778,
 '1953': 77.862,
 '1954': 80.006,
 '1955': 82.209,
 '1956': 84.476,
 '1957': 86.799,
 '1958': 89.189,
 '1959': 91.645,
 '1960': 94.172,
 '1961': 96.762,
 '1962': 99.426,
 '1963': 102.164,
 '1964': 104.981,
 '1965': 107.868,
 '1966': 110.839,
 '1967': 113.891,
 '1968': 117.031,
 '1969': 120.249,
 '1970': 123.561,
 '1971': 126.963,
 '1972': 130.464,
 '1973': 134.052,
 '1974': 137.743,
 '1975': 141.536,
 '1976': 145.439,
 '1977': 149.438,
 '1978': 153.553,
 '1979': 157.782,
 '1980': 162.133,
 '1981': 166.591,
 '1982': 171.178,
 '1983': 175.892,
 '1984': 180.742,
 '1985': 185.713,
 '1986': 190.826,
 '1987': 196.081,
 '1988': 201.488,
 '1989': 207.029,
 '1990': 212.73,
 '1991': 218.588,
 '1992': 224.615,
 '1993': 230.792,
 '1994': 237.147,
 '1995': 243.677,
 '1996': 250.397,
 '1997': 257.282,
 '1998': 264.367,
 '1999': 271.647,
 '2000': 279.138,
 '2001': 286.797,
 '2002': 288.493,
 '2003': 290.2,
 '2004': 291.92,
 '2005': 293.644,
 '2006': 295.387,
 '2007': 299.201,
 '2008': 303.068,
 '2009': 306.975,
 '2010': 310.938,
 '2011': 314.947,
 '2012': 317.331,
 '2013': 319.725,
 '2014': 322.141,
 '2015': 324.575,
 '2016': 327.031,
 '2017': 329.506,
 '2018': 331.999,
 '2019': 333.379,
 '2020': 334.922,
 '2021': 336.714,
 '2022': 338.835,
 '2023': 341.327,
 '2024': 344.2,
 '2025': 347.43,
 '2026': 350.962,
 '2027': 354.725,
 '2028': 358.648,
 '2029': 362.665,
 '2030': 366.727,
 '2031': 370.801,
 '2032': 374.872,
 '2033': 378.933,
 '2034': 382.984,
 '2035': 387.028},
{'Index': 45,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20093,
 'Urban Agglomeration': 'Gold Coast-Tweed Head',
 'Note': 21.0,
 'Latitude': -28.00029,
 'Longitude': 153.43088,
 '1950': 29.034,
 '1951': 30.625,
 '1952': 32.306,
 '1953': 34.073,
 '1954': 35.94,
 '1955': 37.909,
 '1956': 39.989,
 '1957': 42.177,
 '1958': 44.488,
 '1959': 46.925,
 '1960': 49.5,
 '1961': 52.208,
 '1962': 55.068,
 '1963': 58.085,
 '1964': 61.272,
 '1965': 64.625,
 '1966': 68.165,
 '1967': 71.9,
 '1968': 75.845,
 '1969': 79.994,
 '1970': 84.377,
 '1971': 89.0,
 '1972': 93.883,
 '1973': 99.02,
 '1974': 104.445,
 '1975': 110.167,
 '1976': 116.212,
 '1977': 122.57,
 '1978': 129.286,
 '1979': 136.369,
 '1980': 143.851,
 '1981': 151.722,
 '1982': 160.153,
 '1983': 169.052,
 '1984': 178.459,
 '1985': 188.362,
 '1986': 198.829,
 '1987': 209.916,
 '1988': 221.638,
 '1989': 233.979,
 '1990': 247.026,
 '1991': 260.795,
 '1992': 273.226,
 '1993': 286.212,
 '1994': 299.835,
 '1995': 314.106,
 '1996': 329.085,
 '1997': 347.677,
 '1998': 367.347,
 '1999': 388.13,
 '2000': 410.12,
 '2001': 433.263,
 '2002': 447.629,
 '2003': 462.471,
 '2004': 477.827,
 '2005': 493.649,
 '2006': 510.008,
 '2007': 523.49,
 '2008': 537.348,
 '2009': 551.533,
 '2010': 566.112,
 '2011': 581.07,
 '2012': 593.713,
 '2013': 606.596,
 '2014': 619.776,
 '2015': 633.243,
 '2016': 647.021,
 '2017': 661.099,
 '2018': 675.483,
 '2019': 687.46,
 '2020': 699.226,
 '2021': 710.65,
 '2022': 721.687,
 '2023': 732.324,
 '2024': 742.6,
 '2025': 752.57,
 '2026': 762.29,
 '2027': 771.805,
 '2028': 781.154,
 '2029': 790.366,
 '2030': 799.461,
 '2031': 808.46,
 '2032': 817.388,
 '2033': 826.265,
 '2034': 835.107,
 '2035': 843.927},
{'Index': 46,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206168,
 'Urban Agglomeration': 'Melbourne',
 'Note': 21.0,
 'Latitude': -37.814,
 'Longitude': 144.96332,
 '1950': 1331.966,
 '1951': 1376.534,
 '1952': 1424.177,
 '1953': 1473.331,
 '1954': 1524.246,
 '1955': 1574.414,
 '1956': 1626.306,
 '1957': 1679.759,
 '1958': 1735.045,
 '1959': 1792.152,
 '1960': 1851.22,
 '1961': 1911.998,
 '1962': 1949.796,
 '1963': 1988.342,
 '1964': 2027.704,
 '1965': 2067.735,
 '1966': 2108.744,
 '1967': 2200.21,
 '1968': 2295.778,
 '1969': 2395.217,
 '1970': 2499.109,
 '1971': 2607.067,
 '1972': 2637.811,
 '1973': 2668.831,
 '1974': 2700.26,
 '1975': 2732.059,
 '1976': 2764.201,
 '1977': 2782.693,
 '1978': 2801.334,
 '1979': 2820.101,
 '1980': 2839.019,
 '1981': 2858.056,
 '1982': 2885.298,
 '1983': 2912.8,
 '1984': 2940.602,
 '1985': 2968.593,
 '1986': 2996.943,
 '1987': 3035.534,
 '1988': 3074.676,
 '1989': 3114.213,
 '1990': 3154.314,
 '1991': 3194.826,
 '1992': 3216.582,
 '1993': 3238.425,
 '1994': 3260.447,
 '1995': 3282.619,
 '1996': 3304.95,
 '1997': 3318.807,
 '1998': 3332.741,
 '1999': 3346.733,
 '2000': 3360.804,
 '2001': 3374.987,
 '2002': 3423.318,
 '2003': 3472.341,
 '2004': 3522.136,
 '2005': 3572.504,
 '2006': 3623.725,
 '2007': 3698.511,
 '2008': 3774.946,
 '2009': 3852.745,
 '2010': 3932.257,
 '2011': 4013.457,
 '2012': 4113.893,
 '2013': 4216.555,
 '2014': 4321.926,
 '2015': 4429.931,
 '2016': 4540.788,
 '2017': 4654.419,
 '2018': 4770.894,
 '2019': 4870.388,
 '2020': 4967.733,
 '2021': 5061.439,
 '2022': 5150.766,
 '2023': 5235.407,
 '2024': 5315.6,
 '2025': 5391.886,
 '2026': 5464.916,
 '2027': 5535.322,
 '2028': 5603.712,
 '2029': 5670.551,
 '2030': 5736.197,
 '2031': 5800.959,
 '2032': 5865.109,
 '2033': 5928.84,
 '2034': 5992.295,
 '2035': 6055.588},
{'Index': 47,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206177,
 'Urban Agglomeration': 'Newcastle-Maitland',
 'Note': 21.0,
 'Latitude': -32.924878,
 'Longitude': 151.740852,
 '1950': 160.911,
 '1951': 166.19,
 '1952': 170.096,
 '1953': 174.082,
 '1954': 178.167,
 '1955': 182.232,
 '1956': 186.395,
 '1957': 190.641,
 '1958': 194.991,
 '1959': 199.439,
 '1960': 203.995,
 '1961': 208.643,
 '1962': 213.481,
 '1963': 218.431,
 '1964': 223.504,
 '1965': 228.679,
 '1966': 233.976,
 '1967': 237.164,
 '1968': 240.399,
 '1969': 243.67,
 '1970': 246.99,
 '1971': 250.353,
 '1972': 252.839,
 '1973': 255.343,
 '1974': 257.875,
 '1975': 260.432,
 '1976': 263.029,
 '1977': 269.583,
 '1978': 276.311,
 '1979': 283.206,
 '1980': 290.283,
 '1981': 297.497,
 '1982': 297.41,
 '1983': 297.323,
 '1984': 297.237,
 '1985': 297.15,
 '1986': 297.072,
 '1987': 299.822,
 '1988': 302.601,
 '1989': 305.399,
 '1990': 308.226,
 '1991': 311.076,
 '1992': 312.617,
 '1993': 314.16,
 '1994': 315.714,
 '1995': 317.275,
 '1996': 318.872,
 '1997': 329.912,
 '1998': 341.351,
 '1999': 353.187,
 '2000': 365.45,
 '2001': 378.076,
 '2002': 380.842,
 '2003': 383.63,
 '2004': 386.441,
 '2005': 389.265,
 '2006': 392.119,
 '2007': 396.714,
 '2008': 401.37,
 '2009': 406.067,
 '2010': 410.826,
 '2011': 415.639,
 '2012': 419.673,
 '2013': 423.735,
 '2014': 427.843,
 '2015': 431.99,
 '2016': 436.182,
 '2017': 440.415,
 '2018': 444.688,
 '2019': 447.446,
 '2020': 450.36,
 '2021': 453.515,
 '2022': 457.004,
 '2023': 460.874,
 '2024': 465.145,
 '2025': 469.794,
 '2026': 474.766,
 '2027': 479.982,
 '2028': 485.367,
 '2029': 490.847,
 '2030': 496.367,
 '2031': 501.892,
 '2032': 507.407,
 '2033': 512.907,
 '2034': 518.391,
 '2035': 523.865},
{'Index': 48,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206172,
 'Urban Agglomeration': 'Perth',
 'Note': 21.0,
 'Latitude': -31.947841,
 'Longitude': 115.852514,
 '1950': 310.759,
 '1951': 320.447,
 '1952': 329.605,
 '1953': 338.999,
 '1954': 348.672,
 '1955': 358.088,
 '1956': 367.77,
 '1957': 377.687,
 '1958': 387.886,
 '1959': 398.36,
 '1960': 409.131,
 '1961': 420.173,
 '1962': 435.05,
 '1963': 450.454,
 '1964': 466.426,
 '1965': 482.918,
 '1966': 500.078,
 '1967': 541.568,
 '1968': 586.564,
 '1969': 635.159,
 '1970': 687.856,
 '1971': 744.704,
 '1972': 763.932,
 '1973': 783.601,
 '1974': 803.804,
 '1975': 824.529,
 '1976': 845.799,
 '1977': 864.124,
 '1978': 882.871,
 '1979': 902.025,
 '1980': 921.623,
 '1981': 941.617,
 '1982': 967.1,
 '1983': 993.272,
 '1984': 1020.19,
 '1985': 1047.761,
 '1986': 1076.113,
 '1987': 1104.6,
 '1988': 1133.882,
 '1989': 1163.856,
 '1990': 1194.665,
 '1991': 1226.238,
 '1992': 1248.852,
 '1993': 1271.819,
 '1994': 1295.242,
 '1995': 1319.095,
 '1996': 1343.397,
 '1997': 1358.986,
 '1998': 1374.777,
 '1999': 1390.752,
 '2000': 1406.935,
 '2001': 1423.274,
 '2002': 1444.662,
 '2003': 1466.371,
 '2004': 1488.437,
 '2005': 1510.773,
 '2006': 1533.535,
 '2007': 1578.696,
 '2008': 1625.253,
 '2009': 1673.049,
 '2010': 1722.319,
 '2011': 1772.979,
 '2012': 1802.589,
 '2013': 1832.61,
 '2014': 1863.173,
 '2015': 1894.246,
 '2016': 1925.881,
 '2017': 1958.044,
 '2018': 1990.745,
 '2019': 2016.415,
 '2020': 2041.959,
 '2021': 2067.333,
 '2022': 2092.649,
 '2023': 2117.997,
 '2024': 2143.491,
 '2025': 2169.192,
 '2026': 2195.091,
 '2027': 2221.117,
 '2028': 2247.192,
 '2029': 2273.221,
 '2030': 2299.13,
 '2031': 2324.889,
 '2032': 2350.511,
 '2033': 2376.017,
 '2034': 2401.433,
 '2035': 2426.794},
{'Index': 49,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20098,
 'Urban Agglomeration': 'Sunshine Coast',
 'Note': 21.0,
 'Latitude': -26.66008,
 'Longitude': 153.09953,
 '1950': 9.882,
 '1951': 10.62,
 '1952': 11.415,
 '1953': 12.266,
 '1954': 13.183,
 '1955': 14.167,
 '1956': 15.227,
 '1957': 16.363,
 '1958': 17.585,
 '1959': 18.899,
 '1960': 20.312,
 '1961': 21.827,
 '1962': 23.458,
 '1963': 25.21,
 '1964': 27.096,
 '1965': 29.117,
 '1966': 31.292,
 '1967': 33.629,
 '1968': 36.145,
 '1969': 38.841,
 '1970': 41.742,
 '1971': 44.86,
 '1972': 48.216,
 '1973': 51.813,
 '1974': 55.683,
 '1975': 59.842,
 '1976': 64.318,
 '1977': 69.116,
 '1978': 74.279,
 '1979': 79.827,
 '1980': 85.798,
 '1981': 92.192,
 '1982': 96.617,
 '1983': 101.255,
 '1984': 106.123,
 '1985': 111.21,
 '1986': 116.554,
 '1987': 124.388,
 '1988': 132.762,
 '1989': 141.673,
 '1990': 151.196,
 '1991': 161.348,
 '1992': 169.885,
 '1993': 178.848,
 '1994': 188.298,
 '1995': 198.247,
 '1996': 208.709,
 '1997': 209.603,
 '1998': 210.501,
 '1999': 211.403,
 '2000': 212.311,
 '2001': 213.236,
 '2002': 220.432,
 '2003': 227.87,
 '2004': 235.571,
 '2005': 243.509,
 '2006': 251.718,
 '2007': 257.324,
 '2008': 263.062,
 '2009': 268.912,
 '2010': 274.9,
 '2011': 281.024,
 '2012': 287.961,
 '2013': 295.051,
 '2014': 302.324,
 '2015': 309.778,
 '2016': 317.425,
 '2017': 325.261,
 '2018': 333.29,
 '2019': 340.132,
 '2020': 346.829,
 '2021': 353.281,
 '2022': 359.438,
 '2023': 365.281,
 '2024': 370.828,
 '2025': 376.114,
 '2026': 381.184,
 '2027': 386.079,
 '2028': 390.839,
 '2029': 395.496,
 '2030': 400.071,
 '2031': 404.587,
 '2032': 409.06,
 '2033': 413.505,
 '2034': 417.93,
 '2035': 422.345},
{'Index': 50,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206167,
 'Urban Agglomeration': 'Sydney',
 'Note': 21.0,
 'Latitude': -33.86785,
 'Longitude': 151.20732,
 '1950': 1689.935,
 '1951': 1735.903,
 '1952': 1777.422,
 '1953': 1819.816,
 '1954': 1863.277,
 '1955': 1905.976,
 '1956': 1949.715,
 '1957': 1994.333,
 '1958': 2040.035,
 '1959': 2086.785,
 '1960': 2134.673,
 '1961': 2183.523,
 '1962': 2233.459,
 '1963': 2284.537,
 '1964': 2336.856,
 '1965': 2390.224,
 '1966': 2445.016,
 '1967': 2549.933,
 '1968': 2659.506,
 '1969': 2773.466,
 '1970': 2892.477,
 '1971': 3016.037,
 '1972': 3041.223,
 '1973': 3066.549,
 '1974': 3092.121,
 '1975': 3117.906,
 '1976': 3143.945,
 '1977': 3170.608,
 '1978': 3197.534,
 '1979': 3224.688,
 '1980': 3252.111,
 '1981': 3279.743,
 '1982': 3317.267,
 '1983': 3355.221,
 '1984': 3393.661,
 '1985': 3432.435,
 '1986': 3471.704,
 '1987': 3511.087,
 '1988': 3550.973,
 '1989': 3591.2,
 '1990': 3631.94,
 '1991': 3673.11,
 '1992': 3709.165,
 '1993': 3745.472,
 '1994': 3782.186,
 '1995': 3819.26,
 '1996': 3856.593,
 '1997': 3837.252,
 '1998': 3817.981,
 '1999': 3798.807,
 '2000': 3779.704,
 '2001': 3760.877,
 '2002': 3789.046,
 '2003': 3817.426,
 '2004': 3846.058,
 '2005': 3874.825,
 '2006': 3903.942,
 '2007': 3967.807,
 '2008': 4032.807,
 '2009': 4098.688,
 '2010': 4165.739,
 '2011': 4233.904,
 '2012': 4309.56,
 '2013': 4386.354,
 '2014': 4464.625,
 '2015': 4544.293,
 '2016': 4625.496,
 '2017': 4708.15,
 '2018': 4792.281,
 '2019': 4859.432,
 '2020': 4925.987,
 '2021': 4991.654,
 '2022': 5056.571,
 '2023': 5120.894,
 '2024': 5184.896,
 '2025': 5248.788,
 '2026': 5312.641,
 '2027': 5376.399,
 '2028': 5439.981,
 '2029': 5503.256,
 '2030': 5566.118,
 '2031': 5628.549,
 '2032': 5690.609,
 '2033': 5752.37,
 '2034': 5813.909,
 '2035': 5875.309},
{'Index': 51,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20101,
 'Urban Agglomeration': 'Wollongong',
 'Note': 21.0,
 'Latitude': -34.424,
 'Longitude': 150.89345,
 '1950': 73.477,
 '1951': 77.484,
 '1952': 81.716,
 '1953': 86.166,
 '1954': 90.865,
 '1955': 95.821,
 '1956': 101.054,
 '1957': 106.557,
 '1958': 112.368,
 '1959': 118.496,
 '1960': 124.968,
 '1961': 131.769,
 '1962': 137.471,
 '1963': 143.419,
 '1964': 149.634,
 '1965': 156.099,
 '1966': 162.847,
 '1967': 167.262,
 '1968': 171.802,
 '1969': 176.453,
 '1970': 181.237,
 '1971': 186.149,
 '1972': 190.893,
 '1973': 195.745,
 '1974': 200.727,
 '1975': 205.836,
 '1976': 211.079,
 '1977': 214.993,
 '1978': 218.985,
 '1979': 223.051,
 '1980': 227.199,
 '1981': 231.401,
 '1982': 231.72,
 '1983': 232.04,
 '1984': 232.36,
 '1985': 232.68,
 '1986': 233.006,
 '1987': 235.339,
 '1988': 237.699,
 '1989': 240.075,
 '1990': 242.479,
 '1991': 244.906,
 '1992': 247.04,
 '1993': 249.186,
 '1994': 251.354,
 '1995': 253.541,
 '1996': 255.747,
 '1997': 256.72,
 '1998': 257.699,
 '1999': 258.682,
 '2000': 259.669,
 '2001': 260.658,
 '2002': 261.698,
 '2003': 262.743,
 '2004': 263.793,
 '2005': 264.844,
 '2006': 265.906,
 '2007': 268.994,
 '2008': 272.122,
 '2009': 275.278,
 '2010': 278.475,
 '2011': 281.707,
 '2012': 284.451,
 '2013': 287.213,
 '2014': 290.006,
 '2015': 292.825,
 '2016': 295.677,
 '2017': 298.557,
 '2018': 301.465,
 '2019': 303.345,
 '2020': 305.329,
 '2021': 307.477,
 '2022': 309.849,
 '2023': 312.479,
 '2024': 315.379,
 '2025': 318.535,
 '2026': 321.908,
 '2027': 325.446,
 '2028': 329.098,
 '2029': 332.815,
 '2030': 336.557,
 '2031': 340.304,
 '2032': 344.043,
 '2033': 347.772,
 '2034': 351.491,
 '2035': 355.202},
{'Index': 52,
 'Country Code': 40,
 'Country or area': 'Austria',
 'City Code': 20107,
 'Urban Agglomeration': 'Wien (Vienna)',
 'Note': '',
 'Latitude': 48.206443,
 'Longitude': 16.370725,
 '1950': 1615.058,
 '1951': 1616.221,
 '1952': 1617.386,
 '1953': 1618.548,
 '1954': 1619.714,
 '1955': 1620.88,
 '1956': 1622.048,
 '1957': 1623.214,
 '1958': 1624.383,
 '1959': 1625.552,
 '1960': 1626.724,
 '1961': 1627.354,
 '1962': 1626.595,
 '1963': 1625.837,
 '1964': 1625.077,
 '1965': 1624.321,
 '1966': 1623.563,
 '1967': 1622.806,
 '1968': 1622.048,
 '1969': 1621.293,
 '1970': 1620.537,
 '1971': 1618.638,
 '1972': 1609.553,
 '1973': 1600.544,
 '1974': 1591.573,
 '1975': 1582.652,
 '1976': 1573.769,
 '1977': 1564.96,
 '1978': 1556.188,
 '1979': 1547.466,
 '1980': 1538.78,
 '1981': 1531.462,
 '1982': 1532.31,
 '1983': 1533.157,
 '1984': 1534.007,
 '1985': 1534.855,
 '1986': 1535.704,
 '1987': 1536.554,
 '1988': 1537.405,
 '1989': 1538.255,
 '1990': 1539.106,
 '1991': 1539.98,
 '1992': 1541.006,
 '1993': 1542.03,
 '1994': 1543.055,
 '1995': 1544.082,
 '1996': 1545.111,
 '1997': 1546.137,
 '1998': 1547.166,
 '1999': 1548.195,
 '2000': 1549.227,
 '2001': 1552.88,
 '2002': 1574.455,
 '2003': 1596.329,
 '2004': 1618.539,
 '2005': 1640.995,
 '2006': 1656.806,
 '2007': 1670.919,
 '2008': 1690.624,
 '2009': 1710.506,
 '2010': 1730.649,
 '2011': 1751.03,
 '2012': 1771.68,
 '2013': 1792.515,
 '2014': 1813.624,
 '2015': 1834.982,
 '2016': 1856.622,
 '2017': 1878.456,
 '2018': 1900.547,
 '2019': 1915.338,
 '2020': 1929.944,
 '2021': 1944.91,
 '2022': 1960.023,
 '2023': 1975.271,
 '2024': 1990.487,
 '2025': 2005.497,
 '2026': 2020.317,
 '2027': 2035.114,
 '2028': 2049.922,
 '2029': 2064.752,
 '2030': 2079.587,
 '2031': 2094.406,
 '2032': 2109.193,
 '2033': 2123.967,
 '2034': 2138.751,
 '2035': 2153.584},
{'Index': 53,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20053,
 'Urban Agglomeration': 'Baku',
 'Note': 22.0,
 'Latitude': 40.37767,
 'Longitude': 49.89201,
 '1950': 896.761,
 '1951': 905.156,
 '1952': 913.641,
 '1953': 922.182,
 '1954': 930.815,
 '1955': 939.529,
 '1956': 948.336,
 '1957': 957.201,
 '1958': 966.162,
 '1959': 981.668,
 '1960': 1005.297,
 '1961': 1029.427,
 '1962': 1054.171,
 '1963': 1079.51,
 '1964': 1105.494,
 '1965': 1132.029,
 '1966': 1159.239,
 '1967': 1187.103,
 '1968': 1215.677,
 '1969': 1244.857,
 '1970': 1274.298,
 '1971': 1303.852,
 '1972': 1334.134,
 '1973': 1365.033,
 '1974': 1396.692,
 '1975': 1429.085,
 '1976': 1462.275,
 '1977': 1496.142,
 '1978': 1530.841,
 '1979': 1557.576,
 '1980': 1574.287,
 '1981': 1591.131,
 '1982': 1608.178,
 '1983': 1625.408,
 '1984': 1642.846,
 '1985': 1660.424,
 '1986': 1678.213,
 '1987': 1696.194,
 '1988': 1714.392,
 '1989': 1727.104,
 '1990': 1733.452,
 '1991': 1739.823,
 '1992': 1746.226,
 '1993': 1752.636,
 '1994': 1759.077,
 '1995': 1765.543,
 '1996': 1772.041,
 '1997': 1778.545,
 '1998': 1785.082,
 '1999': 1793.936,
 '2000': 1805.977,
 '2001': 1818.065,
 '2002': 1830.251,
 '2003': 1842.519,
 '2004': 1854.885,
 '2005': 1867.301,
 '2006': 1884.268,
 '2007': 1905.967,
 '2008': 1945.022,
 '2009': 2002.541,
 '2010': 2061.843,
 '2011': 2104.671,
 '2012': 2129.67,
 '2013': 2154.896,
 '2014': 2180.456,
 '2015': 2206.32,
 '2016': 2232.526,
 '2017': 2258.971,
 '2018': 2285.729,
 '2019': 2313.138,
 '2020': 2341.443,
 '2021': 2370.776,
 '2022': 2401.108,
 '2023': 2432.304,
 '2024': 2464.162,
 '2025': 2496.495,
 '2026': 2529.068,
 '2027': 2561.684,
 '2028': 2594.208,
 '2029': 2626.666,
 '2030': 2659.07,
 '2031': 2691.475,
 '2032': 2723.88,
 '2033': 2756.343,
 '2034': 2788.755,
 '2035': 2821.01},
{'Index': 54,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20054,
 'Urban Agglomeration': 'Gäncä',
 'Note': '',
 'Latitude': 40.68278,
 'Longitude': 46.36056,
 '1950': 108.093,
 '1951': 108.99,
 '1952': 109.896,
 '1953': 110.807,
 '1954': 111.726,
 '1955': 112.653,
 '1956': 113.589,
 '1957': 114.531,
 '1958': 115.481,
 '1959': 118.405,
 '1960': 123.845,
 '1961': 129.519,
 '1962': 135.461,
 '1963': 141.676,
 '1964': 148.185,
 '1965': 154.974,
 '1966': 162.084,
 '1967': 169.521,
 '1968': 177.309,
 '1969': 185.432,
 '1970': 191.939,
 '1971': 196.246,
 '1972': 200.655,
 '1973': 205.151,
 '1974': 209.755,
 '1975': 214.461,
 '1976': 219.28,
 '1977': 224.193,
 '1978': 229.224,
 '1979': 233.858,
 '1980': 237.976,
 '1981': 242.156,
 '1982': 246.415,
 '1983': 250.748,
 '1984': 255.164,
 '1985': 259.646,
 '1986': 264.212,
 '1987': 268.859,
 '1988': 273.593,
 '1989': 277.182,
 '1990': 279.417,
 '1991': 281.671,
 '1992': 283.946,
 '1993': 286.232,
 '1994': 288.541,
 '1995': 290.868,
 '1996': 293.217,
 '1997': 295.578,
 '1998': 297.962,
 '1999': 299.64,
 '2000': 300.343,
 '2001': 301.046,
 '2002': 301.823,
 '2003': 302.673,
 '2004': 304.024,
 '2005': 305.878,
 '2006': 307.745,
 '2007': 309.625,
 '2008': 311.518,
 '2009': 313.417,
 '2010': 315.331,
 '2011': 317.521,
 '2012': 320.002,
 '2013': 322.496,
 '2014': 325.012,
 '2015': 327.548,
 '2016': 330.108,
 '2017': 332.68,
 '2018': 335.272,
 '2019': 337.987,
 '2020': 340.912,
 '2021': 344.108,
 '2022': 347.598,
 '2023': 351.377,
 '2024': 355.412,
 '2025': 359.663,
 '2026': 364.071,
 '2027': 368.582,
 '2028': 373.15,
 '2029': 377.756,
 '2030': 382.382,
 '2031': 387.026,
 '2032': 391.679,
 '2033': 396.344,
 '2034': 401.003,
 '2035': 405.641},
{'Index': 55,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20056,
 'Urban Agglomeration': 'Sumquayit',
 'Note': '',
 'Latitude': 40.58972,
 'Longitude': 49.66861,
 '1950': 20.232,
 '1951': 22.596,
 '1952': 25.24,
 '1953': 28.185,
 '1954': 31.478,
 '1955': 35.156,
 '1956': 39.269,
 '1957': 43.851,
 '1958': 48.975,
 '1959': 53.914,
 '1960': 58.353,
 '1961': 63.143,
 '1962': 68.334,
 '1963': 73.951,
 '1964': 80.039,
 '1965': 86.61,
 '1966': 93.73,
 '1967': 101.435,
 '1968': 109.786,
 '1969': 118.798,
 '1970': 126.719,
 '1971': 132.873,
 '1972': 139.334,
 '1973': 146.09,
 '1974': 153.184,
 '1975': 160.622,
 '1976': 168.433,
 '1977': 176.6,
 '1978': 185.175,
 '1979': 191.689,
 '1980': 195.437,
 '1981': 199.248,
 '1982': 203.139,
 '1983': 207.106,
 '1984': 211.156,
 '1985': 215.274,
 '1986': 219.478,
 '1987': 223.764,
 '1988': 228.14,
 '1989': 232.714,
 '1990': 237.534,
 '1991': 242.453,
 '1992': 247.482,
 '1993': 252.6,
 '1994': 257.832,
 '1995': 263.171,
 '1996': 268.629,
 '1997': 274.185,
 '1998': 279.864,
 '1999': 283.935,
 '2000': 285.714,
 '2001': 287.499,
 '2002': 288.972,
 '2003': 290.122,
 '2004': 292.358,
 '2005': 295.697,
 '2006': 299.08,
 '2007': 302.501,
 '2008': 305.966,
 '2009': 309.461,
 '2010': 313.0,
 '2011': 316.733,
 '2012': 320.672,
 '2013': 324.65,
 '2014': 328.682,
 '2015': 332.764,
 '2016': 336.903,
 '2017': 341.081,
 '2018': 345.311,
 '2019': 349.636,
 '2020': 354.086,
 '2021': 358.675,
 '2022': 363.394,
 '2023': 368.221,
 '2024': 373.125,
 '2025': 378.08,
 '2026': 383.054,
 '2027': 388.021,
 '2028': 392.963,
 '2029': 397.889,
 '2030': 402.803,
 '2031': 407.714,
 '2032': 412.624,
 '2033': 417.542,
 '2034': 422.452,
 '2035': 427.338},
{'Index': 56,
 'Country Code': 48,
 'Country or area': 'Bahrain',
 'City Code': 20109,
 'Urban Agglomeration': 'Al-Manamah (Manama)',
 'Note': 23.0,
 'Latitude': 26.21536,
 'Longitude': 50.5832,
 '1950': 40.283,
 '1951': 42.276,
 '1952': 44.371,
 '1953': 46.564,
 '1954': 48.868,
 '1955': 51.287,
 '1956': 53.829,
 '1957': 56.489,
 '1958': 59.284,
 '1959': 62.162,
 '1960': 64.888,
 '1961': 67.726,
 '1962': 70.691,
 '1963': 73.787,
 '1964': 77.022,
 '1965': 79.697,
 '1966': 81.304,
 '1967': 82.943,
 '1968': 84.617,
 '1969': 86.321,
 '1970': 88.061,
 '1971': 89.951,
 '1972': 92.251,
 '1973': 94.602,
 '1974': 97.017,
 '1975': 99.494,
 '1976': 102.037,
 '1977': 104.638,
 '1978': 107.31,
 '1979': 110.049,
 '1980': 112.862,
 '1981': 115.318,
 '1982': 116.446,
 '1983': 117.585,
 '1984': 118.736,
 '1985': 119.896,
 '1986': 121.069,
 '1987': 122.253,
 '1988': 123.45,
 '1989': 124.656,
 '1990': 125.875,
 '1991': 127.106,
 '1992': 128.546,
 '1993': 130.12,
 '1994': 131.715,
 '1995': 133.33,
 '1996': 134.966,
 '1997': 136.618,
 '1998': 138.293,
 '1999': 139.988,
 '2000': 141.707,
 '2001': 145.632,
 '2002': 157.33,
 '2003': 169.967,
 '2004': 183.64,
 '2005': 198.37,
 '2006': 214.304,
 '2007': 231.518,
 '2008': 250.141,
 '2009': 270.205,
 '2010': 292.172,
 '2011': 317.239,
 '2012': 344.495,
 '2013': 374.008,
 '2014': 406.095,
 '2015': 440.935,
 '2016': 478.819,
 '2017': 519.958,
 '2018': 564.631,
 '2019': 600.433,
 '2020': 634.508,
 '2021': 663.893,
 '2022': 688.558,
 '2023': 708.882,
 '2024': 726.505,
 '2025': 743.066,
 '2026': 759.306,
 '2027': 775.067,
 '2028': 790.322,
 '2029': 804.712,
 '2030': 817.889,
 '2031': 829.848,
 '2032': 840.868,
 '2033': 851.085,
 '2034': 860.708,
 '2035': 869.902},
{'Index': 57,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20110,
 'Urban Agglomeration': 'Barisal',
 'Note': '',
 'Latitude': 22.70194,
 'Longitude': 90.37111,
 '1950': 71.139,
 '1951': 72.283,
 '1952': 73.447,
 '1953': 74.626,
 '1954': 75.825,
 '1955': 77.044,
 '1956': 78.285,
 '1957': 79.541,
 '1958': 80.82,
 '1959': 82.119,
 '1960': 83.441,
 '1961': 85.128,
 '1962': 87.362,
 '1963': 89.654,
 '1964': 92.01,
 '1965': 94.421,
 '1966': 96.898,
 '1967': 99.44,
 '1968': 102.053,
 '1969': 104.727,
 '1970': 107.475,
 '1971': 110.295,
 '1972': 113.193,
 '1973': 116.159,
 '1974': 120.646,
 '1975': 128.338,
 '1976': 136.532,
 '1977': 145.225,
 '1978': 154.485,
 '1979': 164.334,
 '1980': 174.827,
 '1981': 183.338,
 '1982': 186.654,
 '1983': 190.029,
 '1984': 193.47,
 '1985': 196.964,
 '1986': 200.525,
 '1987': 204.152,
 '1988': 207.848,
 '1989': 211.602,
 '1990': 215.428,
 '1991': 219.032,
 '1992': 222.031,
 '1993': 225.064,
 '1994': 228.141,
 '1995': 231.261,
 '1996': 234.428,
 '1997': 237.63,
 '1998': 240.879,
 '1999': 244.173,
 '2000': 247.517,
 '2001': 253.162,
 '2002': 261.939,
 '2003': 271.02,
 '2004': 280.428,
 '2005': 290.137,
 '2006': 300.195,
 '2007': 310.603,
 '2008': 321.386,
 '2009': 332.512,
 '2010': 344.039,
 '2011': 355.967,
 '2012': 368.309,
 '2013': 381.078,
 '2014': 394.29,
 '2015': 407.96,
 '2016': 422.105,
 '2017': 436.739,
 '2018': 451.881,
 '2019': 467.491,
 '2020': 483.506,
 '2021': 499.854,
 '2022': 516.3,
 '2023': 532.69,
 '2024': 549.031,
 '2025': 565.243,
 '2026': 581.269,
 '2027': 597.094,
 '2028': 612.699,
 '2029': 628.096,
 '2030': 643.286,
 '2031': 658.263,
 '2032': 673.001,
 '2033': 687.497,
 '2034': 701.722,
 '2035': 715.625},
{'Index': 58,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20112,
 'Urban Agglomeration': 'Bogra',
 'Note': '',
 'Latitude': 24.85,
 'Longitude': 89.36667,
 '1950': 33.781,
 '1951': 34.78,
 '1952': 35.81,
 '1953': 36.867,
 '1954': 37.956,
 '1955': 39.078,
 '1956': 40.235,
 '1957': 41.423,
 '1958': 42.647,
 '1959': 43.908,
 '1960': 45.207,
 '1961': 46.472,
 '1962': 47.673,
 '1963': 48.904,
 '1964': 50.168,
 '1965': 51.462,
 '1966': 52.791,
 '1967': 54.155,
 '1968': 55.555,
 '1969': 56.988,
 '1970': 58.459,
 '1971': 59.969,
 '1972': 61.52,
 '1973': 63.107,
 '1974': 65.548,
 '1975': 69.795,
 '1976': 74.323,
 '1977': 79.132,
 '1978': 84.259,
 '1979': 89.718,
 '1980': 95.539,
 '1981': 101.533,
 '1982': 107.497,
 '1983': 113.812,
 '1984': 120.506,
 '1985': 127.575,
 '1986': 135.068,
 '1987': 143.002,
 '1988': 151.414,
 '1989': 160.295,
 '1990': 169.711,
 '1991': 177.85,
 '1992': 182.124,
 '1993': 186.489,
 '1994': 190.965,
 '1995': 195.548,
 '1996': 200.248,
 '1997': 205.048,
 '1998': 209.969,
 '1999': 215.008,
 '2000': 220.176,
 '2001': 229.502,
 '2002': 244.751,
 '2003': 261.013,
 '2004': 278.381,
 '2005': 296.851,
 '2006': 316.575,
 '2007': 337.609,
 '2008': 360.073,
 '2009': 383.964,
 '2010': 409.475,
 '2011': 436.682,
 '2012': 465.697,
 '2013': 496.639,
 '2014': 529.638,
 '2015': 564.829,
 '2016': 602.358,
 '2017': 642.381,
 '2018': 685.063,
 '2019': 729.609,
 '2020': 775.034,
 '2021': 820.297,
 '2022': 864.183,
 '2023': 905.814,
 '2024': 944.877,
 '2025': 981.223,
 '2026': 1014.993,
 '2027': 1046.555,
 '2028': 1076.333,
 '2029': 1104.777,
 '2030': 1132.239,
 '2031': 1158.965,
 '2032': 1185.079,
 '2033': 1210.671,
 '2034': 1235.746,
 '2035': 1260.237},
{'Index': 59,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20115,
 'Urban Agglomeration': 'Chittagong',
 'Note': '',
 'Latitude': 22.33306,
 'Longitude': 91.83639,
 '1950': 288.853,
 '1951': 296.181,
 '1952': 302.671,
 '1953': 309.285,
 '1954': 316.053,
 '1955': 322.969,
 '1956': 330.047,
 '1957': 337.259,
 '1958': 344.639,
 '1959': 352.18,
 '1960': 359.898,
 '1961': 375.578,
 '1962': 403.949,
 '1963': 434.462,
 '1964': 467.328,
 '1965': 502.578,
 '1966': 540.542,
 '1967': 581.374,
 '1968': 625.352,
 '1969': 672.523,
 '1970': 723.324,
 '1971': 777.963,
 '1972': 836.812,
 '1973': 899.933,
 '1974': 962.217,
 '1975': 1016.788,
 '1976': 1074.535,
 '1977': 1135.389,
 '1978': 1199.781,
 '1979': 1267.824,
 '1980': 1339.829,
 '1981': 1408.871,
 '1982': 1466.646,
 '1983': 1526.79,
 '1984': 1589.489,
 '1985': 1654.58,
 '1986': 1722.431,
 '1987': 1793.065,
 '1988': 1866.698,
 '1989': 1943.14,
 '1990': 2022.825,
 '1991': 2112.037,
 '1992': 2220.172,
 '1993': 2333.522,
 '1994': 2452.828,
 '1995': 2578.233,
 '1996': 2710.237,
 '1997': 2848.607,
 '1998': 2994.248,
 '1999': 3147.335,
 '2000': 3308.476,
 '2001': 3432.049,
 '2002': 3501.111,
 '2003': 3571.563,
 '2004': 3643.533,
 '2005': 3716.749,
 '2006': 3791.54,
 '2007': 3867.836,
 '2008': 3945.776,
 '2009': 4025.065,
 '2010': 4106.06,
 '2011': 4188.686,
 '2012': 4272.975,
 '2013': 4358.959,
 '2014': 4446.675,
 '2015': 4536.155,
 '2016': 4627.436,
 '2017': 4720.553,
 '2018': 4815.545,
 '2019': 4914.633,
 '2020': 5019.824,
 '2021': 5132.751,
 '2022': 5252.842,
 '2023': 5379.66,
 '2024': 5513.609,
 '2025': 5653.493,
 '2026': 5797.811,
 '2027': 5945.172,
 '2028': 6094.106,
 '2029': 6243.551,
 '2030': 6392.58,
 '2031': 6540.445,
 '2032': 6686.451,
 '2033': 6830.289,
 '2034': 6971.554,
 '2035': 7109.655},
{'Index': 60,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20117,
 'Urban Agglomeration': 'Comilla',
 'Note': '',
 'Latitude': 23.45778,
 'Longitude': 91.20444,
 '1950': 78.54,
 '1951': 79.632,
 '1952': 80.74,
 '1953': 81.861,
 '1954': 82.999,
 '1955': 84.153,
 '1956': 85.324,
 '1957': 86.509,
 '1958': 87.711,
 '1959': 88.931,
 '1960': 90.168,
 '1961': 92.23,
 '1962': 95.541,
 '1963': 98.972,
 '1964': 102.53,
 '1965': 106.206,
 '1966': 110.018,
 '1967': 113.968,
 '1968': 118.066,
 '1969': 122.298,
 '1970': 126.689,
 '1971': 131.237,
 '1972': 135.956,
 '1973': 140.83,
 '1974': 147.353,
 '1975': 157.284,
 '1976': 167.899,
 '1977': 179.198,
 '1978': 191.275,
 '1979': 204.166,
 '1980': 217.945,
 '1981': 228.216,
 '1982': 229.634,
 '1983': 231.061,
 '1984': 232.499,
 '1985': 233.942,
 '1986': 235.396,
 '1987': 236.86,
 '1988': 238.334,
 '1989': 239.813,
 '1990': 241.303,
 '1991': 243.843,
 '1992': 248.805,
 '1993': 253.855,
 '1994': 259.014,
 '1995': 264.278,
 '1996': 269.657,
 '1997': 275.13,
 '1998': 280.721,
 '1999': 286.427,
 '2000': 292.256,
 '2001': 300.203,
 '2002': 311.049,
 '2003': 322.287,
 '2004': 333.947,
 '2005': 345.995,
 '2006': 358.495,
 '2007': 371.447,
 '2008': 384.886,
 '2009': 398.772,
 '2010': 413.179,
 '2011': 428.106,
 '2012': 443.572,
 '2013': 459.597,
 '2014': 476.201,
 '2015': 493.405,
 '2016': 511.23,
 '2017': 529.7,
 '2018': 548.836,
 '2019': 568.563,
 '2020': 588.772,
 '2021': 609.345,
 '2022': 629.972,
 '2023': 650.448,
 '2024': 670.775,
 '2025': 690.86,
 '2026': 710.642,
 '2027': 730.117,
 '2028': 749.277,
 '2029': 768.151,
 '2030': 786.753,
 '2031': 805.081,
 '2032': 823.113,
 '2033': 840.843,
 '2034': 858.242,
 '2035': 875.247},
{'Index': 61,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 24.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 '1950': 335.76,
 '1951': 343.74,
 '1952': 358.999,
 '1953': 374.891,
 '1954': 391.51,
 '1955': 408.866,
 '1956': 427.016,
 '1957': 445.919,
 '1958': 465.687,
 '1959': 486.331,
 '1960': 507.921,
 '1961': 543.565,
 '1962': 602.546,
 '1963': 667.926,
 '1964': 740.506,
 '1965': 820.74,
 '1966': 909.796,
 '1967': 1008.515,
 '1968': 1118.104,
 '1969': 1239.251,
 '1970': 1373.718,
 '1971': 1522.776,
 '1972': 1688.248,
 '1973': 1871.169,
 '1974': 2056.298,
 '1975': 2221.055,
 '1976': 2399.267,
 '1977': 2591.228,
 '1978': 2798.845,
 '1979': 3023.097,
 '1980': 3265.663,
 '1981': 3519.136,
 '1982': 3775.135,
 '1983': 4049.756,
 '1984': 4344.775,
 '1985': 4660.384,
 '1986': 4999.402,
 '1987': 5363.083,
 '1988': 5753.775,
 '1989': 6171.735,
 '1990': 6620.697,
 '1991': 7041.281,
 '1992': 7344.419,
 '1993': 7659.719,
 '1994': 7989.018,
 '1995': 8332.474,
 '1996': 8691.2,
 '1997': 9064.318,
 '1998': 9454.003,
 '1999': 9860.44,
 '2000': 10284.947,
 '2001': 10695.828,
 '2002': 11083.051,
 '2003': 11484.292,
 '2004': 11900.642,
 '2005': 12330.879,
 '2006': 12777.296,
 '2007': 13239.874,
 '2008': 13719.871,
 '2009': 14215.877,
 '2010': 14730.537,
 '2011': 15263.828,
 '2012': 15816.426,
 '2013': 16389.029,
 '2014': 16982.363,
 '2015': 17597.177,
 '2016': 18234.249,
 '2017': 18894.385,
 '2018': 19578.421,
 '2019': 20283.552,
 '2020': 21005.86,
 '2021': 21741.09,
 '2022': 22478.117,
 '2023': 23209.616,
 '2024': 23935.652,
 '2025': 24652.864,
 '2026': 25359.145,
 '2027': 26054.326,
 '2028': 26738.209,
 '2029': 27411.819,
 '2030': 28075.66,
 '2031': 28729.757,
 '2032': 29373.215,
 '2033': 30005.948,
 '2034': 30626.85,
 '2035': 31233.651},
{'Index': 62,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20124,
 'Urban Agglomeration': 'Khulna',
 'Note': '',
 'Latitude': 22.80978,
 'Longitude': 89.56439,
 '1950': 61.259,
 '1951': 65.673,
 '1952': 70.411,
 '1953': 75.477,
 '1954': 80.915,
 '1955': 86.745,
 '1956': 93.003,
 '1957': 99.694,
 '1958': 106.877,
 '1959': 114.577,
 '1960': 122.844,
 '1961': 133.009,
 '1962': 146.114,
 '1963': 160.511,
 '1964': 176.349,
 '1965': 193.699,
 '1966': 212.784,
 '1967': 233.75,
 '1968': 256.815,
 '1969': 282.082,
 '1970': 309.875,
 '1971': 340.407,
 '1972': 373.996,
 '1973': 410.793,
 '1974': 445.721,
 '1975': 471.849,
 '1976': 499.549,
 '1977': 528.791,
 '1978': 559.789,
 '1979': 592.605,
 '1980': 627.393,
 '1981': 661.405,
 '1982': 691.363,
 '1983': 722.679,
 '1984': 755.459,
 '1985': 789.629,
 '1986': 825.396,
 '1987': 862.782,
 '1988': 901.917,
 '1989': 942.712,
 '1990': 985.412,
 '1991': 1023.029,
 '1992': 1045.839,
 '1993': 1069.092,
 '1994': 1092.895,
 '1995': 1117.228,
 '1996': 1142.137,
 '1997': 1167.531,
 '1998': 1193.526,
 '1999': 1220.1,
 '2000': 1247.303,
 '2001': 1254.617,
 '2002': 1236.177,
 '2003': 1218.008,
 '2004': 1200.082,
 '2005': 1182.467,
 '2006': 1165.088,
 '2007': 1147.964,
 '2008': 1131.068,
 '2009': 1114.467,
 '2010': 1098.087,
 '2011': 1081.947,
 '2012': 1066.044,
 '2013': 1050.375,
 '2014': 1034.936,
 '2015': 1019.725,
 '2016': 1004.736,
 '2017': 989.969,
 '2018': 975.418,
 '2019': 962.845,
 '2020': 953.745,
 '2021': 949.229,
 '2022': 949.659,
 '2023': 955.104,
 '2024': 965.483,
 '2025': 980.2,
 '2026': 998.46,
 '2027': 1019.424,
 '2028': 1042.257,
 '2029': 1066.267,
 '2030': 1090.895,
 '2031': 1115.724,
 '2032': 1140.449,
 '2033': 1164.908,
 '2034': 1188.973,
 '2035': 1212.517},
{'Index': 63,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20126,
 'Urban Agglomeration': 'Mymensingh',
 'Note': '',
 'Latitude': 24.75,
 'Longitude': 90.4,
 '1950': 65.043,
 '1951': 66.36,
 '1952': 67.45,
 '1953': 68.555,
 '1954': 69.68,
 '1955': 70.823,
 '1956': 71.986,
 '1957': 73.166,
 '1958': 74.366,
 '1959': 75.586,
 '1960': 76.828,
 '1961': 78.439,
 '1962': 80.604,
 '1963': 82.829,
 '1964': 85.119,
 '1965': 87.465,
 '1966': 89.88,
 '1967': 92.361,
 '1968': 94.914,
 '1969': 97.531,
 '1970': 100.223,
 '1971': 102.99,
 '1972': 105.837,
 '1973': 108.754,
 '1974': 112.469,
 '1975': 117.793,
 '1976': 123.376,
 '1977': 129.207,
 '1978': 135.323,
 '1979': 141.728,
 '1980': 148.446,
 '1981': 156.414,
 '1982': 166.941,
 '1983': 178.176,
 '1984': 190.185,
 '1985': 202.966,
 '1986': 216.626,
 '1987': 231.205,
 '1988': 246.788,
 '1989': 263.373,
 '1990': 281.098,
 '1991': 295.766,
 '1992': 301.337,
 '1993': 306.996,
 '1994': 312.77,
 '1995': 318.652,
 '1996': 324.654,
 '1997': 330.751,
 '1998': 336.972,
 '1999': 343.31,
 '2000': 349.775,
 '2001': 355.53,
 '2002': 360.332,
 '2003': 365.198,
 '2004': 370.136,
 '2005': 375.128,
 '2006': 380.194,
 '2007': 385.328,
 '2008': 390.539,
 '2009': 395.805,
 '2010': 401.15,
 '2011': 406.567,
 '2012': 412.057,
 '2013': 417.621,
 '2014': 423.261,
 '2015': 428.976,
 '2016': 434.769,
 '2017': 440.64,
 '2018': 446.59,
 '2019': 452.94,
 '2020': 459.983,
 '2021': 467.957,
 '2022': 476.875,
 '2023': 486.73,
 '2024': 497.562,
 '2025': 509.237,
 '2026': 521.576,
 '2027': 534.4,
 '2028': 547.521,
 '2029': 560.795,
 '2030': 574.1,
 '2031': 587.339,
 '2032': 600.433,
 '2033': 613.342,
 '2034': 626.025,
 '2035': 638.425},
{'Index': 64,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20131,
 'Urban Agglomeration': 'Rajshahi',
 'Note': '',
 'Latitude': 24.36667,
 'Longitude': 88.6,
 '1950': 38.97,
 '1951': 40.47,
 '1952': 41.935,
 '1953': 43.449,
 '1954': 45.019,
 '1955': 46.646,
 '1956': 48.335,
 '1957': 50.079,
 '1958': 51.889,
 '1959': 53.764,
 '1960': 55.71,
 '1961': 58.423,
 '1962': 62.34,
 '1963': 66.519,
 '1964': 70.986,
 '1965': 75.739,
 '1966': 80.817,
 '1967': 86.235,
 '1968': 92.026,
 '1969': 98.187,
 '1970': 104.77,
 '1971': 111.795,
 '1972': 119.301,
 '1973': 127.289,
 '1974': 137.07,
 '1975': 150.312,
 '1976': 164.855,
 '1977': 180.76,
 '1978': 198.223,
 '1979': 217.374,
 '1980': 238.405,
 '1981': 260.132,
 '1982': 280.987,
 '1983': 303.515,
 '1984': 327.883,
 '1985': 354.133,
 '1986': 382.525,
 '1987': 413.193,
 '1988': 446.368,
 '1989': 482.103,
 '1990': 520.755,
 '1991': 553.183,
 '1992': 565.877,
 '1993': 578.827,
 '1994': 592.092,
 '1995': 605.66,
 '1996': 619.559,
 '1997': 633.738,
 '1998': 648.261,
 '1999': 663.117,
 '2000': 678.334,
 '2001': 691.289,
 '2002': 701.175,
 '2003': 711.203,
 '2004': 721.387,
 '2005': 731.689,
 '2006': 742.153,
 '2007': 752.766,
 '2008': 763.546,
 '2009': 774.45,
 '2010': 785.525,
 '2011': 796.759,
 '2012': 808.154,
 '2013': 819.711,
 '2014': 831.434,
 '2015': 843.325,
 '2016': 855.385,
 '2017': 867.618,
 '2018': 880.026,
 '2019': 893.214,
 '2020': 907.732,
 '2021': 924.033,
 '2022': 942.126,
 '2023': 961.991,
 '2024': 983.707,
 '2025': 1007.015,
 '2026': 1031.574,
 '2027': 1057.04,
 '2028': 1083.058,
 '2029': 1109.352,
 '2030': 1135.69,
 '2031': 1161.89,
 '2032': 1187.797,
 '2033': 1213.336,
 '2034': 1238.425,
 '2035': 1262.956},
{'Index': 65,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20132,
 'Urban Agglomeration': 'Rangpur',
 'Note': '',
 'Latitude': 25.75,
 'Longitude': 89.25,
 '1950': 34.131,
 '1951': 35.074,
 '1952': 35.957,
 '1953': 36.86,
 '1954': 37.787,
 '1955': 38.737,
 '1956': 39.712,
 '1957': 40.709,
 '1958': 41.733,
 '1959': 42.782,
 '1960': 43.859,
 '1961': 45.328,
 '1962': 47.396,
 '1963': 49.559,
 '1964': 51.823,
 '1965': 54.185,
 '1966': 56.658,
 '1967': 59.243,
 '1968': 61.95,
 '1969': 64.773,
 '1970': 67.729,
 '1971': 70.819,
 '1972': 74.056,
 '1973': 77.43,
 '1974': 81.994,
 '1975': 89.041,
 '1976': 96.705,
 '1977': 105.005,
 '1978': 114.03,
 '1979': 123.83,
 '1980': 134.489,
 '1981': 144.293,
 '1982': 150.997,
 '1983': 158.012,
 '1984': 165.364,
 '1985': 173.036,
 '1986': 181.076,
 '1987': 189.488,
 '1988': 198.305,
 '1989': 207.505,
 '1990': 217.146,
 '1991': 225.711,
 '1992': 231.082,
 '1993': 236.566,
 '1994': 242.187,
 '1995': 247.943,
 '1996': 253.843,
 '1997': 259.867,
 '1998': 266.042,
 '1999': 272.364,
 '2000': 278.846,
 '2001': 284.861,
 '2002': 290.231,
 '2003': 295.702,
 '2004': 301.284,
 '2005': 306.955,
 '2006': 312.741,
 '2007': 318.637,
 '2008': 324.651,
 '2009': 330.763,
 '2010': 336.998,
 '2011': 343.35,
 '2012': 349.822,
 '2013': 356.415,
 '2014': 363.133,
 '2015': 369.978,
 '2016': 376.952,
 '2017': 384.057,
 '2018': 391.296,
 '2019': 398.869,
 '2020': 406.956,
 '2021': 415.707,
 '2022': 425.087,
 '2023': 435.065,
 '2024': 445.677,
 '2025': 456.821,
 '2026': 468.368,
 '2027': 480.198,
 '2028': 492.182,
 '2029': 504.225,
 '2030': 516.247,
 '2031': 528.181,
 '2032': 539.969,
 '2033': 551.583,
 '2034': 562.99,
 '2035': 574.143},
{'Index': 66,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 205390,
 'Urban Agglomeration': 'Rupganj',
 'Note': '',
 'Latitude': 23.792554,
 'Longitude': 90.520591,
 '1950': 9.682,
 '1951': 10.163,
 '1952': 10.669,
 '1953': 11.199,
 '1954': 11.756,
 '1955': 12.34,
 '1956': 12.955,
 '1957': 13.598,
 '1958': 14.274,
 '1959': 14.983,
 '1960': 15.729,
 '1961': 16.51,
 '1962': 17.331,
 '1963': 18.193,
 '1964': 19.098,
 '1965': 20.047,
 '1966': 21.043,
 '1967': 22.089,
 '1968': 23.189,
 '1969': 24.34,
 '1970': 25.55,
 '1971': 26.821,
 '1972': 28.156,
 '1973': 29.554,
 '1974': 31.023,
 '1975': 32.565,
 '1976': 34.186,
 '1977': 35.883,
 '1978': 37.667,
 '1979': 39.54,
 '1980': 41.509,
 '1981': 43.569,
 '1982': 45.735,
 '1983': 48.009,
 '1984': 50.399,
 '1985': 52.901,
 '1986': 55.531,
 '1987': 58.292,
 '1988': 61.194,
 '1989': 64.232,
 '1990': 67.425,
 '1991': 69.918,
 '1992': 70.53,
 '1993': 71.145,
 '1994': 71.767,
 '1995': 72.395,
 '1996': 73.029,
 '1997': 73.666,
 '1998': 74.31,
 '1999': 74.96,
 '2000': 75.616,
 '2001': 79.236,
 '2002': 87.178,
 '2003': 95.917,
 '2004': 105.546,
 '2005': 116.111,
 '2006': 127.75,
 '2007': 140.556,
 '2008': 154.666,
 '2009': 170.148,
 '2010': 187.204,
 '2011': 205.97,
 '2012': 226.617,
 '2013': 249.334,
 '2014': 274.328,
 '2015': 301.828,
 '2016': 332.084,
 '2017': 365.373,
 '2018': 402.0,
 '2019': 441.158,
 '2020': 481.718,
 '2021': 522.367,
 '2022': 561.639,
 '2023': 598.367,
 '2024': 631.95,
 '2025': 662.138,
 '2026': 689.092,
 '2027': 713.282,
 '2028': 735.288,
 '2029': 755.704,
 '2030': 775.014,
 '2031': 793.566,
 '2032': 811.563,
 '2033': 829.137,
 '2034': 846.327,
 '2035': 863.106},
{'Index': 67,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20136,
 'Urban Agglomeration': 'Sylhet',
 'Note': '',
 'Latitude': 24.89667,
 'Longitude': 91.87167,
 '1950': 67.438,
 '1951': 69.156,
 '1952': 69.978,
 '1953': 70.808,
 '1954': 71.649,
 '1955': 72.499,
 '1956': 73.361,
 '1957': 74.231,
 '1958': 75.112,
 '1959': 76.004,
 '1960': 76.908,
 '1961': 78.466,
 '1962': 81.013,
 '1963': 83.642,
 '1964': 86.361,
 '1965': 89.16,
 '1966': 92.053,
 '1967': 95.041,
 '1968': 98.13,
 '1969': 101.31,
 '1970': 104.598,
 '1971': 107.993,
 '1972': 111.503,
 '1973': 115.117,
 '1974': 121.225,
 '1975': 132.78,
 '1976': 145.455,
 '1977': 159.3,
 '1978': 174.484,
 '1979': 191.116,
 '1980': 209.36,
 '1981': 223.533,
 '1982': 226.326,
 '1983': 229.154,
 '1984': 232.022,
 '1985': 234.917,
 '1986': 237.853,
 '1987': 240.825,
 '1988': 243.839,
 '1989': 246.882,
 '1990': 249.967,
 '1991': 254.39,
 '1992': 261.913,
 '1993': 269.637,
 '1994': 277.6,
 '1995': 285.798,
 '1996': 294.25,
 '1997': 302.928,
 '1998': 311.874,
 '1999': 321.084,
 '2000': 330.579,
 '2001': 343.158,
 '2002': 360.029,
 '2003': 377.73,
 '2004': 396.327,
 '2005': 415.784,
 '2006': 436.226,
 '2007': 457.673,
 '2008': 480.206,
 '2009': 503.781,
 '2010': 528.55,
 '2011': 554.535,
 '2012': 581.797,
 '2013': 610.4,
 '2014': 640.409,
 '2015': 671.894,
 '2016': 704.926,
 '2017': 739.582,
 '2018': 775.942,
 '2019': 813.538,
 '2020': 851.808,
 '2021': 890.18,
 '2022': 927.856,
 '2023': 964.291,
 '2024': 999.374,
 '2025': 1032.982,
 '2026': 1065.146,
 '2027': 1096.038,
 '2028': 1125.851,
 '2029': 1154.814,
 '2030': 1183.1,
 '2031': 1210.821,
 '2032': 1238.01,
 '2033': 1264.707,
 '2034': 1290.888,
 '2035': 1316.467},
{'Index': 68,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20344,
 'Urban Agglomeration': 'Brest',
 'Note': '',
 'Latitude': 52.09755,
 'Longitude': 23.68775,
 '1950': 65.685,
 '1951': 66.608,
 '1952': 67.545,
 '1953': 68.493,
 '1954': 69.455,
 '1955': 70.431,
 '1956': 71.422,
 '1957': 72.424,
 '1958': 73.442,
 '1959': 75.555,
 '1960': 79.073,
 '1961': 82.745,
 '1962': 86.592,
 '1963': 90.619,
 '1964': 94.839,
 '1965': 99.242,
 '1966': 103.857,
 '1967': 108.686,
 '1968': 113.747,
 '1969': 119.029,
 '1970': 124.33,
 '1971': 129.578,
 '1972': 135.056,
 '1973': 140.75,
 '1974': 146.691,
 '1975': 152.884,
 '1976': 159.347,
 '1977': 166.064,
 '1978': 173.074,
 '1979': 180.016,
 '1980': 186.798,
 '1981': 193.815,
 '1982': 201.106,
 '1983': 208.672,
 '1984': 216.533,
 '1985': 224.667,
 '1986': 233.119,
 '1987': 241.889,
 '1988': 251.002,
 '1989': 257.321,
 '1990': 260.201,
 '1991': 263.114,
 '1992': 266.063,
 '1993': 269.037,
 '1994': 272.049,
 '1995': 275.094,
 '1996': 278.178,
 '1997': 281.287,
 '1998': 284.436,
 '1999': 287.324,
 '2000': 289.737,
 '2001': 292.163,
 '2002': 294.612,
 '2003': 297.083,
 '2004': 299.3,
 '2005': 301.249,
 '2006': 303.214,
 '2007': 305.192,
 '2008': 307.185,
 '2009': 309.185,
 '2010': 312.985,
 '2011': 317.563,
 '2012': 322.214,
 '2013': 326.92,
 '2014': 331.702,
 '2015': 336.554,
 '2016': 341.483,
 '2017': 346.471,
 '2018': 351.532,
 '2019': 355.16,
 '2020': 358.587,
 '2021': 361.738,
 '2022': 364.532,
 '2023': 366.934,
 '2024': 368.922,
 '2025': 370.503,
 '2026': 371.715,
 '2027': 372.615,
 '2028': 373.26,
 '2029': 373.706,
 '2030': 374.001,
 '2031': 374.174,
 '2032': 374.246,
 '2033': 374.237,
 '2034': 374.171,
 '2035': 374.076},
{'Index': 69,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20345,
 'Urban Agglomeration': 'Gomel',
 'Note': '',
 'Latitude': 52.4345,
 'Longitude': 30.9754,
 '1950': 115.888,
 '1951': 121.06,
 '1952': 126.47,
 '1953': 132.105,
 '1954': 138.0,
 '1955': 144.159,
 '1956': 150.601,
 '1957': 157.312,
 '1958': 164.332,
 '1959': 171.665,
 '1960': 179.336,
 '1961': 187.328,
 '1962': 195.687,
 '1963': 204.42,
 '1964': 213.555,
 '1965': 223.071,
 '1966': 233.025,
 '1967': 243.424,
 '1968': 254.302,
 '1969': 265.634,
 '1970': 276.774,
 '1971': 287.501,
 '1972': 298.66,
 '1973': 310.219,
 '1974': 322.242,
 '1975': 334.732,
 '1976': 347.724,
 '1977': 361.182,
 '1978': 375.181,
 '1979': 387.613,
 '1980': 397.904,
 '1981': 408.439,
 '1982': 419.268,
 '1983': 430.384,
 '1984': 441.811,
 '1985': 453.508,
 '1986': 465.532,
 '1987': 477.874,
 '1988': 490.562,
 '1989': 496.415,
 '1990': 494.199,
 '1991': 491.994,
 '1992': 489.795,
 '1993': 487.612,
 '1994': 485.436,
 '1995': 483.27,
 '1996': 481.11,
 '1997': 478.966,
 '1998': 476.828,
 '1999': 475.917,
 '2000': 477.087,
 '2001': 478.256,
 '2002': 479.43,
 '2003': 480.606,
 '2004': 481.323,
 '2005': 481.573,
 '2006': 481.825,
 '2007': 482.076,
 '2008': 482.328,
 '2009': 482.58,
 '2010': 487.603,
 '2011': 494.64,
 '2012': 501.788,
 '2013': 509.02,
 '2014': 516.366,
 '2015': 523.818,
 '2016': 531.387,
 '2017': 539.045,
 '2018': 546.813,
 '2019': 552.354,
 '2020': 557.589,
 '2021': 562.405,
 '2022': 566.678,
 '2023': 570.354,
 '2024': 573.4,
 '2025': 575.827,
 '2026': 577.688,
 '2027': 579.073,
 '2028': 580.067,
 '2029': 580.756,
 '2030': 581.211,
 '2031': 581.479,
 '2032': 581.59,
 '2033': 581.576,
 '2034': 581.474,
 '2035': 581.326},
{'Index': 70,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20346,
 'Urban Agglomeration': 'Grodno',
 'Note': '',
 'Latitude': 53.6884,
 'Longitude': 23.8258,
 '1950': 64.669,
 '1951': 65.593,
 '1952': 66.531,
 '1953': 67.48,
 '1954': 68.444,
 '1955': 69.422,
 '1956': 70.415,
 '1957': 71.42,
 '1958': 72.44,
 '1959': 74.821,
 '1960': 78.966,
 '1961': 83.329,
 '1962': 87.939,
 '1963': 92.804,
 '1964': 97.946,
 '1965': 103.357,
 '1966': 109.076,
 '1967': 115.11,
 '1968': 121.488,
 '1969': 128.2,
 '1970': 134.645,
 '1971': 140.611,
 '1972': 146.85,
 '1973': 153.347,
 '1974': 160.142,
 '1975': 167.237,
 '1976': 174.658,
 '1977': 182.386,
 '1978': 190.467,
 '1979': 197.919,
 '1980': 204.462,
 '1981': 211.203,
 '1982': 218.175,
 '1983': 225.377,
 '1984': 232.828,
 '1985': 240.503,
 '1986': 248.443,
 '1987': 256.644,
 '1988': 265.128,
 '1989': 271.15,
 '1990': 274.165,
 '1991': 277.214,
 '1992': 280.301,
 '1993': 283.414,
 '1994': 286.566,
 '1995': 289.753,
 '1996': 292.979,
 '1997': 296.233,
 '1998': 299.527,
 '1999': 302.605,
 '2000': 305.284,
 '2001': 307.978,
 '2002': 310.701,
 '2003': 313.447,
 '2004': 315.911,
 '2005': 318.076,
 '2006': 320.258,
 '2007': 322.456,
 '2008': 324.672,
 '2009': 326.896,
 '2010': 331.39,
 '2011': 336.872,
 '2012': 342.453,
 '2013': 348.11,
 '2014': 353.869,
 '2015': 359.722,
 '2016': 365.681,
 '2017': 371.722,
 '2018': 377.863,
 '2019': 382.453,
 '2020': 386.787,
 '2021': 390.757,
 '2022': 394.26,
 '2023': 397.248,
 '2024': 399.7,
 '2025': 401.629,
 '2026': 403.09,
 '2027': 404.161,
 '2028': 404.917,
 '2029': 405.433,
 '2030': 405.769,
 '2031': 405.965,
 '2032': 406.047,
 '2033': 406.039,
 '2034': 405.968,
 '2035': 405.865},
{'Index': 71,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20348,
 'Urban Agglomeration': 'Minsk',
 'Note': 22.0,
 'Latitude': 53.9,
 'Longitude': 27.56667,
 '1950': 284.222,
 '1951': 306.913,
 '1952': 331.45,
 '1953': 357.873,
 '1954': 386.444,
 '1955': 413.598,
 '1956': 438.709,
 '1957': 465.269,
 '1958': 493.478,
 '1959': 522.073,
 '1960': 550.71,
 '1961': 580.833,
 '1962': 612.649,
 '1963': 646.207,
 '1964': 681.653,
 '1965': 718.938,
 '1966': 758.319,
 '1967': 799.856,
 '1968': 843.731,
 '1969': 889.881,
 '1970': 931.566,
 '1971': 966.515,
 '1972': 1002.827,
 '1973': 1040.396,
 '1974': 1079.428,
 '1975': 1119.925,
 '1976': 1161.999,
 '1977': 1205.532,
 '1978': 1250.76,
 '1979': 1289.55,
 '1980': 1319.711,
 '1981': 1350.492,
 '1982': 1382.034,
 '1983': 1414.313,
 '1984': 1447.393,
 '1985': 1481.151,
 '1986': 1515.745,
 '1987': 1551.147,
 '1988': 1587.427,
 '1989': 1610.396,
 '1990': 1617.544,
 '1991': 1624.724,
 '1992': 1631.945,
 '1993': 1639.179,
 '1994': 1646.455,
 '1995': 1653.763,
 '1996': 1661.114,
 '1997': 1668.477,
 '1998': 1675.883,
 '1999': 1685.887,
 '2000': 1700.376,
 '2001': 1714.949,
 '2002': 1729.668,
 '2003': 1744.512,
 '2004': 1759.505,
 '2005': 1774.585,
 '2006': 1789.815,
 '2007': 1804.472,
 '2008': 1818.556,
 '2009': 1832.71,
 '2010': 1849.991,
 '2011': 1868.657,
 '2012': 1887.537,
 '2013': 1906.555,
 '2014': 1925.792,
 '2015': 1945.223,
 '2016': 1964.877,
 '2017': 1984.675,
 '2018': 2004.672,
 '2019': 2016.677,
 '2020': 2028.104,
 '2021': 2038.822,
 '2022': 2048.575,
 '2023': 2057.257,
 '2024': 2064.733,
 '2025': 2070.934,
 '2026': 2075.899,
 '2027': 2079.769,
 '2028': 2082.673,
 '2029': 2084.772,
 '2030': 2086.212,
 '2031': 2087.081,
 '2032': 2087.438,
 '2033': 2087.373,
 '2034': 2086.999,
 '2035': 2086.462},
{'Index': 72,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20349,
 'Urban Agglomeration': 'Mogilev',
 'Note': '',
 'Latitude': 53.9141,
 'Longitude': 30.33764,
 '1950': 82.124,
 '1951': 85.995,
 '1952': 90.054,
 '1953': 94.292,
 '1954': 98.736,
 '1955': 103.39,
 '1956': 108.27,
 '1957': 113.366,
 '1958': 118.709,
 '1959': 124.304,
 '1960': 130.171,
 '1961': 136.298,
 '1962': 142.722,
 '1963': 149.448,
 '1964': 156.502,
 '1965': 163.868,
 '1966': 171.592,
 '1967': 179.679,
 '1968': 188.16,
 '1969': 197.016,
 '1970': 205.748,
 '1971': 214.183,
 '1972': 222.976,
 '1973': 232.105,
 '1974': 241.62,
 '1975': 251.526,
 '1976': 261.853,
 '1977': 272.573,
 '1978': 283.748,
 '1979': 292.768,
 '1980': 298.92,
 '1981': 305.183,
 '1982': 311.586,
 '1983': 318.123,
 '1984': 324.807,
 '1985': 331.613,
 '1986': 338.571,
 '1987': 345.674,
 '1988': 352.937,
 '1989': 356.845,
 '1990': 356.805,
 '1991': 356.765,
 '1992': 356.724,
 '1993': 356.684,
 '1994': 356.644,
 '1995': 356.603,
 '1996': 356.563,
 '1997': 356.523,
 '1998': 356.482,
 '1999': 357.106,
 '2000': 358.87,
 '2001': 360.637,
 '2002': 362.415,
 '2003': 364.203,
 '2004': 364.507,
 '2005': 363.322,
 '2006': 362.14,
 '2007': 360.961,
 '2008': 359.785,
 '2009': 358.615,
 '2010': 360.408,
 '2011': 363.418,
 '2012': 366.457,
 '2013': 369.513,
 '2014': 372.599,
 '2015': 375.711,
 '2016': 378.853,
 '2017': 382.012,
 '2018': 385.197,
 '2019': 386.864,
 '2020': 388.465,
 '2021': 389.996,
 '2022': 391.421,
 '2023': 392.727,
 '2024': 393.884,
 '2025': 394.873,
 '2026': 395.687,
 '2027': 396.34,
 '2028': 396.842,
 '2029': 397.214,
 '2030': 397.473,
 '2031': 397.632,
 '2032': 397.697,
 '2033': 397.683,
 '2034': 397.611,
 '2035': 397.508},
{'Index': 73,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20355,
 'Urban Agglomeration': 'Vitebsk',
 'Note': '',
 'Latitude': 55.19048,
 'Longitude': 30.2033,
 '1950': 105.116,
 '1951': 109.438,
 '1952': 113.943,
 '1953': 118.621,
 '1954': 123.498,
 '1955': 128.575,
 '1956': 133.869,
 '1957': 139.364,
 '1958': 145.094,
 '1959': 151.059,
 '1960': 157.278,
 '1961': 163.735,
 '1962': 170.466,
 '1963': 177.475,
 '1964': 184.781,
 '1965': 192.367,
 '1966': 200.276,
 '1967': 208.509,
 '1968': 217.094,
 '1969': 226.006,
 '1970': 233.97,
 '1971': 240.596,
 '1972': 247.418,
 '1973': 254.415,
 '1974': 261.619,
 '1975': 269.027,
 '1976': 276.656,
 '1977': 284.479,
 '1978': 292.535,
 '1979': 299.14,
 '1980': 303.879,
 '1981': 308.679,
 '1982': 313.562,
 '1983': 318.522,
 '1984': 323.568,
 '1985': 328.679,
 '1986': 333.878,
 '1987': 339.16,
 '1988': 344.532,
 '1989': 347.113,
 '1990': 346.443,
 '1991': 345.774,
 '1992': 345.105,
 '1993': 344.439,
 '1994': 343.774,
 '1995': 343.11,
 '1996': 342.446,
 '1997': 341.786,
 '1998': 341.125,
 '1999': 340.837,
 '2000': 341.18,
 '2001': 341.522,
 '2002': 341.865,
 '2003': 342.209,
 '2004': 342.857,
 '2005': 343.809,
 '2006': 344.765,
 '2007': 345.724,
 '2008': 346.687,
 '2009': 347.65,
 '2010': 350.041,
 '2011': 353.028,
 '2012': 356.045,
 '2013': 359.079,
 '2014': 362.144,
 '2015': 365.235,
 '2016': 368.356,
 '2017': 371.495,
 '2018': 374.661,
 '2019': 376.348,
 '2020': 377.966,
 '2021': 379.509,
 '2022': 380.941,
 '2023': 382.248,
 '2024': 383.402,
 '2025': 384.385,
 '2026': 385.191,
 '2027': 385.835,
 '2028': 386.329,
 '2029': 386.694,
 '2030': 386.948,
 '2031': 387.103,
 '2032': 387.166,
 '2033': 387.153,
 '2034': 387.083,
 '2035': 386.983},
{'Index': 74,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20142,
 'Urban Agglomeration': 'Antwerpen',
 'Note': '',
 'Latitude': 51.21989,
 'Longitude': 4.40346,
 '1950': 758.931,
 '1951': 764.178,
 '1952': 769.468,
 '1953': 774.78,
 '1954': 780.136,
 '1955': 785.529,
 '1956': 790.967,
 '1957': 796.428,
 '1958': 801.934,
 '1959': 807.477,
 '1960': 813.067,
 '1961': 818.68,
 '1962': 823.44,
 '1963': 827.318,
 '1964': 831.22,
 '1965': 835.13,
 '1966': 839.064,
 '1967': 843.015,
 '1968': 846.992,
 '1969': 850.975,
 '1970': 854.983,
 '1971': 858.211,
 '1972': 860.648,
 '1973': 863.085,
 '1974': 865.532,
 '1975': 867.986,
 '1976': 870.451,
 '1977': 872.915,
 '1978': 875.391,
 '1979': 877.873,
 '1980': 880.365,
 '1981': 882.923,
 '1982': 885.623,
 '1983': 888.33,
 '1984': 891.05,
 '1985': 893.77,
 '1986': 896.502,
 '1987': 899.243,
 '1988': 901.996,
 '1989': 904.75,
 '1990': 907.516,
 '1991': 910.29,
 '1992': 913.077,
 '1993': 915.865,
 '1994': 918.665,
 '1995': 922.311,
 '1996': 926.843,
 '1997': 931.384,
 '1998': 935.954,
 '1999': 940.547,
 '2000': 945.168,
 '2001': 949.8,
 '2002': 954.46,
 '2003': 959.144,
 '2004': 963.857,
 '2005': 968.58,
 '2006': 973.332,
 '2007': 978.108,
 '2008': 982.914,
 '2009': 987.731,
 '2010': 992.577,
 '2011': 997.448,
 '2012': 1002.349,
 '2013': 1007.26,
 '2014': 1012.203,
 '2015': 1017.17,
 '2016': 1022.168,
 '2017': 1027.176,
 '2018': 1032.209,
 '2019': 1037.311,
 '2020': 1042.471,
 '2021': 1047.613,
 '2022': 1052.622,
 '2023': 1057.215,
 '2024': 1061.089,
 '2025': 1064.868,
 '2026': 1068.656,
 '2027': 1072.439,
 '2028': 1076.221,
 '2029': 1079.947,
 '2030': 1083.549,
 '2031': 1087.008,
 '2032': 1090.354,
 '2033': 1093.594,
 '2034': 1096.732,
 '2035': 1099.766},
{'Index': 75,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20144,
 'Urban Agglomeration': 'Bruxelles-Brussel',
 'Note': 25.0,
 'Latitude': 50.846735,
 'Longitude': 4.349919,
 '1950': 1414.671,
 '1951': 1421.519,
 '1952': 1428.41,
 '1953': 1435.316,
 '1954': 1442.264,
 '1955': 1449.246,
 '1956': 1456.271,
 '1957': 1463.312,
 '1958': 1470.395,
 '1959': 1477.514,
 '1960': 1484.676,
 '1961': 1491.853,
 '1962': 1499.611,
 '1963': 1507.95,
 '1964': 1516.347,
 '1965': 1524.767,
 '1966': 1533.246,
 '1967': 1541.772,
 '1968': 1550.357,
 '1969': 1558.966,
 '1970': 1567.635,
 '1971': 1576.19,
 '1972': 1584.639,
 '1973': 1593.109,
 '1974': 1601.636,
 '1975': 1610.209,
 '1976': 1618.84,
 '1977': 1627.493,
 '1978': 1636.205,
 '1979': 1644.963,
 '1980': 1653.78,
 '1981': 1660.926,
 '1982': 1664.73,
 '1983': 1668.543,
 '1984': 1672.369,
 '1985': 1676.195,
 '1986': 1680.034,
 '1987': 1683.882,
 '1988': 1687.744,
 '1989': 1691.604,
 '1990': 1695.478,
 '1991': 1699.362,
 '1992': 1703.259,
 '1993': 1707.155,
 '1994': 1711.065,
 '1995': 1714.984,
 '1996': 1728.342,
 '1997': 1741.767,
 '1998': 1755.315,
 '1999': 1768.968,
 '2000': 1782.747,
 '2001': 1796.594,
 '2002': 1810.568,
 '2003': 1824.651,
 '2004': 1838.864,
 '2005': 1853.147,
 '2006': 1867.561,
 '2007': 1882.088,
 '2008': 1896.747,
 '2009': 1911.48,
 '2010': 1926.348,
 '2011': 1941.332,
 '2012': 1956.453,
 '2013': 1971.65,
 '2014': 1986.986,
 '2015': 2002.441,
 '2016': 2018.038,
 '2017': 2033.713,
 '2018': 2049.51,
 '2019': 2065.284,
 '2020': 2080.788,
 '2021': 2095.688,
 '2022': 2109.631,
 '2023': 2121.992,
 '2024': 2132.178,
 '2025': 2141.515,
 '2026': 2150.324,
 '2027': 2158.701,
 '2028': 2166.775,
 '2029': 2174.536,
 '2030': 2181.923,
 '2031': 2188.953,
 '2032': 2195.72,
 '2033': 2202.258,
 '2034': 2208.581,
 '2035': 2214.691},
{'Index': 76,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20145,
 'Urban Agglomeration': 'Charleroi',
 'Note': '',
 'Latitude': 50.41136,
 'Longitude': 4.44448,
 '1950': 412.9,
 '1951': 413.292,
 '1952': 413.684,
 '1953': 414.076,
 '1954': 414.468,
 '1955': 414.861,
 '1956': 415.255,
 '1957': 415.648,
 '1958': 416.042,
 '1959': 416.437,
 '1960': 416.832,
 '1961': 417.227,
 '1962': 417.622,
 '1963': 418.018,
 '1964': 418.415,
 '1965': 418.811,
 '1966': 419.208,
 '1967': 419.606,
 '1968': 420.004,
 '1969': 420.401,
 '1970': 420.8,
 '1971': 420.385,
 '1972': 419.153,
 '1973': 417.928,
 '1974': 416.705,
 '1975': 415.486,
 '1976': 414.268,
 '1977': 413.058,
 '1978': 411.849,
 '1979': 410.644,
 '1980': 409.44,
 '1981': 408.244,
 '1982': 407.049,
 '1983': 405.858,
 '1984': 404.669,
 '1985': 403.486,
 '1986': 402.305,
 '1987': 401.128,
 '1988': 399.953,
 '1989': 398.784,
 '1990': 397.617,
 '1991': 396.453,
 '1992': 395.292,
 '1993': 394.136,
 '1994': 392.983,
 '1995': 391.833,
 '1996': 392.667,
 '1997': 393.501,
 '1998': 394.338,
 '1999': 395.177,
 '2000': 396.018,
 '2001': 396.859,
 '2002': 397.703,
 '2003': 398.549,
 '2004': 399.398,
 '2005': 400.246,
 '2006': 401.097,
 '2007': 401.95,
 '2008': 402.806,
 '2009': 403.662,
 '2010': 404.52,
 '2011': 405.38,
 '2012': 406.243,
 '2013': 407.106,
 '2014': 407.972,
 '2015': 408.84,
 '2016': 409.71,
 '2017': 410.58,
 '2018': 411.452,
 '2019': 412.389,
 '2020': 413.429,
 '2021': 414.576,
 '2022': 415.807,
 '2023': 417.018,
 '2024': 418.087,
 '2025': 419.244,
 '2026': 420.51,
 '2027': 421.853,
 '2028': 423.253,
 '2029': 424.67,
 '2030': 426.06,
 '2031': 427.408,
 '2032': 428.718,
 '2033': 429.99,
 '2034': 431.223,
 '2035': 432.416},
{'Index': 77,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20146,
 'Urban Agglomeration': 'Gent',
 'Note': '',
 'Latitude': 51.05,
 'Longitude': 3.71667,
 '1950': 362.075,
 '1951': 362.259,
 '1952': 362.443,
 '1953': 362.626,
 '1954': 362.81,
 '1955': 362.995,
 '1956': 363.179,
 '1957': 363.363,
 '1958': 363.548,
 '1959': 363.732,
 '1960': 363.917,
 '1961': 364.101,
 '1962': 363.848,
 '1963': 363.155,
 '1964': 362.463,
 '1965': 361.774,
 '1966': 361.085,
 '1967': 360.397,
 '1968': 359.71,
 '1969': 359.026,
 '1970': 358.342,
 '1971': 358.628,
 '1972': 359.893,
 '1973': 361.159,
 '1974': 362.432,
 '1975': 363.708,
 '1976': 364.991,
 '1977': 366.275,
 '1978': 367.565,
 '1979': 368.86,
 '1980': 370.161,
 '1981': 371.503,
 '1982': 372.929,
 '1983': 374.362,
 '1984': 375.801,
 '1985': 377.242,
 '1986': 378.691,
 '1987': 380.146,
 '1988': 381.607,
 '1989': 383.071,
 '1990': 384.542,
 '1991': 386.019,
 '1992': 387.503,
 '1993': 388.99,
 '1994': 390.483,
 '1995': 391.983,
 '1996': 394.726,
 '1997': 397.48,
 '1998': 400.258,
 '1999': 403.055,
 '2000': 405.875,
 '2001': 408.707,
 '2002': 411.563,
 '2003': 414.439,
 '2004': 417.339,
 '2005': 420.251,
 '2006': 423.188,
 '2007': 426.145,
 '2008': 429.127,
 '2009': 432.121,
 '2010': 435.141,
 '2011': 438.182,
 '2012': 441.248,
 '2013': 444.327,
 '2014': 447.432,
 '2015': 450.558,
 '2016': 453.711,
 '2017': 456.877,
 '2018': 460.065,
 '2019': 463.257,
 '2020': 466.412,
 '2021': 469.466,
 '2022': 472.348,
 '2023': 474.921,
 '2024': 477.052,
 '2025': 479.034,
 '2026': 480.931,
 '2027': 482.758,
 '2028': 484.535,
 '2029': 486.255,
 '2030': 487.898,
 '2031': 489.466,
 '2032': 490.977,
 '2033': 492.439,
 '2034': 493.852,
 '2035': 495.218},
{'Index': 78,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20148,
 'Urban Agglomeration': 'Liège',
 'Note': '',
 'Latitude': 50.63373,
 'Longitude': 5.56749,
 '1950': 602.056,
 '1951': 604.001,
 '1952': 605.954,
 '1953': 607.909,
 '1954': 609.872,
 '1955': 611.842,
 '1956': 613.821,
 '1957': 615.8,
 '1958': 617.789,
 '1959': 619.785,
 '1960': 621.789,
 '1961': 623.795,
 '1962': 624.481,
 '1963': 623.834,
 '1964': 623.186,
 '1965': 622.541,
 '1966': 621.896,
 '1967': 621.252,
 '1968': 620.607,
 '1969': 619.964,
 '1970': 619.322,
 '1971': 619.691,
 '1972': 621.08,
 '1973': 622.469,
 '1974': 623.863,
 '1975': 625.259,
 '1976': 626.661,
 '1977': 628.063,
 '1978': 629.469,
 '1979': 630.878,
 '1980': 632.293,
 '1981': 633.144,
 '1982': 632.879,
 '1983': 632.613,
 '1984': 632.347,
 '1985': 632.082,
 '1986': 631.817,
 '1987': 631.552,
 '1988': 631.287,
 '1989': 631.023,
 '1990': 630.758,
 '1991': 630.493,
 '1992': 630.228,
 '1993': 629.964,
 '1994': 629.7,
 '1995': 629.436,
 '1996': 631.287,
 '1997': 633.138,
 '1998': 634.997,
 '1999': 636.862,
 '2000': 638.735,
 '2001': 640.608,
 '2002': 642.489,
 '2003': 644.375,
 '2004': 646.27,
 '2005': 648.165,
 '2006': 650.069,
 '2007': 651.977,
 '2008': 653.895,
 '2009': 655.812,
 '2010': 657.738,
 '2011': 659.669,
 '2012': 661.609,
 '2013': 663.549,
 '2014': 665.498,
 '2015': 667.452,
 '2016': 669.414,
 '2017': 671.377,
 '2018': 673.346,
 '2019': 675.403,
 '2020': 677.589,
 '2021': 679.895,
 '2022': 682.272,
 '2023': 684.549,
 '2024': 686.523,
 '2025': 688.582,
 '2026': 690.769,
 '2027': 693.045,
 '2028': 695.387,
 '2029': 697.738,
 '2030': 700.035,
 '2031': 702.255,
 '2032': 704.411,
 '2033': 706.502,
 '2034': 708.528,
 '2035': 710.487}]},
'Cities Over 300K': {'headers': ['Index',
'Country Code',
'Country or area',
'City Code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20001,
 'Urban Agglomeration': 'Herat',
 'Note': '',
 'Latitude': 34.34817,
 'Longitude': 62.19967,
 '1950': 82.468,
 '1955': 85.751,
 '1960': 89.166,
 '1965': 92.715,
 '1970': 101.576,
 '1975': 120.323,
 '1980': 143.859,
 '1985': 162.457,
 '1990': 183.465,
 '1995': 207.19,
 '2000': 233.991,
 '2005': 275.678,
 '2010': 358.691,
 '2015': 466.703,
 '2020': 605.575,
 '2025': 752.91,
 '2030': 897.041,
 '2035': 1057.573},
{'Index': 2,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20002,
 'Urban Agglomeration': 'Kabul',
 'Note': '',
 'Latitude': 34.528887,
 'Longitude': 69.17246,
 '1950': 170.784,
 '1955': 220.749,
 '1960': 285.352,
 '1965': 368.809,
 '1970': 471.891,
 '1975': 674.254,
 '1980': 977.824,
 '1985': 1239.961,
 '1990': 1549.32,
 '1995': 1928.694,
 '2000': 2401.109,
 '2005': 2905.178,
 '2010': 3289.005,
 '2015': 3723.543,
 '2020': 4221.532,
 '2025': 4877.024,
 '2030': 5737.138,
 '2035': 6760.5},
{'Index': 3,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20003,
 'Urban Agglomeration': 'Kandahar',
 'Note': '',
 'Latitude': 31.61332,
 'Longitude': 65.71013,
 '1950': 82.199,
 '1955': 89.785,
 '1960': 98.074,
 '1965': 107.123,
 '1970': 127.164,
 '1975': 154.012,
 '1980': 182.904,
 '1985': 206.542,
 '1990': 233.243,
 '1995': 263.395,
 '2000': 297.456,
 '2005': 336.746,
 '2010': 383.498,
 '2015': 436.741,
 '2020': 498.002,
 '2025': 577.128,
 '2030': 679.278,
 '2035': 800.461},
{'Index': 4,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20004,
 'Urban Agglomeration': 'Mazar-e Sharif',
 'Note': '',
 'Latitude': 36.70904,
 'Longitude': 67.11087,
 '1950': 30.0,
 '1955': 37.139,
 '1960': 45.979,
 '1965': 56.916,
 '1970': 70.46,
 '1975': 87.226,
 '1980': 105.977,
 '1985': 119.677,
 '1990': 135.153,
 '1995': 152.629,
 '2000': 172.372,
 '2005': 206.403,
 '2010': 283.532,
 '2015': 389.483,
 '2020': 532.689,
 '2025': 681.531,
 '2030': 816.04,
 '2035': 962.262},
{'Index': 5,
 'Country Code': 8,
 'Country or area': 'Albania',
 'City Code': 20005,
 'Urban Agglomeration': 'Tiranë (Tirana)',
 'Note': '',
 'Latitude': 41.3275,
 'Longitude': 19.81889,
 '1950': 84.513,
 '1955': 106.932,
 '1960': 134.761,
 '1965': 145.255,
 '1970': 156.734,
 '1975': 173.975,
 '1980': 193.644,
 '1985': 217.882,
 '1990': 247.27,
 '1995': 287.95,
 '2000': 335.336,
 '2005': 371.803,
 '2010': 408.697,
 '2015': 449.298,
 '2020': 493.712,
 '2025': 535.702,
 '2030': 565.301,
 '2035': 581.626},
{'Index': 6,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20009,
 'Urban Agglomeration': 'Annaba',
 'Note': '',
 'Latitude': 36.9,
 'Longitude': 7.76667,
 '1950': 99.741,
 '1955': 116.444,
 '1960': 135.95,
 '1965': 158.709,
 '1970': 192.064,
 '1975': 233.928,
 '1980': 266.91,
 '1985': 295.148,
 '1990': 312.885,
 '1995': 324.437,
 '2000': 333.805,
 '2005': 339.492,
 '2010': 345.278,
 '2015': 351.158,
 '2020': 358.241,
 '2025': 379.346,
 '2030': 410.307,
 '2035': 439.473},
{'Index': 7,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20011,
 'Urban Agglomeration': 'Batna',
 'Note': '',
 'Latitude': 35.55597,
 'Longitude': 6.17414,
 '1950': 13.046,
 '1955': 20.683,
 '1960': 32.794,
 '1965': 51.985,
 '1970': 70.787,
 '1975': 93.803,
 '1980': 124.347,
 '1985': 164.835,
 '1990': 197.568,
 '1995': 224.63,
 '2000': 249.379,
 '2005': 267.234,
 '2010': 286.372,
 '2015': 306.88,
 '2020': 329.333,
 '2025': 358.478,
 '2030': 389.593,
 '2035': 417.363},
{'Index': 8,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20015,
 'Urban Agglomeration': 'Blida',
 'Note': '',
 'Latitude': 36.480781,
 'Longitude': 2.831943,
 '1950': 33.97,
 '1955': 45.99,
 '1960': 62.269,
 '1965': 84.296,
 '1970': 104.497,
 '1975': 127.513,
 '1980': 146.825,
 '1985': 164.415,
 '1990': 190.852,
 '1995': 225.742,
 '2000': 264.604,
 '2005': 305.978,
 '2010': 353.834,
 '2015': 409.179,
 '2020': 472.733,
 '2025': 535.641,
 '2030': 586.199,
 '2035': 628.153},
{'Index': 9,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20006,
 'Urban Agglomeration': 'El Djazaïr  (Algiers)',
 'Note': 1.0,
 'Latitude': 36.7525,
 'Longitude': 3.04197,
 '1950': 516.45,
 '1955': 622.921,
 '1960': 871.636,
 '1965': 1081.394,
 '1970': 1281.127,
 '1975': 1506.658,
 '1980': 1621.442,
 '1985': 1672.335,
 '1990': 1797.068,
 '1995': 1973.014,
 '2000': 2140.577,
 '2005': 2281.632,
 '2010': 2432.023,
 '2015': 2592.33,
 '2020': 2767.661,
 '2025': 3004.133,
 '2030': 3263.293,
 '2035': 3495.835},
{'Index': 10,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20020,
 'Urban Agglomeration': 'El Djelfa',
 'Note': '',
 'Latitude': 34.67279,
 'Longitude': 3.263,
 '1950': 10.45,
 '1955': 13.884,
 '1960': 18.448,
 '1965': 24.509,
 '1970': 32.563,
 '1975': 43.265,
 '1980': 57.488,
 '1985': 76.375,
 '1990': 101.274,
 '1995': 134.151,
 '2000': 176.441,
 '2005': 229.567,
 '2010': 298.71,
 '2015': 388.677,
 '2020': 503.397,
 '2025': 606.968,
 '2030': 671.455,
 '2035': 719.812},
{'Index': 11,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20019,
 'Urban Agglomeration': 'Qacentina',
 'Note': '',
 'Latitude': 36.354921,
 'Longitude': 6.607293,
 '1950': 88.001,
 '1955': 121.878,
 '1960': 168.811,
 '1965': 233.775,
 '1970': 280.65,
 '1975': 328.417,
 '1980': 375.749,
 '1985': 425.251,
 '1990': 453.758,
 '1995': 469.476,
 '2000': 472.556,
 '2005': 456.656,
 '2010': 441.286,
 '2015': 426.43,
 '2020': 414.011,
 '2025': 426.746,
 '2030': 459.425,
 '2035': 491.992},
{'Index': 12,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20037,
 'Urban Agglomeration': 'Sétif',
 'Note': '',
 'Latitude': 36.19112,
 'Longitude': 5.41373,
 '1950': 41.289,
 '1955': 52.534,
 '1960': 66.846,
 '1965': 85.045,
 '1970': 102.559,
 '1975': 122.499,
 '1980': 142.093,
 '1985': 162.509,
 '1990': 181.397,
 '1995': 199.918,
 '2000': 219.584,
 '2005': 239.954,
 '2010': 262.221,
 '2015': 286.552,
 '2020': 313.401,
 '2025': 344.671,
 '2030': 375.258,
 '2035': 402.034},
{'Index': 13,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20035,
 'Urban Agglomeration': 'Wahran (Oran)',
 'Note': '',
 'Latitude': 35.69111,
 'Longitude': -0.64167,
 '1950': 268.935,
 '1955': 286.368,
 '1960': 304.936,
 '1965': 324.697,
 '1970': 385.189,
 '1975': 465.87,
 '1980': 536.561,
 '1985': 603.626,
 '1990': 657.905,
 '1995': 705.268,
 '2000': 748.693,
 '2005': 783.334,
 '2010': 819.588,
 '2015': 857.521,
 '2020': 899.182,
 '2025': 966.494,
 '2030': 1048.089,
 '2035': 1122.702},
{'Index': 14,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000001,
 'Urban Agglomeration': 'Benguela',
 'Note': 2.0,
 'Latitude': -12.576,
 'Longitude': 13.405,
 '1950': 14.364,
 '1955': 18.085,
 '1960': 22.77,
 '1965': 30.067,
 '1970': 39.917,
 '1975': 66.332,
 '1980': 112.763,
 '1985': 168.354,
 '1990': 206.991,
 '1995': 254.496,
 '2000': 312.921,
 '2005': 384.715,
 '2010': 473.008,
 '2015': 581.564,
 '2020': 715.13,
 '2025': 878.004,
 '2030': 1065.572,
 '2035': 1273.636},
{'Index': 15,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204043,
 'Urban Agglomeration': 'Cabinda',
 'Note': 3.0,
 'Latitude': -5.55,
 'Longitude': 12.2,
 '1950': 4.722,
 '1955': 4.663,
 '1960': 4.606,
 '1965': 9.16,
 '1970': 19.695,
 '1975': 32.345,
 '1980': 51.706,
 '1985': 82.634,
 '1990': 132.079,
 '1995': 195.473,
 '2000': 257.777,
 '2005': 339.887,
 '2010': 448.187,
 '2015': 590.993,
 '2020': 777.697,
 '2025': 990.695,
 '2030': 1210.051,
 '2035': 1446.685},
{'Index': 16,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000011,
 'Urban Agglomeration': 'Cuito',
 'Note': '',
 'Latitude': -12.383,
 'Longitude': 16.933,
 '1950': 8.632,
 '1955': 10.46,
 '1960': 12.676,
 '1965': 15.359,
 '1970': 18.611,
 '1975': 25.741,
 '1980': 36.084,
 '1985': 50.572,
 '1990': 70.885,
 '1995': 99.357,
 '2000': 139.278,
 '2005': 195.202,
 '2010': 273.607,
 '2015': 383.504,
 '2020': 535.407,
 '2025': 704.349,
 '2030': 865.116,
 '2035': 1034.52},
{'Index': 17,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20050,
 'Urban Agglomeration': 'Huambo',
 'Note': 4.0,
 'Latitude': -12.77611,
 'Longitude': 15.73917,
 '1950': 15.306,
 '1955': 23.818,
 '1960': 37.069,
 '1965': 47.875,
 '1970': 60.567,
 '1975': 95.155,
 '1980': 152.811,
 '1985': 232.492,
 '1990': 326.355,
 '1995': 415.532,
 '2000': 457.066,
 '2005': 502.724,
 '2010': 552.957,
 '2015': 608.21,
 '2020': 671.413,
 '2025': 777.336,
 '2030': 933.847,
 '2035': 1115.75},
{'Index': 18,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000000,
 'Urban Agglomeration': 'Lobito',
 'Note': 5.0,
 'Latitude': -12.364,
 'Longitude': 13.536,
 '1950': 23.027,
 '1955': 33.373,
 '1960': 48.371,
 '1965': 54.219,
 '1970': 59.064,
 '1975': 83.193,
 '1980': 120.263,
 '1985': 158.694,
 '1990': 182.698,
 '1995': 210.333,
 '2000': 242.157,
 '2005': 278.774,
 '2010': 320.941,
 '2015': 369.487,
 '2020': 426.31,
 '2025': 505.576,
 '2030': 609.908,
 '2035': 728.829},
{'Index': 19,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20049,
 'Urban Agglomeration': 'Luanda',
 'Note': 6.0,
 'Latitude': -8.83682,
 'Longitude': 13.23432,
 '1950': 138.413,
 '1955': 174.268,
 '1960': 219.427,
 '1965': 315.108,
 '1970': 459.225,
 '1975': 598.504,
 '1980': 771.349,
 '1985': 1034.661,
 '1990': 1473.848,
 '1995': 2066.306,
 '2000': 2828.82,
 '2005': 3872.05,
 '2010': 5300.466,
 '2015': 7023.206,
 '2020': 8329.798,
 '2025': 10027.897,
 '2030': 12128.764,
 '2035': 14495.112},
{'Index': 20,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204044,
 'Urban Agglomeration': 'Lubango',
 'Note': 7.0,
 'Latitude': -14.91717,
 'Longitude': 13.4925,
 '1950': 11.555,
 '1955': 13.09,
 '1960': 14.83,
 '1965': 21.039,
 '1970': 30.606,
 '1975': 45.917,
 '1980': 69.11,
 '1985': 103.993,
 '1990': 156.502,
 '1995': 222.227,
 '2000': 289.231,
 '2005': 376.382,
 '2010': 489.83,
 '2015': 637.473,
 '2020': 828.248,
 '2025': 1047.806,
 '2030': 1278.271,
 '2035': 1528.175},
{'Index': 21,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000004,
 'Urban Agglomeration': 'Malanje',
 'Note': 8.0,
 'Latitude': -9.54,
 'Longitude': 16.341,
 '1950': 9.176,
 '1955': 12.976,
 '1960': 18.353,
 '1965': 23.91,
 '1970': 30.869,
 '1975': 41.795,
 '1980': 56.864,
 '1985': 77.354,
 '1990': 105.235,
 '1995': 143.166,
 '2000': 194.785,
 '2005': 264.972,
 '2010': 360.478,
 '2015': 490.41,
 '2020': 665.15,
 '2025': 861.38,
 '2030': 1055.109,
 '2035': 1261.582},
{'Index': 22,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000012,
 'Urban Agglomeration': 'Uige',
 'Note': '',
 'Latitude': -7.1069,
 'Longitude': 15.4406,
 '1950': 3.201,
 '1955': 4.418,
 '1960': 6.1,
 '1965': 8.42,
 '1970': 11.624,
 '1975': 16.898,
 '1980': 24.694,
 '1985': 36.082,
 '1990': 52.725,
 '1995': 77.045,
 '2000': 112.596,
 '2005': 164.516,
 '2010': 240.402,
 '2015': 351.293,
 '2020': 510.631,
 '2025': 686.667,
 '2030': 846.615,
 '2035': 1012.545},
{'Index': 23,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20057,
 'Urban Agglomeration': 'Bahia Blanca',
 'Note': '',
 'Latitude': -38.7196,
 'Longitude': -62.27243,
 '1950': 115.752,
 '1955': 120.954,
 '1960': 126.392,
 '1965': 150.529,
 '1970': 180.515,
 '1975': 200.764,
 '1980': 222.408,
 '1985': 237.224,
 '1990': 252.403,
 '1995': 261.703,
 '2000': 269.873,
 '2005': 283.152,
 '2010': 299.059,
 '2015': 307.351,
 '2020': 315.533,
 '2025': 327.329,
 '2030': 341.833,
 '2035': 355.78},
{'Index': 24,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 9.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 '1950': 5166.14,
 '1955': 5910.271,
 '1960': 6761.837,
 '1965': 7548.511,
 '1970': 8416.17,
 '1975': 9143.219,
 '1980': 9919.781,
 '1985': 10523.442,
 '1990': 11147.566,
 '1995': 11806.407,
 '2000': 12503.871,
 '2005': 13329.54,
 '2010': 14245.871,
 '2015': 14705.533,
 '2020': 15153.729,
 '2025': 15752.275,
 '2030': 16456.115,
 '2035': 17127.741},
{'Index': 25,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20059,
 'Urban Agglomeration': 'Córdoba',
 'Note': 10.0,
 'Latitude': -31.4135,
 'Longitude': -64.18105,
 '1950': 429.249,
 '1955': 509.722,
 '1960': 605.309,
 '1965': 700.581,
 '1970': 809.794,
 '1975': 904.947,
 '1980': 1009.521,
 '1985': 1101.512,
 '1990': 1200.168,
 '1995': 1275.108,
 '2000': 1347.561,
 '2005': 1405.769,
 '2010': 1459.268,
 '2015': 1514.241,
 '2020': 1571.944,
 '2025': 1640.599,
 '2030': 1715.096,
 '2035': 1785.143},
{'Index': 26,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20063,
 'Urban Agglomeration': 'Corrientes',
 'Note': 11.0,
 'Latitude': -27.4806,
 'Longitude': -58.8341,
 '1950': 64.256,
 '1955': 78.753,
 '1960': 96.526,
 '1965': 114.571,
 '1970': 135.77,
 '1975': 156.052,
 '1980': 179.084,
 '1985': 211.517,
 '1990': 250.312,
 '1995': 279.506,
 '2000': 308.31,
 '2005': 332.736,
 '2010': 356.125,
 '2015': 381.158,
 '2020': 407.725,
 '2025': 432.527,
 '2030': 453.448,
 '2035': 472.019},
{'Index': 27,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20065,
 'Urban Agglomeration': 'La Plata',
 'Note': 12.0,
 'Latitude': -34.92145,
 'Longitude': -57.95453,
 '1950': 299.505,
 '1955': 346.637,
 '1960': 401.203,
 '1965': 441.115,
 '1970': 483.711,
 '1975': 521.68,
 '1980': 562.151,
 '1985': 597.15,
 '1990': 633.742,
 '1995': 656.329,
 '2000': 676.227,
 '2005': 723.535,
 '2010': 785.427,
 '2015': 834.021,
 '2020': 884.054,
 '2025': 933.193,
 '2030': 977.488,
 '2035': 1017.488},
{'Index': 28,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20067,
 'Urban Agglomeration': 'Mar Del Plata',
 'Note': '',
 'Latitude': -38.00228,
 'Longitude': -57.55754,
 '1950': 132.415,
 '1955': 166.345,
 '1960': 208.981,
 '1965': 250.52,
 '1970': 299.597,
 '1975': 350.956,
 '1980': 410.692,
 '1985': 458.418,
 '1990': 510.119,
 '1995': 528.249,
 '2000': 538.785,
 '2005': 567.524,
 '2010': 605.216,
 '2015': 635.058,
 '2020': 665.707,
 '2025': 698.471,
 '2030': 730.858,
 '2035': 760.734},
{'Index': 29,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20068,
 'Urban Agglomeration': 'Mendoza',
 'Note': 13.0,
 'Latitude': -32.89084,
 'Longitude': -68.82717,
 '1950': 245.797,
 '1955': 284.087,
 '1960': 328.355,
 '1965': 393.888,
 '1970': 473.447,
 '1975': 537.372,
 '1980': 608.116,
 '1985': 679.577,
 '1990': 758.832,
 '1995': 802.228,
 '2000': 838.384,
 '2005': 903.268,
 '2010': 984.602,
 '2015': 1075.085,
 '2020': 1172.619,
 '2025': 1257.182,
 '2030': 1320.409,
 '2035': 1374.585},
{'Index': 30,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20070,
 'Urban Agglomeration': 'Neuquén-Plottier-Cipolletti',
 'Note': '',
 'Latitude': -38.95143,
 'Longitude': -68.064809,
 '1950': 13.911,
 '1955': 22.575,
 '1960': 36.641,
 '1965': 50.269,
 '1970': 68.369,
 '1975': 96.15,
 '1980': 135.472,
 '1985': 177.85,
 '1990': 232.421,
 '1995': 261.178,
 '2000': 284.298,
 '2005': 310.414,
 '2010': 339.34,
 '2015': 372.569,
 '2020': 408.609,
 '2025': 439.389,
 '2030': 461.726,
 '2035': 480.68},
{'Index': 31,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20072,
 'Urban Agglomeration': 'Posadas',
 'Note': '',
 'Latitude': -27.36708,
 'Longitude': -55.89608,
 '1950': 45.612,
 '1955': 57.742,
 '1960': 73.103,
 '1965': 84.343,
 '1970': 96.844,
 '1975': 117.179,
 '1980': 142.181,
 '1985': 170.658,
 '1990': 204.705,
 '1995': 235.988,
 '2000': 269.792,
 '2005': 295.318,
 '2010': 317.948,
 '2015': 351.554,
 '2020': 388.782,
 '2025': 419.963,
 '2030': 441.659,
 '2035': 459.803},
{'Index': 32,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20073,
 'Urban Agglomeration': 'Resistencia',
 'Note': 14.0,
 'Latitude': -27.46056,
 'Longitude': -58.98389,
 '1950': 72.574,
 '1955': 87.124,
 '1960': 104.597,
 '1965': 121.868,
 '1970': 141.774,
 '1975': 175.199,
 '1980': 217.203,
 '1985': 249.191,
 '1990': 284.448,
 '1995': 316.277,
 '2000': 349.735,
 '2005': 369.943,
 '2010': 384.749,
 '2015': 407.602,
 '2020': 432.25,
 '2025': 456.388,
 '2030': 478.071,
 '2035': 497.635},
{'Index': 33,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20075,
 'Urban Agglomeration': 'Rosario',
 'Note': 15.0,
 'Latitude': -32.94682,
 'Longitude': -60.63932,
 '1950': 554.483,
 '1955': 610.116,
 '1960': 671.349,
 '1965': 740.204,
 '1970': 816.23,
 '1975': 882.638,
 '1980': 953.491,
 '1985': 1016.985,
 '1990': 1083.819,
 '1995': 1121.096,
 '2000': 1152.387,
 '2005': 1225.617,
 '2010': 1320.626,
 '2015': 1422.998,
 '2020': 1532.128,
 '2025': 1631.093,
 '2030': 1711.036,
 '2035': 1781.154},
{'Index': 34,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20076,
 'Urban Agglomeration': 'Salta',
 'Note': '',
 'Latitude': -24.7859,
 'Longitude': -65.41166,
 '1950': 77.248,
 '1955': 95.029,
 '1960': 116.91,
 '1965': 142.84,
 '1970': 174.467,
 '1975': 212.031,
 '1980': 257.628,
 '1985': 303.521,
 '1990': 356.884,
 '1995': 407.241,
 '2000': 461.791,
 '2005': 512.811,
 '2010': 564.977,
 '2015': 622.449,
 '2020': 684.751,
 '2025': 737.555,
 '2030': 775.274,
 '2035': 807.108},
{'Index': 35,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20078,
 'Urban Agglomeration': 'San Juan',
 'Note': 16.0,
 'Latitude': -31.5375,
 'Longitude': -68.53639,
 '1950': 108.151,
 '1955': 126.999,
 '1960': 149.138,
 '1965': 181.149,
 '1970': 220.433,
 '1975': 252.914,
 '1980': 289.297,
 '1985': 322.38,
 '1990': 358.641,
 '1995': 386.51,
 '2000': 413.76,
 '2005': 451.057,
 '2010': 495.172,
 '2015': 516.433,
 '2020': 536.913,
 '2025': 560.819,
 '2030': 586.367,
 '2035': 610.319},
{'Index': 36,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20081,
 'Urban Agglomeration': 'San Miguel de Tucumán',
 'Note': 17.0,
 'Latitude': -26.82414,
 'Longitude': -65.2226,
 '1950': 223.765,
 '1955': 259.559,
 '1960': 301.091,
 '1965': 331.8,
 '1970': 364.67,
 '1975': 423.76,
 '1980': 493.888,
 '1985': 550.171,
 '1990': 611.067,
 '1995': 665.605,
 '2000': 722.052,
 '2005': 781.213,
 '2010': 844.399,
 '2015': 912.695,
 '2020': 985.656,
 '2025': 1051.043,
 '2030': 1102.87,
 '2035': 1148.078},
{'Index': 37,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20084,
 'Urban Agglomeration': 'San Salvador de Jujuy',
 'Note': 18.0,
 'Latitude': -24.19456,
 'Longitude': -65.29712,
 '1950': 33.863,
 '1955': 38.557,
 '1960': 43.904,
 '1965': 59.491,
 '1970': 81.357,
 '1975': 100.704,
 '1980': 124.009,
 '1985': 148.336,
 '1990': 177.107,
 '1995': 215.523,
 '2000': 263.341,
 '2005': 292.81,
 '2010': 314.069,
 '2015': 336.872,
 '2020': 361.106,
 '2025': 383.507,
 '2030': 402.135,
 '2035': 418.608},
{'Index': 38,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20085,
 'Urban Agglomeration': 'Santa Fe',
 'Note': 19.0,
 'Latitude': -31.632717,
 'Longitude': -60.698281,
 '1950': 214.298,
 '1955': 238.639,
 '1960': 265.753,
 '1965': 288.466,
 '1970': 312.707,
 '1975': 347.318,
 '1980': 386.262,
 '1985': 392.174,
 '1990': 395.8,
 '1995': 419.706,
 '2000': 449.732,
 '2005': 473.204,
 '2010': 494.488,
 '2015': 527.351,
 '2020': 562.917,
 '2025': 596.474,
 '2030': 625.199,
 '2035': 650.799},
{'Index': 39,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20086,
 'Urban Agglomeration': 'Santiago Del Estero',
 'Note': 20.0,
 'Latitude': -27.79511,
 'Longitude': -64.26149,
 '1950': 82.652,
 '1955': 92.526,
 '1960': 103.584,
 '1965': 119.696,
 '1970': 138.551,
 '1975': 164.722,
 '1980': 196.12,
 '1985': 225.239,
 '1990': 258.079,
 '1995': 287.666,
 '2000': 318.793,
 '2005': 346.613,
 '2010': 374.141,
 '2015': 403.854,
 '2020': 435.567,
 '2025': 464.131,
 '2030': 486.957,
 '2035': 506.916},
{'Index': 40,
 'Country Code': 51,
 'Country or area': 'Armenia',
 'City Code': 20140,
 'Urban Agglomeration': 'Yerevan',
 'Note': '',
 'Latitude': 40.181998,
 'Longitude': 44.514619,
 '1950': 341.432,
 '1955': 431.494,
 '1960': 537.759,
 '1965': 647.706,
 '1970': 778.158,
 '1975': 911.195,
 '1980': 1041.587,
 '1985': 1122.84,
 '1990': 1174.524,
 '1995': 1142.48,
 '2000': 1111.301,
 '2005': 1087.153,
 '2010': 1065.597,
 '2015': 1071.265,
 '2020': 1086.275,
 '2025': 1100.237,
 '2030': 1113.926,
 '2035': 1130.102},
{'Index': 41,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206171,
 'Urban Agglomeration': 'Adelaide',
 'Note': 21.0,
 'Latitude': -34.92866,
 'Longitude': 138.59863,
 '1950': 429.277,
 '1955': 497.246,
 '1960': 571.822,
 '1965': 696.809,
 '1970': 850.095,
 '1975': 928.6,
 '1980': 971.834,
 '1985': 1023.736,
 '1990': 1081.585,
 '1995': 1111.665,
 '2000': 1121.573,
 '2005': 1154.863,
 '2010': 1221.639,
 '2015': 1283.805,
 '2020': 1336.403,
 '2025': 1392.943,
 '2030': 1471.525,
 '2035': 1553.036},
{'Index': 42,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206170,
 'Urban Agglomeration': 'Brisbane',
 'Note': 21.0,
 'Latitude': -27.46794,
 'Longitude': 153.02809,
 '1950': 441.718,
 '1955': 517.881,
 '1960': 602.999,
 '1965': 698.523,
 '1970': 904.663,
 '1975': 1037.288,
 '1980': 1134.779,
 '1985': 1242.281,
 '1990': 1381.223,
 '1995': 1529.441,
 '2000': 1611.411,
 '2005': 1785.7,
 '2010': 2008.737,
 '2015': 2212.889,
 '2020': 2406.182,
 '2025': 2568.173,
 '2030': 2724.233,
 '2035': 2875.593},
{'Index': 43,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206175,
 'Urban Agglomeration': 'Canberra',
 'Note': 21.0,
 'Latitude': -35.28346,
 'Longitude': 149.12807,
 '1950': 19.921,
 '1955': 31.393,
 '1960': 51.208,
 '1965': 84.411,
 '1970': 137.3,
 '1975': 194.964,
 '1980': 222.885,
 '1985': 251.649,
 '1990': 282.263,
 '1995': 305.308,
 '2000': 343.655,
 '2005': 366.339,
 '2010': 397.692,
 '2015': 428.843,
 '2020': 457.33,
 '2025': 482.986,
 '2030': 511.397,
 '2035': 539.773},
{'Index': 44,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 895000015,
 'Urban Agglomeration': 'Central Coast',
 'Note': 21.0,
 'Latitude': -33.42,
 'Longitude': 151.39583,
 '1950': 71.768,
 '1955': 82.209,
 '1960': 94.172,
 '1965': 107.868,
 '1970': 123.561,
 '1975': 141.536,
 '1980': 162.133,
 '1985': 185.713,
 '1990': 212.73,
 '1995': 243.677,
 '2000': 279.138,
 '2005': 293.644,
 '2010': 310.938,
 '2015': 324.575,
 '2020': 334.922,
 '2025': 347.43,
 '2030': 366.727,
 '2035': 387.028},
{'Index': 45,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20093,
 'Urban Agglomeration': 'Gold Coast-Tweed Head',
 'Note': 21.0,
 'Latitude': -28.00029,
 'Longitude': 153.43088,
 '1950': 29.034,
 '1955': 37.909,
 '1960': 49.5,
 '1965': 64.625,
 '1970': 84.377,
 '1975': 110.167,
 '1980': 143.851,
 '1985': 188.362,
 '1990': 247.026,
 '1995': 314.106,
 '2000': 410.12,
 '2005': 493.649,
 '2010': 566.112,
 '2015': 633.243,
 '2020': 699.226,
 '2025': 752.57,
 '2030': 799.461,
 '2035': 843.927},
{'Index': 46,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206168,
 'Urban Agglomeration': 'Melbourne',
 'Note': 21.0,
 'Latitude': -37.814,
 'Longitude': 144.96332,
 '1950': 1331.966,
 '1955': 1574.414,
 '1960': 1851.22,
 '1965': 2067.735,
 '1970': 2499.109,
 '1975': 2732.059,
 '1980': 2839.019,
 '1985': 2968.593,
 '1990': 3154.314,
 '1995': 3282.619,
 '2000': 3360.804,
 '2005': 3572.504,
 '2010': 3932.257,
 '2015': 4429.931,
 '2020': 4967.733,
 '2025': 5391.886,
 '2030': 5736.197,
 '2035': 6055.588},
{'Index': 47,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206177,
 'Urban Agglomeration': 'Newcastle-Maitland',
 'Note': 21.0,
 'Latitude': -32.924878,
 'Longitude': 151.740852,
 '1950': 160.911,
 '1955': 182.232,
 '1960': 203.995,
 '1965': 228.679,
 '1970': 246.99,
 '1975': 260.432,
 '1980': 290.283,
 '1985': 297.15,
 '1990': 308.226,
 '1995': 317.275,
 '2000': 365.45,
 '2005': 389.265,
 '2010': 410.826,
 '2015': 431.99,
 '2020': 450.36,
 '2025': 469.794,
 '2030': 496.367,
 '2035': 523.865},
{'Index': 48,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206172,
 'Urban Agglomeration': 'Perth',
 'Note': 21.0,
 'Latitude': -31.947841,
 'Longitude': 115.852514,
 '1950': 310.759,
 '1955': 358.088,
 '1960': 409.131,
 '1965': 482.918,
 '1970': 687.856,
 '1975': 824.529,
 '1980': 921.623,
 '1985': 1047.761,
 '1990': 1194.665,
 '1995': 1319.095,
 '2000': 1406.935,
 '2005': 1510.773,
 '2010': 1722.319,
 '2015': 1894.246,
 '2020': 2041.959,
 '2025': 2169.192,
 '2030': 2299.13,
 '2035': 2426.794},
{'Index': 49,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20098,
 'Urban Agglomeration': 'Sunshine Coast',
 'Note': 21.0,
 'Latitude': -26.66008,
 'Longitude': 153.09953,
 '1950': 9.882,
 '1955': 14.167,
 '1960': 20.312,
 '1965': 29.117,
 '1970': 41.742,
 '1975': 59.842,
 '1980': 85.798,
 '1985': 111.21,
 '1990': 151.196,
 '1995': 198.247,
 '2000': 212.311,
 '2005': 243.509,
 '2010': 274.9,
 '2015': 309.778,
 '2020': 346.829,
 '2025': 376.114,
 '2030': 400.071,
 '2035': 422.345},
{'Index': 50,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206167,
 'Urban Agglomeration': 'Sydney',
 'Note': 21.0,
 'Latitude': -33.86785,
 'Longitude': 151.20732,
 '1950': 1689.935,
 '1955': 1905.976,
 '1960': 2134.673,
 '1965': 2390.224,
 '1970': 2892.477,
 '1975': 3117.906,
 '1980': 3252.111,
 '1985': 3432.435,
 '1990': 3631.94,
 '1995': 3819.26,
 '2000': 3779.704,
 '2005': 3874.825,
 '2010': 4165.739,
 '2015': 4544.293,
 '2020': 4925.987,
 '2025': 5248.788,
 '2030': 5566.118,
 '2035': 5875.309},
{'Index': 51,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20101,
 'Urban Agglomeration': 'Wollongong',
 'Note': 21.0,
 'Latitude': -34.424,
 'Longitude': 150.89345,
 '1950': 73.477,
 '1955': 95.821,
 '1960': 124.968,
 '1965': 156.099,
 '1970': 181.237,
 '1975': 205.836,
 '1980': 227.199,
 '1985': 232.68,
 '1990': 242.479,
 '1995': 253.541,
 '2000': 259.669,
 '2005': 264.844,
 '2010': 278.475,
 '2015': 292.825,
 '2020': 305.329,
 '2025': 318.535,
 '2030': 336.557,
 '2035': 355.202},
{'Index': 52,
 'Country Code': 40,
 'Country or area': 'Austria',
 'City Code': 20107,
 'Urban Agglomeration': 'Wien (Vienna)',
 'Note': '',
 'Latitude': 48.206443,
 'Longitude': 16.370725,
 '1950': 1615.058,
 '1955': 1620.88,
 '1960': 1626.724,
 '1965': 1624.321,
 '1970': 1620.537,
 '1975': 1582.652,
 '1980': 1538.78,
 '1985': 1534.855,
 '1990': 1539.106,
 '1995': 1544.082,
 '2000': 1549.227,
 '2005': 1640.995,
 '2010': 1730.649,
 '2015': 1834.982,
 '2020': 1929.944,
 '2025': 2005.497,
 '2030': 2079.587,
 '2035': 2153.584},
{'Index': 53,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20053,
 'Urban Agglomeration': 'Baku',
 'Note': 22.0,
 'Latitude': 40.37767,
 'Longitude': 49.89201,
 '1950': 896.761,
 '1955': 939.529,
 '1960': 1005.297,
 '1965': 1132.029,
 '1970': 1274.298,
 '1975': 1429.085,
 '1980': 1574.287,
 '1985': 1660.424,
 '1990': 1733.452,
 '1995': 1765.543,
 '2000': 1805.977,
 '2005': 1867.301,
 '2010': 2061.843,
 '2015': 2206.32,
 '2020': 2341.443,
 '2025': 2496.495,
 '2030': 2659.07,
 '2035': 2821.01},
{'Index': 54,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20054,
 'Urban Agglomeration': 'Gäncä',
 'Note': '',
 'Latitude': 40.68278,
 'Longitude': 46.36056,
 '1950': 108.093,
 '1955': 112.653,
 '1960': 123.845,
 '1965': 154.974,
 '1970': 191.939,
 '1975': 214.461,
 '1980': 237.976,
 '1985': 259.646,
 '1990': 279.417,
 '1995': 290.868,
 '2000': 300.343,
 '2005': 305.878,
 '2010': 315.331,
 '2015': 327.548,
 '2020': 340.912,
 '2025': 359.663,
 '2030': 382.382,
 '2035': 405.641},
{'Index': 55,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20056,
 'Urban Agglomeration': 'Sumquayit',
 'Note': '',
 'Latitude': 40.58972,
 'Longitude': 49.66861,
 '1950': 20.232,
 '1955': 35.156,
 '1960': 58.353,
 '1965': 86.61,
 '1970': 126.719,
 '1975': 160.622,
 '1980': 195.437,
 '1985': 215.274,
 '1990': 237.534,
 '1995': 263.171,
 '2000': 285.714,
 '2005': 295.697,
 '2010': 313.0,
 '2015': 332.764,
 '2020': 354.086,
 '2025': 378.08,
 '2030': 402.803,
 '2035': 427.338},
{'Index': 56,
 'Country Code': 48,
 'Country or area': 'Bahrain',
 'City Code': 20109,
 'Urban Agglomeration': 'Al-Manamah (Manama)',
 'Note': 23.0,
 'Latitude': 26.21536,
 'Longitude': 50.5832,
 '1950': 40.283,
 '1955': 51.287,
 '1960': 64.888,
 '1965': 79.697,
 '1970': 88.061,
 '1975': 99.494,
 '1980': 112.862,
 '1985': 119.896,
 '1990': 125.875,
 '1995': 133.33,
 '2000': 141.707,
 '2005': 198.37,
 '2010': 292.172,
 '2015': 440.935,
 '2020': 634.508,
 '2025': 743.066,
 '2030': 817.889,
 '2035': 869.902},
{'Index': 57,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20110,
 'Urban Agglomeration': 'Barisal',
 'Note': '',
 'Latitude': 22.70194,
 'Longitude': 90.37111,
 '1950': 71.139,
 '1955': 77.044,
 '1960': 83.441,
 '1965': 94.421,
 '1970': 107.475,
 '1975': 128.338,
 '1980': 174.827,
 '1985': 196.964,
 '1990': 215.428,
 '1995': 231.261,
 '2000': 247.517,
 '2005': 290.137,
 '2010': 344.039,
 '2015': 407.96,
 '2020': 483.506,
 '2025': 565.243,
 '2030': 643.286,
 '2035': 715.625},
{'Index': 58,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20112,
 'Urban Agglomeration': 'Bogra',
 'Note': '',
 'Latitude': 24.85,
 'Longitude': 89.36667,
 '1950': 33.781,
 '1955': 39.078,
 '1960': 45.207,
 '1965': 51.462,
 '1970': 58.459,
 '1975': 69.795,
 '1980': 95.539,
 '1985': 127.575,
 '1990': 169.711,
 '1995': 195.548,
 '2000': 220.176,
 '2005': 296.851,
 '2010': 409.475,
 '2015': 564.829,
 '2020': 775.034,
 '2025': 981.223,
 '2030': 1132.239,
 '2035': 1260.237},
{'Index': 59,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20115,
 'Urban Agglomeration': 'Chittagong',
 'Note': '',
 'Latitude': 22.33306,
 'Longitude': 91.83639,
 '1950': 288.853,
 '1955': 322.969,
 '1960': 359.898,
 '1965': 502.578,
 '1970': 723.324,
 '1975': 1016.788,
 '1980': 1339.829,
 '1985': 1654.58,
 '1990': 2022.825,
 '1995': 2578.233,
 '2000': 3308.476,
 '2005': 3716.749,
 '2010': 4106.06,
 '2015': 4536.155,
 '2020': 5019.824,
 '2025': 5653.493,
 '2030': 6392.58,
 '2035': 7109.655},
{'Index': 60,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20117,
 'Urban Agglomeration': 'Comilla',
 'Note': '',
 'Latitude': 23.45778,
 'Longitude': 91.20444,
 '1950': 78.54,
 '1955': 84.153,
 '1960': 90.168,
 '1965': 106.206,
 '1970': 126.689,
 '1975': 157.284,
 '1980': 217.945,
 '1985': 233.942,
 '1990': 241.303,
 '1995': 264.278,
 '2000': 292.256,
 '2005': 345.995,
 '2010': 413.179,
 '2015': 493.405,
 '2020': 588.772,
 '2025': 690.86,
 '2030': 786.753,
 '2035': 875.247},
{'Index': 61,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 24.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 '1950': 335.76,
 '1955': 408.866,
 '1960': 507.921,
 '1965': 820.74,
 '1970': 1373.718,
 '1975': 2221.055,
 '1980': 3265.663,
 '1985': 4660.384,
 '1990': 6620.697,
 '1995': 8332.474,
 '2000': 10284.947,
 '2005': 12330.879,
 '2010': 14730.537,
 '2015': 17597.177,
 '2020': 21005.86,
 '2025': 24652.864,
 '2030': 28075.66,
 '2035': 31233.651},
{'Index': 62,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20124,
 'Urban Agglomeration': 'Khulna',
 'Note': '',
 'Latitude': 22.80978,
 'Longitude': 89.56439,
 '1950': 61.259,
 '1955': 86.745,
 '1960': 122.844,
 '1965': 193.699,
 '1970': 309.875,
 '1975': 471.849,
 '1980': 627.393,
 '1985': 789.629,
 '1990': 985.412,
 '1995': 1117.228,
 '2000': 1247.303,
 '2005': 1182.467,
 '2010': 1098.087,
 '2015': 1019.725,
 '2020': 953.745,
 '2025': 980.2,
 '2030': 1090.895,
 '2035': 1212.517},
{'Index': 63,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20126,
 'Urban Agglomeration': 'Mymensingh',
 'Note': '',
 'Latitude': 24.75,
 'Longitude': 90.4,
 '1950': 65.043,
 '1955': 70.823,
 '1960': 76.828,
 '1965': 87.465,
 '1970': 100.223,
 '1975': 117.793,
 '1980': 148.446,
 '1985': 202.966,
 '1990': 281.098,
 '1995': 318.652,
 '2000': 349.775,
 '2005': 375.128,
 '2010': 401.15,
 '2015': 428.976,
 '2020': 459.983,
 '2025': 509.237,
 '2030': 574.1,
 '2035': 638.425},
{'Index': 64,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20131,
 'Urban Agglomeration': 'Rajshahi',
 'Note': '',
 'Latitude': 24.36667,
 'Longitude': 88.6,
 '1950': 38.97,
 '1955': 46.646,
 '1960': 55.71,
 '1965': 75.739,
 '1970': 104.77,
 '1975': 150.312,
 '1980': 238.405,
 '1985': 354.133,
 '1990': 520.755,
 '1995': 605.66,
 '2000': 678.334,
 '2005': 731.689,
 '2010': 785.525,
 '2015': 843.325,
 '2020': 907.732,
 '2025': 1007.015,
 '2030': 1135.69,
 '2035': 1262.956},
{'Index': 65,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20132,
 'Urban Agglomeration': 'Rangpur',
 'Note': '',
 'Latitude': 25.75,
 'Longitude': 89.25,
 '1950': 34.131,
 '1955': 38.737,
 '1960': 43.859,
 '1965': 54.185,
 '1970': 67.729,
 '1975': 89.041,
 '1980': 134.489,
 '1985': 173.036,
 '1990': 217.146,
 '1995': 247.943,
 '2000': 278.846,
 '2005': 306.955,
 '2010': 336.998,
 '2015': 369.978,
 '2020': 406.956,
 '2025': 456.821,
 '2030': 516.247,
 '2035': 574.143},
{'Index': 66,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 205390,
 'Urban Agglomeration': 'Rupganj',
 'Note': '',
 'Latitude': 23.792554,
 'Longitude': 90.520591,
 '1950': 9.682,
 '1955': 12.34,
 '1960': 15.729,
 '1965': 20.047,
 '1970': 25.55,
 '1975': 32.565,
 '1980': 41.509,
 '1985': 52.901,
 '1990': 67.425,
 '1995': 72.395,
 '2000': 75.616,
 '2005': 116.111,
 '2010': 187.204,
 '2015': 301.828,
 '2020': 481.718,
 '2025': 662.138,
 '2030': 775.014,
 '2035': 863.106},
{'Index': 67,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20136,
 'Urban Agglomeration': 'Sylhet',
 'Note': '',
 'Latitude': 24.89667,
 'Longitude': 91.87167,
 '1950': 67.438,
 '1955': 72.499,
 '1960': 76.908,
 '1965': 89.16,
 '1970': 104.598,
 '1975': 132.78,
 '1980': 209.36,
 '1985': 234.917,
 '1990': 249.967,
 '1995': 285.798,
 '2000': 330.579,
 '2005': 415.784,
 '2010': 528.55,
 '2015': 671.894,
 '2020': 851.808,
 '2025': 1032.982,
 '2030': 1183.1,
 '2035': 1316.467},
{'Index': 68,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20344,
 'Urban Agglomeration': 'Brest',
 'Note': '',
 'Latitude': 52.09755,
 'Longitude': 23.68775,
 '1950': 65.685,
 '1955': 70.431,
 '1960': 79.073,
 '1965': 99.242,
 '1970': 124.33,
 '1975': 152.884,
 '1980': 186.798,
 '1985': 224.667,
 '1990': 260.201,
 '1995': 275.094,
 '2000': 289.737,
 '2005': 301.249,
 '2010': 312.985,
 '2015': 336.554,
 '2020': 358.587,
 '2025': 370.503,
 '2030': 374.001,
 '2035': 374.076},
{'Index': 69,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20345,
 'Urban Agglomeration': 'Gomel',
 'Note': '',
 'Latitude': 52.4345,
 'Longitude': 30.9754,
 '1950': 115.888,
 '1955': 144.159,
 '1960': 179.336,
 '1965': 223.071,
 '1970': 276.774,
 '1975': 334.732,
 '1980': 397.904,
 '1985': 453.508,
 '1990': 494.199,
 '1995': 483.27,
 '2000': 477.087,
 '2005': 481.573,
 '2010': 487.603,
 '2015': 523.818,
 '2020': 557.589,
 '2025': 575.827,
 '2030': 581.211,
 '2035': 581.326},
{'Index': 70,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20346,
 'Urban Agglomeration': 'Grodno',
 'Note': '',
 'Latitude': 53.6884,
 'Longitude': 23.8258,
 '1950': 64.669,
 '1955': 69.422,
 '1960': 78.966,
 '1965': 103.357,
 '1970': 134.645,
 '1975': 167.237,
 '1980': 204.462,
 '1985': 240.503,
 '1990': 274.165,
 '1995': 289.753,
 '2000': 305.284,
 '2005': 318.076,
 '2010': 331.39,
 '2015': 359.722,
 '2020': 386.787,
 '2025': 401.629,
 '2030': 405.769,
 '2035': 405.865},
{'Index': 71,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20348,
 'Urban Agglomeration': 'Minsk',
 'Note': 22.0,
 'Latitude': 53.9,
 'Longitude': 27.56667,
 '1950': 284.222,
 '1955': 413.598,
 '1960': 550.71,
 '1965': 718.938,
 '1970': 931.566,
 '1975': 1119.925,
 '1980': 1319.711,
 '1985': 1481.151,
 '1990': 1617.544,
 '1995': 1653.763,
 '2000': 1700.376,
 '2005': 1774.585,
 '2010': 1849.991,
 '2015': 1945.223,
 '2020': 2028.104,
 '2025': 2070.934,
 '2030': 2086.212,
 '2035': 2086.462},
{'Index': 72,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20349,
 'Urban Agglomeration': 'Mogilev',
 'Note': '',
 'Latitude': 53.9141,
 'Longitude': 30.33764,
 '1950': 82.124,
 '1955': 103.39,
 '1960': 130.171,
 '1965': 163.868,
 '1970': 205.748,
 '1975': 251.526,
 '1980': 298.92,
 '1985': 331.613,
 '1990': 356.805,
 '1995': 356.603,
 '2000': 358.87,
 '2005': 363.322,
 '2010': 360.408,
 '2015': 375.711,
 '2020': 388.465,
 '2025': 394.873,
 '2030': 397.473,
 '2035': 397.508},
{'Index': 73,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20355,
 'Urban Agglomeration': 'Vitebsk',
 'Note': '',
 'Latitude': 55.19048,
 'Longitude': 30.2033,
 '1950': 105.116,
 '1955': 128.575,
 '1960': 157.278,
 '1965': 192.367,
 '1970': 233.97,
 '1975': 269.027,
 '1980': 303.879,
 '1985': 328.679,
 '1990': 346.443,
 '1995': 343.11,
 '2000': 341.18,
 '2005': 343.809,
 '2010': 350.041,
 '2015': 365.235,
 '2020': 377.966,
 '2025': 384.385,
 '2030': 386.948,
 '2035': 386.983},
{'Index': 74,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20142,
 'Urban Agglomeration': 'Antwerpen',
 'Note': '',
 'Latitude': 51.21989,
 'Longitude': 4.40346,
 '1950': 758.931,
 '1955': 785.529,
 '1960': 813.067,
 '1965': 835.13,
 '1970': 854.983,
 '1975': 867.986,
 '1980': 880.365,
 '1985': 893.77,
 '1990': 907.516,
 '1995': 922.311,
 '2000': 945.168,
 '2005': 968.58,
 '2010': 992.577,
 '2015': 1017.17,
 '2020': 1042.471,
 '2025': 1064.868,
 '2030': 1083.549,
 '2035': 1099.766},
{'Index': 75,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20144,
 'Urban Agglomeration': 'Bruxelles-Brussel',
 'Note': 25.0,
 'Latitude': 50.846735,
 'Longitude': 4.349919,
 '1950': 1414.671,
 '1955': 1449.246,
 '1960': 1484.676,
 '1965': 1524.767,
 '1970': 1567.635,
 '1975': 1610.209,
 '1980': 1653.78,
 '1985': 1676.195,
 '1990': 1695.478,
 '1995': 1714.984,
 '2000': 1782.747,
 '2005': 1853.147,
 '2010': 1926.348,
 '2015': 2002.441,
 '2020': 2080.788,
 '2025': 2141.515,
 '2030': 2181.923,
 '2035': 2214.691},
{'Index': 76,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20145,
 'Urban Agglomeration': 'Charleroi',
 'Note': '',
 'Latitude': 50.41136,
 'Longitude': 4.44448,
 '1950': 412.9,
 '1955': 414.861,
 '1960': 416.832,
 '1965': 418.811,
 '1970': 420.8,
 '1975': 415.486,
 '1980': 409.44,
 '1985': 403.486,
 '1990': 397.617,
 '1995': 391.833,
 '2000': 396.018,
 '2005': 400.246,
 '2010': 404.52,
 '2015': 408.84,
 '2020': 413.429,
 '2025': 419.244,
 '2030': 426.06,
 '2035': 432.416},
{'Index': 77,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20146,
 'Urban Agglomeration': 'Gent',
 'Note': '',
 'Latitude': 51.05,
 'Longitude': 3.71667,
 '1950': 362.075,
 '1955': 362.995,
 '1960': 363.917,
 '1965': 361.774,
 '1970': 358.342,
 '1975': 363.708,
 '1980': 370.161,
 '1985': 377.242,
 '1990': 384.542,
 '1995': 391.983,
 '2000': 405.875,
 '2005': 420.251,
 '2010': 435.141,
 '2015': 450.558,
 '2020': 466.412,
 '2025': 479.034,
 '2030': 487.898,
 '2035': 495.218},
{'Index': 78,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20148,
 'Urban Agglomeration': 'Liège',
 'Note': '',
 'Latitude': 50.63373,
 'Longitude': 5.56749,
 '1950': 602.056,
 '1955': 611.842,
 '1960': 621.789,
 '1965': 622.541,
 '1970': 619.322,
 '1975': 625.259,
 '1980': 632.293,
 '1985': 632.082,
 '1990': 630.758,
 '1995': 629.436,
 '2000': 638.735,
 '2005': 648.165,
 '2010': 657.738,
 '2015': 667.452,
 '2020': 677.589,
 '2025': 688.582,
 '2030': 700.035,
 '2035': 710.487}]},
'CITY PERSPECTIVE INITIATIVE': {'headers': ['Table 1: City Prosperity Index. Global CPI. 2016',
'Unnamed: 1',
'Unnamed: 2',
'Unnamed: 3',
'Unnamed: 4',
'Unnamed: 5',
'Unnamed: 6',
'Unnamed: 7',
'Unnamed: 8',
'Unnamed: 9',
'Unnamed: 10',
'Unnamed: 11',
'Unnamed: 12',
'Unnamed: 13',
'Unnamed: 14',
'Unnamed: 15',
'Unnamed: 16',
'Unnamed: 17',
'Unnamed: 18',
'Unnamed: 19',
'Unnamed: 20'],
'data': [{'Table 1: City Prosperity Index. Global CPI. 2016': '',
 'Unnamed: 1': '',
 'Unnamed: 2': '',
 'Unnamed: 3': '',
 'Unnamed: 4': '',
 'Unnamed: 5': '',
 'Unnamed: 6': '',
 'Unnamed: 7': '',
 'Unnamed: 8': 'Subdimensions',
 'Unnamed: 9': '',
 'Unnamed: 10': '',
 'Unnamed: 11': '',
 'Unnamed: 12': '',
 'Unnamed: 13': '',
 'Unnamed: 14': '',
 'Unnamed: 15': 'City Prosperity Index with 5 Dimensions',
 'Unnamed: 16': '',
 'Unnamed: 17': '',
 'Unnamed: 18': '',
 'Unnamed: 19': '',
 'Unnamed: 20': ''},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'CONTINENT',
 'Unnamed: 1': 'COUNTRY',
 'Unnamed: 2': 'METROPOLITAN AREA',
 'Unnamed: 3': 'CITY',
 'Unnamed: 4': 'YEAR',
 'Unnamed: 5': '',
 'Unnamed: 6': 'City Prosperity Index (with 6 Dimensions)',
 'Unnamed: 7': '',
 'Unnamed: 8': 'Productivity Index',
 'Unnamed: 9': 'Infrastructure Development Index',
 'Unnamed: 10': 'Quality of Life Index',
 'Unnamed: 11': 'Equity and Social Inclusion Index',
 'Unnamed: 12': 'Environmental Sustainability Index',
 'Unnamed: 13': 'Urban Governance and Legislation Index',
 'Unnamed: 14': '',
 'Unnamed: 15': 'City Prosperity Index (with 5 Dimensions, without Productivity)',
 'Unnamed: 16': 'City Prosperity Index (with 5 Dimensions, without Infrastructure)',
 'Unnamed: 17': 'City Prosperity Index (with 5 Dimensions, without Quality of Life)',
 'Unnamed: 18': 'City Prosperity Index (with 5 Dimensions, without Inclusion)',
 'Unnamed: 19': 'City Prosperity Index (with 5 Dimensions, without Sustainability)',
 'Unnamed: 20': 'City Prosperity Index (with 5 Dimensions, without Governance)'},
{'Table 1: City Prosperity Index. Global CPI. 2016': '',
 'Unnamed: 1': 'Africa',
 'Unnamed: 2': '',
 'Unnamed: 3': '',
 'Unnamed: 4': '',
 'Unnamed: 5': '',
 'Unnamed: 6': '',
 'Unnamed: 7': '',
 'Unnamed: 8': '',
 'Unnamed: 9': '',
 'Unnamed: 10': '',
 'Unnamed: 11': '',
 'Unnamed: 12': '',
 'Unnamed: 13': '',
 'Unnamed: 14': '',
 'Unnamed: 15': '',
 'Unnamed: 16': '',
 'Unnamed: 17': '',
 'Unnamed: 18': '',
 'Unnamed: 19': '',
 'Unnamed: 20': ''},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'Africa',
 'Unnamed: 1': 'Ghana',
 'Unnamed: 2': '--',
 'Unnamed: 3': 'Accra',
 'Unnamed: 4': 2015,
 'Unnamed: 5': '',
 'Unnamed: 6': 44.6514223209,
 'Unnamed: 7': '',
 'Unnamed: 8': 39.7772168279,
 'Unnamed: 9': 31.9083791554,
 'Unnamed: 10': 57.9139025345,
 'Unnamed: 11': 71.6680037334,
 'Unnamed: 12': 18.7815743206,
 'Unnamed: 13': 80.1,
 'Unnamed: 14': '',
 'Unnamed: 15': 45.6957151301,
 'Unnamed: 16': 47.7552813548,
 'Unnamed: 17': 42.3882796351,
 'Unnamed: 18': 40.6197546028,
 'Unnamed: 19': 53.0952852384,
 'Unnamed: 20': 39.726092882},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'Africa',
 'Unnamed: 1': 'Kenya',
 'Unnamed: 2': '--',
 'Unnamed: 3': 'Nairobi',
 'Unnamed: 4': 2015,
 'Unnamed: 5': '',
 'Unnamed: 6': 59.7719024326,
 'Unnamed: 7': '',
 'Unnamed: 8': 42.3402237525,
 'Unnamed: 9': 36.8078834989,
 'Unnamed: 10': 61.8613985721,
 'Unnamed: 11': 58.4148065269,
 'Unnamed: 12': 94.2544975711,
 'Unnamed: 13': 85.91,
 'Unnamed: 14': '',
 'Unnamed: 15': 64.0391951288,
 'Unnamed: 16': 65.8579678134,
 'Unnamed: 17': 59.3625499152,
 'Unnamed: 18': 60.0470817918,
 'Unnamed: 19': 54.5677539291,
 'Unnamed: 20': 55.5888578355},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'Africa',
 'Unnamed: 1': 'Nigeria',
 'Unnamed: 2': '--',
 'Unnamed: 3': 'Lagos',
 'Unnamed: 4': 2015,
 'Unnamed: 5': '',
 'Unnamed: 6': 36.1303898521,
 'Unnamed: 7': '',
 'Unnamed: 8': 16.1135011819,
 'Unnamed: 9': 37.4511129531,
 'Unnamed: 10': 47.2805100201,
 'Unnamed: 11': 42.4370767679,
 'Unnamed: 12': 34.2248160296,
 'Unnamed: 13': 53.68,
 'Unnamed: 14': '',
 'Unnamed: 15': 42.4628553398,
 'Unnamed: 16': 35.8718877196,
 'Unnamed: 17': 34.2381859823,
 'Unnamed: 18': 34.9863055874,
 'Unnamed: 19': 36.5240520289,
 'Unnamed: 20': 33.3798726778},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'Africa',
 'Unnamed: 1': 'South Africa',
 'Unnamed: 2': '--',
 'Unnamed: 3': 'Cape Town',
 'Unnamed: 4': 2015,
 'Unnamed: 5': '',
 'Unnamed: 6': 45.7639862433,
 'Unnamed: 7': '',
 'Unnamed: 8': 34.3620226352,
 'Unnamed: 9': 44.403930963,
 'Unnamed: 10': 49.0753989692,
 'Unnamed: 11': 50.0471988839,
 'Unnamed: 12': 33.3603177139,
 'Unnamed: 13': 73.48,
 'Unnamed: 14': '',
 'Unnamed: 15': 48.4632875713,
 'Unnamed: 16': 46.0409559057,
 'Unnamed: 17': 45.1290143023,
 'Unnamed: 18': 44.95237692,
 'Unnamed: 19': 48.7508935271,
 'Unnamed: 20': 41.6288857051},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'Africa',
 'Unnamed: 1': 'South Africa',
 'Unnamed: 2': '--',
 'Unnamed: 3': 'Johannesburg',
 'Unnamed: 4': 2015,
 'Unnamed: 5': '',
 'Unnamed: 6': 36.2784096065,
 'Unnamed: 7': '',
 'Unnamed: 8': 34.4007158763,
 'Unnamed: 9': 41.503930963,
 'Unnamed: 10': 52.067195553,
 'Unnamed: 11': 49.9202338842,
 'Unnamed: 12': 8.3603177139,
 'Unnamed: 13': 73.48,
 'Unnamed: 14': '',
 'Unnamed: 15': 36.6660724199,
 'Unnamed: 16': 35.3150675702,
 'Unnamed: 17': 33.7493218525,
 'Unnamed: 18': 34.0347500622,
 'Unnamed: 19': 48.6556559131,
 'Unnamed: 20': 31.5024302326},
{'Table 1: City Prosperity Index. Global CPI. 2016': 'Africa',
 'Unnamed: 1': 'Tanzania',
 'Unnamed: 2': '--',
 'Unnamed: 3': 'Dar es Salaam',
 'Unnamed: 4': 2015,
 'Unnamed: 5': '',
 'Unnamed: 6': 44.8970582505,
 'Unnamed: 7': '',
 'Unnamed: 8': 44.4100818891,
 'Unnamed: 9': 29.8396766129,
 'Unnamed: 10': 52.7282743271,
 'Unnamed: 11': 65.7774476732,
 'Unnamed: 12': 41.5969599543,
 'Unnamed: 13': 42.84,
 'Unnamed: 14': '',
 'Unnamed: 15': 44.9950924478,
 'Unnamed: 16': 48.7194796133,
 'Unnamed: 17': 43.4763174964,
 'Unnamed: 18': 41.595472281,
 'Unnamed: 19': 45.5878535919,
 'Unnamed: 20': 45.3201742321}]},
'City Size Class-Number': {'headers': ['Index',
'Country Code',
'Region, subregion, country or area *',
'Size class of urban settlement',
'Size class code',
'Type of data',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 2,
 '1955': 2,
 '1960': 3,
 '1965': 3,
 '1970': 3,
 '1975': 4,
 '1980': 5,
 '1985': 9,
 '1990': 10,
 '1995': 14,
 '2000': 16,
 '2005': 20,
 '2010': 25,
 '2015': 29,
 '2020': 34,
 '2025': 37,
 '2030': 43,
 '2035': 48},
{'Index': 2,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 5,
 '1955': 9,
 '1960': 9,
 '1965': 13,
 '1970': 15,
 '1975': 14,
 '1980': 19,
 '1985': 18,
 '1990': 21,
 '1995': 23,
 '2000': 30,
 '2005': 36,
 '2010': 39,
 '2015': 45,
 '2020': 51,
 '2025': 58,
 '2030': 66,
 '2035': 73},
{'Index': 3,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 69,
 '1955': 74,
 '1960': 93,
 '1965': 112,
 '1970': 127,
 '1975': 145,
 '1980': 174,
 '1985': 202,
 '1990': 243,
 '1995': 276,
 '2000': 325,
 '2005': 343,
 '2010': 380,
 '2015': 439,
 '2020': 494,
 '2025': 558,
 '2030': 597,
 '2035': 639},
{'Index': 4,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 101,
 '1955': 124,
 '1960': 132,
 '1965': 153,
 '1970': 190,
 '1975': 223,
 '1980': 247,
 '1985': 279,
 '1990': 301,
 '1995': 342,
 '2000': 396,
 '2005': 456,
 '2010': 510,
 '2015': 554,
 '2020': 626,
 '2025': 659,
 '2030': 710,
 '2035': 757},
{'Index': 5,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 129,
 '1955': 146,
 '1960': 184,
 '1965': 205,
 '1970': 225,
 '1975': 258,
 '1980': 297,
 '1985': 347,
 '1990': 416,
 '1995': 460,
 '2000': 524,
 '2005': 591,
 '2010': 645,
 '2015': 707,
 '2020': 729,
 '2025': 794,
 '2030': 827,
 '2035': 846},
{'Index': 6,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 2,
 '1955': 2,
 '1960': 3,
 '1965': 3,
 '1970': 3,
 '1975': 3,
 '1980': 3,
 '1985': 4,
 '1990': 4,
 '1995': 4,
 '2000': 5,
 '2005': 6,
 '2010': 6,
 '2015': 6,
 '2020': 6,
 '2025': 6,
 '2030': 7,
 '2035': 7},
{'Index': 7,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 4,
 '1955': 6,
 '1960': 5,
 '1965': 6,
 '1970': 6,
 '1975': 6,
 '1980': 6,
 '1985': 5,
 '1990': 6,
 '1995': 6,
 '2000': 7,
 '2005': 8,
 '2010': 9,
 '2015': 13,
 '2020': 14,
 '2025': 16,
 '2030': 16,
 '2035': 16},
{'Index': 8,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 37,
 '1955': 37,
 '1960': 49,
 '1965': 58,
 '1970': 64,
 '1975': 70,
 '1980': 80,
 '1985': 84,
 '1990': 88,
 '1995': 93,
 '2000': 96,
 '2005': 96,
 '2010': 100,
 '2015': 103,
 '2020': 105,
 '2025': 110,
 '2030': 113,
 '2035': 115},
{'Index': 9,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 66,
 '1955': 81,
 '1960': 81,
 '1965': 85,
 '1970': 97,
 '1975': 105,
 '1980': 105,
 '1985': 112,
 '1990': 113,
 '1995': 117,
 '2000': 122,
 '2005': 128,
 '2010': 137,
 '2015': 136,
 '2020': 151,
 '2025': 151,
 '2030': 156,
 '2035': 162},
{'Index': 10,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 79,
 '1955': 81,
 '1960': 93,
 '1965': 105,
 '1970': 114,
 '1975': 114,
 '1980': 129,
 '1985': 136,
 '1990': 158,
 '1995': 174,
 '2000': 183,
 '2005': 189,
 '2010': 188,
 '2015': 203,
 '2020': 194,
 '2025': 196,
 '2030': 198,
 '2035': 201},
{'Index': 11,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 1,
 '1980': 2,
 '1985': 5,
 '1990': 6,
 '1995': 10,
 '2000': 11,
 '2005': 14,
 '2010': 19,
 '2015': 23,
 '2020': 28,
 '2025': 31,
 '2030': 36,
 '2035': 41},
{'Index': 12,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 1,
 '1955': 3,
 '1960': 4,
 '1965': 7,
 '1970': 9,
 '1975': 8,
 '1980': 13,
 '1985': 13,
 '1990': 15,
 '1995': 17,
 '2000': 23,
 '2005': 28,
 '2010': 30,
 '2015': 32,
 '2020': 37,
 '2025': 42,
 '2030': 50,
 '2035': 57},
{'Index': 13,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 32,
 '1955': 37,
 '1960': 44,
 '1965': 54,
 '1970': 63,
 '1975': 75,
 '1980': 94,
 '1985': 118,
 '1990': 155,
 '1995': 183,
 '2000': 229,
 '2005': 247,
 '2010': 280,
 '2015': 336,
 '2020': 389,
 '2025': 448,
 '2030': 484,
 '2035': 524},
{'Index': 14,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 35,
 '1955': 43,
 '1960': 51,
 '1965': 68,
 '1970': 93,
 '1975': 118,
 '1980': 142,
 '1985': 167,
 '1990': 188,
 '1995': 225,
 '2000': 274,
 '2005': 328,
 '2010': 373,
 '2015': 418,
 '2020': 475,
 '2025': 508,
 '2030': 554,
 '2035': 595},
{'Index': 15,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 50,
 '1955': 65,
 '1960': 91,
 '1965': 100,
 '1970': 111,
 '1975': 144,
 '1980': 168,
 '1985': 211,
 '1990': 258,
 '1995': 286,
 '2000': 341,
 '2005': 402,
 '2010': 457,
 '2015': 504,
 '2020': 535,
 '2025': 598,
 '2030': 629,
 '2035': 645},
{'Index': 16,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 0,
 '1995': 0,
 '2000': 1,
 '2005': 1,
 '2010': 1,
 '2015': 2,
 '2020': 2,
 '2025': 3,
 '2030': 4,
 '2035': 4},
{'Index': 17,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 1,
 '1995': 1,
 '2000': 1,
 '2005': 1,
 '2010': 2,
 '2015': 3,
 '2020': 5,
 '2025': 5,
 '2030': 7,
 '2035': 10},
{'Index': 18,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 1,
 '1955': 1,
 '1960': 1,
 '1965': 1,
 '1970': 3,
 '1975': 4,
 '1980': 6,
 '1985': 10,
 '1990': 12,
 '1995': 15,
 '2000': 22,
 '2005': 24,
 '2010': 24,
 '2015': 30,
 '2020': 33,
 '2025': 45,
 '2030': 53,
 '2035': 60},
{'Index': 19,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 2,
 '1965': 4,
 '1970': 5,
 '1975': 8,
 '1980': 11,
 '1985': 13,
 '1990': 17,
 '1995': 17,
 '2000': 14,
 '2005': 19,
 '2010': 29,
 '2015': 31,
 '2020': 44,
 '2025': 53,
 '2030': 60,
 '2035': 73},
{'Index': 20,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 3,
 '1955': 4,
 '1960': 5,
 '1965': 7,
 '1970': 11,
 '1975': 10,
 '1980': 11,
 '1985': 17,
 '1990': 17,
 '1995': 21,
 '2000': 27,
 '2005': 33,
 '2010': 36,
 '2015': 48,
 '2020': 50,
 '2025': 58,
 '2030': 73,
 '2035': 82},
{'Index': 21,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 1,
 '1980': 2,
 '1985': 5,
 '1990': 6,
 '1995': 10,
 '2000': 10,
 '2005': 13,
 '2010': 18,
 '2015': 21,
 '2020': 26,
 '2025': 28,
 '2030': 32,
 '2035': 37},
{'Index': 22,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 1,
 '1955': 3,
 '1960': 4,
 '1965': 7,
 '1970': 9,
 '1975': 8,
 '1980': 13,
 '1985': 13,
 '1990': 14,
 '1995': 16,
 '2000': 22,
 '2005': 27,
 '2010': 28,
 '2015': 29,
 '2020': 32,
 '2025': 37,
 '2030': 43,
 '2035': 47},
{'Index': 23,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 31,
 '1955': 36,
 '1960': 43,
 '1965': 53,
 '1970': 60,
 '1975': 71,
 '1980': 88,
 '1985': 108,
 '1990': 143,
 '1995': 168,
 '2000': 207,
 '2005': 223,
 '2010': 256,
 '2015': 306,
 '2020': 356,
 '2025': 403,
 '2030': 431,
 '2035': 464},
{'Index': 24,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 35,
 '1955': 43,
 '1960': 49,
 '1965': 64,
 '1970': 88,
 '1975': 110,
 '1980': 131,
 '1985': 154,
 '1990': 171,
 '1995': 208,
 '2000': 260,
 '2005': 309,
 '2010': 344,
 '2015': 387,
 '2020': 431,
 '2025': 455,
 '2030': 494,
 '2035': 522},
{'Index': 25,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 47,
 '1955': 61,
 '1960': 86,
 '1965': 93,
 '1970': 100,
 '1975': 134,
 '1980': 157,
 '1985': 194,
 '1990': 241,
 '1995': 265,
 '2000': 314,
 '2005': 369,
 '2010': 421,
 '2015': 456,
 '2020': 485,
 '2025': 540,
 '2030': 556,
 '2035': 563},
{'Index': 26,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 1,
 '1980': 2,
 '1985': 5,
 '1990': 6,
 '1995': 9,
 '2000': 9,
 '2005': 12,
 '2010': 13,
 '2015': 17,
 '2020': 22,
 '2025': 24,
 '2030': 28,
 '2035': 31},
{'Index': 27,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 1,
 '1955': 2,
 '1960': 3,
 '1965': 6,
 '1970': 8,
 '1975': 7,
 '1980': 11,
 '1985': 11,
 '1990': 12,
 '1995': 12,
 '2000': 17,
 '2005': 17,
 '2010': 20,
 '2015': 20,
 '2020': 22,
 '2025': 26,
 '2030': 30,
 '2035': 38},
{'Index': 28,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 23,
 '1955': 27,
 '1960': 32,
 '1965': 39,
 '1970': 47,
 '1975': 58,
 '1980': 75,
 '1985': 93,
 '1990': 119,
 '1995': 139,
 '2000': 168,
 '2005': 183,
 '2010': 204,
 '2015': 239,
 '2020': 270,
 '2025': 303,
 '2030': 333,
 '2035': 364},
{'Index': 29,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 23,
 '1955': 31,
 '1960': 36,
 '1965': 48,
 '1970': 67,
 '1975': 90,
 '1980': 110,
 '1985': 131,
 '1990': 149,
 '1995': 167,
 '2000': 188,
 '2005': 222,
 '2010': 249,
 '2015': 264,
 '2020': 303,
 '2025': 339,
 '2030': 377,
 '2035': 415},
{'Index': 30,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 36,
 '1955': 48,
 '1960': 67,
 '1965': 79,
 '1970': 90,
 '1975': 106,
 '1980': 127,
 '1985': 162,
 '1990': 190,
 '1995': 205,
 '2000': 224,
 '2005': 253,
 '2010': 308,
 '2015': 364,
 '2020': 393,
 '2025': 442,
 '2030': 483,
 '2035': 500},
{'Index': 31,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 2,
 '1955': 2,
 '1960': 3,
 '1965': 3,
 '1970': 3,
 '1975': 3,
 '1980': 3,
 '1985': 4,
 '1990': 5,
 '1995': 5,
 '2000': 4,
 '2005': 5,
 '2010': 5,
 '2015': 5,
 '2020': 5,
 '2025': 6,
 '2030': 7,
 '2035': 7},
{'Index': 32,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 3,
 '1955': 5,
 '1960': 4,
 '1965': 5,
 '1970': 6,
 '1975': 6,
 '1980': 6,
 '1985': 5,
 '1990': 6,
 '1995': 7,
 '2000': 10,
 '2005': 11,
 '2010': 14,
 '2015': 17,
 '2020': 18,
 '2025': 20,
 '2030': 20,
 '2035': 21},
{'Index': 33,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 41,
 '1955': 42,
 '1960': 52,
 '1965': 60,
 '1970': 65,
 '1975': 71,
 '1980': 74,
 '1985': 80,
 '1990': 85,
 '1995': 90,
 '2000': 93,
 '2005': 98,
 '2010': 102,
 '2015': 108,
 '2020': 112,
 '2025': 117,
 '2030': 121,
 '2035': 123},
{'Index': 34,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 56,
 '1955': 66,
 '1960': 67,
 '1965': 70,
 '1970': 80,
 '1975': 91,
 '1980': 94,
 '1985': 98,
 '1990': 100,
 '1995': 109,
 '2000': 118,
 '2005': 122,
 '2010': 129,
 '2015': 129,
 '2020': 144,
 '2025': 143,
 '2030': 147,
 '2035': 155},
{'Index': 35,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 67,
 '1955': 71,
 '1960': 77,
 '1965': 85,
 '1970': 91,
 '1975': 88,
 '1980': 97,
 '1985': 105,
 '1990': 120,
 '1995': 135,
 '2000': 145,
 '2005': 155,
 '2010': 159,
 '2015': 179,
 '2020': 174,
 '2025': 179,
 '2030': 185,
 '2035': 188},
{'Index': 36,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 1,
 '1980': 2,
 '1985': 5,
 '1990': 5,
 '1995': 9,
 '2000': 12,
 '2005': 15,
 '2010': 20,
 '2015': 23,
 '2020': 28,
 '2025': 30,
 '2030': 34,
 '2035': 39},
{'Index': 37,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 2,
 '1955': 4,
 '1960': 5,
 '1965': 8,
 '1970': 9,
 '1975': 8,
 '1980': 13,
 '1985': 13,
 '1990': 15,
 '1995': 16,
 '2000': 19,
 '2005': 24,
 '2010': 24,
 '2015': 27,
 '2020': 32,
 '2025': 36,
 '2030': 42,
 '2035': 46},
{'Index': 38,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 28,
 '1955': 32,
 '1960': 41,
 '1965': 52,
 '1970': 61,
 '1975': 72,
 '1980': 97,
 '1985': 116,
 '1990': 148,
 '1995': 175,
 '2000': 216,
 '2005': 227,
 '2010': 260,
 '2015': 307,
 '2020': 352,
 '2025': 405,
 '2030': 439,
 '2035': 475},
{'Index': 39,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 44,
 '1955': 57,
 '1960': 63,
 '1965': 80,
 '1970': 107,
 '1975': 124,
 '1980': 142,
 '1985': 168,
 '1990': 186,
 '1995': 216,
 '2000': 263,
 '2005': 318,
 '2010': 357,
 '2015': 405,
 '2020': 458,
 '2025': 483,
 '2030': 520,
 '2035': 548},
{'Index': 40,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 61,
 '1955': 74,
 '1960': 105,
 '1965': 115,
 '1970': 123,
 '1975': 161,
 '1980': 189,
 '1985': 229,
 '1990': 284,
 '1995': 312,
 '2000': 362,
 '2005': 414,
 '2010': 466,
 '2015': 495,
 '2020': 520,
 '2025': 570,
 '2030': 581,
 '2035': 591},
{'Index': 41,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 1,
 '1980': 2,
 '1985': 3,
 '1990': 3,
 '1995': 5,
 '2000': 7,
 '2005': 8,
 '2010': 12,
 '2015': 12,
 '2020': 15,
 '2025': 16,
 '2030': 18,
 '2035': 22},
{'Index': 42,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 2,
 '1955': 3,
 '1960': 4,
 '1965': 6,
 '1970': 6,
 '1975': 5,
 '1980': 6,
 '1985': 8,
 '1990': 8,
 '1995': 10,
 '2000': 11,
 '2005': 16,
 '2010': 16,
 '2015': 19,
 '2020': 22,
 '2025': 25,
 '2030': 29,
 '2035': 26},
{'Index': 43,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 16,
 '1955': 19,
 '1960': 26,
 '1965': 31,
 '1970': 39,
 '1975': 46,
 '1980': 61,
 '1985': 71,
 '1990': 92,
 '1995': 107,
 '2000': 131,
 '2005': 137,
 '2010': 160,
 '2015': 189,
 '2020': 221,
 '2025': 255,
 '2030': 272,
 '2035': 292},
{'Index': 44,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 29,
 '1955': 41,
 '1960': 43,
 '1965': 53,
 '1970': 64,
 '1975': 74,
 '1980': 79,
 '1985': 97,
 '1990': 109,
 '1995': 132,
 '2000': 180,
 '2005': 214,
 '2010': 235,
 '2015': 276,
 '2020': 306,
 '2025': 315,
 '2030': 323,
 '2035': 326},
{'Index': 45,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 37,
 '1955': 42,
 '1960': 62,
 '1965': 66,
 '1970': 75,
 '1975': 101,
 '1980': 118,
 '1985': 144,
 '1990': 184,
 '1995': 207,
 '2000': 243,
 '2005': 292,
 '2010': 314,
 '2015': 313,
 '2020': 317,
 '2025': 340,
 '2030': 343,
 '2035': 350},
{'Index': 46,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 2,
 '1990': 2,
 '1995': 4,
 '2000': 5,
 '2005': 7,
 '2010': 8,
 '2015': 11,
 '2020': 13,
 '2025': 14,
 '2030': 16,
 '2035': 17},
{'Index': 47,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 1,
 '1960': 1,
 '1965': 2,
 '1970': 3,
 '1975': 3,
 '1980': 7,
 '1985': 5,
 '1990': 7,
 '1995': 6,
 '2000': 8,
 '2005': 8,
 '2010': 8,
 '2015': 8,
 '2020': 10,
 '2025': 11,
 '2030': 13,
 '2035': 20},
{'Index': 48,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 12,
 '1955': 13,
 '1960': 15,
 '1965': 21,
 '1970': 22,
 '1975': 26,
 '1980': 36,
 '1985': 45,
 '1990': 56,
 '1995': 68,
 '2000': 85,
 '2005': 90,
 '2010': 100,
 '2015': 118,
 '2020': 131,
 '2025': 150,
 '2030': 167,
 '2035': 183},
{'Index': 49,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 15,
 '1955': 16,
 '1960': 20,
 '1965': 27,
 '1970': 43,
 '1975': 50,
 '1980': 63,
 '1985': 71,
 '1990': 77,
 '1995': 84,
 '2000': 83,
 '2005': 104,
 '2010': 122,
 '2015': 129,
 '2020': 152,
 '2025': 168,
 '2030': 197,
 '2035': 222},
{'Index': 50,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 24,
 '1955': 32,
 '1960': 43,
 '1965': 49,
 '1970': 48,
 '1975': 60,
 '1980': 71,
 '1985': 85,
 '1990': 100,
 '1995': 105,
 '2000': 119,
 '2005': 122,
 '2010': 152,
 '2015': 182,
 '2020': 203,
 '2025': 230,
 '2030': 238,
 '2035': 241},
{'Index': 51,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 0,
 '1995': 0,
 '2000': 0,
 '2005': 0,
 '2010': 0,
 '2015': 1,
 '2020': 1,
 '2025': 1,
 '2030': 2,
 '2035': 2},
{'Index': 52,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 0,
 '1995': 0,
 '2000': 1,
 '2005': 1,
 '2010': 1,
 '2015': 1,
 '2020': 1,
 '2025': 2,
 '2030': 4,
 '2035': 6},
{'Index': 53,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 1,
 '1975': 2,
 '1980': 3,
 '1985': 6,
 '1990': 10,
 '1995': 11,
 '2000': 16,
 '2005': 18,
 '2010': 18,
 '2015': 24,
 '2020': 30,
 '2025': 36,
 '2030': 37,
 '2035': 41},
{'Index': 54,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 1,
 '1955': 1,
 '1960': 2,
 '1965': 3,
 '1970': 3,
 '1975': 8,
 '1980': 11,
 '1985': 13,
 '1990': 15,
 '1995': 17,
 '2000': 15,
 '2005': 16,
 '2010': 24,
 '2015': 20,
 '2020': 24,
 '2025': 33,
 '2030': 43,
 '2035': 54},
{'Index': 55,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 1,
 '1955': 1,
 '1960': 2,
 '1965': 5,
 '1970': 11,
 '1975': 9,
 '1980': 11,
 '1985': 13,
 '1990': 12,
 '1995': 13,
 '2000': 17,
 '2005': 22,
 '2010': 20,
 '2015': 33,
 '2020': 35,
 '2025': 45,
 '2030': 61,
 '2035': 66},
{'Index': 56,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 0,
 '1995': 0,
 '2000': 0,
 '2005': 0,
 '2010': 1,
 '2015': 2,
 '2020': 2,
 '2025': 3,
 '2030': 4,
 '2035': 4},
{'Index': 57,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 0,
 '1995': 1,
 '2000': 2,
 '2005': 2,
 '2010': 2,
 '2015': 2,
 '2020': 4,
 '2025': 6,
 '2030': 11,
 '2035': 17},
{'Index': 58,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 1,
 '1960': 1,
 '1965': 2,
 '1970': 4,
 '1975': 5,
 '1980': 10,
 '1985': 15,
 '1990': 18,
 '1995': 20,
 '2000': 30,
 '2005': 35,
 '2010': 34,
 '2015': 44,
 '2020': 51,
 '2025': 62,
 '2030': 69,
 '2035': 81},
{'Index': 59,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 3,
 '1955': 3,
 '1960': 6,
 '1965': 6,
 '1970': 10,
 '1975': 14,
 '1980': 14,
 '1985': 21,
 '1990': 25,
 '1995': 30,
 '2000': 28,
 '2005': 31,
 '2010': 46,
 '2015': 47,
 '2020': 61,
 '2025': 79,
 '2030': 94,
 '2035': 107},
{'Index': 60,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 4,
 '1955': 4,
 '1960': 5,
 '1965': 10,
 '1970': 12,
 '1975': 17,
 '1980': 25,
 '1985': 26,
 '1990': 30,
 '1995': 28,
 '2000': 34,
 '2005': 41,
 '2010': 47,
 '2015': 69,
 '2020': 71,
 '2025': 77,
 '2030': 93,
 '2035': 96},
{'Index': 61,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 0,
 '1975': 0,
 '1980': 0,
 '1985': 0,
 '1990': 0,
 '1995': 1,
 '2000': 1,
 '2005': 1,
 '2010': 2,
 '2015': 3,
 '2020': 3,
 '2025': 4,
 '2030': 5,
 '2035': 5},
{'Index': 62,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 0,
 '1955': 0,
 '1960': 0,
 '1965': 0,
 '1970': 1,
 '1975': 1,
 '1980': 1,
 '1985': 1,
 '1990': 1,
 '1995': 1,
 '2000': 2,
 '2005': 2,
 '2010': 2,
 '2015': 3,
 '2020': 6,
 '2025': 8,
 '2030': 13,
 '2035': 19},
{'Index': 63,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 2,
 '1955': 3,
 '1960': 3,
 '1965': 6,
 '1970': 7,
 '1975': 8,
 '1980': 15,
 '1985': 20,
 '1990': 24,
 '1995': 26,
 '2000': 37,
 '2005': 42,
 '2010': 42,
 '2015': 51,
 '2020': 59,
 '2025': 73,
 '2030': 81,
 '2035': 93},
{'Index': 64,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 5,
 '1955': 6,
 '1960': 9,
 '1965': 7,
 '1970': 12,
 '1975': 18,
 '1980': 18,
 '1985': 25,
 '1990': 29,
 '1995': 36,
 '2000': 35,
 '2005': 39,
 '2010': 56,
 '2015': 60,
 '2020': 75,
 '2025': 94,
 '2030': 111,
 '2035': 128},
{'Index': 65,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 5,
 '1955': 4,
 '1960': 7,
 '1965': 14,
 '1970': 17,
 '1975': 22,
 '1980': 33,
 '1985': 37,
 '1990': 43,
 '1995': 41,
 '2000': 48,
 '2005': 58,
 '2010': 65,
 '2015': 90,
 '2020': 92,
 '2025': 99,
 '2030': 117,
 '2035': 121}]},
'City Size Class-Percentage': {'headers': ['Index',
'Country Code',
'Region, subregion, country or area *',
'Size class of urban settlement',
'Size class code',
'Type of data',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 3.1446290599,
 '1955': 3.0708973171,
 '1960': 4.0491638935,
 '1965': 4.0831053947,
 '1970': 4.0436838274,
 '1975': 4.5187741179,
 '1980': 4.9193069992,
 '1985': 6.612753168,
 '1990': 6.6936725764,
 '1995': 8.0579302725,
 '2000': 8.5550672265,
 '2005': 9.5606346733,
 '2010': 10.7678098411,
 '2015': 11.6233953696,
 '2020': 12.714574606,
 '2025': 13.3190588924,
 '2030': 14.5518895334,
 '2035': 15.5167044795},
{'Index': 2,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 4.284399404,
 '1955': 6.5001803026,
 '1960': 5.8119899938,
 '1965': 7.2540837625,
 '1970': 7.9204355818,
 '1975': 7.0170476511,
 '1980': 7.9583539567,
 '1985': 6.3946062092,
 '1990': 6.8190578167,
 '1995': 6.3154758837,
 '2000': 7.4536754525,
 '2005': 7.7018258168,
 '2010': 7.494240569,
 '2015': 7.7901471319,
 '2020': 7.9500526023,
 '2025': 8.4601773276,
 '2030': 8.6663896857,
 '2035': 8.8677355979},
{'Index': 3,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 16.9774899722,
 '1955': 15.5819776786,
 '1960': 17.2739534494,
 '1965': 17.4194030286,
 '1970': 18.0475125061,
 '1975': 19.1456114485,
 '1980': 19.1503559995,
 '1985': 19.5391141708,
 '1990': 20.3936193,
 '1995': 20.8686668035,
 '2000': 21.8197229259,
 '2005': 21.0220877352,
 '2010': 21.1518946487,
 '2015': 21.7264319163,
 '2020': 22.3061731186,
 '2025': 23.1181895779,
 '2030': 22.8910367341,
 '2035': 22.7323947924},
{'Index': 4,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.9853598362,
 '1955': 9.7382298684,
 '1960': 9.0618284164,
 '1965': 8.8748257734,
 '1970': 9.6688724495,
 '1975': 10.1074938082,
 '1980': 9.705116414,
 '1985': 9.555128865,
 '1990': 9.064214755,
 '1995': 9.1557794873,
 '2000': 9.3797780322,
 '2005': 9.7833020431,
 '2010': 9.862694391,
 '2015': 9.6044168141,
 '2020': 9.851590948,
 '2025': 9.5346117829,
 '2030': 9.5530191713,
 '2035': 9.4902821905},
{'Index': 5,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.6391767134,
 '1955': 6.3925578985,
 '1960': 6.9570913597,
 '1965': 6.6795129732,
 '1970': 6.3916317053,
 '1975': 6.4234884644,
 '1980': 6.4817584256,
 '1985': 6.5859392069,
 '1990': 6.9409548454,
 '1995': 6.9025685362,
 '2000': 6.9596074025,
 '2005': 6.9539609531,
 '2010': 6.8310958574,
 '2015': 6.7751216209,
 '2020': 6.3690365085,
 '2025': 6.3988538964,
 '2030': 6.1894854892,
 '2035': 5.9006466691},
{'Index': 6,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 59.9689450143,
 '1955': 58.7161569347,
 '1960': 56.8459728871,
 '1965': 55.6890690676,
 '1970': 53.9278639299,
 '1975': 52.78758451,
 '1980': 51.785108205,
 '1985': 51.3124583801,
 '1990': 50.0884807065,
 '1995': 48.6995790168,
 '2000': 45.8321489604,
 '2005': 44.9781887785,
 '2010': 43.8922646928,
 '2015': 42.4804871473,
 '2020': 40.8085722167,
 '2025': 39.1691085228,
 '2030': 38.1481793863,
 '2035': 37.4922362706},
{'Index': 7,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 5.2910461789,
 '1955': 5.374463101,
 '1960': 7.3996277906,
 '1965': 7.8306169102,
 '1970': 8.1235767009,
 '1975': 8.1378986141,
 '1980': 8.0274628939,
 '1985': 9.2756152738,
 '1990': 9.3854682607,
 '1995': 9.4119604483,
 '2000': 10.4908105324,
 '2005': 11.4654339196,
 '2010': 11.3845613346,
 '2015': 11.2692855272,
 '2020': 11.0959908046,
 '2025': 10.8922097603,
 '2030': 11.7302388181,
 '2035': 11.6173225364},
{'Index': 8,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.0511958151,
 '1955': 8.0151739469,
 '1960': 6.1559333921,
 '1965': 6.8333295178,
 '1970': 6.6624439843,
 '1975': 6.4652420654,
 '1980': 6.3064744981,
 '1985': 4.968965105,
 '1990': 5.5624329695,
 '1995': 5.5648323113,
 '2000': 5.6179489094,
 '2005': 5.5967463216,
 '2010': 6.1503510008,
 '2015': 8.4617430591,
 '2020': 9.2416060632,
 '2025': 10.4063631238,
 '2030': 10.0338964258,
 '2035': 10.1316521781},
{'Index': 9,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 15.8764319525,
 '1955': 14.091827184,
 '1960': 16.4825223775,
 '1965': 17.2566275525,
 '1970': 18.3724011563,
 '1975': 19.002131281,
 '1980': 20.3101756743,
 '1985': 20.7903923454,
 '1990': 20.9141773263,
 '1995': 21.7095929211,
 '2000': 21.4602789511,
 '2005': 20.7785972628,
 '2010': 21.0923846861,
 '2015': 20.306803937,
 '2020': 20.5766320798,
 '2025': 20.5223357063,
 '2030': 20.6176693827,
 '2035': 20.9715743913},
{'Index': 10,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 9.8350962183,
 '1955': 11.1320628556,
 '1960': 10.033341051,
 '1965': 9.5515109018,
 '1970': 10.1191000266,
 '1975': 10.1422264419,
 '1980': 9.4046695129,
 '1985': 9.5366333443,
 '1990': 9.3152493954,
 '1995': 9.2805837113,
 '2000': 9.2884017419,
 '2005': 9.4409205383,
 '2010': 9.6056650592,
 '2015': 9.3448417072,
 '2020': 10.1181810312,
 '2025': 9.880375689,
 '2030': 9.960254681,
 '2035': 10.1761500441},
{'Index': 11,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.8951122214,
 '1955': 6.2448480131,
 '1960': 6.4740074616,
 '1965': 6.5546994063,
 '1970': 6.4534812867,
 '1975': 6.0624341937,
 '1980': 6.4899748552,
 '1985': 6.5181129254,
 '1990': 7.2477293576,
 '1995': 7.6809778423,
 '2000': 7.7505148063,
 '2005': 7.7044417839,
 '2010': 7.3385861737,
 '2015': 7.8193529135,
 '2020': 7.3637831367,
 '2025': 7.3138456612,
 '2030': 7.1999064105,
 '2035': 7.1253143992},
{'Index': 12,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 56.0511176139,
 '1955': 55.1416248993,
 '1960': 53.4545679272,
 '1965': 51.9732157114,
 '1970': 50.2689968452,
 '1975': 50.1900674039,
 '1980': 49.4612425657,
 '1985': 48.9102810061,
 '1990': 47.5749426906,
 '1995': 46.3520527657,
 '2000': 45.3920450589,
 '2005': 45.0138601739,
 '2010': 44.4284517456,
 '2015': 42.797972856,
 '2020': 41.6038068845,
 '2025': 40.9848700594,
 '2030': 40.4580342817,
 '2035': 39.9779864509},
{'Index': 13,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.315159397,
 '1980': 2.5317105208,
 '1985': 4.861413597,
 '1990': 5.164000668,
 '1995': 7.3808400711,
 '2000': 7.6928716604,
 '2005': 8.7992816506,
 '2010': 10.5449826365,
 '2015': 11.7388709756,
 '2020': 13.1958501911,
 '2025': 13.984189556,
 '2030': 15.2712200648,
 '2035': 16.4476848837},
{'Index': 14,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 1.695937316,
 '1955': 4.4805332189,
 '1960': 5.3963212289,
 '1965': 7.7125170239,
 '1970': 9.167262505,
 '1975': 7.5055007284,
 '1980': 9.2272805202,
 '1985': 7.3322370668,
 '1990': 7.5331624344,
 '1995': 6.6908393111,
 '2000': 8.2713227518,
 '2005': 8.543231356,
 '2010': 7.9797767356,
 '2015': 7.5711389671,
 '2020': 7.5660174062,
 '2025': 7.9267828809,
 '2030': 8.3177677444,
 '2035': 8.5659745532},
{'Index': 15,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 18.590605622,
 '1955': 17.568506211,
 '1960': 18.2304282001,
 '1965': 17.5967552322,
 '1970': 17.7255072424,
 '1975': 19.2726187335,
 '1980': 18.2594156912,
 '1985': 18.7161601858,
 '1990': 20.0978007897,
 '1995': 20.4481570953,
 '2000': 21.97982215,
 '2005': 21.1194114859,
 '2010': 21.1733951051,
 '2015': 22.1893741495,
 '2020': 22.8204411315,
 '2025': 23.8296396574,
 '2030': 23.4705920051,
 '2035': 23.1527920021},
{'Index': 16,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 7.7404453707,
 '1955': 7.8801027809,
 '1960': 7.8877182028,
 '1965': 8.1375427291,
 '1970': 9.2226406419,
 '1975': 10.0767488099,
 '1980': 9.9359111319,
 '1985': 9.5672931964,
 '1990': 8.9215588172,
 '1995': 9.0933704519,
 '2000': 9.4204777635,
 '2005': 9.9201527869,
 '2010': 9.955556959,
 '2015': 9.6890645398,
 '2020': 9.7723220846,
 '2025': 9.439847682,
 '2030': 9.449201596,
 '2035': 9.3265307189},
{'Index': 17,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.264215934,
 '1955': 6.5894708297,
 '1960': 7.5409167456,
 '1965': 6.8155037358,
 '1970': 6.3303310388,
 '1975': 6.7430902846,
 '1980': 6.4754467994,
 '1985': 6.6305479196,
 '1990': 6.7666235036,
 '1995': 6.5133207017,
 '2000': 6.6073309127,
 '2005': 6.653991888,
 '2010': 6.6477438108,
 '2015': 6.4345966568,
 '2020': 6.0732549339,
 '2025': 6.1480805494,
 '2030': 5.931896336,
 '2035': 5.6082563172},
{'Index': 18,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 65.7087957573,
 '1955': 63.4813869595,
 '1960': 60.9446156226,
 '1965': 59.7376812791,
 '1970': 57.554258572,
 '1975': 55.0868820467,
 '1980': 53.5702353365,
 '1985': 52.8923480344,
 '1990': 51.5168537871,
 '1995': 49.8734723689,
 '2000': 46.0281747616,
 '2005': 44.9639308326,
 '2010': 43.6985447531,
 '2015': 42.3769547112,
 '2020': 40.5721142527,
 '2025': 38.6714596744,
 '2030': 37.5593222537,
 '2035': 36.8987615249},
{'Index': 19,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 6.1840265513,
 '2005': 6.0262578325,
 '2010': 5.8919029769,
 '2015': 9.5423470697,
 '2020': 9.5012487352,
 '2025': 11.6706290357,
 '2030': 13.5382325985,
 '2035': 13.4220026235},
{'Index': 20,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 6.0276660959,
 '1995': 6.0831684035,
 '2000': 3.6920476238,
 '2005': 3.7088748096,
 '2010': 5.8725448014,
 '2015': 5.6437912512,
 '2020': 8.3894365167,
 '2025': 7.2834737154,
 '2030': 8.2797173422,
 '2035': 10.7171688659},
{'Index': 21,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.8485352207,
 '1955': 7.836645751,
 '1960': 6.8458044356,
 '1965': 5.8657364716,
 '1970': 11.0764932537,
 '1975': 13.6235974244,
 '1980': 16.8816509633,
 '1985': 22.5475902683,
 '1990': 19.9047769077,
 '1995': 22.0657717359,
 '2000': 23.3949050899,
 '2005': 23.8494272291,
 '2010': 21.1138949682,
 '2015': 20.0032177727,
 '2020': 18.1534328219,
 '2025': 20.0884519328,
 '2030': 19.4462487994,
 '2035': 18.8265669149},
{'Index': 22,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 4.4166782627,
 '1965': 8.7912874971,
 '1970': 9.1365420016,
 '1975': 11.0491226226,
 '1980': 11.4784761081,
 '1985': 9.9398299572,
 '1990': 10.7744332194,
 '1995': 9.0338971992,
 '2000': 5.7076285769,
 '2005': 6.400439775,
 '2010': 8.2167563364,
 '2015': 7.0958647999,
 '2020': 8.4362972639,
 '2025': 8.0233000499,
 '2030': 7.7479876171,
 '2035': 8.1015030709},
{'Index': 23,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 7.4170891838,
 '1955': 8.4866373562,
 '1960': 8.1604600269,
 '1965': 9.0425356055,
 '1970': 10.6443989668,
 '1975': 8.2200357745,
 '1980': 6.5171202448,
 '1985': 7.4074850716,
 '1990': 5.8427891798,
 '1995': 5.9372763042,
 '2000': 6.3396002647,
 '2005': 6.3489905399,
 '2010': 5.6607384111,
 '2015': 6.1736431859,
 '2020': 5.2865685618,
 '2025': 4.9334125732,
 '2030': 5.208692485,
 '2035': 4.9365004238},
{'Index': 24,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 83.7343755955,
 '1955': 83.6767168929,
 '1960': 80.5770572748,
 '1965': 76.3004404257,
 '1970': 69.142565778,
 '1975': 67.1072441786,
 '1980': 65.1227526838,
 '1985': 60.1050947029,
 '1990': 57.4503345972,
 '1995': 56.8798863572,
 '2000': 54.6817918935,
 '2005': 53.6660098139,
 '2010': 53.2441625059,
 '2015': 51.5411359206,
 '2020': 50.2330161004,
 '2025': 48.000732693,
 '2030': 45.7791211578,
 '2035': 43.9962581011},
{'Index': 25,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.4017794981,
 '1980': 2.7162060882,
 '1985': 5.2335317349,
 '1990': 5.5839936891,
 '1995': 8.0207262101,
 '2000': 7.8308956368,
 '2005': 9.0703895544,
 '2010': 11.0315766652,
 '2015': 11.9880972287,
 '2020': 13.6535223278,
 '2025': 14.2995092937,
 '2030': 15.5319789737,
 '2035': 16.9505749832},
{'Index': 26,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 1.7820479294,
 '1955': 4.7108058336,
 '1960': 5.6813150831,
 '1965': 8.1420397836,
 '1970': 9.7344210109,
 '1975': 7.9998341402,
 '1980': 9.8997082491,
 '1985': 7.8934850145,
 '1990': 7.6556058646,
 '1995': 6.743521687,
 '2000': 8.6902191372,
 '2005': 9.0158678552,
 '2010': 8.2001397105,
 '2015': 7.7898234296,
 '2020': 7.4640156103,
 '2025': 8.014460759,
 '2030': 8.3234931068,
 '2035': 8.2084306246},
{'Index': 27,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 19.0852557781,
 '1955': 18.068665644,
 '1960': 18.8316799913,
 '1965': 18.2500749638,
 '1970': 18.1368672136,
 '1975': 19.6446791833,
 '1980': 18.3598187519,
 '1985': 18.4228823975,
 '1990': 20.1134996031,
 '1995': 20.3079170715,
 '2000': 21.8503752153,
 '2005': 20.8525083166,
 '2010': 21.1796173092,
 '2015': 22.437424062,
 '2020': 23.3985710572,
 '2025': 24.3395335295,
 '2030': 24.0761262998,
 '2035': 23.8718416504},
{'Index': 28,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.1334637286,
 '1955': 8.2850929423,
 '1960': 8.0710329108,
 '1965': 8.1011346076,
 '1970': 9.2279673767,
 '1975': 10.0127055326,
 '1980': 9.8234984377,
 '1985': 9.5387772755,
 '1990': 8.7708628031,
 '1995': 9.0985265194,
 '2000': 9.7601164749,
 '2005': 10.2642616296,
 '2010': 10.1373913703,
 '2015': 9.9832991954,
 '2020': 9.937823382,
 '2025': 9.6329117595,
 '2030': 9.7051796163,
 '2035': 9.530139103},
{'Index': 29,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.2056792052,
 '1955': 6.491967815,
 '1960': 7.5081970427,
 '1965': 6.6914766676,
 '1970': 6.0634290799,
 '1975': 6.6458144959,
 '1980': 6.4724098938,
 '1985': 6.571077068,
 '1990': 6.8417598162,
 '1995': 6.5632611993,
 '2000': 6.6318219943,
 '2005': 6.6838107,
 '2010': 6.7509595236,
 '2015': 6.4642054653,
 '2020': 6.1707064282,
 '2025': 6.3136300495,
 '2030': 6.0407152691,
 '2035': 5.7199069663},
{'Index': 30,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 64.7935533586,
 '1955': 62.4434677651,
 '1960': 59.9077749721,
 '1965': 58.8152739774,
 '1970': 56.837315319,
 '1975': 54.29518715,
 '1980': 52.7283585793,
 '1985': 52.3402465096,
 '1990': 51.0342782238,
 '1995': 49.2660473127,
 '2000': 45.2365715415,
 '2005': 44.1131619441,
 '2010': 42.7003154213,
 '2015': 41.3371506189,
 '2020': 39.3753611946,
 '2025': 37.3999546087,
 '2030': 36.3225067343,
 '2035': 35.7191066725},
{'Index': 31,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.6630667274,
 '1980': 3.1941579391,
 '1985': 6.1981297434,
 '1990': 6.6691052544,
 '1995': 8.8150026252,
 '2000': 8.5321855208,
 '2005': 10.0542668434,
 '2010': 10.2649930665,
 '2015': 11.8886852099,
 '2020': 13.8587818893,
 '2025': 14.4587918484,
 '2030': 15.7584931205,
 '2035': 16.662007288},
{'Index': 32,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 2.1958952969,
 '1955': 3.8868868732,
 '1960': 5.1729069819,
 '1965': 8.6946344183,
 '1970': 10.6699809553,
 '1975': 8.6143270007,
 '1980': 10.2053897528,
 '1985': 7.9680258487,
 '1990': 7.8586450283,
 '1995': 6.4091470959,
 '2000': 8.0990131332,
 '2005': 7.0310823735,
 '2010': 7.5211687224,
 '2015': 6.6385806199,
 '2020': 6.004516758,
 '2025': 6.4500417098,
 '2030': 6.4979068434,
 '2035': 7.374417512},
{'Index': 33,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 16.8548244888,
 '1955': 16.9508977499,
 '1960': 17.3330849328,
 '1965': 16.453602793,
 '1970': 16.7464575386,
 '1975': 18.7169745098,
 '1980': 18.0825344148,
 '1985': 18.3962106876,
 '1990': 19.7874253672,
 '1995': 20.1767637397,
 '2000': 20.74140952,
 '2005': 20.6930705912,
 '2010': 20.8011091064,
 '2015': 21.580153375,
 '2020': 21.8294842798,
 '2025': 22.2072223733,
 '2030': 22.1417245767,
 '2035': 21.6242828038},
{'Index': 34,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.7690204414,
 '1955': 7.2918690185,
 '1960': 7.2870817288,
 '1965': 7.6006319254,
 '1970': 8.6373074551,
 '1975': 9.6767902777,
 '1980': 9.5690533575,
 '1985': 9.4228892816,
 '1990': 9.1277468924,
 '1995': 8.928109857,
 '2000': 8.5389737605,
 '2005': 8.9968278409,
 '2010': 9.029188665,
 '2015': 8.4046239247,
 '2020': 8.4660272989,
 '2025': 8.4350679839,
 '2030': 8.4776804487,
 '2035': 8.4607600338},
{'Index': 35,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 5.9094697454,
 '1955': 6.3456793883,
 '1960': 7.3865415766,
 '1965': 7.0713511561,
 '1970': 6.6721128572,
 '1975': 6.3664062734,
 '1980': 6.1698914127,
 '1985': 6.4689436272,
 '1990': 6.4376034386,
 '1995': 6.0940084669,
 '2000': 5.7616260638,
 '2005': 5.616365494,
 '2010': 5.9811063607,
 '2015': 6.3021123649,
 '2020': 6.0853198649,
 '2025': 6.1474873868,
 '2030': 6.0569979852,
 '2035': 5.7022894032},
{'Index': 36,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 68.2707900275,
 '1955': 65.5246669701,
 '1960': 62.8203847799,
 '1965': 60.1797797071,
 '1970': 57.2741411938,
 '1975': 54.9624352111,
 '1980': 52.7789731231,
 '1985': 51.5458008115,
 '1990': 50.1194740191,
 '1995': 49.5769682154,
 '2000': 48.3267920015,
 '2005': 47.608386857,
 '2010': 46.4024340789,
 '2015': 45.1858445057,
 '2020': 43.755869909,
 '2025': 42.3013886977,
 '2030': 41.0671970255,
 '2035': 40.1762429591},
{'Index': 37,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 5.9980151041,
 '1955': 6.1584170948,
 '1960': 8.5376156393,
 '1965': 9.054300989,
 '1970': 9.3656165545,
 '1975': 9.3464567498,
 '1980': 9.1564205452,
 '1985': 10.4731373615,
 '1990': 11.8768559599,
 '1995': 11.6201659951,
 '2000': 10.0653106542,
 '2005': 10.8691519165,
 '2010': 10.5672588672,
 '2015': 10.2895521873,
 '2020': 9.9966842752,
 '2025': 10.7084650511,
 '2030': 11.4884205247,
 '2035': 11.3273963859},
{'Index': 38,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 5.4991448265,
 '1955': 7.8697817081,
 '1960': 5.8320232681,
 '1965': 6.6656444304,
 '1970': 7.3741074788,
 '1975': 7.2958028512,
 '1980': 7.209593566,
 '1985': 5.7173104436,
 '1990': 5.7672098062,
 '1995': 6.3571002512,
 '2000': 8.743336158,
 '2005': 8.5160261159,
 '2010': 10.0133465453,
 '2015': 11.8388121218,
 '2020': 12.6169539308,
 '2025': 13.2613249934,
 '2030': 12.8902581368,
 '2035': 13.4730544335},
{'Index': 39,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 18.8487575215,
 '1955': 17.4621369628,
 '1960': 20.1420023048,
 '1965': 21.0775788682,
 '1970': 21.7509349755,
 '1975': 22.5679338226,
 '1980': 23.0834458036,
 '1985': 24.156721718,
 '1990': 24.1957639031,
 '1995': 24.6507928276,
 '2000': 24.3334051215,
 '2005': 24.0402240415,
 '2010': 23.3974371064,
 '2015': 23.3393801289,
 '2020': 23.9415431573,
 '2025': 23.5231854493,
 '2030': 23.7165213632,
 '2035': 23.671779024},
{'Index': 40,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 9.5574258299,
 '1955': 10.3905241798,
 '1960': 9.5437724033,
 '1965': 8.9913552809,
 '1970': 9.3713966725,
 '1975': 9.6520492766,
 '1980': 9.6569815908,
 '1985': 9.4925216876,
 '1990': 9.2506618802,
 '1995': 9.5628129075,
 '2000': 9.8860579983,
 '2005': 9.6796652632,
 '2010': 9.6410424814,
 '2015': 9.332955022,
 '2020': 10.0291945386,
 '2025': 9.6995052134,
 '2030': 9.700533982,
 '2035': 9.9838421509},
{'Index': 41,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.650542862,
 '1955': 6.315932115,
 '1960': 6.2653056066,
 '1965': 6.1852723832,
 '1970': 5.9475669687,
 '1975': 5.2785057138,
 '1980': 5.5821759411,
 '1985': 5.6884918208,
 '1990': 6.1833039745,
 '1995': 6.5645287352,
 '2000': 6.6468398594,
 '2005': 6.7059072989,
 '2010': 6.4948790032,
 '2015': 7.080955027,
 '2020': 6.6896963007,
 '2025': 6.7507647766,
 '2030': 6.7728328779,
 '2035': 6.6572655131},
{'Index': 42,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 53.446113856,
 '1955': 51.8032079396,
 '1960': 49.679280778,
 '1965': 48.0258480482,
 '1970': 46.19037735,
 '1975': 45.8592515861,
 '1980': 45.3113825533,
 '1985': 44.4718169685,
 '1990': 42.7262044762,
 '1995': 41.2445992834,
 '2000': 40.3250502087,
 '2005': 40.1890253639,
 '2010': 39.8860359966,
 '2015': 38.1183455129,
 '2020': 36.7259277973,
 '2025': 36.0567545163,
 '2030': 35.4314331154,
 '2035': 34.8866624926},
{'Index': 43,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.2339081348,
 '1980': 2.4219411356,
 '1985': 4.7411644401,
 '1990': 4.411924888,
 '1995': 6.85253529,
 '2000': 8.4049073739,
 '2005': 9.6290701369,
 '2010': 11.545586856,
 '2015': 12.4909333659,
 '2020': 14.1055036109,
 '2025': 14.7261272801,
 '2030': 15.9381656595,
 '2035': 17.3087696316},
{'Index': 44,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 3.0497016621,
 '1955': 5.3168104938,
 '1960': 6.0043202067,
 '1965': 8.0314622734,
 '1970': 8.6905922287,
 '1975': 7.1355160836,
 '1980': 8.8167716221,
 '1985': 7.0901827185,
 '1990': 7.6989443367,
 '1995': 6.6388460135,
 '2000': 7.0166751385,
 '2005': 7.5081205694,
 '2010': 6.6885375444,
 '2015': 6.7945414948,
 '2020': 6.8905874949,
 '2025': 7.3555638381,
 '2030': 7.6885478924,
 '2035': 7.6182953289},
{'Index': 45,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 15.442003576,
 '1955': 14.1892690321,
 '1960': 15.2199381257,
 '1965': 14.9625870004,
 '1970': 15.7375331595,
 '1975': 17.2187761038,
 '1980': 17.0323689295,
 '1985': 17.0587124361,
 '1990': 18.3760317981,
 '1995': 19.0141263675,
 '2000': 20.7115248085,
 '2005': 19.672953653,
 '2010': 20.2565487319,
 '2015': 21.0820157703,
 '2020': 21.5756016369,
 '2025': 22.7953983376,
 '2030': 22.7389128979,
 '2035': 22.6564869002},
{'Index': 46,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.5004341837,
 '1955': 9.2700023064,
 '1960': 8.7160440637,
 '1965': 8.7812987119,
 '1970': 10.0011550865,
 '1975': 10.3072511793,
 '1980': 9.4692935025,
 '1985': 9.3681592963,
 '1990': 8.7481159253,
 '1995': 8.7655816511,
 '2000': 9.1947211629,
 '2005': 9.9256394509,
 '2010': 9.9015547279,
 '2015': 9.8669434038,
 '2020': 10.0312403233,
 '2025': 9.6985354069,
 '2030': 9.6486383656,
 '2035': 9.4292639177},
{'Index': 47,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.7470806039,
 '1955': 6.5877848103,
 '1960': 7.702078517,
 '1965': 7.0577059411,
 '1970': 6.4405130015,
 '1975': 7.1342311195,
 '1980': 6.9549560235,
 '1985': 7.0005578931,
 '1990': 7.3611181805,
 '1995': 7.1328124512,
 '2000': 7.1540001851,
 '2005': 7.09077995,
 '2010': 7.1008649548,
 '2015': 6.7013955347,
 '2020': 6.3245023424,
 '2025': 6.3516599816,
 '2030': 6.0084220517,
 '2035': 5.6920001296},
{'Index': 48,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 66.2607799743,
 '1955': 64.6361333574,
 '1960': 62.357619087,
 '1965': 61.1669460732,
 '1970': 59.1302065239,
 '1975': 56.9703173791,
 '1980': 55.3046687868,
 '1985': 54.7412232159,
 '1990': 53.4038648715,
 '1995': 51.5960982267,
 '2000': 47.5181713311,
 '2005': 46.1734362398,
 '2010': 44.506907185,
 '2015': 43.0641704305,
 '2020': 41.0725645917,
 '2025': 39.0727151557,
 '2030': 37.9773131329,
 '2035': 37.295184092},
{'Index': 49,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.9857885799,
 '1980': 3.9530610224,
 '1985': 5.042581563,
 '1990': 4.6579021838,
 '1995': 6.4599217376,
 '2000': 8.0892093885,
 '2005': 8.640695506,
 '2010': 11.3672611719,
 '2015': 11.2560554638,
 '2020': 12.9071129577,
 '2025': 13.4706061817,
 '2030': 14.5258905859,
 '2035': 16.4448704726},
{'Index': 50,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 4.9849138183,
 '1955': 6.5322400554,
 '1960': 7.6609822613,
 '1965': 9.6016400915,
 '1970': 9.6153106878,
 '1975': 7.3578174639,
 '1980': 6.8011355974,
 '1985': 6.941072057,
 '1990': 6.5802327259,
 '1995': 6.4751073141,
 '2000': 6.6341442759,
 '2005': 8.3250911877,
 '2010': 7.248098874,
 '2015': 8.1683626836,
 '2020': 8.3047125403,
 '2025': 9.0842984112,
 '2030': 9.7353663957,
 '2035': 8.1137509664},
{'Index': 51,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 14.9381824482,
 '1955': 14.1327083375,
 '1960': 14.985808738,
 '1965': 13.7453346001,
 '1970': 15.5558834626,
 '1975': 16.9678856225,
 '1980': 17.7767176192,
 '1985': 16.7928499561,
 '1990': 18.8791301533,
 '1995': 19.3768225959,
 '2000': 21.8689084861,
 '2005': 20.538170646,
 '2010': 21.1494308622,
 '2015': 22.3369674491,
 '2020': 23.21031866,
 '2025': 24.7574793527,
 '2030': 24.6428277611,
 '2035': 25.4706123536},
{'Index': 52,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 9.1027703051,
 '1955': 10.4704465751,
 '1960': 9.242979126,
 '1965': 9.3917651731,
 '1970': 9.6273690208,
 '1975': 9.9080404169,
 '1980': 8.7956467623,
 '1985': 8.8646280797,
 '1990': 8.3323413962,
 '1995': 8.7199559441,
 '2000': 10.4018587974,
 '2005': 11.1528103352,
 '2010': 10.968321701,
 '2015': 11.4426446342,
 '2020': 11.5983467241,
 '2025': 11.1861485594,
 '2030': 10.9448736436,
 '2035': 10.5484848426},
{'Index': 53,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.8057024739,
 '1955': 5.898581513,
 '1960': 7.048617878,
 '1965': 6.3639356211,
 '1970': 6.1900923455,
 '1975': 7.0968319716,
 '1980': 7.1575995468,
 '1985': 7.2606218376,
 '1990': 7.8824379055,
 '1995': 7.8522539626,
 '2000': 7.9270662549,
 '2005': 8.2924393834,
 '2010': 8.1212648575,
 '2015': 7.2501217202,
 '2020': 6.681032911,
 '2025': 6.6665734836,
 '2030': 6.441825884,
 '2035': 6.3242979843},
{'Index': 54,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 64.1684309544,
 '1955': 62.9660235189,
 '1960': 61.0616119967,
 '1965': 60.8973245142,
 '1970': 59.0113444832,
 '1975': 56.6836359454,
 '1980': 55.5158394519,
 '1985': 55.0982465066,
 '1990': 53.6679556353,
 '1995': 51.1159384457,
 '2000': 45.0788127972,
 '2005': 43.0507929418,
 '2010': 41.1456225334,
 '2015': 39.5458480491,
 '2020': 37.2984762069,
 '2025': 34.8348940114,
 '2030': 33.7092157297,
 '2035': 33.0979833805},
{'Index': 55,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 4.2699511168,
 '1990': 4.0325100005,
 '1995': 7.4496479096,
 '2000': 8.8770128043,
 '2005': 11.0908114033,
 '2010': 11.8048028724,
 '2015': 14.2491231605,
 '2020': 15.7539610751,
 '2025': 16.3652223736,
 '2030': 17.6693034546,
 '2035': 18.2958045843},
{'Index': 56,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 3.2833461193,
 '1960': 3.119409607,
 '1965': 5.2490791434,
 '1970': 7.1058859663,
 '1975': 6.7706981351,
 '1980': 12.0051253525,
 '1985': 7.3232913412,
 '1990': 9.4245338409,
 '1995': 6.8878706412,
 '2000': 7.5887247109,
 '2005': 6.2998745977,
 '2010': 5.8751535412,
 '2015': 4.8385275527,
 '2020': 4.9453745711,
 '2025': 5.0986839179,
 '2030': 5.1795997866,
 '2035': 7.0522199639},
{'Index': 57,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 16.2359755061,
 '1955': 14.2838974343,
 '1960': 15.6276509421,
 '1965': 17.1195799884,
 '1970': 16.0488294348,
 '1975': 17.6305115171,
 '1980': 15.8549505403,
 '1985': 17.4743422502,
 '1990': 17.6000129985,
 '1995': 18.46251399,
 '2000': 18.9807341651,
 '2005': 18.3933544571,
 '2010': 18.9586462444,
 '2015': 19.2952454099,
 '2020': 19.3269513563,
 '2025': 20.2338823513,
 '2030': 20.4051331406,
 '2035': 19.4412503131},
{'Index': 58,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 7.5512124332,
 '1955': 7.2616089521,
 '1960': 7.7984395695,
 '1965': 7.6995412424,
 '1970': 10.6417188313,
 '1975': 10.9623944411,
 '1980': 10.5348748231,
 '1985': 10.1553429032,
 '1990': 9.3894395305,
 '1995': 8.8349722395,
 '2000': 7.3895267719,
 '2005': 8.1107341849,
 '2010': 8.3508914757,
 '2015': 7.6234974585,
 '2020': 7.8755924661,
 '2025': 7.7564418631,
 '2030': 8.0597397698,
 '2035': 8.1505149328},
{'Index': 59,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.6546983739,
 '1955': 7.7408506859,
 '1960': 8.8400145968,
 '1965': 8.2870793358,
 '1970': 6.8696632771,
 '1975': 7.1956067187,
 '1980': 6.6344124207,
 '1985': 6.5939930822,
 '1990': 6.5569932951,
 '1995': 6.038638287,
 '2000': 5.9979310731,
 '2005': 5.3136044468,
 '2010': 5.6176013449,
 '2015': 5.9201322392,
 '2020': 5.8340733863,
 '2025': 5.9405373196,
 '2030': 5.4771645307,
 '2035': 4.9695777537},
{'Index': 60,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 69.5581136868,
 '1955': 67.4302968083,
 '1960': 64.6144852846,
 '1965': 61.6447202901,
 '1970': 59.3339024904,
 '1975': 57.440789188,
 '1980': 54.9706368635,
 '1985': 54.1830793064,
 '1990': 52.9965103346,
 '1995': 52.3263569327,
 '2000': 51.1660704747,
 '2005': 50.7916209102,
 '2010': 49.3929045214,
 '2015': 48.0734741793,
 '2020': 46.2640471451,
 '2025': 44.6052321745,
 '2030': 43.2090593176,
 '2035': 42.0906324522},
{'Index': 61,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 0.0,
 '2005': 0.0,
 '2010': 0.0,
 '2015': 5.8416254105,
 '2020': 5.905218633,
 '2025': 6.005625883,
 '2030': 9.1133010966,
 '2035': 9.2778467626},
{'Index': 62,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 5.6250815421,
 '2005': 5.7213522195,
 '2010': 5.7952917216,
 '2015': 2.5767157254,
 '2020': 2.7592732625,
 '2025': 4.9042961571,
 '2030': 6.6279975153,
 '2035': 9.1619604788},
{'Index': 63,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 3.4863447202,
 '1975': 7.2916949019,
 '1980': 10.5730948015,
 '1985': 16.9599025997,
 '1990': 22.6885146867,
 '1995': 23.3447307847,
 '2000': 22.9324421956,
 '2005': 24.0747253825,
 '2010': 22.5978537178,
 '2015': 23.4096309348,
 '2020': 25.3522384742,
 '2025': 25.710506256,
 '2030': 22.2584864222,
 '2035': 21.2659790105},
{'Index': 64,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 4.3241387841,
 '1955': 3.992237951,
 '1960': 6.32845821,
 '1965': 8.9464942536,
 '1970': 7.5824772748,
 '1975': 13.2370956124,
 '1980': 15.6877777413,
 '1985': 14.4383253186,
 '1990': 13.6922594252,
 '1995': 13.1345366298,
 '2000': 9.0167412806,
 '2005': 8.2545138601,
 '2010': 10.663650992,
 '2015': 7.2954130508,
 '2020': 6.9097206665,
 '2025': 7.1427681558,
 '2030': 8.1992178686,
 '2035': 8.9002280045},
{'Index': 65,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 3.2850046577,
 '1955': 3.1198684554,
 '1960': 4.3563487284,
 '1965': 8.0172061574,
 '1970': 13.8352167833,
 '1975': 9.193734916,
 '1980': 8.9236409958,
 '1985': 8.7289263387,
 '1990': 6.3487868167,
 '1995': 5.636434019,
 '2000': 5.9923605612,
 '2005': 6.4166134556,
 '2010': 4.6562850937,
 '2015': 6.4380272678,
 '2020': 5.7098138395,
 '2025': 5.7984160326,
 '2030': 6.4306402135,
 '2035': 5.9404767068},
{'Index': 66,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 92.3908565583,
 '1955': 92.8878935936,
 '1960': 89.3151930616,
 '1965': 83.036299589,
 '1970': 75.0959612217,
 '1975': 70.2774745698,
 '1980': 64.8154864615,
 '1985': 59.872845743,
 '1990': 57.2704390714,
 '1995': 57.8842985664,
 '2000': 56.4333744205,
 '2005': 55.5327950823,
 '2010': 56.2869184748,
 '2015': 54.4385876107,
 '2020': 53.3637351243,
 '2025': 50.4383875155,
 '2030': 47.3703568838,
 '2035': 45.4535090369},
{'Index': 67,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 0.0,
 '2005': 0.0,
 '2010': 3.4176508742,
 '2015': 6.3425306416,
 '2020': 6.2595760794,
 '2025': 8.0996073296,
 '2030': 9.8221556071,
 '2035': 9.9692661616},
{'Index': 68,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 3.5821587719,
 '2000': 6.623120683,
 '2005': 6.623046028,
 '2010': 4.8058184588,
 '2015': 3.2299221718,
 '2020': 5.6722657046,
 '2025': 6.8183527181,
 '2030': 9.9339666072,
 '2035': 13.9018614477},
{'Index': 69,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 4.009989572,
 '1960': 3.4790438024,
 '1965': 5.8793459914,
 '1970': 9.7216067038,
 '1975': 10.9366169821,
 '1980': 18.0755248762,
 '1985': 22.9091052115,
 '1990': 24.587305539,
 '1995': 22.8642012703,
 '2000': 25.5679666644,
 '2005': 27.2532377441,
 '2010': 24.6012309888,
 '2015': 25.7978648697,
 '2020': 24.8923190512,
 '2025': 24.4279597304,
 '2030': 21.6874598941,
 '2035': 20.0008799767},
{'Index': 70,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 10.4029001692,
 '1955': 7.4035311049,
 '1960': 12.1671063801,
 '1965': 10.8469091931,
 '1970': 12.9605458941,
 '1975': 15.6409493646,
 '1980': 11.4356677635,
 '1985': 12.3695360291,
 '1990': 13.0287507771,
 '1995': 12.8959536002,
 '2000': 9.3184337848,
 '2005': 8.3668430613,
 '2010': 10.5694567316,
 '2015': 8.8076411596,
 '2020': 9.3638981831,
 '2025': 9.6111324478,
 '2030': 9.8143320225,
 '2035': 9.4594880635},
{'Index': 71,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.2804904252,
 '1955': 6.87379712,
 '1960': 5.8236748548,
 '1965': 9.4168963385,
 '1970': 8.820086616,
 '1975': 9.8545159121,
 '1980': 11.7014209672,
 '1985': 9.318536197,
 '1990': 8.6098498657,
 '1995': 6.7814527249,
 '2000': 6.5259076391,
 '2005': 6.5346686482,
 '2010': 5.9752012819,
 '2015': 7.1003534325,
 '2020': 6.1369359413,
 '2025': 5.4186918651,
 '2030': 5.3397811331,
 '2035': 4.674304323},
{'Index': 72,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 81.3166094056,
 '1955': 81.7126822031,
 '1960': 78.5301749627,
 '1965': 73.8568484769,
 '1970': 68.4977607861,
 '1975': 63.5679177412,
 '1980': 58.7873863931,
 '1985': 55.4028225624,
 '1990': 53.7740938181,
 '1995': 53.8762336326,
 '2000': 51.9645712287,
 '2005': 51.2222045184,
 '2010': 50.6306416647,
 '2015': 48.7216877249,
 '2020': 47.6750050404,
 '2025': 45.624255909,
 '2030': 43.402304736,
 '2035': 41.9942000275},
{'Index': 73,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 4.9465631609,
 '2000': 4.764223346,
 '2005': 4.4494297207,
 '2010': 6.6914008495,
 '2015': 8.6783897691,
 '2020': 8.4410728034,
 '2025': 9.7453401143,
 '2030': 11.037252154,
 '2035': 11.1228494191},
{'Index': 74,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 6.7578469644,
 '1975': 6.2499856467,
 '1980': 5.7137375041,
 '1985': 5.1817783168,
 '1990': 4.9433206409,
 '1995': 2.4739791947,
 '2000': 4.6927402317,
 '2005': 4.8231225269,
 '2010': 3.5933931777,
 '2015': 3.5129460335,
 '2020': 6.3168439127,
 '2025': 7.2207312645,
 '2030': 9.783427887,
 '2035': 13.1332944339},
{'Index': 75,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 10.8116602114,
 '1955': 12.7971950798,
 '1960': 11.9447314271,
 '1965': 16.8828609542,
 '1970': 11.8755642877,
 '1975': 12.3722462049,
 '1980': 18.4022699081,
 '1985': 21.2919558522,
 '1990': 22.9204802112,
 '1995': 21.7239794346,
 '2000': 23.9285466481,
 '2005': 25.1361936217,
 '2010': 23.4342383518,
 '2015': 23.2273396044,
 '2020': 22.0393028222,
 '2025': 22.2576895028,
 '2030': 20.27329018,
 '2035': 18.9134433113},
{'Index': 76,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 9.8486320539,
 '1955': 9.2130882146,
 '1960': 12.1501270789,
 '1965': 7.7270820744,
 '1970': 9.8482478327,
 '1975': 12.923396953,
 '1980': 9.4359118154,
 '1985': 10.047188515,
 '1990': 10.2156097175,
 '1995': 10.6432733791,
 '2000': 8.2205896181,
 '2005': 7.7540270578,
 '2010': 9.5561671565,
 '2015': 8.6006268348,
 '2020': 8.9488177596,
 '2025': 9.0335835401,
 '2030': 9.2941517372,
 '2035': 9.2696482216},
{'Index': 77,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.5014374921,
 '1955': 4.2307318364,
 '1960': 4.8534416935,
 '1965': 8.0558381832,
 '1970': 7.9165237229,
 '1975': 8.151570167,
 '1980': 9.752000129,
 '1985': 8.7164051093,
 '1990': 8.3190840961,
 '1995': 6.8029841879,
 '2000': 6.5215499072,
 '2005': 6.7068897424,
 '2010': 6.1754402908,
 '2015': 7.0435464945,
 '2020': 6.1594864974,
 '2025': 5.5060371265,
 '2030': 5.4478100907,
 '2035': 4.8334347023},
{'Index': 78,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 72.8382702426,
 '1955': 73.7589848693,
 '1960': 71.0516998006,
 '1965': 67.3342187881,
 '1970': 63.6018171924,
 '1975': 60.3028010284,
 '1980': 56.6960806433,
 '1985': 54.7626722068,
 '1990': 53.6015053343,
 '1995': 53.4092206427,
 '2000': 51.8723502489,
 '2005': 51.1303373305,
 '2010': 50.5493601737,
 '2015': 48.9371512637,
 '2020': 48.0944762046,
 '2025': 46.2366184518,
 '2030': 44.1640679511,
 '2035': 42.7273299118}]},
'City Size Class-Population': {'headers': ['Index',
'Country Code',
'Region, subregion, country or area *',
'Size class of urban settlement',
'Size class code',
'Type of data',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 23613.112,
 '1955': 26932.041,
 '1960': 41457.183,
 '1965': 48526.451,
 '1970': 54760.193,
 '1975': 69526.988,
 '1980': 86294.534,
 '1985': 132780.054,
 '1990': 153300.37,
 '1995': 207532.416,
 '2000': 245385.636,
 '2005': 307461.011,
 '2010': 387088.566,
 '2015': 462785.215,
 '2020': 556770.452,
 '2025': 635937.9529999999,
 '2030': 751933.6099999999,
 '2035': 862082.262},
{'Index': 2,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 32171.681,
 '1955': 57007.156,
 '1960': 59505.799,
 '1965': 86212.553,
 '1970': 107259.766,
 '1975': 107966.049,
 '1980': 139605.527,
 '1985': 128399.796,
 '1990': 156171.978,
 '1995': 162655.412,
 '2000': 213794.333,
 '2005': 247683.4680000001,
 '2010': 269408.067,
 '2015': 310164.526,
 '2020': 348132.322,
 '2025': 403943.5440000001,
 '2030': 447814.675,
 '2035': 492676.6230000001},
{'Index': 3,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 127484.471,
 '1955': 136655.322,
 '1960': 176858.598,
 '1965': 207024.244,
 '1970': 244402.211,
 '1975': 294579.1630000001,
 '1980': 335935.742,
 '1985': 392333.506,
 '1990': 467060.399,
 '1995': 537473.6059999999,
 '2000': 625856.752,
 '2005': 676050.5519999999,
 '2010': 760382.723,
 '2015': 865037.3790000001,
 '2020': 976785.9700000004,
 '2025': 1103811.7840000002,
 '2030': 1182838.8229999999,
 '2035': 1262973.9999999993},
{'Index': 4,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 67471.331,
 '1955': 85405.137,
 '1960': 92779.124,
 '1965': 105474.573,
 '1970': 130937.369,
 '1975': 155516.426,
 '1980': 170247.252,
 '1985': 191861.165,
 '1990': 207591.193,
 '1995': 235807.58,
 '2000': 269040.878,
 '2005': 314621.784,
 '2010': 354550.8590000001,
 '2015': 382399.6310000002,
 '2020': 431400.5710000001,
 '2025': 455243.9890000001,
 '2030': 493629.1040000001,
 '2035': 527264.275},
{'Index': 5,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 49853.773,
 '1955': 56063.298,
 '1960': 71229.868,
 '1965': 79383.956,
 '1970': 86556.467,
 '1975': 98833.399,
 '1980': 113703.073,
 '1985': 132241.646,
 '1990': 158963.6979999999,
 '1995': 177776.0140000001,
 '2000': 199622.9420000001,
 '2005': 223632.838,
 '2010': 245568.8890000001,
 '2015': 269751.3089999999,
 '2020': 278899.723,
 '2025': 305522.6409999999,
 '2030': 319826.6560000001,
 '2035': 327830.1029999998},
{'Index': 6,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 450308.5699999997,
 '1955': 514945.8880000003,
 '1960': 582014.9449999996,
 '1965': 661847.447,
 '1970': 730299.4900000002,
 '1975': 812202.9689999998,
 '1980': 908414.9009999993,
 '1985': 1030322.8960000005,
 '1990': 1147140.4579999999,
 '1995': 1254260.2070000009,
 '2000': 1314606.9720000003,
 '2005': 1446456.2099999993,
 '2010': 1577869.042,
 '2015': 1691359.6029999992,
 '2020': 1787004.906,
 '2025': 1870186.3920000007,
 '2030': 1971214.678000002,
 '2035': 2083006.2140000004},
{'Index': 7,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 23613.112,
 '1955': 26932.041,
 '1960': 41457.183,
 '1965': 48526.451,
 '1970': 54760.193,
 '1975': 58793.128,
 '1980': 61177.46,
 '1985': 73894.386,
 '1990': 77887.814,
 '1995': 80807.821,
 '2000': 92726.169,
 '2005': 105291.897,
 '2010': 108619.067,
 '2015': 110336.313,
 '2020': 111363.802,
 '2025': 111873.577,
 '2030': 123132.254,
 '2035': 124398.773},
{'Index': 8,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 27005.541,
 '1955': 40164.941,
 '1960': 34489.256,
 '1965': 42346.246,
 '1970': 44910.848,
 '1975': 46708.84,
 '1980': 48061.772,
 '1985': 39585.366,
 '1990': 46161.335,
 '1995': 47777.716,
 '2000': 49655.923,
 '2005': 51397.273,
 '2010': 58679.941,
 '2015': 82847.979,
 '2020': 92752.455,
 '2025': 106883.46,
 '2030': 105325.757,
 '2035': 108490.153},
{'Index': 9,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 70854.034,
 '1955': 70615.736,
 '1960': 92345.043,
 '1965': 106939.581,
 '1970': 123846.462,
 '1975': 137282.951,
 '1980': 154784.267,
 '1985': 165627.102,
 '1990': 173561.884,
 '1995': 186391.019,
 '2000': 189683.099,
 '2005': 190818.589,
 '2010': 201240.529,
 '2015': 198821.644,
 '2020': 206515.31,
 '2025': 210784.327,
 '2030': 216423.565,
 '2035': 224564.491},
{'Index': 10,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 43892.497,
 '1955': 55784.023,
 '1960': 56212.835,
 '1965': 59190.857,
 '1970': 68211.81,
 '1975': 73273.611,
 '1980': 71673.18,
 '1985': 75973.792,
 '1990': 77305.084,
 '1995': 79679.866,
 '2000': 82098.319,
 '2005': 86699.94,
 '2010': 91646.779,
 '2015': 91494.299,
 '2020': 101550.112,
 '2025': 101481.058,
 '2030': 104552.74,
 '2035': 108966.638},
{'Index': 11,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 30771.808,
 '1955': 31293.638,
 '1960': 36271.299,
 '1965': 40619.571,
 '1970': 43502.252,
 '1975': 43798.711,
 '1980': 49460.232,
 '1985': 51926.685,
 '1990': 60147.217,
 '1995': 65946.206,
 '2000': 68505.245,
 '2005': 70753.126,
 '2010': 70016.785,
 '2015': 76558.409,
 '2020': 73905.873,
 '2025': 75120.301,
 '2030': 75577.379,
 '2035': 76298.163},
{'Index': 12,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 250147.376,
 '1955': 276320.904,
 '1960': 299484.7669999999,
 '1965': 322078.8009999999,
 '1970': 338858.1250000001,
 '1975': 362603.566,
 '1980': 376945.148,
 '1985': 389644.792,
 '1990': 394813.363,
 '1995': 397962.6140000001,
 '2000': 401211.1769999999,
 '2005': 413381.191,
 '2010': 423887.8279999998,
 '2015': 419030.161,
 '2020': 417552.447,
 '2025': 420954.436,
 '2030': 424687.7690000001,
 '2035': 428085.942},
{'Index': 13,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 58885.668,
 '1990': 75412.556,
 '1995': 126724.595,
 '2000': 152659.467,
 '2005': 202169.114,
 '2010': 278469.499,
 '2015': 352448.9020000001,
 '2020': 445406.65,
 '2025': 524064.3759999999,
 '2030': 628801.356,
 '2035': 737683.489},
{'Index': 14,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 5166.14,
 '1955': 16842.215,
 '1960': 25016.543,
 '1965': 43866.307,
 '1970': 62348.918,
 '1975': 61257.209,
 '1980': 91543.755,
 '1985': 88814.43,
 '1990': 110010.643,
 '1995': 114877.696,
 '2000': 164138.41,
 '2005': 196286.195,
 '2010': 210728.126,
 '2015': 227316.547,
 '2020': 255379.867,
 '2025': 297060.084,
 '2030': 342488.9180000001,
 '2035': 384186.47},
{'Index': 15,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 56630.437,
 '1955': 66039.586,
 '1960': 84513.555,
 '1965': 100084.663,
 '1970': 120555.749,
 '1975': 157296.212,
 '1980': 181151.4749999999,
 '1985': 226706.404,
 '1990': 293498.515,
 '1995': 351082.5869999999,
 '2000': 436173.6530000002,
 '2005': 485231.9630000002,
 '2010': 559142.1939999999,
 '2015': 666215.7350000003,
 '2020': 770270.6600000003,
 '2025': 893027.4570000004,
 '2030': 966415.258,
 '2035': 1038409.5089999997},
{'Index': 16,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 23578.834,
 '1955': 29621.114,
 '1960': 36566.289,
 '1965': 46283.716,
 '1970': 62725.559,
 '1975': 82242.815,
 '1980': 98574.072,
 '1985': 115887.373,
 '1990': 130286.109,
 '1995': 156127.7140000001,
 '2000': 186942.5590000001,
 '2005': 227921.8440000001,
 '2010': 262904.0800000001,
 '2015': 290905.332,
 '2020': 329850.459,
 '2025': 353762.931,
 '2030': 389076.364,
 '2035': 418297.6369999998},
{'Index': 17,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 19081.965,
 '1955': 24769.66,
 '1960': 34958.569,
 '1965': 38764.385,
 '1970': 43054.215,
 '1975': 55034.688,
 '1980': 64242.841,
 '1985': 80314.9609999999,
 '1990': 98816.481,
 '1995': 111829.808,
 '2000': 131117.697,
 '2005': 152879.7120000001,
 '2010': 175552.104,
 '2015': 193192.9,
 '2020': 204993.85,
 '2025': 230402.3400000001,
 '2030': 244249.2769999999,
 '2035': 251531.94},
{'Index': 18,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 200161.194,
 '1955': 238624.9839999999,
 '1960': 282530.178,
 '1965': 339768.6459999999,
 '1970': 391441.365,
 '1975': 449599.4029999998,
 '1980': 531469.7529999998,
 '1985': 640678.1040000004,
 '1990': 752327.0950000003,
 '1995': 856297.5929999995,
 '2000': 913395.7950000003,
 '2005': 1033075.0190000002,
 '2010': 1153981.2139999997,
 '2015': 1272329.4420000003,
 '2020': 1369452.4589999998,
 '2025': 1449231.9559999995,
 '2030': 1546526.9090000011,
 '2035': 1654920.271999999},
{'Index': 19,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 10284.947,
 '2005': 12330.879,
 '2010': 14730.537,
 '2015': 29194.883,
 '2020': 35348.299,
 '2025': 52459.235,
 '2030': 72907.289,
 '2035': 85793.95},
{'Index': 20,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 6620.697,
 '1995': 8332.474,
 '2000': 6140.419,
 '2005': 7589.069,
 '2010': 14682.139,
 '2015': 17267.222,
 '2020': 31211.93,
 '2025': 32739.063,
 '2030': 44588.667,
 '2035': 68504.55},
{'Index': 21,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 1302.462,
 '1955': 1439.948,
 '1960': 1591.991,
 '1965': 1759.991,
 '1970': 4389.205,
 '1975': 6870.816,
 '1980': 11376.093,
 '1985': 19419.281,
 '1990': 21863.105,
 '1995': 30224.787,
 '2000': 38909.173,
 '2005': 48800.501,
 '2010': 52787.531,
 '2015': 61199.996,
 '2020': 67537.751,
 '2025': 90297.174,
 '2030': 104723.661,
 '2035': 120340.13},
{'Index': 22,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 1027.098,
 '1965': 2637.791,
 '1970': 3620.474,
 '1975': 5572.426,
 '1980': 7735.038,
 '1985': 8560.753,
 '1990': 11834.474,
 '1995': 12374.261,
 '2000': 9492.627,
 '2005': 13096.527,
 '2010': 20542.978,
 '2015': 21709.852,
 '2020': 31386.27,
 '2025': 36064.567,
 '2030': 41725.149,
 '2035': 51785.115},
{'Index': 23,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 1091.76,
 '1955': 1559.381,
 '1960': 1897.714,
 '1965': 2713.177,
 '1970': 4217.982,
 '1975': 4145.627,
 '1980': 4391.713,
 '1985': 6379.752,
 '1990': 6417.631,
 '1995': 8132.637,
 '2000': 10543.689,
 '2005': 12991.252,
 '2010': 14152.595,
 '2015': 18888.308,
 '2020': 19668.068,
 '2025': 22175.587,
 '2030': 28050.312,
 '2035': 31554.298},
{'Index': 24,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 12325.299,
 '1955': 15375.216,
 '1960': 18738.185,
 '1965': 22893.645,
 '1970': 27398.644,
 '1975': 33844.33,
 '1980': 43884.481,
 '1985': 51765.963,
 '1990': 63102.576,
 '1995': 77911.73,
 '2000': 90943.874,
 '2005': 109810.946,
 '2010': 133117.451,
 '2015': 157690.495,
 '2020': 186886.137,
 '2025': 215762.2960000001,
 '2030': 246533.7770000001,
 '2035': 281225.751},
{'Index': 25,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 58885.668,
 '1990': 75412.556,
 '1995': 126724.595,
 '2000': 142374.52,
 '2005': 189838.235,
 '2010': 263738.9620000001,
 '2015': 323254.019,
 '2020': 410058.351,
 '2025': 471605.141,
 '2030': 555894.067,
 '2035': 651889.539},
{'Index': 26,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 5166.14,
 '1955': 16842.215,
 '1960': 25016.543,
 '1965': 43866.307,
 '1970': 62348.918,
 '1975': 61257.209,
 '1980': 91543.755,
 '1985': 88814.43,
 '1990': 103389.946,
 '1995': 106545.222,
 '2000': 157997.991,
 '2005': 188697.126,
 '2010': 196045.9870000001,
 '2015': 210049.325,
 '2020': 224167.937,
 '2025': 264321.0210000001,
 '2030': 297900.2510000001,
 '2035': 315681.92},
{'Index': 27,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 55327.975,
 '1955': 64599.638,
 '1960': 82921.564,
 '1965': 98324.672,
 '1970': 116166.544,
 '1975': 150425.396,
 '1980': 169775.382,
 '1985': 207287.123,
 '1990': 271635.41,
 '1995': 320857.7999999999,
 '2000': 397264.4800000002,
 '2005': 436431.4620000002,
 '2010': 506354.6630000001,
 '2015': 605015.7390000003,
 '2020': 702732.9090000003,
 '2025': 802730.2830000002,
 '2030': 861691.597,
 '2035': 918069.3789999998},
{'Index': 28,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 23578.834,
 '1955': 29621.114,
 '1960': 35539.191,
 '1965': 43645.925,
 '1970': 59105.085,
 '1975': 76670.389,
 '1980': 90839.034,
 '1985': 107326.62,
 '1990': 118451.635,
 '1995': 143753.453,
 '2000': 177449.9320000001,
 '2005': 214825.3170000001,
 '2010': 242361.1020000001,
 '2015': 269195.48,
 '2020': 298464.189,
 '2025': 317698.364,
 '2030': 347351.2149999999,
 '2035': 366512.5219999999},
{'Index': 29,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 17990.205,
 '1955': 23210.279,
 '1960': 33060.855,
 '1965': 36051.208,
 '1970': 38836.233,
 '1975': 50889.061,
 '1980': 59851.128,
 '1985': 73935.209,
 '1990': 92398.85,
 '1995': 103697.171,
 '2000': 120574.008,
 '2005': 139888.46,
 '2010': 161399.509,
 '2015': 174304.5919999999,
 '2020': 185325.7819999999,
 '2025': 208226.7530000001,
 '2030': 216198.9649999999,
 '2035': 219977.642},
{'Index': 30,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 187835.8950000001,
 '1955': 223249.768,
 '1960': 263791.9930000001,
 '1965': 316875.0009999999,
 '1970': 364042.7210000001,
 '1975': 415755.0729999998,
 '1980': 487585.2719999999,
 '1985': 588912.1410000002,
 '1990': 689224.5190000002,
 '1995': 778385.8629999995,
 '2000': 822451.9210000003,
 '2005': 923264.0730000001,
 '2010': 1020863.7629999998,
 '2015': 1114638.9469999997,
 '2020': 1182566.322,
 '2025': 1233469.6599999997,
 '2030': 1299993.1320000007,
 '2035': 1373694.5209999995},
{'Index': 31,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 58885.668,
 '1990': 75412.556,
 '1995': 115652.532,
 '2000': 128127.835,
 '2005': 172122.034,
 '2010': 199819.0820000001,
 '2015': 261687.194,
 '2020': 342765.952,
 '2025': 399511.4749999999,
 '2030': 483955.26,
 '2035': 565890.05},
{'Index': 32,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 5166.14,
 '1955': 11129.357,
 '1960': 18151.231,
 '1965': 37438.176,
 '1970': 56296.45,
 '1975': 55599.08,
 '1980': 80249.485,
 '1985': 75700.662,
 '1990': 88863.571,
 '1995': 84087.79,
 '2000': 121622.885,
 '2005': 120367.225,
 '2010': 146407.603,
 '2015': 146124.7819999999,
 '2020': 148508.283,
 '2025': 178221.369,
 '2030': 199555.641,
 '2035': 250456.588},
{'Index': 33,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 39653.249,
 '1955': 48535.653,
 '1960': 60820.121,
 '1965': 70847.473,
 '1970': 88356.869,
 '1975': 120804.163,
 '1980': 142190.951,
 '1985': 174774.198,
 '1990': 223751.203,
 '1995': 264718.4479999999,
 '2000': 311473.759,
 '2005': 354250.9320000001,
 '2010': 404915.8630000001,
 '2015': 475010.4559999999,
 '2020': 539903.4360000002,
 '2025': 613608.6790000004,
 '2030': 679989.133,
 '2035': 734423.3060000001},
{'Index': 34,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 15925.034,
 '1955': 20878.872,
 '1960': 25569.666,
 '1965': 32727.517,
 '1970': 45571.754,
 '1975': 62456.491,
 '1980': 75245.691,
 '1985': 89522.671,
 '1990': 103214.254,
 '1995': 117136.495,
 '2000': 128229.774,
 '2005': 154019.416,
 '2010': 175762.826,
 '2015': 184997.955,
 '2020': 209388.237,
 '2025': 233069.7119999999,
 '2030': 260355.988,
 '2035': 287351.928},
{'Index': 35,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 13902.825,
 '1955': 18169.639,
 '1960': 25918.661,
 '1965': 30448.49,
 '1970': 35203.087,
 '1975': 41090.422,
 '1980': 48516.58,
 '1985': 61458.55,
 '1990': 72794.792,
 '1995': 79953.182,
 '2000': 86522.342,
 '2005': 96148.259,
 '2010': 116428.64,
 '2015': 138718.628,
 '2020': 150506.767,
 '2025': 169861.478,
 '2030': 186014.996,
 '2035': 193666.272},
{'Index': 36,
 'Country Code': 948,
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 160616.246,
 '1955': 187617.3489999999,
 '1960': 220430.663,
 '1965': 259127.765,
 '1970': 302187.121,
 '1975': 354741.68,
 '1980': 415024.366,
 '1985': 489713.6780000001,
 '1990': 566738.3399999999,
 '1995': 650448.1219999996,
 '2000': 725723.4640000003,
 '2005': 815022.3690000001,
 '2010': 903273.0679999995,
 '2015': 994605.9339999999,
 '2020': 1082203.51,
 '2025': 1168831.4189999993,
 '2030': 1261204.7270000004,
 '2035': 1364501.6319999998},
{'Index': 37,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 23613.112,
 '1955': 26932.041,
 '1960': 41457.183,
 '1965': 48526.451,
 '1970': 54760.193,
 '1975': 58793.128,
 '1980': 61177.46,
 '1985': 73894.386,
 '1990': 88405.379,
 '1995': 91063.71,
 '2000': 82721.646,
 '2005': 94540.469,
 '2010': 97157.803,
 '2015': 98287.178,
 '2020': 98825.848,
 '2025': 109161.991,
 '2030': 120499.685,
 '2035': 121861.644},
{'Index': 38,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 21649.149,
 '1955': 34416.195,
 '1960': 28319.295,
 '1965': 35724.466,
 '1970': 43115.96,
 '1975': 45893.656,
 '1980': 48169.983,
 '1985': 40339.12,
 '1990': 42928.227,
 '1995': 49818.663,
 '2000': 71857.013,
 '2005': 74072.854,
 '2010': 92065.006,
 '2015': 113085.916,
 '2020': 124729.474,
 '2025': 135185.821,
 '2030': 135203.272,
 '2035': 144944.92},
{'Index': 39,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 74204.185,
 '1955': 76365.563,
 '1960': 97806.075,
 '1965': 112965.109,
 '1970': 127176.4,
 '1975': 141961.757,
 '1980': 154229.109,
 '1985': 170440.438,
 '1990': 180101.172,
 '1995': 193180.773,
 '2000': 199983.825,
 '2005': 209103.164,
 '2010': 215121.406,
 '2015': 222940.879,
 '2020': 236682.808,
 '2025': 239795.129,
 '2030': 248757.725,
 '2035': 254664.162},
{'Index': 40,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 37625.875,
 '1955': 45439.927,
 '1960': 46342.906,
 '1965': 48189.094,
 '1970': 54793.989,
 '1975': 60715.433,
 '1980': 64521.895,
 '1985': 66975.543,
 '1990': 68857.303,
 '1995': 74940.859,
 '2000': 81248.46,
 '2005': 84194.25,
 '2010': 88641.957,
 '2015': 89149.634,
 '2020': 99147.24,
 '2025': 98876.664,
 '2030': 101746.91,
 '2035': 107407.508},
{'Index': 41,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 26181.997,
 '1955': 27620.887,
 '1960': 30423.239,
 '1965': 33149.916,
 '1970': 34775.064,
 '1975': 33204.012,
 '1980': 37296.599,
 '1985': 40135.787,
 '1990': 46025.424,
 '1995': 51444.217,
 '2000': 54626.981,
 '2005': 58328.343,
 '2010': 59715.408,
 '2015': 67638.229,
 '2020': 66133.419,
 '2025': 68817.232,
 '2030': 71038.854,
 '2035': 71619.752},
{'Index': 42,
 'Country Code': 1503,
 'Region, subregion, country or area *': 'High-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 210407.785,
 '1955': 226546.221,
 '1960': 241233.9840000001,
 '1965': 257394.134,
 '1970': 270072.34,
 '1975': 288473.9019999999,
 '1980': 302742.2430000001,
 '1985': 313775.8529999999,
 '1990': 318032.5090000001,
 '1995': 323221.3920000001,
 '2000': 331410.9859999999,
 '2005': 349566.3080000001,
 '2010': 366721.368,
 '2015': 364111.5319999999,
 '2020': 363067.4789999999,
 '2025': 367562.2129999999,
 '2030': 371633.03,
 '2035': 375315.377},
{'Index': 43,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 58885.668,
 '1990': 64894.991,
 '1995': 116468.706,
 '2000': 162663.99,
 '2005': 212920.542,
 '2010': 289930.763,
 '2015': 352900.331,
 '2020': 443602.165,
 '2025': 508997.4879999999,
 '2030': 598731.06,
 '2035': 700155.431},
{'Index': 44,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 10522.532,
 '1955': 22590.961,
 '1960': 31186.504,
 '1965': 50488.087,
 '1970': 64143.806,
 '1975': 62072.393,
 '1980': 91435.544,
 '1985': 88060.676,
 '1990': 113243.751,
 '1995': 112836.749,
 '2000': 135796.901,
 '2005': 166021.545,
 '2010': 167961.388,
 '2015': 191962.912,
 '2020': 216701.198,
 '2025': 254239.519,
 '2030': 288826.991,
 '2035': 308166.956},
{'Index': 45,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 53280.286,
 '1955': 60289.759,
 '1960': 79052.523,
 '1965': 94059.135,
 '1970': 116156.097,
 '1975': 149787.433,
 '1980': 176636.527,
 '1985': 211870.668,
 '1990': 270293.001,
 '1995': 323172.461,
 '2000': 400839.5470000001,
 '2005': 435013.5470000001,
 '2010': 508678.918,
 '2015': 595620.0489999999,
 '2020': 678528.3150000001,
 '2025': 787905.7589999997,
 '2030': 854207.0469999999,
 '2035': 916475.445},
{'Index': 46,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 29329.456,
 '1955': 39387.949,
 '1960': 45271.227,
 '1965': 55201.775,
 '1970': 73816.851,
 '1975': 89663.556,
 '1980': 98202.612,
 '1985': 116353.34,
 '1990': 128676.013,
 '1995': 148983.684,
 '2000': 177949.615,
 '2005': 219478.361,
 '2010': 248646.1150000001,
 '2015': 278766.0050000001,
 '2020': 315471.184,
 '2025': 335222.565,
 '2030': 362459.4950000001,
 '2035': 381422.278},
{'Index': 47,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 23279.776,
 '1955': 27991.291,
 '1960': 40004.679,
 '1965': 44366.774,
 '1970': 47536.348,
 '1975': 62061.215,
 '1980': 72127.329,
 '1985': 86947.528,
 '1990': 108274.6669999999,
 '1995': 121232.42,
 '2000': 138454.615,
 '2005': 156793.199,
 '2010': 178315.682,
 '2015': 189331.304,
 '2020': 198898.459,
 '2025': 219540.3390000001,
 '2030': 225711.6020000001,
 '2035': 230246.568},
{'Index': 48,
 'Country Code': 1517,
 'Region, subregion, country or area *': 'Middle-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 228622.749,
 '1955': 274636.903,
 '1960': 323886.147,
 '1965': 384513.0550000001,
 '1970': 436430.1529999999,
 '1975': 495589.0910000001,
 '1980': 573544.682,
 '1985': 679890.676,
 '1990': 785517.3010000006,
 '1995': 876949.9960000003,
 '2000': 919640.7530000001,
 '2005': 1020999.2170000002,
 '2010': 1117649.689,
 '2015': 1216671.2889999996,
 '2020': 1291685.7900000005,
 '2025': 1350518.9440000001,
 '2030': 1426650.81,
 '2035': 1508624.0240000002},
{'Index': 49,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 38196.473,
 '1990': 41565.724,
 '1995': 66240.93,
 '2000': 93817.899,
 '2005': 113989.748,
 '2010': 169112.81,
 '2015': 186806.771,
 '2020': 235043.161,
 '2025': 263649.7670000001,
 '2030': 300515.192,
 '2035': 354731.94},
{'Index': 50,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 10522.532,
 '1955': 17371.875,
 '1960': 25276.294,
 '1965': 38584.403,
 '1970': 44817.051,
 '1975': 39771.496,
 '1980': 43213.253,
 '1985': 52577.131,
 '1990': 58720.026,
 '1995': 66396.645,
 '2000': 76942.189,
 '2005': 109826.234,
 '2010': 107831.284,
 '2015': 135563.072,
 '2020': 151231.797,
 '2025': 177799.9540000001,
 '2030': 201407.651,
 '2035': 175021.544},
{'Index': 51,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 31532.642,
 '1955': 37584.602,
 '1960': 49443.491,
 '1965': 55235.931,
 '1970': 72506.115,
 '1975': 91717.17,
 '1980': 112950.225,
 '1985': 127202.234,
 '1990': 168471.703,
 '1995': 198692.616,
 '2000': 253633.5689999999,
 '2005': 270943.571,
 '2010': 314643.926,
 '2015': 370706.8410000001,
 '2020': 422668.2359999999,
 '2025': 484559.0150000001,
 '2030': 509816.8730000001,
 '2035': 549426.0199999999},
{'Index': 52,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 19214.814,
 '1955': 27845.163,
 '1960': 30495.862,
 '1965': 37741.016,
 '1970': 44873.255,
 '1975': 53556.315,
 '1980': 55886.036,
 '1985': 67147.655,
 '1990': 74355.319,
 '1995': 89415.633,
 '2000': 120639.792,
 '2005': 147130.059,
 '2010': 163177.7150000001,
 '2015': 189903.426,
 '2020': 211210.058,
 '2025': 218937.843,
 '2030': 226430.234,
 '2035': 227541.1349999999},
{'Index': 53,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 14365.99,
 '1955': 15686.72,
 '1960': 23255.887,
 '1965': 25573.616,
 '1970': 28852.077,
 '1975': 38360.781,
 '1980': 45478.164,
 '1985': 54997.652,
 '1990': 70340.515,
 '1995': 80518.097,
 '2000': 91937.378,
 '2005': 109395.485,
 '2010': 120821.533,
 '2015': 120323.841,
 '2020': 121664.008,
 '2025': 130479.692,
 '2030': 133270.076,
 '2035': 136421.293},
{'Index': 54,
 'Country Code': 1502,
 'Region, subregion, country or area *': 'Upper-middle-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 135451.563,
 '1955': 167452.188,
 '1960': 201463.886,
 '1965': 244717.245,
 '1970': 275052.4160000001,
 '1975': 306394.2549999999,
 '1980': 352738.154,
 '1985': 417357.3910000001,
 '1990': 478916.7620000002,
 '1995': 524149.895,
 '2000': 522819.8830000001,
 '2005': 567934.4950000001,
 '2010': 612130.9029999999,
 '2015': 656307.3719999996,
 '2020': 679218.643,
 '2025': 681796.4659999997,
 '2030': 697384.5339999999,
 '2035': 713955.8730000001},
{'Index': 55,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 20689.195,
 '1990': 23329.267,
 '1995': 50227.776,
 '2000': 68846.091,
 '2005': 98930.794,
 '2010': 120817.953,
 '2015': 166093.56,
 '2020': 208559.004,
 '2025': 245347.721,
 '2030': 298215.868,
 '2035': 345423.491},
{'Index': 56,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 5219.086,
 '1960': 5910.21,
 '1965': 11903.684,
 '1970': 19326.755,
 '1975': 22300.897,
 '1980': 48222.291,
 '1985': 35483.545,
 '1990': 54523.725,
 '1995': 46440.104,
 '2000': 58854.712,
 '2005': 56195.311,
 '2010': 60130.104,
 '2015': 56399.84,
 '2020': 65469.401,
 '2025': 76439.565,
 '2030': 87419.34,
 '2035': 133145.412},
{'Index': 57,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 21747.644,
 '1955': 22705.157,
 '1960': 29609.032,
 '1965': 38823.204,
 '1970': 43649.982,
 '1975': 58070.263,
 '1980': 63686.302,
 '1985': 84668.434,
 '1990': 101821.298,
 '1995': 124479.845,
 '2000': 147205.9780000001,
 '2005': 164069.976,
 '2010': 194034.9919999999,
 '2015': 224913.208,
 '2020': 255860.0790000001,
 '2025': 303346.7439999999,
 '2030': 344390.174,
 '2035': 367049.4249999999},
{'Index': 58,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 10114.642,
 '1955': 11542.786,
 '1960': 14775.365,
 '1965': 17460.759,
 '1970': 28943.596,
 '1975': 36107.241,
 '1980': 42316.576,
 '1985': 49205.685,
 '1990': 54320.694,
 '1995': 59568.051,
 '2000': 57309.823,
 '2005': 72348.302,
 '2010': 85468.4,
 '2015': 88862.579,
 '2020': 104261.126,
 '2025': 116284.722,
 '2030': 136029.261,
 '2035': 153881.143},
{'Index': 59,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 8913.786,
 '1955': 12304.571,
 '1960': 16748.792,
 '1965': 18793.158,
 '1970': 18684.271,
 '1975': 23700.434,
 '1980': 26649.165,
 '1985': 31949.876,
 '1990': 37934.152,
 '1995': 40714.323,
 '2000': 46517.237,
 '2005': 47397.714,
 '2010': 57494.149,
 '2015': 69007.463,
 '2020': 77234.451,
 '2025': 89060.647,
 '2030': 92441.526,
 '2035': 93825.275},
{'Index': 60,
 'Country Code': 1501,
 'Region, subregion, country or area *': 'Lower-middle-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 93171.186,
 '1955': 107184.715,
 '1960': 122422.261,
 '1965': 139795.81,
 '1970': 161377.7369999999,
 '1975': 189194.836,
 '1980': 220806.528,
 '1985': 262533.285,
 '1990': 306600.539,
 '1995': 352800.101,
 '2000': 396820.8699999999,
 '2005': 453064.7219999998,
 '2010': 505518.7860000001,
 '2015': 560363.9170000001,
 '2020': 612467.1469999999,
 '2025': 668722.4779999995,
 '2030': 729266.2760000001,
 '2035': 794668.1510000002},
{'Index': 61,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 0.0,
 '2005': 0.0,
 '2010': 0.0,
 '2015': 11597.706,
 '2020': 14342.439,
 '2025': 17778.474,
 '2030': 32702.865,
 '2035': 40065.187},
{'Index': 62,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 6140.419,
 '2005': 7589.069,
 '2010': 9381.673,
 '2015': 5115.698,
 '2020': 6701.65,
 '2025': 14518.204,
 '2030': 23784.412,
 '2035': 39564.747},
{'Index': 63,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 1069.714,
 '1975': 2829.973,
 '1980': 5070.106,
 '1985': 10022.4,
 '1990': 16666.226,
 '1995': 21120.372,
 '2000': 25033.38,
 '2005': 31933.841,
 '2010': 36582.399,
 '2015': 46476.451,
 '2020': 61574.847,
 '2025': 76110.896,
 '2030': 79874.051,
 '2035': 91834.393},
{'Index': 64,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 516.0,
 '1955': 577.261,
 '1960': 1164.991,
 '1965': 2083.704,
 '1970': 2326.529,
 '1975': 5137.437,
 '1980': 7522.745,
 '1985': 8532.282,
 '1990': 10057.877,
 '1995': 11883.037,
 '2000': 9842.803,
 '2005': 10949.173,
 '2010': 17262.787,
 '2015': 14483.992,
 '2020': 16782.147,
 '2025': 21144.76,
 '2030': 29422.699,
 '2035': 38434.489},
{'Index': 65,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 392.0,
 '1955': 451.12,
 '1960': 801.95,
 '1965': 1867.266,
 '1970': 4245.055,
 '1975': 3568.172,
 '1980': 4279.145,
 '1985': 5158.331,
 '1990': 4663.607,
 '1995': 5099.377,
 '2000': 6541.346,
 '2005': 8511.296,
 '2010': 7537.799,
 '2015': 12781.776,
 '2020': 13867.845,
 '2025': 17165.07,
 '2030': 23076.2,
 '2035': 25653.184},
{'Index': 66,
 'Country Code': 1500,
 'Region, subregion, country or area *': 'Low-income countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 11025.012,
 '1955': 13431.203,
 '1960': 16441.824,
 '1965': 19339.762,
 '1970': 23041.669,
 '1975': 27275.326,
 '1980': 31080.908,
 '1985': 35381.666,
 '1990': 42068.954,
 '1995': 52368.902,
 '2000': 61603.474,
 '2005': 73661.295,
 '2010': 91119.738,
 '2015': 108079.976,
 '2020': 129608.43,
 '2025': 149312.924,
 '2030': 169987.403,
 '2035': 196285.128},
{'Index': 67,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 0.0,
 '2005': 0.0,
 '2010': 10441.182,
 '2015': 23836.912,
 '2020': 28710.771,
 '2025': 44962.764,
 '2030': 65431.785,
 '2035': 78979.067},
{'Index': 68,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 5982.68,
 '2000': 13421.125,
 '2005': 16448.468,
 '2010': 14682.139,
 '2015': 12138.904,
 '2020': 26016.957,
 '2025': 37850.228,
 '2030': 66176.631,
 '2035': 110134.089},
{'Index': 69,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 1022.266,
 '1960': 1147.725,
 '1965': 2423.938,
 '1970': 5040.317,
 '1975': 7227.519,
 '1980': 15204.819,
 '1985': 24463.299,
 '1990': 33324.87,
 '1995': 38186.247,
 '2000': 51811.056,
 '2005': 67683.964,
 '2010': 75158.622,
 '2015': 96955.217,
 '2020': 114173.494,
 '2025': 135605.165,
 '2030': 144474.316,
 '2035': 158452.068},
{'Index': 70,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 2074.576,
 '1955': 1887.381,
 '1960': 4013.888,
 '1965': 4471.966,
 '1970': 6719.595,
 '1975': 10336.401,
 '1980': 9619.486,
 '1985': 13208.707,
 '1990': 17658.764,
 '1995': 21537.952,
 '2000': 18882.921,
 '2005': 20779.223,
 '2010': 32290.49,
 '2015': 33101.451,
 '2020': 42949.352,
 '2025': 53353.584,
 '2030': 65379.667,
 '2035': 74940.475},
{'Index': 71,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 1651.319,
 '1955': 1752.336,
 '1960': 1921.211,
 '1965': 3882.4,
 '1970': 4572.91,
 '1975': 6512.407,
 '1980': 9843.033,
 '1985': 9950.722,
 '1990': 11669.523,
 '1995': 11325.925,
 '2000': 13224.132,
 '2005': 16228.981,
 '2010': 18254.692,
 '2015': 26685.011,
 '2020': 28148.258,
 '2025': 30080.392,
 '2030': 35571.765,
 '2035': 37031.03},
{'Index': 72,
 'Country Code': 947,
 'Region, subregion, country or area *': 'Sub-Saharan Africa',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 16216.39,
 '1955': 20831.001,
 '1960': 25906.844,
 '1965': 30449.717,
 '1970': 35513.721,
 '1975': 42009.182,
 '1980': 49450.933,
 '1985': 59161.447,
 '1990': 72883.736,
 '1995': 89980.452,
 '2000': 105301.268,
 '2005': 127211.375,
 '2010': 154680.441,
 '2015': 183109.022,
 '2020': 218670.743,
 '2025': 253270.63,
 '2030': 289131.061,
 '2035': 332688.7540000001},
{'Index': 73,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 11961.986,
 '2000': 13625.565,
 '2005': 15174.05,
 '2010': 27340.197,
 '2015': 42656.984,
 '2020': 49611.375,
 '2025': 68036.989,
 '2030': 90948.481,
 '2035': 107483.418},
{'Index': 74,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 5584.507,
 '1975': 6449.922,
 '1980': 7348.778,
 '1985': 8328.255,
 '1990': 9892.143,
 '1995': 5982.68,
 '2000': 13421.125,
 '2005': 16448.468,
 '2010': 14682.139,
 '2015': 17267.222,
 '2020': 37126.479,
 '2025': 50411.459,
 '2030': 80616.796,
 '2035': 126910.949},
{'Index': 75,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 3530.976,
 '1955': 5300.498,
 '1960': 6331.714,
 '1965': 11201.538,
 '1970': 9813.654,
 '1975': 12768.033,
 '1980': 23668.255,
 '1985': 34220.846,
 '1990': 45866.47,
 '1995': 52533.836,
 '2000': 68435.072,
 '2005': 85722.864,
 '2010': 95749.262,
 '2015': 114169.596,
 '2020': 129533.312,
 '2025': 155391.824,
 '2030': 167054.709,
 '2035': 182766.255},
{'Index': 76,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 3216.461,
 '1955': 3815.989,
 '1960': 6440.591,
 '1965': 5126.809,
 '1970': 8138.333,
 '1975': 13336.815,
 '1980': 12136.088,
 '1985': 16148.037,
 '1990': 20442.589,
 '1995': 25738.009,
 '2000': 23510.69,
 '2005': 26443.837,
 '2010': 39045.261,
 '2015': 42274.755,
 '2020': 52595.584,
 '2025': 63067.868,
 '2030': 76585.093,
 '2035': 89575.381},
{'Index': 77,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 2123.302,
 '1955': 1752.336,
 '1960': 2572.733,
 '1965': 5344.934,
 '1970': 6542.007,
 '1975': 8412.338,
 '1980': 12542.628,
 '1985': 14009.176,
 '1990': 16647.427,
 '1995': 16451.261,
 '2000': 18651.477,
 '2005': 22872.747,
 '2010': 25232.049,
 '2015': 34621.221,
 '2020': 36201.63,
 '2025': 38440.34,
 '2030': 44890.707,
 '2035': 46706.924},
{'Index': 78,
 'Country Code': 903,
 'Region, subregion, country or area *': 'AFRICA',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 23788.223,
 '1955': 30550.394,
 '1960': 37663.387,
 '1965': 44675.296,
 '1970': 52558.869,
 '1975': 62231.881,
 '1980': 72920.205,
 '1985': 88015.633,
 '1990': 107262.667,
 '1995': 129156.412,
 '2000': 148353.683,
 '2005': 174371.626,
 '2010': 206538.137,
 '2015': 240541.314,
 '2020': 282669.4130000001,
 '2025': 322800.463,
 '2030': 363918.0150000001,
 '2035': 412886.9580000001}]},
'City Size Class': {'headers': ['Index',
'Country Code',
'Region, subregion, country or area *',
'Size class of urban settlement',
'Size class code',
'Type of data',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 2.0,
 '1955': 2.0,
 '1960': 3.0,
 '1965': 3.0,
 '1970': 3.0,
 '1975': 4.0,
 '1980': 5.0,
 '1985': 9.0,
 '1990': 10.0,
 '1995': 14.0,
 '2000': 16.0,
 '2005': 20.0,
 '2010': 25.0,
 '2015': 29.0,
 '2020': 34.0,
 '2025': 37.0,
 '2030': 43.0,
 '2035': 48.0},
{'Index': 2,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 3.1446290599,
 '1955': 3.0708973171,
 '1960': 4.0491638935,
 '1965': 4.0831053947,
 '1970': 4.0436838274,
 '1975': 4.5187741179,
 '1980': 4.9193069992,
 '1985': 6.612753168,
 '1990': 6.6936725764,
 '1995': 8.0579302725,
 '2000': 8.5550672265,
 '2005': 9.5606346733,
 '2010': 10.7678098411,
 '2015': 11.6233953696,
 '2020': 12.714574606,
 '2025': 13.3190588924,
 '2030': 14.5518895334,
 '2035': 15.5167044795},
{'Index': 3,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 23613.112,
 '1955': 26932.041,
 '1960': 41457.183,
 '1965': 48526.451,
 '1970': 54760.193,
 '1975': 69526.988,
 '1980': 86294.534,
 '1985': 132780.054,
 '1990': 153300.37,
 '1995': 207532.416,
 '2000': 245385.636,
 '2005': 307461.011,
 '2010': 387088.566,
 '2015': 462785.215,
 '2020': 556770.452,
 '2025': 635937.9529999999,
 '2030': 751933.6099999999,
 '2035': 862082.262},
{'Index': 4,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 5.0,
 '1955': 9.0,
 '1960': 9.0,
 '1965': 13.0,
 '1970': 15.0,
 '1975': 14.0,
 '1980': 19.0,
 '1985': 18.0,
 '1990': 21.0,
 '1995': 23.0,
 '2000': 30.0,
 '2005': 36.0,
 '2010': 39.0,
 '2015': 45.0,
 '2020': 51.0,
 '2025': 58.0,
 '2030': 66.0,
 '2035': 73.0},
{'Index': 5,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 4.284399404,
 '1955': 6.5001803026,
 '1960': 5.8119899938,
 '1965': 7.2540837625,
 '1970': 7.9204355818,
 '1975': 7.0170476511,
 '1980': 7.9583539567,
 '1985': 6.3946062092,
 '1990': 6.8190578167,
 '1995': 6.3154758837,
 '2000': 7.4536754525,
 '2005': 7.7018258168,
 '2010': 7.494240569,
 '2015': 7.7901471319,
 '2020': 7.9500526023,
 '2025': 8.4601773276,
 '2030': 8.6663896857,
 '2035': 8.8677355979},
{'Index': 6,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 32171.681,
 '1955': 57007.156,
 '1960': 59505.799,
 '1965': 86212.553,
 '1970': 107259.766,
 '1975': 107966.049,
 '1980': 139605.527,
 '1985': 128399.796,
 '1990': 156171.978,
 '1995': 162655.412,
 '2000': 213794.333,
 '2005': 247683.4680000001,
 '2010': 269408.067,
 '2015': 310164.526,
 '2020': 348132.3219999999,
 '2025': 403943.5440000001,
 '2030': 447814.675,
 '2035': 492676.623},
{'Index': 7,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 69.0,
 '1955': 74.0,
 '1960': 93.0,
 '1965': 112.0,
 '1970': 127.0,
 '1975': 145.0,
 '1980': 174.0,
 '1985': 202.0,
 '1990': 243.0,
 '1995': 276.0,
 '2000': 325.0,
 '2005': 343.0,
 '2010': 380.0,
 '2015': 439.0,
 '2020': 494.0,
 '2025': 558.0,
 '2030': 597.0,
 '2035': 639.0},
{'Index': 8,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 16.9774899722,
 '1955': 15.5819776786,
 '1960': 17.2739534494,
 '1965': 17.4194030286,
 '1970': 18.0475125061,
 '1975': 19.1456114485,
 '1980': 19.1503559995,
 '1985': 19.5391141708,
 '1990': 20.3936193,
 '1995': 20.8686668035,
 '2000': 21.8197229259,
 '2005': 21.0220877352,
 '2010': 21.1518946487,
 '2015': 21.7264319163,
 '2020': 22.3061731186,
 '2025': 23.1181895779,
 '2030': 22.8910367341,
 '2035': 22.7323947924},
{'Index': 9,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 127484.471,
 '1955': 136655.322,
 '1960': 176858.598,
 '1965': 207024.244,
 '1970': 244402.211,
 '1975': 294579.1630000001,
 '1980': 335935.7420000001,
 '1985': 392333.506,
 '1990': 467060.399,
 '1995': 537473.606,
 '2000': 625856.752,
 '2005': 676050.5520000001,
 '2010': 760382.7229999999,
 '2015': 865037.3790000002,
 '2020': 976785.9700000004,
 '2025': 1103811.784,
 '2030': 1182838.823,
 '2035': 1262973.9999999995},
{'Index': 10,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 101.0,
 '1955': 124.0,
 '1960': 132.0,
 '1965': 153.0,
 '1970': 190.0,
 '1975': 223.0,
 '1980': 247.0,
 '1985': 279.0,
 '1990': 301.0,
 '1995': 342.0,
 '2000': 396.0,
 '2005': 456.0,
 '2010': 510.0,
 '2015': 554.0,
 '2020': 626.0,
 '2025': 659.0,
 '2030': 710.0,
 '2035': 757.0},
{'Index': 11,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.9853598362,
 '1955': 9.7382298684,
 '1960': 9.0618284164,
 '1965': 8.8748257734,
 '1970': 9.6688724495,
 '1975': 10.1074938082,
 '1980': 9.705116414,
 '1985': 9.555128865,
 '1990': 9.064214755,
 '1995': 9.1557794873,
 '2000': 9.3797780322,
 '2005': 9.7833020431,
 '2010': 9.862694391,
 '2015': 9.6044168141,
 '2020': 9.851590948,
 '2025': 9.5346117829,
 '2030': 9.5530191713,
 '2035': 9.4902821905},
{'Index': 12,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 67471.331,
 '1955': 85405.137,
 '1960': 92779.124,
 '1965': 105474.573,
 '1970': 130937.369,
 '1975': 155516.4259999999,
 '1980': 170247.252,
 '1985': 191861.165,
 '1990': 207591.1930000001,
 '1995': 235807.58,
 '2000': 269040.878,
 '2005': 314621.784,
 '2010': 354550.8590000001,
 '2015': 382399.6310000002,
 '2020': 431400.571,
 '2025': 455243.9890000002,
 '2030': 493629.1040000001,
 '2035': 527264.2749999999},
{'Index': 13,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 129.0,
 '1955': 146.0,
 '1960': 184.0,
 '1965': 205.0,
 '1970': 225.0,
 '1975': 258.0,
 '1980': 297.0,
 '1985': 347.0,
 '1990': 416.0,
 '1995': 460.0,
 '2000': 524.0,
 '2005': 591.0,
 '2010': 645.0,
 '2015': 707.0,
 '2020': 729.0,
 '2025': 794.0,
 '2030': 827.0,
 '2035': 846.0},
{'Index': 14,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.6391767134,
 '1955': 6.3925578985,
 '1960': 6.9570913597,
 '1965': 6.6795129732,
 '1970': 6.3916317053,
 '1975': 6.4234884644,
 '1980': 6.4817584256,
 '1985': 6.5859392069,
 '1990': 6.9409548454,
 '1995': 6.9025685362,
 '2000': 6.9596074025,
 '2005': 6.9539609531,
 '2010': 6.8310958574,
 '2015': 6.7751216209,
 '2020': 6.3690365085,
 '2025': 6.3988538964,
 '2030': 6.1894854892,
 '2035': 5.9006466691},
{'Index': 15,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 49853.773,
 '1955': 56063.298,
 '1960': 71229.868,
 '1965': 79383.956,
 '1970': 86556.467,
 '1975': 98833.399,
 '1980': 113703.073,
 '1985': 132241.646,
 '1990': 158963.6979999999,
 '1995': 177776.0140000001,
 '2000': 199622.9420000001,
 '2005': 223632.838,
 '2010': 245568.8890000001,
 '2015': 269751.3089999998,
 '2020': 278899.723,
 '2025': 305522.6409999999,
 '2030': 319826.656,
 '2035': 327830.1029999999},
{'Index': 16,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 59.9689450143,
 '1955': 58.7161569347,
 '1960': 56.8459728871,
 '1965': 55.6890690676,
 '1970': 53.9278639299,
 '1975': 52.78758451,
 '1980': 51.785108205,
 '1985': 51.3124583801,
 '1990': 50.0884807065,
 '1995': 48.6995790168,
 '2000': 45.8321489604,
 '2005': 44.9781887785,
 '2010': 43.8922646928,
 '2015': 42.4804871473,
 '2020': 40.8085722167,
 '2025': 39.1691085228,
 '2030': 38.1481793863,
 '2035': 37.4922362706},
{'Index': 17,
 'Country Code': 900,
 'Region, subregion, country or area *': 'WORLD',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 450308.5699999997,
 '1955': 514945.8880000003,
 '1960': 582014.9449999995,
 '1965': 661847.4469999998,
 '1970': 730299.4900000001,
 '1975': 812202.9689999995,
 '1980': 908414.9009999993,
 '1985': 1030322.8960000006,
 '1990': 1147140.4579999999,
 '1995': 1254260.2070000006,
 '2000': 1314606.9720000003,
 '2005': 1446456.2099999993,
 '2010': 1577869.0420000001,
 '2015': 1691359.6029999994,
 '2020': 1787004.906,
 '2025': 1870186.3920000007,
 '2030': 1971214.6780000015,
 '2035': 2083006.214},
{'Index': 18,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 2.0,
 '1955': 2.0,
 '1960': 3.0,
 '1965': 3.0,
 '1970': 3.0,
 '1975': 3.0,
 '1980': 3.0,
 '1985': 4.0,
 '1990': 4.0,
 '1995': 4.0,
 '2000': 5.0,
 '2005': 6.0,
 '2010': 6.0,
 '2015': 6.0,
 '2020': 6.0,
 '2025': 6.0,
 '2030': 7.0,
 '2035': 7.0},
{'Index': 19,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 5.2910461789,
 '1955': 5.374463101,
 '1960': 7.3996277906,
 '1965': 7.8306169102,
 '1970': 8.1235767009,
 '1975': 8.1378986141,
 '1980': 8.0274628939,
 '1985': 9.2756152738,
 '1990': 9.3854682607,
 '1995': 9.4119604483,
 '2000': 10.4908105324,
 '2005': 11.4654339196,
 '2010': 11.3845613346,
 '2015': 11.2692855272,
 '2020': 11.0959908046,
 '2025': 10.8922097603,
 '2030': 11.7302388181,
 '2035': 11.6173225364},
{'Index': 20,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 23613.112,
 '1955': 26932.041,
 '1960': 41457.183,
 '1965': 48526.451,
 '1970': 54760.193,
 '1975': 58793.128,
 '1980': 61177.46,
 '1985': 73894.386,
 '1990': 77887.814,
 '1995': 80807.821,
 '2000': 92726.169,
 '2005': 105291.897,
 '2010': 108619.067,
 '2015': 110336.313,
 '2020': 111363.802,
 '2025': 111873.577,
 '2030': 123132.254,
 '2035': 124398.773},
{'Index': 21,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 4.0,
 '1955': 6.0,
 '1960': 5.0,
 '1965': 6.0,
 '1970': 6.0,
 '1975': 6.0,
 '1980': 6.0,
 '1985': 5.0,
 '1990': 6.0,
 '1995': 6.0,
 '2000': 7.0,
 '2005': 8.0,
 '2010': 9.0,
 '2015': 13.0,
 '2020': 14.0,
 '2025': 16.0,
 '2030': 16.0,
 '2035': 16.0},
{'Index': 22,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.0511958151,
 '1955': 8.0151739469,
 '1960': 6.1559333921,
 '1965': 6.8333295178,
 '1970': 6.6624439843,
 '1975': 6.4652420654,
 '1980': 6.3064744981,
 '1985': 4.968965105,
 '1990': 5.5624329695,
 '1995': 5.5648323113,
 '2000': 5.6179489094,
 '2005': 5.5967463216,
 '2010': 6.1503510008,
 '2015': 8.4617430591,
 '2020': 9.2416060632,
 '2025': 10.4063631238,
 '2030': 10.0338964258,
 '2035': 10.1316521781},
{'Index': 23,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 27005.541,
 '1955': 40164.941,
 '1960': 34489.256,
 '1965': 42346.246,
 '1970': 44910.848,
 '1975': 46708.84,
 '1980': 48061.772,
 '1985': 39585.366,
 '1990': 46161.335,
 '1995': 47777.716,
 '2000': 49655.923,
 '2005': 51397.273,
 '2010': 58679.941,
 '2015': 82847.979,
 '2020': 92752.455,
 '2025': 106883.46,
 '2030': 105325.757,
 '2035': 108490.153},
{'Index': 24,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 37.0,
 '1955': 37.0,
 '1960': 49.0,
 '1965': 58.0,
 '1970': 64.0,
 '1975': 70.0,
 '1980': 80.0,
 '1985': 84.0,
 '1990': 88.0,
 '1995': 93.0,
 '2000': 96.0,
 '2005': 96.0,
 '2010': 100.0,
 '2015': 103.0,
 '2020': 105.0,
 '2025': 110.0,
 '2030': 113.0,
 '2035': 115.0},
{'Index': 25,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 15.8764319525,
 '1955': 14.091827184,
 '1960': 16.4825223775,
 '1965': 17.2566275525,
 '1970': 18.3724011563,
 '1975': 19.002131281,
 '1980': 20.3101756743,
 '1985': 20.7903923454,
 '1990': 20.9141773263,
 '1995': 21.7095929211,
 '2000': 21.4602789511,
 '2005': 20.7785972628,
 '2010': 21.0923846861,
 '2015': 20.306803937,
 '2020': 20.5766320798,
 '2025': 20.5223357063,
 '2030': 20.6176693827,
 '2035': 20.9715743913},
{'Index': 26,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 70854.034,
 '1955': 70615.736,
 '1960': 92345.043,
 '1965': 106939.581,
 '1970': 123846.462,
 '1975': 137282.951,
 '1980': 154784.267,
 '1985': 165627.102,
 '1990': 173561.884,
 '1995': 186391.019,
 '2000': 189683.099,
 '2005': 190818.589,
 '2010': 201240.529,
 '2015': 198821.644,
 '2020': 206515.3100000001,
 '2025': 210784.327,
 '2030': 216423.565,
 '2035': 224564.491},
{'Index': 27,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 66.0,
 '1955': 81.0,
 '1960': 81.0,
 '1965': 85.0,
 '1970': 97.0,
 '1975': 105.0,
 '1980': 105.0,
 '1985': 112.0,
 '1990': 113.0,
 '1995': 117.0,
 '2000': 122.0,
 '2005': 128.0,
 '2010': 137.0,
 '2015': 136.0,
 '2020': 151.0,
 '2025': 151.0,
 '2030': 156.0,
 '2035': 162.0},
{'Index': 28,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 9.8350962183,
 '1955': 11.1320628556,
 '1960': 10.033341051,
 '1965': 9.5515109018,
 '1970': 10.1191000266,
 '1975': 10.1422264419,
 '1980': 9.4046695129,
 '1985': 9.5366333443,
 '1990': 9.3152493954,
 '1995': 9.2805837113,
 '2000': 9.2884017419,
 '2005': 9.4409205383,
 '2010': 9.6056650592,
 '2015': 9.3448417072,
 '2020': 10.1181810312,
 '2025': 9.880375689,
 '2030': 9.960254681,
 '2035': 10.1761500441},
{'Index': 29,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 43892.497,
 '1955': 55784.023,
 '1960': 56212.835,
 '1965': 59190.857,
 '1970': 68211.81,
 '1975': 73273.611,
 '1980': 71673.18,
 '1985': 75973.792,
 '1990': 77305.084,
 '1995': 79679.866,
 '2000': 82098.319,
 '2005': 86699.94,
 '2010': 91646.779,
 '2015': 91494.299,
 '2020': 101550.112,
 '2025': 101481.058,
 '2030': 104552.74,
 '2035': 108966.638},
{'Index': 30,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 79.0,
 '1955': 81.0,
 '1960': 93.0,
 '1965': 105.0,
 '1970': 114.0,
 '1975': 114.0,
 '1980': 129.0,
 '1985': 136.0,
 '1990': 158.0,
 '1995': 174.0,
 '2000': 183.0,
 '2005': 189.0,
 '2010': 188.0,
 '2015': 203.0,
 '2020': 194.0,
 '2025': 196.0,
 '2030': 198.0,
 '2035': 201.0},
{'Index': 31,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.8951122214,
 '1955': 6.2448480131,
 '1960': 6.4740074616,
 '1965': 6.5546994063,
 '1970': 6.4534812867,
 '1975': 6.0624341937,
 '1980': 6.4899748552,
 '1985': 6.5181129254,
 '1990': 7.2477293576,
 '1995': 7.6809778423,
 '2000': 7.7505148063,
 '2005': 7.7044417839,
 '2010': 7.3385861737,
 '2015': 7.8193529135,
 '2020': 7.3637831367,
 '2025': 7.3138456612,
 '2030': 7.1999064105,
 '2035': 7.1253143992},
{'Index': 32,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 30771.808,
 '1955': 31293.638,
 '1960': 36271.299,
 '1965': 40619.571,
 '1970': 43502.252,
 '1975': 43798.711,
 '1980': 49460.232,
 '1985': 51926.685,
 '1990': 60147.217,
 '1995': 65946.206,
 '2000': 68505.245,
 '2005': 70753.126,
 '2010': 70016.785,
 '2015': 76558.409,
 '2020': 73905.873,
 '2025': 75120.301,
 '2030': 75577.379,
 '2035': 76298.163},
{'Index': 33,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 56.0511176139,
 '1955': 55.1416248993,
 '1960': 53.4545679272,
 '1965': 51.9732157114,
 '1970': 50.2689968452,
 '1975': 50.1900674039,
 '1980': 49.4612425657,
 '1985': 48.9102810061,
 '1990': 47.5749426906,
 '1995': 46.3520527657,
 '2000': 45.3920450589,
 '2005': 45.0138601739,
 '2010': 44.4284517456,
 '2015': 42.797972856,
 '2020': 41.6038068845,
 '2025': 40.9848700594,
 '2030': 40.4580342817,
 '2035': 39.9779864509},
{'Index': 34,
 'Country Code': 901,
 'Region, subregion, country or area *': 'More developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 250147.376,
 '1955': 276320.904,
 '1960': 299484.767,
 '1965': 322078.801,
 '1970': 338858.1250000001,
 '1975': 362603.566,
 '1980': 376945.148,
 '1985': 389644.792,
 '1990': 394813.363,
 '1995': 397962.614,
 '2000': 401211.177,
 '2005': 413381.191,
 '2010': 423887.8279999998,
 '2015': 419030.1609999999,
 '2020': 417552.4469999999,
 '2025': 420954.436,
 '2030': 424687.7690000001,
 '2035': 428085.942},
{'Index': 35,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.0,
 '1980': 2.0,
 '1985': 5.0,
 '1990': 6.0,
 '1995': 10.0,
 '2000': 11.0,
 '2005': 14.0,
 '2010': 19.0,
 '2015': 23.0,
 '2020': 28.0,
 '2025': 31.0,
 '2030': 36.0,
 '2035': 41.0},
{'Index': 36,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.315159397,
 '1980': 2.5317105208,
 '1985': 4.861413597,
 '1990': 5.164000668,
 '1995': 7.3808400711,
 '2000': 7.6928716604,
 '2005': 8.7992816506,
 '2010': 10.5449826365,
 '2015': 11.7388709756,
 '2020': 13.1958501911,
 '2025': 13.984189556,
 '2030': 15.2712200648,
 '2035': 16.4476848837},
{'Index': 37,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 58885.668,
 '1990': 75412.556,
 '1995': 126724.595,
 '2000': 152659.467,
 '2005': 202169.114,
 '2010': 278469.499,
 '2015': 352448.9020000001,
 '2020': 445406.65,
 '2025': 524064.376,
 '2030': 628801.3559999999,
 '2035': 737683.4890000001},
{'Index': 38,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 1.0,
 '1955': 3.0,
 '1960': 4.0,
 '1965': 7.0,
 '1970': 9.0,
 '1975': 8.0,
 '1980': 13.0,
 '1985': 13.0,
 '1990': 15.0,
 '1995': 17.0,
 '2000': 23.0,
 '2005': 28.0,
 '2010': 30.0,
 '2015': 32.0,
 '2020': 37.0,
 '2025': 42.0,
 '2030': 50.0,
 '2035': 57.0},
{'Index': 39,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 1.695937316,
 '1955': 4.4805332189,
 '1960': 5.3963212289,
 '1965': 7.7125170239,
 '1970': 9.167262505,
 '1975': 7.5055007284,
 '1980': 9.2272805202,
 '1985': 7.3322370668,
 '1990': 7.5331624344,
 '1995': 6.6908393111,
 '2000': 8.2713227518,
 '2005': 8.543231356,
 '2010': 7.9797767356,
 '2015': 7.5711389671,
 '2020': 7.5660174062,
 '2025': 7.9267828809,
 '2030': 8.3177677444,
 '2035': 8.5659745532},
{'Index': 40,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 5166.14,
 '1955': 16842.215,
 '1960': 25016.543,
 '1965': 43866.307,
 '1970': 62348.918,
 '1975': 61257.209,
 '1980': 91543.755,
 '1985': 88814.43,
 '1990': 110010.643,
 '1995': 114877.696,
 '2000': 164138.41,
 '2005': 196286.1950000001,
 '2010': 210728.126,
 '2015': 227316.547,
 '2020': 255379.867,
 '2025': 297060.0840000001,
 '2030': 342488.918,
 '2035': 384186.47},
{'Index': 41,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 32.0,
 '1955': 37.0,
 '1960': 44.0,
 '1965': 54.0,
 '1970': 63.0,
 '1975': 75.0,
 '1980': 94.0,
 '1985': 118.0,
 '1990': 155.0,
 '1995': 183.0,
 '2000': 229.0,
 '2005': 247.0,
 '2010': 280.0,
 '2015': 336.0,
 '2020': 389.0,
 '2025': 448.0,
 '2030': 484.0,
 '2035': 524.0},
{'Index': 42,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 18.590605622,
 '1955': 17.568506211,
 '1960': 18.2304282001,
 '1965': 17.5967552322,
 '1970': 17.7255072424,
 '1975': 19.2726187335,
 '1980': 18.2594156912,
 '1985': 18.7161601858,
 '1990': 20.0978007897,
 '1995': 20.4481570953,
 '2000': 21.97982215,
 '2005': 21.1194114859,
 '2010': 21.1733951051,
 '2015': 22.1893741495,
 '2020': 22.8204411315,
 '2025': 23.8296396574,
 '2030': 23.4705920051,
 '2035': 23.1527920021},
{'Index': 43,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 56630.437,
 '1955': 66039.586,
 '1960': 84513.555,
 '1965': 100084.663,
 '1970': 120555.749,
 '1975': 157296.212,
 '1980': 181151.4749999999,
 '1985': 226706.404,
 '1990': 293498.515,
 '1995': 351082.5869999999,
 '2000': 436173.6530000002,
 '2005': 485231.9630000002,
 '2010': 559142.1939999999,
 '2015': 666215.7350000003,
 '2020': 770270.6600000005,
 '2025': 893027.4570000003,
 '2030': 966415.2580000001,
 '2035': 1038409.5089999998},
{'Index': 44,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 35.0,
 '1955': 43.0,
 '1960': 51.0,
 '1965': 68.0,
 '1970': 93.0,
 '1975': 118.0,
 '1980': 142.0,
 '1985': 167.0,
 '1990': 188.0,
 '1995': 225.0,
 '2000': 274.0,
 '2005': 328.0,
 '2010': 373.0,
 '2015': 418.0,
 '2020': 475.0,
 '2025': 508.0,
 '2030': 554.0,
 '2035': 595.0},
{'Index': 45,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 7.7404453707,
 '1955': 7.8801027809,
 '1960': 7.8877182028,
 '1965': 8.1375427291,
 '1970': 9.2226406419,
 '1975': 10.0767488099,
 '1980': 9.9359111319,
 '1985': 9.5672931964,
 '1990': 8.9215588172,
 '1995': 9.0933704519,
 '2000': 9.4204777635,
 '2005': 9.9201527869,
 '2010': 9.955556959,
 '2015': 9.6890645398,
 '2020': 9.7723220846,
 '2025': 9.439847682,
 '2030': 9.449201596,
 '2035': 9.3265307189},
{'Index': 46,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 23578.834,
 '1955': 29621.114,
 '1960': 36566.289,
 '1965': 46283.716,
 '1970': 62725.559,
 '1975': 82242.815,
 '1980': 98574.072,
 '1985': 115887.373,
 '1990': 130286.109,
 '1995': 156127.7140000001,
 '2000': 186942.5590000001,
 '2005': 227921.8440000001,
 '2010': 262904.0800000002,
 '2015': 290905.332,
 '2020': 329850.459,
 '2025': 353762.9310000001,
 '2030': 389076.3640000001,
 '2035': 418297.6369999999},
{'Index': 47,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 50.0,
 '1955': 65.0,
 '1960': 91.0,
 '1965': 100.0,
 '1970': 111.0,
 '1975': 144.0,
 '1980': 168.0,
 '1985': 211.0,
 '1990': 258.0,
 '1995': 286.0,
 '2000': 341.0,
 '2005': 402.0,
 '2010': 457.0,
 '2015': 504.0,
 '2020': 535.0,
 '2025': 598.0,
 '2030': 629.0,
 '2035': 645.0},
{'Index': 48,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 6.264215934,
 '1955': 6.5894708297,
 '1960': 7.5409167456,
 '1965': 6.8155037358,
 '1970': 6.3303310388,
 '1975': 6.7430902846,
 '1980': 6.4754467994,
 '1985': 6.6305479196,
 '1990': 6.7666235036,
 '1995': 6.5133207017,
 '2000': 6.6073309127,
 '2005': 6.653991888,
 '2010': 6.6477438108,
 '2015': 6.4345966568,
 '2020': 6.0732549339,
 '2025': 6.1480805494,
 '2030': 5.931896336,
 '2035': 5.6082563172},
{'Index': 49,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 19081.965,
 '1955': 24769.66,
 '1960': 34958.569,
 '1965': 38764.385,
 '1970': 43054.215,
 '1975': 55034.688,
 '1980': 64242.841,
 '1985': 80314.961,
 '1990': 98816.4809999999,
 '1995': 111829.808,
 '2000': 131117.697,
 '2005': 152879.712,
 '2010': 175552.104,
 '2015': 193192.9,
 '2020': 204993.85,
 '2025': 230402.3400000001,
 '2030': 244249.2769999999,
 '2035': 251531.9399999999},
{'Index': 50,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 65.7087957573,
 '1955': 63.4813869595,
 '1960': 60.9446156226,
 '1965': 59.7376812791,
 '1970': 57.554258572,
 '1975': 55.0868820467,
 '1980': 53.5702353365,
 '1985': 52.8923480344,
 '1990': 51.5168537871,
 '1995': 49.8734723689,
 '2000': 46.0281747616,
 '2005': 44.9639308326,
 '2010': 43.6985447531,
 '2015': 42.3769547112,
 '2020': 40.5721142527,
 '2025': 38.6714596744,
 '2030': 37.5593222537,
 '2035': 36.8987615249},
{'Index': 51,
 'Country Code': 902,
 'Region, subregion, country or area *': 'Less developed regions',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 200161.194,
 '1955': 238624.9839999999,
 '1960': 282530.178,
 '1965': 339768.6459999999,
 '1970': 391441.3649999999,
 '1975': 449599.4029999998,
 '1980': 531469.7529999998,
 '1985': 640678.1040000004,
 '1990': 752327.0950000002,
 '1995': 856297.593,
 '2000': 913395.7950000003,
 '2005': 1033075.0189999999,
 '2010': 1153981.2139999997,
 '2015': 1272329.4419999998,
 '2020': 1369452.4589999998,
 '2025': 1449231.9559999998,
 '2030': 1546526.9090000011,
 '2035': 1654920.2719999992},
{'Index': 52,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 1.0,
 '2005': 1.0,
 '2010': 1.0,
 '2015': 2.0,
 '2020': 2.0,
 '2025': 3.0,
 '2030': 4.0,
 '2035': 4.0},
{'Index': 53,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 6.1840265513,
 '2005': 6.0262578325,
 '2010': 5.8919029769,
 '2015': 9.5423470697,
 '2020': 9.5012487352,
 '2025': 11.6706290357,
 '2030': 13.5382325985,
 '2035': 13.4220026235},
{'Index': 54,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 0.0,
 '1995': 0.0,
 '2000': 10284.947,
 '2005': 12330.879,
 '2010': 14730.537,
 '2015': 29194.883,
 '2020': 35348.299,
 '2025': 52459.235,
 '2030': 72907.289,
 '2035': 85793.95},
{'Index': 55,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 1.0,
 '1995': 1.0,
 '2000': 1.0,
 '2005': 1.0,
 '2010': 2.0,
 '2015': 3.0,
 '2020': 5.0,
 '2025': 5.0,
 '2030': 7.0,
 '2035': 10.0},
{'Index': 56,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 6.0276660959,
 '1995': 6.0831684035,
 '2000': 3.6920476238,
 '2005': 3.7088748096,
 '2010': 5.8725448014,
 '2015': 5.6437912512,
 '2020': 8.3894365167,
 '2025': 7.2834737154,
 '2030': 8.2797173422,
 '2035': 10.7171688659},
{'Index': 57,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 0.0,
 '1980': 0.0,
 '1985': 0.0,
 '1990': 6620.697,
 '1995': 8332.474,
 '2000': 6140.419,
 '2005': 7589.069,
 '2010': 14682.139,
 '2015': 17267.222,
 '2020': 31211.93,
 '2025': 32739.063,
 '2030': 44588.667,
 '2035': 68504.55},
{'Index': 58,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 1.0,
 '1955': 1.0,
 '1960': 1.0,
 '1965': 1.0,
 '1970': 3.0,
 '1975': 4.0,
 '1980': 6.0,
 '1985': 10.0,
 '1990': 12.0,
 '1995': 15.0,
 '2000': 22.0,
 '2005': 24.0,
 '2010': 24.0,
 '2015': 30.0,
 '2020': 33.0,
 '2025': 45.0,
 '2030': 53.0,
 '2035': 60.0},
{'Index': 59,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 8.8485352207,
 '1955': 7.836645751,
 '1960': 6.8458044356,
 '1965': 5.8657364716,
 '1970': 11.0764932537,
 '1975': 13.6235974244,
 '1980': 16.8816509633,
 '1985': 22.5475902683,
 '1990': 19.9047769077,
 '1995': 22.0657717359,
 '2000': 23.3949050899,
 '2005': 23.8494272291,
 '2010': 21.1138949682,
 '2015': 20.0032177727,
 '2020': 18.1534328219,
 '2025': 20.0884519328,
 '2030': 19.4462487994,
 '2035': 18.8265669149},
{'Index': 60,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 1302.462,
 '1955': 1439.948,
 '1960': 1591.991,
 '1965': 1759.991,
 '1970': 4389.205,
 '1975': 6870.816,
 '1980': 11376.093,
 '1985': 19419.281,
 '1990': 21863.105,
 '1995': 30224.787,
 '2000': 38909.173,
 '2005': 48800.501,
 '2010': 52787.531,
 '2015': 61199.996,
 '2020': 67537.751,
 '2025': 90297.174,
 '2030': 104723.661,
 '2035': 120340.13},
{'Index': 61,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 2.0,
 '1965': 4.0,
 '1970': 5.0,
 '1975': 8.0,
 '1980': 11.0,
 '1985': 13.0,
 '1990': 17.0,
 '1995': 17.0,
 '2000': 14.0,
 '2005': 19.0,
 '2010': 29.0,
 '2015': 31.0,
 '2020': 44.0,
 '2025': 53.0,
 '2030': 60.0,
 '2035': 73.0},
{'Index': 62,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 4.4166782627,
 '1965': 8.7912874971,
 '1970': 9.1365420016,
 '1975': 11.0491226226,
 '1980': 11.4784761081,
 '1985': 9.9398299572,
 '1990': 10.7744332194,
 '1995': 9.0338971992,
 '2000': 5.7076285769,
 '2005': 6.400439775,
 '2010': 8.2167563364,
 '2015': 7.0958647999,
 '2020': 8.4362972639,
 '2025': 8.0233000499,
 '2030': 7.7479876171,
 '2035': 8.1015030709},
{'Index': 63,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 1027.098,
 '1965': 2637.791,
 '1970': 3620.474,
 '1975': 5572.426,
 '1980': 7735.038,
 '1985': 8560.753,
 '1990': 11834.474,
 '1995': 12374.261,
 '2000': 9492.627,
 '2005': 13096.527,
 '2010': 20542.978,
 '2015': 21709.852,
 '2020': 31386.27,
 '2025': 36064.567,
 '2030': 41725.149,
 '2035': 51785.115},
{'Index': 64,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Number of Agglomerations',
 '1950': 3.0,
 '1955': 4.0,
 '1960': 5.0,
 '1965': 7.0,
 '1970': 11.0,
 '1975': 10.0,
 '1980': 11.0,
 '1985': 17.0,
 '1990': 17.0,
 '1995': 21.0,
 '2000': 27.0,
 '2005': 33.0,
 '2010': 36.0,
 '2015': 48.0,
 '2020': 50.0,
 '2025': 58.0,
 '2030': 73.0,
 '2035': 82.0},
{'Index': 65,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Percentage of Urban Population',
 '1950': 7.4170891838,
 '1955': 8.4866373562,
 '1960': 8.1604600269,
 '1965': 9.0425356055,
 '1970': 10.6443989668,
 '1975': 8.2200357745,
 '1980': 6.5171202448,
 '1985': 7.4074850716,
 '1990': 5.8427891798,
 '1995': 5.9372763042,
 '2000': 6.3396002647,
 '2005': 6.3489905399,
 '2010': 5.6607384111,
 '2015': 6.1736431859,
 '2020': 5.2865685618,
 '2025': 4.9334125732,
 '2030': 5.208692485,
 '2035': 4.9365004238},
{'Index': 66,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': '300 000 to 500 000',
 'Size class code': 5,
 'Type of data': 'Population',
 '1950': 1091.76,
 '1955': 1559.381,
 '1960': 1897.714,
 '1965': 2713.177,
 '1970': 4217.982,
 '1975': 4145.627,
 '1980': 4391.713,
 '1985': 6379.752,
 '1990': 6417.631,
 '1995': 8132.637,
 '2000': 10543.689,
 '2005': 12991.252,
 '2010': 14152.595,
 '2015': 18888.308,
 '2020': 19668.068,
 '2025': 22175.587,
 '2030': 28050.312,
 '2035': 31554.298},
{'Index': 67,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Percentage of Urban Population',
 '1950': 83.7343755955,
 '1955': 83.6767168929,
 '1960': 80.5770572748,
 '1965': 76.3004404257,
 '1970': 69.142565778,
 '1975': 67.1072441786,
 '1980': 65.1227526838,
 '1985': 60.1050947029,
 '1990': 57.4503345972,
 '1995': 56.8798863572,
 '2000': 54.6817918935,
 '2005': 53.6660098139,
 '2010': 53.2441625059,
 '2015': 51.5411359206,
 '2020': 50.2330161004,
 '2025': 48.000732693,
 '2030': 45.7791211578,
 '2035': 43.9962581011},
{'Index': 68,
 'Country Code': 941,
 'Region, subregion, country or area *': 'Least developed countries',
 'Size class of urban settlement': 'Fewer than 300 000',
 'Size class code': 6,
 'Type of data': 'Population',
 '1950': 12325.299,
 '1955': 15375.216,
 '1960': 18738.185,
 '1965': 22893.645,
 '1970': 27398.644,
 '1975': 33844.33,
 '1980': 43884.481,
 '1985': 51765.963,
 '1990': 63102.576,
 '1995': 77911.73,
 '2000': 90943.874,
 '2005': 109810.946,
 '2010': 133117.451,
 '2015': 157690.495,
 '2020': 186886.137,
 '2025': 215762.2960000001,
 '2030': 246533.7770000001,
 '2035': 281225.751},
{'Index': 69,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Number of Agglomerations',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.0,
 '1980': 2.0,
 '1985': 5.0,
 '1990': 6.0,
 '1995': 10.0,
 '2000': 10.0,
 '2005': 13.0,
 '2010': 18.0,
 '2015': 21.0,
 '2020': 26.0,
 '2025': 28.0,
 '2030': 32.0,
 '2035': 37.0},
{'Index': 70,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Percentage of Urban Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 1.4017794981,
 '1980': 2.7162060882,
 '1985': 5.2335317349,
 '1990': 5.5839936891,
 '1995': 8.0207262101,
 '2000': 7.8308956368,
 '2005': 9.0703895544,
 '2010': 11.0315766652,
 '2015': 11.9880972287,
 '2020': 13.6535223278,
 '2025': 14.2995092937,
 '2030': 15.5319789737,
 '2035': 16.9505749832},
{'Index': 71,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '10 million or more',
 'Size class code': 1,
 'Type of data': 'Population',
 '1950': 0.0,
 '1955': 0.0,
 '1960': 0.0,
 '1965': 0.0,
 '1970': 0.0,
 '1975': 10733.86,
 '1980': 25117.074,
 '1985': 58885.668,
 '1990': 75412.556,
 '1995': 126724.595,
 '2000': 142374.52,
 '2005': 189838.235,
 '2010': 263738.9620000001,
 '2015': 323254.019,
 '2020': 410058.351,
 '2025': 471605.1409999999,
 '2030': 555894.067,
 '2035': 651889.5389999999},
{'Index': 72,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Number of Agglomerations',
 '1950': 1.0,
 '1955': 3.0,
 '1960': 4.0,
 '1965': 7.0,
 '1970': 9.0,
 '1975': 8.0,
 '1980': 13.0,
 '1985': 13.0,
 '1990': 14.0,
 '1995': 16.0,
 '2000': 22.0,
 '2005': 27.0,
 '2010': 28.0,
 '2015': 29.0,
 '2020': 32.0,
 '2025': 37.0,
 '2030': 43.0,
 '2035': 47.0},
{'Index': 73,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Percentage of Urban Population',
 '1950': 1.7820479294,
 '1955': 4.7108058336,
 '1960': 5.6813150831,
 '1965': 8.1420397836,
 '1970': 9.7344210109,
 '1975': 7.9998341402,
 '1980': 9.8997082491,
 '1985': 7.8934850145,
 '1990': 7.6556058646,
 '1995': 6.743521687,
 '2000': 8.6902191372,
 '2005': 9.0158678552,
 '2010': 8.2001397105,
 '2015': 7.7898234296,
 '2020': 7.4640156103,
 '2025': 8.014460759,
 '2030': 8.3234931068,
 '2035': 8.2084306246},
{'Index': 74,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '5 to 10 million',
 'Size class code': 2,
 'Type of data': 'Population',
 '1950': 5166.14,
 '1955': 16842.215,
 '1960': 25016.543,
 '1965': 43866.307,
 '1970': 62348.918,
 '1975': 61257.209,
 '1980': 91543.755,
 '1985': 88814.43,
 '1990': 103389.946,
 '1995': 106545.222,
 '2000': 157997.991,
 '2005': 188697.126,
 '2010': 196045.9870000001,
 '2015': 210049.325,
 '2020': 224167.9369999999,
 '2025': 264321.0210000001,
 '2030': 297900.2510000001,
 '2035': 315681.9199999999},
{'Index': 75,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Number of Agglomerations',
 '1950': 31.0,
 '1955': 36.0,
 '1960': 43.0,
 '1965': 53.0,
 '1970': 60.0,
 '1975': 71.0,
 '1980': 88.0,
 '1985': 108.0,
 '1990': 143.0,
 '1995': 168.0,
 '2000': 207.0,
 '2005': 223.0,
 '2010': 256.0,
 '2015': 306.0,
 '2020': 356.0,
 '2025': 403.0,
 '2030': 431.0,
 '2035': 464.0},
{'Index': 76,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Percentage of Urban Population',
 '1950': 19.0852557781,
 '1955': 18.068665644,
 '1960': 18.8316799913,
 '1965': 18.2500749638,
 '1970': 18.1368672136,
 '1975': 19.6446791833,
 '1980': 18.3598187519,
 '1985': 18.4228823975,
 '1990': 20.1134996031,
 '1995': 20.3079170715,
 '2000': 21.8503752153,
 '2005': 20.8525083166,
 '2010': 21.1796173092,
 '2015': 22.437424062,
 '2020': 23.3985710572,
 '2025': 24.3395335295,
 '2030': 24.0761262998,
 '2035': 23.8718416504},
{'Index': 77,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '1 to 5 million',
 'Size class code': 3,
 'Type of data': 'Population',
 '1950': 55327.975,
 '1955': 64599.638,
 '1960': 82921.564,
 '1965': 98324.672,
 '1970': 116166.544,
 '1975': 150425.396,
 '1980': 169775.382,
 '1985': 207287.123,
 '1990': 271635.41,
 '1995': 320857.7999999999,
 '2000': 397264.4800000002,
 '2005': 436431.4620000003,
 '2010': 506354.663,
 '2015': 605015.7390000002,
 '2020': 702732.9090000001,
 '2025': 802730.283,
 '2030': 861691.597,
 '2035': 918069.3789999997},
{'Index': 78,
 'Country Code': 934,
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Size class of urban settlement': '500 000 to 1 million',
 'Size class code': 4,
 'Type of data': 'Number of Agglomerations',
 '1950': 35.0,
 '1955': 43.0,
 '1960': 49.0,
 '1965': 64.0,
 '1970': 88.0,
 '1975': 110.0,
 '1980': 131.0,
 '1985': 154.0,
 '1990': 171.0,
 '1995': 208.0,
 '2000': 260.0,
 '2005': 309.0,
 '2010': 344.0,
 '2015': 387.0,
 '2020': 431.0,
 '2025': 455.0,
 '2030': 494.0,
 '2035': 522.0}]},
'Crude birth rate (CBR)': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'2020-2025',
'2025-2030',
'2030-2035'],
'data': [{'Index': 1,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '2020-2025': 17.464001,
 '2025-2030': 16.639999,
 '2030-2035': 16.014999},
{'Index': 2,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '2020-2025': '...',
 '2025-2030': '...',
 '2030-2035': '...'},
{'Index': 3,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '2020-2025': 10.178,
 '2025-2030': 9.863,
 '2030-2035': 9.712},
{'Index': 4,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '2020-2025': 18.851,
 '2025-2030': 17.868999,
 '2030-2035': 17.107},
{'Index': 5,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '2020-2025': 29.91,
 '2025-2030': 28.254999,
 '2030-2035': 26.691},
{'Index': 6,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '2020-2025': 16.636,
 '2025-2030': 15.647,
 '2030-2035': 14.917},
{'Index': 7,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '2020-2025': 21.184,
 '2025-2030': 20.030001,
 '2030-2035': 19.041},
{'Index': 8,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '2020-2025': 29.312,
 '2025-2030': 27.346001,
 '2030-2035': 25.746},
{'Index': 9,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '2020-2025': 17.388,
 '2025-2030': 16.476999,
 '2030-2035': 15.716},
{'Index': 10,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '2020-2025': '...',
 '2025-2030': '...',
 '2030-2035': '...'}]},
'Data Source Urban Agglomeration and Capital Cities  ': {'headers': ['Index',
'Country or area',
'Country Code',
'ISO3 Alpha Code',
'ISO2 Alpha Code',
'City Code',
'Location name',
'Location type',
'Data',
'Sources',
'Statistical Concept',
'Note'],
'data': [{'Index': 1,
 'Country or area': 'Afghanistan',
 'Country Code': 4,
 'ISO3 Alpha Code': 'AFG',
 'ISO2 Alpha Code': 'AF',
 'City Code': 20001,
 'Location name': 'Herat',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Census of 1979; Estimates for 1950, 1966, 1971, 2004 and 2016.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 2,
 'Country or area': 'Afghanistan',
 'Country Code': 4,
 'ISO3 Alpha Code': 'AFG',
 'ISO2 Alpha Code': 'AF',
 'City Code': 20002,
 'Location name': 'Kabul',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Census of 1979; Estimates for 1966, 1971, 1986, 2004 and 2016.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 3,
 'Country or area': 'Afghanistan',
 'Country Code': 4,
 'ISO3 Alpha Code': 'AFG',
 'ISO2 Alpha Code': 'AF',
 'City Code': 20003,
 'Location name': 'Kandahar',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Census of 1979; Estimates for 1950, 1966, 1971, 2004 and 2016.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 4,
 'Country or area': 'Afghanistan',
 'Country Code': 4,
 'ISO3 Alpha Code': 'AFG',
 'ISO2 Alpha Code': 'AF',
 'City Code': 20004,
 'Location name': 'Mazar-e Sharif',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Census of 1979; Estimates for 1950, 2004 and 2016.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 5,
 'Country or area': 'Albania',
 'Country Code': 8,
 'ISO3 Alpha Code': 'ALB',
 'ISO2 Alpha Code': 'AL',
 'City Code': 20005,
 'Location name': 'Tiranë (Tirana)',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1950, 1955, 1960, 1969, 1979, 1989, 2001 and 2011.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 6,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20009,
 'Location name': 'Annaba',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1966, 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 7,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20011,
 'Location name': 'Batna',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1966, 1977, 1987, 1998 and 2011.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 8,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20015,
 'Location name': 'Blida',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1966, 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 9,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20006,
 'Location name': 'El Djazaïr  (Algiers)',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1960, 1966, 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to the Governorate of Grand Algiers.'},
{'Index': 10,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20020,
 'Location name': 'El Djelfa',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 11,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20019,
 'Location name': 'Qacentina',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1966, 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 12,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20037,
 'Location name': 'Sétif',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1966, 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 13,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'City Code': 20035,
 'Location name': 'Wahran (Oran)',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1966, 1977, 1987, 1998 and 2008.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 14,
 'Country or area': 'American Samoa',
 'Country Code': 16,
 'ISO3 Alpha Code': 'ASM',
 'ISO2 Alpha Code': 'AS',
 'City Code': 20047,
 'Location name': 'Pago Pago',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 2000 and 2010; UN Estimates for 1950, 1970, 1980 and 1990.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 15,
 'Country or area': 'Andorra',
 'Country Code': 20,
 'ISO3 Alpha Code': 'AND',
 'ISO2 Alpha Code': 'AD',
 'City Code': 20048,
 'Location name': 'Andorra la Vella',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Estimates for 1950, 1959, 1965, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 2003, 2011 and 2017.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 16,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 895000001,
 'Location name': 'Benguela',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014; Estimates for 1950 and 1983; UN Estimate for 1993.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the "municipio" of Benguela.'},
{'Index': 17,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 204043,
 'Location name': 'Cabinda',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014; UN Estimate for 1993.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the "municipio" of Cabinda.'},
{'Index': 18,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 895000011,
 'Location name': 'Cuito',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1970 and 2014; Estimate for 1950.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 19,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 20050,
 'Location name': 'Huambo',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014; Estimates for 1950, 1983 and 1993.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the "municipio" of Huambo.'},
{'Index': 20,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 895000000,
 'Location name': 'Lobito',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014; Estimates for 1950 and 1983.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the "municipio" of Lobito.'},
{'Index': 21,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 20049,
 'Location name': 'Luanda',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1983 and 2014; Estimates for 1950, 1993 and 2018.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the province of Luanda.'},
{'Index': 22,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 204044,
 'Location name': 'Lubango',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014; Estimate for 1950; UN Estimate for 1993.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the "municipio" of Lubango.'},
{'Index': 23,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 895000004,
 'Location name': 'Malanje',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014; Estimate for 1950.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Estimate for 2014 refers to the urban population of the "municipio" of Malanje.'},
{'Index': 24,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'City Code': 895000012,
 'Location name': 'Uige',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970 and 2014.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 25,
 'Country or area': 'Anguilla',
 'Country Code': 660,
 'ISO3 Alpha Code': 'AIA',
 'ISO2 Alpha Code': 'AI',
 'City Code': 22407,
 'Location name': 'The Valley',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1992, 2001 and 2011; UN Estimates for 1960, 1974 and 1984.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 26,
 'Country or area': 'Antigua and Barbuda',
 'Country Code': 28,
 'ISO3 Alpha Code': 'ATG',
 'ISO2 Alpha Code': 'AG',
 'City Code': 20052,
 'Location name': "St. John's",
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1991, 2001 and 2011.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 27,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20057,
 'Location name': 'Bahia Blanca',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 28,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20058,
 'Location name': 'Buenos Aires',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2017.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Buenos Aires. Data for 2001 and 2010 refer to the urban agglomeration including Buenos Aires city, 24 districts of Gran Buenos Aires and some districts of the suburbs.'},
{'Index': 29,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20059,
 'Location name': 'Córdoba',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Córdoba.'},
{'Index': 30,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20063,
 'Location name': 'Corrientes',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991 and 2001; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Corrientes.'},
{'Index': 31,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20065,
 'Location name': 'La Plata',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran La Plata.'},
{'Index': 32,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20067,
 'Location name': 'Mar Del Plata',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 33,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20068,
 'Location name': 'Mendoza',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Mendoza.'},
{'Index': 34,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20070,
 'Location name': 'Neuquén-Plottier-Cipolletti',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2017.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 35,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20072,
 'Location name': 'Posadas',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 36,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20073,
 'Location name': 'Resistencia',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Resistencia.'},
{'Index': 37,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20075,
 'Location name': 'Rosario',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991 and 2001; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Rosario.'},
{'Index': 38,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20076,
 'Location name': 'Salta',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991 and 2001; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 39,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20078,
 'Location name': 'San Juan',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran San Juan.'},
{'Index': 40,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20081,
 'Location name': 'San Miguel de Tucumán',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran San Miguel de Tucumán.'},
{'Index': 41,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20084,
 'Location name': 'San Salvador de Jujuy',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991 and 2001; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran San Salvador de Jujuy.'},
{'Index': 42,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20085,
 'Location name': 'Santa Fe',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Gran Santa Fe.'},
{'Index': 43,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'City Code': 20086,
 'Location name': 'Santiago Del Estero',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991 and 2001; Estimate for 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to Santiago del Estero-La Banda, including the locality of El Zanjón.'},
{'Index': 44,
 'Country or area': 'Armenia',
 'Country Code': 51,
 'ISO3 Alpha Code': 'ARM',
 'ISO2 Alpha Code': 'AM',
 'City Code': 20140,
 'Location name': 'Yerevan',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 2001 and 2011; Estimate for 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 45,
 'Country or area': 'Aruba',
 'Country Code': 533,
 'ISO3 Alpha Code': 'ABW',
 'ISO2 Alpha Code': 'AW',
 'City Code': 21954,
 'Location name': 'Oranjestad',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1991, 2000 and 2010; Estimate for 1965.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 46,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206171,
 'Location name': 'Adelaide',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961 and 1966; Estimates for 1950, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 47,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206170,
 'Location name': 'Brisbane',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961 and 1966; Estimates for 1950, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 48,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206175,
 'Location name': 'Canberra',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961 and 1966; Estimates for 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 49,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 895000015,
 'Location name': 'Central Coast',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Estimates for 1954, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 50,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 20093,
 'Location name': 'Gold Coast-Tweed Head',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Census of 1976; Estimates for 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 51,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206168,
 'Location name': 'Melbourne',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961 and 1966; Estimates for 1950, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 52,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206177,
 'Location name': 'Newcastle-Maitland',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961, 1966, 1971 and 1976; Estimates for 1950, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 53,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206172,
 'Location name': 'Perth',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961 and 1966; Estimates for 1950, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 54,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 20098,
 'Location name': 'Sunshine Coast',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Estimates for 1950, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 55,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 206167,
 'Location name': 'Sydney',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961 and 1966; Estimates for 1950, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 56,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'City Code': 20101,
 'Location name': 'Wollongong',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1954, 1961, 1966, 1971, 1976 and 1981; Estimates for 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to Significant Urban Areas as of 2001.'},
{'Index': 57,
 'Country or area': 'Austria',
 'Country Code': 40,
 'ISO3 Alpha Code': 'AUT',
 'ISO2 Alpha Code': 'AT',
 'City Code': 20107,
 'Location name': 'Wien (Vienna)',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1971, 1981, 1991 and 2001; Estimates for 2006, 2007 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 58,
 'Country or area': 'Azerbaijan',
 'Country Code': 31,
 'ISO3 Alpha Code': 'AZE',
 'ISO2 Alpha Code': 'AZ',
 'City Code': 20053,
 'Location name': 'Baku',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989 and 1999; Estimates for 2006, 2008, 2011 and 2017.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'The data include communities under the authority of the Town Council. The 1989 census produced data referring to the city proper only; the population of the urban agglomeration for that date was estimated by assuming that the ratio of the population of the urban agglomeration to that of the city proper was the same as in 1979.'},
{'Index': 59,
 'Country or area': 'Azerbaijan',
 'Country Code': 31,
 'ISO3 Alpha Code': 'AZE',
 'ISO2 Alpha Code': 'AZ',
 'City Code': 20054,
 'Location name': 'Gäncä',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989 and 1999; Estimates for 2001, 2003, 2011 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 60,
 'Country or area': 'Azerbaijan',
 'Country Code': 31,
 'ISO3 Alpha Code': 'AZE',
 'ISO2 Alpha Code': 'AZ',
 'City Code': 20056,
 'Location name': 'Sumquayit',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989 and 1999; Estimates for 2001, 2003, 2011 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 61,
 'Country or area': 'Bahamas',
 'Country Code': 44,
 'ISO3 Alpha Code': 'BHS',
 'ISO2 Alpha Code': 'BS',
 'City Code': 20108,
 'Location name': 'Nassau',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1963, 1970, 1980, 1990, 2000 and 2010; Estimate for 1953.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 62,
 'Country or area': 'Bahrain',
 'Country Code': 48,
 'ISO3 Alpha Code': 'BHR',
 'ISO2 Alpha Code': 'BH',
 'City Code': 20109,
 'Location name': 'Al-Manamah (Manama)',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1950, 1959, 1965, 1971, 1981, 1991 and 2001; UN Estimates for 2010 and 2016.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'Refers to the urban area of the municipality of Al-Manamah.'},
{'Index': 63,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20110,
 'Location name': 'Barisal',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 64,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20112,
 'Location name': 'Bogra',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 65,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20115,
 'Location name': 'Chittagong',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Metropolitan area',
 'Note': ''},
{'Index': 66,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20117,
 'Location name': 'Comilla',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 67,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20119,
 'Location name': 'Dhaka',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Metropolitan area',
 'Note': 'Refers to the Mega city.'},
{'Index': 68,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20124,
 'Location name': 'Khulna',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Metropolitan area',
 'Note': ''},
{'Index': 69,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20126,
 'Location name': 'Mymensingh',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 70,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20131,
 'Location name': 'Rajshahi',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Metropolitan area',
 'Note': ''},
{'Index': 71,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20132,
 'Location name': 'Rangpur',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 72,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 205390,
 'Location name': 'Rupganj',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1991, 2001 and 2011.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 73,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'City Code': 20136,
 'Location name': 'Sylhet',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991, 2001 and 2011.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 74,
 'Country or area': 'Barbados',
 'Country Code': 52,
 'ISO3 Alpha Code': 'BRB',
 'ISO2 Alpha Code': 'BB',
 'City Code': 20141,
 'Location name': 'Bridgetown',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1970, 1980, 1990, 2000 and 2010.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''},
{'Index': 75,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'City Code': 20344,
 'Location name': 'Brest',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 2003 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 76,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'City Code': 20345,
 'Location name': 'Gomel',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 2003 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 77,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'City Code': 20346,
 'Location name': 'Grodno',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 2003 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 78,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'City Code': 20348,
 'Location name': 'Minsk',
 'Location type': 'Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 1950, 1955, 2006 and 2017.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': 'The data include communities under the authority of the Town Council. The 1989 census produced data referring to the city proper only; the population of the urban agglomeration for that date was estimated by assuming that the ratio of the population of the urban agglomeration to that of the city proper was the same as in 1979.'},
{'Index': 79,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'City Code': 20349,
 'Location name': 'Mogilev',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 2003 and 2017.',
 'Statistical Concept': 'City Proper',
 'Note': ''},
{'Index': 80,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'City Code': 20355,
 'Location name': 'Vitebsk',
 'Location type': 'Non-Capital',
 'Data': 'Urban agglomerations and capital cities',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 2003 and 2017.',
 'Statistical Concept': 'Urban Agglomeration',
 'Note': ''}]},
'Data Source Urban Population  ': {'headers': ['Index',
'Country or area',
'Country Code',
'ISO3 Alpha Code',
'ISO2 Alpha Code',
'Data',
'Sources',
'Definition'],
'data': [{'Index': 1,
 'Country or area': 'Afghanistan',
 'Country Code': 4,
 'ISO3 Alpha Code': 'AFG',
 'ISO2 Alpha Code': 'AF',
 'Data': 'Urban Population',
 'Sources': 'Census of 1979; Estimates for 1950, 2004 and 2016; UN Estimate for 1988.',
 'Definition': 'Sixty-six localities and provincial centres.'},
{'Index': 2,
 'Country or area': 'Albania',
 'Country Code': 8,
 'ISO3 Alpha Code': 'ALB',
 'ISO2 Alpha Code': 'AL',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1955, 1960, 1969, 1979, 2001 and 2011; Estimate for 1991.',
 'Definition': 'Towns and other industrial centres with 400 inhabitants or more.'},
{'Index': 3,
 'Country or area': 'Algeria',
 'Country Code': 12,
 'ISO3 Alpha Code': 'DZA',
 'ISO2 Alpha Code': 'DZ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1954, 1960, 1966, 1977, 1987, 1998 and 2008.',
 'Definition': 'For 1998 and 2008, agglomerations with 5,000 inhabitants or more, non-agricultural economic activity, connection to water supply network, connection to electricity network, connection to network of sanitation and additional conditions.'},
{'Index': 4,
 'Country or area': 'American Samoa',
 'Country Code': 16,
 'ISO3 Alpha Code': 'ASM',
 'ISO2 Alpha Code': 'AS',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 2000 and 2010; UN Estimates for 1970, 1980 and 1990.',
 'Definition': 'Densely settled territory that meets minimum population density requirements and with 2,500 inhabitants or more.'},
{'Index': 5,
 'Country or area': 'Andorra',
 'Country Code': 20,
 'ISO3 Alpha Code': 'AND',
 'ISO2 Alpha Code': 'AD',
 'Data': 'Urban Population',
 'Sources': 'Estimates for 1985, 1990, 2000, 2004, 2007 and 2017; UN Estimates for 1950 and 1960.',
 'Definition': 'Parishes of Andorra la Vella, Escaldes-Engordany, Saint Julia, Encamp and La Massana.'},
{'Index': 6,
 'Country or area': 'Angola',
 'Country Code': 24,
 'ISO3 Alpha Code': 'AGO',
 'ISO2 Alpha Code': 'AO',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970 and 2014; Estimates for 1950 and 1994; UN Estimate for 2005.',
 'Definition': 'Geographic areas with a high population density and concentrated population groups with a high level of infrastructure.'},
{'Index': 7,
 'Country or area': 'Anguilla',
 'Country Code': 660,
 'ISO3 Alpha Code': 'AIA',
 'ISO2 Alpha Code': 'AI',
 'Data': 'Urban Population',
 'Sources': 'UN Estimates for 1960, 1974, 1984, 1992, 2001 and 2011.',
 'Definition': 'In the absence of more detailed information the entire population is considered urban.'},
{'Index': 8,
 'Country or area': 'Antigua and Barbuda',
 'Country Code': 28,
 'ISO3 Alpha Code': 'ATG',
 'ISO2 Alpha Code': 'AG',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970, 1991, 2001 and 2011; UN Estimate for 2015.',
 'Definition': "St. John's (capital)."},
{'Index': 9,
 'Country or area': 'Argentina',
 'Country Code': 32,
 'ISO3 Alpha Code': 'ARG',
 'ISO2 Alpha Code': 'AR',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2001 and 2010; Estimate for 2017.',
 'Definition': 'Localities with 2,000 inhabitants or more.'},
{'Index': 10,
 'Country or area': 'Armenia',
 'Country Code': 51,
 'ISO3 Alpha Code': 'ARM',
 'ISO2 Alpha Code': 'AM',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 2001 and 2011; Estimate for 1974.',
 'Definition': 'Cities and urban-type localities, officially designated as such, usually according to the number of inhabitants and predominance of non-agricultural workers and their families.'},
{'Index': 11,
 'Country or area': 'Aruba',
 'Country Code': 533,
 'ISO3 Alpha Code': 'ABW',
 'ISO2 Alpha Code': 'AW',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1991, 2000 and 2010; Estimate for 1965; UN Estimate for 2011.',
 'Definition': 'Oranjestad (capital) and San Nicolaas.'},
{'Index': 12,
 'Country or area': 'Australia',
 'Country Code': 36,
 'ISO3 Alpha Code': 'AUS',
 'ISO2 Alpha Code': 'AU',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1954, 1961, 1966, 1981 and 1991; Estimates for 2001, 2006, 2011 and 2016.',
 'Definition': 'For 2001 and later, Significant Urban Centres representing concentrations of urban development with 10,000 inhabitants or more. Before 2001, urban centres with 1,000 inhabitants or more.'},
{'Index': 13,
 'Country or area': 'Austria',
 'Country Code': 40,
 'ISO3 Alpha Code': 'AUT',
 'ISO2 Alpha Code': 'AT',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1951, 1961, 1971, 1981 and 2011; Estimate for 2017.',
 'Definition': "For 2011 and later, urban centres and regional centres identified in Statistics Austria's 2013 Urban-Rural Typology.  For 1951 to 1981, functional and structural urban areas (Stadtregion) consisting of an urban core area (Kernzone) and surrounding urban areas (Außenzone). Surrounding urban areas are those where at least 30 per cent of working adults commute into the urban core area."},
{'Index': 14,
 'Country or area': 'Azerbaijan',
 'Country Code': 31,
 'ISO3 Alpha Code': 'AZE',
 'ISO2 Alpha Code': 'AZ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 1974 and 1984.',
 'Definition': 'Cities and urban-type localities, officially designated as such, usually according to the criteria of number of inhabitants and predominance of non-agricultural workers and their families.'},
{'Index': 15,
 'Country or area': 'Bahamas',
 'Country Code': 44,
 'ISO3 Alpha Code': 'BHS',
 'ISO2 Alpha Code': 'BS',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1963, 1980, 1990, 2000 and 2010; Estimate for 1953.',
 'Definition': 'For 1980 and later, sum of the cities.'},
{'Index': 16,
 'Country or area': 'Bahrain',
 'Country Code': 48,
 'ISO3 Alpha Code': 'BHR',
 'ISO2 Alpha Code': 'BH',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1959, 1965, 1991 and 2001; UN Estimate for 1950.',
 'Definition': 'Communes or villages with 2,500 inhabitants or more. For consistency, the 1971 and 1981 census estimates were excluded.'},
{'Index': 17,
 'Country or area': 'Bangladesh',
 'Country Code': 50,
 'ISO3 Alpha Code': 'BGD',
 'ISO2 Alpha Code': 'BD',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1951, 1961, 1974, 1981, 1991 and 2001; UN Estimate for 2011.',
 'Definition': 'Localities having a municipality (pourashava), town (shahar) committee or cantonment board. In general, urban areas are a concentration of 5,000 inhabitants or more in a continuous collection of houses where the community sense is well developed and the community maintains public utilities, such as roads, street lighting, water supply, sanitary arrangements, etc. These places are generally centres of trade and commerce where the labour force is mostly non-agricultural and literacy levels are high. An area that has urban characteristics but has fewer than 5,000 inhabitants may, in special cases, be considered urban.'},
{'Index': 18,
 'Country or area': 'Barbados',
 'Country Code': 52,
 'ISO3 Alpha Code': 'BRB',
 'ISO2 Alpha Code': 'BB',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1970, 1980, 1990, 2000 and 2010.',
 'Definition': 'Bridgetown (capital).'},
{'Index': 19,
 'Country or area': 'Belarus',
 'Country Code': 112,
 'ISO3 Alpha Code': 'BLR',
 'ISO2 Alpha Code': 'BY',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 1999 and 2009; Estimates for 1964, 1974, 1984 and 2017.',
 'Definition': 'Cities and urban-type localities (towns, semiurban centers, industrial communities and health resort communities), officially designated as such.'},
{'Index': 20,
 'Country or area': 'Belgium',
 'Country Code': 56,
 'ISO3 Alpha Code': 'BEL',
 'ISO2 Alpha Code': 'BE',
 'Data': 'Urban Population',
 'Sources': 'Census of 1981; Estimates for 1976 and 2017; UN Estimates for 1961 and 2000.',
 'Definition': 'Communes with 5,000 inhabitants or more.'},
{'Index': 21,
 'Country or area': 'Belize',
 'Country Code': 84,
 'ISO3 Alpha Code': 'BLZ',
 'ISO2 Alpha Code': 'BZ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970, 1980, 1991, 2000 and 2010.',
 'Definition': 'Belize City and all towns.'},
{'Index': 22,
 'Country or area': 'Benin',
 'Country Code': 204,
 'ISO3 Alpha Code': 'BEN',
 'ISO2 Alpha Code': 'BJ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1992, 2002 and 2013; Estimate for 1979; Sample Survey of 1961.',
 'Definition': 'Localities with 10,000 inhabitants or more.'},
{'Index': 23,
 'Country or area': 'Bermuda',
 'Country Code': 60,
 'ISO3 Alpha Code': 'BMU',
 'ISO2 Alpha Code': 'BM',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1960, 1970, 1980, 1991, 2000 and 2010.',
 'Definition': 'Entire population.'},
{'Index': 24,
 'Country or area': 'Bhutan',
 'Country Code': 64,
 'ISO3 Alpha Code': 'BTN',
 'ISO2 Alpha Code': 'BT',
 'Data': 'Urban Population',
 'Sources': 'Census of 2005; Estimates for 1950 and 2011.',
 'Definition': 'Areas satisfying at least 4 out of the following 5 conditions: (1) 1,500 inhabitants or more; (2) 1,000 inhabitants or more per square kilometre; (3) more than 50 per cent of the population depends on economic activity outside of the primary (e.g., agriculture, livestock and forestry) sector; (4) area of the urban centre is 1.5 square kilometres or larger; and (5) identified potential for future growth of the urban centre, particularly in terms of its revenue base. As of 2005, there were 28 declared urban centres and 26 satellite towns.'},
{'Index': 25,
 'Country or area': 'Bolivia (Plurinational State of)',
 'Country Code': 68,
 'ISO3 Alpha Code': 'BOL',
 'ISO2 Alpha Code': 'BO',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1976, 1992, 2001 and 2012; Estimate for 2017.',
 'Definition': 'Localities with 2,000 inhabitants or more.'},
{'Index': 26,
 'Country or area': 'Bosnia and Herzegovina',
 'Country Code': 70,
 'ISO3 Alpha Code': 'BIH',
 'ISO2 Alpha Code': 'BA',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1953, 1961, 1971, 1981, 1991 and 2013.',
 'Definition': 'Settlements officially designated as urban.'},
{'Index': 27,
 'Country or area': 'Botswana',
 'Country Code': 72,
 'ISO3 Alpha Code': 'BWA',
 'ISO2 Alpha Code': 'BW',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1964, 1971, 1981, 1991, 2001 and 2011; Estimates for 2006 and 2017; UN Estimate for 1950.',
 'Definition': 'Agglomerations of 5,000 inhabitants or more where at least 75 per cent of the economic activity is non-agricultural.'},
{'Index': 28,
 'Country or area': 'Brazil',
 'Country Code': 76,
 'ISO3 Alpha Code': 'BRA',
 'ISO2 Alpha Code': 'BR',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1960, 1970, 1996, 2000 and 2010; Estimate for 2015.',
 'Definition': 'Administrative centres of municipios and districts, including suburban zones.'},
{'Index': 29,
 'Country or area': 'British Virgin Islands',
 'Country Code': 92,
 'ISO3 Alpha Code': 'VGB',
 'ISO2 Alpha Code': 'VG',
 'Data': 'Urban Population',
 'Sources': 'Census of 2001; UN Estimates for 1960, 1970, 1980 and 1991.',
 'Definition': 'Road Town (capital).'},
{'Index': 30,
 'Country or area': 'Brunei Darussalam',
 'Country Code': 96,
 'ISO3 Alpha Code': 'BRN',
 'ISO2 Alpha Code': 'BN',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1971, 1991, 2001 and 2011.',
 'Definition': 'Municipalities and areas having urban socio-economic characteristics.'},
{'Index': 31,
 'Country or area': 'Bulgaria',
 'Country Code': 100,
 'ISO3 Alpha Code': 'BGR',
 'ISO2 Alpha Code': 'BG',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1956, 1965, 1975, 1985, 1992, 2001 and 2011; Estimates for 1960, 1970 and 1980.',
 'Definition': 'Localities officially designated as urban (towns).'},
{'Index': 32,
 'Country or area': 'Burkina Faso',
 'Country Code': 854,
 'ISO3 Alpha Code': 'BFA',
 'ISO2 Alpha Code': 'BF',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1975, 1985, 1996 and 2006; Estimate for 2015.',
 'Definition': 'Cities and urban-type localities (communes), officially designated as such, according to socio-economic characteristics such as a non-agricultural economy.'},
{'Index': 33,
 'Country or area': 'Burundi',
 'Country Code': 108,
 'ISO3 Alpha Code': 'BDI',
 'ISO2 Alpha Code': 'BI',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1965, 1979, 1990 and 2008; Estimate for 1998.',
 'Definition': 'Commune of Bujumbura.'},
{'Index': 34,
 'Country or area': 'Cabo Verde',
 'Country Code': 132,
 'ISO3 Alpha Code': 'CPV',
 'ISO2 Alpha Code': 'CV',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970, 1980, 1990, 2000 and 2010; Estimates for 1985 and 2015; UN Estimate for 1950.',
 'Definition': 'Cities and towns as defined in the administrative division.'},
{'Index': 35,
 'Country or area': 'Cambodia',
 'Country Code': 116,
 'ISO3 Alpha Code': 'KHM',
 'ISO2 Alpha Code': 'KH',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1962, 1980, 1998 and 2008; Estimates for 1950, 1966 and 2017; UN Estimates for 1970, 1975, 1975 and 1979.',
 'Definition': 'For 1998 and later, communes that meet at least one of the following criteria: (1) population density exceeding 200 persons per square kilometre, (2) percentage of male employment in agriculture below 50 per cent, or (3) 2,000 inhabitants or more. For 1962 and 1980, municipalities of Phnom Penh, Bokor and Kep, as well as 13 additional urban centres.'},
{'Index': 36,
 'Country or area': 'Cameroon',
 'Country Code': 120,
 'ISO3 Alpha Code': 'CMR',
 'ISO2 Alpha Code': 'CM',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1976, 1987 and 2005; Estimates for 1959 and 1970.',
 'Definition': 'Administrative centres of territorial units (district, sub-division, division or province) or any locality with 5,000 inhabitants or more and with sufficient socio-economic and administrative infrastructures.'},
{'Index': 37,
 'Country or area': 'Canada',
 'Country Code': 124,
 'ISO3 Alpha Code': 'CAN',
 'ISO2 Alpha Code': 'CA',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1951, 1956, 1961, 1966, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Definition': 'For 1981 and later, areas with 1,000 inhabitants or more and at least 400 inhabitants per square kilometre. The definition of urban has changed slightly between 1951 and 1981.'},
{'Index': 38,
 'Country or area': 'Caribbean Netherlands',
 'Country Code': 535,
 'ISO3 Alpha Code': 'BES',
 'ISO2 Alpha Code': 'BQ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1972, 1981, 1992 and 2001; Estimate for 2013.',
 'Definition': 'The island of Bonaire.'},
{'Index': 39,
 'Country or area': 'Cayman Islands',
 'Country Code': 136,
 'ISO3 Alpha Code': 'CYM',
 'ISO2 Alpha Code': 'KY',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970, 1979, 1989, 1999 and 2010; Sample Survey of 2007.',
 'Definition': 'Entire population.'},
{'Index': 40,
 'Country or area': 'Central African Republic',
 'Country Code': 140,
 'ISO3 Alpha Code': 'CAF',
 'ISO2 Alpha Code': 'CF',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1975, 1988 and 2003; Estimates for 1960, 1963 and 1967.',
 'Definition': 'Principal centres with 3,000 inhabitants or more.'},
{'Index': 41,
 'Country or area': 'Chad',
 'Country Code': 148,
 'ISO3 Alpha Code': 'TCD',
 'ISO2 Alpha Code': 'TD',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1993 and 2009; Estimates for 1972 and 1978; Sample Survey of 1964; UN Estimate for 1950.',
 'Definition': 'Administrative centres of prefectures, sous-prefectures and administrative posts.'},
{'Index': 42,
 'Country or area': 'Channel Islands',
 'Country Code': 830,
 'ISO3 Alpha Code': 'CHI',
 'ISO2 Alpha Code': '',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1971, 1981, 1986, 1991, 1996 and 2001; Estimates for 2011 and 2016.',
 'Definition': 'Civil Parish of St. Peter Port, Guernsey; Civil Parish of St. Helier, Jersey.'},
{'Index': 43,
 'Country or area': 'Chile',
 'Country Code': 152,
 'ISO3 Alpha Code': 'CHL',
 'ISO2 Alpha Code': 'CL',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1952, 1960, 1970, 1982, 1992, 2002 and 2015.',
 'Definition': 'Populated centres with defined urban characteristics, such as certain public and municipal services.'},
{'Index': 44,
 'Country or area': 'China',
 'Country Code': 156,
 'ISO3 Alpha Code': 'CHN',
 'ISO2 Alpha Code': 'CN',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1953, 1964, 1982, 1990, 2000 and 2010; Estimates for 1965, 1970, 1972, 1975, 1977, 2005 and 2016.',
 'Definition': 'For 1982 and earlier, total population of cities and towns. Cities had 100,000 inhabitants or more or commanded special administrative, strategic, or economic importance . Towns were either settlements with 3,000 inhabitants or more, of whom more than 70 per cent were registered as non-agricultural, or settlements with between 2,500 and 3,000 inhabitants, of whom more than 85 per cent were registered as non-agricultural. For 1990, all residents of urban districts in provincial and prefectural-level cities, the resident population of streets (jiedao) in county-level cities, and the population of all resident committees in towns. For 2000, population of city districts with average population density of at least 1,500 persons per square kilometre, population of suburban-district units and township-level units meeting certain criteria, such as having contiguous built-up area, being the location of the local government, or being a street (jiedao) or having a resident committee. For 2010, urban residents meeting the criterion defined by the National Bureau of Statistics of China in 2008, i.e., the criteria used in the 2000 census plus residents living in villages or towns in outer urban and suburban areas that are directly connected to municipal infrastructure and that receive public services from urban municipalities.'},
{'Index': 45,
 'Country or area': 'China, Hong Kong SAR',
 'Country Code': 344,
 'ISO3 Alpha Code': 'HKG',
 'ISO2 Alpha Code': 'HK',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1961, 1971, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016; UN Estimate for 1950.',
 'Definition': 'Hong Kong Island, New Kowloon and new towns in New Territories.'},
{'Index': 46,
 'Country or area': 'China, Macao SAR',
 'Country Code': 446,
 'ISO3 Alpha Code': 'MAC',
 'ISO2 Alpha Code': 'MO',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1960, 1970, 2001, 2006, 2011 and 2016; UN Estimates for 1981 and 1995.',
 'Definition': 'For 2001 and later, the entire population. Before 2001, the entire population except for the maritime population and residents of Coloane, Taipa, and Co-Thai.'},
{'Index': 47,
 'Country or area': 'China, Taiwan Province of China',
 'Country Code': 158,
 'ISO3 Alpha Code': 'TWN',
 'ISO2 Alpha Code': 'TW',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1974, 1990, 2000 and 2010; UN Estimates for 1958 and 1964.',
 'Definition': 'A place meeting one of three criteria: (1) more than 70 per cent of the population engaged in non-agricultural sectors and at least 300 inhabitants per square kilometre; (2) at least 2,000 inhabitants per square kilometre; (3) having at least three of the following: the government seat, a police station or branch, a railway or bus station, a public primary, middle, or high school, a post office, a hospital or clinic, and a cinema. Hilly villages with police, transit and schools, but none of the other facitities, are not considered urban.'},
{'Index': 48,
 'Country or area': 'Colombia',
 'Country Code': 170,
 'ISO3 Alpha Code': 'COL',
 'ISO2 Alpha Code': 'CO',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1951, 1964, 1973, 1985, 1993 and 2005.',
 'Definition': 'Administrative headquarters (población cabecera) with 2,000 inhabitants or more.'},
{'Index': 49,
 'Country or area': 'Comoros',
 'Country Code': 174,
 'ISO3 Alpha Code': 'COM',
 'ISO2 Alpha Code': 'KM',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1966, 1980, 1991 and 2003; UN Estimate for 1950.',
 'Definition': 'Administrative centres of prefectures and localities with 5,000 inhabitants or more.'},
{'Index': 50,
 'Country or area': 'Congo',
 'Country Code': 178,
 'ISO3 Alpha Code': 'COG',
 'ISO2 Alpha Code': 'CG',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1974, 1984, 1996 and 2007.',
 'Definition': 'For 1984 and later, six communes: Brazzaville, Pointe-Noire, Dolisie/Loubomo, Nkayi, Ouesso and Mossendjo.'},
{'Index': 51,
 'Country or area': 'Cook Islands',
 'Country Code': 184,
 'ISO3 Alpha Code': 'COK',
 'ISO2 Alpha Code': 'CK',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1956, 1966, 1971, 1976, 1981, 1986, 1991, 1996, 2001, 2006, 2011 and 2016.',
 'Definition': 'Island of Rarotonga.'},
{'Index': 52,
 'Country or area': 'Costa Rica',
 'Country Code': 188,
 'ISO3 Alpha Code': 'CRI',
 'ISO2 Alpha Code': 'CR',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1963, 1973, 1984, 2000 and 2011.',
 'Definition': 'Administrative centres of cantons or districts, including adjacent areas with clear urban characteristics such as streets, urban services (waste management, street lighting), and economic activities.'},
{'Index': 53,
 'Country or area': "Côte d'Ivoire",
 'Country Code': 384,
 'ISO3 Alpha Code': 'CIV',
 'ISO2 Alpha Code': 'CI',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1958, 1975, 1988, 1998 and 2014; Sample Survey of 1965 and 1978.',
 'Definition': 'Agglomerations with 10,000 inhabitants or more; agglomerations with between 4,000 and 10,000 inhabitants and with more than 50 per cent of households engaged in non-agricultural activities; and the administrative centres of Grand Lahoun and Dabakala.'},
{'Index': 54,
 'Country or area': 'Croatia',
 'Country Code': 191,
 'ISO3 Alpha Code': 'HRV',
 'ISO2 Alpha Code': 'HR',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1953, 1961, 1971, 1981, 1991, 2001 and 2011.',
 'Definition': 'Administrative seats of towns; settlements with 10,000 inhabitants or more; settlements with between 5,000 and 9,999 inhabitants and with at least 25 per cent employed in the secondary or tertiary sectors; settlements with between 2,000 and 4,999 in habitants and with at least 25 per cent employed in the secondary or tertiary sectors and with at least 50 per cent non-agricultural households.'},
{'Index': 55,
 'Country or area': 'Cuba',
 'Country Code': 192,
 'ISO3 Alpha Code': 'CUB',
 'ISO2 Alpha Code': 'CU',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1953, 1970, 1981, 2002 and 2012; Estimates for 1990, 1996 and 2016.',
 'Definition': 'Administrative centers of municipalities and provinces and settlements of 2,000 inhabitants or more with urban characteristics, such as streets, street lighting, water-supply and sewerage systems, waste management, planned public spaces, medical centres, educational facilities, communication services and trade.'},
{'Index': 56,
 'Country or area': 'Curaçao',
 'Country Code': 531,
 'ISO3 Alpha Code': 'CUW',
 'ISO2 Alpha Code': 'CW',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1992, 2001 and 2011; UN Estimate for 1960.',
 'Definition': 'Willemstad (capital).'},
{'Index': 57,
 'Country or area': 'Cyprus',
 'Country Code': 196,
 'ISO3 Alpha Code': 'CYP',
 'ISO2 Alpha Code': 'CY',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1956, 1960, 1973, 1982, 1992, 2001 and 2011.',
 'Definition': 'Six district towns and the suburbs of Nicosia and Larnaka.'},
{'Index': 58,
 'Country or area': 'Czechia',
 'Country Code': 203,
 'ISO3 Alpha Code': 'CZE',
 'ISO2 Alpha Code': 'CZ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1961, 1970, 1980, 1991 and 2001; Estimates for 2011 and 2016.',
 'Definition': 'Municipalities with 2,000 inhabitants or more.'},
{'Index': 59,
 'Country or area': "Dem. People's Republic of Korea",
 'Country Code': 408,
 'ISO3 Alpha Code': 'PRK',
 'ISO2 Alpha Code': 'KP',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1993 and 2008; Estimates for 1950, 1960, 1967, 1970, 1975 and 1980; Sample Survey of 2014.',
 'Definition': 'No official definition available.'},
{'Index': 60,
 'Country or area': 'Democratic Republic of the Congo',
 'Country Code': 180,
 'ISO3 Alpha Code': 'COD',
 'ISO2 Alpha Code': 'CD',
 'Data': 'Urban Population',
 'Sources': 'Census of 1984; Estimates for 1950 and 1960; UN Estimate for 2004.',
 'Definition': 'Places with 2,000 inhabitants or more where the predominant economic activity is non-agricultural; and places with fewer than 2,000 inhabitants that are considered urban because of their type of economic activity (predominantly non-agricultural).'},
{'Index': 61,
 'Country or area': 'Denmark',
 'Country Code': 208,
 'ISO3 Alpha Code': 'DNK',
 'ISO2 Alpha Code': 'DK',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1955, 1960, 1965 and 1970; Estimates for 1990, 2000, 2001, 2003 and 2004; Registers of 1976, 1981, 2006, 2009, 2011, 2013 and 2017.',
 'Definition': 'Localities with 200 inhabitants or more.'},
{'Index': 62,
 'Country or area': 'Djibouti',
 'Country Code': 262,
 'ISO3 Alpha Code': 'DJI',
 'ISO2 Alpha Code': 'DJ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1983 and 2009; Estimate for 1956; Sample Survey of 1991.',
 'Definition': 'For 2009, Djibouti ville, and urban and rural sedentary populations of the regions of Ali Sabieh, Dikhil, Tadjourah, Obock and Arta. For 1991, nine towns: Djibouti (capital), Dikhil, Ali-Sabieh, Tadjourah, Obock, Arta, Damerjog, Yoboki and Randa. For 1983, the urban population of the districts of Djibouti, Ali-Sabieh, Dikhil, Tadjourah and Obock. For 1956 and 1960, Djibouti (capital).'},
{'Index': 63,
 'Country or area': 'Dominica',
 'Country Code': 212,
 'ISO3 Alpha Code': 'DMA',
 'ISO2 Alpha Code': 'DM',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970, 1981, 1991, 2001 and 2011.',
 'Definition': 'Cities and villages with 1,000 inhabitants or more.'},
{'Index': 64,
 'Country or area': 'Dominican Republic',
 'Country Code': 214,
 'ISO3 Alpha Code': 'DOM',
 'ISO2 Alpha Code': 'DO',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1960, 1970, 1981, 1993, 2002 and 2010; Estimate for 2017.',
 'Definition': 'Administrative centres of communes and municipal districts.'},
{'Index': 65,
 'Country or area': 'Ecuador',
 'Country Code': 218,
 'ISO3 Alpha Code': 'ECU',
 'ISO2 Alpha Code': 'EC',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1962, 1974, 1982, 1990, 2001 and 2010; Estimate for 2017.',
 'Definition': 'Capitals of provinces and cantons.'},
{'Index': 66,
 'Country or area': 'Egypt',
 'Country Code': 818,
 'ISO3 Alpha Code': 'EGY',
 'ISO2 Alpha Code': 'EG',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1976, 1986, 1996 and 2006; Estimates for 2011 and 2016.',
 'Definition': "Governorates of Al-Qahirah (Cairo), Al-Iskandariyah (Alexandria), Bur Sa'id (Port Said), Al-Isma'iliyah (Ismailia) and As-Suways (Suez); frontier governorates; and capitals of other governorates as well as district capitals (markaz)."},
{'Index': 67,
 'Country or area': 'El Salvador',
 'Country Code': 222,
 'ISO3 Alpha Code': 'SLV',
 'ISO2 Alpha Code': 'SV',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1961, 1971, 1992 and 2007; Estimates for 1998 and 2015.',
 'Definition': 'For 2007, the head of the municipality, where the primary civil, religious and military authorities reside, and those areas having a continuous cluster of at least 500 dwellings, with street lighting service, basic schools, regular transportation service, paved or cobbled streets and telephone services. For 1971, areas where authorities of the municipality reside, as determined by those authorities.'},
{'Index': 68,
 'Country or area': 'Equatorial Guinea',
 'Country Code': 226,
 'ISO3 Alpha Code': 'GNQ',
 'ISO2 Alpha Code': 'GQ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1960, 1983, 1994 and 2015; UN Estimate for 2012.',
 'Definition': 'District centres and localities with 300 dwellings or more or with 1,500 inhabitants or more.'},
{'Index': 69,
 'Country or area': 'Eritrea',
 'Country Code': 232,
 'ISO3 Alpha Code': 'ERI',
 'ISO2 Alpha Code': 'ER',
 'Data': 'Urban Population',
 'Sources': 'Census of 1984; Sample Survey of 2010; UN Estimates for 1950, 1967 and 2008.',
 'Definition': 'Localities with 2,000 inhabitants or more.'},
{'Index': 70,
 'Country or area': 'Estonia',
 'Country Code': 233,
 'ISO3 Alpha Code': 'EST',
 'ISO2 Alpha Code': 'EE',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1959, 1970, 1979, 1989, 2000 and 2011; Estimate for 2016.',
 'Definition': 'Officially designated urban settlements including cities, cities without municipal status and towns.'},
{'Index': 71,
 'Country or area': 'Ethiopia',
 'Country Code': 231,
 'ISO3 Alpha Code': 'ETH',
 'ISO2 Alpha Code': 'ET',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1984, 1994 and 2007; Estimates for 1950, 1967, 2012 and 2017.',
 'Definition': 'Localities with 2,000 inhabitants or more.'},
{'Index': 72,
 'Country or area': 'Faeroe Islands',
 'Country Code': 234,
 'ISO3 Alpha Code': 'FRO',
 'ISO2 Alpha Code': 'FO',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1950, 1955, 1960, 1966, 1970 and 1977; Estimates for 1989, 1990, 1996, 1997, 1998, 1999, 2002, 2005, 2010 and 2017.',
 'Definition': 'Torshavn (capital).'},
{'Index': 73,
 'Country or area': 'Falkland Islands (Malvinas)',
 'Country Code': 238,
 'ISO3 Alpha Code': 'FLK',
 'ISO2 Alpha Code': 'FK',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1972, 1980, 1986, 1991, 1996, 2001, 2006 and 2012; Estimates for 1953 and 1962.',
 'Definition': 'Stanley.'},
{'Index': 74,
 'Country or area': 'Fiji',
 'Country Code': 242,
 'ISO3 Alpha Code': 'FJI',
 'ISO2 Alpha Code': 'FJ',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1956, 1966, 1976, 1986, 1996, 2007 and 2017.',
 'Definition': 'Places with 1,000 inhabitants or more.'},
{'Index': 75,
 'Country or area': 'Finland',
 'Country Code': 246,
 'ISO3 Alpha Code': 'FIN',
 'ISO2 Alpha Code': 'FI',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1960, 1970 and 1980; Registers of 1985, 1990, 1995, 2000, 2009, 2012 and 2016; UN Estimate for 1950.',
 'Definition': 'Communes officially designated as urban.'},
{'Index': 76,
 'Country or area': 'France',
 'Country Code': 250,
 'ISO3 Alpha Code': 'FRA',
 'ISO2 Alpha Code': 'FR',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1954, 1962, 1968, 1975, 1982, 1990, 1999 and 2007.',
 'Definition': 'Based on the concept of urban unit, namely communes with 2,000 inhabitants or more in dwellings separated by at most 200 metres.'},
{'Index': 77,
 'Country or area': 'French Guiana',
 'Country Code': 254,
 'ISO3 Alpha Code': 'GUF',
 'ISO2 Alpha Code': 'GF',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1954, 1961, 1967, 1982, 1990 and 2006.',
 'Definition': 'No official definition available.'},
{'Index': 78,
 'Country or area': 'French Polynesia',
 'Country Code': 258,
 'ISO3 Alpha Code': 'PYF',
 'ISO2 Alpha Code': 'PF',
 'Data': 'Urban Population',
 'Sources': 'Censuses of 1962, 1977, 1983, 1988, 1996, 2002, 2012 and 2017; Estimates for 1956 and 1971.',
 'Definition': 'No official definition available. In the present publication, for 2017, the urban agglomeration of Papeete and communes with 5,000 inhabitants or more. For 2012, the same communes as in 2017.'}]},
'Growth Rate Cities': {'headers': ['Index',
'Country Code',
'Country or area',
'City Code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
'1950-1955',
'1955-1960',
'1960-1965',
'1965-1970',
'1970-1975',
'1975-1980',
'1980-1985',
'1985-1990',
'1990-1995',
'1995-2000',
'2000-2005',
'2005-2010',
'2010-2015',
'2015-2020',
'2020-2025',
'2025-2030',
'2030-2035'],
'data': [{'Index': 1,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20001,
 'Urban Agglomeration': 'Herat',
 'Note': '',
 'Latitude': 34.34817,
 'Longitude': 62.19967,
 '1950-1955': 0.7807481695,
 '1955-1960': 0.7810410644,
 '1960-1965': 0.7806094155,
 '1965-1970': 1.8255402998,
 '1970-1975': 3.3874501327,
 '1975-1980': 3.5730771962,
 '1980-1985': 2.4315939631,
 '1985-1990': 2.4322112448,
 '1990-1995': 2.4322466613,
 '1995-2000': 2.4329281281,
 '2000-2005': 3.2790172977,
 '2005-2010': 5.2645555131,
 '2010-2015': 5.2646357486,
 '2015-2020': 5.209706777,
 '2020-2025': 4.3553455769,
 '2025-2030': 3.5031174037,
 '2030-2035': 3.2926074068},
{'Index': 2,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20002,
 'Urban Agglomeration': 'Kabul',
 'Note': '',
 'Latitude': 34.528887,
 'Longitude': 69.17246,
 '1950-1955': 5.1325341862,
 '1955-1960': 5.1339439286,
 '1960-1965': 5.1311077792,
 '1965-1970': 4.9293826372,
 '1970-1975': 7.1371773561,
 '1975-1980': 7.4344560044,
 '1980-1985': 4.750110235,
 '1985-1990': 4.4547239497,
 '1990-1995': 4.3805392987,
 '1995-2000': 4.3817524807,
 '2000-2005': 3.8112789627,
 '2005-2010': 2.4818085066,
 '2010-2015': 2.481810939,
 '2015-2020': 2.5104492193,
 '2020-2025': 2.8867420486,
 '2025-2030': 3.2485056388,
 '2030-2035': 3.282727442},
{'Index': 3,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20003,
 'Urban Agglomeration': 'Kandahar',
 'Note': '',
 'Latitude': 31.61332,
 'Longitude': 65.71013,
 '1950-1955': 1.7654957391,
 '1955-1960': 1.7660874454,
 '1960-1965': 1.765108224,
 '1965-1970': 3.4299977003,
 '1970-1975': 3.8310585895,
 '1975-1980': 3.4386180715,
 '1980-1985': 2.4308471304,
 '1985-1990': 2.4315409402,
 '1990-1995': 2.4314795607,
 '1995-2000': 2.4322301659,
 '2000-2005': 2.4812524417,
 '2005-2010': 2.600109374,
 '2010-2015': 2.6001187276,
 '2015-2020': 2.6252750207,
 '2020-2025': 2.9491997183,
 '2025-2030': 3.259327808,
 '2030-2035': 3.2831468461},
{'Index': 4,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20004,
 'Urban Agglomeration': 'Mazar-e Sharif',
 'Note': '',
 'Latitude': 36.70904,
 'Longitude': 67.11087,
 '1950-1955': 4.269404975,
 '1955-1960': 4.270342802,
 '1960-1965': 4.2678345234,
 '1965-1970': 4.2693735246,
 '1970-1975': 4.2691455739,
 '1975-1980': 3.8943927565,
 '1980-1985': 2.4314871526,
 '1985-1990': 2.4322204593,
 '1990-1995': 2.4320534016,
 '1995-2000': 2.4328958386,
 '2000-2005': 3.6035127268,
 '2005-2010': 6.3498884638,
 '2010-2015': 6.3499045416,
 '2015-2020': 6.2623509106,
 '2020-2025': 4.9280794762,
 '2025-2030': 3.6024327075,
 '2030-2035': 3.2964677897},
{'Index': 5,
 'Country Code': 8,
 'Country or area': 'Albania',
 'City Code': 20005,
 'Urban Agglomeration': 'Tiranë (Tirana)',
 'Note': '',
 'Latitude': 41.3275,
 'Longitude': 19.81889,
 '1950-1955': 4.7057549947,
 '1955-1960': 4.6261944138,
 '1960-1965': 1.4997595887,
 '1965-1970': 1.5211856478,
 '1970-1975': 2.0872301959,
 '1975-1980': 2.1421962203,
 '1980-1985': 2.3586442018,
 '1985-1990': 2.5305445036,
 '1990-1995': 3.0461199387,
 '1995-2000': 3.0469232059,
 '2000-2005': 2.0646225973,
 '2005-2010': 1.8921981217,
 '2010-2015': 1.89424629,
 '2015-2020': 1.8853197306,
 '2020-2025': 1.6325137017,
 '2025-2030': 1.0756059268,
 '2030-2035': 0.5693859366},
{'Index': 6,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20009,
 'Urban Agglomeration': 'Annaba',
 'Note': '',
 'Latitude': 36.9,
 'Longitude': 7.76667,
 '1950-1955': 3.0966728922,
 '1955-1960': 3.0975340067,
 '1960-1965': 3.0957033124,
 '1965-1970': 3.8151262624,
 '1970-1975': 3.9436945177,
 '1975-1980': 2.6379629444,
 '1980-1985': 2.0113080505,
 '1985-1990': 1.1671757088,
 '1990-1995': 0.7251132314,
 '1995-2000': 0.5693123538,
 '2000-2005': 0.3378678502,
 '2005-2010': 0.3379901399,
 '2010-2015': 0.3377274996,
 '2015-2020': 0.3993935928,
 '2020-2025': 1.1448554621,
 '2025-2030': 1.5691388523,
 '2030-2035': 1.373412436},
{'Index': 7,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20011,
 'Urban Agglomeration': 'Batna',
 'Note': '',
 'Latitude': 35.55597,
 'Longitude': 6.17414,
 '1950-1955': 9.2166106689,
 '1955-1960': 9.2186693002,
 '1960-1965': 9.214192872,
 '1965-1970': 6.1744030518,
 '1970-1975': 5.6304294084,
 '1975-1980': 5.6375841213,
 '1980-1985': 5.6373785812,
 '1985-1990': 3.6227571063,
 '1990-1995': 2.5674355059,
 '1995-2000': 2.0903844688,
 '2000-2005': 1.3830170292,
 '2005-2010': 1.3833397174,
 '2010-2015': 1.383302535,
 '2015-2020': 1.4122521048,
 '2020-2025': 1.6959578883,
 '2025-2030': 1.6647062622,
 '2030-2035': 1.3770748453},
{'Index': 8,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20015,
 'Urban Agglomeration': 'Blida',
 'Note': '',
 'Latitude': 36.480781,
 'Longitude': 2.831943,
 '1950-1955': 6.0589239876,
 '1955-1960': 6.0607945621,
 '1960-1965': 6.0574140928,
 '1965-1970': 4.2964789712,
 '1970-1975': 3.9811991465,
 '1975-1980': 2.8204616245,
 '1980-1985': 2.2630463585,
 '1985-1990': 2.9820907847,
 '1990-1995': 3.3578899134,
 '1995-2000': 3.1768322897,
 '2000-2005': 2.9055767044,
 '2005-2010': 2.9062934531,
 '2010-2015': 2.9064967303,
 '2015-2020': 2.8875606794,
 '2020-2025': 2.4986682694,
 '2025-2030': 1.8039032364,
 '2030-2035': 1.3824888999},
{'Index': 9,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20006,
 'Urban Agglomeration': 'El Djazaïr  (Algiers)',
 'Note': 1.0,
 'Latitude': 36.7525,
 'Longitude': 3.04197,
 '1950-1955': 3.7488245303,
 '1955-1960': 6.719044012,
 '1960-1965': 4.31268646,
 '1965-1970': 3.3897841942,
 '1970-1975': 3.243075873,
 '1975-1980': 1.4684384766,
 '1980-1985': 0.6180995334,
 '1985-1990': 1.4387118897,
 '1990-1995': 1.8681174975,
 '1995-2000': 1.630261921,
 '2000-2005': 1.2763111505,
 '2005-2010': 1.2766488982,
 '2010-2015': 1.2766732781,
 '2015-2020': 1.3089094791,
 '2020-2025': 1.6397289613,
 '2025-2030': 1.6549560205,
 '2030-2035': 1.3767090327},
{'Index': 10,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20020,
 'Urban Agglomeration': 'El Djelfa',
 'Note': '',
 'Latitude': 34.67279,
 'Longitude': 3.263,
 '1950-1955': 5.6827023918,
 '1955-1960': 5.6843773105,
 '1960-1965': 5.6816886701,
 '1965-1970': 5.682725549,
 '1970-1975': 5.6833463915,
 '1975-1980': 5.6846447262,
 '1980-1985': 5.6815837424,
 '1985-1990': 5.6434859489,
 '1990-1995': 5.622726325,
 '1995-2000': 5.4804102337,
 '2000-2005': 5.2641676605,
 '2005-2010': 5.2655655435,
 '2010-2015': 5.2655092288,
 '2015-2020': 5.172609174,
 '2020-2025': 3.7419389635,
 '2025-2030': 2.0194185637,
 '2030-2035': 1.3908613447},
{'Index': 11,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20019,
 'Urban Agglomeration': 'Qacentina',
 'Note': '',
 'Latitude': 36.354921,
 'Longitude': 6.607293,
 '1950-1955': 6.513447327,
 '1955-1960': 6.5151840303,
 '1960-1965': 6.5115873681,
 '1965-1970': 3.6549845413,
 '1970-1975': 3.1435160198,
 '1975-1980': 2.6927444982,
 '1980-1985': 2.4751643109,
 '1985-1990': 1.2976886689,
 '1990-1995': 0.6810632571,
 '1995-2000': 0.130781586,
 '2000-2005': -0.6845177243,
 '2005-2010': -0.6847436179,
 '2010-2015': -0.6848992894,
 '2015-2020': -0.5911136666,
 '2020-2025': 0.6059288988,
 '2025-2030': 1.4757343824,
 '2030-2035': 1.3697349723},
{'Index': 12,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20037,
 'Urban Agglomeration': 'Sétif',
 'Note': '',
 'Latitude': 36.19112,
 'Longitude': 5.41373,
 '1950-1955': 4.8172891673,
 '1955-1960': 4.8186177455,
 '1960-1965': 4.8157812372,
 '1965-1970': 3.7451542914,
 '1970-1975': 3.553292479,
 '1975-1980': 2.9675781224,
 '1980-1985': 2.6850322409,
 '1985-1990': 2.1990922931,
 '1990-1995': 1.9443856594,
 '1995-2000': 1.8765512952,
 '2000-2005': 1.7742478214,
 '2005-2010': 1.774808427,
 '2010-2015': 1.774647218,
 '2015-2020': 1.7912700034,
 '2020-2025': 1.9021363626,
 '2025-2030': 1.700469011,
 '2030-2035': 1.378457455},
{'Index': 13,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20035,
 'Urban Agglomeration': 'Wahran (Oran)',
 'Note': '',
 'Latitude': 35.69111,
 'Longitude': -0.64167,
 '1950-1955': 1.2561596457,
 '1955-1960': 1.2564844305,
 '1960-1965': 1.2558104249,
 '1965-1970': 3.4168336631,
 '1970-1975': 3.8034500465,
 '1975-1980': 2.8254726053,
 '1980-1985': 2.3554909067,
 '1985-1990': 1.722114863,
 '1990-1995': 1.3903465684,
 '1995-2000': 1.1950229447,
 '2000-2005': 0.9046029976,
 '2005-2010': 0.9048521087,
 '2010-2015': 0.9048778713,
 '2015-2020': 0.9487958522,
 '2020-2025': 1.4437925903,
 '2025-2030': 1.6209738855,
 '2030-2035': 1.3753954789},
{'Index': 14,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000001,
 'Urban Agglomeration': 'Benguela',
 'Note': 2.0,
 'Latitude': -12.576,
 'Longitude': 13.405,
 '1950-1955': 4.6071557808,
 '1955-1960': 4.6072202934,
 '1960-1965': 5.5596868948,
 '1965-1970': 5.6674814701,
 '1970-1975': 10.1574027407,
 '1975-1980': 10.6123167144,
 '1980-1985': 8.0156126855,
 '1985-1990': 4.1321281742,
 '1990-1995': 4.1321960943,
 '1995-2000': 4.1333128748,
 '2000-2005': 4.1310407581,
 '2005-2010': 4.132190025,
 '2010-2015': 4.1321744885,
 '2015-2020': 4.1348663651,
 '2020-2025': 4.1037361017,
 '2025-2030': 3.8723174746,
 '2030-2035': 3.5672811572},
{'Index': 15,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204043,
 'Urban Agglomeration': 'Cabinda',
 'Note': 3.0,
 'Latitude': -5.55,
 'Longitude': 12.2,
 '1950-1955': -0.2514684167,
 '1955-1960': -0.2459843286,
 '1960-1965': 13.7497275458,
 '1965-1970': 15.3103723547,
 '1970-1975': 9.9218930615,
 '1975-1980': 9.3822875889,
 '1980-1985': 9.3769477834,
 '1985-1990': 9.3795802061,
 '1990-1995': 7.8404406811,
 '1995-2000': 5.5334521521,
 '2000-2005': 5.530366787,
 '2005-2010': 5.5319469322,
 '2010-2015': 5.5318723393,
 '2015-2020': 5.4906563032,
 '2020-2025': 4.8413945773,
 '2025-2030': 4.0002213887,
 '2030-2035': 3.5722444939},
{'Index': 16,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000011,
 'Urban Agglomeration': 'Cuito',
 'Note': '',
 'Latitude': -12.383,
 'Longitude': 16.933,
 '1950-1955': 3.8416446136,
 '1955-1960': 3.8430396638,
 '1960-1965': 3.8398235921,
 '1965-1970': 3.8410236466,
 '1970-1975': 6.4866449538,
 '1975-1980': 6.7552900468,
 '1980-1985': 6.7509701931,
 '1985-1990': 6.7532156424,
 '1990-1995': 6.7532115785,
 '1995-2000': 6.755050226,
 '2000-2005': 6.7512596807,
 '2005-2010': 6.7531570078,
 '2010-2015': 6.7531456157,
 '2015-2020': 6.6735430867,
 '2020-2025': 5.4849353324,
 '2025-2030': 4.1117926006,
 '2030-2035': 3.5765845605},
{'Index': 17,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20050,
 'Urban Agglomeration': 'Huambo',
 'Note': 4.0,
 'Latitude': -12.77611,
 'Longitude': 15.73917,
 '1950-1955': 8.8439337792,
 '1955-1960': 8.8467888692,
 '1960-1965': 5.1162481339,
 '1965-1970': 4.7031348559,
 '1970-1975': 9.0351390135,
 '1975-1980': 9.473894454,
 '1980-1985': 8.3930790433,
 '1985-1990': 6.7825986021,
 '1990-1995': 4.8314776207,
 '1995-2000': 1.9053634725,
 '2000-2005': 1.9042702231,
 '2005-2010': 1.9047785813,
 '2010-2015': 1.9047995251,
 '2015-2020': 1.9772845963,
 '2020-2025': 2.9297648489,
 '2025-2030': 3.6687984784,
 '2030-2035': 3.5593898052},
{'Index': 18,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000000,
 'Urban Agglomeration': 'Lobito',
 'Note': 5.0,
 'Latitude': -12.364,
 'Longitude': 13.536,
 '1950-1955': 7.4215949871,
 '1955-1960': 7.4230654152,
 '1960-1965': 2.2826187986,
 '1965-1970': 1.7118040247,
 '1970-1975': 6.8508321583,
 '1975-1980': 7.3703560316,
 '1980-1985': 5.5459361677,
 '1985-1990': 2.8171339356,
 '1990-1995': 2.8171494534,
 '1995-2000': 2.8178857409,
 '2000-2005': 2.8163028318,
 '2005-2010': 2.8171177578,
 '2010-2015': 2.8171650295,
 '2015-2020': 2.8610244813,
 '2020-2025': 3.4106318439,
 '2025-2030': 3.7521950554,
 '2030-2035': 3.5626202094},
{'Index': 19,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20049,
 'Urban Agglomeration': 'Luanda',
 'Note': 6.0,
 'Latitude': -8.83682,
 'Longitude': 13.23432,
 '1950-1955': 4.6070474951,
 '1955-1960': 4.6085051801,
 '1960-1965': 7.2379166808,
 '1965-1970': 7.5324969765,
 '1970-1975': 5.2978584464,
 '1975-1980': 5.0741544336,
 '1980-1985': 5.8737637157,
 '1985-1990': 7.0760566171,
 '1990-1995': 6.7577160867,
 '1995-2000': 6.281943831,
 '2000-2005': 6.2784883796,
 '2005-2010': 6.2802131733,
 '2010-2015': 5.6285013544,
 '2015-2020': 3.4123879449,
 '2020-2025': 3.7106340564,
 '2025-2030': 3.8041782527,
 '2030-2035': 3.5646333501},
{'Index': 20,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204044,
 'Urban Agglomeration': 'Lubango',
 'Note': 7.0,
 'Latitude': -14.91717,
 'Longitude': 13.4925,
 '1950-1955': 2.4946067239,
 '1955-1960': 2.4960715246,
 '1960-1965': 6.9945140415,
 '1965-1970': 7.4963641989,
 '1970-1975': 8.112787014,
 '1975-1980': 8.1772803847,
 '1980-1985': 8.1724830216,
 '1985-1990': 8.1749040053,
 '1990-1995': 7.0126118505,
 '1995-2000': 5.2705258964,
 '2000-2005': 5.2675781661,
 '2005-2010': 5.2690761406,
 '2010-2015': 5.2690706213,
 '2015-2020': 5.2360140651,
 '2020-2025': 4.7028221359,
 '2025-2030': 3.9761985859,
 '2030-2035': 3.5713165886},
{'Index': 21,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000004,
 'Urban Agglomeration': 'Malanje',
 'Note': 8.0,
 'Latitude': -9.54,
 'Longitude': 16.341,
 '1950-1955': 6.9302023509,
 '1955-1960': 6.9338310301,
 '1960-1965': 5.2900746519,
 '1965-1970': 5.1091132522,
 '1970-1975': 6.0604854214,
 '1975-1980': 6.1577147364,
 '1980-1985': 6.1545967341,
 '1985-1990': 6.1560731183,
 '1990-1995': 6.1561770315,
 '1995-2000': 6.1578318004,
 '2000-2005': 6.1545554767,
 '2005-2010': 6.1561353697,
 '2010-2015': 6.1562169484,
 '2015-2020': 6.095416064,
 '2020-2025': 5.1704635041,
 '2025-2030': 4.0572720755,
 '2030-2035': 3.5744481968},
{'Index': 22,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000012,
 'Urban Agglomeration': 'Uige',
 'Note': '',
 'Latitude': -7.1069,
 'Longitude': 15.4406,
 '1950-1955': 6.4444768802,
 '1955-1960': 6.4520333236,
 '1960-1965': 6.4464211415,
 '1965-1970': 6.4492419603,
 '1970-1975': 7.4824669093,
 '1975-1980': 7.5873005483,
 '1980-1985': 7.5846765377,
 '1985-1990': 7.5859120067,
 '1990-1995': 7.5859988074,
 '1995-2000': 7.5883304872,
 '2000-2005': 7.5840327763,
 '2005-2010': 7.5860938436,
 '2010-2015': 7.5861622198,
 '2015-2020': 7.4805316553,
 '2020-2025': 5.924044854,
 '2025-2030': 4.1879317462,
 '2030-2035': 3.5795239315},
{'Index': 23,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20057,
 'Urban Agglomeration': 'Bahia Blanca',
 'Note': '',
 'Latitude': -38.7196,
 'Longitude': -62.27243,
 '1950-1955': 0.8792067318,
 '1955-1960': 0.8795576109,
 '1960-1965': 3.4953513617,
 '1965-1970': 3.6331624031,
 '1970-1975': 2.1263242413,
 '1975-1980': 2.0476688815,
 '1980-1985': 1.2898261898,
 '1985-1990': 1.240443481,
 '1990-1995': 0.7236651297,
 '1995-2000': 0.6148240998,
 '2000-2005': 0.9606475592,
 '2005-2010': 1.0931404482,
 '2010-2015': 0.5469907726,
 '2015-2020': 0.5254571085,
 '2020-2025': 0.7340501784,
 '2025-2030': 0.867130648,
 '2030-2035': 0.7998049717},
{'Index': 24,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 9.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 '1950-1955': 2.6913178055,
 '1955-1960': 2.692058277,
 '1960-1965': 2.2011145313,
 '1965-1970': 2.1760906029,
 '1970-1975': 1.6571531247,
 '1975-1980': 1.6303666559,
 '1980-1985': 1.1814899133,
 '1985-1990': 1.1523167601,
 '1990-1995': 1.1484234422,
 '1995-2000': 1.1479185229,
 '2000-2005': 1.278886972,
 '2005-2010': 1.3296897075,
 '2010-2015': 0.6351341436,
 '2015-2020': 0.6004564552,
 '2020-2025': 0.7747631801,
 '2025-2030': 0.8742468275,
 '2030-2035': 0.8000457815},
{'Index': 25,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20059,
 'Urban Agglomeration': 'Córdoba',
 'Note': 10.0,
 'Latitude': -31.4135,
 'Longitude': -64.18105,
 '1950-1955': 3.4365661786,
 '1955-1960': 3.4374718478,
 '1960-1965': 2.9234183867,
 '1965-1970': 2.897398071,
 '1970-1975': 2.2219296823,
 '1975-1980': 2.1870972293,
 '1980-1985': 1.7441564101,
 '1985-1990': 1.7155553112,
 '1990-1995': 1.2113866782,
 '1995-2000': 1.1053082178,
 '2000-2005': 0.8457638445,
 '2005-2010': 0.7470091223,
 '2010-2015': 0.7395876639,
 '2015-2020': 0.7479749328,
 '2020-2025': 0.8549669818,
 '2025-2030': 0.8881527335,
 '2030-2035': 0.8005893668},
{'Index': 26,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20063,
 'Urban Agglomeration': 'Corrientes',
 'Note': 11.0,
 'Latitude': -27.4806,
 'Longitude': -58.8341,
 '1950-1955': 4.0688253518,
 '1955-1960': 4.0699205978,
 '1960-1965': 3.427646321,
 '1965-1970': 3.3953511891,
 '1970-1975': 2.7845401485,
 '1975-1980': 2.7533136894,
 '1980-1985': 3.3290080799,
 '1985-1990': 3.368055325,
 '1990-1995': 2.2063123902,
 '1995-2000': 1.9616402207,
 '2000-2005': 1.5248722491,
 '2005-2010': 1.3586482011,
 '2010-2015': 1.3586438902,
 '2015-2020': 1.3475788043,
 '2020-2025': 1.1810364925,
 '2025-2030': 0.9447169417,
 '2030-2035': 0.8027727952},
{'Index': 27,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20065,
 'Urban Agglomeration': 'La Plata',
 'Note': 12.0,
 'Latitude': -34.92145,
 'Longitude': -57.95453,
 '1950-1955': 2.9229402195,
 '1955-1960': 2.9237882149,
 '1960-1965': 1.896761576,
 '1965-1970': 1.8436401702,
 '1970-1975': 1.5113350429,
 '1975-1980': 1.4943224799,
 '1980-1985': 1.2079568207,
 '1985-1990': 1.1894718687,
 '1990-1995': 0.7004051212,
 '1995-2000': 0.5973326176,
 '2000-2005': 1.3524020472,
 '2005-2010': 1.6415719618,
 '2010-2015': 1.2006212592,
 '2015-2020': 1.1651912969,
 '2020-2025': 1.0818778461,
 '2025-2030': 0.9274795304,
 '2030-2035': 0.8021221613},
{'Index': 28,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20067,
 'Urban Agglomeration': 'Mar Del Plata',
 'Note': '',
 'Latitude': -38.00228,
 'Longitude': -57.55754,
 '1950-1955': 4.5624602953,
 '1955-1960': 4.5635878767,
 '1960-1965': 3.6259083783,
 '1965-1970': 3.5779896117,
 '1970-1975': 3.1644524248,
 '1975-1980': 3.143653647,
 '1980-1985': 2.1987577962,
 '1985-1990': 2.1372520038,
 '1990-1995': 0.6984746324,
 '1995-2000': 0.3949768211,
 '2000-2005': 1.0393286941,
 '2005-2010': 1.2860475979,
 '2010-2015': 0.962618284,
 '2015-2020': 0.9426660099,
 '2020-2025': 0.96088053,
 '2025-2030': 0.9065105227,
 '2030-2035': 0.8012914049},
{'Index': 29,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20068,
 'Urban Agglomeration': 'Mendoza',
 'Note': 13.0,
 'Latitude': -32.89084,
 'Longitude': -68.82717,
 '1950-1955': 2.8954907453,
 '1955-1960': 2.8962962179,
 '1960-1965': 3.6394252951,
 '1965-1970': 3.6794673803,
 '1970-1975': 2.5330123633,
 '1975-1980': 2.4735012227,
 '1980-1985': 2.2220978509,
 '1985-1990': 2.2061972647,
 '1990-1995': 1.1122489544,
 '1995-2000': 0.8816674535,
 '2000-2005': 1.490861369,
 '2005-2010': 1.7243640147,
 '2010-2015': 1.758350172,
 '2015-2020': 1.7367996101,
 '2020-2025': 1.3926599916,
 '2025-2030': 0.9813765756,
 '2030-2035': 0.8042066058},
{'Index': 30,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20070,
 'Urban Agglomeration': 'Neuquén-Plottier-Cipolletti',
 'Note': '',
 'Latitude': -38.95143,
 'Longitude': -68.064809,
 '1950-1955': 9.6832641045,
 '1955-1960': 9.6864946541,
 '1960-1965': 6.3244150583,
 '1965-1970': 6.1506184119,
 '1970-1975': 6.8197993303,
 '1975-1980': 6.8571100973,
 '1980-1985': 5.4435104299,
 '1985-1990': 5.3521976789,
 '1990-1995': 2.3330356974,
 '1995-2000': 1.696416332,
 '2000-2005': 1.7576781315,
 '2005-2010': 1.7819132846,
 '2010-2015': 1.868394019,
 '2015-2020': 1.8467290602,
 '2020-2025': 1.4525283385,
 '2025-2030': 0.991730321,
 '2030-2035': 0.8046025298},
{'Index': 31,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20072,
 'Urban Agglomeration': 'Posadas',
 'Note': '',
 'Latitude': -27.36708,
 'Longitude': -55.89608,
 '1950-1955': 4.7162794374,
 '1955-1960': 4.7176918784,
 '1960-1965': 2.8604482482,
 '1965-1970': 2.7641923693,
 '1970-1975': 3.8120248748,
 '1975-1980': 3.8679642723,
 '1980-1985': 3.6512132003,
 '1985-1990': 3.6381672905,
 '1990-1995': 2.8442207583,
 '1995-2000': 2.6774067093,
 '2000-2005': 1.8080290023,
 '2005-2010': 1.4767021109,
 '2010-2015': 2.0095095873,
 '2015-2020': 2.0131089691,
 '2020-2025': 1.5429567388,
 '2025-2030': 1.007429579,
 '2030-2035': 0.8052009155},
{'Index': 32,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20073,
 'Urban Agglomeration': 'Resistencia',
 'Note': 14.0,
 'Latitude': -27.46056,
 'Longitude': -58.98389,
 '1950-1955': 3.6545132057,
 '1955-1960': 3.6556495856,
 '1960-1965': 3.0564724248,
 '1965-1970': 3.0259149735,
 '1970-1975': 4.2337646056,
 '1975-1980': 4.2981985879,
 '1980-1985': 2.7477454114,
 '1985-1990': 2.6466157874,
 '1990-1995': 2.1213590366,
 '1995-2000': 2.0111462591,
 '2000-2005': 1.1234642974,
 '2005-2010': 0.7848446782,
 '2010-2015': 1.1540006897,
 '2015-2020': 1.1742583291,
 '2020-2025': 1.0867840071,
 '2025-2030': 0.9283186422,
 '2030-2035': 0.8021523909},
{'Index': 33,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20075,
 'Urban Agglomeration': 'Rosario',
 'Note': 15.0,
 'Latitude': -32.94682,
 'Longitude': -60.63932,
 '1950-1955': 1.9122590991,
 '1955-1960': 1.9128003592,
 '1960-1965': 1.952734058,
 '1965-1970': 1.9554070822,
 '1970-1975': 1.5643794505,
 '1975-1980': 1.5442967113,
 '1980-1985': 1.2893532118,
 '1985-1990': 1.2729709442,
 '1990-1995': 0.6763172668,
 '1995-2000': 0.5505733023,
 '2000-2005': 1.2321789461,
 '2005-2010': 1.4932295188,
 '2010-2015': 1.4932009404,
 '2015-2020': 1.4778341023,
 '2020-2025': 1.2518544701,
 '2025-2030': 0.9569738554,
 '2030-2035': 0.8032486766},
{'Index': 34,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20076,
 'Urban Agglomeration': 'Salta',
 'Note': '',
 'Latitude': -24.7859,
 'Longitude': -65.41166,
 '1950-1955': 4.143221654,
 '1955-1960': 4.1444459969,
 '1960-1965': 4.0064142942,
 '1965-1970': 4.0002097857,
 '1970-1975': 3.8999375677,
 '1975-1980': 3.8956838716,
 '1980-1985': 3.2786823376,
 '1985-1990': 3.239199963,
 '1990-1995': 2.6398869757,
 '1995-2000': 2.5141451997,
 '2000-2005': 2.0958989692,
 '2005-2010': 1.9375533224,
 '2010-2015': 1.9375334984,
 '2015-2020': 1.9078714251,
 '2020-2025': 1.4857078635,
 '2025-2030': 0.997517071,
 '2030-2035': 0.8048194611},
{'Index': 35,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20078,
 'Urban Agglomeration': 'San Juan',
 'Note': 16.0,
 'Latitude': -31.5375,
 'Longitude': -68.53639,
 '1950-1955': 3.2130162728,
 '1955-1960': 3.2138567879,
 '1960-1965': 3.8889569046,
 '1965-1970': 3.925477936,
 '1970-1975': 2.7491143231,
 '1975-1980': 2.6880866415,
 '1980-1985': 2.165542638,
 '1985-1990': 2.1318182837,
 '1990-1995': 1.4967170552,
 '1995-2000': 1.3625670934,
 '2000-2005': 1.7261524348,
 '2005-2010': 1.8662291927,
 '2010-2015': 0.8408076784,
 '2015-2020': 0.7778101866,
 '2020-2025': 0.8712429021,
 '2025-2030': 0.8909531618,
 '2030-2035': 0.8007179577},
{'Index': 36,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20081,
 'Urban Agglomeration': 'San Miguel de Tucumán',
 'Note': 17.0,
 'Latitude': -26.82414,
 'Longitude': -65.2226,
 '1950-1955': 2.9677528612,
 '1955-1960': 2.9685701513,
 '1960-1965': 1.9423966623,
 '1965-1970': 1.8892091457,
 '1970-1975': 3.0034884439,
 '1975-1980': 3.062830272,
 '1980-1985': 2.1584073632,
 '1985-1990': 2.0995494093,
 '1990-1995': 1.7097958407,
 '1995-2000': 1.6280151392,
 '2000-2005': 1.5750136294,
 '2005-2010': 1.5555458354,
 '2010-2015': 1.5555325911,
 '2015-2020': 1.5381129618,
 '2020-2025': 1.2846174822,
 '2025-2030': 0.9626573694,
 '2030-2035': 0.8034673379},
{'Index': 37,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20084,
 'Urban Agglomeration': 'San Salvador de Jujuy',
 'Note': 18.0,
 'Latitude': -24.19456,
 'Longitude': -65.29712,
 '1950-1955': 2.5962938597,
 '1955-1960': 2.5973553244,
 '1960-1965': 6.0763921701,
 '1965-1970': 6.260436746,
 '1970-1975': 4.2667728596,
 '1975-1980': 4.1633724547,
 '1980-1985': 3.582516545,
 '1985-1990': 3.5454819767,
 '1990-1995': 3.9262712538,
 '1995-2000': 4.0076427581,
 '2000-2005': 2.1214832843,
 '2005-2010': 1.4017754496,
 '2010-2015': 1.4018065851,
 '2015-2020': 1.389370156,
 '2020-2025': 1.2037265907,
 '2025-2030': 0.9485995913,
 '2030-2035': 0.8029413603},
{'Index': 38,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20085,
 'Urban Agglomeration': 'Santa Fe',
 'Note': 19.0,
 'Latitude': -31.632717,
 'Longitude': -60.698281,
 '1950-1955': 2.1516876012,
 '1955-1960': 2.1523071236,
 '1960-1965': 1.6401984417,
 '1965-1970': 1.6137884367,
 '1970-1975': 2.0994827382,
 '1975-1980': 2.1255021779,
 '1980-1985': 0.3037944633,
 '1985-1990': 0.1840682862,
 '1990-1995': 1.1729086599,
 '1995-2000': 1.3819476726,
 '2000-2005': 1.0174947072,
 '2005-2010': 0.8799259736,
 '2010-2015': 1.2868695433,
 '2015-2020': 1.3053166353,
 '2020-2025': 1.1580692047,
 '2025-2030': 0.9406869213,
 '2030-2035': 0.8026167943},
{'Index': 39,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20086,
 'Urban Agglomeration': 'Santiago Del Estero',
 'Note': 20.0,
 'Latitude': -27.79511,
 'Longitude': -64.26149,
 '1950-1955': 2.257013274,
 '1955-1960': 2.2578638328,
 '1960-1965': 2.8914463477,
 '1965-1970': 2.9256658753,
 '1970-1975': 3.4604143114,
 '1975-1980': 3.4893502464,
 '1980-1985': 2.7687068777,
 '1985-1990': 2.7220735787,
 '1990-1995': 2.1706869063,
 '1995-2000': 2.0548380884,
 '2000-2005': 1.6733378891,
 '2005-2010': 1.5284769584,
 '2010-2015': 1.5284138959,
 '2015-2020': 1.5119040821,
 '2020-2025': 1.270364187,
 '2025-2030': 0.9601796706,
 '2030-2035': 0.8033897179},
{'Index': 40,
 'Country Code': 51,
 'Country or area': 'Armenia',
 'City Code': 20140,
 'Urban Agglomeration': 'Yerevan',
 'Note': '',
 'Latitude': 40.181998,
 'Longitude': 44.514619,
 '1950-1955': 4.6821013557,
 '1955-1960': 4.4031379793,
 '1960-1965': 3.7205277057,
 '1965-1970': 3.669853974,
 '1970-1975': 3.1565467291,
 '1975-1980': 2.6748773146,
 '1980-1985': 1.50231357,
 '1985-1990': 0.9000353808,
 '1990-1995': -0.5532324195,
 '1995-2000': -0.5533987421,
 '2000-2005': -0.439380969,
 '2005-2010': -0.4005429424,
 '2010-2015': 0.1060997536,
 '2015-2020': 0.2782843825,
 '2020-2025': 0.255423977,
 '2025-2030': 0.2473020173,
 '2030-2035': 0.2883436426},
{'Index': 41,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206171,
 'Urban Agglomeration': 'Adelaide',
 'Note': 21.0,
 'Latitude': -34.92866,
 'Longitude': 138.59863,
 '1950-1955': 2.939649505,
 '1955-1960': 2.7948576136,
 '1960-1965': 3.9536717501,
 '1965-1970': 3.976735326,
 '1970-1975': 1.7665993528,
 '1975-1980': 0.9101386479,
 '1980-1985': 1.0405790376,
 '1985-1990': 1.0993775398,
 '1990-1995': 0.5486266716,
 '1995-2000': 0.1774654561,
 '2000-2005': 0.5849911593,
 '2005-2010': 1.1242335507,
 '2010-2015': 0.9926984964,
 '2015-2020': 0.8030670352,
 '2020-2025': 0.8287419749,
 '2025-2030': 1.0976100587,
 '2030-2035': 1.0782489365},
{'Index': 42,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206170,
 'Urban Agglomeration': 'Brisbane',
 'Note': 21.0,
 'Latitude': -27.46794,
 'Longitude': 153.02809,
 '1950-1955': 3.1814763345,
 '1955-1960': 3.0434010443,
 '1960-1965': 2.9410513501,
 '1965-1970': 5.1718878561,
 '1970-1975': 2.7360479043,
 '1975-1980': 1.7965660685,
 '1980-1985': 1.8102257518,
 '1985-1990': 2.1204026535,
 '1990-1995': 2.0386594117,
 '1995-2000': 1.0441576707,
 '2000-2005': 2.0540060504,
 '2005-2010': 2.3539134228,
 '2010-2015': 1.9358547058,
 '2015-2020': 1.6748471452,
 '2020-2025': 1.3030698449,
 '2025-2030': 1.1798433889,
 '2030-2035': 1.0814398649},
{'Index': 43,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206175,
 'Urban Agglomeration': 'Canberra',
 'Note': 21.0,
 'Latitude': -35.28346,
 'Longitude': 149.12807,
 '1950-1955': 9.0962097285,
 '1955-1960': 9.7862166343,
 '1960-1965': 9.9960391005,
 '1965-1970': 9.7294117582,
 '1970-1975': 7.0129322672,
 '1975-1980': 2.6768203448,
 '1980-1985': 2.4275863213,
 '1985-1990': 2.2960800197,
 '1990-1995': 1.5696368541,
 '1995-2000': 2.3663428803,
 '2000-2005': 1.2784177415,
 '2005-2010': 1.6423740425,
 '2010-2015': 1.5082609647,
 '2015-2020': 1.2862869276,
 '2020-2025': 1.0916487353,
 '2025-2030': 1.1431705773,
 '2030-2035': 1.0800496843},
{'Index': 44,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 895000015,
 'Urban Agglomeration': 'Central Coast',
 'Note': 21.0,
 'Latitude': -33.42,
 'Longitude': 151.39583,
 '1950-1955': 2.7165218173,
 '1955-1960': 2.7171622473,
 '1960-1965': 2.7157071979,
 '1965-1970': 2.7165340774,
 '1970-1975': 2.7163828087,
 '1975-1980': 2.7172576875,
 '1980-1985': 2.7157097047,
 '1985-1990': 2.7164256938,
 '1990-1995': 2.7163964372,
 '1995-2000': 2.717254107,
 '2000-2005': 1.0132373216,
 '2005-2010': 1.1445077224,
 '2010-2015': 0.8584619771,
 '2015-2020': 0.6276206929,
 '2020-2025': 0.7333107394,
 '2025-2030': 1.0810899234,
 '2030-2035': 1.0775867959},
{'Index': 45,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20093,
 'Urban Agglomeration': 'Gold Coast-Tweed Head',
 'Note': 21.0,
 'Latitude': -28.00029,
 'Longitude': 153.43088,
 '1950-1955': 5.3344198775,
 '1955-1960': 5.3356823732,
 '1960-1965': 5.3325732651,
 '1965-1970': 5.3338703957,
 '1970-1975': 5.3340508744,
 '1975-1980': 5.3356129064,
 '1980-1985': 5.3917520325,
 '1985-1990': 5.4225590192,
 '1990-1995': 4.8047382863,
 '1995-2000': 5.3343858249,
 '2000-2005': 3.7074987705,
 '2005-2010': 2.7393440032,
 '2010-2015': 2.241245925,
 '2015-2020': 1.9823954854,
 '2020-2025': 1.470400131,
 '2025-2030': 1.2088747009,
 '2030-2035': 1.0825649474},
{'Index': 46,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206168,
 'Urban Agglomeration': 'Melbourne',
 'Note': 21.0,
 'Latitude': -37.814,
 'Longitude': 144.96332,
 '1950-1955': 3.3445418657,
 '1955-1960': 3.239234833,
 '1960-1965': 2.212178482,
 '1965-1970': 3.7896092609,
 '1970-1975': 1.7824253805,
 '1975-1980': 0.7680606518,
 '1980-1985': 0.8925906645,
 '1985-1990': 1.2136587303,
 '1990-1995': 0.7974107938,
 '1995-2000': 0.4707730334,
 '2000-2005': 1.2217303884,
 '2005-2010': 1.9189362161,
 '2010-2015': 2.3834089405,
 '2015-2020': 2.2915918182,
 '2020-2025': 1.6386326346,
 '2025-2030': 1.2380243249,
 '2030-2035': 1.0837006984},
{'Index': 47,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206177,
 'Urban Agglomeration': 'Newcastle-Maitland',
 'Note': 21.0,
 'Latitude': -32.924878,
 'Longitude': 151.740852,
 '1950-1955': 2.4885836695,
 '1955-1960': 2.2562976632,
 '1960-1965': 2.2844757945,
 '1965-1970': 1.5405715303,
 '1970-1975': 1.0598788134,
 '1975-1980': 2.1702903711,
 '1980-1985': 0.4676150521,
 '1985-1990': 0.7319243664,
 '1990-1995': 0.5787125113,
 '1995-2000': 2.8272113046,
 '2000-2005': 1.2626174938,
 '2005-2010': 1.0781884315,
 '2010-2015': 1.0046534527,
 '2015-2020': 0.8328964621,
 '2020-2025': 0.8449407563,
 '2025-2030': 1.1004254345,
 '2030-2035': 1.0783689013},
{'Index': 48,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206172,
 'Urban Agglomeration': 'Perth',
 'Note': 21.0,
 'Latitude': -31.947841,
 'Longitude': 115.852514,
 '1950-1955': 2.8352214818,
 '1955-1960': 2.6651326382,
 '1960-1965': 3.3162293765,
 '1965-1970': 7.0746529344,
 '1970-1975': 3.6246560102,
 '1975-1980': 2.2264786403,
 '1980-1985': 2.5654907842,
 '1985-1990': 2.624206098,
 '1990-1995': 1.981601681,
 '1995-2000': 1.2893536816,
 '2000-2005': 1.4241572178,
 '2005-2010': 2.6210039638,
 '2010-2015': 1.9029846323,
 '2015-2020': 1.5017754203,
 '2020-2025': 1.2089021359,
 '2025-2030': 1.1635208505,
 '2030-2035': 1.0808050837},
{'Index': 49,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20098,
 'Urban Agglomeration': 'Sunshine Coast',
 'Note': 21.0,
 'Latitude': -26.66008,
 'Longitude': 153.09953,
 '1950-1955': 7.2040079195,
 '1955-1960': 7.2059305601,
 '1960-1965': 7.2022070328,
 '1965-1970': 7.2037124025,
 '1970-1975': 7.203998788,
 '1975-1980': 7.2057588126,
 '1980-1985': 5.1884921926,
 '1985-1990': 6.1431340508,
 '1990-1995': 5.4187343925,
 '1995-2000': 1.3707690569,
 '2000-2005': 2.7420344397,
 '2005-2010': 2.4250698469,
 '2010-2015': 2.3889703347,
 '2015-2020': 2.2595190238,
 '2020-2025': 1.6212085166,
 '2025-2030': 1.2349948486,
 '2030-2035': 1.0836096845},
{'Index': 50,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206167,
 'Urban Agglomeration': 'Sydney',
 'Note': 21.0,
 'Latitude': -33.86785,
 'Longitude': 151.20732,
 '1950-1955': 2.4060829336,
 '1955-1960': 2.2663852004,
 '1960-1965': 2.2614722409,
 '1965-1970': 3.8145228611,
 '1970-1975': 1.5009678839,
 '1975-1980': 0.8428540259,
 '1980-1985': 1.079311958,
 '1985-1990': 1.1299403787,
 '1990-1995': 1.0057949159,
 '1995-2000': -0.2082197378,
 '2000-2005': 0.4970960162,
 '2005-2010': 1.4478638071,
 '2010-2015': 1.7395693824,
 '2015-2020': 1.6130500133,
 '2020-2025': 1.2694506434,
 '2025-2030': 1.1740134043,
 '2030-2035': 1.0812158274},
{'Index': 51,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20101,
 'Urban Agglomeration': 'Wollongong',
 'Note': 21.0,
 'Latitude': -34.424,
 'Longitude': 150.89345,
 '1950-1955': 5.3101887112,
 '1955-1960': 5.3115167379,
 '1960-1965': 4.4486543364,
 '1965-1970': 2.9863029135,
 '1970-1975': 2.5454833638,
 '1975-1980': 1.9749310043,
 '1980-1985': 0.4767566723,
 '1985-1990': 0.8250197929,
 '1990-1995': 0.8922087393,
 '1995-2000': 0.4776439478,
 '2000-2005': 0.3946646072,
 '2005-2010': 1.0037463066,
 '2010-2015': 1.0049374445,
 '2015-2020': 0.8362944562,
 '2020-2025': 0.8468495064,
 '2025-2030': 1.1007033289,
 '2030-2035': 1.0783823241},
{'Index': 52,
 'Country Code': 40,
 'Country or area': 'Austria',
 'City Code': 20107,
 'Urban Agglomeration': 'Wien (Vienna)',
 'Note': '',
 'Latitude': 48.206443,
 'Longitude': 16.370725,
 '1950-1955': 0.0719668459,
 '1955-1960': 0.0719792968,
 '1960-1965': -0.0295658834,
 '1965-1970': -0.0466461302,
 '1970-1975': -0.4731130964,
 '1975-1980': -0.5622405261,
 '1980-1985': -0.0510796127,
 '1985-1990': 0.0553162868,
 '1990-1995': 0.0645566124,
 '1995-2000': 0.0665307571,
 '2000-2005': 1.1509333665,
 '2005-2010': 1.0638743498,
 '2010-2015': 1.1707637905,
 '2015-2020': 1.0091262952,
 '2020-2025': 0.7680184678,
 '2025-2030': 0.7255481193,
 '2030-2035': 0.6992822943},
{'Index': 53,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20053,
 'Urban Agglomeration': 'Baku',
 'Note': 22.0,
 'Latitude': 40.37767,
 'Longitude': 49.89201,
 '1950-1955': 0.9317860601,
 '1955-1960': 1.3531922673,
 '1960-1965': 2.3745715517,
 '1965-1970': 2.3676768184,
 '1970-1975': 2.2927788118,
 '1975-1980': 1.9353618406,
 '1980-1985': 1.0654104015,
 '1985-1990': 0.8608360935,
 '1990-1995': 0.3668699136,
 '1995-2000': 0.4528685558,
 '2000-2005': 0.6678470638,
 '2005-2010': 1.982123405,
 '2010-2015': 1.3545145243,
 '2015-2020': 1.1888287347,
 '2020-2025': 1.2824068435,
 '2025-2030': 1.261773789,
 '2030-2035': 1.1823707851},
{'Index': 54,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20054,
 'Urban Agglomeration': 'Gäncä',
 'Note': '',
 'Latitude': 40.68278,
 'Longitude': 46.36056,
 '1950-1955': 0.8264065998,
 '1955-1960': 1.8943697204,
 '1960-1965': 4.4845315442,
 '1965-1970': 4.278405046,
 '1970-1975': 2.2190058088,
 '1975-1980': 2.0808384919,
 '1980-1985': 1.7429867314,
 '1985-1990': 1.4677224964,
 '1990-1995': 0.8032853275,
 '1995-2000': 0.6411119774,
 '2000-2005': 0.3652234952,
 '2005-2010': 0.6087310227,
 '2010-2015': 0.7602345688,
 '2015-2020': 0.7997954048,
 '2020-2025': 1.070862049,
 '2025-2030': 1.2250525405,
 '2030-2035': 1.1809684608},
{'Index': 55,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20056,
 'Urban Agglomeration': 'Sumquayit',
 'Note': '',
 'Latitude': 40.58972,
 'Longitude': 49.66861,
 '1950-1955': 11.0505958267,
 '1955-1960': 10.1343094118,
 '1960-1965': 7.898090221,
 '1965-1970': 7.6111350856,
 '1970-1975': 4.7416348362,
 '1975-1980': 3.9236859684,
 '1980-1985': 1.93347117,
 '1985-1990': 1.9679827155,
 '1990-1995': 2.0498647977,
 '1995-2000': 1.6437459895,
 '2000-2005': 0.6868794181,
 '2005-2010': 1.137358183,
 '2010-2015': 1.2246067896,
 '2015-2020': 1.2421258293,
 '2020-2025': 1.3113198391,
 '2025-2030': 1.2668359049,
 '2030-2035': 1.1825532102},
{'Index': 56,
 'Country Code': 48,
 'Country or area': 'Bahrain',
 'City Code': 20109,
 'Urban Agglomeration': 'Al-Manamah (Manama)',
 'Note': 23.0,
 'Latitude': 26.21536,
 'Longitude': 50.5832,
 '1950-1955': 4.8301553006,
 '1955-1960': 4.7045079602,
 '1960-1965': 4.1113847433,
 '1965-1970': 1.9959562445,
 '1970-1975': 2.4413516936,
 '1975-1980': 2.5213698523,
 '1980-1985': 1.2091773378,
 '1985-1990': 0.9732930139,
 '1990-1995': 1.1507581418,
 '1995-2000': 1.2186857498,
 '2000-2005': 6.7274485624,
 '2005-2010': 7.7441739242,
 '2010-2015': 8.2310960469,
 '2015-2020': 7.2790484627,
 '2020-2025': 3.1586994883,
 '2025-2030': 1.9188352146,
 '2030-2035': 1.233078621},
{'Index': 57,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20110,
 'Urban Agglomeration': 'Barisal',
 'Note': '',
 'Latitude': 22.70194,
 'Longitude': 90.37111,
 '1950-1955': 1.5948195518,
 '1955-1960': 1.5952621612,
 '1960-1965': 2.4724742152,
 '1965-1970': 2.5898951269,
 '1970-1975': 3.5481829243,
 '1975-1980': 6.1825900988,
 '1980-1985': 2.3844811477,
 '1985-1990': 1.7921155213,
 '1990-1995': 1.4184039168,
 '1995-2000': 1.3586464738,
 '2000-2005': 3.1774791741,
 '2005-2010': 3.4080359564,
 '2010-2015': 3.4082821468,
 '2015-2020': 3.397891879,
 '2020-2025': 3.123840057,
 '2025-2030': 2.5866737643,
 '2030-2035': 2.131337427},
{'Index': 58,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20112,
 'Urban Agglomeration': 'Bogra',
 'Note': '',
 'Latitude': 24.85,
 'Longitude': 89.36667,
 '1950-1955': 2.9132226907,
 '1955-1960': 2.9138458662,
 '1960-1965': 2.5918345826,
 '1965-1970': 2.5496396517,
 '1970-1975': 3.5447344028,
 '1975-1980': 6.2794433424,
 '1980-1985': 5.7833977173,
 '1985-1990': 5.7078512692,
 '1990-1995': 2.8341776635,
 '1995-2000': 2.3724270587,
 '2000-2005': 5.9760620579,
 '2005-2010': 6.4329104391,
 '2010-2015': 6.432943582,
 '2015-2020': 6.3276773778,
 '2020-2025': 4.7178570687,
 '2025-2030': 2.8630522885,
 '2030-2035': 2.1420542055},
{'Index': 59,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20115,
 'Urban Agglomeration': 'Chittagong',
 'Note': '',
 'Latitude': 22.33306,
 'Longitude': 91.83639,
 '1950-1955': 2.232768704,
 '1955-1960': 2.1652862917,
 '1960-1965': 6.6786038759,
 '1965-1970': 7.2821280558,
 '1970-1975': 6.8109332703,
 '1975-1980': 5.5178670957,
 '1980-1985': 4.2201041262,
 '1985-1990': 4.0189569813,
 '1990-1995': 4.8521846264,
 '1995-2000': 4.9876675966,
 '2000-2005': 2.3272340212,
 '2005-2010': 1.9922913959,
 '2010-2015': 1.9923161133,
 '2015-2020': 2.0263027282,
 '2020-2025': 2.3775742179,
 '2025-2030': 2.457287171,
 '2030-2035': 2.1263155332},
{'Index': 60,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20117,
 'Urban Agglomeration': 'Comilla',
 'Note': '',
 'Latitude': 23.45778,
 'Longitude': 91.20444,
 '1950-1955': 1.3805704295,
 '1955-1960': 1.3807605263,
 '1960-1965': 3.2741201489,
 '1965-1970': 3.5270931983,
 '1970-1975': 4.3263564825,
 '1975-1980': 6.5237929791,
 '1980-1985': 1.4166096801,
 '1985-1990': 0.6196036765,
 '1990-1995': 1.8189634838,
 '1995-2000': 2.0125710221,
 '2000-2005': 3.3758838715,
 '2005-2010': 3.5491317804,
 '2010-2015': 3.548988494,
 '2015-2020': 3.5341734825,
 '2020-2025': 3.1979637277,
 '2025-2030': 2.5995430155,
 '2030-2035': 2.1318356629},
{'Index': 61,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 24.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 '1950-1955': 3.9398170995,
 '1955-1960': 4.3387689935,
 '1960-1965': 9.5976089731,
 '1965-1970': 10.3013967843,
 '1970-1975': 9.6092275133,
 '1975-1980': 7.7096099335,
 '1980-1985': 7.1127008655,
 '1985-1990': 7.0220560648,
 '1990-1995': 4.5991951893,
 '1995-2000': 4.2104191815,
 '2000-2005': 3.6285046843,
 '2005-2010': 3.556321637,
 '2010-2015': 3.5563161086,
 '2015-2020': 3.5412590993,
 '2020-2025': 3.2018326787,
 '2025-2030': 2.6001985691,
 '2030-2035': 2.1318612495},
{'Index': 62,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20124,
 'Urban Agglomeration': 'Khulna',
 'Note': '',
 'Latitude': 22.80978,
 'Longitude': 89.56439,
 '1950-1955': 6.9572400574,
 '1955-1960': 6.9588495489,
 '1960-1965': 9.107803001,
 '1965-1970': 9.3972716516,
 '1970-1975': 8.4098005758,
 '1975-1980': 5.6982823878,
 '1980-1985': 4.5998015273,
 '1985-1990': 4.4299322586,
 '1990-1995': 2.5109213716,
 '1995-2000': 2.2026600582,
 '2000-2005': -1.0676137265,
 '2005-2010': -1.4806671819,
 '2010-2015': -1.4807318364,
 '2015-2020': -1.3378384393,
 '2020-2025': 0.5472058471,
 '2025-2030': 2.1399421349,
 '2030-2035': 2.1139980822},
{'Index': 63,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20126,
 'Urban Agglomeration': 'Mymensingh',
 'Note': '',
 'Latitude': 24.75,
 'Longitude': 90.4,
 '1950-1955': 1.7027043413,
 '1955-1960': 1.6277070068,
 '1960-1965': 2.593391126,
 '1965-1970': 2.7231797977,
 '1970-1975': 3.2306228695,
 '1975-1980': 4.6258481809,
 '1980-1985': 6.2563444316,
 '1985-1990': 6.513297713,
 '1990-1995': 2.5079247048,
 '1995-2000': 1.863809848,
 '2000-2005': 1.3995442089,
 '2005-2010': 1.3413624227,
 '2010-2015': 1.3413110221,
 '2015-2020': 1.3957711794,
 '2020-2025': 2.0344798953,
 '2025-2030': 2.3978014026,
 '2030-2035': 2.1240121719},
{'Index': 64,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20131,
 'Urban Agglomeration': 'Rajshahi',
 'Note': '',
 'Latitude': 24.36667,
 'Longitude': 88.6,
 '1950-1955': 3.5959011872,
 '1955-1960': 3.5514497065,
 '1960-1965': 6.1426711058,
 '1965-1970': 6.4894850408,
 '1970-1975': 7.2189132505,
 '1975-1980': 9.2251554847,
 '1980-1985': 7.9140328133,
 '1985-1990': 7.7121426569,
 '1990-1995': 3.0207818176,
 '1995-2000': 2.2664203899,
 '2000-2005': 1.5143153657,
 '2005-2010': 1.4199344752,
 '2010-2015': 1.4200025506,
 '2015-2020': 1.4719353854,
 '2020-2025': 2.0759321498,
 '2025-2030': 2.4049977276,
 '2030-2035': 2.1242921868},
{'Index': 65,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20132,
 'Urban Agglomeration': 'Rangpur',
 'Note': '',
 'Latitude': 25.75,
 'Longitude': 89.25,
 '1950-1955': 2.5317830683,
 '1955-1960': 2.4836945454,
 '1960-1965': 4.2284834893,
 '1965-1970': 4.4622066247,
 '1970-1975': 5.471649784,
 '1975-1980': 8.24770947,
 '1980-1985': 5.0403450805,
 '1985-1990': 4.5414054606,
 '1990-1995': 2.6525788535,
 '1995-2000': 2.3492155413,
 '2000-2005': 1.9208299787,
 '2005-2010': 1.8675167716,
 '2010-2015': 1.8673309759,
 '2015-2020': 1.9052305416,
 '2020-2025': 2.3117311555,
 '2025-2030': 2.4458740771,
 '2030-2035': 2.1258632218},
{'Index': 66,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 205390,
 'Urban Agglomeration': 'Rupganj',
 'Note': '',
 'Latitude': 23.792554,
 'Longitude': 90.520591,
 '1950-1955': 4.8515505392,
 '1955-1960': 4.8532024756,
 '1960-1965': 4.8514674873,
 '1965-1970': 4.8511560005,
 '1970-1975': 4.852015507,
 '1975-1980': 4.8534435839,
 '1980-1985': 4.8502394217,
 '1985-1990': 4.851872535,
 '1990-1995': 1.4224273442,
 '1995-2000': 0.8706132954,
 '2000-2005': 8.5775745824,
 '2005-2010': 9.5530460242,
 '2010-2015': 9.5531677473,
 '2015-2020': 9.3500312378,
 '2020-2025': 6.3623022567,
 '2025-2030': 3.1481420056,
 '2030-2035': 2.1531283436},
{'Index': 67,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20136,
 'Urban Agglomeration': 'Sylhet',
 'Note': '',
 'Latitude': 24.89667,
 'Longitude': 91.87167,
 '1950-1955': 1.447282228,
 '1955-1960': 1.180742673,
 '1960-1965': 2.9564521242,
 '1965-1970': 3.1938384494,
 '1970-1975': 4.771383846,
 '1975-1980': 9.1072326986,
 '1980-1985': 2.3035400409,
 '1985-1990': 1.2419329776,
 '1990-1995': 2.6791271684,
 '1995-2000': 2.9112078986,
 '2000-2005': 4.5864046429,
 '2005-2010': 4.7994302714,
 '2010-2015': 4.7992636354,
 '2015-2020': 4.7452111867,
 '2020-2025': 3.8568778934,
 '2025-2030': 2.7137669454,
 '2030-2035': 2.136270418},
{'Index': 68,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20344,
 'Urban Agglomeration': 'Brest',
 'Note': '',
 'Latitude': 52.09755,
 'Longitude': 23.68775,
 '1950-1955': 1.3952583646,
 '1955-1960': 2.3147593855,
 '1960-1965': 4.5437967071,
 '1965-1970': 4.5075601836,
 '1970-1975': 4.1348028587,
 '1975-1980': 4.006967104,
 '1980-1985': 3.6918297365,
 '1985-1990': 2.9367020669,
 '1990-1995': 1.1131689635,
 '1995-2000': 1.0372151501,
 '2000-2005': 0.779271007,
 '2005-2010': 0.7643620154,
 '2010-2015': 1.4520669125,
 '2015-2020': 1.2682539346,
 '2020-2025': 0.6538046689,
 '2025-2030': 0.1879385868,
 '2030-2035': 0.0040102824},
{'Index': 69,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20345,
 'Urban Agglomeration': 'Gomel',
 'Note': '',
 'Latitude': 52.4345,
 'Longitude': 30.9754,
 '1950-1955': 4.3658529929,
 '1955-1960': 4.3668856835,
 '1960-1965': 4.3645793033,
 '1965-1970': 4.3142236452,
 '1970-1975': 3.8025784592,
 '1975-1980': 3.4576111701,
 '1980-1985': 2.6160427963,
 '1985-1990': 1.7185072021,
 '1990-1995': -0.447255328,
 '1995-2000': -0.2575327897,
 '2000-2005': 0.1871793021,
 '2005-2010': 0.2488744174,
 '2010-2015': 1.4328549114,
 '2015-2020': 1.2495567221,
 '2020-2025': 0.6437027302,
 '2025-2030': 0.1861317903,
 '2030-2035': 0.0039568633},
{'Index': 70,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20346,
 'Urban Agglomeration': 'Grodno',
 'Note': '',
 'Latitude': 53.6884,
 'Longitude': 23.8258,
 '1950-1955': 1.4184373588,
 '1955-1960': 2.5762711984,
 '1960-1965': 5.3834326953,
 '1965-1970': 5.2890534083,
 '1970-1975': 4.3354056555,
 '1975-1980': 4.0194034222,
 '1980-1985': 3.2470084867,
 '1985-1990': 2.6199510289,
 '1990-1995': 1.1059744199,
 '1995-2000': 1.0442730996,
 '2000-2005': 0.8209571407,
 '2005-2010': 0.8201116317,
 '2010-2015': 1.6407116278,
 '2015-2020': 1.4508528601,
 '2020-2025': 0.7530924602,
 '2025-2030': 0.2051051047,
 '2030-2035': 0.0047311966},
{'Index': 71,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20348,
 'Urban Agglomeration': 'Minsk',
 'Note': 22.0,
 'Latitude': 53.9,
 'Longitude': 27.56667,
 '1950-1955': 7.502777293,
 '1955-1960': 5.7262773444,
 '1960-1965': 5.3313353663,
 '1965-1970': 5.1818383573,
 '1970-1975': 3.6829991353,
 '1975-1980': 3.2830210891,
 '1980-1985': 2.3081342998,
 '1985-1990': 1.7617892254,
 '1990-1995': 0.4428869568,
 '1995-2000': 0.5559221148,
 '2000-2005': 0.8543437939,
 '2005-2010': 0.8322836288,
 '2010-2015': 1.0039169848,
 '2015-2020': 0.8344948602,
 '2020-2025': 0.4179669356,
 '2025-2030': 0.1470053617,
 '2030-2035': 0.0023965448},
{'Index': 72,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20349,
 'Urban Agglomeration': 'Mogilev',
 'Note': '',
 'Latitude': 53.9141,
 'Longitude': 30.33764,
 '1950-1955': 4.6055589086,
 '1955-1960': 4.6068145022,
 '1960-1965': 4.6042450995,
 '1965-1970': 4.5518178658,
 '1970-1975': 4.0178848989,
 '1975-1980': 3.4525923029,
 '1980-1985': 2.0758529458,
 '1985-1990': 1.4644157542,
 '1990-1995': -0.0113259176,
 '1995-2000': 0.1267417547,
 '2000-2005': 0.2465857498,
 '2005-2010': -0.1610554072,
 '2010-2015': 0.8316701557,
 '2015-2020': 0.6676568966,
 '2020-2025': 0.3272223711,
 '2025-2030': 0.1312562609,
 '2030-2035': 0.0017610484},
{'Index': 73,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20355,
 'Urban Agglomeration': 'Vitebsk',
 'Note': '',
 'Latitude': 55.19048,
 'Longitude': 30.2033,
 '1950-1955': 4.028957788,
 '1955-1960': 4.0300509696,
 '1960-1965': 4.0278013141,
 '1965-1970': 3.9157579232,
 '1970-1975': 2.792376886,
 '1975-1980': 2.4363569909,
 '1980-1985': 1.5690398946,
 '1985-1990': 1.052734247,
 '1990-1995': -0.1933441494,
 '1995-2000': -0.1128179642,
 '2000-2005': 0.1535214673,
 '2005-2010': 0.3592803973,
 '2010-2015': 0.8498138309,
 '2015-2020': 0.6852652492,
 '2020-2025': 0.3368082,
 '2025-2030': 0.1329132519,
 '2030-2035': 0.0018089468},
{'Index': 74,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20142,
 'Urban Agglomeration': 'Antwerpen',
 'Note': '',
 'Latitude': 51.21989,
 'Longitude': 4.40346,
 '1950-1955': 0.68893024,
 '1955-1960': 0.689122816,
 '1960-1965': 0.5354776876,
 '1965-1970': 0.4698836869,
 '1970-1975': 0.301879996,
 '1975-1980': 0.2832201741,
 '1980-1985': 0.3022375435,
 '1985-1990': 0.3052545091,
 '1990-1995': 0.3234256008,
 '1995-2000': 0.4896042519,
 '2000-2005': 0.4893678385,
 '2005-2010': 0.4894702004,
 '2010-2015': 0.4894989794,
 '2015-2020': 0.491391903,
 '2020-2025': 0.4251398252,
 '2025-2030': 0.3478183393,
 '2030-2035': 0.2971133024},
{'Index': 75,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20144,
 'Urban Agglomeration': 'Bruxelles-Brussel',
 'Note': 25.0,
 'Latitude': 50.846735,
 'Longitude': 4.349919,
 '1950-1955': 0.4829285192,
 '1955-1960': 0.4830629089,
 '1960-1965': 0.5329008974,
 '1965-1970': 0.5545300543,
 '1970-1975': 0.5359174004,
 '1975-1980': 0.5339918527,
 '1980-1985': 0.2692553374,
 '1985-1990': 0.2287672647,
 '1990-1995': 0.228780883,
 '1995-2000': 0.7750336401,
 '2000-2005': 0.7745968368,
 '2005-2010': 0.7748141488,
 '2010-2015': 0.7748190789,
 '2015-2020': 0.7675946354,
 '2020-2025': 0.5753370872,
 '2025-2030': 0.3738615115,
 '2030-2035': 0.2981258463},
{'Index': 76,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20145,
 'Urban Agglomeration': 'Charleroi',
 'Note': '',
 'Latitude': 50.41136,
 'Longitude': 4.44448,
 '1950-1955': 0.0947618295,
 '1955-1960': 0.0947947711,
 '1960-1965': 0.094729625,
 '1965-1970': 0.094758345,
 '1970-1975': -0.2541748408,
 '1975-1980': -0.2931709394,
 '1980-1985': -0.2929716342,
 '1985-1990': -0.2930512059,
 '1990-1995': -0.293070036,
 '1995-2000': 0.2124787231,
 '2000-2005': 0.2123938661,
 '2005-2010': 0.2124364192,
 '2010-2015': 0.2124540485,
 '2015-2020': 0.223238266,
 '2020-2025': 0.2793458914,
 '2025-2030': 0.3225418418,
 '2030-2035': 0.2961581287},
{'Index': 77,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20146,
 'Urban Agglomeration': 'Gent',
 'Note': '',
 'Latitude': 51.05,
 'Longitude': 3.71667,
 '1950-1955': 0.0507537476,
 '1955-1960': 0.0507351918,
 '1960-1965': -0.1181222437,
 '1965-1970': -0.1906373965,
 '1970-1975': 0.2972702051,
 '1975-1980': 0.3517339646,
 '1980-1985': 0.3789769039,
 '1985-1990': 0.3833224885,
 '1990-1995': 0.3833091151,
 '1995-2000': 0.6965351784,
 '2000-2005': 0.696138428,
 '2005-2010': 0.6963592935,
 '2010-2015': 0.696333962,
 '2015-2020': 0.6916509819,
 '2020-2025': 0.5340442482,
 '2025-2030': 0.3666958302,
 '2030-2035': 0.2978340409},
{'Index': 78,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20148,
 'Urban Agglomeration': 'Liège',
 'Note': '',
 'Latitude': 50.63373,
 'Longitude': 5.56749,
 '1950-1955': 0.3224723002,
 '1955-1960': 0.3225345529,
 '1960-1965': 0.0241736546,
 '1965-1970': -0.1036831666,
 '1970-1975': 0.1908126521,
 '1975-1980': 0.2237386083,
 '1980-1985': -0.0066752349,
 '1985-1990': -0.0419372362,
 '1990-1995': -0.0419618086,
 '1995-2000': 0.293309551,
 '2000-2005': 0.2931127139,
 '2005-2010': 0.2932276434,
 '2010-2015': 0.2932160367,
 '2015-2020': 0.3014686373,
 '2020-2025': 0.3218700226,
 '2025-2030': 0.3299184645,
 '2030-2035': 0.296406332}]},
'LEARNING POVERTY_HISTORICAL DATA AND SUB-COMPONENTS': {'headers': ['countrycode',
'cty_or_agg',
'year',
'indicator',
'value',
'value_metadata'],
'data': [{'countrycode': 'AFG',
 'cty_or_agg': 'cty',
 'year': 2013,
 'indicator': 'SE.LPV.PRIM',
 'value': 93.4479980469,
 'value_metadata': 'OOS: National household survey; BMP: NLA 2013 for grade 5 using MPL 10 for reading'},
{'countrycode': 'AFG',
 'cty_or_agg': 'cty',
 'year': 2013,
 'indicator': 'SE.LPV.PRIM.BMP',
 'value': 87.0,
 'value_metadata': 'NLA 2013 for grade 5 using MPL 10 for reading'},
{'countrycode': 'AFG',
 'cty_or_agg': 'cty',
 'year': 2013,
 'indicator': 'SE.LPV.PRIM.OOS',
 'value': 49.5999984741,
 'value_metadata': 'National household survey'},
{'countrycode': 'ARE',
 'cty_or_agg': 'cty',
 'year': 2011,
 'indicator': 'SE.LPV.PRIM',
 'value': 39.4432601929,
 'value_metadata': 'OOS: ANER; BMP: PIRLS 2011 for grade 4 using MPL Low (400 points) for reading'},
{'countrycode': 'ARE',
 'cty_or_agg': 'cty',
 'year': 2011,
 'indicator': 'SE.LPV.PRIM.BMP',
 'value': 36.0176849365,
 'value_metadata': 'PIRLS 2011 for grade 4 using MPL Low (400 points) for reading'},
{'countrycode': 'ARE',
 'cty_or_agg': 'cty',
 'year': 2011,
 'indicator': 'SE.LPV.PRIM.BMP.FE',
 'value': 29.8556747437,
 'value_metadata': 'PIRLS 2011 for grade 4 using MPL Low (400 points) for reading'},
{'countrycode': 'ARE',
 'cty_or_agg': 'cty',
 'year': 2011,
 'indicator': 'SE.LPV.PRIM.BMP.MA',
 'value': 42.1501464844,
 'value_metadata': 'PIRLS 2011 for grade 4 using MPL Low (400 points) for reading'},
{'countrycode': 'ARE',
 'cty_or_agg': 'cty',
 'year': 2011,
 'indicator': 'SE.LPV.PRIM.FE',
 'value': 33.0180130005,
 'value_metadata': 'OOS: ANER; BMP: PIRLS 2011 for grade 4 using MPL Low (400 points) for reading'},
{'countrycode': 'ARE',
 'cty_or_agg': 'cty',
 'year': 2011,
 'indicator': 'SE.LPV.PRIM.MA',
 'value': 45.705997467,
 'value_metadata': 'OOS: ANER; BMP: PIRLS 2011 for grade 4 using MPL Low (400 points) for reading'}]},
'Locations ': {'headers': ['Index',
'Region, subregion, country or area',
'Notes',
'code',
'Alpha-code',
'Code',
'Name',
'Code.1',
'Name.1',
'Code.2',
'Name.2',
'More Developed Regions',
'Less Developed Regions',
'Least developed countries',
'Less developed regions, excluding least developed countries',
'High-income Countries',
'Middle-income Countries',
'Upper-middle-income Countries',
'Lower-middle-income Countries',
'Low-income Countries',
'Unnamed: 20',
'with a population of less than 90,000 by mid-2018'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Notes': '',
 'code': 900,
 'Alpha-code': '   ',
 'Code': 0,
 'Name': 'Special groupings',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Notes': 'a',
 'code': 901,
 'Alpha-code': '   ',
 'Code': 5,
 'Name': 'Development group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Notes': 'b',
 'code': 902,
 'Alpha-code': '   ',
 'Code': 5,
 'Name': 'Development group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Notes': 'c',
 'code': 941,
 'Alpha-code': '   ',
 'Code': 5,
 'Name': 'Development group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Notes': 'd',
 'code': 934,
 'Alpha-code': '   ',
 'Code': 5,
 'Name': 'Development group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Notes': '',
 'code': 948,
 'Alpha-code': '   ',
 'Code': 12,
 'Name': 'Special groupings',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Notes': 'e',
 'code': 1503,
 'Alpha-code': '   ',
 'Code': 13,
 'Name': 'Income group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Notes': 'e',
 'code': 1517,
 'Alpha-code': '   ',
 'Code': 13,
 'Name': 'Income group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Notes': 'e',
 'code': 1502,
 'Alpha-code': '   ',
 'Code': 13,
 'Name': 'Income group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Notes': 'e',
 'code': 1501,
 'Alpha-code': '   ',
 'Code': 13,
 'Name': 'Income group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Notes': 'e',
 'code': 1500,
 'Alpha-code': '   ',
 'Code': 13,
 'Name': 'Income group',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Notes': 'f',
 'code': 947,
 'Alpha-code': '   ',
 'Code': 12,
 'Name': 'Special groupings',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Notes': '',
 'code': 903,
 'Alpha-code': '   ',
 'Code': 2,
 'Name': 'Region',
 'Code.1': '',
 'Name.1': '',
 'Code.2': '',
 'Name.2': '',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Notes': '',
 'code': 910,
 'Alpha-code': '   ',
 'Code': 3,
 'Name': 'Subregion',
 'Code.1': '',
 'Name.1': '',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Notes': '',
 'code': 108,
 'Alpha-code': 'BDI',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Notes': '',
 'code': 174,
 'Alpha-code': 'COM',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Notes': '',
 'code': 262,
 'Alpha-code': 'DJI',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Notes': '',
 'code': 232,
 'Alpha-code': 'ERI',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Notes': '',
 'code': 231,
 'Alpha-code': 'ETH',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Notes': '',
 'code': 404,
 'Alpha-code': 'KEN',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Notes': '',
 'code': 450,
 'Alpha-code': 'MDG',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Notes': '',
 'code': 454,
 'Alpha-code': 'MWI',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Notes': 1,
 'code': 480,
 'Alpha-code': 'MUS',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Notes': '',
 'code': 175,
 'Alpha-code': 'MYT',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'Not available',
 'Middle-income Countries': 'Not available',
 'Upper-middle-income Countries': 'Not available',
 'Lower-middle-income Countries': 'Not available',
 'Low-income Countries': 'Not available',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Notes': '',
 'code': 508,
 'Alpha-code': 'MOZ',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Notes': '',
 'code': 638,
 'Alpha-code': 'REU',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'Not available',
 'Middle-income Countries': 'Not available',
 'Upper-middle-income Countries': 'Not available',
 'Lower-middle-income Countries': 'Not available',
 'Low-income Countries': 'Not available',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Notes': '',
 'code': 646,
 'Alpha-code': 'RWA',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Notes': '',
 'code': 690,
 'Alpha-code': 'SYC',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'Yes',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Notes': '',
 'code': 706,
 'Alpha-code': 'SOM',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Notes': '',
 'code': 728,
 'Alpha-code': 'SSD',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Notes': '',
 'code': 800,
 'Alpha-code': 'UGA',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Notes': 2,
 'code': 834,
 'Alpha-code': 'TZA',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Notes': '',
 'code': 894,
 'Alpha-code': 'ZMB',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Notes': '',
 'code': 716,
 'Alpha-code': 'ZWE',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 910.0,
 'Name.1': 'Eastern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Notes': '',
 'code': 911,
 'Alpha-code': '   ',
 'Code': 3,
 'Name': 'Subregion',
 'Code.1': '',
 'Name.1': '',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Notes': '',
 'code': 24,
 'Alpha-code': 'AGO',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Notes': '',
 'code': 120,
 'Alpha-code': 'CMR',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Notes': '',
 'code': 140,
 'Alpha-code': 'CAF',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Notes': '',
 'code': 148,
 'Alpha-code': 'TCD',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Notes': '',
 'code': 178,
 'Alpha-code': 'COG',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Notes': '',
 'code': 180,
 'Alpha-code': 'COD',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'No',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'Yes',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Notes': '',
 'code': 226,
 'Alpha-code': 'GNQ',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Notes': '',
 'code': 266,
 'Alpha-code': 'GAB',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Notes': '',
 'code': 678,
 'Alpha-code': 'STP',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 911.0,
 'Name.1': 'Middle Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 45,
 'Region, subregion, country or area': 'Northern Africa',
 'Notes': '',
 'code': 912,
 'Alpha-code': '   ',
 'Code': 3,
 'Name': 'Subregion',
 'Code.1': '',
 'Name.1': '',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 46,
 'Region, subregion, country or area': 'Algeria',
 'Notes': '',
 'code': 12,
 'Alpha-code': 'DZA',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 47,
 'Region, subregion, country or area': 'Egypt',
 'Notes': '',
 'code': 818,
 'Alpha-code': 'EGY',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 48,
 'Region, subregion, country or area': 'Libya',
 'Notes': '',
 'code': 434,
 'Alpha-code': 'LBY',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 49,
 'Region, subregion, country or area': 'Morocco',
 'Notes': '',
 'code': 504,
 'Alpha-code': 'MAR',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 50,
 'Region, subregion, country or area': 'Sudan',
 'Notes': '',
 'code': 729,
 'Alpha-code': 'SDN',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 51,
 'Region, subregion, country or area': 'Tunisia',
 'Notes': '',
 'code': 788,
 'Alpha-code': 'TUN',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 52,
 'Region, subregion, country or area': 'Western Sahara',
 'Notes': '',
 'code': 732,
 'Alpha-code': 'ESH',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 912.0,
 'Name.1': 'Northern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'Not available',
 'Middle-income Countries': 'Not available',
 'Upper-middle-income Countries': 'Not available',
 'Lower-middle-income Countries': 'Not available',
 'Low-income Countries': 'Not available',
 'Unnamed: 20': 'No',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 53,
 'Region, subregion, country or area': 'Southern Africa',
 'Notes': '',
 'code': 913,
 'Alpha-code': '   ',
 'Code': 3,
 'Name': 'Subregion',
 'Code.1': '',
 'Name.1': '',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': '',
 'Less Developed Regions': '',
 'Least developed countries': '',
 'Less developed regions, excluding least developed countries': '',
 'High-income Countries': '',
 'Middle-income Countries': '',
 'Upper-middle-income Countries': '',
 'Lower-middle-income Countries': '',
 'Low-income Countries': '',
 'Unnamed: 20': '',
 'with a population of less than 90,000 by mid-2018': ''},
{'Index': 54,
 'Region, subregion, country or area': 'Botswana',
 'Notes': '',
 'code': 72,
 'Alpha-code': 'BWA',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 913.0,
 'Name.1': 'Southern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 55,
 'Region, subregion, country or area': 'Lesotho',
 'Notes': '',
 'code': 426,
 'Alpha-code': 'LSO',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 913.0,
 'Name.1': 'Southern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'Yes',
 'Less developed regions, excluding least developed countries': 'No',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 56,
 'Region, subregion, country or area': 'Namibia',
 'Notes': '',
 'code': 516,
 'Alpha-code': 'NAM',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 913.0,
 'Name.1': 'Southern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 57,
 'Region, subregion, country or area': 'South Africa',
 'Notes': '',
 'code': 710,
 'Alpha-code': 'ZAF',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 913.0,
 'Name.1': 'Southern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'Yes',
 'Lower-middle-income Countries': 'No',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'},
{'Index': 58,
 'Region, subregion, country or area': 'Swaziland',
 'Notes': '',
 'code': 748,
 'Alpha-code': 'SWZ',
 'Code': 4,
 'Name': 'Country/Area',
 'Code.1': 913.0,
 'Name.1': 'Southern Africa',
 'Code.2': 903.0,
 'Name.2': 'Africa',
 'More Developed Regions': 'No',
 'Less Developed Regions': 'Yes',
 'Least developed countries': 'No',
 'Less developed regions, excluding least developed countries': 'Yes',
 'High-income Countries': 'No',
 'Middle-income Countries': 'Yes',
 'Upper-middle-income Countries': 'No',
 'Lower-middle-income Countries': 'Yes',
 'Low-income Countries': 'No',
 'Unnamed: 20': 'Yes',
 'with a population of less than 90,000 by mid-2018': 'No'}]},
'Median Age of Population': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950',
'1955',
'1960'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950': 23.5693599981,
 '1955': 23.1060484581,
 '1960': 22.6477759207},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1955': '...',
 '1960': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 28.4891027878,
 '1955': 28.9703197878,
 '1960': 29.5267878165},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 21.4237312338,
 '1955': 20.6505618847,
 '1960': 19.987384183},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 19.2960388937,
 '1955': 19.077962469,
 '1960': 18.7468268154},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 21.7117576783,
 '1955': 20.8706454043,
 '1960': 20.1748429775},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 20.3323334378,
 '1955': 19.9713960828,
 '1960': 19.5131329014},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 20.101744504,
 '1955': 19.8227567327,
 '1960': 19.485277435},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 20.2062530085,
 '1955': 19.8690269398,
 '1960': 19.5285403427},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1955': '...',
 '1960': '...'}]},
'Number of births': {'headers': ['country',
'uniqueid',
'nuts1',
'nuts2',
'nuts3',
'lat',
'lng',
'city',
'monotowns',
'year1',
'year2',
'year3',
'cen_1',
'cen_2',
'cen_3',
'agglomerationtype_1',
'agglomerationtype_2',
'agglomerationtype_3',
'agglomerationmaincity_1',
'agglomerationmaincity_2',
'agglomerationmaincity_3',
'agglpop1',
'agglpop2',
'agglpop3',
'agglomeration_3',
'agglomeration_2',
'agglomeration_1',
'area_1',
'area_2',
'area_3',
'rc1996_t0',
'rc2000_t0',
'rc2010_t1',
'ntlchgcorr1_3',
'ntlchgcorr2_3',
'intensive1_3',
'intensive2_3',
'extensive1_3',
'extensive2_3',
'extencorr1_3',
'extencorr2_3',
'ntl1992',
'ntl1993',
'ntl1994',
'ntl1995',
'ntl1996',
'ntl1997',
'ntl1998',
'ntl1999',
'ntl2000',
'ntl2001',
'ntl2002',
'ntl2003',
'ntl2004',
'ntl2005',
'ntl2006',
'ntl2007',
'ntl2008',
'ntl2009',
'ntl2010',
'ntl2011',
'ntl2012',
'rc1996',
'rc1999',
'rc2000',
'rc2004',
'rc2002',
'rc2005',
'rc2010',
'typology1a',
'typology1b',
'poptype1',
'npoptype10_1',
'npoptype20_1',
'npoptype50_1',
'npoptype100_1',
'npoptype500_1',
'npoptype500p_1',
'poptype2',
'npoptype10_2',
'npoptype20_2',
'npoptype50_2',
'npoptype100_2',
'npoptype500_2',
'npoptype500p_2',
'poptype3',
'npoptype10_3',
'npoptype20_3',
'npoptype50_3',
'npoptype100_3',
'npoptype500_3',
'npoptype500p_3',
'metromunicipality2012',
'aggl_d1',
'aggl_d2',
'aggl_d3',
'periods1_3',
'periods2_3',
'periods1_2',
'class_a',
'class_b',
'ndvi',
'jantemp',
'annprecip',
'pcntforest',
'dis_coast',
'dis_border',
'closest_border',
'mp_96',
'mp_00',
'mp_10',
'mpp_1',
'mpp_2',
'mpp_3',
'mpg_1_2',
'mpg_2_3',
'mpg_1_3',
'mppg_1_2',
'mppg_2_3',
'mppg_1_3'],
'data': [{'country': 'Albania',
 'uniqueid': 'ALB1.29',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.803889,
 'lng': 19.914444,
 'city': 'KUCOVE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 21709,
 'cen_2': 18038,
 'cen_3': 12654,
 'agglomerationtype_1': 'Agglomeration',
 'agglomerationtype_2': 'Agglomeration',
 'agglomerationtype_3': 'Agglomeration',
 'agglomerationmaincity_1': 'BERAT',
 'agglomerationmaincity_2': 'BERAT',
 'agglomerationmaincity_3': 'BERAT',
 'agglpop1': 68955.0,
 'agglpop2': 71259.0,
 'agglpop3': 56382.0,
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': '',
 'rc1996_t0': 1117.8299560547,
 'rc2000_t0': 1117.8299560547,
 'rc2010_t1': 3750.4399414062,
 'ntlchgcorr1_3': '',
 'ntlchgcorr2_3': '',
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': '',
 'extensive2_3': '',
 'extencorr1_3': '',
 'extencorr2_3': '',
 'ntl1992': '',
 'ntl1993': '',
 'ntl1994': '',
 'ntl1995': '',
 'ntl1996': '',
 'ntl1997': '',
 'ntl1998': '',
 'ntl1999': '',
 'ntl2000': '',
 'ntl2001': '',
 'ntl2002': '',
 'ntl2003': '',
 'ntl2004': '',
 'ntl2005': '',
 'ntl2006': '',
 'ntl2007': '',
 'ntl2008': '',
 'ntl2009': '',
 'ntl2010': '',
 'ntl2011': '',
 'ntl2012': '',
 'rc1996': '',
 'rc1999': '',
 'rc2000': '',
 'rc2004': '',
 'rc2002': '',
 'rc2005': '',
 'rc2010': '',
 'typology1a': 'FOUND',
 'typology1b': 'FOUND',
 'poptype1': 'Large towns (20k - 50k)',
 'npoptype10_1': '',
 'npoptype20_1': '',
 'npoptype50_1': 1.0,
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Large towns (20k - 50k)',
 'npoptype10_2': '',
 'npoptype20_2': 1.0,
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Mid size towns (10k - 20k)',
 'npoptype10_3': '',
 'npoptype20_3': 1.0,
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': 2.0,
 'aggl_d2': 2.0,
 'aggl_d3': 2.0,
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 179,
 'jantemp': 7.4767,
 'annprecip': 1028.7,
 'pcntforest': 1,
 'dis_coast': 34886.2,
 'dis_border': 64409.7579642,
 'closest_border': 'Albania/Macedonia',
 'mp_96': 799.1959228516,
 'mp_00': 888.0565795898,
 'mp_10': 1538.2537841797,
 'mpp_1': 19145.861328125,
 'mpp_2': 24834.91015625,
 'mpp_3': 24727.064453125,
 'mpg_1_2': 0.1111875772,
 'mpg_2_3': 0.7321574092,
 'mpg_1_3': 0.9247518182,
 'mppg_1_2': 0.2971424758,
 'mppg_2_3': -0.0043425043,
 'mppg_1_3': 0.2915096283},
{'country': 'Albania',
 'uniqueid': 'ALB1.4',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.708638,
 'lng': 19.943731,
 'city': 'BERAT',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 42957,
 'cen_2': 44040,
 'cen_3': 36496,
 'agglomerationtype_1': 'Single City',
 'agglomerationtype_2': 'Single City',
 'agglomerationtype_3': 'Agglomeration',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': 'BERAT',
 'agglpop1': 68955.0,
 'agglpop2': 71259.0,
 'agglpop3': 56382.0,
 'agglomeration_3': 1.0,
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': 49.0796966553,
 'area_2': 49.0796966553,
 'area_3': 135.1549987793,
 'rc1996_t0': 1117.8299560547,
 'rc2000_t0': 1117.8299560547,
 'rc2010_t1': 3750.4399414062,
 'ntlchgcorr1_3': 1361.2199707031,
 'ntlchgcorr2_3': 1361.2199707031,
 'intensive1_3': 664.5609741211,
 'intensive2_3': 664.5609741211,
 'extensive1_3': 1968.0500488281,
 'extensive2_3': 1968.0500488281,
 'extencorr1_3': 696.658996582,
 'extencorr2_3': 696.658996582,
 'ntl1992': 903.0,
 'ntl1993': 1467.0,
 'ntl1994': 2008.0,
 'ntl1995': 2194.0,
 'ntl1996': 2119.0,
 'ntl1997': 1363.0,
 'ntl1998': 1884.0,
 'ntl1999': 2416.0,
 'ntl2000': 2514.0,
 'ntl2001': 2490.0,
 'ntl2002': 2433.0,
 'ntl2003': 2854.0,
 'ntl2004': 2828.0,
 'ntl2005': 3031.0,
 'ntl2006': 3216.0,
 'ntl2007': 3360.0,
 'ntl2008': 3790.0,
 'ntl2009': 2978.0,
 'ntl2010': 3336.0,
 'ntl2011': 3485.0,
 'ntl2012': 3612.0,
 'rc1996': 2389.2199707031,
 'rc1999': 2089.1799316406,
 'rc2000': 2510.25,
 'rc2004': 2803.9599609375,
 'rc2002': 2834.6599121094,
 'rc2005': 2946.3898925781,
 'rc2010': 3750.4399414062,
 'typology1a': 'FOUND',
 'typology1b': 'FOUND',
 'poptype1': 'Large towns (20k - 50k)',
 'npoptype10_1': '',
 'npoptype20_1': '',
 'npoptype50_1': 1.0,
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Large towns (20k - 50k)',
 'npoptype10_2': '',
 'npoptype20_2': '',
 'npoptype50_2': 1.0,
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Large towns (20k - 50k)',
 'npoptype10_3': '',
 'npoptype20_3': '',
 'npoptype50_3': 1.0,
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': 1.0,
 'aggl_d2': 1.0,
 'aggl_d3': 3.0,
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': 4.0,
 'class_b': 4.0,
 'ndvi': 180,
 'jantemp': 7.4767,
 'annprecip': 1028.7,
 'pcntforest': 6,
 'dis_coast': 41928.1,
 'dis_border': 68381.7505022,
 'closest_border': 'Albania/Macedonia',
 'mp_96': 713.0537719727,
 'mp_00': 786.492980957,
 'mp_10': 1358.0972900391,
 'mpp_1': 17568.16015625,
 'mpp_2': 22498.416015625,
 'mpp_3': 22249.2265625,
 'mpg_1_2': 0.1029925272,
 'mpg_2_3': 0.726776123,
 'mpg_1_3': 0.9046211243,
 'mppg_1_2': 0.2806358635,
 'mppg_2_3': -0.0110758664,
 'mppg_1_3': 0.2664517164},
{'country': 'Albania',
 'uniqueid': 'ALB1.47',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.612222,
 'lng': 20.098056,
 'city': 'POLICAN',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 8961,
 'cen_2': 6623,
 'cen_3': 4318,
 'agglomerationtype_1': ' ',
 'agglomerationtype_2': ' ',
 'agglomerationtype_3': ' ',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': '',
 'agglpop1': '',
 'agglpop2': '',
 'agglpop3': '',
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': '',
 'rc1996_t0': '',
 'rc2000_t0': '',
 'rc2010_t1': '',
 'ntlchgcorr1_3': '',
 'ntlchgcorr2_3': '',
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': '',
 'extensive2_3': '',
 'extencorr1_3': '',
 'extencorr2_3': '',
 'ntl1992': '',
 'ntl1993': '',
 'ntl1994': '',
 'ntl1995': '',
 'ntl1996': '',
 'ntl1997': '',
 'ntl1998': '',
 'ntl1999': '',
 'ntl2000': '',
 'ntl2001': '',
 'ntl2002': '',
 'ntl2003': '',
 'ntl2004': '',
 'ntl2005': '',
 'ntl2006': '',
 'ntl2007': '',
 'ntl2008': '',
 'ntl2009': '',
 'ntl2010': '',
 'ntl2011': '',
 'ntl2012': '',
 'rc1996': '',
 'rc1999': '',
 'rc2000': '',
 'rc2004': '',
 'rc2002': '',
 'rc2005': '',
 'rc2010': '',
 'typology1a': 'MISSED',
 'typology1b': 'MISSED',
 'poptype1': 'Small Town (<10k)',
 'npoptype10_1': 1.0,
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small Town (<10k)',
 'npoptype10_2': 1.0,
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small Town (<10k)',
 'npoptype10_3': 1.0,
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': '',
 'aggl_d2': '',
 'aggl_d3': '',
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 190,
 'jantemp': 0.78667,
 'annprecip': 969.109,
 'pcntforest': 22,
 'dis_coast': 54419.7,
 'dis_border': 60764.3650532,
 'closest_border': 'Albania/Greece',
 'mp_96': 727.0880737305,
 'mp_00': 796.6593017578,
 'mp_10': 1347.7923583984,
 'mpp_1': 18710.115234375,
 'mpp_2': 22788.546875,
 'mpp_3': 21859.392578125,
 'mpg_1_2': 0.0956847295,
 'mpg_2_3': 0.6918051839,
 'mpg_1_3': 0.8536851406,
 'mppg_1_2': 0.2179800421,
 'mppg_2_3': -0.0407728627,
 'mppg_1_3': 0.1683195084},
{'country': 'Albania',
 'uniqueid': 'ALB1.59',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.772063,
 'lng': 19.875258,
 'city': 'URA VAJGURORE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 4289,
 'cen_2': 9181,
 'cen_3': 7232,
 'agglomerationtype_1': 'Agglomeration',
 'agglomerationtype_2': 'Agglomeration',
 'agglomerationtype_3': 'Agglomeration',
 'agglomerationmaincity_1': 'BERAT',
 'agglomerationmaincity_2': 'BERAT',
 'agglomerationmaincity_3': 'BERAT',
 'agglpop1': 68955.0,
 'agglpop2': 71259.0,
 'agglpop3': 56382.0,
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': '',
 'rc1996_t0': 1117.8299560547,
 'rc2000_t0': 1117.8299560547,
 'rc2010_t1': 3750.4399414062,
 'ntlchgcorr1_3': '',
 'ntlchgcorr2_3': '',
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': '',
 'extensive2_3': '',
 'extencorr1_3': '',
 'extencorr2_3': '',
 'ntl1992': '',
 'ntl1993': '',
 'ntl1994': '',
 'ntl1995': '',
 'ntl1996': '',
 'ntl1997': '',
 'ntl1998': '',
 'ntl1999': '',
 'ntl2000': '',
 'ntl2001': '',
 'ntl2002': '',
 'ntl2003': '',
 'ntl2004': '',
 'ntl2005': '',
 'ntl2006': '',
 'ntl2007': '',
 'ntl2008': '',
 'ntl2009': '',
 'ntl2010': '',
 'ntl2011': '',
 'ntl2012': '',
 'rc1996': '',
 'rc1999': '',
 'rc2000': '',
 'rc2004': '',
 'rc2002': '',
 'rc2005': '',
 'rc2010': '',
 'typology1a': 'FOUND',
 'typology1b': 'FOUND',
 'poptype1': 'Small Town (<10k)',
 'npoptype10_1': 1.0,
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small Town (<10k)',
 'npoptype10_2': 1.0,
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small Town (<10k)',
 'npoptype10_3': 1.0,
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': 2.0,
 'aggl_d2': 2.0,
 'aggl_d3': 2.0,
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 176,
 'jantemp': 7.4767,
 'annprecip': 1028.7,
 'pcntforest': 1,
 'dis_coast': 33362.4,
 'dis_border': 69060.0399021,
 'closest_border': 'Albania/Macedonia',
 'mp_96': 798.0504150391,
 'mp_00': 883.1791992188,
 'mp_10': 1521.7276611328,
 'mpp_1': 18935.853515625,
 'mpp_2': 24638.3984375,
 'mpp_3': 24453.291015625,
 'mpg_1_2': 0.1066709384,
 'mpg_2_3': 0.7230111957,
 'mpg_1_3': 0.9068064094,
 'mppg_1_2': 0.3011506796,
 'mppg_2_3': -0.0075129648,
 'mppg_1_3': 0.2913751602},
{'country': 'Albania',
 'uniqueid': 'ALB1.9',
 'nuts1': '',
 'nuts2': 'Jug / South',
 'nuts3': 'BERAT',
 'lat': 40.503794,
 'lng': 20.226629,
 'city': 'COROVODE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 7544,
 'cen_2': 6546,
 'cen_3': 4051,
 'agglomerationtype_1': ' ',
 'agglomerationtype_2': ' ',
 'agglomerationtype_3': ' ',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': '',
 'agglpop1': '',
 'agglpop2': '',
 'agglpop3': '',
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': '',
 'rc1996_t0': '',
 'rc2000_t0': '',
 'rc2010_t1': '',
 'ntlchgcorr1_3': '',
 'ntlchgcorr2_3': '',
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': '',
 'extensive2_3': '',
 'extencorr1_3': '',
 'extencorr2_3': '',
 'ntl1992': '',
 'ntl1993': '',
 'ntl1994': '',
 'ntl1995': '',
 'ntl1996': '',
 'ntl1997': '',
 'ntl1998': '',
 'ntl1999': '',
 'ntl2000': '',
 'ntl2001': '',
 'ntl2002': '',
 'ntl2003': '',
 'ntl2004': '',
 'ntl2005': '',
 'ntl2006': '',
 'ntl2007': '',
 'ntl2008': '',
 'ntl2009': '',
 'ntl2010': '',
 'ntl2011': '',
 'ntl2012': '',
 'rc1996': '',
 'rc1999': '',
 'rc2000': '',
 'rc2004': '',
 'rc2002': '',
 'rc2005': '',
 'rc2010': '',
 'typology1a': 'MISSED',
 'typology1b': 'MISSED',
 'poptype1': 'Small Town (<10k)',
 'npoptype10_1': 1.0,
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small Town (<10k)',
 'npoptype10_2': 1.0,
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small Town (<10k)',
 'npoptype10_3': 1.0,
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': '',
 'aggl_d2': '',
 'aggl_d3': '',
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 183,
 'jantemp': 0.78667,
 'annprecip': 969.109,
 'pcntforest': 18,
 'dis_coast': 59941.0,
 'dis_border': 47003.4554333,
 'closest_border': 'Albania/Greece',
 'mp_96': 571.8796386719,
 'mp_00': 629.6531982422,
 'mp_10': 1077.1079101562,
 'mpp_1': 15922.068359375,
 'mpp_2': 19137.33203125,
 'mpp_3': 18460.986328125,
 'mpg_1_2': 0.1010239869,
 'mpg_2_3': 0.7106367946,
 'mpg_1_3': 0.8834521174,
 'mppg_1_2': 0.2019375563,
 'mppg_2_3': -0.0353416912,
 'mppg_1_3': 0.1594590545},
{'country': 'Albania',
 'uniqueid': 'ALB10.15',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.066667,
 'lng': 20.033333,
 'city': 'FUSHE ARREZ',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 2863,
 'cen_2': 4090,
 'cen_3': 2513,
 'agglomerationtype_1': ' ',
 'agglomerationtype_2': ' ',
 'agglomerationtype_3': ' ',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': '',
 'agglpop1': '',
 'agglpop2': '',
 'agglpop3': '',
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': '',
 'rc1996_t0': '',
 'rc2000_t0': '',
 'rc2010_t1': '',
 'ntlchgcorr1_3': '',
 'ntlchgcorr2_3': '',
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': '',
 'extensive2_3': '',
 'extencorr1_3': '',
 'extencorr2_3': '',
 'ntl1992': '',
 'ntl1993': '',
 'ntl1994': '',
 'ntl1995': '',
 'ntl1996': '',
 'ntl1997': '',
 'ntl1998': '',
 'ntl1999': '',
 'ntl2000': '',
 'ntl2001': '',
 'ntl2002': '',
 'ntl2003': '',
 'ntl2004': '',
 'ntl2005': '',
 'ntl2006': '',
 'ntl2007': '',
 'ntl2008': '',
 'ntl2009': '',
 'ntl2010': '',
 'ntl2011': '',
 'ntl2012': '',
 'rc1996': '',
 'rc1999': '',
 'rc2000': '',
 'rc2004': '',
 'rc2002': '',
 'rc2005': '',
 'rc2010': '',
 'typology1a': 'MISSED',
 'typology1b': 'MISSED',
 'poptype1': 'Small Town (<10k)',
 'npoptype10_1': 1.0,
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small Town (<10k)',
 'npoptype10_2': 1.0,
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small Town (<10k)',
 'npoptype10_3': 1.0,
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': '',
 'aggl_d2': '',
 'aggl_d3': '',
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 203,
 'jantemp': -2.5133,
 'annprecip': 1038.29,
 'pcntforest': 63,
 'dis_coast': 46105.7,
 'dis_border': 32793.8961784,
 'closest_border': 'Albania/Kosovo',
 'mp_96': 492.8295593262,
 'mp_00': 547.5681152344,
 'mp_10': 961.908996582,
 'mpp_1': 12519.3310546875,
 'mpp_2': 16449.64453125,
 'mpp_3': 16745.728515625,
 'mpg_1_2': 0.1110699549,
 'mpg_2_3': 0.7566928864,
 'mpg_1_3': 0.9518086314,
 'mppg_1_2': 0.3139395714,
 'mppg_2_3': 0.0179994162,
 'mppg_1_3': 0.337589711},
{'country': 'Albania',
 'uniqueid': 'ALB10.26',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.213611,
 'lng': 19.436389,
 'city': 'KOPLIK',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 2448,
 'cen_2': 3126,
 'cen_3': 3734,
 'agglomerationtype_1': ' ',
 'agglomerationtype_2': ' ',
 'agglomerationtype_3': 'Single City',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': '',
 'agglpop1': '',
 'agglpop2': '',
 'agglpop3': '',
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': 5.7874999046,
 'rc1996_t0': 0.0,
 'rc2000_t0': 0.0,
 'rc2010_t1': 109.6900024414,
 'ntlchgcorr1_3': 20.3959999084,
 'ntlchgcorr2_3': 20.3959999084,
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': 109.6900024414,
 'extensive2_3': 109.6900024414,
 'extencorr1_3': 20.3959999084,
 'extencorr2_3': 20.3959999084,
 'ntl1992': 0.0,
 'ntl1993': 0.0,
 'ntl1994': 60.0,
 'ntl1995': 61.0,
 'ntl1996': 63.0,
 'ntl1997': 20.0,
 'ntl1998': 60.0,
 'ntl1999': 61.0,
 'ntl2000': 68.0,
 'ntl2001': 58.0,
 'ntl2002': 55.0,
 'ntl2003': 70.0,
 'ntl2004': 59.0,
 'ntl2005': 54.0,
 'ntl2006': 52.0,
 'ntl2007': 58.0,
 'ntl2008': 52.0,
 'ntl2009': 40.0,
 'ntl2010': 74.0,
 'ntl2011': 66.0,
 'ntl2012': 82.0,
 'rc1996': 89.2939987183,
 'rc1999': 58.1475982666,
 'rc2000': 81.1277999878,
 'rc2004': 54.7443008423,
 'rc2002': 84.2366027832,
 'rc2005': 78.0696029663,
 'rc2010': 109.6900024414,
 'typology1a': 'APPEAR',
 'typology1b': 'APPEAR',
 'poptype1': 'Small Town (<10k)',
 'npoptype10_1': 1.0,
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small Town (<10k)',
 'npoptype10_2': 1.0,
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small Town (<10k)',
 'npoptype10_3': 1.0,
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': 1.0,
 'aggl_d2': 1.0,
 'aggl_d3': 1.0,
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 182,
 'jantemp': 3.97,
 'annprecip': 1435.43,
 'pcntforest': 1,
 'dis_coast': 30401.7,
 'dis_border': 9223.9604358,
 'closest_border': 'Albania/Montenegro',
 'mp_96': 517.1472167969,
 'mp_00': 560.5718994141,
 'mp_10': 953.4926757812,
 'mpp_1': 13375.5048828125,
 'mpp_2': 16623.763671875,
 'mpp_3': 16626.501953125,
 'mpg_1_2': 0.083969675,
 'mpg_2_3': 0.7009284496,
 'mpg_1_3': 0.843754828,
 'mppg_1_2': 0.242851302,
 'mppg_2_3': 0.0001647209,
 'mppg_1_3': 0.2430560291},
{'country': 'Albania',
 'uniqueid': 'ALB10.48',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.05,
 'lng': 19.9,
 'city': 'PUKE',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 3028,
 'cen_2': 4579,
 'cen_3': 3607,
 'agglomerationtype_1': ' ',
 'agglomerationtype_2': ' ',
 'agglomerationtype_3': ' ',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': '',
 'agglpop1': '',
 'agglpop2': '',
 'agglpop3': '',
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': '',
 'area_2': '',
 'area_3': '',
 'rc1996_t0': '',
 'rc2000_t0': '',
 'rc2010_t1': '',
 'ntlchgcorr1_3': '',
 'ntlchgcorr2_3': '',
 'intensive1_3': '',
 'intensive2_3': '',
 'extensive1_3': '',
 'extensive2_3': '',
 'extencorr1_3': '',
 'extencorr2_3': '',
 'ntl1992': '',
 'ntl1993': '',
 'ntl1994': '',
 'ntl1995': '',
 'ntl1996': '',
 'ntl1997': '',
 'ntl1998': '',
 'ntl1999': '',
 'ntl2000': '',
 'ntl2001': '',
 'ntl2002': '',
 'ntl2003': '',
 'ntl2004': '',
 'ntl2005': '',
 'ntl2006': '',
 'ntl2007': '',
 'ntl2008': '',
 'ntl2009': '',
 'ntl2010': '',
 'ntl2011': '',
 'ntl2012': '',
 'rc1996': '',
 'rc1999': '',
 'rc2000': '',
 'rc2004': '',
 'rc2002': '',
 'rc2005': '',
 'rc2010': '',
 'typology1a': 'MISSED',
 'typology1b': 'MISSED',
 'poptype1': 'Small Town (<10k)',
 'npoptype10_1': 1.0,
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': '',
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small Town (<10k)',
 'npoptype10_2': 1.0,
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': '',
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small Town (<10k)',
 'npoptype10_3': 1.0,
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': '',
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': '',
 'aggl_d2': '',
 'aggl_d3': '',
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': '',
 'class_b': '',
 'ndvi': 202,
 'jantemp': -3.4233,
 'annprecip': 1148.33,
 'pcntforest': 40,
 'dis_coast': 36604.9,
 'dis_border': 40940.8942354,
 'closest_border': 'Albania/Kosovo',
 'mp_96': 529.4975585938,
 'mp_00': 585.8787231445,
 'mp_10': 1025.8287353516,
 'mpp_1': 13518.15234375,
 'mpp_2': 17690.404296875,
 'mpp_3': 17890.244140625,
 'mpg_1_2': 0.1064805016,
 'mpg_2_3': 0.7509233356,
 'mpg_1_3': 0.9373625517,
 'mppg_1_2': 0.3086406887,
 'mppg_2_3': 0.0112965107,
 'mppg_1_3': 0.3234237731},
{'country': 'Albania',
 'uniqueid': 'ALB10.56',
 'nuts1': '',
 'nuts2': 'Veri / Durrësi & North',
 'nuts3': 'SHKODËR',
 'lat': 42.069299,
 'lng': 19.503256,
 'city': 'SHKODER',
 'monotowns': '',
 'year1': 1989,
 'year2': 2001,
 'year3': 2011,
 'cen_1': 79920,
 'cen_2': 83274,
 'cen_3': 77075,
 'agglomerationtype_1': 'Single City',
 'agglomerationtype_2': 'Single City',
 'agglomerationtype_3': 'Single City',
 'agglomerationmaincity_1': '',
 'agglomerationmaincity_2': '',
 'agglomerationmaincity_3': '',
 'agglpop1': '',
 'agglpop2': '',
 'agglpop3': '',
 'agglomeration_3': '',
 'agglomeration_2': '',
 'agglomeration_1': '',
 'area_1': 63.3736000061,
 'area_2': 63.3736000061,
 'area_3': 108.8590011597,
 'rc1996_t0': 2172.9599609375,
 'rc2000_t0': 2172.9599609375,
 'rc2010_t1': 4051.2800292969,
 'ntlchgcorr1_3': 1212.1300048828,
 'ntlchgcorr2_3': 1212.1300048828,
 'intensive1_3': 858.8499755859,
 'intensive2_3': 858.8499755859,
 'extensive1_3': 1019.4699707031,
 'extensive2_3': 1019.4699707031,
 'extencorr1_3': 353.2799987793,
 'extencorr2_3': 353.2799987793,
 'ntl1992': 740.0,
 'ntl1993': 1462.0,
 'ntl1994': 2181.0,
 'ntl1995': 2812.0,
 'ntl1996': 2610.0,
 'ntl1997': 1942.0,
 'ntl1998': 2628.0,
 'ntl1999': 2695.0,
 'ntl2000': 3014.0,
 'ntl2001': 2776.0,
 'ntl2002': 2636.0,
 'ntl2003': 3247.0,
 'ntl2004': 2859.0,
 'ntl2005': 2953.0,
 'ntl2006': 3154.0,
 'ntl2007': 3179.0,
 'ntl2008': 3296.0,
 'ntl2009': 2912.0,
 'ntl2010': 3113.0,
 'ntl2011': 3089.0,
 'ntl2012': 3461.0,
 'rc1996': 2839.1499023438,
 'rc1999': 2653.6398925781,
 'rc2000': 2794.1000976562,
 'rc2004': 2999.830078125,
 'rc2002': 3148.7800292969,
 'rc2005': 3615.2199707031,
 'rc2010': 4051.2800292969,
 'typology1a': 'FOUND',
 'typology1b': 'FOUND',
 'poptype1': 'Small cities (50k - 100k)',
 'npoptype10_1': '',
 'npoptype20_1': '',
 'npoptype50_1': '',
 'npoptype100_1': 1.0,
 'npoptype500_1': '',
 'npoptype500p_1': '',
 'poptype2': 'Small cities (50k - 100k)',
 'npoptype10_2': '',
 'npoptype20_2': '',
 'npoptype50_2': '',
 'npoptype100_2': 1.0,
 'npoptype500_2': '',
 'npoptype500p_2': '',
 'poptype3': 'Small cities (50k - 100k)',
 'npoptype10_3': '',
 'npoptype20_3': '',
 'npoptype50_3': '',
 'npoptype100_3': 1.0,
 'npoptype500_3': '',
 'npoptype500p_3': '',
 'metromunicipality2012': '',
 'aggl_d1': 1.0,
 'aggl_d2': 1.0,
 'aggl_d3': 1.0,
 'periods1_3': 22,
 'periods2_3': 10,
 'periods1_2': 12,
 'class_a': 4.0,
 'class_b': 4.0,
 'ndvi': 173,
 'jantemp': -3.4233,
 'annprecip': 1148.33,
 'pcntforest': 0,
 'dis_coast': 19750.1,
 'dis_border': 11012.5579614,
 'closest_border': 'Albania/Montenegro',
 'mp_96': 425.3075256348,
 'mp_00': 478.8661193848,
 'mp_10': 860.8138427734,
 'mpp_1': 10616.67578125,
 'mpp_2': 14412.7568359375,
 'mpp_3': 14861.9873046875,
 'mpg_1_2': 0.1259291023,
 'mpg_2_3': 0.7976085544,
 'mpg_1_3': 1.0239797831,
 'mppg_1_2': 0.3575583398,
 'mppg_2_3': 0.0311689489,
 'mppg_1_3': 0.399872005}]},
'Percentage Total in Cities': {'headers': ['Index',
'Country Code',
'Country or area',
'City Code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20001,
 'Urban Agglomeration': 'Herat',
 'Note': '',
 'Latitude': 34.34817,
 'Longitude': 62.19967,
 '1950': 1.064,
 '1955': 1.037,
 '1960': 0.991,
 '1965': 0.933,
 '1970': 0.913,
 '1975': 0.956,
 '1980': 1.086,
 '1985': 1.379,
 '1990': 1.498,
 '1995': 1.212,
 '2000': 1.164,
 '2005': 1.1,
 '2010': 1.245,
 '2015': 1.383,
 '2020': 1.591,
 '2025': 1.776,
 '2030': 1.921,
 '2035': 2.077},
{'Index': 2,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20002,
 'Urban Agglomeration': 'Kabul',
 'Note': '',
 'Latitude': 34.528887,
 'Longitude': 69.17246,
 '1950': 2.203,
 '1955': 2.669,
 '1960': 3.172,
 '1965': 3.711,
 '1970': 4.241,
 '1975': 5.355,
 '1980': 7.381,
 '1985': 10.523,
 '1990': 12.648,
 '1995': 11.279,
 '2000': 11.95,
 '2005': 11.588,
 '2010': 11.419,
 '2015': 11.037,
 '2020': 11.093,
 '2025': 11.506,
 '2030': 12.285,
 '2035': 13.28},
{'Index': 3,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20003,
 'Urban Agglomeration': 'Kandahar',
 'Note': '',
 'Latitude': 31.61332,
 'Longitude': 65.71013,
 '1950': 1.06,
 '1955': 1.086,
 '1960': 1.09,
 '1965': 1.078,
 '1970': 1.143,
 '1975': 1.223,
 '1980': 1.381,
 '1985': 1.753,
 '1990': 1.904,
 '1995': 1.54,
 '2000': 1.48,
 '2005': 1.343,
 '2010': 1.331,
 '2015': 1.295,
 '2020': 1.309,
 '2025': 1.362,
 '2030': 1.455,
 '2035': 1.572},
{'Index': 4,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20004,
 'Urban Agglomeration': 'Mazar-e Sharif',
 'Note': '',
 'Latitude': 36.70904,
 'Longitude': 67.11087,
 '1950': 0.387,
 '1955': 0.449,
 '1960': 0.511,
 '1965': 0.573,
 '1970': 0.633,
 '1975': 0.693,
 '1980': 0.8,
 '1985': 1.016,
 '1990': 1.103,
 '1995': 0.893,
 '2000': 0.858,
 '2005': 0.823,
 '2010': 0.984,
 '2015': 1.154,
 '2020': 1.4,
 '2025': 1.608,
 '2030': 1.747,
 '2035': 1.89},
{'Index': 5,
 'Country Code': 8,
 'Country or area': 'Albania',
 'City Code': 20005,
 'Urban Agglomeration': 'Tiranë (Tirana)',
 'Note': '',
 'Latitude': 41.3275,
 'Longitude': 19.81889,
 '1950': 6.691,
 '1955': 7.531,
 '1960': 8.237,
 '1965': 7.661,
 '1970': 7.288,
 '1975': 7.215,
 '1980': 7.222,
 '1985': 7.344,
 '1990': 7.535,
 '1995': 9.269,
 '2000': 10.741,
 '2005': 12.075,
 '2010': 13.899,
 '2015': 15.369,
 '2020': 16.781,
 '2025': 18.178,
 '2030': 19.271,
 '2035': 20.088},
{'Index': 6,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20009,
 'Urban Agglomeration': 'Annaba',
 'Note': '',
 'Latitude': 36.9,
 'Longitude': 7.76667,
 '1950': 1.124,
 '1955': 1.185,
 '1960': 1.222,
 '1965': 1.257,
 '1970': 1.32,
 '1975': 1.4,
 '1980': 1.38,
 '1985': 1.308,
 '1990': 1.207,
 '1995': 1.122,
 '2000': 1.07,
 '2005': 1.02,
 '2010': 0.956,
 '2015': 0.881,
 '2020': 0.827,
 '2025': 0.819,
 '2030': 0.84,
 '2035': 0.861},
{'Index': 7,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20011,
 'Urban Agglomeration': 'Batna',
 'Note': '',
 'Latitude': 35.55597,
 'Longitude': 6.17414,
 '1950': 0.147,
 '1955': 0.21,
 '1960': 0.295,
 '1965': 0.412,
 '1970': 0.487,
 '1975': 0.561,
 '1980': 0.643,
 '1985': 0.73,
 '1990': 0.762,
 '1995': 0.777,
 '2000': 0.8,
 '2005': 0.803,
 '2010': 0.793,
 '2015': 0.77,
 '2020': 0.76,
 '2025': 0.774,
 '2030': 0.798,
 '2035': 0.817},
{'Index': 8,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20015,
 'Urban Agglomeration': 'Blida',
 'Note': '',
 'Latitude': 36.480781,
 'Longitude': 2.831943,
 '1950': 0.383,
 '1955': 0.468,
 '1960': 0.56,
 '1965': 0.668,
 '1970': 0.718,
 '1975': 0.763,
 '1980': 0.759,
 '1985': 0.729,
 '1990': 0.737,
 '1995': 0.781,
 '2000': 0.849,
 '2005': 0.919,
 '2010': 0.98,
 '2015': 1.026,
 '2020': 1.091,
 '2025': 1.157,
 '2030': 1.201,
 '2035': 1.23},
{'Index': 9,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20006,
 'Urban Agglomeration': 'El Djazaïr  (Algiers)',
 'Note': 1.0,
 'Latitude': 36.7525,
 'Longitude': 3.04197,
 '1950': 5.821,
 '1955': 6.337,
 '1960': 7.835,
 '1965': 8.564,
 '1970': 8.805,
 '1975': 9.017,
 '1980': 8.385,
 '1985': 7.411,
 '1990': 6.935,
 '1995': 6.826,
 '2000': 6.864,
 '2005': 6.854,
 '2010': 6.734,
 '2015': 6.502,
 '2020': 6.387,
 '2025': 6.487,
 '2030': 6.684,
 '2035': 6.845},
{'Index': 10,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20020,
 'Urban Agglomeration': 'El Djelfa',
 'Note': '',
 'Latitude': 34.67279,
 'Longitude': 3.263,
 '1950': 0.118,
 '1955': 0.141,
 '1960': 0.166,
 '1965': 0.194,
 '1970': 0.224,
 '1975': 0.259,
 '1980': 0.297,
 '1985': 0.338,
 '1990': 0.391,
 '1995': 0.464,
 '2000': 0.566,
 '2005': 0.69,
 '2010': 0.827,
 '2015': 0.975,
 '2020': 1.162,
 '2025': 1.311,
 '2030': 1.375,
 '2035': 1.409},
{'Index': 11,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20019,
 'Urban Agglomeration': 'Qacentina',
 'Note': '',
 'Latitude': 36.354921,
 'Longitude': 6.607293,
 '1950': 0.992,
 '1955': 1.24,
 '1960': 1.517,
 '1965': 1.851,
 '1970': 1.929,
 '1975': 1.965,
 '1980': 1.943,
 '1985': 1.884,
 '1990': 1.751,
 '1995': 1.624,
 '2000': 1.515,
 '2005': 1.372,
 '2010': 1.222,
 '2015': 1.07,
 '2020': 0.955,
 '2025': 0.922,
 '2030': 0.941,
 '2035': 0.963},
{'Index': 12,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20037,
 'Urban Agglomeration': 'Sétif',
 'Note': '',
 'Latitude': 36.19112,
 'Longitude': 5.41373,
 '1950': 0.465,
 '1955': 0.534,
 '1960': 0.601,
 '1965': 0.674,
 '1970': 0.705,
 '1975': 0.733,
 '1980': 0.735,
 '1985': 0.72,
 '1990': 0.7,
 '1995': 0.692,
 '2000': 0.704,
 '2005': 0.721,
 '2010': 0.726,
 '2015': 0.719,
 '2020': 0.723,
 '2025': 0.744,
 '2030': 0.769,
 '2035': 0.787},
{'Index': 13,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20035,
 'Urban Agglomeration': 'Wahran (Oran)',
 'Note': '',
 'Latitude': 35.69111,
 'Longitude': -0.64167,
 '1950': 3.031,
 '1955': 2.913,
 '1960': 2.741,
 '1965': 2.571,
 '1970': 2.647,
 '1975': 2.788,
 '1980': 2.775,
 '1985': 2.675,
 '1990': 2.539,
 '1995': 2.44,
 '2000': 2.401,
 '2005': 2.353,
 '2010': 2.269,
 '2015': 2.151,
 '2020': 2.075,
 '2025': 2.087,
 '2030': 2.147,
 '2035': 2.198},
{'Index': 14,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000001,
 'Urban Agglomeration': 'Benguela',
 'Note': 2.0,
 'Latitude': -12.576,
 'Longitude': 13.405,
 '1950': 0.316,
 '1955': 0.353,
 '1960': 0.403,
 '1965': 0.485,
 '1970': 0.589,
 '1975': 0.863,
 '1980': 1.263,
 '1985': 1.587,
 '1990': 1.701,
 '1995': 1.784,
 '2000': 1.903,
 '2005': 1.968,
 '2010': 2.024,
 '2015': 2.088,
 '2020': 2.178,
 '2025': 2.285,
 '2030': 2.383,
 '2035': 2.465},
{'Index': 15,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204043,
 'Urban Agglomeration': 'Cabinda',
 'Note': 3.0,
 'Latitude': -5.55,
 'Longitude': 12.2,
 '1950': 0.104,
 '1955': 0.091,
 '1960': 0.082,
 '1965': 0.148,
 '1970': 0.291,
 '1975': 0.421,
 '1980': 0.579,
 '1985': 0.779,
 '1990': 1.085,
 '1995': 1.37,
 '2000': 1.568,
 '2005': 1.738,
 '2010': 1.918,
 '2015': 2.121,
 '2020': 2.369,
 '2025': 2.578,
 '2030': 2.706,
 '2035': 2.8},
{'Index': 16,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000011,
 'Urban Agglomeration': 'Cuito',
 'Note': '',
 'Latitude': -12.383,
 'Longitude': 16.933,
 '1950': 0.19,
 '1955': 0.204,
 '1960': 0.225,
 '1965': 0.248,
 '1970': 0.275,
 '1975': 0.335,
 '1980': 0.404,
 '1985': 0.477,
 '1990': 0.582,
 '1995': 0.696,
 '2000': 0.847,
 '2005': 0.998,
 '2010': 1.171,
 '2015': 1.377,
 '2020': 1.631,
 '2025': 1.833,
 '2030': 1.935,
 '2035': 2.002},
{'Index': 17,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20050,
 'Urban Agglomeration': 'Huambo',
 'Note': 4.0,
 'Latitude': -12.77611,
 'Longitude': 15.73917,
 '1950': 0.337,
 '1955': 0.466,
 '1960': 0.657,
 '1965': 0.772,
 '1970': 0.894,
 '1975': 1.239,
 '1980': 1.711,
 '1985': 2.191,
 '1990': 2.681,
 '1995': 2.912,
 '2000': 2.78,
 '2005': 2.571,
 '2010': 2.366,
 '2015': 2.183,
 '2020': 2.045,
 '2025': 2.023,
 '2030': 2.089,
 '2035': 2.16},
{'Index': 18,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000000,
 'Urban Agglomeration': 'Lobito',
 'Note': 5.0,
 'Latitude': -12.364,
 'Longitude': 13.536,
 '1950': 0.506,
 '1955': 0.652,
 '1960': 0.857,
 '1965': 0.874,
 '1970': 0.872,
 '1975': 1.083,
 '1980': 1.347,
 '1985': 1.496,
 '1990': 1.501,
 '1995': 1.474,
 '2000': 1.473,
 '2005': 1.426,
 '2010': 1.373,
 '2015': 1.326,
 '2020': 1.299,
 '2025': 1.316,
 '2030': 1.364,
 '2035': 1.411},
{'Index': 19,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20049,
 'Urban Agglomeration': 'Luanda',
 'Note': 6.0,
 'Latitude': -8.83682,
 'Longitude': 13.23432,
 '1950': 3.043,
 '1955': 3.406,
 '1960': 3.888,
 '1965': 5.08,
 '1970': 6.777,
 '1975': 7.791,
 '1980': 8.638,
 '1985': 9.753,
 '1990': 12.109,
 '1995': 14.481,
 '2000': 17.206,
 '2005': 19.803,
 '2010': 22.681,
 '2015': 25.21,
 '2020': 25.375,
 '2025': 26.093,
 '2030': 27.126,
 '2035': 28.056},
{'Index': 20,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204044,
 'Urban Agglomeration': 'Lubango',
 'Note': 7.0,
 'Latitude': -14.91717,
 'Longitude': 13.4925,
 '1950': 0.254,
 '1955': 0.256,
 '1960': 0.263,
 '1965': 0.339,
 '1970': 0.452,
 '1975': 0.598,
 '1980': 0.774,
 '1985': 0.98,
 '1990': 1.286,
 '1995': 1.557,
 '2000': 1.759,
 '2005': 1.925,
 '2010': 2.096,
 '2015': 2.288,
 '2020': 2.523,
 '2025': 2.726,
 '2030': 2.859,
 '2035': 2.958},
{'Index': 21,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000004,
 'Urban Agglomeration': 'Malanje',
 'Note': 8.0,
 'Latitude': -9.54,
 'Longitude': 16.341,
 '1950': 0.202,
 '1955': 0.254,
 '1960': 0.325,
 '1965': 0.385,
 '1970': 0.456,
 '1975': 0.544,
 '1980': 0.637,
 '1985': 0.729,
 '1990': 0.865,
 '1995': 1.003,
 '2000': 1.185,
 '2005': 1.355,
 '2010': 1.543,
 '2015': 1.76,
 '2020': 2.026,
 '2025': 2.241,
 '2030': 2.36,
 '2035': 2.442},
{'Index': 22,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000012,
 'Urban Agglomeration': 'Uige',
 'Note': '',
 'Latitude': -7.1069,
 'Longitude': 15.4406,
 '1950': 0.07,
 '1955': 0.086,
 '1960': 0.108,
 '1965': 0.136,
 '1970': 0.172,
 '1975': 0.22,
 '1980': 0.277,
 '1985': 0.34,
 '1990': 0.433,
 '1995': 0.54,
 '2000': 0.685,
 '2005': 0.841,
 '2010': 1.029,
 '2015': 1.261,
 '2020': 1.556,
 '2025': 1.787,
 '2030': 1.893,
 '2035': 1.96},
{'Index': 23,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20057,
 'Urban Agglomeration': 'Bahia Blanca',
 'Note': '',
 'Latitude': -38.7196,
 'Longitude': -62.27243,
 '1950': 0.675,
 '1955': 0.639,
 '1960': 0.613,
 '1965': 0.676,
 '1970': 0.753,
 '1975': 0.77,
 '1980': 0.791,
 '1985': 0.781,
 '1990': 0.771,
 '1995': 0.748,
 '2000': 0.728,
 '2005': 0.723,
 '2010': 0.725,
 '2015': 0.708,
 '2020': 0.693,
 '2025': 0.689,
 '2030': 0.693,
 '2035': 0.697},
{'Index': 24,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 9.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 '1950': 30.123,
 '1955': 31.223,
 '1960': 32.794,
 '1965': 33.875,
 '1970': 35.107,
 '1975': 35.076,
 '1980': 35.294,
 '1985': 34.629,
 '1990': 34.059,
 '1995': 33.738,
 '2000': 33.742,
 '2005': 34.051,
 '2010': 34.557,
 '2015': 33.87,
 '2020': 33.297,
 '2025': 33.177,
 '2030': 33.364,
 '2035': 33.566},
{'Index': 25,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20059,
 'Urban Agglomeration': 'Córdoba',
 'Note': 10.0,
 'Latitude': -31.4135,
 'Longitude': -64.18105,
 '1950': 2.503,
 '1955': 2.693,
 '1960': 2.936,
 '1965': 3.144,
 '1970': 3.378,
 '1975': 3.472,
 '1980': 3.592,
 '1985': 3.625,
 '1990': 3.667,
 '1995': 3.644,
 '2000': 3.636,
 '2005': 3.591,
 '2010': 3.54,
 '2015': 3.488,
 '2020': 3.454,
 '2025': 3.455,
 '2030': 3.477,
 '2035': 3.498},
{'Index': 26,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20063,
 'Urban Agglomeration': 'Corrientes',
 'Note': 11.0,
 'Latitude': -27.4806,
 'Longitude': -58.8341,
 '1950': 0.375,
 '1955': 0.416,
 '1960': 0.468,
 '1965': 0.514,
 '1970': 0.566,
 '1975': 0.599,
 '1980': 0.637,
 '1985': 0.696,
 '1990': 0.765,
 '1995': 0.799,
 '2000': 0.832,
 '2005': 0.85,
 '2010': 0.864,
 '2015': 0.878,
 '2020': 0.896,
 '2025': 0.911,
 '2030': 0.919,
 '2035': 0.925},
{'Index': 27,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20065,
 'Urban Agglomeration': 'La Plata',
 'Note': 12.0,
 'Latitude': -34.92145,
 'Longitude': -57.95453,
 '1950': 1.746,
 '1955': 1.831,
 '1960': 1.946,
 '1965': 1.98,
 '1970': 2.018,
 '1975': 2.001,
 '1980': 2.0,
 '1985': 1.965,
 '1990': 1.936,
 '1995': 1.876,
 '2000': 1.825,
 '2005': 1.848,
 '2010': 1.905,
 '2015': 1.921,
 '2020': 1.943,
 '2025': 1.965,
 '2030': 1.982,
 '2035': 1.994},
{'Index': 28,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20067,
 'Urban Agglomeration': 'Mar Del Plata',
 'Note': '',
 'Latitude': -38.00228,
 'Longitude': -57.55754,
 '1950': 0.772,
 '1955': 0.879,
 '1960': 1.014,
 '1965': 1.124,
 '1970': 1.25,
 '1975': 1.346,
 '1980': 1.461,
 '1985': 1.509,
 '1990': 1.559,
 '1995': 1.51,
 '2000': 1.454,
 '2005': 1.45,
 '2010': 1.468,
 '2015': 1.463,
 '2020': 1.463,
 '2025': 1.471,
 '2030': 1.482,
 '2035': 1.491},
{'Index': 29,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20068,
 'Urban Agglomeration': 'Mendoza',
 'Note': 13.0,
 'Latitude': -32.89084,
 'Longitude': -68.82717,
 '1950': 1.433,
 '1955': 1.501,
 '1960': 1.592,
 '1965': 1.768,
 '1970': 1.975,
 '1975': 2.062,
 '1980': 2.164,
 '1985': 2.236,
 '1990': 2.318,
 '1995': 2.292,
 '2000': 2.262,
 '2005': 2.307,
 '2010': 2.388,
 '2015': 2.476,
 '2020': 2.577,
 '2025': 2.648,
 '2030': 2.677,
 '2035': 2.694},
{'Index': 30,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20070,
 'Urban Agglomeration': 'Neuquén-Plottier-Cipolletti',
 'Note': '',
 'Latitude': -38.95143,
 'Longitude': -68.064809,
 '1950': 0.081,
 '1955': 0.119,
 '1960': 0.178,
 '1965': 0.226,
 '1970': 0.285,
 '1975': 0.369,
 '1980': 0.482,
 '1985': 0.585,
 '1990': 0.71,
 '1995': 0.746,
 '2000': 0.767,
 '2005': 0.793,
 '2010': 0.823,
 '2015': 0.858,
 '2020': 0.898,
 '2025': 0.925,
 '2030': 0.936,
 '2035': 0.942},
{'Index': 31,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20072,
 'Urban Agglomeration': 'Posadas',
 'Note': '',
 'Latitude': -27.36708,
 'Longitude': -55.89608,
 '1950': 0.266,
 '1955': 0.305,
 '1960': 0.355,
 '1965': 0.379,
 '1970': 0.404,
 '1975': 0.45,
 '1980': 0.506,
 '1985': 0.562,
 '1990': 0.625,
 '1995': 0.674,
 '2000': 0.728,
 '2005': 0.754,
 '2010': 0.771,
 '2015': 0.81,
 '2020': 0.854,
 '2025': 0.885,
 '2030': 0.895,
 '2035': 0.901},
{'Index': 32,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20073,
 'Urban Agglomeration': 'Resistencia',
 'Note': 14.0,
 'Latitude': -27.46056,
 'Longitude': -58.98389,
 '1950': 0.423,
 '1955': 0.46,
 '1960': 0.507,
 '1965': 0.547,
 '1970': 0.591,
 '1975': 0.672,
 '1980': 0.773,
 '1985': 0.82,
 '1990': 0.869,
 '1995': 0.904,
 '2000': 0.944,
 '2005': 0.945,
 '2010': 0.933,
 '2015': 0.939,
 '2020': 0.95,
 '2025': 0.961,
 '2030': 0.969,
 '2035': 0.975},
{'Index': 33,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20075,
 'Urban Agglomeration': 'Rosario',
 'Note': 15.0,
 'Latitude': -32.94682,
 'Longitude': -60.63932,
 '1950': 3.233,
 '1955': 3.223,
 '1960': 3.256,
 '1965': 3.322,
 '1970': 3.405,
 '1975': 3.386,
 '1980': 3.392,
 '1985': 3.347,
 '1990': 3.311,
 '1995': 3.204,
 '2000': 3.11,
 '2005': 3.131,
 '2010': 3.204,
 '2015': 3.277,
 '2020': 3.367,
 '2025': 3.435,
 '2030': 3.469,
 '2035': 3.491},
{'Index': 34,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20076,
 'Urban Agglomeration': 'Salta',
 'Note': '',
 'Latitude': -24.7859,
 'Longitude': -65.41166,
 '1950': 0.45,
 '1955': 0.502,
 '1960': 0.567,
 '1965': 0.641,
 '1970': 0.728,
 '1975': 0.813,
 '1980': 0.917,
 '1985': 0.999,
 '1990': 1.09,
 '1995': 1.164,
 '2000': 1.246,
 '2005': 1.31,
 '2010': 1.371,
 '2015': 1.434,
 '2020': 1.505,
 '2025': 1.553,
 '2030': 1.572,
 '2035': 1.582},
{'Index': 35,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20078,
 'Urban Agglomeration': 'San Juan',
 'Note': 16.0,
 'Latitude': -31.5375,
 'Longitude': -68.53639,
 '1950': 0.631,
 '1955': 0.671,
 '1960': 0.723,
 '1965': 0.813,
 '1970': 0.92,
 '1975': 0.97,
 '1980': 1.029,
 '1985': 1.061,
 '1990': 1.096,
 '1995': 1.104,
 '2000': 1.117,
 '2005': 1.152,
 '2010': 1.201,
 '2015': 1.189,
 '2020': 1.18,
 '2025': 1.181,
 '2030': 1.189,
 '2035': 1.196},
{'Index': 36,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20081,
 'Urban Agglomeration': 'San Miguel de Tucumán',
 'Note': 17.0,
 'Latitude': -26.82414,
 'Longitude': -65.2226,
 '1950': 1.305,
 '1955': 1.371,
 '1960': 1.46,
 '1965': 1.489,
 '1970': 1.521,
 '1975': 1.626,
 '1980': 1.757,
 '1985': 1.81,
 '1990': 1.867,
 '1995': 1.902,
 '2000': 1.948,
 '2005': 1.996,
 '2010': 2.048,
 '2015': 2.102,
 '2020': 2.166,
 '2025': 2.214,
 '2030': 2.236,
 '2035': 2.25},
{'Index': 37,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20084,
 'Urban Agglomeration': 'San Salvador de Jujuy',
 'Note': 18.0,
 'Latitude': -24.19456,
 'Longitude': -65.29712,
 '1950': 0.197,
 '1955': 0.204,
 '1960': 0.213,
 '1965': 0.267,
 '1970': 0.339,
 '1975': 0.386,
 '1980': 0.441,
 '1985': 0.488,
 '1990': 0.541,
 '1995': 0.616,
 '2000': 0.711,
 '2005': 0.748,
 '2010': 0.762,
 '2015': 0.776,
 '2020': 0.793,
 '2025': 0.808,
 '2030': 0.815,
 '2035': 0.82},
{'Index': 38,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20085,
 'Urban Agglomeration': 'Santa Fe',
 'Note': 19.0,
 'Latitude': -31.632717,
 'Longitude': -60.698281,
 '1950': 1.25,
 '1955': 1.261,
 '1960': 1.289,
 '1965': 1.295,
 '1970': 1.304,
 '1975': 1.332,
 '1980': 1.374,
 '1985': 1.291,
 '1990': 1.209,
 '1995': 1.199,
 '2000': 1.214,
 '2005': 1.209,
 '2010': 1.2,
 '2015': 1.215,
 '2020': 1.237,
 '2025': 1.256,
 '2030': 1.268,
 '2035': 1.275},
{'Index': 39,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20086,
 'Urban Agglomeration': 'Santiago Del Estero',
 'Note': 20.0,
 'Latitude': -27.79511,
 'Longitude': -64.26149,
 '1950': 0.482,
 '1955': 0.489,
 '1960': 0.502,
 '1965': 0.537,
 '1970': 0.578,
 '1975': 0.632,
 '1980': 0.698,
 '1985': 0.741,
 '1990': 0.789,
 '1995': 0.822,
 '2000': 0.86,
 '2005': 0.885,
 '2010': 0.908,
 '2015': 0.93,
 '2020': 0.957,
 '2025': 0.978,
 '2030': 0.987,
 '2035': 0.993},
{'Index': 40,
 'Country Code': 51,
 'Country or area': 'Armenia',
 'City Code': 20140,
 'Urban Agglomeration': 'Yerevan',
 'Note': '',
 'Latitude': 40.181998,
 'Longitude': 44.514619,
 '1950': 25.226,
 '1955': 27.598,
 '1960': 28.694,
 '1965': 29.291,
 '1970': 30.817,
 '1975': 32.166,
 '1980': 33.602,
 '1985': 33.659,
 '1990': 33.196,
 '1995': 35.51,
 '2000': 36.204,
 '2005': 36.466,
 '2010': 37.034,
 '2015': 36.726,
 '2020': 36.965,
 '2025': 37.495,
 '2030': 38.313,
 '2035': 39.429},
{'Index': 41,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206171,
 'Urban Agglomeration': 'Adelaide',
 'Note': 21.0,
 'Latitude': -34.92866,
 'Longitude': 138.59863,
 '1950': 5.25,
 '1955': 5.398,
 '1960': 5.557,
 '1965': 6.132,
 '1970': 6.619,
 '1975': 6.714,
 '1980': 6.634,
 '1985': 6.508,
 '1990': 6.347,
 '1995': 6.15,
 '2000': 5.883,
 '2005': 5.706,
 '2010': 5.523,
 '2015': 5.394,
 '2020': 5.262,
 '2025': 5.187,
 '2030': 5.212,
 '2035': 5.26},
{'Index': 42,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206170,
 'Urban Agglomeration': 'Brisbane',
 'Note': 21.0,
 'Latitude': -27.46794,
 'Longitude': 153.02809,
 '1950': 5.402,
 '1955': 5.622,
 '1960': 5.86,
 '1965': 6.147,
 '1970': 7.044,
 '1975': 7.5,
 '1980': 7.746,
 '1985': 7.898,
 '1990': 8.105,
 '1995': 8.461,
 '2000': 8.452,
 '2005': 8.823,
 '2010': 9.081,
 '2015': 9.298,
 '2020': 9.474,
 '2025': 9.562,
 '2030': 9.649,
 '2035': 9.739},
{'Index': 43,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206175,
 'Urban Agglomeration': 'Canberra',
 'Note': 21.0,
 'Latitude': -35.28346,
 'Longitude': 149.12807,
 '1950': 0.244,
 '1955': 0.341,
 '1960': 0.498,
 '1965': 0.743,
 '1970': 1.069,
 '1975': 1.41,
 '1980': 1.521,
 '1985': 1.6,
 '1990': 1.656,
 '1995': 1.689,
 '2000': 1.802,
 '2005': 1.81,
 '2010': 1.798,
 '2015': 1.802,
 '2020': 1.801,
 '2025': 1.798,
 '2030': 1.811,
 '2035': 1.828},
{'Index': 44,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 895000015,
 'Urban Agglomeration': 'Central Coast',
 'Note': 21.0,
 'Latitude': -33.42,
 'Longitude': 151.39583,
 '1950': 0.878,
 '1955': 0.893,
 '1960': 0.915,
 '1965': 0.949,
 '1970': 0.962,
 '1975': 1.023,
 '1980': 1.107,
 '1985': 1.181,
 '1990': 1.248,
 '1995': 1.348,
 '2000': 1.464,
 '2005': 1.451,
 '2010': 1.406,
 '2015': 1.364,
 '2020': 1.319,
 '2025': 1.294,
 '2030': 1.299,
 '2035': 1.311},
{'Index': 45,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20093,
 'Urban Agglomeration': 'Gold Coast-Tweed Head',
 'Note': 21.0,
 'Latitude': -28.00029,
 'Longitude': 153.43088,
 '1950': 0.355,
 '1955': 0.412,
 '1960': 0.481,
 '1965': 0.569,
 '1970': 0.657,
 '1975': 0.797,
 '1980': 0.982,
 '1985': 1.197,
 '1990': 1.45,
 '1995': 1.738,
 '2000': 2.151,
 '2005': 2.439,
 '2010': 2.559,
 '2015': 2.661,
 '2020': 2.753,
 '2025': 2.802,
 '2030': 2.831,
 '2035': 2.858},
{'Index': 46,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206168,
 'Urban Agglomeration': 'Melbourne',
 'Note': 21.0,
 'Latitude': -37.814,
 'Longitude': 144.96332,
 '1950': 16.288,
 '1955': 17.093,
 '1960': 17.991,
 '1965': 18.197,
 '1970': 19.459,
 '1975': 19.753,
 '1980': 19.38,
 '1985': 18.873,
 '1990': 18.51,
 '1995': 18.159,
 '2000': 17.627,
 '2005': 17.652,
 '2010': 17.777,
 '2015': 18.614,
 '2020': 19.559,
 '2025': 20.076,
 '2030': 20.316,
 '2035': 20.509},
{'Index': 47,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206177,
 'Urban Agglomeration': 'Newcastle-Maitland',
 'Note': 21.0,
 'Latitude': -32.924878,
 'Longitude': 151.740852,
 '1950': 1.968,
 '1955': 1.978,
 '1960': 1.983,
 '1965': 2.012,
 '1970': 1.923,
 '1975': 1.883,
 '1980': 1.982,
 '1985': 1.889,
 '1990': 1.809,
 '1995': 1.755,
 '2000': 1.917,
 '2005': 1.923,
 '2010': 1.857,
 '2015': 1.815,
 '2020': 1.773,
 '2025': 1.749,
 '2030': 1.758,
 '2035': 1.774},
{'Index': 48,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206172,
 'Urban Agglomeration': 'Perth',
 'Note': 21.0,
 'Latitude': -31.947841,
 'Longitude': 115.852514,
 '1950': 3.8,
 '1955': 3.888,
 '1960': 3.976,
 '1965': 4.25,
 '1970': 5.356,
 '1975': 5.961,
 '1980': 6.291,
 '1985': 6.661,
 '1990': 7.01,
 '1995': 7.297,
 '2000': 7.379,
 '2005': 7.465,
 '2010': 7.786,
 '2015': 7.959,
 '2020': 8.04,
 '2025': 8.077,
 '2030': 8.143,
 '2035': 8.219},
{'Index': 49,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20098,
 'Urban Agglomeration': 'Sunshine Coast',
 'Note': 21.0,
 'Latitude': -26.66008,
 'Longitude': 153.09953,
 '1950': 0.121,
 '1955': 0.154,
 '1960': 0.197,
 '1965': 0.256,
 '1970': 0.325,
 '1975': 0.433,
 '1980': 0.586,
 '1985': 0.707,
 '1990': 0.887,
 '1995': 1.097,
 '2000': 1.114,
 '2005': 1.203,
 '2010': 1.243,
 '2015': 1.302,
 '2020': 1.366,
 '2025': 1.4,
 '2030': 1.417,
 '2035': 1.43},
{'Index': 50,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206167,
 'Urban Agglomeration': 'Sydney',
 'Note': 21.0,
 'Latitude': -33.86785,
 'Longitude': 151.20732,
 '1950': 20.666,
 '1955': 20.693,
 '1960': 20.746,
 '1965': 21.035,
 '1970': 22.522,
 '1975': 22.543,
 '1980': 22.2,
 '1985': 21.821,
 '1990': 21.312,
 '1995': 21.128,
 '2000': 19.824,
 '2005': 19.145,
 '2010': 18.832,
 '2015': 19.094,
 '2020': 19.395,
 '2025': 19.543,
 '2030': 19.714,
 '2035': 19.898},
{'Index': 51,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20101,
 'Urban Agglomeration': 'Wollongong',
 'Note': 21.0,
 'Latitude': -34.424,
 'Longitude': 150.89345,
 '1950': 0.899,
 '1955': 1.04,
 '1960': 1.214,
 '1965': 1.374,
 '1970': 1.411,
 '1975': 1.488,
 '1980': 1.551,
 '1985': 1.479,
 '1990': 1.423,
 '1995': 1.403,
 '2000': 1.362,
 '2005': 1.309,
 '2010': 1.259,
 '2015': 1.23,
 '2020': 1.202,
 '2025': 1.186,
 '2030': 1.192,
 '2035': 1.203},
{'Index': 52,
 'Country Code': 40,
 'Country or area': 'Austria',
 'City Code': 20107,
 'Urban Agglomeration': 'Wien (Vienna)',
 'Note': '',
 'Latitude': 48.206443,
 'Longitude': 16.370725,
 '1950': 23.284,
 '1955': 23.311,
 '1960': 23.006,
 '1965': 22.235,
 '1970': 21.56,
 '1975': 20.722,
 '1980': 20.221,
 '1985': 20.156,
 '1990': 19.926,
 '1995': 19.325,
 '2000': 19.199,
 '2005': 19.882,
 '2010': 20.579,
 '2015': 21.144,
 '2020': 21.976,
 '2025': 22.588,
 '2030': 23.246,
 '2035': 24.007},
{'Index': 53,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20053,
 'Urban Agglomeration': 'Baku',
 'Note': 22.0,
 'Latitude': 40.37767,
 'Longitude': 49.89201,
 '1950': 30.628,
 '1955': 28.219,
 '1960': 25.807,
 '1965': 24.649,
 '1970': 24.6,
 '1975': 25.186,
 '1980': 25.595,
 '1985': 24.907,
 '1990': 23.934,
 '1995': 22.707,
 '2000': 22.234,
 '2005': 21.869,
 '2010': 22.827,
 '2015': 22.941,
 '2020': 23.183,
 '2025': 23.908,
 '2030': 24.897,
 '2035': 25.974},
{'Index': 54,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20054,
 'Urban Agglomeration': 'Gäncä',
 'Note': '',
 'Latitude': 40.68278,
 'Longitude': 46.36056,
 '1950': 3.692,
 '1955': 3.384,
 '1960': 3.179,
 '1965': 3.374,
 '1970': 3.705,
 '1975': 3.78,
 '1980': 3.869,
 '1985': 3.895,
 '1990': 3.858,
 '1995': 3.741,
 '2000': 3.698,
 '2005': 3.582,
 '2010': 3.491,
 '2015': 3.406,
 '2020': 3.375,
 '2025': 3.444,
 '2030': 3.58,
 '2035': 3.735},
{'Index': 55,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20056,
 'Urban Agglomeration': 'Sumquayit',
 'Note': '',
 'Latitude': 40.58972,
 'Longitude': 49.66861,
 '1950': 0.691,
 '1955': 1.056,
 '1960': 1.498,
 '1965': 1.886,
 '1970': 2.446,
 '1975': 2.831,
 '1980': 3.177,
 '1985': 3.229,
 '1990': 3.28,
 '1995': 3.385,
 '2000': 3.517,
 '2005': 3.463,
 '2010': 3.465,
 '2015': 3.46,
 '2020': 3.506,
 '2025': 3.621,
 '2030': 3.771,
 '2035': 3.935},
{'Index': 56,
 'Country Code': 48,
 'Country or area': 'Bahrain',
 'City Code': 20109,
 'Urban Agglomeration': 'Al-Manamah (Manama)',
 'Note': 23.0,
 'Latitude': 26.21536,
 'Longitude': 50.5832,
 '1950': 34.844,
 '1955': 38.393,
 '1960': 39.949,
 '1965': 42.521,
 '1970': 41.42,
 '1975': 37.328,
 '1980': 31.36,
 '1985': 28.585,
 '1990': 25.382,
 '1995': 23.653,
 '2000': 21.322,
 '2005': 22.31,
 '2010': 23.546,
 '2015': 32.142,
 '2020': 37.373,
 '2025': 39.898,
 '2030': 40.628,
 '2035': 40.995},
{'Index': 57,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20110,
 'Urban Agglomeration': 'Barisal',
 'Note': '',
 'Latitude': 22.70194,
 'Longitude': 90.37111,
 '1950': 0.188,
 '1955': 0.183,
 '1960': 0.173,
 '1965': 0.169,
 '1970': 0.165,
 '1975': 0.18,
 '1980': 0.215,
 '1985': 0.211,
 '1990': 0.203,
 '1995': 0.195,
 '2000': 0.188,
 '2005': 0.202,
 '2010': 0.226,
 '2015': 0.253,
 '2020': 0.285,
 '2025': 0.317,
 '2030': 0.347,
 '2035': 0.373},
{'Index': 58,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20112,
 'Urban Agglomeration': 'Bogra',
 'Note': '',
 'Latitude': 24.85,
 'Longitude': 89.36667,
 '1950': 0.089,
 '1955': 0.093,
 '1960': 0.094,
 '1965': 0.092,
 '1970': 0.09,
 '1975': 0.098,
 '1980': 0.117,
 '1985': 0.137,
 '1990': 0.16,
 '1995': 0.165,
 '2000': 0.167,
 '2005': 0.207,
 '2010': 0.269,
 '2015': 0.35,
 '2020': 0.457,
 '2025': 0.55,
 '2030': 0.61,
 '2035': 0.658},
{'Index': 59,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20115,
 'Urban Agglomeration': 'Chittagong',
 'Note': '',
 'Latitude': 22.33306,
 'Longitude': 91.83639,
 '1950': 0.762,
 '1955': 0.767,
 '1960': 0.747,
 '1965': 0.9,
 '1970': 1.112,
 '1975': 1.426,
 '1980': 1.645,
 '1985': 1.775,
 '1990': 1.905,
 '1995': 2.172,
 '2000': 2.514,
 '2005': 2.591,
 '2010': 2.699,
 '2015': 2.814,
 '2020': 2.957,
 '2025': 3.171,
 '2030': 3.445,
 '2035': 3.711},
{'Index': 60,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20117,
 'Urban Agglomeration': 'Comilla',
 'Note': '',
 'Latitude': 23.45778,
 'Longitude': 91.20444,
 '1950': 0.207,
 '1955': 0.2,
 '1960': 0.187,
 '1965': 0.19,
 '1970': 0.195,
 '1975': 0.221,
 '1980': 0.268,
 '1985': 0.251,
 '1990': 0.227,
 '1995': 0.223,
 '2000': 0.222,
 '2005': 0.241,
 '2010': 0.272,
 '2015': 0.306,
 '2020': 0.347,
 '2025': 0.388,
 '2030': 0.424,
 '2035': 0.457},
{'Index': 61,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 24.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 '1950': 0.886,
 '1955': 0.971,
 '1960': 1.054,
 '1965': 1.47,
 '1970': 2.112,
 '1975': 3.115,
 '1980': 4.008,
 '1985': 5.0,
 '1990': 6.235,
 '1995': 7.019,
 '2000': 7.816,
 '2005': 8.597,
 '2010': 9.682,
 '2015': 10.916,
 '2020': 12.373,
 '2025': 13.829,
 '2030': 15.128,
 '2035': 16.301},
{'Index': 62,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20124,
 'Urban Agglomeration': 'Khulna',
 'Note': '',
 'Latitude': 22.80978,
 'Longitude': 89.56439,
 '1950': 0.162,
 '1955': 0.206,
 '1960': 0.255,
 '1965': 0.347,
 '1970': 0.476,
 '1975': 0.662,
 '1980': 0.77,
 '1985': 0.847,
 '1990': 0.928,
 '1995': 0.941,
 '2000': 0.948,
 '2005': 0.824,
 '2010': 0.722,
 '2015': 0.633,
 '2020': 0.562,
 '2025': 0.55,
 '2030': 0.588,
 '2035': 0.633},
{'Index': 63,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20126,
 'Urban Agglomeration': 'Mymensingh',
 'Note': '',
 'Latitude': 24.75,
 'Longitude': 90.4,
 '1950': 0.172,
 '1955': 0.168,
 '1960': 0.159,
 '1965': 0.157,
 '1970': 0.154,
 '1975': 0.165,
 '1980': 0.182,
 '1985': 0.218,
 '1990': 0.265,
 '1995': 0.268,
 '2000': 0.266,
 '2005': 0.262,
 '2010': 0.264,
 '2015': 0.266,
 '2020': 0.271,
 '2025': 0.286,
 '2030': 0.309,
 '2035': 0.333},
{'Index': 64,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20131,
 'Urban Agglomeration': 'Rajshahi',
 'Note': '',
 'Latitude': 24.36667,
 'Longitude': 88.6,
 '1950': 0.103,
 '1955': 0.111,
 '1960': 0.116,
 '1965': 0.136,
 '1970': 0.161,
 '1975': 0.211,
 '1980': 0.293,
 '1985': 0.38,
 '1990': 0.49,
 '1995': 0.51,
 '2000': 0.516,
 '2005': 0.51,
 '2010': 0.516,
 '2015': 0.523,
 '2020': 0.535,
 '2025': 0.565,
 '2030': 0.612,
 '2035': 0.659},
{'Index': 65,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20132,
 'Urban Agglomeration': 'Rangpur',
 'Note': '',
 'Latitude': 25.75,
 'Longitude': 89.25,
 '1950': 0.09,
 '1955': 0.092,
 '1960': 0.091,
 '1965': 0.097,
 '1970': 0.104,
 '1975': 0.125,
 '1980': 0.165,
 '1985': 0.186,
 '1990': 0.204,
 '1995': 0.209,
 '2000': 0.212,
 '2005': 0.214,
 '2010': 0.221,
 '2015': 0.23,
 '2020': 0.24,
 '2025': 0.256,
 '2030': 0.278,
 '2035': 0.3},
{'Index': 66,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 205390,
 'Urban Agglomeration': 'Rupganj',
 'Note': '',
 'Latitude': 23.792554,
 'Longitude': 90.520591,
 '1950': 0.026,
 '1955': 0.029,
 '1960': 0.033,
 '1965': 0.036,
 '1970': 0.039,
 '1975': 0.046,
 '1980': 0.051,
 '1985': 0.057,
 '1990': 0.063,
 '1995': 0.061,
 '2000': 0.057,
 '2005': 0.081,
 '2010': 0.123,
 '2015': 0.187,
 '2020': 0.284,
 '2025': 0.371,
 '2030': 0.418,
 '2035': 0.45},
{'Index': 67,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20136,
 'Urban Agglomeration': 'Sylhet',
 'Note': '',
 'Latitude': 24.89667,
 'Longitude': 91.87167,
 '1950': 0.178,
 '1955': 0.172,
 '1960': 0.16,
 '1965': 0.16,
 '1970': 0.161,
 '1975': 0.186,
 '1980': 0.257,
 '1985': 0.252,
 '1990': 0.235,
 '1995': 0.241,
 '2000': 0.251,
 '2005': 0.29,
 '2010': 0.347,
 '2015': 0.417,
 '2020': 0.502,
 '2025': 0.579,
 '2030': 0.637,
 '2035': 0.687},
{'Index': 68,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20344,
 'Urban Agglomeration': 'Brest',
 'Note': '',
 'Latitude': 52.09755,
 'Longitude': 23.68775,
 '1950': 0.848,
 '1955': 0.903,
 '1960': 0.966,
 '1965': 1.158,
 '1970': 1.385,
 '1975': 1.641,
 '1980': 1.939,
 '1985': 2.254,
 '1990': 2.547,
 '1995': 2.712,
 '2000': 2.917,
 '2005': 3.131,
 '2010': 3.304,
 '2015': 3.548,
 '2020': 3.809,
 '2025': 3.979,
 '2030': 4.082,
 '2035': 4.159},
{'Index': 69,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20345,
 'Urban Agglomeration': 'Gomel',
 'Note': '',
 'Latitude': 52.4345,
 'Longitude': 30.9754,
 '1950': 1.496,
 '1955': 1.847,
 '1960': 2.191,
 '1965': 2.603,
 '1970': 3.083,
 '1975': 3.593,
 '1980': 4.13,
 '1985': 4.55,
 '1990': 4.837,
 '1995': 4.765,
 '2000': 4.803,
 '2005': 5.005,
 '2010': 5.147,
 '2015': 5.522,
 '2020': 5.922,
 '2025': 6.184,
 '2030': 6.343,
 '2035': 6.462},
{'Index': 70,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20346,
 'Urban Agglomeration': 'Grodno',
 'Note': '',
 'Latitude': 53.6884,
 'Longitude': 23.8258,
 '1950': 0.835,
 '1955': 0.89,
 '1960': 0.965,
 '1965': 1.206,
 '1970': 1.5,
 '1975': 1.795,
 '1980': 2.122,
 '1985': 2.413,
 '1990': 2.683,
 '1995': 2.857,
 '2000': 3.073,
 '2005': 3.306,
 '2010': 3.498,
 '2015': 3.792,
 '2020': 4.108,
 '2025': 4.313,
 '2030': 4.428,
 '2035': 4.512},
{'Index': 71,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20348,
 'Urban Agglomeration': 'Minsk',
 'Note': 22.0,
 'Latitude': 53.9,
 'Longitude': 27.56667,
 '1950': 3.67,
 '1955': 5.3,
 '1960': 6.729,
 '1965': 8.391,
 '1970': 10.377,
 '1975': 12.02,
 '1980': 13.699,
 '1985': 14.862,
 '1990': 15.832,
 '1995': 16.306,
 '2000': 17.117,
 '2005': 18.444,
 '2010': 19.529,
 '2015': 20.507,
 '2020': 21.54,
 '2025': 22.241,
 '2030': 22.767,
 '2035': 23.195},
{'Index': 72,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20349,
 'Urban Agglomeration': 'Mogilev',
 'Note': '',
 'Latitude': 53.9141,
 'Longitude': 30.33764,
 '1950': 1.06,
 '1955': 1.325,
 '1960': 1.59,
 '1965': 1.912,
 '1970': 2.292,
 '1975': 2.7,
 '1980': 3.103,
 '1985': 3.327,
 '1990': 3.492,
 '1995': 3.516,
 '2000': 3.613,
 '2005': 3.776,
 '2010': 3.805,
 '2015': 3.961,
 '2020': 4.126,
 '2025': 4.241,
 '2030': 4.338,
 '2035': 4.419},
{'Index': 73,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20355,
 'Urban Agglomeration': 'Vitebsk',
 'Note': '',
 'Latitude': 55.19048,
 'Longitude': 30.2033,
 '1950': 1.357,
 '1955': 1.648,
 '1960': 1.922,
 '1965': 2.245,
 '1970': 2.606,
 '1975': 2.887,
 '1980': 3.154,
 '1985': 3.298,
 '1990': 3.391,
 '1995': 3.383,
 '2000': 3.435,
 '2005': 3.573,
 '2010': 3.695,
 '2015': 3.85,
 '2020': 4.014,
 '2025': 4.128,
 '2030': 4.223,
 '2035': 4.302},
{'Index': 74,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20142,
 'Urban Agglomeration': 'Antwerpen',
 'Note': '',
 'Latitude': 51.21989,
 'Longitude': 4.40346,
 '1950': 8.786,
 '1955': 8.839,
 '1960': 8.869,
 '1965': 8.843,
 '1970': 8.876,
 '1975': 8.883,
 '1980': 8.921,
 '1985': 9.013,
 '1990': 9.069,
 '1995': 9.054,
 '2000': 9.192,
 '2005': 9.184,
 '2010': 9.074,
 '2015': 9.011,
 '2020': 8.971,
 '2025': 9.009,
 '2030': 9.028,
 '2035': 9.044},
{'Index': 75,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20144,
 'Urban Agglomeration': 'Bruxelles-Brussel',
 'Note': 25.0,
 'Latitude': 50.846735,
 'Longitude': 4.349919,
 '1950': 16.378,
 '1955': 16.307,
 '1960': 16.195,
 '1965': 16.145,
 '1970': 16.275,
 '1975': 16.478,
 '1980': 16.757,
 '1985': 16.903,
 '1990': 16.944,
 '1995': 16.836,
 '2000': 17.338,
 '2005': 17.571,
 '2010': 17.61,
 '2015': 17.74,
 '2020': 17.907,
 '2025': 18.119,
 '2030': 18.18,
 '2035': 18.213},
{'Index': 76,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20145,
 'Urban Agglomeration': 'Charleroi',
 'Note': '',
 'Latitude': 50.41136,
 'Longitude': 4.44448,
 '1950': 4.78,
 '1955': 4.668,
 '1960': 4.547,
 '1965': 4.435,
 '1970': 4.369,
 '1975': 4.252,
 '1980': 4.149,
 '1985': 4.069,
 '1990': 3.974,
 '1995': 3.847,
 '2000': 3.852,
 '2005': 3.795,
 '2010': 3.698,
 '2015': 3.622,
 '2020': 3.558,
 '2025': 3.547,
 '2030': 3.55,
 '2035': 3.556},
{'Index': 77,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20146,
 'Urban Agglomeration': 'Gent',
 'Note': '',
 'Latitude': 51.05,
 'Longitude': 3.71667,
 '1950': 4.192,
 '1955': 4.084,
 '1960': 3.97,
 '1965': 3.831,
 '1970': 3.72,
 '1975': 3.722,
 '1980': 3.751,
 '1985': 3.804,
 '1990': 3.843,
 '1995': 3.848,
 '2000': 3.947,
 '2005': 3.985,
 '2010': 3.978,
 '2015': 3.991,
 '2020': 4.014,
 '2025': 4.053,
 '2030': 4.065,
 '2035': 4.073},
{'Index': 78,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20148,
 'Urban Agglomeration': 'Liège',
 'Note': '',
 'Latitude': 50.63373,
 'Longitude': 5.56749,
 '1950': 6.97,
 '1955': 6.884,
 '1960': 6.783,
 '1965': 6.592,
 '1970': 6.43,
 '1975': 6.399,
 '1980': 6.407,
 '1985': 6.374,
 '1990': 6.303,
 '1995': 6.179,
 '2000': 6.212,
 '2005': 6.146,
 '2010': 6.013,
 '2015': 5.913,
 '2020': 5.831,
 '2025': 5.826,
 '2030': 5.833,
 '2035': 5.843}]},
'Percentage Urban in Cities': {'headers': ['Index',
'Country Code',
'Country or area',
'City Code',
'Urban Agglomeration',
'Note',
'Latitude',
'Longitude',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035],
'data': [{'Index': 1,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20001,
 'Urban Agglomeration': 'Herat',
 'Note': '',
 'Latitude': 34.34817,
 'Longitude': 62.19967,
 '1950': 17.73,
 '1955': 14.588,
 '1960': 11.798,
 '1965': 9.419,
 '1970': 7.841,
 '1975': 7.006,
 '1980': 6.789,
 '1985': 7.258,
 '1990': 7.073,
 '1995': 5.603,
 '2000': 5.274,
 '2005': 4.843,
 '2010': 5.246,
 '2015': 5.578,
 '2020': 6.114,
 '2025': 6.433,
 '2030': 6.492,
 '2035': 6.496},
{'Index': 2,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20002,
 'Urban Agglomeration': 'Kabul',
 'Note': '',
 'Latitude': 34.528887,
 'Longitude': 69.17246,
 '1950': 36.718,
 '1955': 37.554,
 '1960': 37.755,
 '1965': 37.467,
 '1970': 36.427,
 '1975': 39.26,
 '1980': 46.144,
 '1985': 55.393,
 '1990': 59.728,
 '1995': 52.161,
 '2000': 54.124,
 '2005': 51.041,
 '2010': 48.106,
 '2015': 44.5,
 '2020': 42.623,
 '2025': 41.667,
 '2030': 41.52,
 '2035': 41.528},
{'Index': 3,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20003,
 'Urban Agglomeration': 'Kandahar',
 'Note': '',
 'Latitude': 31.61332,
 'Longitude': 65.71013,
 '1950': 17.672,
 '1955': 15.274,
 '1960': 12.976,
 '1965': 10.883,
 '1970': 9.816,
 '1975': 8.968,
 '1980': 8.631,
 '1985': 9.227,
 '1990': 8.992,
 '1995': 7.123,
 '2000': 6.705,
 '2005': 5.916,
 '2010': 5.609,
 '2015': 5.219,
 '2020': 5.028,
 '2025': 4.931,
 '2030': 4.916,
 '2035': 4.917},
{'Index': 4,
 'Country Code': 4,
 'Country or area': 'Afghanistan',
 'City Code': 20004,
 'Urban Agglomeration': 'Mazar-e Sharif',
 'Note': '',
 'Latitude': 36.70904,
 'Longitude': 67.11087,
 '1950': 6.45,
 '1955': 6.318,
 '1960': 6.084,
 '1965': 5.782,
 '1970': 5.439,
 '1975': 5.079,
 '1980': 5.001,
 '1985': 5.346,
 '1990': 5.21,
 '1995': 4.128,
 '2000': 3.886,
 '2005': 3.626,
 '2010': 4.147,
 '2015': 4.655,
 '2020': 5.378,
 '2025': 5.823,
 '2030': 5.906,
 '2035': 5.911},
{'Index': 5,
 'Country Code': 8,
 'Country or area': 'Albania',
 'City Code': 20005,
 'Urban Agglomeration': 'Tiranë (Tirana)',
 'Note': '',
 'Latitude': 41.3275,
 'Longitude': 19.81889,
 '1950': 32.592,
 '1955': 28.032,
 '1960': 26.826,
 '1965': 24.53,
 '1970': 22.961,
 '1975': 22.057,
 '1980': 21.392,
 '1985': 20.933,
 '1990': 20.685,
 '1995': 23.82,
 '2000': 25.733,
 '2005': 25.839,
 '2010': 26.645,
 '2015': 26.76,
 '2020': 27.018,
 '2025': 27.488,
 '2030': 27.735,
 '2035': 27.823},
{'Index': 6,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20009,
 'Urban Agglomeration': 'Annaba',
 'Note': '',
 'Latitude': 36.9,
 'Longitude': 7.76667,
 '1950': 5.061,
 '1955': 4.53,
 '1960': 4.005,
 '1965': 3.339,
 '1970': 3.342,
 '1975': 3.471,
 '1980': 3.17,
 '1985': 2.727,
 '1990': 2.318,
 '1995': 2.004,
 '2000': 1.787,
 '2005': 1.598,
 '2010': 1.415,
 '2015': 1.243,
 '2020': 1.121,
 '2025': 1.075,
 '2030': 1.073,
 '2035': 1.075},
{'Index': 7,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20011,
 'Urban Agglomeration': 'Batna',
 'Note': '',
 'Latitude': 35.55597,
 'Longitude': 6.17414,
 '1950': 0.662,
 '1955': 0.805,
 '1960': 0.966,
 '1965': 1.094,
 '1970': 1.232,
 '1975': 1.392,
 '1980': 1.477,
 '1985': 1.523,
 '1990': 1.464,
 '1995': 1.388,
 '2000': 1.335,
 '2005': 1.258,
 '2010': 1.174,
 '2015': 1.086,
 '2020': 1.031,
 '2025': 1.016,
 '2030': 1.019,
 '2035': 1.021},
{'Index': 8,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20015,
 'Urban Agglomeration': 'Blida',
 'Note': '',
 'Latitude': 36.480781,
 'Longitude': 2.831943,
 '1950': 1.724,
 '1955': 1.789,
 '1960': 1.835,
 '1965': 1.773,
 '1970': 1.818,
 '1975': 1.892,
 '1980': 1.744,
 '1985': 1.519,
 '1990': 1.414,
 '1995': 1.395,
 '2000': 1.416,
 '2005': 1.44,
 '2010': 1.451,
 '2015': 1.449,
 '2020': 1.48,
 '2025': 1.518,
 '2030': 1.533,
 '2035': 1.537},
{'Index': 9,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20006,
 'Urban Agglomeration': 'El Djazaïr  (Algiers)',
 'Note': 1.0,
 'Latitude': 36.7525,
 'Longitude': 3.04197,
 '1950': 26.205,
 '1955': 24.234,
 '1960': 25.68,
 '1965': 22.751,
 '1970': 22.291,
 '1975': 22.358,
 '1980': 19.257,
 '1985': 15.45,
 '1990': 13.315,
 '1995': 12.19,
 '2000': 11.456,
 '2005': 10.738,
 '2010': 9.97,
 '2015': 9.177,
 '2020': 8.662,
 '2025': 8.512,
 '2030': 8.536,
 '2035': 8.551},
{'Index': 10,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20020,
 'Urban Agglomeration': 'El Djelfa',
 'Note': '',
 'Latitude': 34.67279,
 'Longitude': 3.263,
 '1950': 0.53,
 '1955': 0.54,
 '1960': 0.544,
 '1965': 0.516,
 '1970': 0.567,
 '1975': 0.642,
 '1980': 0.683,
 '1985': 0.706,
 '1990': 0.75,
 '1995': 0.829,
 '2000': 0.944,
 '2005': 1.08,
 '2010': 1.225,
 '2015': 1.376,
 '2020': 1.576,
 '2025': 1.72,
 '2030': 1.756,
 '2035': 1.761},
{'Index': 11,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20019,
 'Urban Agglomeration': 'Qacentina',
 'Note': '',
 'Latitude': 36.354921,
 'Longitude': 6.607293,
 '1950': 4.465,
 '1955': 4.742,
 '1960': 4.973,
 '1965': 4.918,
 '1970': 4.883,
 '1975': 4.874,
 '1980': 4.463,
 '1985': 3.929,
 '1990': 3.362,
 '1995': 2.901,
 '2000': 2.529,
 '2005': 2.149,
 '2010': 1.809,
 '2015': 1.51,
 '2020': 1.296,
 '2025': 1.209,
 '2030': 1.202,
 '2035': 1.203},
{'Index': 12,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20037,
 'Urban Agglomeration': 'Sétif',
 'Note': '',
 'Latitude': 36.19112,
 'Longitude': 5.41373,
 '1950': 2.095,
 '1955': 2.044,
 '1960': 1.969,
 '1965': 1.789,
 '1970': 1.785,
 '1975': 1.818,
 '1980': 1.688,
 '1985': 1.501,
 '1990': 1.344,
 '1995': 1.235,
 '2000': 1.175,
 '2005': 1.129,
 '2010': 1.075,
 '2015': 1.014,
 '2020': 0.981,
 '2025': 0.977,
 '2030': 0.982,
 '2035': 0.983},
{'Index': 13,
 'Country Code': 12,
 'Country or area': 'Algeria',
 'City Code': 20035,
 'Urban Agglomeration': 'Wahran (Oran)',
 'Note': '',
 'Latitude': 35.69111,
 'Longitude': -0.64167,
 '1950': 13.646,
 '1955': 11.141,
 '1960': 8.984,
 '1965': 6.831,
 '1970': 6.702,
 '1975': 6.913,
 '1980': 6.372,
 '1985': 5.577,
 '1990': 4.875,
 '1995': 4.357,
 '2000': 4.007,
 '2005': 3.687,
 '2010': 3.36,
 '2015': 3.036,
 '2020': 2.814,
 '2025': 2.739,
 '2030': 2.741,
 '2035': 2.746},
{'Index': 14,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000001,
 'Urban Agglomeration': 'Benguela',
 'Note': 2.0,
 'Latitude': -12.576,
 'Longitude': 13.405,
 '1950': 4.169,
 '1955': 3.971,
 '1960': 3.867,
 '1965': 3.876,
 '1970': 3.938,
 '1975': 4.514,
 '1980': 5.197,
 '1985': 5.231,
 '1990': 4.578,
 '1995': 4.038,
 '2000': 3.8,
 '2005': 3.514,
 '2010': 3.386,
 '2015': 3.29,
 '2020': 3.26,
 '2025': 3.27,
 '2030': 3.285,
 '2035': 3.292},
{'Index': 15,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204043,
 'Urban Agglomeration': 'Cabinda',
 'Note': 3.0,
 'Latitude': -5.55,
 'Longitude': 12.2,
 '1950': 1.371,
 '1955': 1.024,
 '1960': 0.782,
 '1965': 1.181,
 '1970': 1.943,
 '1975': 2.201,
 '1980': 2.383,
 '1985': 2.567,
 '1990': 2.921,
 '1995': 3.102,
 '2000': 3.13,
 '2005': 3.104,
 '2010': 3.208,
 '2015': 3.344,
 '2020': 3.545,
 '2025': 3.69,
 '2030': 3.73,
 '2035': 3.739},
{'Index': 16,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000011,
 'Urban Agglomeration': 'Cuito',
 'Note': '',
 'Latitude': -12.383,
 'Longitude': 16.933,
 '1950': 2.505,
 '1955': 2.297,
 '1960': 2.153,
 '1965': 1.98,
 '1970': 1.836,
 '1975': 1.752,
 '1980': 1.663,
 '1985': 1.571,
 '1990': 1.568,
 '1995': 1.576,
 '2000': 1.691,
 '2005': 1.783,
 '2010': 1.958,
 '2015': 2.17,
 '2020': 2.441,
 '2025': 2.623,
 '2030': 2.667,
 '2035': 2.674},
{'Index': 17,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20050,
 'Urban Agglomeration': 'Huambo',
 'Note': 4.0,
 'Latitude': -12.77611,
 'Longitude': 15.73917,
 '1950': 4.442,
 '1955': 5.23,
 '1960': 6.295,
 '1965': 6.172,
 '1970': 5.976,
 '1975': 6.475,
 '1980': 7.043,
 '1985': 7.223,
 '1990': 7.219,
 '1995': 6.593,
 '2000': 5.55,
 '2005': 4.591,
 '2010': 3.958,
 '2015': 3.441,
 '2020': 3.061,
 '2025': 2.895,
 '2030': 2.879,
 '2035': 2.884},
{'Index': 18,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000000,
 'Urban Agglomeration': 'Lobito',
 'Note': 5.0,
 'Latitude': -12.364,
 'Longitude': 13.536,
 '1950': 6.683,
 '1955': 7.328,
 '1960': 8.215,
 '1965': 6.99,
 '1970': 5.828,
 '1975': 5.661,
 '1980': 5.543,
 '1985': 4.931,
 '1990': 4.041,
 '1995': 3.337,
 '2000': 2.941,
 '2005': 2.546,
 '2010': 2.297,
 '2015': 2.09,
 '2020': 1.943,
 '2025': 1.883,
 '2030': 1.88,
 '2035': 1.884},
{'Index': 19,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 20049,
 'Urban Agglomeration': 'Luanda',
 'Note': 6.0,
 'Latitude': -8.83682,
 'Longitude': 13.23432,
 '1950': 40.173,
 '1955': 38.265,
 '1960': 37.264,
 '1965': 40.624,
 '1970': 45.309,
 '1975': 40.728,
 '1980': 35.549,
 '1985': 32.147,
 '1990': 32.6,
 '1995': 32.786,
 '2000': 34.352,
 '2005': 35.363,
 '2010': 37.939,
 '2015': 39.734,
 '2020': 37.972,
 '2025': 37.351,
 '2030': 37.392,
 '2035': 37.463},
{'Index': 20,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 204044,
 'Urban Agglomeration': 'Lubango',
 'Note': 7.0,
 'Latitude': -14.91717,
 'Longitude': 13.4925,
 '1950': 3.354,
 '1955': 2.874,
 '1960': 2.519,
 '1965': 2.712,
 '1970': 3.02,
 '1975': 3.125,
 '1980': 3.185,
 '1985': 3.231,
 '1990': 3.462,
 '1995': 3.526,
 '2000': 3.512,
 '2005': 3.437,
 '2010': 3.506,
 '2015': 3.606,
 '2020': 3.776,
 '2025': 3.903,
 '2030': 3.941,
 '2035': 3.95},
{'Index': 21,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000004,
 'Urban Agglomeration': 'Malanje',
 'Note': 8.0,
 'Latitude': -9.54,
 'Longitude': 16.341,
 '1950': 2.663,
 '1955': 2.849,
 '1960': 3.117,
 '1965': 3.083,
 '1970': 3.046,
 '1975': 2.844,
 '1980': 2.621,
 '1985': 2.403,
 '1990': 2.328,
 '1995': 2.272,
 '2000': 2.365,
 '2005': 2.42,
 '2010': 2.58,
 '2015': 2.774,
 '2020': 3.032,
 '2025': 3.208,
 '2030': 3.253,
 '2035': 3.261},
{'Index': 22,
 'Country Code': 24,
 'Country or area': 'Angola',
 'City Code': 895000012,
 'Urban Agglomeration': 'Uige',
 'Note': '',
 'Latitude': -7.1069,
 'Longitude': 15.4406,
 '1950': 0.929,
 '1955': 0.97,
 '1960': 1.036,
 '1965': 1.086,
 '1970': 1.147,
 '1975': 1.15,
 '1980': 1.138,
 '1985': 1.121,
 '1990': 1.166,
 '1995': 1.222,
 '2000': 1.367,
 '2005': 1.503,
 '2010': 1.721,
 '2015': 1.987,
 '2020': 2.328,
 '2025': 2.558,
 '2030': 2.61,
 '2035': 2.617},
{'Index': 23,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20057,
 'Urban Agglomeration': 'Bahia Blanca',
 'Note': '',
 'Latitude': -38.7196,
 'Longitude': -62.27243,
 '1950': 1.033,
 '1955': 0.918,
 '1960': 0.833,
 '1965': 0.885,
 '1970': 0.955,
 '1975': 0.951,
 '1980': 0.955,
 '1985': 0.918,
 '1990': 0.887,
 '1995': 0.848,
 '2000': 0.817,
 '2005': 0.803,
 '2010': 0.799,
 '2015': 0.774,
 '2020': 0.753,
 '2025': 0.744,
 '2030': 0.743,
 '2035': 0.743},
{'Index': 24,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20058,
 'Urban Agglomeration': 'Buenos Aires',
 'Note': 9.0,
 'Latitude': -34.605083,
 'Longitude': -58.400368,
 '1950': 46.102,
 '1955': 44.839,
 '1960': 44.55,
 '1965': 44.357,
 '1970': 44.507,
 '1975': 43.32,
 '1980': 42.581,
 '1985': 40.722,
 '1990': 39.156,
 '1995': 38.267,
 '2000': 37.852,
 '2005': 37.822,
 '2010': 38.038,
 '2015': 37.015,
 '2020': 36.149,
 '2025': 35.792,
 '2030': 35.779,
 '2035': 35.793},
{'Index': 25,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20059,
 'Urban Agglomeration': 'Córdoba',
 'Note': 10.0,
 'Latitude': -31.4135,
 'Longitude': -64.18105,
 '1950': 3.831,
 '1955': 3.867,
 '1960': 3.988,
 '1965': 4.117,
 '1970': 4.282,
 '1975': 4.288,
 '1980': 4.333,
 '1985': 4.263,
 '1990': 4.216,
 '1995': 4.133,
 '2000': 4.079,
 '2005': 3.989,
 '2010': 3.896,
 '2015': 3.811,
 '2020': 3.75,
 '2025': 3.728,
 '2030': 3.729,
 '2035': 3.731},
{'Index': 26,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20063,
 'Urban Agglomeration': 'Corrientes',
 'Note': 11.0,
 'Latitude': -27.4806,
 'Longitude': -58.8341,
 '1950': 0.573,
 '1955': 0.597,
 '1960': 0.636,
 '1965': 0.673,
 '1970': 0.718,
 '1975': 0.739,
 '1980': 0.769,
 '1985': 0.819,
 '1990': 0.879,
 '1995': 0.906,
 '2000': 0.933,
 '2005': 0.944,
 '2010': 0.951,
 '2015': 0.959,
 '2020': 0.973,
 '2025': 0.983,
 '2030': 0.986,
 '2035': 0.986},
{'Index': 27,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20065,
 'Urban Agglomeration': 'La Plata',
 'Note': 12.0,
 'Latitude': -34.92145,
 'Longitude': -57.95453,
 '1950': 2.673,
 '1955': 2.63,
 '1960': 2.643,
 '1965': 2.592,
 '1970': 2.558,
 '1975': 2.472,
 '1980': 2.413,
 '1985': 2.311,
 '1990': 2.226,
 '1995': 2.127,
 '2000': 2.047,
 '2005': 2.053,
 '2010': 2.097,
 '2015': 2.099,
 '2020': 2.109,
 '2025': 2.12,
 '2030': 2.125,
 '2035': 2.126},
{'Index': 28,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20067,
 'Urban Agglomeration': 'Mar Del Plata',
 'Note': '',
 'Latitude': -38.00228,
 'Longitude': -57.55754,
 '1950': 1.182,
 '1955': 1.262,
 '1960': 1.377,
 '1965': 1.472,
 '1970': 1.584,
 '1975': 1.663,
 '1980': 1.763,
 '1985': 1.774,
 '1990': 1.792,
 '1995': 1.712,
 '2000': 1.631,
 '2005': 1.61,
 '2010': 1.616,
 '2015': 1.599,
 '2020': 1.588,
 '2025': 1.587,
 '2030': 1.589,
 '2035': 1.59},
{'Index': 29,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20068,
 'Urban Agglomeration': 'Mendoza',
 'Note': 13.0,
 'Latitude': -32.89084,
 'Longitude': -68.82717,
 '1950': 2.193,
 '1955': 2.155,
 '1960': 2.163,
 '1965': 2.315,
 '1970': 2.504,
 '1975': 2.546,
 '1980': 2.61,
 '1985': 2.63,
 '1990': 2.665,
 '1995': 2.6,
 '2000': 2.538,
 '2005': 2.563,
 '2010': 2.629,
 '2015': 2.706,
 '2020': 2.797,
 '2025': 2.857,
 '2030': 2.871,
 '2035': 2.873},
{'Index': 30,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20070,
 'Urban Agglomeration': 'Neuquén-Plottier-Cipolletti',
 'Note': '',
 'Latitude': -38.95143,
 'Longitude': -68.064809,
 '1950': 0.124,
 '1955': 0.171,
 '1960': 0.241,
 '1965': 0.295,
 '1970': 0.362,
 '1975': 0.456,
 '1980': 0.582,
 '1985': 0.688,
 '1990': 0.816,
 '1995': 0.847,
 '2000': 0.861,
 '2005': 0.881,
 '2010': 0.906,
 '2015': 0.938,
 '2020': 0.975,
 '2025': 0.998,
 '2030': 1.004,
 '2035': 1.005},
{'Index': 31,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20072,
 'Urban Agglomeration': 'Posadas',
 'Note': '',
 'Latitude': -27.36708,
 'Longitude': -55.89608,
 '1950': 0.407,
 '1955': 0.438,
 '1960': 0.482,
 '1965': 0.496,
 '1970': 0.512,
 '1975': 0.555,
 '1980': 0.61,
 '1985': 0.66,
 '1990': 0.719,
 '1995': 0.765,
 '2000': 0.817,
 '2005': 0.838,
 '2010': 0.849,
 '2015': 0.885,
 '2020': 0.927,
 '2025': 0.954,
 '2030': 0.96,
 '2035': 0.961},
{'Index': 32,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20073,
 'Urban Agglomeration': 'Resistencia',
 'Note': 14.0,
 'Latitude': -27.46056,
 'Longitude': -58.98389,
 '1950': 0.648,
 '1955': 0.661,
 '1960': 0.689,
 '1965': 0.716,
 '1970': 0.75,
 '1975': 0.83,
 '1980': 0.932,
 '1985': 0.964,
 '1990': 0.999,
 '1995': 1.025,
 '2000': 1.059,
 '2005': 1.05,
 '2010': 1.027,
 '2015': 1.026,
 '2020': 1.031,
 '2025': 1.037,
 '2030': 1.039,
 '2035': 1.04},
{'Index': 33,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20075,
 'Urban Agglomeration': 'Rosario',
 'Note': 15.0,
 'Latitude': -32.94682,
 'Longitude': -60.63932,
 '1950': 4.948,
 '1955': 4.629,
 '1960': 4.423,
 '1965': 4.35,
 '1970': 4.316,
 '1975': 4.182,
 '1980': 4.093,
 '1985': 3.935,
 '1990': 3.807,
 '1995': 3.634,
 '2000': 3.489,
 '2005': 3.478,
 '2010': 3.526,
 '2015': 3.582,
 '2020': 3.655,
 '2025': 3.706,
 '2030': 3.72,
 '2035': 3.722},
{'Index': 34,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20076,
 'Urban Agglomeration': 'Salta',
 'Note': '',
 'Latitude': -24.7859,
 'Longitude': -65.41166,
 '1950': 0.689,
 '1955': 0.721,
 '1960': 0.77,
 '1965': 0.839,
 '1970': 0.923,
 '1975': 1.005,
 '1980': 1.106,
 '1985': 1.175,
 '1990': 1.254,
 '1995': 1.32,
 '2000': 1.398,
 '2005': 1.455,
 '2010': 1.509,
 '2015': 1.567,
 '2020': 1.633,
 '2025': 1.676,
 '2030': 1.686,
 '2035': 1.687},
{'Index': 35,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20078,
 'Urban Agglomeration': 'San Juan',
 'Note': 16.0,
 'Latitude': -31.5375,
 'Longitude': -68.53639,
 '1950': 0.965,
 '1955': 0.963,
 '1960': 0.983,
 '1965': 1.064,
 '1970': 1.166,
 '1975': 1.198,
 '1980': 1.242,
 '1985': 1.248,
 '1990': 1.26,
 '1995': 1.253,
 '2000': 1.253,
 '2005': 1.28,
 '2010': 1.322,
 '2015': 1.3,
 '2020': 1.281,
 '2025': 1.274,
 '2030': 1.275,
 '2035': 1.275},
{'Index': 36,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20081,
 'Urban Agglomeration': 'San Miguel de Tucumán',
 'Note': 17.0,
 'Latitude': -26.82414,
 'Longitude': -65.2226,
 '1950': 1.997,
 '1955': 1.969,
 '1960': 1.984,
 '1965': 1.95,
 '1970': 1.928,
 '1975': 2.008,
 '1980': 2.12,
 '1985': 2.129,
 '1990': 2.146,
 '1995': 2.157,
 '2000': 2.186,
 '2005': 2.217,
 '2010': 2.255,
 '2015': 2.297,
 '2020': 2.351,
 '2025': 2.388,
 '2030': 2.398,
 '2035': 2.399},
{'Index': 37,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20084,
 'Urban Agglomeration': 'San Salvador de Jujuy',
 'Note': 18.0,
 'Latitude': -24.19456,
 'Longitude': -65.29712,
 '1950': 0.302,
 '1955': 0.293,
 '1960': 0.289,
 '1965': 0.35,
 '1970': 0.43,
 '1975': 0.477,
 '1980': 0.532,
 '1985': 0.574,
 '1990': 0.622,
 '1995': 0.699,
 '2000': 0.797,
 '2005': 0.831,
 '2010': 0.839,
 '2015': 0.848,
 '2020': 0.861,
 '2025': 0.871,
 '2030': 0.874,
 '2035': 0.875},
{'Index': 38,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20085,
 'Urban Agglomeration': 'Santa Fe',
 'Note': 19.0,
 'Latitude': -31.632717,
 'Longitude': -60.698281,
 '1950': 1.912,
 '1955': 1.81,
 '1960': 1.751,
 '1965': 1.695,
 '1970': 1.654,
 '1975': 1.646,
 '1980': 1.658,
 '1985': 1.518,
 '1990': 1.39,
 '1995': 1.36,
 '2000': 1.361,
 '2005': 1.343,
 '2010': 1.32,
 '2015': 1.327,
 '2020': 1.343,
 '2025': 1.355,
 '2030': 1.359,
 '2035': 1.36},
{'Index': 39,
 'Country Code': 32,
 'Country or area': 'Argentina',
 'City Code': 20086,
 'Urban Agglomeration': 'Santiago Del Estero',
 'Note': 20.0,
 'Latitude': -27.79511,
 'Longitude': -64.26149,
 '1950': 0.738,
 '1955': 0.702,
 '1960': 0.682,
 '1965': 0.703,
 '1970': 0.733,
 '1975': 0.78,
 '1980': 0.842,
 '1985': 0.872,
 '1990': 0.907,
 '1995': 0.932,
 '2000': 0.965,
 '2005': 0.983,
 '2010': 0.999,
 '2015': 1.017,
 '2020': 1.039,
 '2025': 1.055,
 '2030': 1.059,
 '2035': 1.059},
{'Index': 40,
 'Country Code': 51,
 'Country or area': 'Armenia',
 'City Code': 20140,
 'Urban Agglomeration': 'Yerevan',
 'Note': '',
 'Latitude': 40.181998,
 'Longitude': 44.514619,
 '1950': 62.535,
 '1955': 60.059,
 '1960': 55.961,
 '1965': 52.66,
 '1970': 51.479,
 '1975': 50.567,
 '1980': 50.874,
 '1985': 50.17,
 '1990': 49.237,
 '1995': 53.756,
 '2000': 55.985,
 '2005': 57.033,
 '2010': 58.377,
 '2015': 58.216,
 '2020': 58.385,
 '2025': 58.456,
 '2030': 58.449,
 '2035': 58.427},
{'Index': 41,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206171,
 'Urban Agglomeration': 'Adelaide',
 'Note': 21.0,
 'Latitude': -34.92866,
 'Longitude': 138.59863,
 '1950': 6.817,
 '1955': 6.803,
 '1960': 6.816,
 '1965': 7.382,
 '1970': 7.88,
 '1975': 7.918,
 '1980': 7.754,
 '1985': 7.605,
 '1990': 7.429,
 '1995': 7.244,
 '2000': 6.984,
 '2005': 6.746,
 '2010': 6.483,
 '2015': 6.294,
 '2020': 6.101,
 '2025': 5.969,
 '2030': 5.948,
 '2035': 5.948},
{'Index': 42,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206170,
 'Urban Agglomeration': 'Brisbane',
 'Note': 21.0,
 'Latitude': -27.46794,
 'Longitude': 153.02809,
 '1950': 7.015,
 '1955': 7.085,
 '1960': 7.188,
 '1965': 7.4,
 '1970': 8.386,
 '1975': 8.845,
 '1980': 9.055,
 '1985': 9.228,
 '1990': 9.487,
 '1995': 9.966,
 '2000': 10.034,
 '2005': 10.431,
 '2010': 10.661,
 '2015': 10.849,
 '2020': 10.985,
 '2025': 11.005,
 '2030': 11.011,
 '2035': 11.013},
{'Index': 43,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206175,
 'Urban Agglomeration': 'Canberra',
 'Note': 21.0,
 'Latitude': -35.28346,
 'Longitude': 149.12807,
 '1950': 0.316,
 '1955': 0.429,
 '1960': 0.61,
 '1965': 0.894,
 '1970': 1.273,
 '1975': 1.662,
 '1980': 1.778,
 '1985': 1.869,
 '1990': 1.939,
 '1995': 1.989,
 '2000': 2.14,
 '2005': 2.14,
 '2010': 2.111,
 '2015': 2.103,
 '2020': 2.088,
 '2025': 2.07,
 '2030': 2.067,
 '2035': 2.067},
{'Index': 44,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 895000015,
 'Urban Agglomeration': 'Central Coast',
 'Note': 21.0,
 'Latitude': -33.42,
 'Longitude': 151.39583,
 '1950': 1.14,
 '1955': 1.125,
 '1960': 1.123,
 '1965': 1.143,
 '1970': 1.145,
 '1975': 1.207,
 '1980': 1.294,
 '1985': 1.38,
 '1990': 1.461,
 '1995': 1.588,
 '2000': 1.738,
 '2005': 1.715,
 '2010': 1.65,
 '2015': 1.591,
 '2020': 1.529,
 '2025': 1.489,
 '2030': 1.482,
 '2035': 1.482},
{'Index': 45,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20093,
 'Urban Agglomeration': 'Gold Coast-Tweed Head',
 'Note': 21.0,
 'Latitude': -28.00029,
 'Longitude': 153.43088,
 '1950': 0.461,
 '1955': 0.519,
 '1960': 0.59,
 '1965': 0.685,
 '1970': 0.782,
 '1975': 0.939,
 '1980': 1.148,
 '1985': 1.399,
 '1990': 1.697,
 '1995': 2.047,
 '2000': 2.554,
 '2005': 2.884,
 '2010': 3.004,
 '2015': 3.105,
 '2020': 3.192,
 '2025': 3.225,
 '2030': 3.231,
 '2035': 3.232},
{'Index': 46,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206168,
 'Urban Agglomeration': 'Melbourne',
 'Note': 21.0,
 'Latitude': -37.814,
 'Longitude': 144.96332,
 '1950': 21.153,
 '1955': 21.539,
 '1960': 22.067,
 '1965': 21.906,
 '1970': 23.166,
 '1975': 23.296,
 '1980': 22.653,
 '1985': 22.052,
 '1990': 21.666,
 '1995': 21.389,
 '2000': 20.926,
 '2005': 20.869,
 '2010': 20.869,
 '2015': 21.719,
 '2020': 22.68,
 '2025': 23.106,
 '2030': 23.186,
 '2035': 23.192},
{'Index': 47,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206177,
 'Urban Agglomeration': 'Newcastle-Maitland',
 'Note': 21.0,
 'Latitude': -32.924878,
 'Longitude': 151.740852,
 '1950': 2.555,
 '1955': 2.493,
 '1960': 2.432,
 '1965': 2.423,
 '1970': 2.29,
 '1975': 2.221,
 '1980': 2.316,
 '1985': 2.207,
 '1990': 2.117,
 '1995': 2.067,
 '2000': 2.276,
 '2005': 2.274,
 '2010': 2.18,
 '2015': 2.118,
 '2020': 2.056,
 '2025': 2.013,
 '2030': 2.006,
 '2035': 2.006},
{'Index': 48,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206172,
 'Urban Agglomeration': 'Perth',
 'Note': 21.0,
 'Latitude': -31.947841,
 'Longitude': 115.852514,
 '1950': 4.935,
 '1955': 4.899,
 '1960': 4.877,
 '1965': 5.116,
 '1970': 6.376,
 '1975': 7.031,
 '1980': 7.354,
 '1985': 7.783,
 '1990': 8.206,
 '1995': 8.595,
 '2000': 8.76,
 '2005': 8.825,
 '2010': 9.141,
 '2015': 9.287,
 '2020': 9.322,
 '2025': 9.296,
 '2030': 9.293,
 '2035': 9.294},
{'Index': 49,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20098,
 'Urban Agglomeration': 'Sunshine Coast',
 'Note': 21.0,
 'Latitude': -26.66008,
 'Longitude': 153.09953,
 '1950': 0.157,
 '1955': 0.194,
 '1960': 0.242,
 '1965': 0.308,
 '1970': 0.387,
 '1975': 0.51,
 '1980': 0.685,
 '1985': 0.826,
 '1990': 1.039,
 '1995': 1.292,
 '2000': 1.322,
 '2005': 1.422,
 '2010': 1.459,
 '2015': 1.519,
 '2020': 1.583,
 '2025': 1.612,
 '2030': 1.617,
 '2035': 1.618},
{'Index': 50,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 206167,
 'Urban Agglomeration': 'Sydney',
 'Note': 21.0,
 'Latitude': -33.86785,
 'Longitude': 151.20732,
 '1950': 26.838,
 '1955': 26.075,
 '1960': 25.446,
 '1965': 25.322,
 '1970': 26.812,
 '1975': 26.586,
 '1980': 25.949,
 '1985': 25.498,
 '1990': 24.946,
 '1995': 24.886,
 '2000': 23.535,
 '2005': 22.635,
 '2010': 22.108,
 '2015': 22.28,
 '2020': 22.489,
 '2025': 22.493,
 '2030': 22.498,
 '2035': 22.502},
{'Index': 51,
 'Country Code': 36,
 'Country or area': 'Australia',
 'City Code': 20101,
 'Urban Agglomeration': 'Wollongong',
 'Note': 21.0,
 'Latitude': -34.424,
 'Longitude': 150.89345,
 '1950': 1.167,
 '1955': 1.311,
 '1960': 1.49,
 '1965': 1.654,
 '1970': 1.68,
 '1975': 1.755,
 '1980': 1.813,
 '1985': 1.728,
 '1990': 1.665,
 '1995': 1.652,
 '2000': 1.617,
 '2005': 1.547,
 '2010': 1.478,
 '2015': 1.436,
 '2020': 1.394,
 '2025': 1.365,
 '2030': 1.36,
 '2035': 1.36},
{'Index': 52,
 'Country Code': 40,
 'Country or area': 'Austria',
 'City Code': 20107,
 'Urban Agglomeration': 'Wien (Vienna)',
 'Note': '',
 'Latitude': 48.206443,
 'Longitude': 16.370725,
 '1950': 36.612,
 '1955': 36.332,
 '1960': 35.548,
 '1965': 34.202,
 '1970': 33.039,
 '1975': 31.713,
 '1980': 30.923,
 '1985': 31.345,
 '1990': 31.649,
 '1995': 31.374,
 '2000': 31.886,
 '2005': 33.805,
 '2010': 35.852,
 '2015': 36.634,
 '2020': 37.407,
 '2025': 37.57,
 '2030': 37.596,
 '2035': 37.602},
{'Index': 53,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20053,
 'Urban Agglomeration': 'Baku',
 'Note': 22.0,
 'Latitude': 40.37767,
 'Longitude': 49.89201,
 '1950': 67.032,
 '1955': 56.41,
 '1960': 49.004,
 '1965': 48.176,
 '1970': 49.193,
 '1975': 48.531,
 '1980': 48.497,
 '1985': 46.557,
 '1990': 44.528,
 '1995': 43.494,
 '2000': 43.268,
 '2005': 41.743,
 '2010': 42.743,
 '2015': 41.928,
 '2020': 41.107,
 '2025': 40.917,
 '2030': 40.963,
 '2035': 40.984},
{'Index': 54,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20054,
 'Urban Agglomeration': 'Gäncä',
 'Note': '',
 'Latitude': 40.68278,
 'Longitude': 46.36056,
 '1950': 8.08,
 '1955': 6.764,
 '1960': 6.037,
 '1965': 6.595,
 '1970': 7.41,
 '1975': 7.283,
 '1980': 7.331,
 '1985': 7.28,
 '1990': 7.178,
 '1995': 7.166,
 '2000': 7.196,
 '2005': 6.838,
 '2010': 6.537,
 '2015': 6.225,
 '2020': 5.985,
 '2025': 5.895,
 '2030': 5.891,
 '2035': 5.893},
{'Index': 55,
 'Country Code': 31,
 'Country or area': 'Azerbaijan',
 'City Code': 20056,
 'Urban Agglomeration': 'Sumquayit',
 'Note': '',
 'Latitude': 40.58972,
 'Longitude': 49.66861,
 '1950': 1.512,
 '1955': 2.111,
 '1960': 2.844,
 '1965': 3.686,
 '1970': 4.892,
 '1975': 5.455,
 '1980': 6.021,
 '1985': 6.036,
 '1990': 6.102,
 '1995': 6.483,
 '2000': 6.845,
 '2005': 6.61,
 '2010': 6.489,
 '2015': 6.324,
 '2020': 6.216,
 '2025': 6.197,
 '2030': 6.205,
 '2035': 6.208},
{'Index': 56,
 'Country Code': 48,
 'Country or area': 'Bahrain',
 'City Code': 20109,
 'Urban Agglomeration': 'Al-Manamah (Manama)',
 'Note': 23.0,
 'Latitude': 26.21536,
 'Longitude': 50.5832,
 '1950': 54.105,
 '1955': 50.832,
 '1960': 48.529,
 '1965': 51.54,
 '1970': 49.442,
 '1975': 43.928,
 '1980': 36.423,
 '1985': 32.798,
 '1990': 28.797,
 '1995': 26.76,
 '2000': 24.127,
 '2005': 25.231,
 '2010': 26.565,
 '2015': 36.114,
 '2020': 41.755,
 '2025': 44.266,
 '2030': 44.73,
 '2035': 44.811},
{'Index': 57,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20110,
 'Urban Agglomeration': 'Barisal',
 'Note': '',
 'Latitude': 22.70194,
 'Longitude': 90.37111,
 '1950': 4.384,
 '1955': 3.902,
 '1960': 3.371,
 '1965': 2.723,
 '1970': 2.176,
 '1975': 1.83,
 '1980': 1.445,
 '1985': 1.208,
 '1990': 1.024,
 '1995': 0.898,
 '2000': 0.797,
 '2005': 0.755,
 '2010': 0.742,
 '2015': 0.738,
 '2020': 0.746,
 '2025': 0.755,
 '2030': 0.76,
 '2035': 0.762},
{'Index': 58,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20112,
 'Urban Agglomeration': 'Bogra',
 'Note': '',
 'Latitude': 24.85,
 'Longitude': 89.36667,
 '1950': 2.082,
 '1955': 1.979,
 '1960': 1.827,
 '1965': 1.484,
 '1970': 1.184,
 '1975': 0.995,
 '1980': 0.79,
 '1985': 0.782,
 '1990': 0.807,
 '1995': 0.759,
 '2000': 0.709,
 '2005': 0.772,
 '2010': 0.883,
 '2015': 1.021,
 '2020': 1.196,
 '2025': 1.311,
 '2030': 1.337,
 '2035': 1.341},
{'Index': 59,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20115,
 'Urban Agglomeration': 'Chittagong',
 'Note': '',
 'Latitude': 22.33306,
 'Longitude': 91.83639,
 '1950': 17.801,
 '1955': 16.357,
 '1960': 14.541,
 '1965': 14.493,
 '1970': 14.645,
 '1975': 14.498,
 '1980': 11.074,
 '1985': 10.147,
 '1990': 9.615,
 '1995': 10.012,
 '2000': 10.659,
 '2005': 9.666,
 '2010': 8.859,
 '2015': 8.202,
 '2020': 7.745,
 '2025': 7.554,
 '2030': 7.548,
 '2035': 7.567},
{'Index': 60,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20117,
 'Urban Agglomeration': 'Comilla',
 'Note': '',
 'Latitude': 23.45778,
 'Longitude': 91.20444,
 '1950': 4.84,
 '1955': 4.262,
 '1960': 3.643,
 '1965': 3.063,
 '1970': 2.565,
 '1975': 2.243,
 '1980': 1.801,
 '1985': 1.435,
 '1990': 1.147,
 '1995': 1.026,
 '2000': 0.942,
 '2005': 0.9,
 '2010': 0.891,
 '2015': 0.892,
 '2020': 0.908,
 '2025': 0.923,
 '2030': 0.929,
 '2035': 0.932},
{'Index': 61,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20119,
 'Urban Agglomeration': 'Dhaka',
 'Note': 24.0,
 'Latitude': 23.7104,
 'Longitude': 90.40744,
 '1950': 20.692,
 '1955': 20.708,
 '1960': 20.522,
 '1965': 23.668,
 '1970': 27.814,
 '1975': 31.668,
 '1980': 26.991,
 '1985': 28.581,
 '1990': 31.471,
 '1995': 32.357,
 '2000': 33.134,
 '2005': 32.067,
 '2010': 31.783,
 '2015': 31.818,
 '2020': 32.409,
 '2025': 32.942,
 '2030': 33.152,
 '2035': 33.242},
{'Index': 62,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20124,
 'Urban Agglomeration': 'Khulna',
 'Note': '',
 'Latitude': 22.80978,
 'Longitude': 89.56439,
 '1950': 3.775,
 '1955': 4.393,
 '1960': 4.963,
 '1965': 5.586,
 '1970': 6.274,
 '1975': 6.728,
 '1980': 5.185,
 '1985': 4.843,
 '1990': 4.684,
 '1995': 4.339,
 '2000': 4.018,
 '2005': 3.075,
 '2010': 2.369,
 '2015': 1.844,
 '2020': 1.471,
 '2025': 1.31,
 '2030': 1.288,
 '2035': 1.29},
{'Index': 63,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20126,
 'Urban Agglomeration': 'Mymensingh',
 'Note': '',
 'Latitude': 24.75,
 'Longitude': 90.4,
 '1950': 4.008,
 '1955': 3.587,
 '1960': 3.104,
 '1965': 2.522,
 '1970': 2.029,
 '1975': 1.68,
 '1980': 1.227,
 '1985': 1.245,
 '1990': 1.336,
 '1995': 1.237,
 '2000': 1.127,
 '2005': 0.976,
 '2010': 0.866,
 '2015': 0.776,
 '2020': 0.71,
 '2025': 0.68,
 '2030': 0.678,
 '2035': 0.679},
{'Index': 64,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20131,
 'Urban Agglomeration': 'Rajshahi',
 'Note': '',
 'Latitude': 24.36667,
 'Longitude': 88.6,
 '1950': 2.402,
 '1955': 2.362,
 '1960': 2.251,
 '1965': 2.184,
 '1970': 2.121,
 '1975': 2.143,
 '1980': 1.97,
 '1985': 2.172,
 '1990': 2.475,
 '1995': 2.352,
 '2000': 2.185,
 '2005': 1.903,
 '2010': 1.695,
 '2015': 1.525,
 '2020': 1.4,
 '2025': 1.346,
 '2030': 1.341,
 '2035': 1.344},
{'Index': 65,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20132,
 'Urban Agglomeration': 'Rangpur',
 'Note': '',
 'Latitude': 25.75,
 'Longitude': 89.25,
 '1950': 2.103,
 '1955': 1.962,
 '1960': 1.772,
 '1965': 1.563,
 '1970': 1.371,
 '1975': 1.27,
 '1980': 1.112,
 '1985': 1.061,
 '1990': 1.032,
 '1995': 0.963,
 '2000': 0.898,
 '2005': 0.798,
 '2010': 0.727,
 '2015': 0.669,
 '2020': 0.628,
 '2025': 0.61,
 '2030': 0.61,
 '2035': 0.611},
{'Index': 66,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 205390,
 'Urban Agglomeration': 'Rupganj',
 'Note': '',
 'Latitude': 23.792554,
 'Longitude': 90.520591,
 '1950': 0.597,
 '1955': 0.625,
 '1960': 0.636,
 '1965': 0.578,
 '1970': 0.517,
 '1975': 0.464,
 '1980': 0.343,
 '1985': 0.324,
 '1990': 0.32,
 '1995': 0.281,
 '2000': 0.244,
 '2005': 0.302,
 '2010': 0.404,
 '2015': 0.546,
 '2020': 0.743,
 '2025': 0.885,
 '2030': 0.915,
 '2035': 0.919},
{'Index': 67,
 'Country Code': 50,
 'Country or area': 'Bangladesh',
 'City Code': 20136,
 'Urban Agglomeration': 'Sylhet',
 'Note': '',
 'Latitude': 24.89667,
 'Longitude': 91.87167,
 '1950': 4.156,
 '1955': 3.672,
 '1960': 3.107,
 '1965': 2.571,
 '1970': 2.118,
 '1975': 1.893,
 '1980': 1.73,
 '1985': 1.441,
 '1990': 1.188,
 '1995': 1.11,
 '2000': 1.065,
 '2005': 1.081,
 '2010': 1.14,
 '2015': 1.215,
 '2020': 1.314,
 '2025': 1.38,
 '2030': 1.397,
 '2035': 1.401},
{'Index': 68,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20344,
 'Urban Agglomeration': 'Brest',
 'Note': '',
 'Latitude': 52.09755,
 'Longitude': 23.68775,
 '1950': 3.233,
 '1955': 3.128,
 '1960': 2.982,
 '1965': 3.038,
 '1970': 3.147,
 '1975': 3.242,
 '1980': 3.432,
 '1985': 3.646,
 '1990': 3.86,
 '1995': 3.993,
 '2000': 4.168,
 '2005': 4.327,
 '2010': 4.425,
 '2015': 4.597,
 '2020': 4.792,
 '2025': 4.882,
 '2030': 4.901,
 '2035': 4.904},
{'Index': 69,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20345,
 'Urban Agglomeration': 'Gomel',
 'Note': '',
 'Latitude': 52.4345,
 'Longitude': 30.9754,
 '1950': 5.704,
 '1955': 6.403,
 '1960': 6.762,
 '1965': 6.828,
 '1970': 7.005,
 '1975': 7.098,
 '1980': 7.31,
 '1985': 7.359,
 '1990': 7.331,
 '1995': 7.015,
 '2000': 6.864,
 '2005': 6.918,
 '2010': 6.893,
 '2015': 7.155,
 '2020': 7.451,
 '2025': 7.587,
 '2030': 7.617,
 '2035': 7.62},
{'Index': 70,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20346,
 'Urban Agglomeration': 'Grodno',
 'Note': '',
 'Latitude': 53.6884,
 'Longitude': 23.8258,
 '1950': 3.183,
 '1955': 3.083,
 '1960': 2.978,
 '1965': 3.164,
 '1970': 3.408,
 '1975': 3.546,
 '1980': 3.756,
 '1985': 3.903,
 '1990': 4.067,
 '1995': 4.206,
 '2000': 4.392,
 '2005': 4.569,
 '2010': 4.685,
 '2015': 4.913,
 '2020': 5.168,
 '2025': 5.292,
 '2030': 5.318,
 '2035': 5.32},
{'Index': 71,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20348,
 'Urban Agglomeration': 'Minsk',
 'Note': 22.0,
 'Latitude': 53.9,
 'Longitude': 27.56667,
 '1950': 13.989,
 '1955': 18.369,
 '1960': 20.766,
 '1965': 22.007,
 '1970': 23.578,
 '1975': 23.749,
 '1980': 24.246,
 '1985': 24.035,
 '1990': 23.995,
 '1995': 24.005,
 '2000': 24.463,
 '2005': 25.491,
 '2010': 26.153,
 '2015': 26.57,
 '2020': 27.101,
 '2025': 27.287,
 '2030': 27.34,
 '2035': 27.351},
{'Index': 72,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20349,
 'Urban Agglomeration': 'Mogilev',
 'Note': '',
 'Latitude': 53.9141,
 'Longitude': 30.33764,
 '1950': 4.042,
 '1955': 4.592,
 '1960': 4.909,
 '1965': 5.016,
 '1970': 5.207,
 '1975': 5.334,
 '1980': 5.492,
 '1985': 5.381,
 '1990': 5.293,
 '1995': 5.176,
 '2000': 5.163,
 '2005': 5.219,
 '2010': 5.095,
 '2015': 5.132,
 '2020': 5.191,
 '2025': 5.203,
 '2030': 5.209,
 '2035': 5.211},
{'Index': 73,
 'Country Code': 112,
 'Country or area': 'Belarus',
 'City Code': 20355,
 'Urban Agglomeration': 'Vitebsk',
 'Note': '',
 'Latitude': 55.19048,
 'Longitude': 30.2033,
 '1950': 5.173,
 '1955': 5.71,
 '1960': 5.931,
 '1965': 5.888,
 '1970': 5.922,
 '1975': 5.705,
 '1980': 5.583,
 '1985': 5.334,
 '1990': 5.139,
 '1995': 4.98,
 '2000': 4.908,
 '2005': 4.939,
 '2010': 4.948,
 '2015': 4.989,
 '2020': 5.051,
 '2025': 5.065,
 '2030': 5.071,
 '2035': 5.073},
{'Index': 74,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20142,
 'Urban Agglomeration': 'Antwerpen',
 'Note': '',
 'Latitude': 51.21989,
 'Longitude': 4.40346,
 '1950': 9.606,
 '1955': 9.61,
 '1960': 9.592,
 '1965': 9.495,
 '1970': 9.459,
 '1975': 9.402,
 '1980': 9.352,
 '1985': 9.395,
 '1990': 9.41,
 '1995': 9.356,
 '2000': 9.464,
 '2005': 9.428,
 '2010': 9.292,
 '2015': 9.207,
 '2020': 9.147,
 '2025': 9.169,
 '2030': 9.174,
 '2035': 9.177},
{'Index': 75,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20144,
 'Urban Agglomeration': 'Bruxelles-Brussel',
 'Note': 25.0,
 'Latitude': 50.846735,
 'Longitude': 4.349919,
 '1950': 17.906,
 '1955': 17.729,
 '1960': 17.516,
 '1965': 17.335,
 '1970': 17.343,
 '1975': 17.441,
 '1980': 17.569,
 '1985': 17.62,
 '1990': 17.581,
 '1995': 17.397,
 '2000': 17.851,
 '2005': 18.039,
 '2010': 18.034,
 '2015': 18.125,
 '2020': 18.258,
 '2025': 18.44,
 '2030': 18.473,
 '2035': 18.481},
{'Index': 76,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20145,
 'Urban Agglomeration': 'Charleroi',
 'Note': '',
 'Latitude': 50.41136,
 'Longitude': 4.44448,
 '1950': 5.226,
 '1955': 5.075,
 '1960': 4.918,
 '1965': 4.761,
 '1970': 4.655,
 '1975': 4.5,
 '1980': 4.35,
 '1985': 4.241,
 '1990': 4.123,
 '1995': 3.975,
 '2000': 3.965,
 '2005': 3.896,
 '2010': 3.787,
 '2015': 3.7,
 '2020': 3.628,
 '2025': 3.61,
 '2030': 3.607,
 '2035': 3.608},
{'Index': 77,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20146,
 'Urban Agglomeration': 'Gent',
 'Note': '',
 'Latitude': 51.05,
 'Longitude': 3.71667,
 '1950': 4.583,
 '1955': 4.441,
 '1960': 4.293,
 '1965': 4.113,
 '1970': 3.964,
 '1975': 3.94,
 '1980': 3.932,
 '1985': 3.966,
 '1990': 3.987,
 '1995': 3.976,
 '2000': 4.064,
 '2005': 4.091,
 '2010': 4.074,
 '2015': 4.078,
 '2020': 4.092,
 '2025': 4.125,
 '2030': 4.131,
 '2035': 4.132},
{'Index': 78,
 'Country Code': 56,
 'Country or area': 'Belgium',
 'City Code': 20148,
 'Urban Agglomeration': 'Liège',
 'Note': '',
 'Latitude': 50.63373,
 'Longitude': 5.56749,
 '1950': 7.621,
 '1955': 7.485,
 '1960': 7.336,
 '1965': 7.078,
 '1970': 6.852,
 '1975': 6.773,
 '1980': 6.717,
 '1985': 6.644,
 '1990': 6.54,
 '1995': 6.385,
 '2000': 6.396,
 '2005': 6.309,
 '2010': 6.158,
 '2015': 6.041,
 '2020': 5.945,
 '2025': 5.929,
 '2030': 5.927,
 '2035': 5.929}]},
'Population Density': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950',
'1951',
'1952'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950': 19.4969066436,
 '1951': 19.8628205262,
 '1952': 20.2227714446},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 16.5961968779,
 '1951': 16.7832683988,
 '1952': 16.9811769357},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 21.2551794892,
 '1951': 21.7294991393,
 '1952': 22.187672473},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 9.7042874986,
 '1951': 9.8906290122,
 '1952': 10.0810529474},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 25.077378812,
 '1951': 25.6469906559,
 '1952': 26.193762478},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 16.1712730084,
 '1951': 16.4858168135,
 '1952': 16.8215616936},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 6.2767141933,
 '1951': 6.4016887774,
 '1952': 6.5352717874},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 19.8724943194,
 '1951': 20.2386158628,
 '1952': 20.6361322942},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'}]},
'Population Growth Rate': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950-1955',
'1955-1960',
'1960-1965'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950-1955': 1.784,
 '1955-1960': 1.805,
 '1960-1965': 1.913},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950-1955': '...',
 '1955-1960': '...',
 '1960-1965': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950-1955': 1.182,
 '1955-1960': 1.166,
 '1960-1965': 1.068},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950-1955': 2.062,
 '1955-1960': 2.088,
 '1960-1965': 2.268},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950-1955': 1.954,
 '1955-1960': 2.198,
 '1960-1965': 2.366},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950-1955': 2.076,
 '1955-1960': 2.074,
 '1960-1965': 2.255},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950-1955': 2.083,
 '1955-1960': 2.342,
 '1960-1965': 2.448},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950-1955': 2.133,
 '1955-1960': 2.4,
 '1960-1965': 2.511},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950-1955': 1.983,
 '1955-1960': 2.123,
 '1960-1965': 2.208},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950-1955': '...',
 '1955-1960': '...',
 '1960-1965': '...'}]},
'Proportion Ubran Annual': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
2000,
2001,
2002,
2003,
2004,
2005,
2006,
2007,
2008,
2009,
2010,
2011,
2012,
2013,
2014,
2015,
2016,
2017,
2018,
2019,
2020,
2021,
2022,
2023,
2024,
2025,
2026,
2027,
2028,
2029,
2030,
2031,
2032,
2033,
2034,
2035,
2036,
2037,
2038,
2039,
2040,
2041,
2042,
2043,
2044,
2045,
2046,
2047,
2048,
2049,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '2000': 46.6770423229,
 '2001': 47.1297486899,
 '2002': 47.6314971073,
 '2003': 48.1358271074,
 '2004': 48.6436231207,
 '2005': 49.1566419393,
 '2006': 49.6606544897,
 '2007': 50.1550792477,
 '2008': 50.6603094542,
 '2009': 51.1632637216,
 '2010': 51.6639947069,
 '2011': 52.1286297918,
 '2012': 52.5778557431,
 '2013': 53.0259836217,
 '2014': 53.4747831678,
 '2015': 53.9278464928,
 '2016': 54.3815736989,
 '2017': 54.8350314018,
 '2018': 55.285172337,
 '2019': 55.7313597481,
 '2020': 56.1734831845,
 '2021': 56.6114808484,
 '2022': 57.0455592607,
 '2023': 57.4762171167,
 '2024': 57.9041079861,
 '2025': 58.3297287747,
 '2026': 58.753302914,
 '2027': 59.1748474199,
 '2028': 59.5943884231,
 '2029': 60.0118793886,
 '2030': 60.4272893324,
 '2031': 60.8407464376,
 '2032': 61.2523857711,
 '2033': 61.6622501942,
 '2034': 62.0702779659,
 '2035': 62.4763262559,
 '2036': 62.8800843558,
 '2037': 63.2817092491,
 '2038': 63.6814551129,
 '2039': 64.0788153784,
 '2040': 64.4737431803,
 '2041': 64.866057462,
 '2042': 65.2560398787,
 '2043': 65.6430367908,
 '2044': 66.0306129086,
 '2045': 66.4184093499,
 '2046': 66.8063387604,
 '2047': 67.1943116325,
 '2048': 67.5822137524,
 '2049': 67.96992018,
 '2050': 68.357320132},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '2000': 74.2441341067,
 '2001': 74.530842769,
 '2002': 74.8749369822,
 '2003': 75.2135953254,
 '2004': 75.5427771948,
 '2005': 75.8618319792,
 '2006': 76.1595491629,
 '2007': 76.4455654511,
 '2008': 76.7228118954,
 '2009': 76.9903897086,
 '2010': 77.2454129273,
 '2011': 77.4409213836,
 '2012': 77.6106526219,
 '2013': 77.7822660777,
 '2014': 77.9532705923,
 '2015': 78.1266909373,
 '2016': 78.304458397,
 '2017': 78.4872715976,
 '2018': 78.6761672042,
 '2019': 78.8710327494,
 '2020': 79.0717960517,
 '2021': 79.278397161,
 '2022': 79.490755362,
 '2023': 79.7087310801,
 '2024': 79.9321461935,
 '2025': 80.1608127441,
 '2026': 80.3945491965,
 '2027': 80.6331680656,
 '2028': 80.8764503261,
 '2029': 81.1241615088,
 '2030': 81.37605385,
 '2031': 81.631844784,
 '2032': 81.8912536744,
 '2033': 82.1539415696,
 '2034': 82.4195228776,
 '2035': 82.687607762,
 '2036': 82.9577734117,
 '2037': 83.2290127409,
 '2038': 83.5002069833,
 '2039': 83.771058504,
 '2040': 84.0413220818,
 '2041': 84.3104022575,
 '2042': 84.57703398,
 '2043': 84.8404709778,
 '2044': 85.1004596801,
 '2045': 85.3569599886,
 '2046': 85.6099992966,
 '2047': 85.8595985365,
 '2048': 86.1057873898,
 '2049': 86.3485954465,
 '2050': 86.5880493518},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '2000': 40.0530160098,
 '2001': 40.6228888923,
 '2002': 41.2368302102,
 '2003': 41.8520276288,
 '2004': 42.4701136824,
 '2005': 43.0932154944,
 '2006': 43.7062090016,
 '2007': 44.3066388903,
 '2008': 44.919889133,
 '2009': 45.5315100315,
 '2010': 46.1430179714,
 '2011': 46.723559228,
 '2012': 47.2904325325,
 '2013': 47.8542583623,
 '2014': 48.4166173985,
 '2015': 48.980517214,
 '2016': 49.5411472929,
 '2017': 50.0976100081,
 '2018': 50.6463557681,
 '2019': 51.1870849713,
 '2020': 51.7200073479,
 '2021': 52.2451874506,
 '2022': 52.7628926191,
 '2023': 53.2737937795,
 '2024': 53.7787204992,
 '2025': 54.2783398599,
 '2026': 54.7730225139,
 '2027': 55.2629379319,
 '2028': 55.7482895137,
 '2029': 56.2292091765,
 '2030': 56.7058182228,
 '2031': 57.1783877536,
 '2032': 57.6471570289,
 '2033': 58.1122599525,
 '2034': 58.5736993388,
 '2035': 59.0313899524,
 '2036': 59.4850744681,
 '2037': 59.9351466512,
 '2038': 60.3821149422,
 '2039': 60.8254576163,
 '2040': 61.2651801841,
 '2041': 61.7011924671,
 '2042': 62.1340431233,
 '2043': 62.5630959799,
 '2044': 62.9925235626,
 '2045': 63.4219108068,
 '2046': 63.8511540599,
 '2047': 64.2801605719,
 '2048': 64.7088164121,
 '2049': 65.1370020867,
 '2050': 65.5646102643},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '2000': 25.0170784351,
 '2001': 25.402228608,
 '2002': 25.8196007767,
 '2003': 26.2521808028,
 '2004': 26.6864385534,
 '2005': 27.1335725263,
 '2006': 27.5743066083,
 '2007': 27.9711863744,
 '2008': 28.4579221808,
 '2009': 28.9528222168,
 '2010': 29.4551836248,
 '2011': 29.9641721525,
 '2012': 30.4622893399,
 '2013': 30.9628533066,
 '2014': 31.4691941254,
 '2015': 31.982104015,
 '2016': 32.5013997901,
 '2017': 33.026820245,
 '2018': 33.5587391103,
 '2019': 34.0968687729,
 '2020': 34.6409591804,
 '2021': 35.1908317391,
 '2022': 35.7463359941,
 '2023': 36.3072584898,
 '2024': 36.8733672982,
 '2025': 37.4444125442,
 '2026': 38.0201248532,
 '2027': 38.6002279127,
 '2028': 39.1844250296,
 '2029': 39.7723690161,
 '2030': 40.3635579848,
 '2031': 40.9580086905,
 '2032': 41.5554359265,
 '2033': 42.1553551565,
 '2034': 42.7571750702,
 '2035': 43.3598781628,
 '2036': 43.9629644307,
 '2037': 44.5656901344,
 '2038': 45.1703548776,
 '2039': 45.7758592594,
 '2040': 46.3823013926,
 '2041': 46.9891245685,
 '2042': 47.5969893066,
 '2043': 48.2050338206,
 '2044': 48.8138337593,
 '2045': 49.423245735,
 '2046': 50.0330205893,
 '2047': 50.6429906268,
 '2048': 51.2529965163,
 '2049': 51.862881834,
 '2050': 52.4724881523},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '2000': 42.3832416112,
 '2001': 43.0104965841,
 '2002': 43.6855063758,
 '2003': 44.3608476521,
 '2004': 45.0397941715,
 '2005': 45.7224817484,
 '2006': 46.3942211164,
 '2007': 47.0586841611,
 '2008': 47.7235064017,
 '2009': 48.386149329,
 '2010': 49.0490125643,
 '2011': 49.6760693433,
 '2012': 50.2904479593,
 '2013': 50.9021556345,
 '2014': 51.5122222342,
 '2015': 52.1238910423,
 '2016': 52.7314593429,
 '2017': 53.3339376642,
 '2018': 53.9270170476,
 '2019': 54.5103750561,
 '2020': 55.0842562608,
 '2021': 55.6486806242,
 '2022': 56.2038550046,
 '2023': 56.7504591566,
 '2024': 57.2893488286,
 '2025': 57.8212157346,
 '2026': 58.3464474987,
 '2027': 58.8652149151,
 '2028': 59.3777201129,
 '2029': 59.8840953341,
 '2030': 60.384496999,
 '2031': 60.8791501948,
 '2032': 61.3683126492,
 '2033': 61.8521670445,
 '2034': 62.3307667568,
 '2035': 62.8041663134,
 '2036': 63.272093902,
 '2037': 63.7351500944,
 '2038': 64.1933250224,
 '2039': 64.6461542901,
 '2040': 65.093540287,
 '2041': 65.5354416542,
 '2042': 65.9723149636,
 '2043': 66.403521497,
 '2044': 66.8341501641,
 '2045': 67.2636922445,
 '2046': 67.6920551495,
 '2047': 68.1191451064,
 '2048': 68.5448535186,
 '2049': 68.9690692748,
 '2050': 69.3916907377},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '2000': 41.2286361683,
 '2001': 41.5612140155,
 '2002': 41.9182324048,
 '2003': 42.2772055675,
 '2004': 42.6401844024,
 '2005': 43.0124886396,
 '2006': 43.3877449367,
 '2007': 43.7564313159,
 '2008': 44.1446005013,
 '2009': 44.5352850978,
 '2010': 44.9292331896,
 '2011': 45.3063107135,
 '2012': 45.6793915517,
 '2013': 46.0545268199,
 '2014': 46.4326113394,
 '2015': 46.8185136807,
 '2016': 47.2058318591,
 '2017': 47.5952954964,
 '2018': 47.9883347416,
 '2019': 48.3851561124,
 '2020': 48.7860341099,
 '2021': 49.1909646514,
 '2022': 49.6000811637,
 '2023': 50.013921402,
 '2024': 50.4331255382,
 '2025': 50.8581054462,
 '2026': 51.2889269216,
 '2027': 51.7254156465,
 '2028': 52.1673981118,
 '2029': 52.6146022156,
 '2030': 53.0667274071,
 '2031': 53.5236466472,
 '2032': 53.985183392,
 '2033': 54.4510321411,
 '2034': 54.9207292305,
 '2035': 55.3937167397,
 '2036': 55.8692492733,
 '2037': 56.3474063626,
 '2038': 56.8283963056,
 '2039': 57.3111990366,
 '2040': 57.7954738581,
 '2041': 58.2807966626,
 '2042': 58.7675796377,
 '2043': 59.2548978852,
 '2044': 59.7424597195,
 '2045': 60.2299583493,
 '2046': 60.7172391645,
 '2047': 61.2041625109,
 '2048': 61.690580499,
 '2049': 62.1763425022,
 '2050': 62.6613054916},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '2000': 76.7989626466,
 '2001': 77.1326559212,
 '2002': 77.5234439929,
 '2003': 77.8929405631,
 '2004': 78.2496307517,
 '2005': 78.5943741502,
 '2006': 78.9092207294,
 '2007': 79.2083685774,
 '2008': 79.4984935807,
 '2009': 79.778463179,
 '2010': 80.0478005604,
 '2011': 80.2497305455,
 '2012': 80.423999424,
 '2013': 80.5998470397,
 '2014': 80.773108636,
 '2015': 80.9461038715,
 '2016': 81.1207687075,
 '2017': 81.2982327507,
 '2018': 81.4791665596,
 '2019': 81.663671671,
 '2020': 81.8518274918,
 '2021': 82.0435719222,
 '2022': 82.2387895404,
 '2023': 82.4374398725,
 '2024': 82.6394754897,
 '2025': 82.8448324667,
 '2026': 83.0534354852,
 '2027': 83.2651678631,
 '2028': 83.4798564182,
 '2029': 83.6973054271,
 '2030': 83.9173274476,
 '2031': 84.1397549744,
 '2032': 84.3644218387,
 '2033': 84.5911460384,
 '2034': 84.8196754199,
 '2035': 85.0497487456,
 '2036': 85.2810345559,
 '2037': 85.5126306165,
 '2038': 85.7444465436,
 '2039': 85.9762429223,
 '2040': 86.2078287231,
 '2041': 86.4388705498,
 '2042': 86.6680541477,
 '2043': 86.894325372,
 '2044': 87.1175872959,
 '2045': 87.3378061277,
 '2046': 87.5550034058,
 '2047': 87.7691970749,
 '2048': 87.9804049329,
 '2049': 88.1886458725,
 '2050': 88.3939365585},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '2000': 41.6428125471,
 '2001': 42.2084541352,
 '2002': 42.8266639599,
 '2003': 43.4521523677,
 '2004': 44.0838645549,
 '2005': 44.7210596247,
 '2006': 45.3496697897,
 '2007': 45.9743663544,
 '2008': 46.6018292865,
 '2009': 47.2300147384,
 '2010': 47.8604777084,
 '2011': 48.4612156586,
 '2012': 49.0525971301,
 '2013': 49.6435933009,
 '2014': 50.2349956362,
 '2015': 50.8297536906,
 '2016': 51.4223418568,
 '2017': 52.0116810306,
 '2018': 52.5937704438,
 '2019': 53.168197775,
 '2020': 53.7350906802,
 '2021': 54.294382186,
 '2022': 54.8461690092,
 '2023': 55.3909694403,
 '2024': 55.9294625394,
 '2025': 56.46219874,
 '2026': 56.98946302,
 '2027': 57.5113802843,
 '2028': 58.0281413015,
 '2029': 58.5398894843,
 '2030': 59.0467649648,
 '2031': 59.5489063869,
 '2032': 60.0465448686,
 '2033': 60.5397792264,
 '2034': 61.028592123,
 '2035': 61.5128413624,
 '2036': 61.9921617745,
 '2037': 62.4669706306,
 '2038': 62.9376339595,
 '2039': 63.4035834729,
 '2040': 63.8647655019,
 '2041': 64.3211040276,
 '2042': 64.7730079681,
 '2043': 65.2198909686,
 '2044': 65.6664197934,
 '2045': 66.1120664402,
 '2046': 66.5567135255,
 '2047': 67.0002446153,
 '2048': 67.4425222388,
 '2049': 67.8834060597,
 '2050': 68.3227684939},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '2000': 50.2600856326,
 '2001': 51.1534770719,
 '2002': 52.1067431495,
 '2003': 53.0714341865,
 '2004': 54.044870337,
 '2005': 55.0215043739,
 '2006': 55.9783273565,
 '2007': 56.9241103324,
 '2008': 57.8707547448,
 '2009': 58.8151872786,
 '2010': 59.7618511966,
 '2011': 60.6592578726,
 '2012': 61.5331500717,
 '2013': 62.3998046047,
 '2014': 63.2621955873,
 '2015': 64.1181834165,
 '2016': 64.9679492945,
 '2017': 65.8079433471,
 '2018': 66.6273240676,
 '2019': 67.4248865366,
 '2020': 68.2004750088,
 '2021': 68.9539131874,
 '2022': 69.6851517281,
 '2023': 70.3943357538,
 '2024': 71.081722296,
 '2025': 71.7475629945,
 '2026': 72.3920757385,
 '2027': 73.0154510389,
 '2028': 73.6179143763,
 '2029': 74.1997036522,
 '2030': 74.7611007537,
 '2031': 75.3024288485,
 '2032': 75.8241354136,
 '2033': 76.3265744227,
 '2034': 76.8101019734,
 '2035': 77.2752895406,
 '2036': 77.7224439532,
 '2037': 78.1519305487,
 '2038': 78.5636737156,
 '2039': 78.958398871,
 '2040': 79.3363810139,
 '2041': 79.6977813882,
 '2042': 80.0428550039,
 '2043': 80.3715079467,
 '2044': 80.6967069513,
 '2045': 81.0178671811,
 '2046': 81.3349907188,
 '2047': 81.648076772,
 '2048': 81.9571317869,
 '2049': 82.2621643026,
 '2050': 82.5631794408},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '2000': 33.1446154088,
 '2001': 33.4708745693,
 '2002': 33.8469235193,
 '2003': 34.2303702828,
 '2004': 34.6215565261,
 '2005': 35.0240330015,
 '2006': 35.4319122916,
 '2007': 35.845415428,
 '2008': 36.2653758266,
 '2009': 36.6895364601,
 '2010': 37.1160607634,
 '2011': 37.5299308697,
 '2012': 37.9467971615,
 '2013': 38.3703043759,
 '2014': 38.801227718,
 '2015': 39.2484654334,
 '2016': 39.7018209619,
 '2017': 40.1621546694,
 '2018': 40.6315458656,
 '2019': 41.110245411,
 '2020': 41.5984377993,
 '2021': 42.0961214311,
 '2022': 42.6030711829,
 '2023': 43.1189443001,
 '2024': 43.6432638734,
 '2025': 44.1756098491,
 '2026': 44.7156951457,
 '2027': 45.263355029,
 '2028': 45.8184131718,
 '2029': 46.3807139506,
 '2030': 46.9500212568,
 '2031': 47.5259306235,
 '2032': 48.1080725813,
 '2033': 48.6960307693,
 '2034': 49.2892113202,
 '2035': 49.8866633368,
 '2036': 50.4872702615,
 '2037': 51.0912428673,
 '2038': 51.6990256088,
 '2039': 52.3088879104,
 '2040': 52.9203457035,
 '2041': 53.5329739537,
 '2042': 54.1471397094,
 '2043': 54.7617999469,
 '2044': 55.3758485756,
 '2045': 55.9888345695,
 '2046': 56.6005510574,
 '2047': 57.2107991216,
 '2048': 57.8193850021,
 '2049': 58.4261201052,
 '2050': 59.0308173605},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '2000': 25.677213331,
 '2001': 25.974575695,
 '2002': 26.2634307439,
 '2003': 26.5567193528,
 '2004': 26.8464549828,
 '2005': 27.1567492545,
 '2006': 27.4758094316,
 '2007': 27.7260667223,
 '2008': 28.1111523622,
 '2009': 28.5047476687,
 '2010': 28.9075435933,
 '2011': 29.317669903,
 '2012': 29.7107130561,
 '2013': 30.1077387052,
 '2014': 30.5144047702,
 '2015': 30.9313603534,
 '2016': 31.3591243087,
 '2017': 31.797370221,
 '2018': 32.2463386979,
 '2019': 32.7053730051,
 '2020': 33.1739484968,
 '2021': 33.6518123786,
 '2022': 34.1388885509,
 '2023': 34.6350200281,
 '2024': 35.1400820985,
 '2025': 35.6538892068,
 '2026': 36.1761514138,
 '2027': 36.7065203249,
 '2028': 37.2446465318,
 '2029': 37.7901083236,
 '2030': 38.3422966287,
 '2031': 38.9014252831,
 '2032': 39.4668064205,
 '2033': 40.0379954605,
 '2034': 40.6143974872,
 '2035': 41.1955511146,
 '2036': 41.781146404,
 '2037': 42.3706057968,
 '2038': 42.963431087,
 '2039': 43.5586937885,
 '2040': 44.1561162703,
 '2041': 44.7547604555,
 '2042': 45.3555637421,
 '2043': 45.9574272647,
 '2044': 46.5611307971,
 '2045': 47.1665818989,
 '2046': 47.7734890586,
 '2047': 48.3816760639,
 '2048': 48.990980658,
 '2049': 49.60124483,
 '2050': 50.21230204},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '2000': 31.4167846088,
 '2001': 31.8554370924,
 '2002': 32.3085730458,
 '2003': 32.7659468092,
 '2004': 33.2279998792,
 '2005': 33.7011036854,
 '2006': 34.1682717723,
 '2007': 34.5913363174,
 '2008': 35.1047323606,
 '2009': 35.6225401808,
 '2010': 36.1489168998,
 '2011': 36.6815944335,
 '2012': 37.2022248093,
 '2013': 37.7233361977,
 '2014': 38.2481485647,
 '2015': 38.7756124603,
 '2016': 39.3053818242,
 '2017': 39.8372408077,
 '2018': 40.3717308226,
 '2019': 40.9091293477,
 '2020': 41.4495586215,
 '2021': 41.9928573773,
 '2022': 42.5387138307,
 '2023': 43.0869010376,
 '2024': 43.6371597485,
 '2025': 44.1892374168,
 '2026': 44.7428951351,
 '2027': 45.2979047792,
 '2028': 45.8540137959,
 '2029': 46.4109229241,
 '2030': 46.9681770464,
 '2031': 47.5258127126,
 '2032': 48.083218532,
 '2033': 48.640176445,
 '2034': 49.1961093894,
 '2035': 49.7504535163,
 '2036': 50.3025108203,
 '2037': 50.8557883864,
 '2038': 51.4097008897,
 '2039': 51.9637514227,
 '2040': 52.5176987258,
 '2041': 53.0713625822,
 '2042': 53.6252734045,
 '2043': 54.178852673,
 '2044': 54.732640624,
 '2045': 55.2865143246,
 '2046': 55.8402382235,
 '2047': 56.3936589754,
 '2048': 56.9466297872,
 '2049': 57.4990099555,
 '2050': 58.0506553746},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '2000': 34.9815929969,
 '2001': 35.345177484,
 '2002': 35.7202059521,
 '2003': 36.0986316596,
 '2004': 36.4808619663,
 '2005': 36.878156197,
 '2006': 37.2727136808,
 '2007': 37.6293099497,
 '2008': 38.05748197,
 '2009': 38.4910444332,
 '2010': 38.9335812484,
 '2011': 39.3831110956,
 '2012': 39.8218638883,
 '2013': 40.2622627769,
 '2014': 40.7066411733,
 '2015': 41.1540083778,
 '2016': 41.6041135125,
 '2017': 42.0588053254,
 '2018': 42.51832115,
 '2019': 42.9826498362,
 '2020': 43.4517338086,
 '2021': 43.925404961,
 '2022': 44.403478007,
 '2023': 44.8858244445,
 '2024': 45.3723549232,
 '2025': 45.8629594579,
 '2026': 46.3574688163,
 '2027': 46.8557000277,
 '2028': 47.3574877396,
 '2029': 47.8626218401,
 '2030': 48.370746113,
 '2031': 48.8818837961,
 '2032': 49.3955100633,
 '2033': 49.9114260744,
 '2034': 50.4290784475,
 '2035': 50.9478568808,
 '2036': 51.4670190321,
 '2037': 51.9894512726,
 '2038': 52.5146174012,
 '2039': 53.0420400505,
 '2040': 53.5714225434,
 '2041': 54.1024594702,
 '2042': 54.6355104214,
 '2043': 55.1688500911,
 '2044': 55.7027365115,
 '2045': 56.2370218942,
 '2046': 56.7714745289,
 '2047': 57.3059271082,
 '2048': 57.8401982378,
 '2049': 58.3741072299,
 '2050': 58.9074820385},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '2000': 21.0446514354,
 '2001': 21.3255416165,
 '2002': 21.6219408203,
 '2003': 21.9104631989,
 '2004': 22.201401667,
 '2005': 22.5163906182,
 '2006': 22.8371363855,
 '2007': 23.0467508851,
 '2008': 23.4753278804,
 '2009': 23.9090007501,
 '2010': 24.3534794444,
 '2011': 24.8087414609,
 '2012': 25.2349945449,
 '2013': 25.6660084176,
 '2014': 26.1078334392,
 '2015': 26.5598879217,
 '2016': 27.0221899856,
 '2017': 27.4939226013,
 '2018': 27.975888939,
 '2019': 28.4679729119,
 '2020': 28.9700193914,
 '2021': 29.4818562619,
 '2022': 30.0033055519,
 '2023': 30.5341644808,
 '2024': 31.0742102278,
 '2025': 31.6231866049,
 '2026': 32.1808225734,
 '2027': 32.7468176827,
 '2028': 33.3208457192,
 '2029': 33.9025472846,
 '2030': 34.4915398308,
 '2031': 35.08738566,
 '2032': 35.689610772,
 '2033': 36.2976371347,
 '2034': 36.9106920141,
 '2035': 37.5282449813,
 '2036': 38.1493003863,
 '2037': 38.7737088851,
 '2038': 39.4007625545,
 '2039': 40.0293992166,
 '2040': 40.6603826016,
 '2041': 41.2928337988,
 '2042': 41.9277377623,
 '2043': 42.5640789283,
 '2044': 43.2033696898,
 '2045': 43.8455330353,
 '2046': 44.4901848242,
 '2047': 45.1371192529,
 '2048': 45.7861399602,
 '2049': 46.4370510222,
 '2050': 47.0896452264},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '2000': 8.246,
 '2001': 8.461,
 '2002': 8.682,
 '2003': 8.908,
 '2004': 9.139,
 '2005': 9.375,
 '2006': 9.617,
 '2007': 9.864,
 '2008': 10.118,
 '2009': 10.376,
 '2010': 10.642,
 '2011': 10.915,
 '2012': 11.194,
 '2013': 11.482,
 '2014': 11.776,
 '2015': 12.078,
 '2016': 12.388,
 '2017': 12.706,
 '2018': 13.032,
 '2019': 13.366,
 '2020': 13.708,
 '2021': 14.058,
 '2022': 14.417,
 '2023': 14.784,
 '2024': 15.16,
 '2025': 15.544,
 '2026': 15.938,
 '2027': 16.34,
 '2028': 16.75,
 '2029': 17.17,
 '2030': 17.598,
 '2031': 18.034,
 '2032': 18.479,
 '2033': 18.932,
 '2034': 19.392,
 '2035': 19.859,
 '2036': 20.335,
 '2037': 20.819,
 '2038': 21.312,
 '2039': 21.814,
 '2040': 22.324,
 '2041': 22.842,
 '2042': 23.369,
 '2043': 23.904,
 '2044': 24.448,
 '2045': 25.0,
 '2046': 25.56,
 '2047': 26.128,
 '2048': 26.704,
 '2049': 27.289,
 '2050': 27.881},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '2000': 28.08,
 '2001': 28.036,
 '2002': 27.992,
 '2003': 27.947,
 '2004': 27.903,
 '2005': 27.875,
 '2006': 27.863,
 '2007': 27.867,
 '2008': 27.886,
 '2009': 27.921,
 '2010': 27.973,
 '2011': 28.04,
 '2012': 28.123,
 '2013': 28.223,
 '2014': 28.338,
 '2015': 28.47,
 '2016': 28.619,
 '2017': 28.784,
 '2018': 28.965,
 '2019': 29.164,
 '2020': 29.38,
 '2021': 29.613,
 '2022': 29.864,
 '2023': 30.132,
 '2024': 30.418,
 '2025': 30.722,
 '2026': 31.045,
 '2027': 31.386,
 '2028': 31.746,
 '2029': 32.125,
 '2030': 32.523,
 '2031': 32.924,
 '2032': 33.327,
 '2033': 33.732,
 '2034': 34.14,
 '2035': 34.551,
 '2036': 34.963,
 '2037': 35.378,
 '2038': 35.795,
 '2039': 36.215,
 '2040': 36.636,
 '2041': 37.059,
 '2042': 37.485,
 '2043': 37.912,
 '2044': 38.342,
 '2045': 38.773,
 '2046': 39.206,
 '2047': 39.64,
 '2048': 40.076,
 '2049': 40.514,
 '2050': 40.954},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '2000': 76.532,
 '2001': 76.578,
 '2002': 76.624,
 '2003': 76.67,
 '2004': 76.716,
 '2005': 76.761,
 '2006': 76.807,
 '2007': 76.853,
 '2008': 76.899,
 '2009': 76.944,
 '2010': 76.999,
 '2011': 77.064,
 '2012': 77.138,
 '2013': 77.222,
 '2014': 77.314,
 '2015': 77.417,
 '2016': 77.528,
 '2017': 77.648,
 '2018': 77.777,
 '2019': 77.915,
 '2020': 78.062,
 '2021': 78.217,
 '2022': 78.38,
 '2023': 78.552,
 '2024': 78.732,
 '2025': 78.92,
 '2026': 79.115,
 '2027': 79.318,
 '2028': 79.528,
 '2029': 79.745,
 '2030': 79.969,
 '2031': 80.2,
 '2032': 80.437,
 '2033': 80.68,
 '2034': 80.929,
 '2035': 81.184,
 '2036': 81.436,
 '2037': 81.685,
 '2038': 81.932,
 '2039': 82.176,
 '2040': 82.417,
 '2041': 82.656,
 '2042': 82.893,
 '2043': 83.127,
 '2044': 83.358,
 '2045': 83.587,
 '2046': 83.813,
 '2047': 84.036,
 '2048': 84.258,
 '2049': 84.476,
 '2050': 84.692},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '2000': 26.587,
 '2001': 27.455,
 '2002': 28.341,
 '2003': 29.244,
 '2004': 30.164,
 '2005': 31.099,
 '2006': 32.051,
 '2007': 33.017,
 '2008': 34.0,
 '2009': 34.585,
 '2010': 35.175,
 '2011': 35.771,
 '2012': 36.372,
 '2013': 36.979,
 '2014': 37.59,
 '2015': 38.206,
 '2016': 38.827,
 '2017': 39.451,
 '2018': 40.08,
 '2019': 40.712,
 '2020': 41.347,
 '2021': 41.985,
 '2022': 42.625,
 '2023': 43.267,
 '2024': 43.911,
 '2025': 44.557,
 '2026': 45.203,
 '2027': 45.85,
 '2028': 46.496,
 '2029': 47.142,
 '2030': 47.786,
 '2031': 48.429,
 '2032': 49.069,
 '2033': 49.705,
 '2034': 50.338,
 '2035': 50.964,
 '2036': 51.582,
 '2037': 52.201,
 '2038': 52.82,
 '2039': 53.439,
 '2040': 54.056,
 '2041': 54.672,
 '2042': 55.286,
 '2043': 55.899,
 '2044': 56.51,
 '2045': 57.119,
 '2046': 57.726,
 '2047': 58.331,
 '2048': 58.933,
 '2049': 59.532,
 '2050': 60.129},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '2000': 14.74,
 '2001': 14.927,
 '2002': 15.118,
 '2003': 15.31,
 '2004': 15.504,
 '2005': 15.7,
 '2006': 15.899,
 '2007': 16.116,
 '2008': 16.51,
 '2009': 16.91,
 '2010': 17.319,
 '2011': 17.735,
 '2012': 18.16,
 '2013': 18.575,
 '2014': 18.998,
 '2015': 19.428,
 '2016': 19.866,
 '2017': 20.31,
 '2018': 20.763,
 '2019': 21.225,
 '2020': 21.695,
 '2021': 22.174,
 '2022': 22.661,
 '2023': 23.157,
 '2024': 23.661,
 '2025': 24.173,
 '2026': 24.694,
 '2027': 25.222,
 '2028': 25.759,
 '2029': 26.303,
 '2030': 26.856,
 '2031': 27.415,
 '2032': 27.982,
 '2033': 28.556,
 '2034': 29.137,
 '2035': 29.724,
 '2036': 30.317,
 '2037': 30.916,
 '2038': 31.519,
 '2039': 32.128,
 '2040': 32.74,
 '2041': 33.355,
 '2042': 33.972,
 '2043': 34.588,
 '2044': 35.211,
 '2045': 35.84,
 '2046': 36.473,
 '2047': 37.111,
 '2048': 37.753,
 '2049': 38.4,
 '2050': 39.051},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '2000': 19.892,
 '2001': 20.239,
 '2002': 20.591,
 '2003': 20.948,
 '2004': 21.31,
 '2005': 21.675,
 '2006': 22.045,
 '2007': 22.42,
 '2008': 22.8,
 '2009': 23.183,
 '2010': 23.571,
 '2011': 23.969,
 '2012': 24.376,
 '2013': 24.794,
 '2014': 25.221,
 '2015': 25.658,
 '2016': 26.105,
 '2017': 26.562,
 '2018': 27.03,
 '2019': 27.507,
 '2020': 27.995,
 '2021': 28.493,
 '2022': 29.002,
 '2023': 29.52,
 '2024': 30.049,
 '2025': 30.588,
 '2026': 31.137,
 '2027': 31.695,
 '2028': 32.263,
 '2029': 32.841,
 '2030': 33.427,
 '2031': 34.023,
 '2032': 34.626,
 '2033': 35.238,
 '2034': 35.856,
 '2035': 36.479,
 '2036': 37.106,
 '2037': 37.739,
 '2038': 38.377,
 '2039': 39.019,
 '2040': 39.664,
 '2041': 40.313,
 '2042': 40.966,
 '2043': 41.622,
 '2044': 42.28,
 '2045': 42.942,
 '2046': 43.606,
 '2047': 44.272,
 '2048': 44.941,
 '2049': 45.611,
 '2050': 46.283},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '2000': 27.121,
 '2001': 27.391,
 '2002': 27.663,
 '2003': 27.936,
 '2004': 28.211,
 '2005': 28.814,
 '2006': 29.425,
 '2007': 30.043,
 '2008': 30.67,
 '2009': 31.301,
 '2010': 31.938,
 '2011': 32.58,
 '2012': 33.227,
 '2013': 33.878,
 '2014': 34.534,
 '2015': 35.193,
 '2016': 35.856,
 '2017': 36.522,
 '2018': 37.191,
 '2019': 37.861,
 '2020': 38.534,
 '2021': 39.207,
 '2022': 39.882,
 '2023': 40.556,
 '2024': 41.231,
 '2025': 41.904,
 '2026': 42.577,
 '2027': 43.247,
 '2028': 43.915,
 '2029': 44.579,
 '2030': 45.24,
 '2031': 45.895,
 '2032': 46.544,
 '2033': 47.185,
 '2034': 47.817,
 '2035': 48.451,
 '2036': 49.086,
 '2037': 49.721,
 '2038': 50.356,
 '2039': 50.991,
 '2040': 51.626,
 '2041': 52.26,
 '2042': 52.894,
 '2043': 53.526,
 '2044': 54.158,
 '2045': 54.788,
 '2046': 55.416,
 '2047': 56.043,
 '2048': 56.668,
 '2049': 57.291,
 '2050': 57.911},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '2000': 14.61,
 '2001': 14.698,
 '2002': 14.786,
 '2003': 14.875,
 '2004': 14.964,
 '2005': 15.054,
 '2006': 15.144,
 '2007': 15.235,
 '2008': 15.326,
 '2009': 15.429,
 '2010': 15.544,
 '2011': 15.672,
 '2012': 15.812,
 '2013': 15.966,
 '2014': 16.132,
 '2015': 16.313,
 '2016': 16.506,
 '2017': 16.714,
 '2018': 16.937,
 '2019': 17.174,
 '2020': 17.427,
 '2021': 17.695,
 '2022': 17.98,
 '2023': 18.28,
 '2024': 18.598,
 '2025': 18.933,
 '2026': 19.286,
 '2027': 19.658,
 '2028': 20.048,
 '2029': 20.457,
 '2030': 20.886,
 '2031': 21.335,
 '2032': 21.804,
 '2033': 22.293,
 '2034': 22.802,
 '2035': 23.32,
 '2036': 23.847,
 '2037': 24.381,
 '2038': 24.924,
 '2039': 25.474,
 '2040': 26.033,
 '2041': 26.599,
 '2042': 27.173,
 '2043': 27.755,
 '2044': 28.345,
 '2045': 28.942,
 '2046': 29.546,
 '2047': 30.158,
 '2048': 30.777,
 '2049': 31.402,
 '2050': 32.035},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '2000': 42.67,
 '2001': 42.559,
 '2002': 42.447,
 '2003': 42.335,
 '2004': 42.223,
 '2005': 42.112,
 '2006': 42.0,
 '2007': 41.889,
 '2008': 41.777,
 '2009': 41.666,
 '2010': 41.555,
 '2011': 41.444,
 '2012': 41.332,
 '2013': 41.222,
 '2014': 41.111,
 '2015': 41.0,
 '2016': 40.91,
 '2017': 40.841,
 '2018': 40.793,
 '2019': 40.766,
 '2020': 40.76,
 '2021': 40.775,
 '2022': 40.81,
 '2023': 40.867,
 '2024': 40.944,
 '2025': 41.043,
 '2026': 41.162,
 '2027': 41.302,
 '2028': 41.464,
 '2029': 41.647,
 '2030': 41.85,
 '2031': 42.076,
 '2032': 42.322,
 '2033': 42.59,
 '2034': 42.879,
 '2035': 43.19,
 '2036': 43.523,
 '2037': 43.877,
 '2038': 44.253,
 '2039': 44.65,
 '2040': 45.069,
 '2041': 45.509,
 '2042': 45.95,
 '2043': 46.391,
 '2044': 46.834,
 '2045': 47.276,
 '2046': 47.719,
 '2047': 48.163,
 '2048': 48.607,
 '2049': 49.051,
 '2050': 49.495},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '2000': 47.731,
 '2001': 48.998,
 '2002': 50.269,
 '2003': 50.326,
 '2004': 50.279,
 '2005': 50.232,
 '2006': 50.185,
 '2007': 50.137,
 '2008': 49.781,
 '2009': 49.368,
 '2010': 48.954,
 '2011': 48.541,
 '2012': 48.128,
 '2013': 47.715,
 '2014': 47.336,
 '2015': 46.989,
 '2016': 46.676,
 '2017': 46.395,
 '2018': 46.148,
 '2019': 45.933,
 '2020': 45.751,
 '2021': 45.602,
 '2022': 45.486,
 '2023': 45.403,
 '2024': 45.352,
 '2025': 45.334,
 '2026': 45.349,
 '2027': 45.397,
 '2028': 45.477,
 '2029': 45.59,
 '2030': 45.735,
 '2031': 45.914,
 '2032': 46.125,
 '2033': 46.369,
 '2034': 46.647,
 '2035': 46.957,
 '2036': 47.3,
 '2037': 47.675,
 '2038': 48.084,
 '2039': 48.525,
 '2040': 48.966,
 '2041': 49.408,
 '2042': 49.85,
 '2043': 50.291,
 '2044': 50.733,
 '2045': 51.175,
 '2046': 51.616,
 '2047': 52.057,
 '2048': 52.498,
 '2049': 52.939,
 '2050': 53.379},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '2000': 29.098,
 '2001': 29.277,
 '2002': 29.457,
 '2003': 29.637,
 '2004': 29.818,
 '2005': 29.999,
 '2006': 30.182,
 '2007': 30.364,
 '2008': 30.832,
 '2009': 31.328,
 '2010': 31.83,
 '2011': 32.336,
 '2012': 32.846,
 '2013': 33.36,
 '2014': 33.878,
 '2015': 34.4,
 '2016': 34.926,
 '2017': 35.455,
 '2018': 35.988,
 '2019': 36.528,
 '2020': 37.074,
 '2021': 37.628,
 '2022': 38.187,
 '2023': 38.753,
 '2024': 39.326,
 '2025': 39.904,
 '2026': 40.487,
 '2027': 41.076,
 '2028': 41.671,
 '2029': 42.27,
 '2030': 42.874,
 '2031': 43.483,
 '2032': 44.095,
 '2033': 44.711,
 '2034': 45.33,
 '2035': 45.953,
 '2036': 46.577,
 '2037': 47.204,
 '2038': 47.832,
 '2039': 48.461,
 '2040': 49.09,
 '2041': 49.718,
 '2042': 50.344,
 '2043': 50.968,
 '2044': 51.586,
 '2045': 52.205,
 '2046': 52.824,
 '2047': 53.442,
 '2048': 54.059,
 '2049': 54.675,
 '2050': 55.29},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '2000': 91.169,
 '2001': 92.548,
 '2002': 93.728,
 '2003': 94.732,
 '2004': 95.584,
 '2005': 96.302,
 '2006': 96.907,
 '2007': 97.416,
 '2008': 97.844,
 '2009': 98.201,
 '2010': 98.501,
 '2011': 98.743,
 '2012': 98.94,
 '2013': 99.1,
 '2014': 99.231,
 '2015': 99.339,
 '2016': 99.429,
 '2017': 99.503,
 '2018': 99.564,
 '2019': 99.616,
 '2020': 99.659,
 '2021': 99.696,
 '2022': 99.726,
 '2023': 99.753,
 '2024': 99.775,
 '2025': 99.794,
 '2026': 99.81,
 '2027': 99.823,
 '2028': 99.835,
 '2029': 99.845,
 '2030': 99.853,
 '2031': 99.86,
 '2032': 99.866,
 '2033': 99.87,
 '2034': 99.874,
 '2035': 99.877,
 '2036': 99.879,
 '2037': 99.881,
 '2038': 99.883,
 '2039': 99.884,
 '2040': 99.886,
 '2041': 99.888,
 '2042': 99.89,
 '2043': 99.892,
 '2044': 99.893,
 '2045': 99.895,
 '2046': 99.897,
 '2047': 99.898,
 '2048': 99.9,
 '2049': 99.901,
 '2050': 99.903},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '2000': 14.926,
 '2001': 15.829,
 '2002': 16.777,
 '2003': 16.904,
 '2004': 16.908,
 '2005': 16.912,
 '2006': 16.917,
 '2007': 16.921,
 '2008': 16.925,
 '2009': 16.93,
 '2010': 16.934,
 '2011': 16.938,
 '2012': 16.943,
 '2013': 16.947,
 '2014': 16.967,
 '2015': 17.004,
 '2016': 17.056,
 '2017': 17.125,
 '2018': 17.211,
 '2019': 17.313,
 '2020': 17.432,
 '2021': 17.568,
 '2022': 17.721,
 '2023': 17.892,
 '2024': 18.081,
 '2025': 18.289,
 '2026': 18.515,
 '2027': 18.761,
 '2028': 19.027,
 '2029': 19.313,
 '2030': 19.619,
 '2031': 19.947,
 '2032': 20.297,
 '2033': 20.67,
 '2034': 21.065,
 '2035': 21.485,
 '2036': 21.928,
 '2037': 22.396,
 '2038': 22.888,
 '2039': 23.405,
 '2040': 23.931,
 '2041': 24.465,
 '2042': 25.007,
 '2043': 25.557,
 '2044': 26.115,
 '2045': 26.681,
 '2046': 27.254,
 '2047': 27.835,
 '2048': 28.424,
 '2049': 29.02,
 '2050': 29.624},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '2000': 50.433,
 '2001': 50.646,
 '2002': 50.876,
 '2003': 51.123,
 '2004': 51.388,
 '2005': 51.67,
 '2006': 51.969,
 '2007': 52.285,
 '2008': 52.619,
 '2009': 52.969,
 '2010': 53.336,
 '2011': 53.72,
 '2012': 54.12,
 '2013': 54.537,
 '2014': 54.969,
 '2015': 55.4,
 '2016': 55.831,
 '2017': 56.261,
 '2018': 56.691,
 '2019': 57.119,
 '2020': 57.546,
 '2021': 57.972,
 '2022': 58.396,
 '2023': 58.82,
 '2024': 59.242,
 '2025': 59.663,
 '2026': 60.082,
 '2027': 60.5,
 '2028': 60.917,
 '2029': 61.331,
 '2030': 61.745,
 '2031': 62.156,
 '2032': 62.566,
 '2033': 62.974,
 '2034': 63.38,
 '2035': 63.784,
 '2036': 64.187,
 '2037': 64.587,
 '2038': 64.985,
 '2039': 65.381,
 '2040': 65.775,
 '2041': 66.167,
 '2042': 66.557,
 '2043': 66.944,
 '2044': 67.33,
 '2045': 67.712,
 '2046': 68.093,
 '2047': 68.471,
 '2048': 68.847,
 '2049': 69.22,
 '2050': 69.59},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '2000': 33.247,
 '2001': 33.617,
 '2002': 33.99,
 '2003': 34.756,
 '2004': 35.531,
 '2005': 36.311,
 '2006': 37.1,
 '2007': 34.404,
 '2008': 36.011,
 '2009': 37.645,
 '2010': 39.31,
 '2011': 41.0,
 '2012': 41.558,
 '2013': 42.117,
 '2014': 42.679,
 '2015': 43.245,
 '2016': 43.816,
 '2017': 44.391,
 '2018': 44.971,
 '2019': 45.554,
 '2020': 46.141,
 '2021': 46.731,
 '2022': 47.324,
 '2023': 47.92,
 '2024': 48.519,
 '2025': 49.119,
 '2026': 49.722,
 '2027': 50.326,
 '2028': 50.931,
 '2029': 51.538,
 '2030': 52.144,
 '2031': 52.751,
 '2032': 53.357,
 '2033': 53.962,
 '2034': 54.566,
 '2035': 55.167,
 '2036': 55.767,
 '2037': 56.363,
 '2038': 56.954,
 '2039': 57.54,
 '2040': 58.119,
 '2041': 58.697,
 '2042': 59.273,
 '2043': 59.846,
 '2044': 60.417,
 '2045': 60.985,
 '2046': 61.55,
 '2047': 62.112,
 '2048': 62.671,
 '2049': 63.226,
 '2050': 63.778},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '2000': 16.504,
 '2001': 16.632,
 '2002': 16.761,
 '2003': 16.891,
 '2004': 17.023,
 '2005': 17.154,
 '2006': 17.287,
 '2007': 17.42,
 '2008': 17.555,
 '2009': 17.701,
 '2010': 17.86,
 '2011': 18.032,
 '2012': 18.217,
 '2013': 18.415,
 '2014': 18.626,
 '2015': 18.852,
 '2016': 19.092,
 '2017': 19.346,
 '2018': 19.615,
 '2019': 19.899,
 '2020': 20.199,
 '2021': 20.514,
 '2022': 20.846,
 '2023': 21.195,
 '2024': 21.56,
 '2025': 21.943,
 '2026': 22.344,
 '2027': 22.763,
 '2028': 23.2,
 '2029': 23.656,
 '2030': 24.131,
 '2031': 24.625,
 '2032': 25.138,
 '2033': 25.67,
 '2034': 26.22,
 '2035': 26.779,
 '2036': 27.345,
 '2037': 27.919,
 '2038': 28.5,
 '2039': 29.089,
 '2040': 29.684,
 '2041': 30.287,
 '2042': 30.896,
 '2043': 31.512,
 '2044': 32.135,
 '2045': 32.764,
 '2046': 33.399,
 '2047': 34.04,
 '2048': 34.688,
 '2049': 35.34,
 '2050': 35.999},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '2000': 14.786,
 '2001': 15.201,
 '2002': 15.626,
 '2003': 16.061,
 '2004': 16.507,
 '2005': 16.96,
 '2006': 17.425,
 '2007': 17.899,
 '2008': 18.384,
 '2009': 18.878,
 '2010': 19.383,
 '2011': 19.898,
 '2012': 20.424,
 '2013': 20.958,
 '2014': 21.504,
 '2015': 22.06,
 '2016': 22.624,
 '2017': 23.196,
 '2018': 23.774,
 '2019': 24.361,
 '2020': 24.954,
 '2021': 25.553,
 '2022': 26.159,
 '2023': 26.771,
 '2024': 27.389,
 '2025': 28.012,
 '2026': 28.64,
 '2027': 29.273,
 '2028': 29.909,
 '2029': 30.55,
 '2030': 31.193,
 '2031': 31.839,
 '2032': 32.487,
 '2033': 33.137,
 '2034': 33.788,
 '2035': 34.438,
 '2036': 35.089,
 '2037': 35.737,
 '2038': 36.384,
 '2039': 37.027,
 '2040': 37.666,
 '2041': 38.296,
 '2042': 38.933,
 '2043': 39.574,
 '2044': 40.218,
 '2045': 40.866,
 '2046': 41.517,
 '2047': 42.171,
 '2048': 42.827,
 '2049': 43.487,
 '2050': 44.148},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '2000': 22.309,
 '2001': 22.674,
 '2002': 23.044,
 '2003': 23.611,
 '2004': 24.223,
 '2005': 24.845,
 '2006': 25.478,
 '2007': 26.121,
 '2008': 26.776,
 '2009': 27.439,
 '2010': 28.114,
 '2011': 28.798,
 '2012': 29.493,
 '2013': 30.196,
 '2014': 30.904,
 '2015': 31.617,
 '2016': 32.333,
 '2017': 33.053,
 '2018': 33.776,
 '2019': 34.5,
 '2020': 35.227,
 '2021': 35.954,
 '2022': 36.682,
 '2023': 37.409,
 '2024': 38.136,
 '2025': 38.862,
 '2026': 39.585,
 '2027': 40.306,
 '2028': 41.024,
 '2029': 41.738,
 '2030': 42.447,
 '2031': 43.151,
 '2032': 43.849,
 '2033': 44.541,
 '2034': 45.225,
 '2035': 45.901,
 '2036': 46.567,
 '2037': 47.223,
 '2038': 47.867,
 '2039': 48.496,
 '2040': 49.128,
 '2041': 49.761,
 '2042': 50.393,
 '2043': 51.026,
 '2044': 51.658,
 '2045': 52.29,
 '2046': 52.92,
 '2047': 53.55,
 '2048': 54.179,
 '2049': 54.807,
 '2050': 55.433},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '2000': 34.802,
 '2001': 35.002,
 '2002': 35.475,
 '2003': 35.951,
 '2004': 36.43,
 '2005': 36.911,
 '2006': 37.395,
 '2007': 37.881,
 '2008': 38.371,
 '2009': 38.861,
 '2010': 39.355,
 '2011': 39.851,
 '2012': 40.354,
 '2013': 40.865,
 '2014': 41.382,
 '2015': 41.907,
 '2016': 42.438,
 '2017': 42.976,
 '2018': 43.521,
 '2019': 44.072,
 '2020': 44.629,
 '2021': 45.192,
 '2022': 45.761,
 '2023': 46.335,
 '2024': 46.914,
 '2025': 47.498,
 '2026': 48.087,
 '2027': 48.679,
 '2028': 49.276,
 '2029': 49.875,
 '2030': 50.478,
 '2031': 51.083,
 '2032': 51.69,
 '2033': 52.298,
 '2034': 52.906,
 '2035': 53.513,
 '2036': 54.119,
 '2037': 54.721,
 '2038': 55.323,
 '2039': 55.923,
 '2040': 56.522,
 '2041': 57.12,
 '2042': 57.715,
 '2043': 58.307,
 '2044': 58.898,
 '2045': 59.486,
 '2046': 60.071,
 '2047': 60.653,
 '2048': 61.232,
 '2049': 61.808,
 '2050': 62.381},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '2000': 33.758,
 '2001': 34.17,
 '2002': 34.585,
 '2003': 34.479,
 '2004': 34.294,
 '2005': 34.11,
 '2006': 33.926,
 '2007': 33.743,
 '2008': 33.56,
 '2009': 33.378,
 '2010': 33.196,
 '2011': 33.015,
 '2012': 32.834,
 '2013': 32.654,
 '2014': 32.504,
 '2015': 32.385,
 '2016': 32.296,
 '2017': 32.237,
 '2018': 32.209,
 '2019': 32.21,
 '2020': 32.242,
 '2021': 32.303,
 '2022': 32.395,
 '2023': 32.517,
 '2024': 32.67,
 '2025': 32.853,
 '2026': 33.067,
 '2027': 33.313,
 '2028': 33.589,
 '2029': 33.897,
 '2030': 34.238,
 '2031': 34.61,
 '2032': 35.015,
 '2033': 35.452,
 '2034': 35.923,
 '2035': 36.426,
 '2036': 36.962,
 '2037': 37.532,
 '2038': 38.133,
 '2039': 38.765,
 '2040': 39.403,
 '2041': 40.044,
 '2042': 40.689,
 '2043': 41.337,
 '2044': 41.989,
 '2045': 42.643,
 '2046': 43.299,
 '2047': 43.958,
 '2048': 44.619,
 '2049': 45.282,
 '2050': 45.947},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '2000': 39.73368448,
 '2001': 40.2941129039,
 '2002': 40.8554414164,
 '2003': 41.4182993226,
 '2004': 41.98555768,
 '2005': 42.5596312516,
 '2006': 43.0719133591,
 '2007': 43.5916437589,
 '2008': 44.1177394432,
 '2009': 44.6477017583,
 '2010': 45.1824940212,
 '2011': 45.7216204202,
 '2012': 46.2652946361,
 '2013': 46.8053277981,
 '2014': 47.3486415632,
 '2015': 47.8933227435,
 '2016': 48.4389962509,
 '2017': 48.9857165868,
 '2018': 49.5339077515,
 '2019': 50.0841643174,
 '2020': 50.6368306776,
 '2021': 51.1918133026,
 '2022': 51.7488109218,
 '2023': 52.3076429081,
 '2024': 52.8680713937,
 '2025': 53.42981937,
 '2026': 53.9925889068,
 '2027': 54.5559776408,
 '2028': 55.1193930421,
 '2029': 55.6819842234,
 '2030': 56.242268097,
 '2031': 56.8021769248,
 '2032': 57.3601042529,
 '2033': 57.9171110571,
 '2034': 58.4729058774,
 '2035': 59.0272052829,
 '2036': 59.5785787794,
 '2037': 60.126691131,
 '2038': 60.671366213,
 '2039': 61.2124070986,
 '2040': 61.7495796884,
 '2041': 62.2849615646,
 '2042': 62.8182585884,
 '2043': 63.3493164331,
 '2044': 63.8779835588,
 '2045': 64.4041210466,
 '2046': 64.9275939853,
 '2047': 65.4482726062,
 '2048': 65.9660335807,
 '2049': 66.4807558082,
 '2050': 66.9923184886},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '2000': 50.087,
 '2001': 51.274,
 '2002': 52.461,
 '2003': 53.645,
 '2004': 54.827,
 '2005': 56.0,
 '2006': 56.764,
 '2007': 57.524,
 '2008': 58.282,
 '2009': 59.034,
 '2010': 59.783,
 '2011': 60.528,
 '2012': 61.268,
 '2013': 62.002,
 '2014': 62.731,
 '2015': 63.446,
 '2016': 64.149,
 '2017': 64.839,
 '2018': 65.514,
 '2019': 66.177,
 '2020': 66.825,
 '2021': 67.46,
 '2022': 68.081,
 '2023': 68.688,
 '2024': 69.281,
 '2025': 69.86,
 '2026': 70.425,
 '2027': 70.976,
 '2028': 71.513,
 '2029': 72.037,
 '2030': 72.546,
 '2031': 73.042,
 '2032': 73.524,
 '2033': 73.993,
 '2034': 74.448,
 '2035': 74.889,
 '2036': 75.317,
 '2037': 75.731,
 '2038': 76.132,
 '2039': 76.518,
 '2040': 76.89,
 '2041': 77.258,
 '2042': 77.623,
 '2043': 77.983,
 '2044': 78.339,
 '2045': 78.691,
 '2046': 79.039,
 '2047': 79.382,
 '2048': 79.721,
 '2049': 80.057,
 '2050': 80.388},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '2000': 45.542,
 '2001': 46.139,
 '2002': 46.738,
 '2003': 47.338,
 '2004': 47.94,
 '2005': 48.541,
 '2006': 49.143,
 '2007': 49.746,
 '2008': 50.35,
 '2009': 50.954,
 '2010': 51.559,
 '2011': 52.164,
 '2012': 52.769,
 '2013': 53.373,
 '2014': 53.976,
 '2015': 54.578,
 '2016': 55.179,
 '2017': 55.777,
 '2018': 56.374,
 '2019': 56.968,
 '2020': 57.56,
 '2021': 58.148,
 '2022': 58.733,
 '2023': 59.315,
 '2024': 59.892,
 '2025': 60.464,
 '2026': 61.032,
 '2027': 61.594,
 '2028': 62.15,
 '2029': 62.7,
 '2030': 63.242,
 '2031': 63.777,
 '2032': 64.301,
 '2033': 64.823,
 '2034': 65.342,
 '2035': 65.858,
 '2036': 66.37,
 '2037': 66.877,
 '2038': 67.381,
 '2039': 67.881,
 '2040': 68.377,
 '2041': 68.869,
 '2042': 69.357,
 '2043': 69.84,
 '2044': 70.319,
 '2045': 70.793,
 '2046': 71.264,
 '2047': 71.729,
 '2048': 72.19,
 '2049': 72.646,
 '2050': 73.098},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '2000': 37.639,
 '2001': 37.72,
 '2002': 37.802,
 '2003': 37.884,
 '2004': 37.966,
 '2005': 38.069,
 '2006': 38.193,
 '2007': 38.339,
 '2008': 38.506,
 '2009': 38.694,
 '2010': 38.904,
 '2011': 39.135,
 '2012': 39.388,
 '2013': 39.663,
 '2014': 39.959,
 '2015': 40.277,
 '2016': 40.618,
 '2017': 40.98,
 '2018': 41.364,
 '2019': 41.77,
 '2020': 42.198,
 '2021': 42.648,
 '2022': 43.12,
 '2023': 43.614,
 '2024': 44.13,
 '2025': 44.666,
 '2026': 45.223,
 '2027': 45.801,
 '2028': 46.399,
 '2029': 47.014,
 '2030': 47.646,
 '2031': 48.28,
 '2032': 48.916,
 '2033': 49.551,
 '2034': 50.187,
 '2035': 50.823,
 '2036': 51.458,
 '2037': 52.093,
 '2038': 52.727,
 '2039': 53.361,
 '2040': 53.993,
 '2041': 54.624,
 '2042': 55.253,
 '2043': 55.881,
 '2044': 56.507,
 '2045': 57.131,
 '2046': 57.753,
 '2047': 58.372,
 '2048': 58.989,
 '2049': 59.602,
 '2050': 60.213},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '2000': 21.637,
 '2001': 21.67,
 '2002': 21.702,
 '2003': 21.735,
 '2004': 21.768,
 '2005': 21.801,
 '2006': 21.834,
 '2007': 21.868,
 '2008': 21.901,
 '2009': 21.934,
 '2010': 21.985,
 '2011': 22.054,
 '2012': 22.142,
 '2013': 22.248,
 '2014': 22.372,
 '2015': 22.515,
 '2016': 22.677,
 '2017': 22.858,
 '2018': 23.059,
 '2019': 23.279,
 '2020': 23.52,
 '2021': 23.781,
 '2022': 24.063,
 '2023': 24.366,
 '2024': 24.691,
 '2025': 25.038,
 '2026': 25.407,
 '2027': 25.799,
 '2028': 26.215,
 '2029': 26.654,
 '2030': 27.117,
 '2031': 27.604,
 '2032': 28.116,
 '2033': 28.653,
 '2034': 29.214,
 '2035': 29.798,
 '2036': 30.39,
 '2037': 30.989,
 '2038': 31.594,
 '2039': 32.206,
 '2040': 32.824,
 '2041': 33.448,
 '2042': 34.077,
 '2043': 34.713,
 '2044': 35.353,
 '2045': 36.0,
 '2046': 36.651,
 '2047': 37.307,
 '2048': 37.968,
 '2049': 38.633,
 '2050': 39.303},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '2000': 58.695,
 '2001': 59.156,
 '2002': 59.617,
 '2003': 60.076,
 '2004': 60.533,
 '2005': 60.988,
 '2006': 61.441,
 '2007': 61.893,
 '2008': 62.346,
 '2009': 62.8,
 '2010': 63.256,
 '2011': 63.712,
 '2012': 64.169,
 '2013': 64.627,
 '2014': 65.085,
 '2015': 65.543,
 '2016': 66.001,
 '2017': 66.459,
 '2018': 66.916,
 '2019': 67.373,
 '2020': 67.829,
 '2021': 68.283,
 '2022': 68.736,
 '2023': 69.188,
 '2024': 69.638,
 '2025': 70.085,
 '2026': 70.53,
 '2027': 70.973,
 '2028': 71.412,
 '2029': 71.848,
 '2030': 72.28,
 '2031': 72.708,
 '2032': 73.131,
 '2033': 73.548,
 '2034': 73.962,
 '2035': 74.372,
 '2036': 74.777,
 '2037': 75.179,
 '2038': 75.576,
 '2039': 75.968,
 '2040': 76.357,
 '2041': 76.74,
 '2042': 77.12,
 '2043': 77.495,
 '2044': 77.866,
 '2045': 78.232,
 '2046': 78.594,
 '2047': 78.952,
 '2048': 79.305,
 '2049': 79.654,
 '2050': 79.998},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '2000': 35.122,
 '2001': 35.587,
 '2002': 36.055,
 '2003': 36.526,
 '2004': 37.0,
 '2005': 37.481,
 '2006': 37.971,
 '2007': 38.47,
 '2008': 38.976,
 '2009': 39.491,
 '2010': 40.013,
 '2011': 40.544,
 '2012': 41.082,
 '2013': 41.627,
 '2014': 42.18,
 '2015': 42.74,
 '2016': 43.307,
 '2017': 43.88,
 '2018': 44.46,
 '2019': 45.046,
 '2020': 45.638,
 '2021': 46.235,
 '2022': 46.837,
 '2023': 47.444,
 '2024': 48.055,
 '2025': 48.669,
 '2026': 49.286,
 '2027': 49.905,
 '2028': 50.525,
 '2029': 51.145,
 '2030': 51.762,
 '2031': 52.381,
 '2032': 52.999,
 '2033': 53.616,
 '2034': 54.232,
 '2035': 54.847,
 '2036': 55.46,
 '2037': 56.072,
 '2038': 56.681,
 '2039': 57.289,
 '2040': 57.895,
 '2041': 58.498,
 '2042': 59.099,
 '2043': 59.697,
 '2044': 60.292,
 '2045': 60.884,
 '2046': 61.473,
 '2047': 62.058,
 '2048': 62.64,
 '2049': 63.219,
 '2050': 63.794},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '2000': 49.092,
 '2001': 50.832,
 '2002': 52.573,
 '2003': 54.307,
 '2004': 56.033,
 '2005': 57.74,
 '2006': 59.431,
 '2007': 61.1,
 '2008': 62.745,
 '2009': 64.358,
 '2010': 65.94,
 '2011': 67.488,
 '2012': 69.0,
 '2013': 69.544,
 '2014': 70.083,
 '2015': 70.616,
 '2016': 71.138,
 '2017': 71.646,
 '2018': 72.143,
 '2019': 72.627,
 '2020': 73.1,
 '2021': 73.561,
 '2022': 74.01,
 '2023': 74.448,
 '2024': 74.874,
 '2025': 75.29,
 '2026': 75.695,
 '2027': 76.088,
 '2028': 76.472,
 '2029': 76.845,
 '2030': 77.207,
 '2031': 77.56,
 '2032': 77.903,
 '2033': 78.236,
 '2034': 78.559,
 '2035': 78.874,
 '2036': 79.179,
 '2037': 79.475,
 '2038': 79.762,
 '2039': 80.04,
 '2040': 80.31,
 '2041': 80.571,
 '2042': 80.829,
 '2043': 81.085,
 '2044': 81.338,
 '2045': 81.589,
 '2046': 81.837,
 '2047': 82.083,
 '2048': 82.325,
 '2049': 82.566,
 '2050': 82.803},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '2000': 78.879,
 '2001': 79.633,
 '2002': 80.368,
 '2003': 81.083,
 '2004': 81.778,
 '2005': 82.452,
 '2006': 83.107,
 '2007': 83.742,
 '2008': 84.359,
 '2009': 84.955,
 '2010': 85.533,
 '2011': 86.092,
 '2012': 86.634,
 '2013': 87.156,
 '2014': 87.651,
 '2015': 88.118,
 '2016': 88.559,
 '2017': 88.976,
 '2018': 89.37,
 '2019': 89.741,
 '2020': 90.092,
 '2021': 90.423,
 '2022': 90.735,
 '2023': 91.029,
 '2024': 91.307,
 '2025': 91.568,
 '2026': 91.814,
 '2027': 92.046,
 '2028': 92.264,
 '2029': 92.47,
 '2030': 92.663,
 '2031': 92.844,
 '2032': 93.014,
 '2033': 93.173,
 '2034': 93.322,
 '2035': 93.462,
 '2036': 93.592,
 '2037': 93.713,
 '2038': 93.826,
 '2039': 93.93,
 '2040': 94.033,
 '2041': 94.134,
 '2042': 94.233,
 '2043': 94.331,
 '2044': 94.428,
 '2045': 94.522,
 '2046': 94.616,
 '2047': 94.707,
 '2048': 94.798,
 '2049': 94.886,
 '2050': 94.974},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '2000': 53.424,
 '2001': 54.377,
 '2002': 55.555,
 '2003': 56.766,
 '2004': 57.972,
 '2005': 59.165,
 '2006': 60.348,
 '2007': 61.52,
 '2008': 62.68,
 '2009': 63.823,
 '2010': 64.952,
 '2011': 66.064,
 '2012': 67.16,
 '2013': 68.208,
 '2014': 69.213,
 '2015': 70.174,
 '2016': 71.092,
 '2017': 71.968,
 '2018': 72.803,
 '2019': 73.598,
 '2020': 74.354,
 '2021': 75.073,
 '2022': 75.755,
 '2023': 76.401,
 '2024': 77.014,
 '2025': 77.593,
 '2026': 78.14,
 '2027': 78.657,
 '2028': 79.144,
 '2029': 79.602,
 '2030': 80.032,
 '2031': 80.436,
 '2032': 80.814,
 '2033': 81.166,
 '2034': 81.495,
 '2035': 81.8,
 '2036': 82.083,
 '2037': 82.343,
 '2038': 82.582,
 '2039': 82.819,
 '2040': 83.053,
 '2041': 83.284,
 '2042': 83.513,
 '2043': 83.74,
 '2044': 83.963,
 '2045': 84.185,
 '2046': 84.404,
 '2047': 84.62,
 '2048': 84.834,
 '2049': 85.045,
 '2050': 85.255}]},
'Proportion Urban': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035,
2040,
2045,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950': 29.6065300727,
 '1955': 31.6353576907,
 '1960': 33.7544932274,
 '1965': 35.5872507528,
 '1970': 36.594705586,
 '1975': 37.719835819,
 '1980': 39.3458749966,
 '1985': 41.1987886829,
 '1990': 42.9610276902,
 '1995': 44.7799129182,
 '2000': 46.6770423229,
 '2005': 49.1566419393,
 '2010': 51.6639947069,
 '2015': 53.9278464928,
 '2020': 56.1734831845,
 '2025': 58.3297287747,
 '2030': 60.4272893324,
 '2035': 62.4763262559,
 '2040': 64.4737431803,
 '2045': 66.4184093499,
 '2050': 68.357320132},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950': 54.7678855038,
 '1955': 57.9272897079,
 '1960': 61.0925724018,
 '1965': 64.0597220772,
 '1970': 66.8022854072,
 '1975': 68.8442341566,
 '1980': 70.2887919228,
 '1985': 71.3887553111,
 '1990': 72.3519862535,
 '1995': 73.2986060029,
 '2000': 74.2441341067,
 '2005': 75.8618319792,
 '2010': 77.2454129273,
 '2015': 78.1266909373,
 '2020': 79.0717960517,
 '2025': 80.1608127441,
 '2030': 81.37605385,
 '2035': 82.687607762,
 '2040': 84.0413220818,
 '2045': 85.3569599886,
 '2050': 86.5880493518},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950': 17.6958790516,
 '1955': 19.7096719104,
 '1960': 21.9070630838,
 '1965': 23.9762620066,
 '1970': 25.2694352359,
 '1975': 26.9390144032,
 '1980': 29.4027780446,
 '1985': 32.2335372667,
 '1990': 34.9037010321,
 '1995': 37.4865536824,
 '2000': 40.0530160098,
 '2005': 43.0932154944,
 '2010': 46.1430179714,
 '2015': 48.980517214,
 '2020': 51.7200073479,
 '2025': 54.2783398599,
 '2030': 56.7058182228,
 '2035': 59.0313899524,
 '2040': 61.2651801841,
 '2045': 63.4219108068,
 '2050': 65.5646102643},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950': 7.5384575249,
 '1955': 8.5295953627,
 '1960': 9.659705854,
 '1965': 11.0554710765,
 '1970': 12.8453988468,
 '1975': 14.530163585,
 '1980': 17.1347244785,
 '1985': 19.2571237116,
 '1990': 21.5020660905,
 '1995': 23.3948392575,
 '2000': 25.0170784351,
 '2005': 27.1335725263,
 '2010': 29.4551836248,
 '2015': 31.982104015,
 '2020': 34.6409591804,
 '2025': 37.4444125442,
 '2030': 40.3635579848,
 '2035': 43.3598781628,
 '2040': 46.3823013926,
 '2045': 49.423245735,
 '2050': 52.4724881523},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950': 18.9954418496,
 '1955': 21.1332989754,
 '1960': 23.4792353586,
 '1965': 25.6454786301,
 '1970': 26.8777569513,
 '1975': 28.5445680797,
 '1980': 31.0213465037,
 '1985': 33.9865650486,
 '1990': 36.76749281,
 '1995': 39.5519759781,
 '2000': 42.3832416112,
 '2005': 45.7224817484,
 '2010': 49.0490125643,
 '2015': 52.1238910423,
 '2020': 55.0842562608,
 '2025': 57.8212157346,
 '2030': 60.384496999,
 '2035': 62.8041663134,
 '2040': 65.093540287,
 '2045': 67.2636922445,
 '2050': 69.3916907377},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950': 20.3304699488,
 '1955': 22.2888552634,
 '1960': 24.2910743162,
 '1965': 26.3630354018,
 '1970': 28.5522334404,
 '1975': 30.9109238059,
 '1980': 33.3561442248,
 '1985': 35.6864238577,
 '1990': 37.881113515,
 '1995': 39.6079859439,
 '2000': 41.2286361683,
 '2005': 43.0124886396,
 '2010': 44.9292331896,
 '2015': 46.8185136807,
 '2020': 48.7860341099,
 '2025': 50.8581054462,
 '2030': 53.0667274071,
 '2035': 55.3937167397,
 '2040': 57.7954738581,
 '2045': 60.2299583493,
 '2050': 62.6613054916},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950': 58.5056424131,
 '1955': 61.1431315238,
 '1960': 63.7617793141,
 '1965': 66.2506882582,
 '1970': 68.6809363058,
 '1975': 70.4481100858,
 '1980': 71.8474190728,
 '1985': 73.1141687227,
 '1990': 74.4268633435,
 '1995': 75.6733705012,
 '2000': 76.7989626466,
 '2005': 78.5943741502,
 '2010': 80.0478005604,
 '2015': 80.9461038715,
 '2020': 81.8518274918,
 '2025': 82.8448324667,
 '2030': 83.9173274476,
 '2035': 85.0497487456,
 '2040': 86.2078287231,
 '2045': 87.3378061277,
 '2050': 88.3939365585},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950': 19.8926843494,
 '1955': 22.1659216697,
 '1960': 24.5471630397,
 '1965': 26.6764468408,
 '1970': 27.8311793026,
 '1975': 29.362225518,
 '1980': 31.6565220218,
 '1985': 34.2704304413,
 '1990': 36.7148295505,
 '1995': 39.1417564378,
 '2000': 41.6428125471,
 '2005': 44.7210596247,
 '2010': 47.8604777084,
 '2015': 50.8297536906,
 '2020': 53.7350906802,
 '2025': 56.46219874,
 '2030': 59.0467649648,
 '2035': 61.5128413624,
 '2040': 63.8647655019,
 '2045': 66.1120664402,
 '2050': 68.3227684939},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950': 22.0755839695,
 '1955': 25.0777192223,
 '1960': 28.4046821219,
 '1965': 31.2635344306,
 '1970': 32.1903063032,
 '1975': 33.5909074525,
 '1980': 36.2780461807,
 '1985': 39.791587977,
 '1990': 42.9144869601,
 '1995': 46.4404783647,
 '2000': 50.2600856326,
 '2005': 55.0215043739,
 '2010': 59.7618511966,
 '2015': 64.1181834165,
 '2020': 68.2004750088,
 '2025': 71.7475629945,
 '2030': 74.7611007537,
 '2035': 77.2752895406,
 '2040': 79.3363810139,
 '2045': 81.0178671811,
 '2050': 82.5631794408},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950': 17.2107393625,
 '1955': 18.5604060082,
 '1960': 19.8522607789,
 '1965': 21.1718465406,
 '1970': 22.589011815,
 '1975': 24.3348052034,
 '1980': 26.3472902935,
 '1985': 28.1617414305,
 '1990': 30.0243565795,
 '1995': 31.5908034283,
 '2000': 33.1446154088,
 '2005': 35.0240330015,
 '2010': 37.1160607634,
 '2015': 39.2484654334,
 '2020': 41.5984377993,
 '2025': 44.1756098491,
 '2030': 46.9500212568,
 '2035': 49.8866633368,
 '2040': 52.9203457035,
 '2045': 55.9888345695,
 '2050': 59.0308173605},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950': 9.3156317408,
 '1955': 10.3879247174,
 '1960': 11.9019496992,
 '1965': 13.4683042068,
 '1970': 15.6617155437,
 '1975': 17.4743780441,
 '1980': 19.1070857215,
 '1985': 20.8850016544,
 '1990': 22.7641139322,
 '1995': 24.349608575,
 '2000': 25.677213331,
 '2005': 27.1567492545,
 '2010': 28.9075435933,
 '2015': 30.9313603534,
 '2020': 33.1739484968,
 '2025': 35.6538892068,
 '2030': 38.3422966287,
 '2035': 41.1955511146,
 '2040': 44.1561162703,
 '2045': 47.1665818989,
 '2050': 50.21230204},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950': 11.1024192952,
 '1955': 12.8505865702,
 '1960': 14.8944198043,
 '1965': 16.515058655,
 '1970': 18.3002794072,
 '1975': 20.4168719628,
 '1980': 22.5936391362,
 '1985': 24.8972372205,
 '1990': 27.4739347383,
 '1995': 29.56998743,
 '2000': 31.4167846088,
 '2005': 33.7011036854,
 '2010': 36.1489168998,
 '2015': 38.7756124603,
 '2020': 41.4495586215,
 '2025': 44.1892374168,
 '2030': 46.9681770464,
 '2035': 49.7504535163,
 '2040': 52.5176987258,
 '2045': 55.2865143246,
 '2050': 58.0506553746},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950': 14.2821355169,
 '1955': 16.3070977473,
 '1960': 18.5901844992,
 '1965': 20.5750756827,
 '1970': 22.5502405482,
 '1975': 24.6947749752,
 '1980': 26.7943088923,
 '1985': 29.0743566723,
 '1990': 31.535091192,
 '1995': 33.4509389735,
 '2000': 34.9815929969,
 '2005': 36.878156197,
 '2010': 38.9335812484,
 '2015': 41.1540083778,
 '2020': 43.4517338086,
 '2025': 45.8629594579,
 '2030': 48.370746113,
 '2035': 50.9478568808,
 '2040': 53.5714225434,
 '2045': 56.2370218942,
 '2050': 58.9074820385},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950': 5.747069119,
 '1955': 6.6745058705,
 '1960': 7.7383083169,
 '1965': 9.0657639908,
 '1970': 10.6559320176,
 '1975': 12.4638017262,
 '1980': 14.5598722984,
 '1985': 16.1994466205,
 '1990': 18.047526439,
 '1995': 19.7279006342,
 '2000': 21.0446514354,
 '2005': 22.5163906182,
 '2010': 24.3534794444,
 '2015': 26.5598879217,
 '2020': 28.9700193914,
 '2025': 31.6231866049,
 '2030': 34.4915398308,
 '2035': 37.5282449813,
 '2040': 40.6603826016,
 '2045': 43.8455330353,
 '2050': 47.0896452264},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950': 1.731,
 '1955': 1.896,
 '1960': 2.077,
 '1965': 2.294,
 '1970': 2.845,
 '1975': 3.525,
 '1980': 4.339,
 '1985': 5.221,
 '1990': 6.271,
 '1995': 7.211,
 '2000': 8.246,
 '2005': 9.375,
 '2010': 10.642,
 '2015': 12.078,
 '2020': 13.708,
 '2025': 15.544,
 '2030': 17.598,
 '2035': 19.859,
 '2040': 22.324,
 '2045': 25.0,
 '2050': 27.881},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950': 6.601,
 '1955': 9.15,
 '1960': 12.551,
 '1965': 16.978,
 '1970': 19.39,
 '1975': 21.239,
 '1980': 23.215,
 '1985': 25.469,
 '1990': 27.869,
 '1995': 28.301,
 '2000': 28.08,
 '2005': 27.875,
 '2010': 27.973,
 '2015': 28.47,
 '2020': 29.38,
 '2025': 30.722,
 '2030': 32.523,
 '2035': 34.551,
 '2040': 36.636,
 '2045': 38.773,
 '2050': 40.954},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950': 39.81,
 '1955': 45.011,
 '1960': 50.325,
 '1965': 56.109,
 '1970': 61.777,
 '1975': 67.142,
 '1980': 72.096,
 '1985': 74.925,
 '1990': 75.957,
 '1995': 76.3,
 '2000': 76.532,
 '2005': 76.761,
 '2010': 76.999,
 '2015': 77.417,
 '2020': 78.062,
 '2025': 78.92,
 '2030': 79.969,
 '2035': 81.184,
 '2040': 82.417,
 '2045': 83.587,
 '2050': 84.692},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950': 7.1,
 '1955': 8.351,
 '1960': 9.799,
 '1965': 11.466,
 '1970': 12.678,
 '1975': 13.511,
 '1980': 14.39,
 '1985': 15.757,
 '1990': 18.905,
 '1995': 22.514,
 '2000': 26.587,
 '2005': 31.099,
 '2010': 35.175,
 '2015': 38.206,
 '2020': 41.347,
 '2025': 44.557,
 '2030': 47.786,
 '2035': 50.964,
 '2040': 54.056,
 '2045': 57.119,
 '2050': 60.129},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950': 4.6,
 '1955': 5.444,
 '1960': 6.433,
 '1965': 7.587,
 '1970': 8.588,
 '1975': 9.46,
 '1980': 10.41,
 '1985': 11.453,
 '1990': 12.621,
 '1995': 13.827,
 '2000': 14.74,
 '2005': 15.7,
 '2010': 17.319,
 '2015': 19.428,
 '2020': 21.695,
 '2025': 24.173,
 '2030': 26.856,
 '2035': 29.724,
 '2040': 32.74,
 '2045': 35.84,
 '2050': 39.051},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950': 5.59,
 '1955': 6.419,
 '1960': 7.362,
 '1965': 8.605,
 '1970': 10.295,
 '1975': 12.914,
 '1980': 15.583,
 '1985': 16.079,
 '1990': 16.748,
 '1995': 18.263,
 '2000': 19.892,
 '2005': 21.675,
 '2010': 23.571,
 '2015': 25.658,
 '2020': 27.995,
 '2025': 30.588,
 '2030': 33.427,
 '2035': 36.479,
 '2040': 39.664,
 '2045': 42.942,
 '2050': 46.283},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950': 7.8,
 '1955': 9.122,
 '1960': 10.642,
 '1965': 12.379,
 '1970': 14.1,
 '1975': 16.334,
 '1980': 18.524,
 '1985': 20.933,
 '1990': 23.566,
 '1995': 25.796,
 '2000': 27.121,
 '2005': 28.814,
 '2010': 31.938,
 '2015': 35.193,
 '2020': 38.534,
 '2025': 41.904,
 '2030': 45.24,
 '2035': 48.451,
 '2040': 51.626,
 '2045': 54.788,
 '2050': 57.911},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950': 3.506,
 '1955': 3.924,
 '1960': 4.39,
 '1965': 4.908,
 '1970': 6.053,
 '1975': 7.652,
 '1980': 9.05,
 '1985': 10.163,
 '1990': 11.56,
 '1995': 13.263,
 '2000': 14.61,
 '2005': 15.054,
 '2010': 15.544,
 '2015': 16.313,
 '2020': 17.427,
 '2025': 18.933,
 '2030': 20.886,
 '2035': 23.32,
 '2040': 26.033,
 '2045': 28.942,
 '2050': 32.035},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950': 29.327,
 '1955': 31.619,
 '1960': 35.111,
 '1965': 38.767,
 '1970': 42.556,
 '1975': 43.443,
 '1980': 42.351,
 '1985': 42.325,
 '1990': 43.9,
 '1995': 43.284,
 '2000': 42.67,
 '2005': 42.112,
 '2010': 41.555,
 '2015': 41.0,
 '2020': 40.76,
 '2025': 41.043,
 '2030': 41.85,
 '2035': 43.19,
 '2040': 45.069,
 '2045': 47.276,
 '2050': 49.495},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950': 8.52,
 '1955': 11.881,
 '1960': 16.333,
 '1965': 22.033,
 '1970': 25.146,
 '1975': 27.544,
 '1980': 30.08,
 '1985': 32.999,
 '1990': 36.057,
 '1995': 41.458,
 '2000': 47.731,
 '2005': 50.232,
 '2010': 48.954,
 '2015': 46.989,
 '2020': 45.751,
 '2025': 45.334,
 '2030': 45.735,
 '2035': 46.957,
 '2040': 48.966,
 '2045': 51.175,
 '2050': 53.379},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950': 5.472,
 '1955': 6.133,
 '1960': 6.868,
 '1965': 7.86,
 '1970': 8.99,
 '1975': 10.869,
 '1980': 13.158,
 '1985': 18.326,
 '1990': 25.0,
 '1995': 27.495,
 '2000': 29.098,
 '2005': 29.999,
 '2010': 31.83,
 '2015': 34.4,
 '2020': 37.074,
 '2025': 39.904,
 '2030': 42.874,
 '2035': 45.953,
 '2040': 49.09,
 '2045': 52.205,
 '2050': 55.29},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950': 23.493,
 '1955': 27.926,
 '1960': 32.838,
 '1965': 38.154,
 '1970': 41.662,
 '1975': 44.459,
 '1980': 53.48,
 '1985': 67.916,
 '1990': 81.227,
 '1995': 86.119,
 '2000': 91.169,
 '2005': 96.302,
 '2010': 98.501,
 '2015': 99.339,
 '2020': 99.659,
 '2025': 99.794,
 '2030': 99.853,
 '2035': 99.877,
 '2040': 99.886,
 '2045': 99.895,
 '2050': 99.903},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950': 2.114,
 '1955': 2.345,
 '1960': 2.6,
 '1965': 2.882,
 '1970': 3.194,
 '1975': 3.998,
 '1980': 4.721,
 '1985': 5.057,
 '1990': 5.416,
 '1995': 9.837,
 '2000': 14.926,
 '2005': 16.912,
 '2010': 16.934,
 '2015': 17.004,
 '2020': 17.432,
 '2025': 18.289,
 '2030': 19.619,
 '2035': 21.485,
 '2040': 23.931,
 '2045': 26.681,
 '2050': 29.624},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950': 27.399,
 '1955': 27.455,
 '1960': 27.673,
 '1965': 33.123,
 '1970': 39.068,
 '1975': 46.266,
 '1980': 49.366,
 '1985': 49.292,
 '1990': 49.27,
 '1995': 49.633,
 '2000': 50.433,
 '2005': 51.67,
 '2010': 53.336,
 '2015': 55.4,
 '2020': 57.546,
 '2025': 59.663,
 '2030': 61.745,
 '2035': 63.784,
 '2040': 65.775,
 '2045': 67.712,
 '2050': 69.59},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950': 12.726,
 '1955': 14.873,
 '1960': 17.312,
 '1965': 19.964,
 '1970': 22.678,
 '1975': 25.498,
 '1980': 26.763,
 '1985': 28.067,
 '1990': 29.658,
 '1995': 31.425,
 '2000': 33.247,
 '2005': 36.311,
 '2010': 39.31,
 '2015': 43.245,
 '2020': 46.141,
 '2025': 49.119,
 '2030': 52.144,
 '2035': 55.167,
 '2040': 58.119,
 '2045': 60.985,
 '2050': 63.778},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950': 8.865,
 '1955': 8.806,
 '1960': 8.748,
 '1965': 8.69,
 '1970': 8.633,
 '1975': 8.576,
 '1980': 8.519,
 '1985': 9.844,
 '1990': 13.276,
 '1995': 15.873,
 '2000': 16.504,
 '2005': 17.154,
 '2010': 17.86,
 '2015': 18.852,
 '2020': 20.199,
 '2025': 21.943,
 '2030': 24.131,
 '2035': 26.779,
 '2040': 29.684,
 '2045': 32.764,
 '2050': 35.999},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950': 2.82,
 '1955': 3.532,
 '1960': 4.417,
 '1965': 5.509,
 '1970': 6.664,
 '1975': 7.04,
 '1980': 7.534,
 '1985': 9.152,
 '1990': 11.076,
 '1995': 12.846,
 '2000': 14.786,
 '2005': 16.96,
 '2010': 19.383,
 '2015': 22.06,
 '2020': 24.954,
 '2025': 28.012,
 '2030': 31.193,
 '2035': 34.438,
 '2040': 37.666,
 '2045': 40.866,
 '2050': 44.148},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950': 3.491,
 '1955': 4.409,
 '1960': 5.246,
 '1965': 6.03,
 '1970': 7.852,
 '1975': 11.146,
 '1980': 14.555,
 '1985': 16.767,
 '1990': 18.884,
 '1995': 20.543,
 '2000': 22.309,
 '2005': 24.845,
 '2010': 28.114,
 '2015': 31.617,
 '2020': 35.227,
 '2025': 38.862,
 '2030': 42.447,
 '2035': 45.901,
 '2040': 49.128,
 '2045': 52.29,
 '2050': 55.433},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950': 11.5,
 '1955': 14.509,
 '1960': 18.145,
 '1965': 23.372,
 '1970': 30.351,
 '1975': 34.934,
 '1980': 39.815,
 '1985': 39.655,
 '1990': 39.407,
 '1995': 37.104,
 '2000': 34.802,
 '2005': 36.911,
 '2010': 39.355,
 '2015': 41.907,
 '2020': 44.629,
 '2025': 47.498,
 '2030': 50.478,
 '2035': 53.513,
 '2040': 56.522,
 '2045': 59.486,
 '2050': 62.381},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950': 10.644,
 '1955': 11.59,
 '1960': 12.608,
 '1965': 14.62,
 '1970': 17.362,
 '1975': 19.873,
 '1980': 22.371,
 '1985': 25.414,
 '1990': 28.988,
 '1995': 31.732,
 '2000': 33.758,
 '2005': 34.11,
 '2010': 33.196,
 '2015': 32.385,
 '2020': 32.242,
 '2025': 32.853,
 '2030': 34.238,
 '2035': 36.426,
 '2040': 39.403,
 '2045': 42.643,
 '2050': 45.947},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950': 13.9133934901,
 '1955': 15.6272923242,
 '1960': 17.5890139815,
 '1965': 19.5759312311,
 '1970': 21.9209507964,
 '1975': 25.1747324377,
 '1980': 28.0854596216,
 '1985': 30.9611783935,
 '1990': 34.0310122261,
 '1995': 36.939246404,
 '2000': 39.73368448,
 '2005': 42.5596312516,
 '2010': 45.1824940212,
 '2015': 47.8933227435,
 '2020': 50.6368306776,
 '2025': 53.42981937,
 '2030': 56.242268097,
 '2035': 59.0272052829,
 '2040': 61.7495796884,
 '2045': 64.4041210466,
 '2050': 66.9923184886},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950': 7.576,
 '1955': 8.902,
 '1960': 10.435,
 '1965': 12.504,
 '1970': 14.957,
 '1975': 19.128,
 '1980': 24.298,
 '1985': 30.338,
 '1990': 37.144,
 '1995': 44.169,
 '2000': 50.087,
 '2005': 56.0,
 '2010': 59.783,
 '2015': 63.446,
 '2020': 66.825,
 '2025': 69.86,
 '2030': 72.546,
 '2035': 74.889,
 '2040': 76.89,
 '2045': 78.691,
 '2050': 80.388},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950': 9.333,
 '1955': 11.434,
 '1960': 13.937,
 '1965': 16.88,
 '1970': 20.3,
 '1975': 27.292,
 '1980': 31.921,
 '1985': 36.232,
 '1990': 39.657,
 '1995': 42.573,
 '2000': 45.542,
 '2005': 48.541,
 '2010': 51.559,
 '2015': 54.578,
 '2020': 57.56,
 '2025': 60.464,
 '2030': 63.242,
 '2035': 65.858,
 '2040': 68.377,
 '2045': 70.793,
 '2050': 73.098},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950': 14.418,
 '1955': 17.072,
 '1960': 20.1,
 '1965': 23.519,
 '1970': 27.492,
 '1975': 31.971,
 '1980': 33.874,
 '1985': 35.532,
 '1990': 36.825,
 '1995': 37.231,
 '2000': 37.639,
 '2005': 38.069,
 '2010': 38.904,
 '2015': 40.277,
 '2020': 42.198,
 '2025': 44.666,
 '2030': 47.646,
 '2035': 50.823,
 '2040': 53.993,
 '2045': 57.131,
 '2050': 60.213},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950': 4.5,
 '1955': 5.495,
 '1960': 6.695,
 '1965': 8.406,
 '1970': 11.568,
 '1975': 15.566,
 '1980': 18.787,
 '1985': 19.779,
 '1990': 20.811,
 '1995': 21.473,
 '2000': 21.637,
 '2005': 21.801,
 '2010': 21.985,
 '2015': 22.515,
 '2020': 23.52,
 '2025': 25.038,
 '2030': 27.117,
 '2035': 29.798,
 '2040': 32.824,
 '2045': 36.0,
 '2050': 39.303},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950': 24.926,
 '1955': 28.143,
 '1960': 31.601,
 '1965': 35.273,
 '1970': 39.129,
 '1975': 43.264,
 '1980': 47.857,
 '1985': 52.221,
 '1990': 54.324,
 '1995': 56.413,
 '2000': 58.695,
 '2005': 60.988,
 '2010': 63.256,
 '2015': 65.543,
 '2020': 67.829,
 '2025': 70.085,
 '2030': 72.28,
 '2035': 74.372,
 '2040': 76.357,
 '2045': 78.232,
 '2050': 79.998},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950': 19.1,
 '1955': 20.654,
 '1960': 22.3,
 '1965': 23.434,
 '1970': 24.608,
 '1975': 25.821,
 '1980': 27.072,
 '1985': 28.513,
 '1990': 30.633,
 '1995': 32.838,
 '2000': 35.122,
 '2005': 37.481,
 '2010': 40.013,
 '2015': 42.74,
 '2020': 45.638,
 '2025': 48.669,
 '2030': 51.762,
 '2035': 54.847,
 '2040': 57.895,
 '2045': 60.884,
 '2050': 63.794},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950': 15.463,
 '1955': 20.355,
 '1960': 25.537,
 '1965': 26.502,
 '1970': 26.954,
 '1975': 27.41,
 '1980': 27.872,
 '1985': 29.94,
 '1990': 34.745,
 '1995': 40.494,
 '2000': 49.092,
 '2005': 57.74,
 '2010': 65.94,
 '2015': 70.616,
 '2020': 73.1,
 '2025': 75.29,
 '2030': 77.207,
 '2035': 78.874,
 '2040': 80.31,
 '2045': 81.589,
 '2050': 82.803},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950': 11.4,
 '1955': 14.135,
 '1960': 17.398,
 '1965': 23.775,
 '1970': 32.0,
 '1975': 42.971,
 '1980': 54.682,
 '1985': 62.402,
 '1990': 69.143,
 '1995': 74.797,
 '2000': 78.879,
 '2005': 82.452,
 '2010': 85.533,
 '2015': 88.118,
 '2020': 90.092,
 '2025': 91.568,
 '2030': 92.663,
 '2035': 93.462,
 '2040': 94.033,
 '2045': 94.522,
 '2050': 94.974},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950': 13.49,
 '1955': 14.735,
 '1960': 16.073,
 '1965': 21.833,
 '1970': 29.518,
 '1975': 31.639,
 '1980': 33.482,
 '1985': 38.049,
 '1990': 43.648,
 '1995': 48.631,
 '2000': 53.424,
 '2005': 59.165,
 '2010': 64.952,
 '2015': 70.174,
 '2020': 74.354,
 '2025': 77.593,
 '2030': 80.032,
 '2035': 81.8,
 '2040': 83.053,
 '2045': 84.185,
 '2050': 85.255},
{'Index': 45,
 'Region, subregion, country or area': 'Northern Africa',
 'Note': '',
 'Country\ncode': 912,
 '1950': 25.9265056945,
 '1955': 28.6365267706,
 '1960': 31.4503742607,
 '1965': 34.4912526517,
 '1970': 37.0309884884,
 '1975': 39.3914049858,
 '1980': 41.3152970508,
 '1985': 43.534529631,
 '1990': 45.7202679358,
 '1995': 47.314158555,
 '2000': 48.3064765086,
 '2005': 49.3427398825,
 '2010': 50.4524414568,
 '2015': 51.3932695255,
 '2020': 52.4562410068,
 '2025': 53.767148736,
 '2030': 55.3457805907,
 '2035': 57.2137486637,
 '2040': 59.3587058539,
 '2045': 61.7066254707,
 '2050': 64.0680175603},
{'Index': 46,
 'Region, subregion, country or area': 'Algeria',
 'Note': '',
 'Country\ncode': 12,
 '1950': 22.213,
 '1955': 26.149,
 '1960': 30.51,
 '1965': 37.643,
 '1970': 39.5,
 '1975': 40.33,
 '1980': 43.542,
 '1985': 47.968,
 '1990': 52.085,
 '1995': 55.997,
 '2000': 59.919,
 '2005': 63.83,
 '2010': 67.54,
 '2015': 70.848,
 '2020': 73.733,
 '2025': 76.212,
 '2030': 78.308,
 '2035': 80.049,
 '2040': 81.63,
 '2045': 83.111,
 '2050': 84.496},
{'Index': 47,
 'Region, subregion, country or area': 'Egypt',
 'Note': '',
 'Country\ncode': 818,
 '1950': 31.928,
 '1955': 34.837,
 '1960': 37.864,
 '1965': 39.686,
 '1970': 41.477,
 '1975': 43.291,
 '1980': 43.858,
 '1985': 43.938,
 '1990': 43.478,
 '1995': 42.814,
 '2000': 42.797,
 '2005': 43.027,
 '2010': 43.019,
 '2015': 42.785,
 '2020': 42.783,
 '2025': 43.444,
 '2030': 44.773,
 '2035': 46.769,
 '2040': 49.415,
 '2045': 52.508,
 '2050': 55.608},
{'Index': 48,
 'Region, subregion, country or area': 'Libya',
 'Note': '',
 'Country\ncode': 434,
 '1950': 19.547,
 '1955': 23.208,
 '1960': 27.323,
 '1965': 33.666,
 '1970': 49.671,
 '1975': 62.785,
 '1980': 70.094,
 '1985': 75.45,
 '1990': 75.723,
 '1995': 75.994,
 '2000': 76.387,
 '2005': 77.08,
 '2010': 78.052,
 '2015': 79.27,
 '2020': 80.691,
 '2025': 82.204,
 '2030': 83.631,
 '2035': 84.964,
 '2040': 86.207,
 '2045': 87.363,
 '2050': 88.434},
{'Index': 49,
 'Region, subregion, country or area': 'Morocco',
 'Note': '',
 'Country\ncode': 504,
 '1950': 26.184,
 '1955': 27.74,
 '1960': 29.357,
 '1965': 31.862,
 '1970': 34.477,
 '1975': 37.714,
 '1980': 41.21,
 '1985': 44.779,
 '1990': 48.391,
 '1995': 51.692,
 '2000': 53.335,
 '2005': 55.174,
 '2010': 58.018,
 '2015': 60.809,
 '2020': 63.532,
 '2025': 66.16,
 '2030': 68.672,
 '2035': 71.042,
 '2040': 73.244,
 '2045': 75.284,
 '2050': 77.218},
{'Index': 50,
 'Region, subregion, country or area': 'Sudan',
 'Note': '',
 'Country\ncode': 729,
 '1950': 6.824,
 '1955': 8.584,
 '1960': 10.746,
 '1965': 13.373,
 '1970': 16.523,
 '1975': 18.943,
 '1980': 19.959,
 '1985': 22.937,
 '1990': 28.61,
 '1995': 32.232,
 '2000': 32.495,
 '2005': 32.76,
 '2010': 33.089,
 '2015': 33.894,
 '2020': 35.253,
 '2025': 37.185,
 '2030': 39.705,
 '2035': 42.772,
 '2040': 46.014,
 '2045': 49.291,
 '2050': 52.573},
{'Index': 51,
 'Region, subregion, country or area': 'Tunisia',
 'Note': '',
 'Country\ncode': 788,
 '1950': 32.293,
 '1955': 35.244,
 '1960': 37.511,
 '1965': 39.724,
 '1970': 43.482,
 '1975': 47.588,
 '1980': 50.569,
 '1985': 53.839,
 '1990': 57.946,
 '1995': 61.474,
 '2000': 63.432,
 '2005': 65.237,
 '2010': 66.657,
 '2015': 68.056,
 '2020': 69.568,
 '2025': 71.22,
 '2030': 72.985,
 '2035': 74.827,
 '2040': 76.702,
 '2045': 78.516,
 '2050': 80.226},
{'Index': 52,
 'Region, subregion, country or area': 'Western Sahara',
 'Note': '',
 'Country\ncode': 732,
 '1950': 31.0,
 '1955': 31.095,
 '1960': 31.19,
 '1965': 36.185,
 '1970': 42.092,
 '1975': 59.458,
 '1980': 75.688,
 '1985': 82.281,
 '1990': 84.089,
 '1995': 85.522,
 '2000': 85.775,
 '2005': 86.023,
 '2010': 86.268,
 '2015': 86.51,
 '2020': 86.829,
 '2025': 87.273,
 '2030': 87.831,
 '2035': 88.488,
 '2040': 89.226,
 '2045': 89.985,
 '2050': 90.696},
{'Index': 53,
 'Region, subregion, country or area': 'Southern Africa',
 'Note': '',
 'Country\ncode': 913,
 '1950': 37.6637856727,
 '1955': 39.7631344608,
 '1960': 41.9805672217,
 '1965': 42.8737879062,
 '1970': 43.7307308993,
 '1975': 44.3069361684,
 '1980': 44.7635821535,
 '1985': 45.9557669491,
 '1990': 48.8398222822,
 '1995': 51.4353488408,
 '2000': 53.8496623547,
 '2005': 56.5343586056,
 '2010': 59.3619997854,
 '2015': 62.0596405476,
 '2020': 64.6322339845,
 '2025': 67.0903314388,
 '2030': 69.4106080257,
 '2035': 71.5735343008,
 '2040': 73.5596535366,
 '2045': 75.4231786933,
 '2050': 77.1928973745},
{'Index': 54,
 'Region, subregion, country or area': 'Botswana',
 'Note': '',
 'Country\ncode': 72,
 '1950': 2.716,
 '1955': 2.883,
 '1960': 3.06,
 '1965': 3.839,
 '1970': 7.834,
 '1975': 11.884,
 '1980': 16.479,
 '1985': 26.724,
 '1990': 41.933,
 '1995': 48.981,
 '2000': 53.219,
 '2005': 55.944,
 '2010': 62.412,
 '2015': 67.155,
 '2020': 70.877,
 '2025': 74.093,
 '2030': 76.822,
 '2035': 79.103,
 '2040': 80.976,
 '2045': 82.504,
 '2050': 83.905},
{'Index': 55,
 'Region, subregion, country or area': 'Lesotho',
 'Note': '',
 'Country\ncode': 426,
 '1950': 1.75,
 '1955': 2.049,
 '1960': 3.512,
 '1965': 6.366,
 '1970': 8.608,
 '1975': 10.822,
 '1980': 11.45,
 '1985': 11.752,
 '1990': 13.967,
 '1995': 16.955,
 '2000': 19.548,
 '2005': 22.249,
 '2010': 24.798,
 '2015': 26.908,
 '2020': 29.028,
 '2025': 31.39,
 '2030': 34.001,
 '2035': 36.85,
 '2040': 39.908,
 '2045': 43.097,
 '2050': 46.351},
{'Index': 56,
 'Region, subregion, country or area': 'Namibia',
 'Note': '',
 'Country\ncode': 516,
 '1950': 13.408,
 '1955': 15.526,
 '1960': 17.909,
 '1965': 20.035,
 '1970': 22.292,
 '1975': 23.651,
 '1980': 25.066,
 '1985': 26.366,
 '1990': 27.656,
 '1995': 29.813,
 '2000': 32.373,
 '2005': 36.632,
 '2010': 41.616,
 '2015': 46.9,
 '2020': 52.033,
 '2025': 56.681,
 '2030': 60.762,
 '2035': 64.233,
 '2040': 67.077,
 '2045': 69.492,
 '2050': 71.807},
{'Index': 57,
 'Region, subregion, country or area': 'South Africa',
 'Note': '',
 'Country\ncode': 710,
 '1950': 42.23,
 '1955': 44.413,
 '1960': 46.619,
 '1965': 47.248,
 '1970': 47.809,
 '1975': 48.109,
 '1980': 48.425,
 '1985': 49.372,
 '1990': 52.037,
 '1995': 54.486,
 '2000': 56.891,
 '2005': 59.536,
 '2010': 62.218,
 '2015': 64.828,
 '2020': 67.354,
 '2025': 69.773,
 '2030': 72.065,
 '2035': 74.209,
 '2040': 76.184,
 '2045': 78.045,
 '2050': 79.798},
{'Index': 58,
 'Region, subregion, country or area': 'Swaziland',
 'Note': '',
 'Country\ncode': 748,
 '1950': 2.2,
 '1955': 2.526,
 '1960': 3.913,
 '1965': 6.494,
 '1970': 9.705,
 '1975': 14.004,
 '1980': 16.478,
 '1985': 18.266,
 '1990': 20.202,
 '1995': 22.286,
 '2000': 22.686,
 '2005': 22.038,
 '2010': 22.48,
 '2015': 23.3,
 '2020': 24.171,
 '2025': 25.245,
 '2030': 26.535,
 '2035': 28.056,
 '2040': 29.824,
 '2045': 31.77,
 '2050': 33.783}]},
'Rate of Natural Population Increase': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950-1955',
'1955-1960',
'1960-1965'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950-1955': 17.824,
 '1955-1960': 18.04,
 '1960-1965': 19.116},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950-1955': '...',
 '1955-1960': '...',
 '1960-1965': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950-1955': 11.787,
 '1955-1960': 11.629,
 '1960-1965': 10.148},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950-1955': 20.617,
 '1955-1960': 20.873,
 '1960-1965': 22.876},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950-1955': 20.013,
 '1955-1960': 22.525,
 '1960-1965': 24.417},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950-1955': 20.693,
 '1955-1960': 20.663,
 '1960-1965': 22.677},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950-1955': 20.83,
 '1955-1960': 23.429,
 '1960-1965': 24.664},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950-1955': 20.422,
 '1955-1960': 22.69,
 '1960-1965': 24.294},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950-1955': 23.844,
 '1955-1960': 25.117,
 '1960-1965': 27.001},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950-1955': '...',
 '1955-1960': '...',
 '1960-1965': '...'}]},
'Rate Proportion Rural': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
'1950-1955',
'1955-1960',
'1960-1965',
'1965-1970',
'1970-1975',
'1975-1980',
'1980-1985',
'1985-1990',
'1990-1995',
'1995-2000',
'2000-2005',
'2005-2010',
'2010-2015',
'2015-2020',
'2020-2025',
'2025-2030',
'2030-2035',
'2035-2040',
'2040-2045',
'2045-2050'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950-1955': -0.5848947294,
 '1955-1960': -0.6297625082,
 '1960-1965': -0.5611211414,
 '1965-1970': -0.3152843426,
 '1970-1975': -0.3580876585,
 '1975-1980': -0.5291067363,
 '1980-1985': -0.62050382,
 '1985-1990': -0.6085539278,
 '1990-1995': -0.6481595087,
 '1995-2000': -0.6991963882,
 '2000-2005': -0.952349368,
 '2005-2010': -1.0114552307,
 '2010-2015': -0.9593602411,
 '2015-2020': -0.9993936231,
 '2020-2025': -1.0090217329,
 '2025-2030': -1.032963963,
 '2030-2035': -1.0633544503,
 '2035-2040': -1.0939996364,
 '2040-2045': -1.1258806463,
 '2045-2050': -1.1894236291},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950-1955': -1.4481602668,
 '1955-1960': -1.5642829139,
 '1960-1965': -1.5865311787,
 '1965-1970': -1.5875515661,
 '1970-1975': -1.2696341715,
 '1975-1980': -0.9494995291,
 '1980-1985': -0.7544907892,
 '1985-1990': -0.6849184335,
 '1990-1995': -0.6967623229,
 '1995-2000': -0.7210674165,
 '2000-2005': -1.2973615967,
 '2005-2010': -1.1805513674,
 '2010-2015': -0.7899925076,
 '2015-2020': -0.8833881759,
 '2020-2025': -1.0687716874,
 '2025-2030': -1.2642191196,
 '2030-2035': -1.4605124141,
 '2035-2040': -1.6283961604,
 '2040-2045': -1.7207522672,
 '2045-2050': -1.7563797821},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950-1955': -0.4954402442,
 '1955-1960': -0.554991003,
 '1960-1965': -0.5370796562,
 '1965-1970': -0.3431291646,
 '1970-1975': -0.4518932759,
 '1975-1980': -0.6860743373,
 '1980-1985': -0.8184674407,
 '1985-1990': -0.8039945302,
 '1990-1995': -0.8097204285,
 '1995-2000': -0.8384220646,
 '2000-2005': -1.0409200366,
 '2005-2010': -1.1016503488,
 '2010-2015': -1.0824895399,
 '2015-2020': -1.103806623,
 '2020-2025': -1.0889018949,
 '2025-2030': -1.0910778671,
 '2030-2035': -1.1042418212,
 '2035-2040': -1.1213446504,
 '2040-2045': -1.1457905429,
 '2045-2050': -1.2072919655},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950-1955': -0.2155465534,
 '1955-1960': -0.2486377433,
 '1960-1965': -0.3114136263,
 '1965-1970': -0.4065867707,
 '1970-1975': -0.3904008627,
 '1975-1980': -0.6189484143,
 '1980-1985': -0.5189272728,
 '1985-1990': -0.5639486811,
 '1990-1995': -0.4881571545,
 '1995-2000': -0.4280814391,
 '2000-2005': -0.5726474136,
 '2005-2010': -0.6475960668,
 '2010-2015': -0.7295470863,
 '2015-2020': -0.797501434,
 '2020-2025': -0.8768042869,
 '2025-2030': -0.9557746066,
 '2030-2035': -1.0309845992,
 '2035-2040': -1.0967677798,
 '2040-2045': -1.1677428523,
 '2045-2050': -1.2436665739},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950-1955': -0.5349265606,
 '1955-1960': -0.603939226,
 '1960-1965': -0.5743530839,
 '1965-1970': -0.3342376017,
 '1970-1975': -0.4611735476,
 '1975-1980': -0.705536769,
 '1980-1985': -0.8787761187,
 '1985-1990': -0.8607951598,
 '1990-1995': -0.9006926895,
 '1995-2000': -0.9594083816,
 '2000-2005': -1.1940671389,
 '2005-2010': -1.2649194545,
 '2010-2015': -1.2449505826,
 '2015-2020': -1.2765647496,
 '2020-2025': -1.2574204253,
 '2025-2030': -1.2539364105,
 '2030-2035': -1.2604754848,
 '2035-2040': -1.2704970638,
 '2040-2045': -1.2837422657,
 '2045-2050': -1.3442654848},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950-1955': -0.4977704938,
 '1955-1960': -0.5220523572,
 '1960-1965': -0.5549785217,
 '1965-1970': -0.6036098189,
 '1970-1975': -0.6714002748,
 '1975-1980': -0.7206755081,
 '1980-1985': -0.7118421897,
 '1985-1990': -0.6944134716,
 '1990-1995': -0.5638638862,
 '1995-2000': -0.5440430395,
 '2000-2005': -0.6164516345,
 '2005-2010': -0.6842623485,
 '2010-2015': -0.698173864,
 '2015-2020': -0.7539613624,
 '2020-2025': -0.8260069117,
 '2025-2030': -0.9197011938,
 '2030-2035': -1.0170426298,
 '2035-2040': -1.1069451908,
 '2040-2045': -1.1882712666,
 '2045-2050': -1.2616746258},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950-1955': -1.3134520058,
 '1955-1960': -1.3954094808,
 '1960-1965': -1.4230871525,
 '1965-1970': -1.4946609684,
 '1970-1975': -1.1615855512,
 '1975-1980': -0.9701732622,
 '1980-1985': -0.9207921131,
 '1985-1990': -1.001139567,
 '1990-1995': -0.9994167341,
 '1995-2000': -0.9474924658,
 '2000-2005': -1.6108642704,
 '2005-2010': -1.4062878559,
 '2010-2015': -0.9213556603,
 '2015-2020': -0.9740346891,
 '2020-2025': -1.1254085054,
 '2025-2030': -1.2911397735,
 '2030-2035': -1.4602869487,
 '2035-2040': -1.6125394719,
 '2040-2045': -1.7096087812,
 '2045-2050': -1.7418604267},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950-1955': -0.5757564256,
 '1955-1960': -0.621431501,
 '1960-1965': -0.5725180452,
 '1965-1970': -0.317475529,
 '1970-1975': -0.428861112,
 '1975-1980': -0.6603782613,
 '1980-1985': -0.7799448808,
 '1985-1990': -0.7579573205,
 '1990-1995': -0.782074877,
 '1995-2000': -0.8392950864,
 '2000-2005': -1.0838103695,
 '2005-2010': -1.1693752905,
 '2010-2015': -1.1726911135,
 '2015-2020': -1.2180983014,
 '2020-2025': -1.2150844092,
 '2025-2030': -1.2239749681,
 '2030-2035': -1.2421232608,
 '2035-2040': -1.2611245913,
 '2040-2045': -1.2841881076,
 '2045-2050': -1.3492167007},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950-1955': -0.7857602335,
 '1955-1960': -0.9084328178,
 '1960-1965': -0.8149965269,
 '1965-1970': -0.2714938623,
 '1970-1975': -0.4174235308,
 '1975-1980': -0.8260967183,
 '1980-1985': -1.1343413999,
 '1985-1990': -1.0652340954,
 '1990-1995': -1.2751356596,
 '1995-2000': -1.4797174527,
 '2000-2005': -2.0124643239,
 '2005-2010': -2.2273795947,
 '2010-2015': -2.2916971103,
 '2015-2020': -2.4155862607,
 '2020-2025': -2.3654326548,
 '2025-2030': -2.2558658862,
 '2030-2035': -2.0986705264,
 '2035-2040': -1.9015656367,
 '2040-2045': -1.6975291661,
 '2045-2050': -1.6982812861},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950-1955': -0.3287356622,
 '1955-1960': -0.3197979123,
 '1960-1965': -0.332029227,
 '1965-1970': -0.3628294745,
 '1970-1975': -0.4562092027,
 '1975-1980': -0.5391468539,
 '1980-1985': -0.4988750121,
 '1985-1990': -0.5253990587,
 '1990-1995': -0.4527992394,
 '1995-2000': -0.4595084145,
 '2000-2005': -0.5702876925,
 '2005-2010': -0.6545333998,
 '2010-2015': -0.6899690159,
 '2015-2020': -0.7889940554,
 '2020-2025': -0.9026353224,
 '2025-2030': -1.01952818,
 '2030-2035': -1.1389458167,
 '2035-2040': -1.2489246812,
 '2040-2045': -1.3479515592,
 '2045-2050': -1.4324644074},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950-1955': -0.2378983409,
 '1955-1960': -0.3407935501,
 '1960-1965': -0.3587925999,
 '1965-1970': -0.5134972974,
 '1970-1975': -0.4345418604,
 '1975-1980': -0.3996516046,
 '1980-1985': -0.4444752959,
 '1985-1990': -0.480765496,
 '1990-1995': -0.4148316017,
 '1995-2000': -0.3541005006,
 '2000-2005': -0.4021541382,
 '2005-2010': -0.4865729924,
 '2010-2015': -0.577608904,
 '2015-2020': -0.6601558108,
 '2020-2025': -0.7563300639,
 '2025-2030': -0.8535663754,
 '2030-2035': -0.947613235,
 '2035-2040': -1.0331501258,
 '2040-2045': -1.1083219597,
 '2045-2050': -1.1875196898},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950-1955': -0.3972177424,
 '1955-1960': -0.4746287143,
 '1960-1965': -0.3845266645,
 '1965-1970': -0.4323138095,
 '1970-1975': -0.5249694178,
 '1975-1980': -0.5546630426,
 '1980-1985': -0.6042322564,
 '1985-1990': -0.6982265601,
 '1990-1995': -0.5865306173,
 '1995-2000': -0.5314331207,
 '2000-2005': -0.6774916197,
 '2005-2010': -0.7523940936,
 '2010-2015': -0.8401589236,
 '2015-2020': -0.893139417,
 '2020-2025': -0.9584379976,
 '2025-2030': -1.0214912435,
 '2030-2035': -1.0778128951,
 '2035-2040': -1.1328896969,
 '2040-2045': -1.2016377554,
 '2045-2050': -1.2762467809},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950-1955': -0.4781416708,
 '1955-1960': -0.5531664953,
 '1960-1965': -0.4936724403,
 '1965-1970': -0.5036553253,
 '1970-1975': -0.5615987834,
 '1975-1980': -0.5655271304,
 '1980-1985': -0.6328222826,
 '1985-1990': -0.7062143471,
 '1990-1995': -0.5676379677,
 '1995-2000': -0.4653804196,
 '2000-2005': -0.5920705457,
 '2005-2010': -0.6620956673,
 '2010-2015': -0.7407676841,
 '2015-2020': -0.7965835453,
 '2020-2025': -0.8715184542,
 '2025-2030': -0.94860344,
 '2030-2035': -1.0240914007,
 '2035-2040': -1.0993742898,
 '2040-2045': -1.1825390375,
 '2045-2050': -1.2592430207},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950-1955': -0.1977720644,
 '1955-1960': -0.22928611,
 '1960-1965': -0.2898489992,
 '1965-1970': -0.3528343087,
 '1970-1975': -0.4088489246,
 '1975-1980': -0.4847306506,
 '1980-1985': -0.3875251761,
 '1985-1990': -0.4460024504,
 '1990-1995': -0.4143476583,
 '1995-2000': -0.3307924194,
 '2000-2005': -0.3763212498,
 '2005-2010': -0.4798995389,
 '2010-2015': -0.5920234554,
 '2015-2020': -0.6673644485,
 '2020-2025': -0.761365366,
 '2025-2030': -0.8570896904,
 '2030-2035': -0.9492952459,
 '2035-2040': -1.0287473534,
 '2040-2045': -1.1034187014,
 '2045-2050': -1.1901434007},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950-1955': -0.0336095163,
 '1955-1960': -0.0369336982,
 '1960-1965': -0.044369718,
 '1965-1970': -0.1131065669,
 '1970-1975': -0.1404746776,
 '1975-1980': -0.1694643107,
 '1980-1985': -0.1852565231,
 '1985-1990': -0.2228045195,
 '1990-1995': -0.2015908295,
 '1995-2000': -0.2243403114,
 '2000-2005': -0.2476193908,
 '2005-2010': -0.2815868009,
 '2010-2015': -0.3240143068,
 '2015-2020': -0.3742632776,
 '2020-2025': -0.4301241044,
 '2025-2030': -0.4924196044,
 '2030-2035': -0.5564425034,
 '2035-2040': -0.6248250788,
 '2040-2045': -0.7011643163,
 '2045-2050': -0.7834116215},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950-1955': -0.5534168739,
 '1955-1960': -0.763080571,
 '1960-1965': -1.0390026676,
 '1965-1970': -0.5896584324,
 '1970-1975': -0.4640952161,
 '1975-1980': -0.5081728383,
 '1980-1985': -0.5958832472,
 '1985-1990': -0.6546247189,
 '1990-1995': -0.1201421954,
 '1995-2000': 0.0615517931,
 '2000-2005': 0.0569266933,
 '2005-2010': -0.0271935221,
 '2010-2015': -0.138482132,
 '2015-2020': -0.2560710324,
 '2020-2025': -0.3837199005,
 '2025-2030': -0.5268119281,
 '2030-2035': -0.6103117134,
 '2035-2040': -0.6475067315,
 '2040-2045': -0.6861521625,
 '2045-2050': -0.7254293511},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950-1955': -1.8074612066,
 '1955-1960': -2.0326275358,
 '1960-1965': -2.4758500153,
 '1965-1970': -2.7654371801,
 '1970-1975': -3.0248436437,
 '1975-1980': -3.2685039752,
 '1980-1985': -2.1379742776,
 '1985-1990': -0.8405487991,
 '1990-1995': -0.2873769151,
 '1995-2000': -0.1967451415,
 '2000-2005': -0.1961177853,
 '2005-2010': -0.2058841711,
 '2010-2015': -0.3668056482,
 '2015-2020': -0.5795423569,
 '2020-2025': -0.7979113863,
 '2025-2030': -1.0208730026,
 '2030-2035': -1.2514700366,
 '2035-2040': -1.3555009111,
 '2040-2045': -1.3771764483,
 '2045-2050': -1.3939627237},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950-1955': -0.2711516534,
 '1955-1960': -0.3185109934,
 '1960-1965': -0.3730770891,
 '1965-1970': -0.2756844669,
 '1970-1975': -0.1917039492,
 '1975-1980': -0.2043027893,
 '1980-1985': -0.3219323805,
 '1985-1990': -0.7616834558,
 '1990-1995': -0.9104806412,
 '1995-2000': -1.0799248645,
 '2000-2005': -1.268606799,
 '2005-2010': -1.2195872056,
 '2010-2015': -0.9577011811,
 '2015-2020': -1.0433509537,
 '2020-2025': -1.1256651743,
 '2025-2030': -1.2000961562,
 '2030-2035': -1.2559187186,
 '2035-2040': -1.3026291734,
 '2040-2045': -1.3798885235,
 '2045-2050': -1.4555918958},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950-1955': -0.1777265375,
 '1955-1960': -0.2102898873,
 '1960-1965': -0.2482019165,
 '1965-1970': -0.2178180104,
 '1970-1975': -0.1917003773,
 '1975-1980': -0.210960708,
 '1980-1985': -0.2342044424,
 '1985-1990': -0.265570106,
 '1990-1995': -0.2779615129,
 '1995-2000': -0.2130298442,
 '2000-2005': -0.2264709266,
 '2005-2010': -0.3878407089,
 '2010-2015': -0.516772699,
 '2015-2020': -0.570794734,
 '2020-2025': -0.6431405633,
 '2025-2030': -0.7204865778,
 '2030-2035': -0.7999950872,
 '2035-2040': -0.8772928038,
 '2040-2045': -0.9437148551,
 '2045-2050': -1.0268502931},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950-1955': -0.1763925664,
 '1955-1960': -0.2025589356,
 '1960-1965': -0.2701730455,
 '1965-1970': -0.3732852699,
 '1970-1975': -0.5926074544,
 '1975-1980': -0.6225466606,
 '1980-1985': -0.1178584599,
 '1985-1990': -0.1600745506,
 '1990-1995': -0.3673075374,
 '1995-2000': -0.4026210296,
 '2000-2005': -0.4501777481,
 '2005-2010': -0.4900926307,
 '2010-2015': -0.5537227476,
 '2015-2020': -0.6388101375,
 '2020-2025': -0.7335159564,
 '2025-2030': -0.8352134657,
 '2030-2035': -0.9385706011,
 '2035-2040': -1.0288323874,
 '2040-2045': -1.1172129234,
 '2045-2050': -1.2067753875},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950-1955': -0.2888436575,
 '1955-1960': -0.3373434911,
 '1960-1965': -0.3926015578,
 '1965-1970': -0.396737325,
 '1970-1975': -0.5270229337,
 '1975-1980': -0.5304836791,
 '1980-1985': -0.6002580811,
 '1985-1990': -0.6773594188,
 '1990-1995': -0.5921913256,
 '1995-2000': -0.3603505081,
 '2000-2005': -0.470087236,
 '2005-2010': -0.8975423079,
 '2010-2015': -0.9801086452,
 '2015-2020': -1.0585889161,
 '2020-2025': -1.1277472347,
 '2025-2030': -1.182736285,
 '2030-2035': -1.2085437758,
 '2035-2040': -1.2714066466,
 '2040-2045': -1.3519988195,
 '2045-2050': -1.4315222888},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950-1955': -0.0868257063,
 '1955-1960': -0.0972425567,
 '1960-1965': -0.1086514612,
 '1965-1970': -0.2422810113,
 '1970-1975': -0.343334876,
 '1975-1980': -0.3050828941,
 '1980-1985': -0.2462597558,
 '1985-1990': -0.3134512237,
 '1990-1995': -0.388876086,
 '1995-2000': -0.3130310754,
 '2000-2005': -0.1042647486,
 '2005-2010': -0.115701436,
 '2010-2015': -0.1829407972,
 '2015-2020': -0.268017965,
 '2020-2025': -0.3681355464,
 '2025-2030': -0.4877224599,
 '2030-2035': -0.6249786417,
 '2035-2040': -0.7204374077,
 '2040-2045': -0.8024520565,
 '2045-2050': -0.8900715636},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950-1955': -0.6593719273,
 '1955-1960': -1.0483378089,
 '1960-1965': -1.1598371588,
 '1965-1970': -1.2775139936,
 '1970-1975': -0.3112316207,
 '1975-1980': 0.382478427,
 '1980-1985': 0.009018071,
 '1985-1990': -0.5537598306,
 '1990-1995': 0.2184109069,
 '1995-2000': 0.2153537809,
 '2000-2005': 0.1937212459,
 '2005-2010': 0.1915206369,
 '2010-2015': 0.1890260569,
 '2015-2020': 0.0811909099,
 '2020-2025': -0.0957724953,
 '2025-2030': -0.2756497134,
 '2030-2035': -0.4662702479,
 '2035-2040': -0.6726902878,
 '2040-2045': -0.8201418465,
 '2045-2050': -0.8599683714},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950-1955': -0.7486439089,
 '1955-1960': -1.0368707838,
 '1960-1965': -1.4111794855,
 '1965-1970': -0.8149222119,
 '1970-1975': -0.6512013716,
 '1975-1980': -0.7125549945,
 '1980-1985': -0.8528837339,
 '1985-1990': -0.9343096627,
 '1990-1995': -1.7649523233,
 '1995-2000': -2.2668196849,
 '2000-2005': -0.9806250779,
 '2005-2010': 0.5070995955,
 '2010-2015': 0.755445044,
 '2015-2020': 0.4617023977,
 '2020-2025': 0.1531476978,
 '2025-2030': -0.1472498412,
 '2030-2035': -0.4555309307,
 '2035-2040': -0.7722165619,
 '2040-2045': -0.8849920101,
 '2045-2050': -0.9238278673},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950-1955': -0.1403440033,
 '1955-1960': -0.1572209017,
 '1960-1965': -0.214173643,
 '1965-1970': -0.2467953784,
 '1970-1975': -0.4172438589,
 '1975-1980': -0.5203364408,
 '1980-1985': -1.2270932369,
 '1985-1990': -1.7049520045,
 '1990-1995': -0.6766517707,
 '1995-2000': -0.4471376623,
 '2000-2005': -0.2557822845,
 '2005-2010': -0.5300988457,
 '2010-2015': -0.7685777885,
 '2015-2020': -0.8323252624,
 '2020-2025': -0.9203229849,
 '2025-2030': -1.0136785811,
 '2030-2035': -1.108106323,
 '2035-2040': -1.1958934094,
 '2040-2045': -1.262766728,
 '2045-2050': -1.3344768254},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950-1955': -1.1937774184,
 '1955-1960': -1.4117151519,
 '1960-1965': -1.6492037449,
 '1965-1970': -1.1678748419,
 '1970-1975': -0.982643906,
 '1975-1980': -3.5447831822,
 '1980-1985': -7.4304972829,
 '1985-1990': -10.7187559232,
 '1990-1995': -6.037973375,
 '1995-2000': -9.0450548021,
 '2000-2005': -17.4095225104,
 '2005-2010': -18.0598782769,
 '2010-2015': -16.375993165,
 '2015-2020': -13.2374272514,
 '2020-2025': -10.0801261699,
 '2025-2030': -6.7488716402,
 '2030-2035': -3.5649646281,
 '2035-2040': -1.5197181396,
 '2040-2045': -1.6447619647,
 '2045-2050': -1.5849874331},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950-1955': -0.0472535391,
 '1955-1960': -0.0522929728,
 '1960-1965': -0.0579895326,
 '1965-1970': -0.0643551637,
 '1970-1975': -0.166799025,
 '1975-1980': -0.1511918995,
 '1980-1985': -0.0706543616,
 '1985-1990': -0.0757676594,
 '1990-1995': -0.9573837041,
 '1995-2000': -1.1619535475,
 '2000-2005': -0.4724235776,
 '2005-2010': -0.0052962914,
 '2010-2015': -0.0168611733,
 '2015-2020': -0.103404352,
 '2020-2025': -0.2086712908,
 '2025-2030': -0.3282160375,
 '2030-2035': -0.4697628102,
 '2035-2040': -0.632977324,
 '2040-2045': -0.736420782,
 '2045-2050': -0.8193497617},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950-1955': -0.0154327375,
 '1955-1960': -0.0601911106,
 '1960-1965': -1.5668478425,
 '1965-1970': -1.8619324607,
 '1970-1975': -2.5142508,
 '1975-1980': -1.1884532174,
 '1980-1985': 0.0292080335,
 '1985-1990': 0.00867525,
 '1990-1995': -0.1436250571,
 '1995-2000': -0.3202181799,
 '2000-2005': -0.5054560774,
 '2005-2010': -0.7015899281,
 '2010-2015': -0.9047826085,
 '2015-2020': -0.9862544441,
 '2020-2025': -1.0230394987,
 '2025-2030': -1.0598978241,
 '2030-2035': -1.095465211,
 '2035-2040': -1.1308927792,
 '2040-2045': -1.1652145401,
 '2045-2050': -1.1984828496},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950-1955': -0.4981667167,
 '1955-1960': -0.5813954067,
 '1960-1965': -0.6519591053,
 '1965-1970': -0.6899602584,
 '1970-1975': -0.7430509974,
 '1975-1980': -0.3425042584,
 '1980-1985': -0.3593125504,
 '1985-1990': -0.4473214052,
 '1990-1995': -0.5088204628,
 '1995-2000': -0.5385759347,
 '2000-2005': -0.9397475377,
 '2005-2010': -0.9646584672,
 '2010-2015': -1.3407036328,
 '2015-2020': -1.047484753,
 '2020-2025': -1.1375989526,
 '2025-2030': -1.2258614208,
 '2030-2035': -1.3050405297,
 '2035-2040': -1.3622442388,
 '2040-2045': -1.4177215179,
 '2045-2050': -1.4855903705},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950-1955': 0.0129436353,
 '1955-1960': 0.0127160918,
 '1960-1965': 0.012708012,
 '1965-1970': 0.0124810462,
 '1970-1975': 0.0124732622,
 '1975-1980': 0.012465488,
 '1980-1985': -0.2917959454,
 '1985-1990': -0.7762168217,
 '1990-1995': -0.6080620052,
 '1995-2000': -0.1505767062,
 '2000-2005': -0.1563052767,
 '2005-2010': -0.1711670831,
 '2010-2015': -0.2430092118,
 '2015-2020': -0.3347722447,
 '2020-2025': -0.4419341333,
 '2025-2030': -0.5686232043,
 '2030-2035': -0.7105180751,
 '2035-2040': -0.8096579226,
 '2040-2045': -0.8958110113,
 '2045-2050': -0.9862022027},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950-1955': -0.1470716369,
 '1955-1960': -0.1843273431,
 '1960-1965': -0.2298077622,
 '1965-1970': -0.2459741269,
 '1970-1975': -0.0807318484,
 '1975-1980': -0.1065656744,
 '1980-1985': -0.3530645818,
 '1985-1990': -0.428114159,
 '1990-1995': -0.402108071,
 '1995-2000': -0.4502185841,
 '2000-2005': -0.5168664034,
 '2005-2010': -0.5922574806,
 '2010-2015': -0.6754049095,
 '2015-2020': -0.7567608211,
 '2020-2025': -0.832036408,
 '2025-2030': -0.9038790902,
 '2030-2035': -0.9661844827,
 '2035-2040': -1.00978473,
 '2040-2045': -1.0540193643,
 '2045-2050': -1.1420144004},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950-1955': -0.1911518976,
 '1955-1960': -0.1758922787,
 '1960-1965': -0.1661695407,
 '1965-1970': -0.3915920452,
 '1970-1975': -0.7280281371,
 '1975-1980': -0.7824335837,
 '1980-1985': -0.5245798059,
 '1985-1990': -0.5152734968,
 '1990-1995': -0.4132846827,
 '1995-2000': -0.4495314856,
 '2000-2005': -0.6637354593,
 '2005-2010': -0.889422334,
 '2010-2015': -0.9991455032,
 '2015-2020': -1.0847081173,
 '2020-2025': -1.1551049149,
 '2025-2030': -1.2085468345,
 '2030-2035': -1.23781122,
 '2035-2040': -1.2300605486,
 '2040-2045': -1.2834330887,
 '2045-2050': -1.3629468937},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950-1955': -0.6918288954,
 '1955-1960': -0.8692343588,
 '1960-1965': -1.3197368821,
 '1965-1970': -1.9098840516,
 '1970-1975': -1.3613240653,
 '1975-1980': -1.5595797505,
 '1980-1985': 0.0530988448,
 '1985-1990': 0.0820256156,
 '1990-1995': 0.7460638765,
 '1995-2000': 0.7189244987,
 '2000-2005': -0.6576473146,
 '2005-2010': -0.7901847225,
 '2010-2015': -0.8598403418,
 '2015-2020': -0.9597836736,
 '2020-2025': -1.0640945377,
 '2025-2030': -1.1686849765,
 '2030-2035': -1.2648862334,
 '2035-2040': -1.3383528116,
 '2040-2045': -1.4121493929,
 '2045-2050': -1.4827670296},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950-1955': -0.2128661117,
 '1955-1960': -0.2316268025,
 '1960-1965': -0.4658372792,
 '1965-1970': -0.6528451633,
 '1970-1975': -0.6171349447,
 '1975-1980': -0.6334361442,
 '1980-1985': -0.7997649336,
 '1985-1990': -0.9820789039,
 '1990-1995': -0.7881548258,
 '1995-2000': -0.602528654,
 '2000-2005': -0.1065603586,
 '2005-2010': 0.2755254813,
 '2010-2015': 0.2413378587,
 '2015-2020': 0.0422536409,
 '2020-2025': -0.1811657619,
 '2025-2030': -0.4168416392,
 '2030-2035': -0.6767516436,
 '2035-2040': -0.9591838966,
 '2040-2045': -1.0990098646,
 '2045-2050': -1.1865969392},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950-1955': -0.4021972284,
 '1955-1960': -0.4705045408,
 '1960-1965': -0.4881051863,
 '1965-1970': -0.5918345872,
 '1970-1975': -0.851322705,
 '1975-1980': -0.7935430943,
 '1980-1985': -0.81618993,
 '1985-1990': -0.9096845795,
 '1990-1995': -0.9017228976,
 '1995-2000': -0.9065054356,
 '2000-2005': -0.9605197658,
 '2005-2010': -0.9347549865,
 '2010-2015': -1.0143298449,
 '2015-2020': -1.0817703402,
 '2020-2025': -1.1648830037,
 '2025-2030': -1.2458421853,
 '2030-2035': -1.3152004685,
 '2035-2040': -1.3750750845,
 '2040-2045': -1.4384935466,
 '2045-2050': -1.5097912794},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950-1955': -0.2890167011,
 '1955-1960': -0.3394246292,
 '1960-1965': -0.4674308127,
 '1965-1970': -0.5687213421,
 '1970-1975': -1.0057870615,
 '1975-1980': -1.3212615536,
 '1980-1985': -1.6629920953,
 '1985-1990': -2.0561715907,
 '1990-1995': -2.3703425039,
 '1995-2000': -2.2409556162,
 '2000-2005': -2.521837119,
 '2005-2010': -1.7979968422,
 '2010-2015': -1.9099834495,
 '2015-2020': -1.9398807823,
 '2020-2025': -1.9188677404,
 '2025-2030': -1.8668263274,
 '2030-2035': -1.7841175936,
 '2035-2040': -1.6608114572,
 '2040-2045': -1.6227181121,
 '2045-2050': -1.6597578979},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950-1955': -0.4689083462,
 '1955-1960': -0.5733690116,
 '1960-1965': -0.6958847882,
 '1965-1970': -0.8403152199,
 '1970-1975': -1.8363633209,
 '1975-1980': -1.3156524839,
 '1980-1985': -1.3083459686,
 '1985-1990': -1.1041309273,
 '1990-1995': -0.9906074951,
 '1995-2000': -1.0616962727,
 '2000-2005': -1.1328877655,
 '2005-2010': -1.2087762306,
 '2010-2015': -1.2869998679,
 '2015-2020': -1.3581051086,
 '2020-2025': -1.41759329,
 '2025-2030': -1.4571152041,
 '2030-2035': -1.4765518217,
 '2035-2040': -1.5328718803,
 '2040-2045': -1.5895259474,
 '2045-2050': -1.6441554657},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950-1955': -0.6300443843,
 '1955-1960': -0.7439381735,
 '1960-1965': -0.874670176,
 '1965-1970': -1.0669088674,
 '1970-1975': -1.275256315,
 '1975-1980': -0.5674414383,
 '1980-1985': -0.5078607255,
 '1985-1990': -0.4052064677,
 '1990-1995': -0.128946645,
 '1995-2000': -0.1304248209,
 '2000-2005': -0.138384358,
 '2005-2010': -0.2714892899,
 '2010-2015': -0.454583835,
 '2015-2020': -0.6538765736,
 '2020-2025': -0.8727165869,
 '2025-2030': -1.1071840925,
 '2030-2035': -1.2520461733,
 '2035-2040': -1.3326495139,
 '2040-2045': -1.4128920964,
 '2045-2050': -1.4921745647},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950-1955': -0.2094700867,
 '1955-1960': -0.2555809233,
 '1960-1965': -0.3701585927,
 '1965-1970': -0.7026374452,
 '1970-1975': -0.9252746201,
 '1975-1980': -0.7778966242,
 '1980-1985': -0.2458001378,
 '1985-1990': -0.258958514,
 '1990-1995': -0.1678977118,
 '1995-2000': -0.0418127503,
 '2000-2005': -0.0419003487,
 '2005-2010': -0.0471148771,
 '2010-2015': -0.1363349331,
 '2015-2020': -0.2611020099,
 '2020-2025': -0.4009590054,
 '2025-2030': -0.5625180562,
 '2030-2035': -0.7495723001,
 '2035-2040': -0.8812151955,
 '2040-2045': -0.9686591504,
 '2045-2050': -1.0597761982},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950-1955': -0.8759252159,
 '1955-1960': -0.9863965666,
 '1960-1965': -1.1035955903,
 '1965-1970': -1.2284310859,
 '1970-1975': -1.4069588187,
 '1975-1980': -1.6883797128,
 '1980-1985': -1.7480746366,
 '1985-1990': -0.9002643316,
 '1990-1995': -0.9362811016,
 '1995-2000': -1.0755076549,
 '2000-2005': -1.1422853381,
 '2005-2010': -1.1978868817,
 '2010-2015': -1.2852555434,
 '2015-2020': -1.3729348845,
 '2020-2025': -1.4541079757,
 '2025-2030': -1.5241170504,
 '2030-2035': -1.5693734109,
 '2035-2040': -1.6123683147,
 '2040-2045': -1.6525217312,
 '2045-2050': -1.6921746585},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950-1955': -0.3879157588,
 '1955-1960': -0.419255575,
 '1960-1965': -0.2940428679,
 '1965-1970': -0.3090389078,
 '1970-1975': -0.3244015468,
 '1975-1980': -0.3401687637,
 '1980-1985': -0.3991407615,
 '1985-1990': -0.6020872977,
 '1990-1995': -0.6460727741,
 '1995-2000': -0.6919805641,
 '2000-2005': -0.740761453,
 '2005-2010': -0.8268527693,
 '2010-2015': -0.9305114482,
 '2015-2020': -1.0387383861,
 '2020-2025': -1.147410444,
 '2025-2030': -1.2429553195,
 '2030-2035': -1.321807387,
 '2035-2040': -1.3978044871,
 '2040-2045': -1.4726981606,
 '2045-2050': -1.5461347899},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950-1955': -1.192200972,
 '1955-1960': -1.3455380405,
 '1960-1965': -0.2608832551,
 '1965-1970': -0.1233763056,
 '1970-1975': -0.1252441677,
 '1975-1980': -0.1276970576,
 '1980-1985': -0.581806013,
 '1985-1990': -1.420986923,
 '1990-1995': -1.8445104763,
 '1995-2000': -3.1211413135,
 '2000-2005': -3.7235813988,
 '2005-2010': -4.3143467391,
 '2010-2015': -2.9534673343,
 '2015-2020': -1.7664804382,
 '2020-2025': -1.6983653321,
 '2025-2030': -1.6150909745,
 '2030-2035': -1.5189792375,
 '2035-2040': -1.407872335,
 '2040-2045': -1.3432516115,
 '2045-2050': -1.3642672415},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950-1955': -0.6271112435,
 '1955-1960': -0.7748480425,
 '1960-1965': -1.6068880087,
 '1965-1970': -2.283635754,
 '1970-1975': -3.5189558958,
 '1975-1980': -4.5971121165,
 '1980-1985': -3.7350689414,
 '1985-1990': -3.9517445701,
 '1990-1995': -4.0480118788,
 '1995-2000': -3.533904577,
 '2000-2005': -3.706556458,
 '2005-2010': -3.8613957931,
 '2010-2015': -3.9369108743,
 '2015-2020': -3.6336427661,
 '2020-2025': -3.2261703966,
 '2025-2030': -2.7820790413,
 '2030-2035': -2.3059746286,
 '2035-2040': -1.8277403952,
 '2040-2045': -1.710084354,
 '2045-2050': -1.7223126344},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950-1955': -0.2899192085,
 '1955-1960': -0.3163336076,
 '1960-1965': -1.4219961956,
 '1965-1970': -2.0698041106,
 '1970-1975': -0.6110974298,
 '1975-1980': -0.546597977,
 '1980-1985': -1.4225767546,
 '1985-1990': -1.8945203536,
 '1990-1995': -1.8516570928,
 '1995-2000': -1.9589898134,
 '2000-2005': -2.6309166039,
 '2005-2010': -3.056420126,
 '2010-2015': -3.2267610834,
 '2015-2020': -3.0198576461,
 '2020-2025': -2.7002840799,
 '2025-2030': -2.3048483571,
 '2030-2035': -1.8541879621,
 '2035-2040': -1.4266153414,
 '2040-2045': -1.3826394051,
 '2045-2050': -1.4010962898}]},
'Rural Growth Rate': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
'1950-1955',
'1955-1960',
'1960-1965',
'1965-1970',
'1970-1975',
'1975-1980',
'1980-1985',
'1985-1990',
'1990-1995',
'1995-2000',
'2000-2005',
'2005-2010',
'2010-2015',
'2015-2020',
'2020-2025',
'2025-2030',
'2030-2035',
'2035-2040',
'2040-2045',
'2045-2050'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950-1955': 1.1943095288,
 '1955-1960': 1.169552006,
 '1960-1965': 1.3634098997,
 '1965-1970': 1.7375172421,
 '1970-1975': 1.5895985079,
 '1975-1980': 1.2492794016,
 '1980-1985': 1.1610489985,
 '1985-1990': 1.1846070057,
 '1990-1995': 0.8704006956,
 '1995-2000': 0.6244763768,
 '2000-2005': 0.3001988619,
 '2005-2010': 0.2215266896,
 '2010-2015': 0.2259370957,
 '2015-2020': 0.0878687776,
 '2020-2025': -0.0323453559,
 '2025-2030': -0.1590985269,
 '2030-2035': -0.2801650862,
 '2035-2040': -0.3920894946,
 '2040-2045': -0.4977131941,
 '2045-2050': -0.6340595955},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950-1955': -0.2524153515,
 '1955-1960': -0.3968478872,
 '1960-1965': -0.5183158796,
 '1965-1970': -0.7434762752,
 '1970-1975': -0.4858178745,
 '1975-1980': -0.2964708704,
 '1980-1985': -0.1782987148,
 '1985-1990': -0.1357885599,
 '1990-1995': -0.2770252039,
 '1995-2000': -0.3962399069,
 '2000-2005': -0.9634866969,
 '2005-2010': -0.7782464944,
 '2010-2015': -0.4996094953,
 '2015-2020': -0.6285517323,
 '2020-2025': -0.8802793848,
 '2025-2030': -1.1297972672,
 '2030-2035': -1.3821659136,
 '2035-2040': -1.5898826743,
 '2040-2045': -1.7076030983,
 '2045-2050': -1.7607004892},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950-1955': 1.5541311226,
 '1955-1960': 1.5244842536,
 '1960-1965': 1.7474587094,
 '1965-1970': 2.1823579394,
 '1970-1975': 1.9152615428,
 '1975-1980': 1.4678006708,
 '1980-1985': 1.3354827662,
 '1985-1990': 1.3441710705,
 '1990-1995': 0.9998218054,
 '1995-2000': 0.7328817577,
 '2000-2005': 0.4262253548,
 '2005-2010': 0.3152260824,
 '2010-2015': 0.2908043276,
 '2015-2020': 0.1494571264,
 '2020-2025': 0.0375244955,
 '2025-2030': -0.0829447769,
 '2030-2035': -0.1983972777,
 '2035-2040': -0.308523912,
 '2040-2045': -0.4185569834,
 '2045-2050': -0.5647910834},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950-1955': 1.7498009717,
 '1955-1960': 1.9740040433,
 '1960-1965': 2.0859656194,
 '1965-1970': 2.1550546994,
 '1970-1975': 1.9679080975,
 '1975-1980': 1.8795902961,
 '1980-1985': 2.0526227797,
 '1985-1990': 2.0947423564,
 '1990-1995': 2.2403936762,
 '1995-2000': 2.1125937196,
 '2000-2005': 1.9484634231,
 '2005-2010': 1.7177072832,
 '2010-2015': 1.6625275666,
 '2015-2020': 1.5167542708,
 '2020-2025': 1.349461325,
 '2025-2030': 1.1570254228,
 '2030-2035': 0.9645164282,
 '2035-2040': 0.7771405407,
 '2040-2045': 0.5826073767,
 '2045-2050': 0.3825341039},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950-1955': 1.5253950421,
 '1955-1960': 1.4572319881,
 '1960-1965': 1.6956538733,
 '1965-1970': 2.186574006,
 '1970-1975': 1.907126103,
 '1975-1980': 1.4033058313,
 '1980-1985': 1.2194217812,
 '1985-1990': 1.2173917491,
 '1990-1995': 0.77762976,
 '1995-2000': 0.4657827432,
 '2000-2005': 0.1046500681,
 '2005-2010': -0.0086988589,
 '2010-2015': -0.0544951195,
 '2015-2020': -0.2258206717,
 '2020-2025': -0.354958506,
 '2025-2030': -0.4862723001,
 '2030-2035': -0.6083221197,
 '2035-2040': -0.7217572389,
 '2040-2045': -0.8283748359,
 '2045-2050': -0.9804117704},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950-1955': 1.5917464463,
 '1955-1960': 1.8240185875,
 '1960-1965': 1.9015689552,
 '1965-1970': 1.8651913762,
 '1970-1975': 1.7719642995,
 '1975-1980': 1.70636654,
 '1980-1985': 1.7201066523,
 '1985-1990': 1.5946986823,
 '1990-1995': 1.5175158897,
 '1995-2000': 1.3548661445,
 '2000-2005': 1.1568733226,
 '2005-2010': 1.0131021252,
 '2010-2015': 0.93582008,
 '2015-2020': 0.7540513703,
 '2020-2025': 0.5583060383,
 '2025-2030': 0.3435498481,
 '2030-2035': 0.1377502892,
 '2035-2040': -0.0543032289,
 '2040-2045': -0.2318972744,
 '2045-2050': -0.4003155932},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950-1955': -0.0928714413,
 '1955-1960': -0.1404880826,
 '1960-1965': -0.2151304449,
 '1965-1970': -0.47419294,
 '1970-1975': -0.2074942488,
 '1975-1980': -0.1576223296,
 '1980-1985': -0.1803470638,
 '1985-1990': -0.2866756968,
 '1990-1995': -0.3020813545,
 '1995-2000': -0.291407671,
 '2000-2005': -0.9387855752,
 '2005-2010': -0.6632297344,
 '2010-2015': -0.3807774796,
 '2015-2020': -0.5097528707,
 '2020-2025': -0.7527301717,
 '2025-2030': -0.9782118886,
 '2030-2035': -1.2212806264,
 '2035-2040': -1.443178868,
 '2040-2045': -1.5953189876,
 '2045-2050': -1.6670468683},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950-1955': 1.424187165,
 '1955-1960': 1.3543619952,
 '1960-1965': 1.5810790754,
 '1965-1970': 2.0453191619,
 '1970-1975': 1.7867040364,
 '1975-1980': 1.350153084,
 '1980-1985': 1.2400101302,
 '1985-1990': 1.2469736003,
 '1990-1995': 0.8286344777,
 '1995-2000': 0.5192658501,
 '2000-2005': 0.155104403,
 '2005-2010': 0.0178435164,
 '2010-2015': -0.0196526399,
 '2015-2020': -0.1861761136,
 '2020-2025': -0.3160525706,
 '2025-2030': -0.4536202395,
 '2030-2035': -0.5805844496,
 '2035-2040': -0.6949165082,
 '2040-2045': -0.8041261398,
 '2045-2050': -0.9551047303},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950-1955': 1.2840852635,
 '1955-1960': 0.9125658782,
 '1960-1965': 1.2107846567,
 '1965-1970': 2.1106021595,
 '1970-1975': 1.6938782665,
 '1975-1980': 0.8681663893,
 '1980-1985': 0.532151005,
 '1985-1990': 0.7014013107,
 '1990-1995': -0.0749629364,
 '1995-2000': -0.5976467735,
 '2000-2005': -1.2467060114,
 '2005-2010': -1.476184523,
 '2010-2015': -1.5121083881,
 '2015-2020': -1.7936152399,
 '2020-2025': -1.9370602195,
 '2025-2030': -1.9696601736,
 '2030-2035': -1.9245389208,
 '2035-2040': -1.8208167871,
 '2040-2045': -1.698706856,
 '2045-2050': -1.784660113},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950-1955': 1.5849895086,
 '1955-1960': 1.8460238298,
 '1960-1965': 1.9760358078,
 '1965-1970': 1.9767786035,
 '1970-1975': 1.884024591,
 '1975-1980': 1.8409974913,
 '1980-1985': 1.9195761294,
 '1985-1990': 1.739918607,
 '1990-1995': 1.5916936528,
 '1995-2000': 1.3803457651,
 '2000-2005': 1.1245330478,
 '2005-2010': 0.9346572303,
 '2010-2015': 0.7943287029,
 '2015-2020': 0.5934864301,
 '2020-2025': 0.3829167619,
 '2025-2030': 0.1316705227,
 '2030-2035': -0.1101336153,
 '2035-2040': -0.3320510883,
 '2040-2045': -0.534327008,
 '2045-2050': -0.7184886875},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950-1955': 1.4240725607,
 '1955-1960': 1.7674320963,
 '1960-1965': 1.8730422373,
 '1965-1970': 1.9819431231,
 '1970-1975': 2.0750021202,
 '1975-1980': 2.0442378215,
 '1980-1985': 1.9545145684,
 '1985-1990': 2.1472479416,
 '1990-1995': 2.4053865242,
 '1995-2000': 2.3399510432,
 '2000-2005': 2.3743370112,
 '2005-2010': 2.248058374,
 '2010-2015': 2.1507504195,
 '2015-2020': 1.9717217011,
 '2020-2025': 1.7599087597,
 '2025-2030': 1.5412447945,
 '2030-2035': 1.319866741,
 '2035-2040': 1.0984896356,
 '2040-2045': 0.8829838349,
 '2045-2050': 0.661655256},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950-1955': 1.5894723897,
 '1955-1960': 1.7292506705,
 '1960-1965': 2.008228287,
 '1965-1970': 2.0982140983,
 '1970-1975': 2.1393495199,
 '1975-1980': 2.2446870731,
 '1980-1985': 2.2257180423,
 '1985-1990': 2.1008384348,
 '1990-1995': 2.1196119611,
 '1995-2000': 2.1241251487,
 '2000-2005': 1.9870155927,
 '2005-2010': 1.9878260174,
 '2010-2015': 1.9000127645,
 '2015-2020': 1.7571944989,
 '2020-2025': 1.578665687,
 '2025-2030': 1.4056970622,
 '2030-2035': 1.2373678148,
 '2035-2040': 1.0584633484,
 '2040-2045': 0.8560597354,
 '2045-2050': 0.6427650564},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950-1955': 1.6225519474,
 '1955-1960': 1.7602863573,
 '1960-1965': 1.9668225974,
 '1965-1970': 2.053832226,
 '1970-1975': 2.0654233845,
 '1975-1980': 2.2059524358,
 '1980-1985': 2.1907359172,
 '1985-1990': 2.0528555907,
 '1990-1995': 2.0395286863,
 '1995-2000': 1.995226776,
 '2000-2005': 1.8719320054,
 '2005-2010': 1.8676292677,
 '2010-2015': 1.8463530962,
 '2015-2020': 1.6919424155,
 '2020-2025': 1.4913714233,
 '2025-2030': 1.3017447425,
 '2030-2035': 1.1241187884,
 '2035-2040': 0.9398963633,
 '2040-2045': 0.7343045441,
 '2045-2050': 0.5273556615},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950-1955': 2.0196734544,
 '1955-1960': 2.1914433281,
 '1960-1965': 2.3366836679,
 '1965-1970': 2.4235397426,
 '1970-1975': 2.444394889,
 '1975-1980': 2.4785096665,
 '1980-1985': 2.5810113899,
 '1985-1990': 2.5368168559,
 '1990-1995': 2.1677330766,
 '1995-2000': 2.5557797118,
 '2000-2005': 2.4401352897,
 '2005-2010': 2.3902854852,
 '2010-2015': 2.2243754021,
 '2015-2020': 2.043362265,
 '2020-2025': 1.8073587247,
 '2025-2030': 1.5730257563,
 '2030-2035': 1.3388785278,
 '2035-2040': 1.1116981139,
 '2040-2045': 0.890211081,
 '2045-2050': 0.6581976489},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950-1955': 1.8045159699,
 '1955-1960': 1.8823101535,
 '1960-1965': 1.9475262068,
 '1965-1970': 2.2019560294,
 '1970-1975': 1.0716998934,
 '1975-1980': 2.1199964285,
 '1980-1985': 2.4731946463,
 '1985-1990': 2.6021991436,
 '1990-1995': 1.7218528888,
 '1995-2000': 1.1953672254,
 '2000-2005': 2.7166964483,
 '2005-2010': 3.0457368691,
 '2010-2015': 2.7024641044,
 '2015-2020': 2.7761812656,
 '2020-2025': 2.4809583696,
 '2025-2030': 2.1986290639,
 '2030-2035': 2.0191086812,
 '2035-2040': 1.8890567918,
 '2040-2045': 1.7193181495,
 '2045-2050': 1.4859406726},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950-1955': 1.4095310854,
 '1955-1960': 0.8963361596,
 '1960-1965': 0.5981467787,
 '1965-1970': 1.4814377073,
 '1970-1975': 1.7735336645,
 '1975-1980': 3.07871282,
 '1980-1985': 2.2746618247,
 '1985-1990': 2.2846063207,
 '1990-1995': 2.7620114643,
 '1995-2000': 2.6973079316,
 '2000-2005': 2.4607571189,
 '2005-2010': 2.3754483825,
 '2010-2015': 2.2561809672,
 '2015-2020': 1.9850085402,
 '2020-2025': 1.689515811,
 '2025-2030': 1.3931535003,
 '2030-2035': 1.1778244951,
 '2035-2040': 1.018551881,
 '2040-2045': 0.8561065376,
 '2045-2050': 0.6856069899},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950-1955': 0.5011838625,
 '1955-1960': 1.644789473,
 '1960-1965': 3.8871975645,
 '1965-1970': 3.8027775506,
 '1970-1975': 3.7637411911,
 '1975-1980': 6.1466352761,
 '1980-1985': 1.2683573297,
 '1985-1990': 5.7046229089,
 '1990-1995': 1.0233225591,
 '1995-2000': 2.3948752902,
 '2000-2005': 1.5545570532,
 '2005-2010': 1.4566983501,
 '2010-2015': 1.350127012,
 '2015-2020': 0.9254384626,
 '2020-2025': 0.5388969932,
 '2025-2030': 0.1359457385,
 '2030-2035': -0.2808658407,
 '2035-2040': -0.5671341818,
 '2040-2045': -0.7486528114,
 '2045-2050': -0.9097248598},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950-1955': 1.5206352913,
 '1955-1960': 1.92500586,
 '1960-1965': 2.1976550338,
 '1965-1970': 2.347249932,
 '1970-1975': 2.5295387598,
 '1975-1980': 2.5756938175,
 '1980-1985': 2.5445575153,
 '1985-1990': 1.6971120013,
 '1990-1995': -1.0597511786,
 '1995-2000': 0.7886823538,
 '2000-2005': 1.8686644882,
 '2005-2010': 0.8004667693,
 '2010-2015': 1.0189347713,
 '2015-2020': 1.2367222486,
 '2020-2025': 1.05123193,
 '2025-2030': 0.870710754,
 '2030-2035': 0.7351015916,
 '2035-2040': 0.5782733028,
 '2040-2045': 0.3474062114,
 '2045-2050': 0.0996867622},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950-1955': 1.7348808923,
 '1955-1960': 1.8857148052,
 '1960-1965': 2.182361441,
 '1965-1970': 2.3322945822,
 '1970-1975': 2.5357774724,
 '1975-1980': 1.3807519777,
 '1980-1985': 2.6818322566,
 '1985-1990': 3.0207363623,
 '1990-1995': 3.2313867325,
 '1995-2000': 2.7729827696,
 '2000-2005': 2.6231820016,
 '2005-2010': 2.2862030674,
 '2010-2015': 2.0822121592,
 '2015-2020': 1.8561407089,
 '2020-2025': 1.5966178832,
 '2025-2030': 1.3134108648,
 '2030-2035': 1.0348904158,
 '2035-2040': 0.7656868557,
 '2040-2045': 0.5272421157,
 '2045-2050': 0.2774395965},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950-1955': 2.594850328,
 '1955-1960': 2.7873056075,
 '1960-1965': 2.914879446,
 '1965-1970': 3.002796125,
 '1970-1975': 3.0295048208,
 '1975-1980': 3.1287178516,
 '1980-1985': 3.659793516,
 '1985-1990': 3.3340242228,
 '1990-1995': 2.7475388627,
 '1995-2000': 2.3938974521,
 '2000-2005': 2.2787752961,
 '2005-2010': 2.2542174432,
 '2010-2015': 2.1080770976,
 '2015-2020': 1.8483822574,
 '2020-2025': 1.583991114,
 '2025-2030': 1.3385674671,
 '2030-2035': 1.0841514579,
 '2035-2040': 0.8262406098,
 '2040-2045': 0.5683896807,
 '2045-2050': 0.3238121025},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950-1955': 1.8460355398,
 '1955-1960': 1.9708588509,
 '1960-1965': 2.0755840605,
 '1965-1970': 2.2221014045,
 '1970-1975': 2.250380728,
 '1975-1980': 2.3270538705,
 '1980-1985': 2.2735735526,
 '1985-1990': 2.1622688751,
 '1990-1995': 2.4072311536,
 '1995-2000': 2.780405309,
 '2000-2005': 2.5499900615,
 '2005-2010': 1.9587915731,
 '2010-2015': 1.7405295827,
 '2015-2020': 1.6084657179,
 '2020-2025': 1.4497370364,
 '2025-2030': 1.2601595864,
 '2030-2035': 1.0721589548,
 '2035-2040': 0.8556537137,
 '2040-2045': 0.6395870361,
 '2045-2050': 0.4329136674},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950-1955': 1.8382737556,
 '1955-1960': 2.0370733219,
 '1960-1965': 2.1867657976,
 '1965-1970': 2.2779237761,
 '1970-1975': 2.446337236,
 '1975-1980': 2.7393475772,
 '1980-1985': 2.8947060327,
 '1985-1990': 5.0680022351,
 '1990-1995': 0.5861786995,
 '1995-2000': 2.4484434065,
 '2000-2005': 2.6253143618,
 '2005-2010': 2.906835099,
 '2010-2015': 2.762581426,
 '2015-2020': 2.6002530069,
 '2020-2025': 2.3849752212,
 '2025-2030': 2.1646903402,
 '2030-2035': 1.8701065384,
 '2035-2040': 1.6135594799,
 '2040-2045': 1.3699999178,
 '2045-2050': 1.118926156},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950-1955': 2.2556268416,
 '1955-1960': 1.8617731531,
 '1960-1965': 1.4833768892,
 '1965-1970': 0.5763225437,
 '1970-1975': 1.2203267368,
 '1975-1980': 1.9721007555,
 '1980-1985': 1.0131109703,
 '1985-1990': 0.2207149816,
 '1990-1995': 1.55192966,
 '1995-2000': 1.1917655139,
 '2000-2005': 0.8064904008,
 '2005-2010': 0.6117813873,
 '2010-2015': 0.3723969179,
 '2015-2020': 0.3125850166,
 '2020-2025': 0.0476389827,
 '2025-2030': -0.2189625374,
 '2030-2035': -0.5321211562,
 '2035-2040': -0.8840855653,
 '2040-2045': -1.1636914576,
 '2045-2050': -1.2903406991},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950-1955': 3.7757261631,
 '1955-1960': 3.6645551071,
 '1960-1965': 3.3862816995,
 '1965-1970': 3.0154325583,
 '1970-1975': 3.4937157182,
 '1975-1980': 3.1372996967,
 '1980-1985': 4.5126119846,
 '1985-1990': 4.5357663799,
 '1990-1995': 3.4761487121,
 '1995-2000': 1.7168940516,
 '2000-2005': 2.4091811976,
 '2005-2010': 3.6800235596,
 '2010-2015': 3.5502443101,
 '2015-2020': 3.0445556555,
 '2020-2025': 2.5264281908,
 '2025-2030': 2.0837948494,
 '2030-2035': 1.6377052611,
 '2035-2040': 1.153706643,
 '2040-2045': 0.8554301612,
 '2045-2050': 0.6264828727},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950-1955': 1.5707293036,
 '1955-1960': 1.794400882,
 '1960-1965': 1.8770212822,
 '1965-1970': 1.9632510832,
 '1970-1975': 2.0115896262,
 '1975-1980': 2.1943646219,
 '1980-1985': 0.6041043236,
 '1985-1990': -1.3035035968,
 '1990-1995': 2.7953236532,
 '1995-2000': 2.2868934449,
 '2000-2005': 2.6787247796,
 '2005-2010': 2.3977395647,
 '2010-2015': 2.1384752214,
 '2015-2020': 2.022778495,
 '2020-2025': 1.8539864652,
 '2025-2030': 1.6662121749,
 '2030-2035': 1.4554025021,
 '2035-2040': 1.222797522,
 '2040-2045': 1.0029790226,
 '2045-2050': 0.7804518515},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950-1955': 2.0404252402,
 '1955-1960': 1.4006387338,
 '1960-1965': 1.3897016736,
 '1965-1970': 2.1818227025,
 '1970-1975': -0.0214556848,
 '1975-1980': -2.5591357362,
 '1980-1985': -5.5772229887,
 '1985-1990': -8.94332939,
 '1990-1995': -4.0745965519,
 '1995-2000': -7.2518672655,
 '2000-2005': -15.9718276374,
 '2005-2010': -17.0970531381,
 '2010-2015': -15.6142713893,
 '2015-2020': -12.4877618098,
 '2020-2025': -9.3203625712,
 '2025-2030': -6.1860337186,
 '2030-2035': -3.0498735724,
 '2035-2040': -1.2290555843,
 '2040-2045': -1.3848882435,
 '2045-2050': -1.5083013392},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950-1955': 2.8386091592,
 '1955-1960': 2.9420447042,
 '1960-1965': 1.8863080887,
 '1965-1970': 2.9271452083,
 '1970-1975': 2.8193367462,
 '1975-1980': 3.1473324695,
 '1980-1985': 3.4170262487,
 '1985-1990': 3.2734506407,
 '1990-1995': -4.9442458008,
 '1995-2000': 4.8970913796,
 '2000-2005': 1.8006222186,
 '2005-2010': 2.6080794792,
 '2010-2015': 2.5147789875,
 '2015-2020': 2.2582589711,
 '2020-2025': 1.9021543666,
 '2025-2030': 1.610255003,
 '2030-2035': 1.3411586122,
 '2035-2040': 1.0319071884,
 '2040-2045': 0.7429662818,
 '2045-2050': 0.460564425},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950-1955': 1.3588139548,
 '1955-1960': 1.2483886966,
 '1960-1965': 0.8063188371,
 '1965-1970': 0.3969301156,
 '1970-1975': 0.0707057223,
 '1975-1980': 0.9436546785,
 '1980-1985': 1.0707108574,
 '1985-1990': 0.233014525,
 '1990-1995': 1.507542458,
 '1995-2000': 0.8071399779,
 '2000-2005': 1.2834973224,
 '2005-2010': -0.1108217418,
 '2010-2015': -0.3997196816,
 '2015-2020': -0.4866302308,
 '2020-2025': -0.7541656071,
 '2025-2030': -0.9378183058,
 '2030-2035': -1.0485068802,
 '2035-2040': -1.1428045494,
 '2040-2045': -1.2595674055,
 '2045-2050': -1.4203304749},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950-1955': 1.4161760468,
 '1955-1960': 1.436015002,
 '1960-1965': 1.4961316341,
 '1965-1970': 1.6225701241,
 '1970-1975': 1.6394536162,
 '1975-1980': 9.5368632252,
 '1980-1985': 0.9570008215,
 '1985-1990': 1.2609936912,
 '1990-1995': 0.3060478649,
 '1995-2000': 2.5941942728,
 '2000-2005': 1.9454872462,
 '2005-2010': 1.9668399085,
 '2010-2015': 1.5220208226,
 '2015-2020': 1.8860330865,
 '2020-2025': 1.8132154084,
 '2025-2030': 1.6339487561,
 '2030-2035': 1.436951854,
 '2035-2040': 1.2503579912,
 '2040-2045': 1.0668992762,
 '2045-2050': 0.869711445},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950-1955': 1.0583320582,
 '1955-1960': 1.6597636726,
 '1960-1965': 1.9985044749,
 '1965-1970': 2.2377092834,
 '1970-1975': 2.4448412223,
 '1975-1980': 2.6715418936,
 '1980-1985': 2.6485770775,
 '1985-1990': 0.3581514104,
 '1990-1995': -1.7089214057,
 '1995-2000': 3.9463273184,
 '2000-2005': 3.6586345675,
 '2005-2010': 4.1553498876,
 '2010-2015': 3.0720539302,
 '2015-2020': 2.3806566552,
 '2020-2025': 2.0233490287,
 '2025-2030': 1.7113122849,
 '2030-2035': 1.4085195094,
 '2035-2040': 1.1797226816,
 '2040-2045': 0.9666499522,
 '2045-2050': 0.7499240077},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950-1955': 2.536220578,
 '1955-1960': 2.6244320931,
 '1960-1965': 3.091087481,
 '1965-1970': 3.0413807601,
 '1970-1975': 2.6482484958,
 '1975-1980': 2.8461083747,
 '1980-1985': 2.7374936872,
 '1985-1990': 3.0617215607,
 '1990-1995': 2.8813631715,
 '1995-2000': 2.6860498886,
 '2000-2005': 2.9180698,
 '2005-2010': 2.8561788957,
 '2010-2015': 2.6973446785,
 '2015-2020': 2.4760482839,
 '2020-2025': 2.2628287739,
 '2025-2030': 2.0467718704,
 '2030-2035': 1.8202223908,
 '2035-2040': 1.5976738196,
 '2040-2045': 1.3760612808,
 '2045-2050': 1.1175058623},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950-1955': 2.4758491851,
 '1955-1960': 2.6638309535,
 '1960-1965': 2.7973241083,
 '1965-1970': 2.6541804688,
 '1970-1975': 2.4895911646,
 '1975-1980': 2.3430595372,
 '1980-1985': 2.5948919674,
 '1985-1990': 2.5545043157,
 '1990-1995': 2.8425769006,
 '1995-2000': 2.184501789,
 '2000-2005': 2.1852396209,
 '2005-2010': 2.245655499,
 '2010-2015': 2.1202709241,
 '2015-2020': 1.971259356,
 '2020-2025': 1.7755175121,
 '2025-2030': 1.6149363256,
 '2030-2035': 1.4752069487,
 '2035-2040': 1.3493886812,
 '2040-2045': 1.1509505832,
 '2045-2050': 0.9220415965},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950-1955': 1.9329763477,
 '1955-1960': 2.0261539384,
 '1960-1965': 1.8255594456,
 '1965-1970': 1.252918624,
 '1970-1975': 2.1090822026,
 '1975-1980': 1.8553662519,
 '1980-1985': 3.3804110756,
 '1985-1990': 2.949204918,
 '1990-1995': 3.3358864637,
 '1995-2000': 3.5589229095,
 '2000-2005': 2.040523697,
 '2005-2010': 1.9906960402,
 '2010-2015': 2.1515689601,
 '2015-2020': 2.0112969136,
 '2020-2025': 1.8357208181,
 '2025-2030': 1.647921516,
 '2030-2035': 1.4271441909,
 '2035-2040': 1.222523899,
 '2040-2045': 1.0258278936,
 '2045-2050': 0.8334204903},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950-1955': 2.8536261128,
 '1955-1960': 2.9137344919,
 '1960-1965': 2.7916292414,
 '1965-1970': 2.547874611,
 '1970-1975': 2.7196677112,
 '1975-1980': 2.5324758549,
 '1980-1985': 2.9898656867,
 '1985-1990': 2.2608812941,
 '1990-1995': 1.3294204691,
 '1995-2000': 0.9305428834,
 '2000-2005': 1.0347462866,
 '2005-2010': 1.9731117658,
 '2010-2015': 2.5090008583,
 '2015-2020': 2.3198718167,
 '2020-2025': 1.8505601913,
 '2025-2030': 1.4882531067,
 '2030-2035': 1.1247385178,
 '2035-2040': 0.725366018,
 '2040-2045': 0.4419296984,
 '2045-2050': 0.1954879929},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950-1955': 1.5550148059,
 '1955-1960': 1.6452430846,
 '1960-1965': 1.8049954394,
 '1965-1970': 1.8649574818,
 '1970-1975': 1.7054085937,
 '1975-1980': 1.9562095459,
 '1980-1985': 1.9885096026,
 '1985-1990': 1.9950127989,
 '1990-1995': 2.414509878,
 '1995-2000': 1.7381117385,
 '2000-2005': 2.0936995318,
 '2005-2010': 2.2609983258,
 '2010-2015': 2.1337584547,
 '2015-2020': 1.9557822222,
 '2020-2025': 1.7425335167,
 '2025-2030': 1.5296988273,
 '2030-2035': 1.3242789528,
 '2035-2040': 1.1106619415,
 '2040-2045': 0.8776202584,
 '2045-2050': 0.6358424189},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950-1955': 2.0648133562,
 '1955-1960': 1.621877174,
 '1960-1965': 1.4251132583,
 '1965-1970': 1.1985840188,
 '1970-1975': 1.5041186551,
 '1975-1980': 1.6879625363,
 '1980-1985': 1.7831161073,
 '1985-1990': 0.6914335285,
 '1990-1995': 0.8096714517,
 '1995-2000': 0.5926104439,
 '2000-2005': 0.9449383108,
 '2005-2010': 1.7680335782,
 '2010-2015': 1.6049656138,
 '2015-2020': 1.3422283893,
 '2020-2025': 1.2336028767,
 '2025-2030': 1.1602134994,
 '2030-2035': 1.1065074006,
 '2035-2040': 1.0790699284,
 '2040-2045': 0.9547726781,
 '2045-2050': 0.7547551383},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950-1955': 1.2953764463,
 '1955-1960': 1.3392468594,
 '1960-1965': 1.5028624964,
 '1965-1970': 1.6000660901,
 '1970-1975': 0.826833833,
 '1975-1980': 1.5779984614,
 '1980-1985': 1.7654523066,
 '1985-1990': 1.9619979378,
 '1990-1995': 1.7877452188,
 '1995-2000': 1.4658062869,
 '2000-2005': 1.4969986443,
 '2005-2010': 1.5228894888,
 '2010-2015': 1.393414153,
 '2015-2020': 1.2061572414,
 '2020-2025': 1.0309042572,
 '2025-2030': 0.8822428214,
 '2030-2035': 0.7612996246,
 '2035-2040': 0.5930197827,
 '2040-2045': 0.4174447235,
 '2045-2050': 0.2350850398},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950-1955': 0.4389830334,
 '1955-1960': 0.6899107459,
 '1960-1965': 0.9706471057,
 '1965-1970': 1.0039061312,
 '1970-1975': 0.6884439441,
 '1975-1980': 1.8786892617,
 '1980-1985': 2.381978842,
 '1985-1990': 1.7897059265,
 '1990-1995': 2.5000984698,
 '1995-2000': 2.1355873488,
 '2000-2005': 1.7551906733,
 '2005-2010': 1.2246080583,
 '2010-2015': -0.020813859,
 '2015-2020': 0.9305486438,
 '2020-2025': 1.312145655,
 '2025-2030': 1.0814591421,
 '2030-2035': 0.8361014867,
 '2035-2040': 0.5846036735,
 '2040-2045': 0.3375140036,
 '2045-2050': 0.1188721276},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950-1955': 1.5703405839,
 '1955-1960': 1.6031603061,
 '1960-1965': 1.5833004692,
 '1965-1970': 1.2202009285,
 '1970-1975': 1.3763248108,
 '1975-1980': 1.1964068388,
 '1980-1985': 2.1706009275,
 '1985-1990': 2.8803041872,
 '1990-1995': 3.0616624511,
 '1995-2000': 3.4653509985,
 '2000-2005': 3.7157933722,
 '2005-2010': 3.2769573397,
 '2010-2015': 3.1490103151,
 '2015-2020': 2.7492957774,
 '2020-2025': 2.4452332827,
 '2025-2030': 2.1101115035,
 '2030-2035': 1.7505022587,
 '2035-2040': 1.4482096338,
 '2040-2045': 1.1928249913,
 '2045-2050': 0.9372717053},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950-1955': 1.254159944,
 '1955-1960': 1.4073401958,
 '1960-1965': 1.548691737,
 '1965-1970': 1.6085392647,
 '1970-1975': 1.6481130454,
 '1975-1980': 1.2310516434,
 '1980-1985': 1.1588049923,
 '1985-1990': 1.841710707,
 '1990-1995': 1.8073990268,
 '1995-2000': 1.7604079425,
 '2000-2005': 1.6995937295,
 '2005-2010': 2.1088151429,
 '2010-2015': 1.3144664771,
 '2015-2020': 1.2192369833,
 '2020-2025': 1.0804388109,
 '2025-2030': 0.9866309833,
 '2030-2035': 0.8909215029,
 '2035-2040': 0.7376460049,
 '2040-2045': 0.5427826188,
 '2045-2050': 0.3566959011},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950-1955': 1.6898998791,
 '1955-1960': 1.9903126128,
 '1960-1965': 2.3113974295,
 '1965-1970': 2.5208315932,
 '1970-1975': 2.3758430229,
 '1975-1980': 2.4699771128,
 '1980-1985': 2.1120397316,
 '1985-1990': 2.337322998,
 '1990-1995': 3.0283229514,
 '1995-2000': 1.7834235198,
 '2000-2005': 2.2798890606,
 '2005-2010': 2.4575179073,
 '2010-2015': 2.3953877569,
 '2015-2020': 2.1808619222,
 '2020-2025': 1.8969606992,
 '2025-2030': 1.6503551761,
 '2030-2035': 1.42198991,
 '2035-2040': 1.1743019063,
 '2040-2045': 0.906395017,
 '2045-2050': 0.6405812633},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950-1955': -0.0012588117,
 '1955-1960': -0.0555714947,
 '1960-1965': 1.3974174781,
 '1965-1970': 1.8730907841,
 '1970-1975': -3.4365640924,
 '1975-1980': -0.4709509008,
 '1980-1985': 6.2279598911,
 '1985-1990': 2.047066121,
 '1990-1995': 1.5128624077,
 '1995-2000': 0.8031557145,
 '2000-2005': 0.4617931089,
 '2005-2010': 0.2425536997,
 '2010-2015': 1.2810751296,
 '2015-2020': 1.820548372,
 '2020-2025': 1.335312897,
 '2025-2030': 1.0637593901,
 '2030-2035': 0.8335448432,
 '2035-2040': 0.7857514785,
 '2040-2045': 0.6634272471,
 '2045-2050': 0.4604511586},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950-1955': -0.2394675079,
 '1955-1960': -0.0974492909,
 '1960-1965': -0.3142395924,
 '1965-1970': -0.2293911709,
 '1970-1975': -1.5947164058,
 '1975-1980': -2.2899703604,
 '1980-1985': -1.1422853381,
 '1985-1990': -1.2063934804,
 '1990-1995': -1.4163942843,
 '1995-2000': -1.0274117975,
 '2000-2005': -1.0916706462,
 '2005-2010': -0.7386017264,
 '2010-2015': -0.6815451422,
 '2015-2020': -1.4642767146,
 '2020-2025': -1.2800765897,
 '2025-2030': -0.9881260826,
 '2030-2035': -0.6265373236,
 '2035-2040': -0.2438515729,
 '2040-2045': -0.2358619468,
 '2045-2050': -0.3734591376},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950-1955': -0.7002577483,
 '1955-1960': 1.4630540583,
 '1960-1965': -1.2538649843,
 '1965-1970': 0.6549175229,
 '1970-1975': 1.5212373748,
 '1975-1980': 2.2382458246,
 '1980-1985': 0.3278967917,
 '1985-1990': -0.0068545435,
 '1990-1995': 0.2409854304,
 '1995-2000': -0.1238470544,
 '2000-2005': -0.3138017212,
 '2005-2010': -0.7359332922,
 '2010-2015': -0.9806197181,
 '2015-2020': -0.8457512574,
 '2020-2025': -0.5888009399,
 '2025-2030': -0.2520979474,
 '2030-2035': 0.0885961953,
 '2035-2040': 0.3793239353,
 '2040-2045': 0.2811927149,
 '2045-2050': 0.1225261333}]},
'Rural Population Annual': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
2010,
2011,
2012,
2013,
2014,
2015,
2016,
2017,
2018,
2019,
2020,
2021,
2022,
2023,
2024,
2025,
2026,
2027,
2028,
2029,
2030,
2031,
2032,
2033,
2034,
2035,
2036,
2037,
2038,
2039,
2040,
2041,
2042,
2043,
2044,
2045,
2046,
2047,
2048,
2049,
2050,
1991,
1992,
1993,
1994,
1995,
1996,
1997,
1998,
1999,
2000,
2001,
2002,
2003,
2004,
2005,
2006,
2007,
2008,
2009,
'2010.1',
'2011.1',
'2012.1',
'2013.1',
'2014.1',
'2015.1',
'2016.1',
'2017.1',
'2018.1',
'2019.1',
'2020.1',
'2021.1',
'2022.1',
'2023.1',
'2024.1',
'2025.1',
'2026.1',
'2027.1',
'2028.1',
'2029.1',
'2030.1',
'2031.1',
'2032.1',
'2033.1',
'2034.1',
'2035.1',
'2036.1',
'2037.1',
'2038.1',
'2039.1',
'2040.1',
'2041.1',
'2042.1',
'2043.1',
'2044.1',
'2045.1',
'2046.1',
'2047.1',
'2048.1',
'2049.1',
'2050.1'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '2010': 3363301.0130000003,
 '2011': 3371584.7139999997,
 '2012': 3380334.349000002,
 '2013': 3388436.1230000006,
 '2014': 3395621.0989999943,
 '2015': 3401511.1569999997,
 '2016': 3406311.597,
 '2017': 3410073.5069999965,
 '2018': 3413002.007000001,
 '2019': 3415138.304999998,
 '2020': 3416488.3649999974,
 '2021': 3417047.4810000006,
 '2022': 3416797.665000001,
 '2023': 3415717.533999997,
 '2024': 3413780.1800000016,
 '2025': 3410967.454000002,
 '2026': 3407270.0820000004,
 '2027': 3402695.487999999,
 '2028': 3397263.558000003,
 '2029': 3391003.5670000026,
 '2030': 3383941.0979999993,
 '2031': 3376082.064000001,
 '2032': 3367428.6439999985,
 '2033': 3357993.197999998,
 '2034': 3347796.979000004,
 '2035': 3336868.4630000014,
 '2036': 3325249.071000005,
 '2037': 3312940.856999998,
 '2038': 3299940.685999999,
 '2039': 3286315.543999999,
 '2040': 3272087.978000001,
 '2041': 3257290.0429999987,
 '2042': 3241905.375000003,
 '2043': 3226000.6329999957,
 '2044': 3209242.4399999976,
 '2045': 3191664.7529999996,
 '2046': 3173283.8730000034,
 '2047': 3154117.8150000013,
 '2048': 3134181.8630000027,
 '2049': 3113492.2299999967,
 '2050': 3092066.591000001,
 '1991': 3071296.4669999992,
 '1992': 3100063.851999997,
 '1993': 3126871.3090000004,
 '1994': 3152065.5919999997,
 '1995': 3175969.1809999985,
 '1996': 3198623.437000003,
 '1997': 3219752.7539999997,
 '1998': 3239632.504999999,
 '1999': 3258635.7360000033,
 '2000': 3276699.476000001,
 '2001': 3290333.647999998,
 '2002': 3300341.4159999983,
 '2003': 3309664.9900000007,
 '2004': 3318325.973000001,
 '2005': 3326253.5200000023,
 '2006': 3334401.6870000022,
 '2007': 3342809.033000003,
 '2008': 3350052.125000006,
 '2009': 3356910.790999998,
 '2010.1': 3363301.0130000003,
 '2011.1': 3371584.7139999997,
 '2012.1': 3380334.349000002,
 '2013.1': 3388436.1230000006,
 '2014.1': 3395621.0989999943,
 '2015.1': 3401511.1569999997,
 '2016.1': 3406311.597,
 '2017.1': 3410073.5069999965,
 '2018.1': 3413002.007000001,
 '2019.1': 3415138.304999998,
 '2020.1': 3416488.3649999974,
 '2021.1': 3417047.4810000006,
 '2022.1': 3416797.665000001,
 '2023.1': 3415717.533999997,
 '2024.1': 3413780.1800000016,
 '2025.1': 3410967.454000002,
 '2026.1': 3407270.0820000004,
 '2027.1': 3402695.487999999,
 '2028.1': 3397263.558000003,
 '2029.1': 3391003.5670000026,
 '2030.1': 3383941.0979999993,
 '2031.1': 3376082.064000001,
 '2032.1': 3367428.6439999985,
 '2033.1': 3357993.197999998,
 '2034.1': 3347796.979000004,
 '2035.1': 3336868.4630000014,
 '2036.1': 3325249.071000005,
 '2037.1': 3312940.856999998,
 '2038.1': 3299940.685999999,
 '2039.1': 3286315.543999999,
 '2040.1': 3272087.978000001,
 '2041.1': 3257290.0429999987,
 '2042.1': 3241905.375000003,
 '2043.1': 3226000.6329999957,
 '2044.1': 3209242.4399999976,
 '2045.1': 3191664.7529999996,
 '2046.1': 3173283.8730000034,
 '2047.1': 3154117.8150000013,
 '2048.1': 3134181.8630000027,
 '2049.1': 3113492.2299999967,
 '2050.1': 3092066.591000001},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '2010': 281051.5769999998,
 '2011': 279574.1580000003,
 '2012': 278311.806,
 '2013': 276948.4940000003,
 '2014': 275554.028,
 '2015': 274117.7410000005,
 '2016': 272621.004,
 '2017': 271043.7039999998,
 '2018': 269362.5870000001,
 '2019': 267563.5480000001,
 '2020': 265636.8470000001,
 '2021': 263581.4440000004,
 '2022': 261403.1979999999,
 '2023': 259107.9740000005,
 '2024': 256704.173,
 '2025': 254198.6809999997,
 '2026': 251595.5060000001,
 '2027': 248896.1869999996,
 '2028': 246102.3779999999,
 '2029': 243215.1849999999,
 '2030': 240237.0889999997,
 '2031': 237172.7240000002,
 '2032': 234028.4399999999,
 '2033': 230811.7010000004,
 '2034': 227531.2660000001,
 '2035': 224195.4039999999,
 '2036': 220811.4300000004,
 '2037': 217393.8399999999,
 '2038': 213959.3629999999,
 '2039': 210514.1019999997,
 '2040': 207063.1619999995,
 '2041': 203615.6520000005,
 '2042': 200189.1950000001,
 '2043': 196794.8560000001,
 '2044': 193437.213,
 '2045': 190117.7700000012,
 '2046': 186837.2079999999,
 '2047': 183595.6669999994,
 '2048': 180392.3709999998,
 '2049': 177226.1599999997,
 '2050': 174096.318,
 '1991': 316434.3299999998,
 '1992': 315655.965,
 '1993': 314818.458,
 '1994': 313817.7419999994,
 '1995': 312760.2290000003,
 '1996': 311631.8729999994,
 '1997': 310416.4040000007,
 '1998': 309145.8329999998,
 '1999': 307838.2959999997,
 '2000': 306624.8029999998,
 '2001': 304167.6370000007,
 '2002': 301010.9209999995,
 '2003': 297924.338,
 '2004': 294981.4820000001,
 '2005': 292203.5139999997,
 '2006': 289738.8539999998,
 '2007': 287456.4369999997,
 '2008': 285274.0830000006,
 '2009': 283141.0449999998,
 '2010.1': 281051.5769999998,
 '2011.1': 279574.1580000003,
 '2012.1': 278311.806,
 '2013.1': 276948.4940000003,
 '2014.1': 275554.028,
 '2015.1': 274117.7410000005,
 '2016.1': 272621.004,
 '2017.1': 271043.7039999998,
 '2018.1': 269362.5870000001,
 '2019.1': 267563.5480000001,
 '2020.1': 265636.8470000001,
 '2021.1': 263581.4440000004,
 '2022.1': 261403.1979999999,
 '2023.1': 259107.9740000005,
 '2024.1': 256704.173,
 '2025.1': 254198.6809999997,
 '2026.1': 251595.5060000001,
 '2027.1': 248896.1869999996,
 '2028.1': 246102.3779999999,
 '2029.1': 243215.1849999999,
 '2030.1': 240237.0889999997,
 '2031.1': 237172.7240000002,
 '2032.1': 234028.4399999999,
 '2033.1': 230811.7010000004,
 '2034.1': 227531.2660000001,
 '2035.1': 224195.4039999999,
 '2036.1': 220811.4300000004,
 '2037.1': 217393.8399999999,
 '2038.1': 213959.3629999999,
 '2039.1': 210514.1019999997,
 '2040.1': 207063.1619999995,
 '2041.1': 203615.6520000005,
 '2042.1': 200189.1950000001,
 '2043.1': 196794.8560000001,
 '2044.1': 193437.213,
 '2045.1': 190117.7700000012,
 '2046.1': 186837.2079999999,
 '2047.1': 183595.6669999994,
 '2048.1': 180392.3709999998,
 '2049.1': 177226.1599999997,
 '2050.1': 174096.318},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '2010': 3082249.4360000007,
 '2011': 3092010.555999998,
 '2012': 3102022.5430000015,
 '2013': 3111487.6289999993,
 '2014': 3120067.070999994,
 '2015': 3127393.416,
 '2016': 3133690.593000001,
 '2017': 3139029.8029999966,
 '2018': 3143639.420000001,
 '2019': 3147574.7569999974,
 '2020': 3150851.5179999974,
 '2021': 3153466.037000002,
 '2022': 3155394.467000001,
 '2023': 3156609.559999997,
 '2024': 3157076.0070000016,
 '2025': 3156768.7730000005,
 '2026': 3155674.576,
 '2027': 3153799.301,
 '2028': 3151161.180000004,
 '2029': 3147788.3820000016,
 '2030': 3143704.008999999,
 '2031': 3138909.3400000017,
 '2032': 3133400.203999998,
 '2033': 3127181.496999994,
 '2034': 3120265.7130000032,
 '2035': 3112673.059000003,
 '2036': 3104437.6410000045,
 '2037': 3095547.017,
 '2038': 3085981.323,
 '2039': 3075801.4420000007,
 '2040': 3065024.8160000024,
 '2041': 3053674.390999996,
 '2042': 3041716.1800000025,
 '2043': 3029205.776999995,
 '2044': 3015805.226999998,
 '2045': 3001546.982999999,
 '2046': 2986446.6650000038,
 '2047': 2970522.1480000047,
 '2048': 2953789.4920000024,
 '2049': 2936266.0699999956,
 '2050': 2917970.273,
 '1991': 2754862.1369999982,
 '1992': 2784407.8869999973,
 '1993': 2812052.851000004,
 '1994': 2838247.8499999996,
 '1995': 2863208.9519999987,
 '1996': 2886991.564000004,
 '1997': 2909336.3500000015,
 '1998': 2930486.6719999993,
 '1999': 2950797.4400000004,
 '2000': 2970074.673000002,
 '2001': 2986166.010999998,
 '2002': 2999330.4949999987,
 '2003': 3011740.651999997,
 '2004': 3023344.491000002,
 '2005': 3034050.0060000024,
 '2006': 3044662.833000003,
 '2007': 3055352.595999996,
 '2008': 3064778.0420000055,
 '2009': 3073769.7460000017,
 '2010.1': 3082249.4360000007,
 '2011.1': 3092010.555999998,
 '2012.1': 3102022.5430000015,
 '2013.1': 3111487.6289999993,
 '2014.1': 3120067.070999994,
 '2015.1': 3127393.416,
 '2016.1': 3133690.593000001,
 '2017.1': 3139029.8029999966,
 '2018.1': 3143639.420000001,
 '2019.1': 3147574.7569999974,
 '2020.1': 3150851.5179999974,
 '2021.1': 3153466.037000002,
 '2022.1': 3155394.467000001,
 '2023.1': 3156609.559999997,
 '2024.1': 3157076.0070000016,
 '2025.1': 3156768.7730000005,
 '2026.1': 3155674.576,
 '2027.1': 3153799.301,
 '2028.1': 3151161.180000004,
 '2029.1': 3147788.3820000016,
 '2030.1': 3143704.008999999,
 '2031.1': 3138909.3400000017,
 '2032.1': 3133400.203999998,
 '2033.1': 3127181.496999994,
 '2034.1': 3120265.7130000032,
 '2035.1': 3112673.059000003,
 '2036.1': 3104437.6410000045,
 '2037.1': 3095547.017,
 '2038.1': 3085981.323,
 '2039.1': 3075801.4420000007,
 '2040.1': 3065024.8160000024,
 '2041.1': 3053674.390999996,
 '2042.1': 3041716.1800000025,
 '2043.1': 3029205.776999995,
 '2044.1': 3015805.226999998,
 '2045.1': 3001546.982999999,
 '2046.1': 2986446.6650000038,
 '2047.1': 2970522.1480000047,
 '2048.1': 2953789.4920000024,
 '2049.1': 2936266.0699999956,
 '2050.1': 2917970.273},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '2010': 598778.7309999999,
 '2011': 608820.1250000002,
 '2012': 619180.0990000002,
 '2013': 629683.6699999999,
 '2014': 640209.5259999998,
 '2015': 650680.3520000004,
 '2016': 661073.1399999997,
 '2017': 671396.7219999997,
 '2018': 681645.3019999997,
 '2019': 691827.7919999999,
 '2020': 701945.8219999997,
 '2021': 711987.5160000001,
 '2022': 721930.2239999997,
 '2023': 731752.6259999998,
 '2024': 741430.2259999997,
 '2025': 750942.655,
 '2026': 760275.854,
 '2027': 769421.1589999995,
 '2028': 778371.0539999999,
 '2029': 787120.8549999997,
 '2030': 795666.8449999997,
 '2031': 803995.7290000003,
 '2032': 812096.6490000001,
 '2033': 819962.8820000001,
 '2034': 827589.4539999996,
 '2035': 834978.8399999996,
 '2036': 842127.573,
 '2037': 849036.9760000003,
 '2038': 855661.5220000002,
 '2039': 862007.2390000001,
 '2040': 868062.2340000003,
 '2041': 873826.2859999997,
 '2042': 879278.9499999994,
 '2043': 884423.863,
 '2044': 889240.3460000006,
 '2045': 893721.1190000003,
 '2046': 897861.9959999996,
 '2047': 901659.6219999999,
 '2048': 905112.1729999994,
 '2049': 908219.143999999,
 '2050': 910979.5819999999,
 '1991': 409888.737,
 '1992': 419173.7089999999,
 '1993': 428708.248,
 '1994': 438579.7980000002,
 '1995': 448520.2860000001,
 '1996': 458409.5210000001,
 '1997': 468215.175,
 '1998': 478118.6400000001,
 '1999': 488197.825,
 '2000': 498490.034,
 '2001': 508706.2429999999,
 '2002': 518936.9489999997,
 '2003': 529194.359,
 '2004': 539438.6799999999,
 '2005': 549498.8979999998,
 '2006': 559480.49,
 '2007': 569732.1709999997,
 '2008': 579298.3799999999,
 '2009': 588947.9389999999,
 '2010.1': 598778.7309999999,
 '2011.1': 608820.1250000002,
 '2012.1': 619180.0990000002,
 '2013.1': 629683.6699999999,
 '2014.1': 640209.5259999998,
 '2015.1': 650680.3520000004,
 '2016.1': 661073.1399999997,
 '2017.1': 671396.7219999997,
 '2018.1': 681645.3019999997,
 '2019.1': 691827.7919999999,
 '2020.1': 701945.8219999997,
 '2021.1': 711987.5160000001,
 '2022.1': 721930.2239999997,
 '2023.1': 731752.6259999998,
 '2024.1': 741430.2259999997,
 '2025.1': 750942.655,
 '2026.1': 760275.854,
 '2027.1': 769421.1589999995,
 '2028.1': 778371.0539999999,
 '2029.1': 787120.8549999997,
 '2030.1': 795666.8449999997,
 '2031.1': 803995.7290000003,
 '2032.1': 812096.6490000001,
 '2033.1': 819962.8820000001,
 '2034.1': 827589.4539999996,
 '2035.1': 834978.8399999996,
 '2036.1': 842127.573,
 '2037.1': 849036.9760000003,
 '2038.1': 855661.5220000002,
 '2039.1': 862007.2390000001,
 '2040.1': 868062.2340000003,
 '2041.1': 873826.2859999997,
 '2042.1': 879278.9499999994,
 '2043.1': 884423.863,
 '2044.1': 889240.3460000006,
 '2045.1': 893721.1190000003,
 '2046.1': 897861.9959999996,
 '2047.1': 901659.6219999999,
 '2048.1': 905112.1729999994,
 '2049.1': 908219.143999999,
 '2050.1': 910979.5819999999},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '2010': 2483470.7050000015,
 '2011': 2483190.4310000017,
 '2012': 2482842.4439999983,
 '2013': 2481803.9589999993,
 '2014': 2479857.544999998,
 '2015': 2476713.064,
 '2016': 2472617.4529999983,
 '2017': 2467633.0809999974,
 '2018': 2461994.118000003,
 '2019': 2455746.965,
 '2020': 2448905.695999999,
 '2021': 2441478.5209999974,
 '2022': 2433464.243,
 '2023': 2424856.933999998,
 '2024': 2415645.781,
 '2025': 2405826.117999997,
 '2026': 2395398.722000004,
 '2027': 2384378.142000002,
 '2028': 2372790.126000004,
 '2029': 2360667.5270000007,
 '2030': 2348037.163999999,
 '2031': 2334913.6109999996,
 '2032': 2321303.5549999997,
 '2033': 2307218.614999999,
 '2034': 2292676.259000003,
 '2035': 2277694.2189999977,
 '2036': 2262310.0679999995,
 '2037': 2246510.0409999993,
 '2038': 2230319.801,
 '2039': 2213794.203000001,
 '2040': 2196962.582000004,
 '2041': 2179848.1049999967,
 '2042': 2162437.2300000014,
 '2043': 2144781.913999999,
 '2044': 2126564.881,
 '2045': 2107825.864000002,
 '2046': 2088584.6690000007,
 '2047': 2068862.5260000043,
 '2048': 2048677.3189999945,
 '2049': 2028046.9259999972,
 '2050': 2006990.6909999987,
 '1991': 2344973.4000000004,
 '1992': 2365234.1779999975,
 '1993': 2383344.6029999997,
 '1994': 2399668.052000002,
 '1995': 2414688.6659999983,
 '1996': 2428582.0430000024,
 '1997': 2441121.175,
 '1998': 2452368.0319999987,
 '1999': 2462599.615,
 '2000': 2471584.639000003,
 '2001': 2477459.768000001,
 '2002': 2480393.546,
 '2003': 2482546.292999997,
 '2004': 2483905.8110000044,
 '2005': 2484551.108000002,
 '2006': 2485182.3430000013,
 '2007': 2485620.4250000017,
 '2008': 2485479.6620000005,
 '2009': 2484821.8069999986,
 '2010.1': 2483470.7050000015,
 '2011.1': 2483190.4310000017,
 '2012.1': 2482842.4439999983,
 '2013.1': 2481803.9589999993,
 '2014.1': 2479857.544999998,
 '2015.1': 2476713.064,
 '2016.1': 2472617.4529999983,
 '2017.1': 2467633.0809999974,
 '2018.1': 2461994.118000003,
 '2019.1': 2455746.965,
 '2020.1': 2448905.695999999,
 '2021.1': 2441478.5209999974,
 '2022.1': 2433464.243,
 '2023.1': 2424856.933999998,
 '2024.1': 2415645.781,
 '2025.1': 2405826.117999997,
 '2026.1': 2395398.722000004,
 '2027.1': 2384378.142000002,
 '2028.1': 2372790.126000004,
 '2029.1': 2360667.5270000007,
 '2030.1': 2348037.163999999,
 '2031.1': 2334913.6109999996,
 '2032.1': 2321303.5549999997,
 '2033.1': 2307218.614999999,
 '2034.1': 2292676.259000003,
 '2035.1': 2277694.2189999977,
 '2036.1': 2262310.0679999995,
 '2037.1': 2246510.0409999993,
 '2038.1': 2230319.801,
 '2039.1': 2213794.203000001,
 '2040.1': 2196962.582000004,
 '2041.1': 2179848.1049999967,
 '2042.1': 2162437.2300000014,
 '2043.1': 2144781.913999999,
 '2044.1': 2126564.881,
 '2045.1': 2107825.864000002,
 '2046.1': 2088584.6690000007,
 '2047.1': 2068862.5260000043,
 '2048.1': 2048677.3189999945,
 '2049.1': 2028046.9259999972,
 '2050.1': 2006990.6909999987},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '2010': 2385999.873000001,
 '2011': 2409492.353999993,
 '2012': 2433015.118999999,
 '2013': 2456163.818000001,
 '2014': 2478714.202999999,
 '2015': 2500296.3739999994,
 '2016': 2521141.1720000003,
 '2017': 2541213.283,
 '2018': 2560439.789,
 '2019': 2578826.558999999,
 '2020': 2596363.5799999987,
 '2021': 2613026.670000002,
 '2022': 2628768.3980000005,
 '2023': 2643530.4849999975,
 '2024': 2657245.567000003,
 '2025': 2669862.9590000003,
 '2026': 2681354.6670000018,
 '2027': 2691716.471999994,
 '2028': 2700953.6730000023,
 '2029': 2709083.3760000034,
 '2030': 2716120.6680000015,
 '2031': 2722062.3680000026,
 '2032': 2726902.2269999976,
 '2033': 2730643.9340000004,
 '2034': 2733300.1740000015,
 '2035': 2734892.5599999977,
 '2036': 2735458.060000004,
 '2037': 2734987.4209999945,
 '2038': 2733464.955999999,
 '2039': 2730954.4719999996,
 '2040': 2727476.9570000055,
 '2041': 2723058.3959999993,
 '2042': 2717667.2649999987,
 '2043': 2711357.499999996,
 '2044': 2704141.1789999963,
 '2045': 2696034.868999997,
 '2046': 2687050.1249999995,
 '2047': 2677200.6410000054,
 '2048': 2666500.1729999986,
 '2049': 2654964.099000004,
 '2050': 2642608.101999998,
 '1991': 1883716.5969999987,
 '1992': 1913190.306999997,
 '1993': 1942405.8599999994,
 '1994': 1971519.0250000025,
 '1995': 2000458.0729999996,
 '1996': 2029263.6950000026,
 '1997': 2057630.3149999976,
 '1998': 2085655.3820000004,
 '1999': 2113451.6089999992,
 '2000': 2140671.3570000017,
 '2001': 2167535.535999998,
 '2002': 2193226.164,
 '2003': 2218604.0550000006,
 '2004': 2243637.8100000024,
 '2005': 2268146.9220000003,
 '2006': 2292363.294999999,
 '2007': 2316667.4449999966,
 '2008': 2340017.648000003,
 '2009': 2363137.1119999997,
 '2010.1': 2385999.873000001,
 '2011.1': 2409492.353999993,
 '2012.1': 2433015.118999999,
 '2013.1': 2456163.818000001,
 '2014.1': 2478714.202999999,
 '2015.1': 2500296.3739999994,
 '2016.1': 2521141.1720000003,
 '2017.1': 2541213.283,
 '2018.1': 2560439.789,
 '2019.1': 2578826.558999999,
 '2020.1': 2596363.5799999987,
 '2021.1': 2613026.670000002,
 '2022.1': 2628768.3980000005,
 '2023.1': 2643530.4849999975,
 '2024.1': 2657245.567000003,
 '2025.1': 2669862.9590000003,
 '2026.1': 2681354.6670000018,
 '2027.1': 2691716.471999994,
 '2028.1': 2700953.6730000023,
 '2029.1': 2709083.3760000034,
 '2030.1': 2716120.6680000015,
 '2031.1': 2722062.3680000026,
 '2032.1': 2726902.2269999976,
 '2033.1': 2730643.9340000004,
 '2034.1': 2733300.1740000015,
 '2035.1': 2734892.5599999977,
 '2036.1': 2735458.060000004,
 '2037.1': 2734987.4209999945,
 '2038.1': 2733464.955999999,
 '2039.1': 2730954.4719999996,
 '2040.1': 2727476.9570000055,
 '2041.1': 2723058.3959999993,
 '2042.1': 2717667.2649999987,
 '2043.1': 2711357.499999996,
 '2044.1': 2704141.1789999963,
 '2045.1': 2696034.868999997,
 '2046.1': 2687050.1249999995,
 '2047.1': 2677200.6410000054,
 '2048.1': 2666500.1729999986,
 '2049.1': 2654964.099000004,
 '2050.1': 2642608.101999998},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '2010': 229169.4449999998,
 '2011': 228263.2030000002,
 '2012': 227530.9079999999,
 '2013': 226668.2820000001,
 '2014': 225771.5589999997,
 '2015': 224847.5889999995,
 '2016': 223881.1310000003,
 '2017': 222847.2700000008,
 '2018': 221729.7570000002,
 '2019': 220513.6949999997,
 '2020': 219189.17,
 '2021': 217756.0700000002,
 '2022': 216222.0719999996,
 '2023': 214594.2980000001,
 '2024': 212882.2689999996,
 '2025': 211092.9669999997,
 '2026': 209229.5509999994,
 '2027': 207291.5800000003,
 '2028': 205278.0429999999,
 '2029': 203186.6470000002,
 '2030': 201016.7110000006,
 '2031': 198770.7160000002,
 '2032': 196452.9510000001,
 '2033': 194066.8670000003,
 '2034': 191617.2489999998,
 '2035': 189109.0840000003,
 '2036': 186547.8270000003,
 '2037': 183946.453,
 '2038': 181308.4089999998,
 '2039': 178639.2950000002,
 '2040': 175943.878,
 '2041': 173228.0580000002,
 '2042': 170510.308,
 '2043': 167806.5280000006,
 '2044': 165120.4819999996,
 '2045': 162454.6880000001,
 '2046': 159810.6169999999,
 '2047': 157189.1009999998,
 '2048': 154590.5399999998,
 '2049': 152014.9639999999,
 '2050': 149462.6870000004,
 '1991': 254902.7660000003,
 '1992': 254223.3189999999,
 '1993': 253515.0599999998,
 '1994': 252735.5839999993,
 '1995': 251925.35,
 '1996': 251210.0449999997,
 '1997': 250487.7610000002,
 '1998': 249726.116,
 '1999': 248946.169,
 '2000': 248281.3129999995,
 '2001': 246310.7260000004,
 '2002': 243683.8969999998,
 '2003': 241267.7709999999,
 '2004': 239002.9100000003,
 '2005': 236896.456,
 '2006': 235161.3599999996,
 '2007': 233622.1650000002,
 '2008': 232148.14,
 '2009': 230678.2140000004,
 '2010.1': 229169.4449999998,
 '2011.1': 228263.2030000002,
 '2012.1': 227530.9079999999,
 '2013.1': 226668.2820000001,
 '2014.1': 225771.5589999997,
 '2015.1': 224847.5889999995,
 '2016.1': 223881.1310000003,
 '2017.1': 222847.2700000008,
 '2018.1': 221729.7570000002,
 '2019.1': 220513.6949999997,
 '2020.1': 219189.17,
 '2021.1': 217756.0700000002,
 '2022.1': 216222.0719999996,
 '2023.1': 214594.2980000001,
 '2024.1': 212882.2689999996,
 '2025.1': 211092.9669999997,
 '2026.1': 209229.5509999994,
 '2027.1': 207291.5800000003,
 '2028.1': 205278.0429999999,
 '2029.1': 203186.6470000002,
 '2030.1': 201016.7110000006,
 '2031.1': 198770.7160000002,
 '2032.1': 196452.9510000001,
 '2033.1': 194066.8670000003,
 '2034.1': 191617.2489999998,
 '2035.1': 189109.0840000003,
 '2036.1': 186547.8270000003,
 '2037.1': 183946.453,
 '2038.1': 181308.4089999998,
 '2039.1': 178639.2950000002,
 '2040.1': 175943.878,
 '2041.1': 173228.0580000002,
 '2042.1': 170510.308,
 '2043.1': 167806.5280000006,
 '2044.1': 165120.4819999996,
 '2045.1': 162454.6880000001,
 '2046.1': 159810.6169999999,
 '2047.1': 157189.1009999998,
 '2048.1': 154590.5399999998,
 '2049.1': 152014.9639999999,
 '2050.1': 149462.6870000004},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '2010': 2735698.954,
 '2011': 2736180.8749999995,
 '2012': 2736672.809000001,
 '2013': 2736511.9570000023,
 '2014': 2735407.447999999,
 '2015': 2733012.0890000006,
 '2016': 2729566.523000002,
 '2017': 2725151.107,
 '2018': 2719999.603,
 '2019': 2714171.768000002,
 '2020': 2707689.056999999,
 '2021': 2700558.762,
 '2022': 2692769.275999999,
 '2023': 2684301.8139999984,
 '2024': 2675129.421000001,
 '2025': 2665236.7650000006,
 '2026': 2654622.165999999,
 '2027': 2643304.2539999997,
 '2028': 2631313.3769999994,
 '2029': 2618689.762999996,
 '2030': 2605466.8810000005,
 '2031': 2591663.2420000006,
 '2032': 2577284.1900000004,
 '2033': 2562348.934000002,
 '2034': 2546883.050999999,
 '2035': 2530919.465,
 '2036': 2514503.919999997,
 '2037': 2497631.59,
 '2038': 2480302.865,
 '2039': 2462580.6689999998,
 '2040': 2444490.7919999985,
 '2041': 2426058.5469999984,
 '2042': 2407270.5029999996,
 '2043': 2388175.386000002,
 '2044': 2368457.080000002,
 '2045': 2348156.4459999977,
 '2046': 2327294.249000001,
 '2047': 2305893.339999999,
 '2048': 2283973.140999999,
 '2049': 2261553.3550000004,
 '2050': 2238655.12,
 '1991': 2560923.3010000004,
 '1992': 2584195.994000001,
 '1993': 2605280.7459999993,
 '1994': 2624637.369999999,
 '1995': 2642634.335,
 '1996': 2659244.7820000015,
 '1997': 2674342.078,
 '1998': 2688073.1749999993,
 '1999': 2700754.5449999995,
 '2000': 2712144.272,
 '2001': 2720235.6929999986,
 '2002': 2725053.587,
 '2003': 2728765.310999999,
 '2004': 2731474.5549999983,
 '2005': 2733259.3180000004,
 '2006': 2734823.183999999,
 '2007': 2735966.090999998,
 '2008': 2736417.194,
 '2009': 2736347.6510000005,
 '2010.1': 2735698.954,
 '2011.1': 2736180.8749999995,
 '2012.1': 2736672.809000001,
 '2013.1': 2736511.9570000023,
 '2014.1': 2735407.447999999,
 '2015.1': 2733012.0890000006,
 '2016.1': 2729566.523000002,
 '2017.1': 2725151.107,
 '2018.1': 2719999.603,
 '2019.1': 2714171.768000002,
 '2020.1': 2707689.056999999,
 '2021.1': 2700558.762,
 '2022.1': 2692769.275999999,
 '2023.1': 2684301.8139999984,
 '2024.1': 2675129.421000001,
 '2025.1': 2665236.7650000006,
 '2026.1': 2654622.165999999,
 '2027.1': 2643304.2539999997,
 '2028.1': 2631313.3769999994,
 '2029.1': 2618689.762999996,
 '2030.1': 2605466.8810000005,
 '2031.1': 2591663.2420000006,
 '2032.1': 2577284.1900000004,
 '2033.1': 2562348.934000002,
 '2034.1': 2546883.050999999,
 '2035.1': 2530919.465,
 '2036.1': 2514503.919999997,
 '2037.1': 2497631.59,
 '2038.1': 2480302.865,
 '2039.1': 2462580.6689999998,
 '2040.1': 2444490.7919999985,
 '2041.1': 2426058.5469999984,
 '2042.1': 2407270.5029999996,
 '2043.1': 2388175.386000002,
 '2044.1': 2368457.080000002,
 '2045.1': 2348156.4459999977,
 '2046.1': 2327294.249000001,
 '2047.1': 2305893.339999999,
 '2048.1': 2283973.140999999,
 '2049.1': 2261553.3550000004,
 '2050.1': 2238655.12},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '2010': 1001692.9520000003,
 '2011': 987100.549000001,
 '2012': 972918.5970000005,
 '2013': 958602.6359999999,
 '2014': 943902.0119999999,
 '2015': 928751.6570000013,
 '2016': 913126.371000001,
 '2017': 897150.3029999996,
 '2018': 881117.0099999991,
 '2019': 865084.4530000007,
 '2020': 849086.1199999992,
 '2021': 833141.0359999994,
 '2022': 817276.9179999998,
 '2023': 801546.2990000001,
 '2024': 786007.519000001,
 '2025': 770706.4850000001,
 '2026': 755666.5839999993,
 '2027': 740900.655999999,
 '2028': 726427.8520000004,
 '2029': 712264.1140000012,
 '2030': 698422.7640000009,
 '2031': 684915.5479999988,
 '2032': 671749.2650000001,
 '2033': 658930.5,
 '2034': 646464.1600000001,
 '2035': 634347.9699999997,
 '2036': 622585.5999999992,
 '2037': 611178.6699999995,
 '2038': 600141.0220000013,
 '2039': 589463.3849999993,
 '2040': 579147.2790000001,
 '2041': 569196.2120000003,
 '2042': 559608.4469999997,
 '2043': 550389.3299999996,
 '2044': 541176.4490000005,
 '2045': 531988.2859999985,
 '2046': 522829.9480000008,
 '2047': 513706.8390000011,
 '2048': 504621.5219999994,
 '2049': 495576.066000002,
 '2050': 486573.7410000004,
 '1991': 1189894.5959999997,
 '1992': 1190562.7279999997,
 '1993': 1189342.591,
 '1994': 1186557.509,
 '1995': 1182603.5259999991,
 '1996': 1177611.5970000008,
 '1997': 1171520.4680000003,
 '1998': 1164431.9399999992,
 '1999': 1156536.205,
 '2000': 1147787.352,
 '2001': 1136111.1889999998,
 '2002': 1122595.2089999998,
 '2003': 1108400.7760000005,
 '2004': 1093623.3179999993,
 '2005': 1078424.032999999,
 '2006': 1063360.271,
 '2007': 1048252.354,
 '2008': 1032878.5920000011,
 '2009': 1017385.771,
 '2010.1': 1001692.9520000003,
 '2011.1': 987100.549000001,
 '2012.1': 972918.5970000005,
 '2013.1': 958602.6359999999,
 '2014.1': 943902.0119999999,
 '2015.1': 928751.6570000013,
 '2016.1': 913126.371000001,
 '2017.1': 897150.3029999996,
 '2018.1': 881117.0099999991,
 '2019.1': 865084.4530000007,
 '2020.1': 849086.1199999992,
 '2021.1': 833141.0359999994,
 '2022.1': 817276.9179999998,
 '2023.1': 801546.2990000001,
 '2024.1': 786007.519000001,
 '2025.1': 770706.4850000001,
 '2026.1': 755666.5839999993,
 '2027.1': 740900.655999999,
 '2028.1': 726427.8520000004,
 '2029.1': 712264.1140000012,
 '2030.1': 698422.7640000009,
 '2031.1': 684915.5479999988,
 '2032.1': 671749.2650000001,
 '2033.1': 658930.5,
 '2034.1': 646464.1600000001,
 '2035.1': 634347.9699999997,
 '2036.1': 622585.5999999992,
 '2037.1': 611178.6699999995,
 '2038.1': 600141.0220000013,
 '2039.1': 589463.3849999993,
 '2040.1': 579147.2790000001,
 '2041.1': 569196.2120000003,
 '2042.1': 559608.4469999997,
 '2043.1': 550389.3299999996,
 '2044.1': 541176.4490000005,
 '2045.1': 531988.2859999985,
 '2046.1': 522829.9480000008,
 '2047.1': 513706.8390000011,
 '2048.1': 504621.5219999994,
 '2049.1': 495576.066000002,
 '2050.1': 486573.7410000004},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '2010': 1734006.0019999999,
 '2011': 1749080.3260000001,
 '2012': 1763754.2120000003,
 '2013': 1777909.3210000002,
 '2014': 1791505.4359999998,
 '2015': 1804260.432,
 '2016': 1816440.1520000005,
 '2017': 1828000.8040000005,
 '2018': 1838882.5930000008,
 '2019': 1849087.315,
 '2020': 1858602.9369999997,
 '2021': 1867417.7259999996,
 '2022': 1875492.3579999993,
 '2023': 1882755.5149999987,
 '2024': 1889121.902,
 '2025': 1894530.279999999,
 '2026': 1898955.581999999,
 '2027': 1902403.5980000005,
 '2028': 1904885.524999999,
 '2029': 1906425.648999999,
 '2030': 1907044.1169999996,
 '2031': 1906747.694,
 '2032': 1905534.925000001,
 '2033': 1903418.4339999992,
 '2034': 1900418.8909999991,
 '2035': 1896571.4950000003,
 '2036': 1891918.3199999987,
 '2037': 1886452.9200000004,
 '2038': 1880161.8429999999,
 '2039': 1873117.2839999993,
 '2040': 1865343.5129999986,
 '2041': 1856862.3350000004,
 '2042': 1847662.0559999994,
 '2043': 1837786.0559999999,
 '2044': 1827280.6310000005,
 '2045': 1816168.1600000006,
 '2046': 1804464.3009999995,
 '2047': 1792186.5009999992,
 '2048': 1779351.6189999995,
 '2049': 1765977.2890000003,
 '2050': 1752081.3790000002,
 '1991': 1371028.7049999994,
 '1992': 1393633.266000001,
 '1993': 1415938.1549999996,
 '1994': 1438079.8609999996,
 '1995': 1460030.8089999994,
 '1996': 1481633.185,
 '1997': 1502821.609999999,
 '1998': 1523641.2349999999,
 '1999': 1544218.3399999994,
 '2000': 1564356.9200000006,
 '2001': 1584124.5040000007,
 '2002': 1602458.378,
 '2003': 1620364.5349999997,
 '2004': 1637851.2369999988,
 '2005': 1654835.2849999992,
 '2006': 1671462.9129999992,
 '2007': 1687713.7369999997,
 '2008': 1703538.6019999995,
 '2009': 1718961.8800000004,
 '2010.1': 1734006.0019999999,
 '2011.1': 1749080.3260000001,
 '2012.1': 1763754.2120000003,
 '2013.1': 1777909.3210000002,
 '2014.1': 1791505.4359999998,
 '2015.1': 1804260.432,
 '2016.1': 1816440.1520000005,
 '2017.1': 1828000.8040000005,
 '2018.1': 1838882.5930000008,
 '2019.1': 1849087.315,
 '2020.1': 1858602.9369999997,
 '2021.1': 1867417.7259999996,
 '2022.1': 1875492.3579999993,
 '2023.1': 1882755.5149999987,
 '2024.1': 1889121.902,
 '2025.1': 1894530.279999999,
 '2026.1': 1898955.581999999,
 '2027.1': 1902403.5980000005,
 '2028.1': 1904885.524999999,
 '2029.1': 1906425.648999999,
 '2030.1': 1907044.1169999996,
 '2031.1': 1906747.694,
 '2032.1': 1905534.925000001,
 '2033.1': 1903418.4339999992,
 '2034.1': 1900418.8909999991,
 '2035.1': 1896571.4950000003,
 '2036.1': 1891918.3199999987,
 '2037.1': 1886452.9200000004,
 '2038.1': 1880161.8429999999,
 '2039.1': 1873117.2839999993,
 '2040.1': 1865343.5129999986,
 '2041.1': 1856862.3350000004,
 '2042.1': 1847662.0559999994,
 '2043.1': 1837786.0559999999,
 '2044.1': 1827280.6310000005,
 '2045.1': 1816168.1600000006,
 '2046.1': 1804464.3009999995,
 '2047.1': 1792186.5009999992,
 '2048.1': 1779351.6189999995,
 '2049.1': 1765977.2890000003,
 '2050.1': 1752081.3790000002},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '2010': 398123.048,
 '2011': 406828.0650000002,
 '2012': 415814.666,
 '2013': 424936.1080000001,
 '2014': 434118.1449999998,
 '2015': 443323.0090000002,
 '2016': 452530.5379999998,
 '2017': 461736.528,
 '2018': 470928.666,
 '2019': 480103.4469999999,
 '2020': 489255.442,
 '2021': 498372.811,
 '2022': 507441.472,
 '2023': 516451.741,
 '2024': 525394.0659999999,
 '2025': 534258.6939999998,
 '2026': 543034.8590000002,
 '2027': 551711.837,
 '2028': 560280.161,
 '2029': 568731.21,
 '2030': 577057.7839999998,
 '2031': 585244.7930000001,
 '2032': 593284.8230000001,
 '2033': 601167.5579999998,
 '2034': 608883.9039999999,
 '2035': 616424.4350000002,
 '2036': 623779.3909999997,
 '2037': 630942.7140000002,
 '2038': 637907.4169999998,
 '2039': 644671.9769999998,
 '2040': 651228.27,
 '2041': 657577.1369999999,
 '2042': 663697.1359999998,
 '2043': 669590.2810000001,
 '2044': 675235.5680000001,
 '2045': 680623.5870000002,
 '2046': 685748.37,
 '2047': 690604.269,
 '2048': 695186.7529999999,
 '2049': 699492.2849999999,
 '2050': 703517.0980000002,
 '1991': 255129.482,
 '1992': 261306.7930000001,
 '1993': 267740.9149999999,
 '1994': 274361.3749999999,
 '1995': 281081.258,
 '1996': 287843.681,
 '1997': 294601.838,
 '1998': 301515.1599999999,
 '1999': 308622.105,
 '2000': 315968.1300000001,
 '2001': 323486.525,
 '2002': 331305.915,
 '2003': 339333.213,
 '2004': 347548.3870000001,
 '2005': 355796.2389999999,
 '2006': 364114.524,
 '2007': 372917.2029999999,
 '2008': 381181.6629999999,
 '2009': 389577.8329999999,
 '2010.1': 398123.048,
 '2011.1': 406828.0650000002,
 '2012.1': 415814.666,
 '2013.1': 424936.1080000001,
 '2014.1': 434118.1449999998,
 '2015.1': 443323.0090000002,
 '2016.1': 452530.5379999998,
 '2017.1': 461736.528,
 '2018.1': 470928.666,
 '2019.1': 480103.4469999999,
 '2020.1': 489255.442,
 '2021.1': 498372.811,
 '2022.1': 507441.472,
 '2023.1': 516451.741,
 '2024.1': 525394.0659999999,
 '2025.1': 534258.6939999998,
 '2026.1': 543034.8590000002,
 '2027.1': 551711.837,
 '2028.1': 560280.161,
 '2029.1': 568731.21,
 '2030.1': 577057.7839999998,
 '2031.1': 585244.7930000001,
 '2032.1': 593284.8230000001,
 '2033.1': 601167.5579999998,
 '2034.1': 608883.9039999999,
 '2035.1': 616424.4350000002,
 '2036.1': 623779.3909999997,
 '2037.1': 630942.7140000002,
 '2038.1': 637907.4169999998,
 '2039.1': 644671.9769999998,
 '2040.1': 651228.27,
 '2041.1': 657577.1369999999,
 '2042.1': 663697.1359999998,
 '2043.1': 669590.2810000001,
 '2044.1': 675235.5680000001,
 '2045.1': 680623.5870000002,
 '2046.1': 685748.37,
 '2047.1': 690604.269,
 '2048.1': 695186.7529999999,
 '2049.1': 699492.2849999999,
 '2050.1': 703517.0980000002},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '2010': 539628.588,
 '2011': 550077.3440000002,
 '2012': 560785.0650000001,
 '2013': 571613.9110000001,
 '2014': 582495.8949999996,
 '2015': 593407.7340000002,
 '2016': 604333.2219999996,
 '2017': 615263.1509999996,
 '2018': 626177.8259999999,
 '2019': 637062.3360000001,
 '2020': 647903.3059999996,
 '2021': 658686.8539999997,
 '2022': 669403.1259999997,
 '2023': 680048.0909999998,
 '2024': 690620.4489999997,
 '2025': 701116.9810000005,
 '2026': 711528.708,
 '2027': 721845.2650000002,
 '2028': 732060.5510000001,
 '2029': 742169.4559999998,
 '2030': 752167.9250000002,
 '2031': 762043.6409999998,
 '2032': 771791.669,
 '2033': 781400.326,
 '2034': 790862.7029999996,
 '2035': 800173.0319999993,
 '2036': 809330.4769999997,
 '2037': 818265.5869999998,
 '2038': 826971.5040000002,
 '2039': 835440.4240000003,
 '2040': 843661.3430000002,
 '2041': 851624.2619999998,
 '2042': 859306.3289999996,
 '2043': 866703.4840000002,
 '2044': 873790.702,
 '2045': 880556.5480000004,
 '2046': 886993.0849999997,
 '2047': 893092.8839999991,
 '2048': 898849.8919999993,
 '2049': 904259.1839999999,
 '2050': 909315.7570000002,
 '1991': 365489.1850000001,
 '1992': 373323.6910000001,
 '1993': 381269.536,
 '1994': 389410.6010000001,
 '1995': 397793.3959999999,
 '1996': 406371.503,
 '1997': 415079.198,
 '1998': 424016.4280000001,
 '1999': 433118.5249999999,
 '2000': 442366.6320000001,
 '2001': 451329.6720000001,
 '2002': 460362.9179999998,
 '2003': 469565.8090000002,
 '2004': 478976.1380000002,
 '2005': 488573.4420000001,
 '2006': 498486.32,
 '2007': 509003.398,
 '2008': 519063.9389999997,
 '2009': 529292.435,
 '2010.1': 539628.588,
 '2011.1': 550077.3440000002,
 '2012.1': 560785.0650000001,
 '2013.1': 571613.9110000001,
 '2014.1': 582495.8949999996,
 '2015.1': 593407.7340000002,
 '2016.1': 604333.2219999996,
 '2017.1': 615263.1509999996,
 '2018.1': 626177.8259999999,
 '2019.1': 637062.3360000001,
 '2020.1': 647903.3059999996,
 '2021.1': 658686.8539999997,
 '2022.1': 669403.1259999997,
 '2023.1': 680048.0909999998,
 '2024.1': 690620.4489999997,
 '2025.1': 701116.9810000005,
 '2026.1': 711528.708,
 '2027.1': 721845.2650000002,
 '2028.1': 732060.5510000001,
 '2029.1': 742169.4559999998,
 '2030.1': 752167.9250000002,
 '2031.1': 762043.6409999998,
 '2032.1': 771791.669,
 '2033.1': 781400.326,
 '2034.1': 790862.7029999996,
 '2035.1': 800173.0319999993,
 '2036.1': 809330.4769999997,
 '2037.1': 818265.5869999998,
 '2038.1': 826971.5040000002,
 '2039.1': 835440.4240000003,
 '2040.1': 843661.3430000002,
 '2041.1': 851624.2619999998,
 '2042.1': 859306.3289999996,
 '2043.1': 866703.4840000002,
 '2044.1': 873790.702,
 '2045.1': 880556.5480000004,
 '2046.1': 886993.0849999997,
 '2047.1': 893092.8839999991,
 '2048.1': 898849.8919999993,
 '2049.1': 904259.1839999999,
 '2050.1': 909315.7570000002},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '2010': 640859.2990000001,
 '2011': 652803.7730000002,
 '2012': 665140.0730000002,
 '2013': 677663.8110000001,
 '2014': 690251.6530000002,
 '2015': 702838.816,
 '2016': 715396.6240000001,
 '2017': 727896.7019999998,
 '2018': 740318.3359999999,
 '2019': 752651.0970000001,
 '2020': 764884.396,
 '2021': 777000.2139999999,
 '2022': 788982.6950000001,
 '2023': 800827.8589999997,
 '2024': 812534.941,
 '2025': 824101.1499999999,
 '2026': 835515.99,
 '2027': 846768.465,
 '2028': 857855.0029999999,
 '2029': 868774.0289999997,
 '2030': 879523.7029999997,
 '2031': 890090.9570000003,
 '2032': 900469.066,
 '2033': 910646.202,
 '2034': 920616.0869999995,
 '2035': 930373.8119999999,
 '2036': 939919.531,
 '2037': 949181.3829999997,
 '2038': 958147.8810000003,
 '2039': 966805.7660000001,
 '2040': 975140.216,
 '2041': 983140.9380000001,
 '2042': 990784.3739999998,
 '2043': 998090.1139999998,
 '2044': 1005035.3839999998,
 '2045': 1011608.0770000005,
 '2046': 1017799.9930000007,
 '2047': 1023603.8649999998,
 '2048': 1029014.0710000002,
 '2049': 1034026.3880000003,
 '2050': 1038636.716,
 '1991': 443448.7649999999,
 '1992': 452539.4939999999,
 '1993': 461737.856,
 '1994': 471280.709,
 '1995': 481097.777,
 '1996': 491037.1499999999,
 '1997': 500955.548,
 '1998': 511006.3949999999,
 '1999': 521202.265,
 '2000': 531568.3920000001,
 '2001': 541691.634,
 '2002': 551920.837,
 '2003': 562342.8189999999,
 '2004': 572973.496,
 '2005': 583724.1160000002,
 '2006': 594752.6329999999,
 '2007': 606408.9889999998,
 '2008': 617656.517,
 '2009': 629149.675,
 '2010.1': 640859.2990000001,
 '2011.1': 652803.7730000002,
 '2012.1': 665140.0730000002,
 '2013.1': 677663.8110000001,
 '2014.1': 690251.6530000002,
 '2015.1': 702838.816,
 '2016.1': 715396.6240000001,
 '2017.1': 727896.7019999998,
 '2018.1': 740318.3359999999,
 '2019.1': 752651.0970000001,
 '2020.1': 764884.396,
 '2021.1': 777000.2139999999,
 '2022.1': 788982.6950000001,
 '2023.1': 800827.8589999997,
 '2024.1': 812534.941,
 '2025.1': 824101.1499999999,
 '2026.1': 835515.99,
 '2027.1': 846768.465,
 '2028.1': 857855.0029999999,
 '2029.1': 868774.0289999997,
 '2030.1': 879523.7029999997,
 '2031.1': 890090.9570000003,
 '2032.1': 900469.066,
 '2033.1': 910646.202,
 '2034.1': 920616.0869999995,
 '2035.1': 930373.8119999999,
 '2036.1': 939919.531,
 '2037.1': 949181.3829999997,
 '2038.1': 958147.8810000003,
 '2039.1': 966805.7660000001,
 '2040.1': 975140.216,
 '2041.1': 983140.9380000001,
 '2042.1': 990784.3739999998,
 '2043.1': 998090.1139999998,
 '2044.1': 1005035.3839999998,
 '2045.1': 1011608.0770000005,
 '2046.1': 1017799.9930000007,
 '2047.1': 1023603.8649999998,
 '2048.1': 1029014.0710000002,
 '2049.1': 1034026.3880000003,
 '2050.1': 1038636.716},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '2010': 262483.969,
 '2011': 268444.495,
 '2012': 274596.2869999999,
 '2013': 280815.5660000001,
 '2014': 287073.074,
 '2015': 293362.422,
 '2016': 299674.6100000001,
 '2017': 306001.9249999999,
 '2018': 312327.611,
 '2019': 318637.4739999999,
 '2020': 324919.316,
 '2021': 331162.962,
 '2022': 337361.6200000001,
 '2023': 343510.8899999999,
 '2024': 349608.0590000001,
 '2025': 355649.1919999999,
 '2026': 361627.171,
 '2027': 367533.325,
 '2028': 373360.694,
 '2029': 379102.1779999999,
 '2030': 384750.9019999999,
 '2031': 390300.813,
 '2032': 395745.783,
 '2033': 401079.2369999998,
 '2034': 406295.7799999998,
 '2035': 411389.3309999998,
 '2036': 416358.1960000001,
 '2037': 421196.1979999999,
 '2038': 425901.2130000001,
 '2039': 430474.3229999999,
 '2040': 434903.8400000001,
 '2041': 439189.7339999998,
 '2042': 443317.9419999998,
 '2043': 447289.335,
 '2044': 451085.106,
 '2045': 454698.928,
 '2046': 458127.3340000003,
 '2047': 461366.2519999998,
 '2048': 464412.083,
 '2049': 467261.671,
 '2050': 469911.9730000001,
 '1991': 166498.0850000001,
 '1992': 170016.399,
 '1993': 173553.347,
 '1994': 177328.785,
 '1995': 181431.829,
 '1996': 185879.919,
 '1997': 190651.534,
 '1998': 195717.7009999999,
 '1999': 200924.526,
 '2000': 206163.382,
 '2001': 211349.973,
 '2002': 216551.924,
 '2003': 221870.1730000001,
 '2004': 227333.333,
 '2005': 232915.502,
 '2006': 238674.81,
 '2007': 244964.5329999999,
 '2008': 250718.573,
 '2009': 256572.0340000001,
 '2010.1': 262483.969,
 '2011.1': 268444.495,
 '2012.1': 274596.2869999999,
 '2013.1': 280815.5660000001,
 '2014.1': 287073.074,
 '2015.1': 293362.422,
 '2016.1': 299674.6100000001,
 '2017.1': 306001.9249999999,
 '2018.1': 312327.611,
 '2019.1': 318637.4739999999,
 '2020.1': 324919.316,
 '2021.1': 331162.962,
 '2022.1': 337361.6200000001,
 '2023.1': 343510.8899999999,
 '2024.1': 349608.0590000001,
 '2025.1': 355649.1919999999,
 '2026.1': 361627.171,
 '2027.1': 367533.325,
 '2028.1': 373360.694,
 '2029.1': 379102.1779999999,
 '2030.1': 384750.9019999999,
 '2031.1': 390300.813,
 '2032.1': 395745.783,
 '2033.1': 401079.2369999998,
 '2034.1': 406295.7799999998,
 '2035.1': 411389.3309999998,
 '2036.1': 416358.1960000001,
 '2037.1': 421196.1979999999,
 '2038.1': 425901.2130000001,
 '2039.1': 430474.3229999999,
 '2040.1': 434903.8400000001,
 '2041.1': 439189.7339999998,
 '2042.1': 443317.9419999998,
 '2043.1': 447289.335,
 '2044.1': 451085.106,
 '2045.1': 454698.928,
 '2046.1': 458127.3340000003,
 '2047.1': 461366.2519999998,
 '2048.1': 464412.083,
 '2049.1': 467261.671,
 '2050.1': 469911.9730000001},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '2010': 7833.959,
 '2011': 8056.443,
 '2012': 8276.416,
 '2013': 8497.927,
 '2014': 8726.909,
 '2015': 8967.359,
 '2016': 9220.356,
 '2017': 9483.827,
 '2018': 9754.746,
 '2019': 10028.767,
 '2020': 10302.641,
 '2021': 10575.557,
 '2022': 10848.076,
 '2023': 11120.085,
 '2024': 11391.765,
 '2025': 11663.312,
 '2026': 11934.439,
 '2027': 12204.981,
 '2028': 12475.403,
 '2029': 12746.43,
 '2030': 13018.607,
 '2031': 13291.963,
 '2032': 13566.48,
 '2033': 13842.582,
 '2034': 14120.79,
 '2035': 14401.539,
 '2036': 14684.196,
 '2037': 14968.607,
 '2038': 15254.41,
 '2039': 15541.092,
 '2040': 15828.117,
 '2041': 16115.121,
 '2042': 16401.578,
 '2043': 16686.665,
 '2044': 16969.424,
 '2045': 17248.994,
 '2046': 17524.846,
 '2047': 17796.486,
 '2048': 18063.235,
 '2049': 18324.39,
 '2050': 18579.352,
 '1991': 5184.309,
 '1992': 5285.413,
 '1993': 5377.609,
 '1994': 5459.75,
 '1995': 5532.158,
 '1996': 5593.335,
 '1997': 5646.459,
 '1998': 5701.961,
 '1999': 5774.394,
 '2000': 5872.887,
 '2001': 6001.113,
 '2002': 6156.269,
 '2003': 6333.751,
 '2004': 6526.045,
 '2005': 6727.349,
 '2006': 6937.204,
 '2007': 7156.384,
 '2008': 7381.365,
 '2009': 7608.188,
 '2010.1': 7833.959,
 '2011.1': 8056.443,
 '2012.1': 8276.416,
 '2013.1': 8497.927,
 '2014.1': 8726.909,
 '2015.1': 8967.359,
 '2016.1': 9220.356,
 '2017.1': 9483.827,
 '2018.1': 9754.746,
 '2019.1': 10028.767,
 '2020.1': 10302.641,
 '2021.1': 10575.557,
 '2022.1': 10848.076,
 '2023.1': 11120.085,
 '2024.1': 11391.765,
 '2025.1': 11663.312,
 '2026.1': 11934.439,
 '2027.1': 12204.981,
 '2028.1': 12475.403,
 '2029.1': 12746.43,
 '2030.1': 13018.607,
 '2031.1': 13291.963,
 '2032.1': 13566.48,
 '2033.1': 13842.582,
 '2034.1': 14120.79,
 '2035.1': 14401.539,
 '2036.1': 14684.196,
 '2037.1': 14968.607,
 '2038.1': 15254.41,
 '2039.1': 15541.092,
 '2040.1': 15828.117,
 '2041.1': 16115.121,
 '2042.1': 16401.578,
 '2043.1': 16686.665,
 '2044.1': 16969.424,
 '2045.1': 17248.994,
 '2046.1': 17524.846,
 '2047.1': 17796.486,
 '2048.1': 18063.235,
 '2049.1': 18324.39,
 '2050.1': 18579.352},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '2010': 496.767,
 '2011': 508.448,
 '2012': 520.293,
 '2013': 532.229,
 '2014': 544.189,
 '2015': 556.09,
 '2016': 567.911,
 '2017': 579.639,
 '2018': 591.255,
 '2019': 602.75,
 '2020': 614.114,
 '2021': 625.324,
 '2022': 636.352,
 '2023': 647.197,
 '2024': 657.832,
 '2025': 668.246,
 '2026': 678.42,
 '2027': 688.34,
 '2028': 697.99,
 '2029': 707.367,
 '2030': 716.454,
 '2031': 725.411,
 '2032': 734.246,
 '2033': 742.94,
 '2034': 751.495,
 '2035': 759.914,
 '2036': 768.177,
 '2037': 776.291,
 '2038': 784.245,
 '2039': 792.025,
 '2040': 799.617,
 '2041': 807.029,
 '2042': 814.238,
 '2043': 821.246,
 '2044': 828.031,
 '2045': 834.588,
 '2046': 840.908,
 '2047': 846.985,
 '2048': 852.815,
 '2049': 858.388,
 '2050': 863.694,
 '1991': 303.637,
 '1992': 312.345,
 '1993': 321.724,
 '1994': 331.241,
 '1995': 340.851,
 '1996': 350.556,
 '1997': 360.339,
 '1998': 370.21,
 '1999': 380.114,
 '2000': 390.064,
 '2001': 400.041,
 '2002': 410.073,
 '2003': 420.218,
 '2004': 430.581,
 '2005': 441.134,
 '2006': 451.884,
 '2007': 462.822,
 '2008': 473.954,
 '2009': 485.27,
 '2010.1': 496.767,
 '2011.1': 508.448,
 '2012.1': 520.293,
 '2013.1': 532.229,
 '2014.1': 544.189,
 '2015.1': 556.09,
 '2016.1': 567.911,
 '2017.1': 579.639,
 '2018.1': 591.255,
 '2019.1': 602.75,
 '2020.1': 614.114,
 '2021.1': 625.324,
 '2022.1': 636.352,
 '2023.1': 647.197,
 '2024.1': 657.832,
 '2025.1': 668.246,
 '2026.1': 678.42,
 '2027.1': 688.34,
 '2028.1': 697.99,
 '2029.1': 707.367,
 '2030.1': 716.454,
 '2031.1': 725.411,
 '2032.1': 734.246,
 '2033.1': 742.94,
 '2034.1': 751.495,
 '2035.1': 759.914,
 '2036.1': 768.177,
 '2037.1': 776.291,
 '2038.1': 784.245,
 '2039.1': 792.025,
 '2040.1': 799.617,
 '2041.1': 807.029,
 '2042.1': 814.238,
 '2043.1': 821.246,
 '2044.1': 828.031,
 '2045.1': 834.588,
 '2046.1': 840.908,
 '2047.1': 846.985,
 '2048.1': 852.815,
 '2049.1': 858.388,
 '2050.1': 863.694},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '2010': 195.77,
 '2011': 198.612,
 '2012': 201.456,
 '2013': 204.251,
 '2014': 206.929,
 '2015': 209.442,
 '2016': 211.764,
 '2017': 213.906,
 '2018': 215.875,
 '2019': 217.689,
 '2020': 219.361,
 '2021': 220.887,
 '2022': 222.257,
 '2023': 223.462,
 '2024': 224.496,
 '2025': 225.352,
 '2026': 226.028,
 '2027': 226.524,
 '2028': 226.834,
 '2029': 226.957,
 '2030': 226.889,
 '2031': 226.632,
 '2032': 226.186,
 '2033': 225.55,
 '2034': 224.729,
 '2035': 223.725,
 '2036': 222.633,
 '2037': 221.459,
 '2038': 220.205,
 '2039': 218.874,
 '2040': 217.47,
 '2041': 215.998,
 '2042': 214.459,
 '2043': 212.857,
 '2044': 211.195,
 '2045': 209.48,
 '2046': 207.712,
 '2047': 205.893,
 '2048': 204.028,
 '2049': 202.116,
 '2050': 200.165,
 '1991': 144.952,
 '1992': 146.626,
 '1993': 147.158,
 '1994': 147.789,
 '1995': 149.401,
 '1996': 152.253,
 '1997': 156.032,
 '1998': 160.358,
 '1999': 164.626,
 '2000': 168.406,
 '2001': 171.618,
 '2002': 174.439,
 '2003': 176.988,
 '2004': 179.465,
 '2005': 182.018,
 '2006': 184.663,
 '2007': 187.353,
 '2008': 190.109,
 '2009': 192.941,
 '2010.1': 195.77,
 '2011.1': 198.612,
 '2012.1': 201.456,
 '2013.1': 204.251,
 '2014.1': 206.929,
 '2015.1': 209.442,
 '2016.1': 211.764,
 '2017.1': 213.906,
 '2018.1': 215.875,
 '2019.1': 217.689,
 '2020.1': 219.361,
 '2021.1': 220.887,
 '2022.1': 222.257,
 '2023.1': 223.462,
 '2024.1': 224.496,
 '2025.1': 225.352,
 '2026.1': 226.028,
 '2027.1': 226.524,
 '2028.1': 226.834,
 '2029.1': 226.957,
 '2030.1': 226.889,
 '2031.1': 226.632,
 '2032.1': 226.186,
 '2033.1': 225.55,
 '2034.1': 224.729,
 '2035.1': 223.725,
 '2036.1': 222.633,
 '2037.1': 221.459,
 '2038.1': 220.205,
 '2039.1': 218.874,
 '2040.1': 217.47,
 '2041.1': 215.998,
 '2042.1': 214.459,
 '2043.1': 212.857,
 '2044.1': 211.195,
 '2045.1': 209.48,
 '2046.1': 207.712,
 '2047.1': 205.893,
 '2048.1': 204.028,
 '2049.1': 202.116,
 '2050.1': 200.165},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '2010': 2846.355,
 '2011': 2874.045,
 '2012': 2902.04,
 '2013': 2931.111,
 '2014': 2961.994,
 '2015': 2995.125,
 '2016': 3030.917,
 '2017': 3069.11,
 '2018': 3108.634,
 '2019': 3148.013,
 '2020': 3186.178,
 '2021': 3222.842,
 '2022': 3258.219,
 '2023': 3292.413,
 '2024': 3325.66,
 '2025': 3358.128,
 '2026': 3389.751,
 '2027': 3420.401,
 '2028': 3450.178,
 '2029': 3479.197,
 '2030': 3507.555,
 '2031': 3535.255,
 '2032': 3562.248,
 '2033': 3588.53,
 '2034': 3614.066,
 '2035': 3638.874,
 '2036': 3663.106,
 '2037': 3685.912,
 '2038': 3707.353,
 '2039': 3727.295,
 '2040': 3745.623,
 '2041': 3762.288,
 '2042': 3777.252,
 '2043': 3790.444,
 '2044': 3801.792,
 '2045': 3811.254,
 '2046': 3818.808,
 '2047': 3824.456,
 '2048': 3828.225,
 '2049': 3830.159,
 '2050': 3830.298,
 '1991': 2514.669,
 '1992': 2485.703,
 '1993': 2447.795,
 '1994': 2414.204,
 '1995': 2394.438,
 '1996': 2390.485,
 '1997': 2399.845,
 '1998': 2421.309,
 '1999': 2452.414,
 '2000': 2490.747,
 '2001': 2537.002,
 '2002': 2590.231,
 '2003': 2645.064,
 '2004': 2694.69,
 '2005': 2734.684,
 '2006': 2763.263,
 '2007': 2782.012,
 '2008': 2793.54,
 '2009': 2819.613,
 '2010.1': 2846.355,
 '2011.1': 2874.045,
 '2012.1': 2902.04,
 '2013.1': 2931.111,
 '2014.1': 2961.994,
 '2015.1': 2995.125,
 '2016.1': 3030.917,
 '2017.1': 3069.11,
 '2018.1': 3108.634,
 '2019.1': 3148.013,
 '2020.1': 3186.178,
 '2021.1': 3222.842,
 '2022.1': 3258.219,
 '2023.1': 3292.413,
 '2024.1': 3325.66,
 '2025.1': 3358.128,
 '2026.1': 3389.751,
 '2027.1': 3420.401,
 '2028.1': 3450.178,
 '2029.1': 3479.197,
 '2030.1': 3507.555,
 '2031.1': 3535.255,
 '2032.1': 3562.248,
 '2033.1': 3588.53,
 '2034.1': 3614.066,
 '2035.1': 3638.874,
 '2036.1': 3663.106,
 '2037.1': 3685.912,
 '2038.1': 3707.353,
 '2039.1': 3727.295,
 '2040.1': 3745.623,
 '2041.1': 3762.288,
 '2042.1': 3777.252,
 '2043.1': 3790.444,
 '2044.1': 3801.792,
 '2045.1': 3811.254,
 '2046.1': 3818.808,
 '2047.1': 3824.456,
 '2048.1': 3828.225,
 '2049.1': 3830.159,
 '2050.1': 3830.298},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '2010': 72513.53,
 '2011': 74076.738,
 '2012': 75656.319,
 '2013': 77262.426,
 '2014': 78869.363,
 '2015': 80469.946,
 '2016': 82059.981,
 '2017': 83640.582,
 '2018': 85207.113,
 '2019': 86759.295,
 '2020': 88295.647,
 '2021': 89813.744,
 '2022': 91310.183,
 '2023': 92781.43,
 '2024': 94223.602,
 '2025': 95633.359,
 '2026': 97008.125,
 '2027': 98346.073,
 '2028': 99645.613,
 '2029': 100905.514,
 '2030': 102124.458,
 '2031': 103300.99,
 '2032': 104433.392,
 '2033': 105519.835,
 '2034': 106558.492,
 '2035': 107547.947,
 '2036': 108487.128,
 '2037': 109375.753,
 '2038': 110214.274,
 '2039': 111003.755,
 '2040': 111745.181,
 '2041': 112439.341,
 '2042': 113087.32,
 '2043': 113692.326,
 '2044': 114239.057,
 '2045': 114730.192,
 '2046': 115165.168,
 '2047': 115543.554,
 '2048': 115864.683,
 '2049': 116127.924,
 '2050': 116332.817,
 '1991': 43410.847,
 '1992': 44873.477,
 '1993': 46375.843,
 '1994': 47877.39,
 '1995': 49385.397,
 '1996': 50869.776,
 '1997': 52326.119,
 '1998': 53771.445,
 '1999': 55232.981,
 '2000': 56730.042,
 '2001': 58268.076,
 '2002': 59839.634,
 '2003': 61438.556,
 '2004': 63054.369,
 '2005': 64680.71,
 '2006': 66314.612,
 '2007': 67946.189,
 '2008': 69451.069,
 '2009': 70972.092,
 '2010.1': 72513.53,
 '2011.1': 74076.738,
 '2012.1': 75656.319,
 '2013.1': 77262.426,
 '2014.1': 78869.363,
 '2015.1': 80469.946,
 '2016.1': 82059.981,
 '2017.1': 83640.582,
 '2018.1': 85207.113,
 '2019.1': 86759.295,
 '2020.1': 88295.647,
 '2021.1': 89813.744,
 '2022.1': 91310.183,
 '2023.1': 92781.43,
 '2024.1': 94223.602,
 '2025.1': 95633.359,
 '2026.1': 97008.125,
 '2027.1': 98346.073,
 '2028.1': 99645.613,
 '2029.1': 100905.514,
 '2030.1': 102124.458,
 '2031.1': 103300.99,
 '2032.1': 104433.392,
 '2033.1': 105519.835,
 '2034.1': 106558.492,
 '2035.1': 107547.947,
 '2036.1': 108487.128,
 '2037.1': 109375.753,
 '2038.1': 110214.274,
 '2039.1': 111003.755,
 '2040.1': 111745.181,
 '2041.1': 112439.341,
 '2042.1': 113087.32,
 '2043.1': 113692.326,
 '2044.1': 114239.057,
 '2045.1': 114730.192,
 '2046.1': 115165.168,
 '2047.1': 115543.554,
 '2048.1': 115864.683,
 '2049.1': 116127.924,
 '2050.1': 116332.817},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '2010': 31603.483,
 '2011': 32303.238,
 '2012': 33007.2,
 '2013': 33712.691,
 '2014': 34416.636,
 '2015': 35116.503,
 '2016': 35810.733,
 '2017': 36498.515,
 '2018': 37179.074,
 '2019': 37851.953,
 '2020': 38516.638,
 '2021': 39172.008,
 '2022': 39817.146,
 '2023': 40451.978,
 '2024': 41076.706,
 '2025': 41691.191,
 '2026': 42294.705,
 '2027': 42886.126,
 '2028': 43464.414,
 '2029': 44028.406,
 '2030': 44577.009,
 '2031': 45109.461,
 '2032': 45624.97,
 '2033': 46122.484,
 '2034': 46601.028,
 '2035': 47060.114,
 '2036': 47500.626,
 '2037': 47919.195,
 '2038': 48316.629,
 '2039': 48692.108,
 '2040': 49044.98,
 '2041': 49374.66,
 '2042': 49680.841,
 '2043': 49963.508,
 '2044': 50222.809,
 '2045': 50458.808,
 '2046': 50671.311,
 '2047': 50860.057,
 '2048': 51024.897,
 '2049': 51165.721,
 '2050': 51282.416,
 '1991': 20058.74,
 '1992': 20634.704,
 '1993': 21209.905,
 '1994': 21782.569,
 '1995': 22352.157,
 '1996': 22918.171,
 '1997': 23482.301,
 '1998': 24047.421,
 '1999': 24617.96,
 '2000': 25194.298,
 '2001': 25779.834,
 '2002': 26374.762,
 '2003': 26981.085,
 '2004': 27600.542,
 '2005': 28234.834,
 '2006': 28883.861,
 '2007': 29547.088,
 '2008': 30222.715,
 '2009': 30909.074,
 '2010.1': 31603.483,
 '2011.1': 32303.238,
 '2012.1': 33007.2,
 '2013.1': 33712.691,
 '2014.1': 34416.636,
 '2015.1': 35116.503,
 '2016.1': 35810.733,
 '2017.1': 36498.515,
 '2018.1': 37179.074,
 '2019.1': 37851.953,
 '2020.1': 38516.638,
 '2021.1': 39172.008,
 '2022.1': 39817.146,
 '2023.1': 40451.978,
 '2024.1': 41076.706,
 '2025.1': 41691.191,
 '2026.1': 42294.705,
 '2027.1': 42886.126,
 '2028.1': 43464.414,
 '2029.1': 44028.406,
 '2030.1': 44577.009,
 '2031.1': 45109.461,
 '2032.1': 45624.97,
 '2033.1': 46122.484,
 '2034.1': 46601.028,
 '2035.1': 47060.114,
 '2036.1': 47500.626,
 '2037.1': 47919.195,
 '2038.1': 48316.629,
 '2039.1': 48692.108,
 '2040.1': 49044.98,
 '2041.1': 49374.66,
 '2042.1': 49680.841,
 '2043.1': 49963.508,
 '2044.1': 50222.809,
 '2045.1': 50458.808,
 '2046.1': 50671.311,
 '2047.1': 50860.057,
 '2048.1': 51024.897,
 '2049.1': 51165.721,
 '2050.1': 51282.416},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '2010': 14396.303,
 '2011': 14659.814,
 '2012': 14921.525,
 '2013': 15182.304,
 '2014': 15443.315,
 '2015': 15705.295,
 '2016': 15968.305,
 '2017': 16231.87,
 '2018': 16495.525,
 '2019': 16758.613,
 '2020': 17020.546,
 '2021': 17281.025,
 '2022': 17539.783,
 '2023': 17796.275,
 '2024': 18049.897,
 '2025': 18300.128,
 '2026': 18546.715,
 '2027': 18789.399,
 '2028': 19027.788,
 '2029': 19261.486,
 '2030': 19490.283,
 '2031': 19714.164,
 '2032': 19933.389,
 '2033': 20148.404,
 '2034': 20360.249,
 '2035': 20563.63,
 '2036': 20759.253,
 '2037': 20946.945,
 '2038': 21126.691,
 '2039': 21298.539,
 '2040': 21462.488,
 '2041': 21618.43,
 '2042': 21766.221,
 '2043': 21905.783,
 '2044': 22037.049,
 '2045': 22159.937,
 '2046': 22274.348,
 '2047': 22380.159,
 '2048': 22477.259,
 '2049': 22565.522,
 '2050': 22644.833,
 '1991': 9062.373,
 '1992': 9265.206,
 '1993': 9474.762,
 '1994': 9729.836,
 '1995': 9999.27,
 '1996': 10279.92,
 '1997': 10571.361,
 '1998': 10871.735,
 '1999': 11178.764,
 '2000': 11490.635,
 '2001': 11806.896,
 '2002': 12127.427,
 '2003': 12452.023,
 '2004': 12780.505,
 '2005': 13053.181,
 '2006': 13324.762,
 '2007': 13595.04,
 '2008': 13863.552,
 '2009': 14130.85,
 '2010.1': 14396.303,
 '2011.1': 14659.814,
 '2012.1': 14921.525,
 '2013.1': 15182.304,
 '2014.1': 15443.315,
 '2015.1': 15705.295,
 '2016.1': 15968.305,
 '2017.1': 16231.87,
 '2018.1': 16495.525,
 '2019.1': 16758.613,
 '2020.1': 17020.546,
 '2021.1': 17281.025,
 '2022.1': 17539.783,
 '2023.1': 17796.275,
 '2024.1': 18049.897,
 '2025.1': 18300.128,
 '2026.1': 18546.715,
 '2027.1': 18789.399,
 '2028.1': 19027.788,
 '2029.1': 19261.486,
 '2030.1': 19490.283,
 '2031.1': 19714.164,
 '2032.1': 19933.389,
 '2033.1': 20148.404,
 '2034.1': 20360.249,
 '2035.1': 20563.63,
 '2036.1': 20759.253,
 '2037.1': 20946.945,
 '2038.1': 21126.691,
 '2039.1': 21298.539,
 '2040.1': 21462.488,
 '2041.1': 21618.43,
 '2042.1': 21766.221,
 '2043.1': 21905.783,
 '2044.1': 22037.049,
 '2045.1': 22159.937,
 '2046.1': 22274.348,
 '2047.1': 22380.159,
 '2048.1': 22477.259,
 '2049.1': 22565.522,
 '2050.1': 22644.833},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '2010': 12809.514,
 '2011': 13178.48,
 '2012': 13551.942,
 '2013': 13930.476,
 '2014': 14315.223,
 '2015': 14706.907,
 '2016': 15105.299,
 '2017': 15509.514,
 '2018': 15918.795,
 '2019': 16332.17,
 '2020': 16748.855,
 '2021': 17168.11,
 '2022': 17589.674,
 '2023': 18013.68,
 '2024': 18440.49,
 '2025': 18870.1,
 '2026': 19302.072,
 '2027': 19735.339,
 '2028': 20168.414,
 '2029': 20599.527,
 '2030': 21027.123,
 '2031': 21450.185,
 '2032': 21868.07,
 '2033': 22280.129,
 '2034': 22686.02,
 '2035': 23088.127,
 '2036': 23486.261,
 '2037': 23879.805,
 '2038': 24268.276,
 '2039': 24651.175,
 '2040': 25028.032,
 '2041': 25398.337,
 '2042': 25761.555,
 '2043': 26117.078,
 '2044': 26464.259,
 '2045': 26802.535,
 '2046': 27131.368,
 '2047': 27450.331,
 '2048': 27759.082,
 '2049': 28057.339,
 '2050': 28344.777,
 '1991': 8495.321,
 '1992': 8540.958,
 '1993': 8530.727,
 '1994': 8532.528,
 '1995': 8594.81,
 '1996': 8731.923,
 '1997': 8928.182,
 '1998': 9164.948,
 '1999': 9440.461,
 '2000': 9714.122,
 '2001': 9976.835,
 '2002': 10237.35,
 '2003': 10501.614,
 '2004': 10779.157,
 '2005': 11076.729,
 '2006': 11395.534,
 '2007': 11732.355,
 '2008': 12084.063,
 '2009': 12444.33,
 '2010.1': 12809.514,
 '2011.1': 13178.48,
 '2012.1': 13551.942,
 '2013.1': 13930.476,
 '2014.1': 14315.223,
 '2015.1': 14706.907,
 '2016.1': 15105.299,
 '2017.1': 15509.514,
 '2018.1': 15918.795,
 '2019.1': 16332.17,
 '2020.1': 16748.855,
 '2021.1': 17168.11,
 '2022.1': 17589.674,
 '2023.1': 18013.68,
 '2024.1': 18440.49,
 '2025.1': 18870.1,
 '2026.1': 19302.072,
 '2027.1': 19735.339,
 '2028.1': 20168.414,
 '2029.1': 20599.527,
 '2030.1': 21027.123,
 '2031.1': 21450.185,
 '2032.1': 21868.07,
 '2033.1': 22280.129,
 '2034.1': 22686.02,
 '2035.1': 23088.127,
 '2036.1': 23486.261,
 '2037.1': 23879.805,
 '2038.1': 24268.276,
 '2039.1': 24651.175,
 '2040.1': 25028.032,
 '2041.1': 25398.337,
 '2042.1': 25761.555,
 '2043.1': 26117.078,
 '2044.1': 26464.259,
 '2045.1': 26802.535,
 '2046.1': 27131.368,
 '2047.1': 27450.331,
 '2048.1': 27759.082,
 '2049.1': 28057.339,
 '2050.1': 28344.777},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '2010': 729.371,
 '2011': 732.554,
 '2012': 735.323,
 '2013': 737.839,
 '2014': 740.367,
 '2015': 743.079,
 '2016': 745.793,
 '2017': 748.44,
 '2018': 750.928,
 '2019': 753.079,
 '2020': 754.784,
 '2021': 755.995,
 '2022': 756.756,
 '2023': 757.089,
 '2024': 757.025,
 '2025': 756.584,
 '2026': 755.775,
 '2027': 754.561,
 '2028': 752.935,
 '2029': 750.869,
 '2030': 748.346,
 '2031': 745.359,
 '2032': 741.912,
 '2033': 737.991,
 '2034': 733.585,
 '2035': 728.698,
 '2036': 723.326,
 '2037': 717.475,
 '2038': 711.16,
 '2039': 704.392,
 '2040': 697.188,
 '2041': 689.559,
 '2042': 681.784,
 '2043': 673.881,
 '2044': 665.873,
 '2045': 657.78,
 '2046': 649.623,
 '2047': 641.406,
 '2048': 633.162,
 '2049': 624.913,
 '2050': 616.682,
 '1991': 600.712,
 '1992': 610.21,
 '1993': 620.372,
 '1994': 630.521,
 '1995': 640.136,
 '1996': 649.07,
 '1997': 657.416,
 '1998': 665.193,
 '1999': 672.51,
 '2000': 679.44,
 '2001': 685.803,
 '2002': 691.683,
 '2003': 697.168,
 '2004': 702.381,
 '2005': 707.398,
 '2006': 712.296,
 '2007': 717.043,
 '2008': 721.553,
 '2009': 725.69,
 '2010.1': 729.371,
 '2011.1': 732.554,
 '2012.1': 735.323,
 '2013.1': 737.839,
 '2014.1': 740.367,
 '2015.1': 743.079,
 '2016.1': 745.793,
 '2017.1': 748.44,
 '2018.1': 750.928,
 '2019.1': 753.079,
 '2020.1': 754.784,
 '2021.1': 755.995,
 '2022.1': 756.756,
 '2023.1': 757.089,
 '2024.1': 757.025,
 '2025.1': 756.584,
 '2026.1': 755.775,
 '2027.1': 754.561,
 '2028.1': 752.935,
 '2029.1': 750.869,
 '2030.1': 748.346,
 '2031.1': 745.359,
 '2032.1': 741.912,
 '2033.1': 737.991,
 '2034.1': 733.585,
 '2035.1': 728.698,
 '2036.1': 723.326,
 '2037.1': 717.475,
 '2038.1': 711.16,
 '2039.1': 704.392,
 '2040.1': 697.188,
 '2041.1': 689.559,
 '2042.1': 681.784,
 '2043.1': 673.881,
 '2044.1': 665.873,
 '2045.1': 657.78,
 '2046.1': 649.623,
 '2047.1': 641.406,
 '2048.1': 633.162,
 '2049.1': 624.913,
 '2050.1': 616.682},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '2010': 106.542,
 '2011': 110.597,
 '2012': 114.701,
 '2013': 118.87,
 '2014': 123.044,
 '2015': 127.237,
 '2016': 131.439,
 '2017': 135.644,
 '2018': 139.845,
 '2019': 144.023,
 '2020': 148.158,
 '2021': 152.244,
 '2022': 156.285,
 '2023': 160.272,
 '2024': 164.212,
 '2025': 168.107,
 '2026': 171.944,
 '2027': 175.713,
 '2028': 179.417,
 '2029': 183.034,
 '2030': 186.567,
 '2031': 189.993,
 '2032': 193.314,
 '2033': 196.512,
 '2034': 199.574,
 '2035': 202.487,
 '2036': 205.232,
 '2037': 207.807,
 '2038': 210.196,
 '2039': 212.391,
 '2040': 214.511,
 '2041': 216.551,
 '2042': 218.512,
 '2043': 220.392,
 '2044': 222.187,
 '2045': 223.885,
 '2046': 225.498,
 '2047': 227.013,
 '2048': 228.435,
 '2049': 229.771,
 '2050': 231.009,
 '1991': 63.422,
 '1992': 65.81,
 '1993': 68.087,
 '1994': 70.207,
 '1995': 72.113,
 '1996': 73.78,
 '1997': 75.235,
 '1998': 76.488,
 '1999': 77.597,
 '2000': 78.577,
 '2001': 79.437,
 '2002': 80.169,
 '2003': 82.816,
 '2004': 85.688,
 '2005': 88.636,
 '2006': 91.676,
 '2007': 94.788,
 '2008': 98.57,
 '2009': 102.532,
 '2010.1': 106.542,
 '2011.1': 110.597,
 '2012.1': 114.701,
 '2013.1': 118.87,
 '2014.1': 123.044,
 '2015.1': 127.237,
 '2016.1': 131.439,
 '2017.1': 135.644,
 '2018.1': 139.845,
 '2019.1': 144.023,
 '2020.1': 148.158,
 '2021.1': 152.244,
 '2022.1': 156.285,
 '2023.1': 160.272,
 '2024.1': 164.212,
 '2025.1': 168.107,
 '2026.1': 171.944,
 '2027.1': 175.713,
 '2028.1': 179.417,
 '2029.1': 183.034,
 '2030.1': 186.567,
 '2031.1': 189.993,
 '2032.1': 193.314,
 '2033.1': 196.512,
 '2034.1': 199.574,
 '2035.1': 202.487,
 '2036.1': 205.232,
 '2037.1': 207.807,
 '2038.1': 210.196,
 '2039.1': 212.391,
 '2040.1': 214.511,
 '2041.1': 216.551,
 '2042.1': 218.512,
 '2043.1': 220.392,
 '2044.1': 222.187,
 '2045.1': 223.885,
 '2046.1': 225.498,
 '2047.1': 227.013,
 '2048.1': 228.435,
 '2049.1': 229.771,
 '2050.1': 231.009},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '2010': 16511.748,
 '2011': 16874.793,
 '2012': 17242.761,
 '2013': 17615.928,
 '2014': 17993.425,
 '2015': 18375.089,
 '2016': 18760.441,
 '2017': 19149.788,
 '2018': 19542.053,
 '2019': 19935.885,
 '2020': 20330.756,
 '2021': 20726.122,
 '2022': 21121.577,
 '2023': 21516.806,
 '2024': 21911.568,
 '2025': 22305.519,
 '2026': 22698.128,
 '2027': 23088.773,
 '2028': 23476.915,
 '2029': 23861.99,
 '2030': 24243.408,
 '2031': 24620.633,
 '2032': 24993.048,
 '2033': 25359.858,
 '2034': 25720.206,
 '2035': 26073.38,
 '2036': 26418.874,
 '2037': 26756.321,
 '2038': 27085.364,
 '2039': 27405.733,
 '2040': 27717.244,
 '2041': 28019.84,
 '2042': 28313.618,
 '2043': 28598.93,
 '2044': 28876.899,
 '2045': 29142.678,
 '2046': 29397.324,
 '2047': 29640.637,
 '2048': 29872.568,
 '2049': 30093.162,
 '2050': 30302.381,
 '1991': 10127.821,
 '1992': 10415.478,
 '1993': 10761.306,
 '1994': 11110.894,
 '1995': 11426.146,
 '1996': 11696.621,
 '1997': 11935.569,
 '1998': 12211.321,
 '1999': 12499.372,
 '2000': 12810.292,
 '2001': 13146.513,
 '2002': 13501.744,
 '2003': 13873.191,
 '2004': 14255.83,
 '2005': 14646.262,
 '2006': 15044.085,
 '2007': 15451.006,
 '2008': 15802.686,
 '2009': 16154.357,
 '2010.1': 16511.748,
 '2011.1': 16874.793,
 '2012.1': 17242.761,
 '2013.1': 17615.928,
 '2014.1': 17993.425,
 '2015.1': 18375.089,
 '2016.1': 18760.441,
 '2017.1': 19149.788,
 '2018.1': 19542.053,
 '2019.1': 19935.885,
 '2020.1': 20330.756,
 '2021.1': 20726.122,
 '2022.1': 21121.577,
 '2023.1': 21516.806,
 '2024.1': 21911.568,
 '2025.1': 22305.519,
 '2026.1': 22698.128,
 '2027.1': 23088.773,
 '2028.1': 23476.915,
 '2029.1': 23861.99,
 '2030.1': 24243.408,
 '2031.1': 24620.633,
 '2032.1': 24993.048,
 '2033.1': 25359.858,
 '2034.1': 25720.206,
 '2035.1': 26073.38,
 '2036.1': 26418.874,
 '2037.1': 26756.321,
 '2038.1': 27085.364,
 '2039.1': 27405.733,
 '2040.1': 27717.244,
 '2041.1': 28019.84,
 '2042.1': 28313.618,
 '2043.1': 28598.93,
 '2044.1': 28876.899,
 '2045.1': 29142.678,
 '2046.1': 29397.324,
 '2047.1': 29640.637,
 '2048.1': 29872.568,
 '2049.1': 30093.162,
 '2050.1': 30302.381},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '2010': 12.452,
 '2011': 10.526,
 '2012': 8.95,
 '2013': 7.655,
 '2014': 6.587,
 '2015': 5.704,
 '2016': 4.971,
 '2017': 4.36,
 '2018': 3.848,
 '2019': 3.418,
 '2020': 3.055,
 '2021': 2.748,
 '2022': 2.488,
 '2023': 2.266,
 '2024': 2.078,
 '2025': 1.917,
 '2026': 1.779,
 '2027': 1.662,
 '2028': 1.562,
 '2029': 1.478,
 '2030': 1.407,
 '2031': 1.348,
 '2032': 1.299,
 '2033': 1.26,
 '2034': 1.23,
 '2035': 1.208,
 '2036': 1.194,
 '2037': 1.18,
 '2038': 1.165,
 '2039': 1.151,
 '2040': 1.136,
 '2041': 1.121,
 '2042': 1.106,
 '2043': 1.091,
 '2044': 1.075,
 '2045': 1.06,
 '2046': 1.045,
 '2047': 1.029,
 '2048': 1.014,
 '2049': 0.998,
 '2050': 0.983,
 '1991': 110.158,
 '1992': 105.83,
 '1993': 101.643,
 '1994': 97.535,
 '1995': 93.496,
 '1996': 89.521,
 '1997': 85.638,
 '1998': 81.827,
 '1999': 75.65,
 '2000': 65.061,
 '2001': 55.79,
 '2002': 47.682,
 '2003': 40.635,
 '2004': 34.527,
 '2005': 29.275,
 '2006': 24.758,
 '2007': 20.894,
 '2008': 17.599,
 '2009': 14.812,
 '2010.1': 12.452,
 '2011.1': 10.526,
 '2012.1': 8.95,
 '2013.1': 7.655,
 '2014.1': 6.587,
 '2015.1': 5.704,
 '2016.1': 4.971,
 '2017.1': 4.36,
 '2018.1': 3.848,
 '2019.1': 3.418,
 '2020.1': 3.055,
 '2021.1': 2.748,
 '2022.1': 2.488,
 '2023.1': 2.266,
 '2024.1': 2.078,
 '2025.1': 1.917,
 '2026.1': 1.779,
 '2027.1': 1.662,
 '2028.1': 1.562,
 '2029.1': 1.478,
 '2030.1': 1.407,
 '2031.1': 1.348,
 '2032.1': 1.299,
 '2033.1': 1.26,
 '2034.1': 1.23,
 '2035.1': 1.208,
 '2036.1': 1.194,
 '2037.1': 1.18,
 '2038.1': 1.165,
 '2039.1': 1.151,
 '2040.1': 1.136,
 '2041.1': 1.121,
 '2042.1': 1.106,
 '2043.1': 1.091,
 '2044.1': 1.075,
 '2045.1': 1.06,
 '2046.1': 1.045,
 '2047.1': 1.029,
 '2048.1': 1.014,
 '2049.1': 0.998,
 '2050.1': 0.983},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '2010': 8511.644,
 '2011': 8734.828,
 '2012': 8960.938,
 '2013': 9189.947,
 '2014': 9420.354,
 '2015': 9652.086,
 '2016': 9884.801,
 '2017': 10117.663,
 '2018': 10349.599,
 '2019': 10579.327,
 '2020': 10805.843,
 '2021': 11028.578,
 '2022': 11247.444,
 '2023': 11462.678,
 '2024': 11674.765,
 '2025': 11884.021,
 '2026': 12090.218,
 '2027': 12292.958,
 '2028': 12492.254,
 '2029': 12688.109,
 '2030': 12880.409,
 '2031': 13068.866,
 '2032': 13252.99,
 '2033': 13432.266,
 '2034': 13606.066,
 '2035': 13773.761,
 '2036': 13934.858,
 '2037': 14088.798,
 '2038': 14234.825,
 '2039': 14372.222,
 '2040': 14503.076,
 '2041': 14627.319,
 '2042': 14744.714,
 '2043': 14854.87,
 '2044': 14957.384,
 '2045': 15051.973,
 '2046': 15138.414,
 '2047': 15216.641,
 '2048': 15286.681,
 '2049': 15348.634,
 '2050': 15402.615,
 '1991': 6664.566,
 '1992': 6280.411,
 '1993': 5839.222,
 '1994': 5495.25,
 '1995': 5344.914,
 '1996': 5419.636,
 '1997': 5709.311,
 '1998': 6124.788,
 '1999': 6525.356,
 '2000': 6827.783,
 '2001': 7010.937,
 '2002': 7104.058,
 '2003': 7213.04,
 '2004': 7327.409,
 '2005': 7471.017,
 '2006': 7649.129,
 '2007': 7848.805,
 '2008': 8065.028,
 '2009': 8288.298,
 '2010.1': 8511.644,
 '2011.1': 8734.828,
 '2012.1': 8960.938,
 '2013.1': 9189.947,
 '2014.1': 9420.354,
 '2015.1': 9652.086,
 '2016.1': 9884.801,
 '2017.1': 10117.663,
 '2018.1': 10349.599,
 '2019.1': 10579.327,
 '2020.1': 10805.843,
 '2021.1': 11028.578,
 '2022.1': 11247.444,
 '2023.1': 11462.678,
 '2024.1': 11674.765,
 '2025.1': 11884.021,
 '2026.1': 12090.218,
 '2027.1': 12292.958,
 '2028.1': 12492.254,
 '2029.1': 12688.109,
 '2030.1': 12880.409,
 '2031.1': 13068.866,
 '2032.1': 13252.99,
 '2033.1': 13432.266,
 '2034.1': 13606.066,
 '2035.1': 13773.761,
 '2036.1': 13934.858,
 '2037.1': 14088.798,
 '2038.1': 14234.825,
 '2039.1': 14372.222,
 '2040.1': 14503.076,
 '2041.1': 14627.319,
 '2042.1': 14744.714,
 '2043.1': 14854.87,
 '2044.1': 14957.384,
 '2045.1': 15051.973,
 '2046.1': 15138.414,
 '2047.1': 15216.641,
 '2048.1': 15286.681,
 '2049.1': 15348.634,
 '2050.1': 15402.615},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '2010': 42.653,
 '2011': 42.501,
 '2012': 42.34,
 '2013': 42.174,
 '2014': 41.993,
 '2015': 41.809,
 '2016': 41.619,
 '2017': 41.437,
 '2018': 41.246,
 '2019': 41.038,
 '2020': 40.804,
 '2021': 40.542,
 '2022': 40.256,
 '2023': 39.949,
 '2024': 39.624,
 '2025': 39.294,
 '2026': 38.952,
 '2027': 38.598,
 '2028': 38.236,
 '2029': 37.868,
 '2030': 37.494,
 '2031': 37.118,
 '2032': 36.736,
 '2033': 36.354,
 '2034': 35.968,
 '2035': 35.579,
 '2036': 35.188,
 '2037': 34.796,
 '2038': 34.403,
 '2039': 34.004,
 '2040': 33.603,
 '2041': 33.2,
 '2042': 32.795,
 '2043': 32.385,
 '2044': 31.97,
 '2045': 31.552,
 '2046': 31.126,
 '2047': 30.696,
 '2048': 30.264,
 '2049': 29.829,
 '2050': 29.389,
 '1991': 36.245,
 '1992': 36.82,
 '1993': 37.476,
 '1994': 38.104,
 '1995': 38.633,
 '1996': 39.026,
 '1997': 39.308,
 '1998': 39.546,
 '1999': 39.835,
 '2000': 40.224,
 '2001': 40.75,
 '2002': 41.364,
 '2003': 41.99,
 '2004': 42.528,
 '2005': 42.89,
 '2006': 43.064,
 '2007': 43.077,
 '2008': 42.968,
 '2009': 42.814,
 '2010.1': 42.653,
 '2011.1': 42.501,
 '2012.1': 42.34,
 '2013.1': 42.174,
 '2014.1': 41.993,
 '2015.1': 41.809,
 '2016.1': 41.619,
 '2017.1': 41.437,
 '2018.1': 41.246,
 '2019.1': 41.038,
 '2020.1': 40.804,
 '2021.1': 40.542,
 '2022.1': 40.256,
 '2023.1': 39.949,
 '2024.1': 39.624,
 '2025.1': 39.294,
 '2026.1': 38.952,
 '2027.1': 38.598,
 '2028.1': 38.236,
 '2029.1': 37.868,
 '2030.1': 37.494,
 '2031.1': 37.118,
 '2032.1': 36.736,
 '2033.1': 36.354,
 '2034.1': 35.968,
 '2035.1': 35.579,
 '2036.1': 35.188,
 '2037.1': 34.796,
 '2038.1': 34.403,
 '2039.1': 34.004,
 '2040.1': 33.603,
 '2041.1': 33.2,
 '2042.1': 32.795,
 '2043.1': 32.385,
 '2044.1': 31.97,
 '2045.1': 31.552,
 '2046.1': 31.126,
 '2047.1': 30.696,
 '2048.1': 30.264,
 '2049.1': 29.829,
 '2050.1': 29.389},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '2010': 7315.117,
 '2011': 7318.788,
 '2012': 7459.376,
 '2013': 7601.384,
 '2014': 7745.889,
 '2015': 7893.535,
 '2016': 8044.409,
 '2017': 8198.119,
 '2018': 8354.51,
 '2019': 8513.289,
 '2020': 8674.136,
 '2021': 8836.924,
 '2022': 9001.371,
 '2023': 9166.777,
 '2024': 9332.305,
 '2025': 9497.29,
 '2026': 9661.372,
 '2027': 9824.388,
 '2028': 9986.19,
 '2029': 10146.685,
 '2030': 10305.77,
 '2031': 10463.253,
 '2032': 10618.918,
 '2033': 10772.597,
 '2034': 10924.151,
 '2035': 11073.463,
 '2036': 11220.472,
 '2037': 11365.201,
 '2038': 11507.77,
 '2039': 11648.46,
 '2040': 11787.851,
 '2041': 11923.631,
 '2042': 12056.227,
 '2043': 12185.526,
 '2044': 12311.407,
 '2045': 12433.748,
 '2046': 12552.4,
 '2047': 12667.185,
 '2048': 12777.909,
 '2049': 12884.367,
 '2050': 12986.365,
 '1991': 5218.628,
 '1992': 5215.131,
 '1993': 5210.375,
 '1994': 5227.852,
 '1995': 5283.649,
 '1996': 5383.769,
 '1997': 5521.517,
 '1998': 5684.137,
 '1999': 5853.196,
 '2000': 6015.423,
 '2001': 6167.501,
 '2002': 6313.307,
 '2003': 6417.677,
 '2004': 6521.864,
 '2005': 6629.975,
 '2006': 6741.849,
 '2007': 7240.839,
 '2008': 7275.093,
 '2009': 7300.523,
 '2010.1': 7315.117,
 '2011.1': 7318.788,
 '2012.1': 7459.376,
 '2013.1': 7601.384,
 '2014.1': 7745.889,
 '2015.1': 7893.535,
 '2016.1': 8044.409,
 '2017.1': 8198.119,
 '2018.1': 8354.51,
 '2019.1': 8513.289,
 '2020.1': 8674.136,
 '2021.1': 8836.924,
 '2022.1': 9001.371,
 '2023.1': 9166.777,
 '2024.1': 9332.305,
 '2025.1': 9497.29,
 '2026.1': 9661.372,
 '2027.1': 9824.388,
 '2028.1': 9986.19,
 '2029.1': 10146.685,
 '2030.1': 10305.77,
 '2031.1': 10463.253,
 '2032.1': 10618.918,
 '2033.1': 10772.597,
 '2034.1': 10924.151,
 '2035.1': 11073.463,
 '2036.1': 11220.472,
 '2037.1': 11365.201,
 '2038.1': 11507.77,
 '2039.1': 11648.46,
 '2040.1': 11787.851,
 '2041.1': 11923.631,
 '2042.1': 12056.227,
 '2043.1': 12185.526,
 '2044.1': 12311.407,
 '2045.1': 12433.748,
 '2046.1': 12552.4,
 '2047.1': 12667.185,
 '2048.1': 12777.909,
 '2049.1': 12884.367,
 '2050.1': 12986.365},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '2010': 8269.201,
 '2011': 8564.747,
 '2012': 8847.54,
 '2013': 9119.185,
 '2014': 9383.162,
 '2015': 9642.116,
 '2016': 9895.674,
 '2017': 10142.827,
 '2018': 10384.989,
 '2019': 10623.927,
 '2020': 10860.946,
 '2021': 11096.528,
 '2022': 11330.428,
 '2023': 11562.285,
 '2024': 11791.407,
 '2025': 12017.223,
 '2026': 12239.627,
 '2027': 12458.599,
 '2028': 12673.744,
 '2029': 12884.591,
 '2030': 13090.758,
 '2031': 13291.885,
 '2032': 13487.8,
 '2033': 13678.448,
 '2034': 13863.987,
 '2035': 14045.927,
 '2036': 14224.447,
 '2037': 14399.32,
 '2038': 14570.291,
 '2039': 14737.062,
 '2040': 14899.365,
 '2041': 15056.99,
 '2042': 15209.767,
 '2043': 15357.519,
 '2044': 15500.049,
 '2045': 15637.175,
 '2046': 15768.701,
 '2047': 15894.409,
 '2048': 16014.102,
 '2049': 16127.583,
 '2050': 16234.641,
 '1991': 4902.426,
 '1992': 4764.772,
 '1993': 4632.913,
 '1994': 4576.302,
 '1995': 4592.949,
 '1996': 4696.682,
 '1997': 4876.638,
 '1998': 5108.763,
 '1999': 5356.86,
 '2000': 5594.806,
 '2001': 5814.454,
 '2002': 6024.212,
 '2003': 6234.504,
 '2004': 6461.992,
 '2005': 6717.865,
 '2006': 7004.283,
 '2007': 7313.933,
 '2008': 7637.038,
 '2009': 7958.878,
 '2010.1': 8269.201,
 '2011.1': 8564.747,
 '2012.1': 8847.54,
 '2013.1': 9119.185,
 '2014.1': 9383.162,
 '2015.1': 9642.116,
 '2016.1': 9895.674,
 '2017.1': 10142.827,
 '2018.1': 10384.989,
 '2019.1': 10623.927,
 '2020.1': 10860.946,
 '2021.1': 11096.528,
 '2022.1': 11330.428,
 '2023.1': 11562.285,
 '2024.1': 11791.407,
 '2025.1': 12017.223,
 '2026.1': 12239.627,
 '2027.1': 12458.599,
 '2028.1': 12673.744,
 '2029.1': 12884.591,
 '2030.1': 13090.758,
 '2031.1': 13291.885,
 '2032.1': 13487.8,
 '2033.1': 13678.448,
 '2034.1': 13863.987,
 '2035.1': 14045.927,
 '2036.1': 14224.447,
 '2037.1': 14399.32,
 '2038.1': 14570.291,
 '2039.1': 14737.062,
 '2040.1': 14899.365,
 '2041.1': 15056.99,
 '2042.1': 15209.767,
 '2043.1': 15357.519,
 '2044.1': 15500.049,
 '2045.1': 15637.175,
 '2046.1': 15768.701,
 '2047.1': 15894.409,
 '2048.1': 16014.102,
 '2049.1': 16127.583,
 '2050.1': 16234.641},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '2010': 27341.361,
 '2011': 28110.753,
 '2012': 28891.6,
 '2013': 29683.1,
 '2014': 30482.665,
 '2015': 31289.039,
 '2016': 32101.656,
 '2017': 32920.646,
 '2018': 33745.48,
 '2019': 34576.219,
 '2020': 35412.691,
 '2021': 36254.141,
 '2022': 37099.636,
 '2023': 37948.628,
 '2024': 38800.566,
 '2025': 39654.788,
 '2026': 40510.502,
 '2027': 41366.739,
 '2028': 42222.468,
 '2029': 43076.546,
 '2030': 43927.928,
 '2031': 44775.793,
 '2032': 45619.326,
 '2033': 46457.45,
 '2034': 47289.113,
 '2035': 48113.433,
 '2036': 48929.859,
 '2037': 49738.119,
 '2038': 50538.12,
 '2039': 51330.071,
 '2040': 52114.598,
 '2041': 52893.353,
 '2042': 53653.655,
 '2043': 54396.516,
 '2044': 55121.076,
 '2045': 55826.472,
 '2046': 56511.753,
 '2047': 57175.99,
 '2048': 57818.384,
 '2049': 58438.177,
 '2050': 59034.585,
 '1991': 15974.068,
 '1992': 16453.782,
 '1993': 16936.795,
 '1994': 17422.205,
 '1995': 17910.474,
 '1996': 18400.077,
 '1997': 18893.474,
 '1998': 19398.646,
 '1999': 19926.621,
 '2000': 20484.903,
 '2001': 21076.726,
 '2002': 21699.29,
 '2003': 22348.557,
 '2004': 23017.847,
 '2005': 23702.764,
 '2006': 24401.496,
 '2007': 25115.006,
 '2008': 25842.671,
 '2009': 26585.117,
 '2010.1': 27341.361,
 '2011.1': 28110.753,
 '2012.1': 28891.6,
 '2013.1': 29683.1,
 '2014.1': 30482.665,
 '2015.1': 31289.039,
 '2016.1': 32101.656,
 '2017.1': 32920.646,
 '2018.1': 33745.48,
 '2019.1': 34576.219,
 '2020.1': 35412.691,
 '2021.1': 36254.141,
 '2022.1': 37099.636,
 '2023.1': 37948.628,
 '2024.1': 38800.566,
 '2025.1': 39654.788,
 '2026.1': 40510.502,
 '2027.1': 41366.739,
 '2028.1': 42222.468,
 '2029.1': 43076.546,
 '2030.1': 43927.928,
 '2031.1': 44775.793,
 '2032.1': 45619.326,
 '2033.1': 46457.45,
 '2034.1': 47289.113,
 '2035.1': 48113.433,
 '2036.1': 48929.859,
 '2037.1': 49738.119,
 '2038.1': 50538.12,
 '2039.1': 51330.071,
 '2040.1': 52114.598,
 '2041.1': 52893.353,
 '2042.1': 53653.655,
 '2043.1': 54396.516,
 '2044.1': 55121.076,
 '2045.1': 55826.472,
 '2046.1': 56511.753,
 '2047.1': 57175.99,
 '2048.1': 57818.384,
 '2049.1': 58438.177,
 '2050.1': 59034.585},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '2010': 33138.622,
 '2011': 33871.494,
 '2012': 34606.978,
 '2013': 35346.511,
 '2014': 36092.092,
 '2015': 36844.744,
 '2016': 37603.765,
 '2017': 38367.191,
 '2018': 39132.847,
 '2019': 39898.166,
 '2020': 40661.266,
 '2021': 41421.114,
 '2022': 42177.764,
 '2023': 42931.803,
 '2024': 43684.338,
 '2025': 44436.083,
 '2026': 45186.76,
 '2027': 45935.789,
 '2028': 46683.166,
 '2029': 47428.922,
 '2030': 48172.997,
 '2031': 48915.331,
 '2032': 49655.688,
 '2033': 50393.614,
 '2034': 51128.647,
 '2035': 51860.581,
 '2036': 52589.732,
 '2037': 53316.821,
 '2038': 54042.932,
 '2039': 54770.512,
 '2040': 55480.323,
 '2041': 56173.953,
 '2042': 56850.473,
 '2043': 57508.808,
 '2044': 58147.865,
 '2045': 58766.734,
 '2046': 59364.638,
 '2047': 59941.084,
 '2048': 60495.796,
 '2049': 61028.639,
 '2050': 61539.425,
 '1991': 21260.528,
 '1992': 21902.079,
 '1993': 22556.881,
 '1994': 23197.44,
 '1995': 23805.808,
 '1996': 24375.746,
 '1997': 24916.971,
 '1998': 25445.493,
 '1999': 25985.081,
 '2000': 26553.317,
 '2001': 27154.582,
 '2002': 27785.622,
 '2003': 28377.799,
 '2004': 28984.506,
 '2005': 29619.018,
 '2006': 30282.031,
 '2007': 30972.693,
 '2008': 31684.102,
 '2009': 32408.679,
 '2010.1': 33138.622,
 '2011.1': 33871.494,
 '2012.1': 34606.978,
 '2013.1': 35346.511,
 '2014.1': 36092.092,
 '2015.1': 36844.744,
 '2016.1': 37603.765,
 '2017.1': 38367.191,
 '2018.1': 39132.847,
 '2019.1': 39898.166,
 '2020.1': 40661.266,
 '2021.1': 41421.114,
 '2022.1': 42177.764,
 '2023.1': 42931.803,
 '2024.1': 43684.338,
 '2025.1': 44436.083,
 '2026.1': 45186.76,
 '2027.1': 45935.789,
 '2028.1': 46683.166,
 '2029.1': 47428.922,
 '2030.1': 48172.997,
 '2031.1': 48915.331,
 '2032.1': 49655.688,
 '2033.1': 50393.614,
 '2034.1': 51128.647,
 '2035.1': 51860.581,
 '2036.1': 52589.732,
 '2037.1': 53316.821,
 '2038.1': 54042.932,
 '2039.1': 54770.512,
 '2040.1': 55480.323,
 '2041.1': 56173.953,
 '2042.1': 56850.473,
 '2043.1': 57508.808,
 '2044.1': 58147.865,
 '2045.1': 58766.734,
 '2046.1': 59364.638,
 '2047.1': 59941.084,
 '2048.1': 60495.796,
 '2049.1': 61028.639,
 '2050.1': 61539.425},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '2010': 8399.366,
 '2011': 8580.164,
 '2012': 8767.868,
 '2013': 8960.891,
 '2014': 9156.664,
 '2015': 9353.351,
 '2016': 9550.308,
 '2017': 9747.709,
 '2018': 9945.501,
 '2019': 10143.883,
 '2020': 10342.892,
 '2021': 10542.189,
 '2022': 10741.328,
 '2023': 10940.237,
 '2024': 11138.886,
 '2025': 11337.157,
 '2026': 11534.85,
 '2027': 11731.579,
 '2028': 11926.855,
 '2029': 12120.102,
 '2030': 12310.858,
 '2031': 12498.884,
 '2032': 12684.06,
 '2033': 12866.238,
 '2034': 13045.359,
 '2035': 13221.428,
 '2036': 13394.575,
 '2037': 13565.328,
 '2038': 13731.99,
 '2039': 13895.18,
 '2040': 14054.815,
 '2041': 14210.764,
 '2042': 14362.859,
 '2043': 14510.952,
 '2044': 14654.885,
 '2045': 14794.514,
 '2046': 14929.679,
 '2047': 15060.265,
 '2048': 15186.216,
 '2049': 15307.498,
 '2050': 15424.042,
 '1991': 5027.157,
 '1992': 5196.992,
 '1993': 5371.241,
 '1994': 5553.666,
 '1995': 5746.834,
 '1996': 5952.393,
 '1997': 6169.59,
 '1998': 6396.424,
 '1999': 6629.385,
 '2000': 6866.093,
 '2001': 7035.435,
 '2002': 7175.419,
 '2003': 7315.663,
 '2004': 7457.838,
 '2005': 7603.597,
 '2006': 7752.68,
 '2007': 7905.217,
 '2008': 8062.65,
 '2009': 8227.067,
 '2010.1': 8399.366,
 '2011.1': 8580.164,
 '2012.1': 8767.868,
 '2013.1': 8960.891,
 '2014.1': 9156.664,
 '2015.1': 9353.351,
 '2016.1': 9550.308,
 '2017.1': 9747.709,
 '2018.1': 9945.501,
 '2019.1': 10143.883,
 '2020.1': 10342.892,
 '2021.1': 10542.189,
 '2022.1': 10741.328,
 '2023.1': 10940.237,
 '2024.1': 11138.886,
 '2025.1': 11337.157,
 '2026.1': 11534.85,
 '2027.1': 11731.579,
 '2028.1': 11926.855,
 '2029.1': 12120.102,
 '2030.1': 12310.858,
 '2031.1': 12498.884,
 '2032.1': 12684.06,
 '2033.1': 12866.238,
 '2034.1': 13045.359,
 '2035.1': 13221.428,
 '2036.1': 13394.575,
 '2037.1': 13565.328,
 '2038.1': 13731.99,
 '2039.1': 13895.18,
 '2040.1': 14054.815,
 '2041.1': 14210.764,
 '2042.1': 14362.859,
 '2043.1': 14510.952,
 '2044.1': 14654.885,
 '2045.1': 14794.514,
 '2046.1': 14929.679,
 '2047.1': 15060.265,
 '2048.1': 15186.216,
 '2049.1': 15307.498,
 '2050.1': 15424.042},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '2010': 9410.211,
 '2011': 9636.932,
 '2012': 9880.721,
 '2013': 10138.667,
 '2014': 10402.274,
 '2015': 10667.966,
 '2016': 10934.468,
 '2017': 11201.138,
 '2018': 11465.748,
 '2019': 11725.97,
 '2020': 11980.005,
 '2021': 12226.34,
 '2022': 12464.597,
 '2023': 12695.58,
 '2024': 12920.837,
 '2025': 13141.393,
 '2026': 13357.009,
 '2027': 13566.783,
 '2028': 13770.318,
 '2029': 13967.1,
 '2030': 14156.582,
 '2031': 14338.289,
 '2032': 14511.711,
 '2033': 14676.195,
 '2034': 14831.025,
 '2035': 14975.516,
 '2036': 15109.059,
 '2037': 15231.065,
 '2038': 15340.914,
 '2039': 15438.282,
 '2040': 15528.622,
 '2041': 15612.249,
 '2042': 15688.968,
 '2043': 15758.558,
 '2044': 15820.82,
 '2045': 15875.569,
 '2046': 15922.664,
 '2047': 15961.976,
 '2048': 15993.328,
 '2049': 16016.541,
 '2050': 16031.504,
 '1991': 7337.506,
 '1992': 7424.652,
 '1993': 7531.513,
 '1994': 7633.502,
 '1995': 7728.195,
 '1996': 7817.179,
 '1997': 7900.229,
 '1998': 7975.688,
 '1999': 8041.349,
 '2000': 8096.262,
 '2001': 8140.63,
 '2002': 8177.189,
 '2003': 8277.834,
 '2004': 8395.569,
 '2005': 8526.166,
 '2006': 8671.68,
 '2007': 8831.989,
 '2008': 9008.248,
 '2009': 9200.909,
 '2010.1': 9410.211,
 '2011.1': 9636.932,
 '2012.1': 9880.721,
 '2013.1': 10138.667,
 '2014.1': 10402.274,
 '2015.1': 10667.966,
 '2016.1': 10934.468,
 '2017.1': 11201.138,
 '2018.1': 11465.748,
 '2019.1': 11725.97,
 '2020.1': 11980.005,
 '2021.1': 12226.34,
 '2022.1': 12464.597,
 '2023.1': 12695.58,
 '2024.1': 12920.837,
 '2025.1': 13141.393,
 '2026.1': 13357.009,
 '2027.1': 13566.783,
 '2028.1': 13770.318,
 '2029.1': 13967.1,
 '2030.1': 14156.582,
 '2031.1': 14338.289,
 '2032.1': 14511.711,
 '2033.1': 14676.195,
 '2034.1': 14831.025,
 '2035.1': 14975.516,
 '2036.1': 15109.059,
 '2037.1': 15231.065,
 '2038.1': 15340.914,
 '2039.1': 15438.282,
 '2040.1': 15528.622,
 '2041.1': 15612.249,
 '2042.1': 15688.968,
 '2043.1': 15758.558,
 '2044.1': 15820.82,
 '2045.1': 15875.569,
 '2046.1': 15922.664,
 '2047.1': 15961.976,
 '2048.1': 15993.328,
 '2049.1': 16016.541,
 '2050.1': 16031.504},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '2010': 72003.561,
 '2011': 73601.664,
 '2012': 75209.473,
 '2013': 76835.866,
 '2014': 78469.249,
 '2015': 80110.225,
 '2016': 81756.662,
 '2017': 83405.744,
 '2018': 85054.645,
 '2019': 86700.296,
 '2020': 88339.965,
 '2021': 89971.306,
 '2022': 91592.507,
 '2023': 93202.145,
 '2024': 94799.061,
 '2025': 96381.983,
 '2026': 97949.049,
 '2027': 99498.709,
 '2028': 101030.461,
 '2029': 102544.666,
 '2030': 104042.995,
 '2031': 105518.725,
 '2032': 106973.012,
 '2033': 108400.416,
 '2034': 109798.587,
 '2035': 111165.288,
 '2036': 112502.037,
 '2037': 113807.523,
 '2038': 115079.3820000001,
 '2039': 116315.248,
 '2040': 117513.271,
 '2041': 118665.074,
 '2042': 119769.628,
 '2043': 120825.349,
 '2044': 121830.782,
 '2045': 122784.684,
 '2046': 123685.862,
 '2047': 124533.438,
 '2048': 125326.956,
 '2049': 126066.225,
 '2050': 126750.984,
 '1991': 48205.891,
 '1992': 49443.212,
 '1993': 50711.044,
 '1994': 51934.899,
 '1995': 53094.593,
 '1996': 54127.219,
 '1997': 55062.353,
 '1998': 55956.181,
 '1999': 56888.774,
 '2000': 57915.247,
 '2001': 59051.627,
 '2002': 60277.459,
 '2003': 61578.587,
 '2004': 62928.569,
 '2005': 64306.818,
 '2006': 65790.128,
 '2007': 67306.458,
 '2008': 68850.555,
 '2009': 70418.601,
 '2010.1': 72003.561,
 '2011.1': 73601.664,
 '2012.1': 75209.473,
 '2013.1': 76835.866,
 '2014.1': 78469.249,
 '2015.1': 80110.225,
 '2016.1': 81756.662,
 '2017.1': 83405.744,
 '2018.1': 85054.645,
 '2019.1': 86700.296,
 '2020.1': 88339.965,
 '2021.1': 89971.306,
 '2022.1': 91592.507,
 '2023.1': 93202.145,
 '2024.1': 94799.061,
 '2025.1': 96381.983,
 '2026.1': 97949.049,
 '2027.1': 99498.709,
 '2028.1': 101030.461,
 '2029.1': 102544.666,
 '2030.1': 104042.995,
 '2031.1': 105518.725,
 '2032.1': 106973.012,
 '2033.1': 108400.416,
 '2034.1': 109798.587,
 '2035.1': 111165.288,
 '2036.1': 112502.037,
 '2037.1': 113807.523,
 '2038.1': 115079.3820000001,
 '2039.1': 116315.248,
 '2040.1': 117513.271,
 '2041.1': 118665.074,
 '2042.1': 119769.628,
 '2043.1': 120825.349,
 '2044.1': 121830.782,
 '2045.1': 122784.684,
 '2046.1': 123685.862,
 '2047.1': 124533.438,
 '2048.1': 125326.956,
 '2049.1': 126066.225,
 '2050.1': 126750.984},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '2010': 9398.277,
 '2011': 9559.614,
 '2012': 9720.169,
 '2013': 9878.943,
 '2014': 10033.109,
 '2015': 10183.56,
 '2016': 10329.86,
 '2017': 10472.554,
 '2018': 10612.667,
 '2019': 10751.626,
 '2020': 10890.448,
 '2021': 11029.326,
 '2022': 11168.041,
 '2023': 11306.633,
 '2024': 11445.063,
 '2025': 11583.321,
 '2026': 11721.508,
 '2027': 11859.747,
 '2028': 11998.077,
 '2029': 12136.53,
 '2030': 12275.15,
 '2031': 12414.006,
 '2032': 12553.183,
 '2033': 12692.75,
 '2034': 12832.792,
 '2035': 12973.415,
 '2036': 13114.781,
 '2037': 13257.086,
 '2038': 13400.549,
 '2039': 13545.503,
 '2040': 13692.603,
 '2041': 13835.116,
 '2042': 13973.491,
 '2043': 14107.557,
 '2044': 14237.148,
 '2045': 14362.123,
 '2046': 14482.365,
 '2047': 14597.782,
 '2048': 14708.306,
 '2049': 14813.887,
 '2050': 14914.474,
 '1991': 7710.281,
 '1992': 7776.001,
 '1993': 7839.762,
 '1994': 7889.542,
 '1995': 7966.516,
 '1996': 8024.426,
 '1997': 8068.783,
 '1998': 8107.209,
 '1999': 8150.772,
 '2000': 8206.1,
 '2001': 8275.248,
 '2002': 8353.851,
 '2003': 8438.128,
 '2004': 8522.221,
 '2005': 8603.118,
 '2006': 8760.7,
 '2007': 8918.911,
 '2008': 9077.515,
 '2009': 9237.545,
 '2010.1': 9398.277,
 '2011.1': 9559.614,
 '2012.1': 9720.169,
 '2013.1': 9878.943,
 '2014.1': 10033.109,
 '2015.1': 10183.56,
 '2016.1': 10329.86,
 '2017.1': 10472.554,
 '2018.1': 10612.667,
 '2019.1': 10751.626,
 '2020.1': 10890.448,
 '2021.1': 11029.326,
 '2022.1': 11168.041,
 '2023.1': 11306.633,
 '2024.1': 11445.063,
 '2025.1': 11583.321,
 '2026.1': 11721.508,
 '2027.1': 11859.747,
 '2028.1': 11998.077,
 '2029.1': 12136.53,
 '2030.1': 12275.15,
 '2031.1': 12414.006,
 '2032.1': 12553.183,
 '2033.1': 12692.75,
 '2034.1': 12832.792,
 '2035.1': 12973.415,
 '2036.1': 13114.781,
 '2037.1': 13257.086,
 '2038.1': 13400.549,
 '2039.1': 13545.503,
 '2040.1': 13692.603,
 '2041.1': 13835.116,
 '2042.1': 13973.491,
 '2043.1': 14107.557,
 '2044.1': 14237.148,
 '2045.1': 14362.123,
 '2046.1': 14482.365,
 '2047.1': 14597.782,
 '2048.1': 14708.306,
 '2049.1': 14813.887,
 '2050.1': 14914.474},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '2010': 9673.887,
 '2011': 9816.164,
 '2012': 9957.503,
 '2013': 10097.48,
 '2014': 10235.717,
 '2015': 10371.907,
 '2016': 10505.784,
 '2017': 10637.19,
 '2018': 10766.102,
 '2019': 10892.584,
 '2020': 11016.661,
 '2021': 11138.276,
 '2022': 11257.346,
 '2023': 11373.878,
 '2024': 11487.886,
 '2025': 11599.407,
 '2026': 11708.453,
 '2027': 11815.094,
 '2028': 11919.5,
 '2029': 12021.896,
 '2030': 12122.535,
 '2031': 12221.739,
 '2032': 12320.089,
 '2033': 12414.523,
 '2034': 12505.505,
 '2035': 12592.874,
 '2036': 12676.512,
 '2037': 12756.326,
 '2038': 12832.216,
 '2039': 12904.092,
 '2040': 12971.856,
 '2041': 13035.428,
 '2042': 13094.708,
 '2043': 13149.56,
 '2044': 13199.845,
 '2045': 13245.453,
 '2046': 13286.315,
 '2047': 13322.407,
 '2048': 13353.721,
 '2049': 13380.27,
 '2050': 13402.062,
 '1991': 7208.065,
 '1992': 7344.014,
 '1993': 7476.814,
 '1994': 7605.596,
 '1995': 7730.283,
 '1996': 7850.517,
 '1997': 7967.381,
 '1998': 8082.587,
 '1999': 8198.9,
 '2000': 8318.116,
 '2001': 8441.086,
 '2002': 8567.125,
 '2003': 8696.474,
 '2004': 8828.9,
 '2005': 8964.62,
 '2006': 9103.242,
 '2007': 9244.465,
 '2008': 9387.386,
 '2009': 9530.836,
 '2010.1': 9673.887,
 '2011.1': 9816.164,
 '2012.1': 9957.503,
 '2013.1': 10097.48,
 '2014.1': 10235.717,
 '2015.1': 10371.907,
 '2016.1': 10505.784,
 '2017.1': 10637.19,
 '2018.1': 10766.102,
 '2019.1': 10892.584,
 '2020.1': 11016.661,
 '2021.1': 11138.276,
 '2022.1': 11257.346,
 '2023.1': 11373.878,
 '2024.1': 11487.886,
 '2025.1': 11599.407,
 '2026.1': 11708.453,
 '2027.1': 11815.094,
 '2028.1': 11919.5,
 '2029.1': 12021.896,
 '2030.1': 12122.535,
 '2031.1': 12221.739,
 '2032.1': 12320.089,
 '2033.1': 12414.523,
 '2034.1': 12505.505,
 '2035.1': 12592.874,
 '2036.1': 12676.512,
 '2037.1': 12756.326,
 '2038.1': 12832.216,
 '2039.1': 12904.092,
 '2040.1': 12971.856,
 '2041.1': 13035.428,
 '2042.1': 13094.708,
 '2043.1': 13149.56,
 '2044.1': 13199.845,
 '2045.1': 13245.453,
 '2046.1': 13286.315,
 '2047.1': 13322.407,
 '2048.1': 13353.721,
 '2049.1': 13380.27,
 '2050.1': 13402.062},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '2010': 2717.873,
 '2011': 2724.4,
 '2012': 2721.724,
 '2013': 2714.965,
 '2014': 2711.077,
 '2015': 2715.046,
 '2016': 2728.393,
 '2017': 2749.797,
 '2018': 2777.836,
 '2019': 2810.003,
 '2020': 2844.355,
 '2021': 2880.682,
 '2022': 2919.21,
 '2023': 2958.891,
 '2024': 2998.54,
 '2025': 3037.223,
 '2026': 3074.351,
 '2027': 3109.741,
 '2028': 3143.363,
 '2029': 3175.395,
 '2030': 3205.976,
 '2031': 3235.699,
 '2032': 3264.422,
 '2033': 3291.974,
 '2034': 3318.16,
 '2035': 3342.843,
 '2036': 3365.93,
 '2037': 3387.402,
 '2038': 3407.23,
 '2039': 3425.425,
 '2040': 3441.997,
 '2041': 3456.931,
 '2042': 3470.216,
 '2043': 3481.89,
 '2044': 3491.997,
 '2045': 3500.576,
 '2046': 3507.643,
 '2047': 3513.209,
 '2048': 3517.326,
 '2049': 3520.056,
 '2050': 3521.444,
 '1991': 1902.05,
 '1992': 1950.757,
 '1993': 2002.0,
 '1994': 2053.748,
 '1995': 2104.505,
 '1996': 2153.836,
 '1997': 2202.057,
 '1998': 2249.256,
 '1999': 2295.727,
 '2000': 2341.659,
 '2001': 2386.683,
 '2002': 2430.45,
 '2003': 2473.248,
 '2004': 2515.494,
 '2005': 2556.449,
 '2006': 2596.96,
 '2007': 2636.499,
 '2008': 2672.155,
 '2009': 2700.048,
 '2010.1': 2717.873,
 '2011.1': 2724.4,
 '2012.1': 2721.724,
 '2013.1': 2714.965,
 '2014.1': 2711.077,
 '2015.1': 2715.046,
 '2016.1': 2728.393,
 '2017.1': 2749.797,
 '2018.1': 2777.836,
 '2019.1': 2810.003,
 '2020.1': 2844.355,
 '2021.1': 2880.682,
 '2022.1': 2919.21,
 '2023.1': 2958.891,
 '2024.1': 2998.54,
 '2025.1': 3037.223,
 '2026.1': 3074.351,
 '2027.1': 3109.741,
 '2028.1': 3143.363,
 '2029.1': 3175.395,
 '2030.1': 3205.976,
 '2031.1': 3235.699,
 '2032.1': 3264.422,
 '2033.1': 3291.974,
 '2034.1': 3318.16,
 '2035.1': 3342.843,
 '2036.1': 3365.93,
 '2037.1': 3387.402,
 '2038.1': 3407.23,
 '2039.1': 3425.425,
 '2040.1': 3441.997,
 '2041.1': 3456.931,
 '2042.1': 3470.216,
 '2043.1': 3481.89,
 '2044.1': 3491.997,
 '2045.1': 3500.576,
 '2046.1': 3507.643,
 '2047.1': 3513.209,
 '2048.1': 3517.326,
 '2049.1': 3520.056,
 '2050.1': 3521.444},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '2010': 9273.802,
 '2011': 9578.48,
 '2012': 9891.998,
 '2013': 10211.686,
 '2014': 10533.696,
 '2015': 10855.197,
 '2016': 11175.141,
 '2017': 11494.121,
 '2018': 11812.905,
 '2019': 12132.857,
 '2020': 12454.833,
 '2021': 12778.64,
 '2022': 13103.337,
 '2023': 13428.194,
 '2024': 13752.234,
 '2025': 14074.581,
 '2026': 14394.637,
 '2027': 14711.929,
 '2028': 15025.799,
 '2029': 15335.611,
 '2030': 15640.692,
 '2031': 15940.337,
 '2032': 16233.85,
 '2033': 16520.548,
 '2034': 16799.828,
 '2035': 17071.341,
 '2036': 17337.996,
 '2037': 17599.891,
 '2038': 17856.648,
 '2039': 18107.922,
 '2040': 18353.34,
 '2041': 18592.596,
 '2042': 18825.352,
 '2043': 19051.272,
 '2044': 19270.012,
 '2045': 19481.257,
 '2046': 19684.718,
 '2047': 19880.144,
 '2048': 20067.295,
 '2049': 20245.964,
 '2050': 20415.949,
 '1991': 4857.179,
 '1992': 5000.829,
 '1993': 5152.212,
 '1994': 5320.179,
 '1995': 5497.472,
 '1996': 5683.89,
 '1997': 5879.339,
 '1998': 6085.51,
 '1999': 6304.503,
 '2000': 6537.507,
 '2001': 6785.78,
 '2002': 7048.105,
 '2003': 7320.248,
 '2004': 7596.322,
 '2005': 7872.263,
 '2006': 8146.101,
 '2007': 8419.328,
 '2008': 8695.468,
 '2009': 8979.786,
 '2010.1': 9273.802,
 '2011.1': 9578.48,
 '2012.1': 9891.998,
 '2013.1': 10211.686,
 '2014.1': 10533.696,
 '2015.1': 10855.197,
 '2016.1': 11175.141,
 '2017.1': 11494.121,
 '2018.1': 11812.905,
 '2019.1': 12132.857,
 '2020.1': 12454.833,
 '2021.1': 12778.64,
 '2022.1': 13103.337,
 '2023.1': 13428.194,
 '2024.1': 13752.234,
 '2025.1': 14074.581,
 '2026.1': 14394.637,
 '2027.1': 14711.929,
 '2028.1': 15025.799,
 '2029.1': 15335.611,
 '2030.1': 15640.692,
 '2031.1': 15940.337,
 '2032.1': 16233.85,
 '2033.1': 16520.548,
 '2034.1': 16799.828,
 '2035.1': 17071.341,
 '2036.1': 17337.996,
 '2037.1': 17599.891,
 '2038.1': 17856.648,
 '2039.1': 18107.922,
 '2040.1': 18353.34,
 '2041.1': 18592.596,
 '2042.1': 18825.352,
 '2043.1': 19051.272,
 '2044.1': 19270.012,
 '2045.1': 19481.257,
 '2046.1': 19684.718,
 '2047.1': 19880.144,
 '2048.1': 20067.295,
 '2049.1': 20245.964,
 '2050.1': 20415.949},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '2010': 1611.866,
 '2011': 1637.585,
 '2012': 1660.183,
 '2013': 1680.73,
 '2014': 1700.765,
 '2015': 1721.362,
 '2016': 1742.734,
 '2017': 1764.522,
 '2018': 1786.495,
 '2019': 1808.264,
 '2020': 1829.564,
 '2021': 1850.391,
 '2022': 1870.877,
 '2023': 1891.102,
 '2024': 1911.162,
 '2025': 1931.119,
 '2026': 1950.964,
 '2027': 1970.664,
 '2028': 1990.204,
 '2029': 2009.579,
 '2030': 2028.773,
 '2031': 2047.787,
 '2032': 2066.62,
 '2033': 2085.298,
 '2034': 2103.482,
 '2035': 2121.19,
 '2036': 2138.388,
 '2037': 2155.033,
 '2038': 2171.049,
 '2039': 2186.353,
 '2040': 2200.885,
 '2041': 2214.615,
 '2042': 2227.536,
 '2043': 2239.646,
 '2044': 2250.943,
 '2045': 2261.433,
 '2046': 2271.111,
 '2047': 2279.987,
 '2048': 2288.089,
 '2049': 2295.458,
 '2050': 2302.127,
 '1991': 1134.932,
 '1992': 1155.48,
 '1993': 1176.478,
 '1994': 1197.994,
 '1995': 1220.123,
 '1996': 1242.903,
 '1997': 1265.0,
 '1998': 1287.496,
 '1999': 1310.029,
 '2000': 1332.387,
 '2001': 1354.293,
 '2002': 1375.924,
 '2003': 1398.356,
 '2004': 1422.945,
 '2005': 1450.563,
 '2006': 1481.568,
 '2007': 1515.245,
 '2008': 1549.624,
 '2009': 1582.371,
 '2010.1': 1611.866,
 '2011.1': 1637.585,
 '2012.1': 1660.183,
 '2013.1': 1680.73,
 '2014.1': 1700.765,
 '2015.1': 1721.362,
 '2016.1': 1742.734,
 '2017.1': 1764.522,
 '2018.1': 1786.495,
 '2019.1': 1808.264,
 '2020.1': 1829.564,
 '2021.1': 1850.391,
 '2022.1': 1870.877,
 '2023.1': 1891.102,
 '2024.1': 1911.162,
 '2025.1': 1931.119,
 '2026.1': 1950.964,
 '2027.1': 1970.664,
 '2028.1': 1990.204,
 '2029.1': 2009.579,
 '2030.1': 2028.773,
 '2031.1': 2047.787,
 '2032.1': 2066.62,
 '2033.1': 2085.298,
 '2034.1': 2103.482,
 '2035.1': 2121.19,
 '2036.1': 2138.388,
 '2037.1': 2155.033,
 '2038.1': 2171.049,
 '2039.1': 2186.353,
 '2040.1': 2200.885,
 '2041.1': 2214.615,
 '2042.1': 2227.536,
 '2043.1': 2239.646,
 '2044.1': 2250.943,
 '2045.1': 2261.433,
 '2046.1': 2271.111,
 '2047.1': 2279.987,
 '2048.1': 2288.089,
 '2049.1': 2295.458,
 '2050.1': 2302.127},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '2010': 38705.362,
 '2011': 39665.446,
 '2012': 40641.055,
 '2013': 41629.125,
 '2014': 42626.472,
 '2015': 43630.111,
 '2016': 44637.912,
 '2017': 45647.604,
 '2018': 46656.05,
 '2019': 47659.965,
 '2020': 48656.754,
 '2021': 49644.313,
 '2022': 50621.756,
 '2023': 51589.277,
 '2024': 52547.782,
 '2025': 53497.7,
 '2026': 54438.216,
 '2027': 55368.264,
 '2028': 56287.864,
 '2029': 57197.617,
 '2030': 58099.463,
 '2031': 58986.406,
 '2032': 59859.737,
 '2033': 60717.775,
 '2034': 61558.684,
 '2035': 62380.699,
 '2036': 63182.493,
 '2037': 63962.623,
 '2038': 64719.105,
 '2039': 65449.838,
 '2040': 66153.051,
 '2041': 66827.525,
 '2042': 67472.372,
 '2043': 68086.616,
 '2044': 68669.42,
 '2045': 69220.064,
 '2046': 69737.822,
 '2047': 70222.16,
 '2048': 70672.852,
 '2049': 71089.834,
 '2050': 71473.005,
 '1991': 24757.123,
 '1992': 25580.052,
 '1993': 26427.813,
 '1994': 27228.905,
 '1995': 27936.571,
 '1996': 28532.562,
 '1997': 29040.816,
 '1998': 29505.448,
 '1999': 29990.701,
 '2000': 30542.153,
 '2001': 31172.281,
 '2002': 31867.429,
 '2003': 32619.349,
 '2004': 33411.557,
 '2005': 34229.993,
 '2006': 35072.91,
 '2007': 35944.533,
 '2008': 36842.282,
 '2009': 37763.464,
 '2010.1': 38705.362,
 '2011.1': 39665.446,
 '2012.1': 40641.055,
 '2013.1': 41629.125,
 '2014.1': 42626.472,
 '2015.1': 43630.111,
 '2016.1': 44637.912,
 '2017.1': 45647.604,
 '2018.1': 46656.05,
 '2019.1': 47659.965,
 '2020.1': 48656.754,
 '2021.1': 49644.313,
 '2022.1': 50621.756,
 '2023.1': 51589.277,
 '2024.1': 52547.782,
 '2025.1': 53497.7,
 '2026.1': 54438.216,
 '2027.1': 55368.264,
 '2028.1': 56287.864,
 '2029.1': 57197.617,
 '2030.1': 58099.463,
 '2031.1': 58986.406,
 '2032.1': 59859.737,
 '2033.1': 60717.775,
 '2034.1': 61558.684,
 '2035.1': 62380.699,
 '2036.1': 63182.493,
 '2037.1': 63962.623,
 '2038.1': 64719.105,
 '2039.1': 65449.838,
 '2040.1': 66153.051,
 '2041.1': 66827.525,
 '2042.1': 67472.372,
 '2043.1': 68086.616,
 '2044.1': 68669.42,
 '2045.1': 69220.064,
 '2046.1': 69737.822,
 '2047.1': 70222.16,
 '2048.1': 70672.852,
 '2049.1': 71089.834,
 '2050.1': 71473.005},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '2010': 323.947,
 '2011': 323.268,
 '2012': 321.964,
 '2013': 330.07,
 '2014': 337.895,
 '2015': 345.376,
 '2016': 352.55,
 '2017': 359.435,
 '2018': 366.013,
 '2019': 372.296,
 '2020': 378.29,
 '2021': 383.99,
 '2022': 389.404,
 '2023': 394.576,
 '2024': 399.566,
 '2025': 404.409,
 '2026': 409.132,
 '2027': 413.732,
 '2028': 418.181,
 '2029': 422.444,
 '2030': 426.501,
 '2031': 430.351,
 '2032': 434.028,
 '2033': 437.591,
 '2034': 441.116,
 '2035': 444.652,
 '2036': 448.218,
 '2037': 451.805,
 '2038': 455.394,
 '2039': 458.955,
 '2040': 462.469,
 '2041': 465.943,
 '2042': 469.241,
 '2043': 472.364,
 '2044': 475.306,
 '2045': 478.067,
 '2046': 480.642,
 '2047': 483.033,
 '2048': 485.249,
 '2049': 487.303,
 '2050': 489.201,
 '1991': 283.109,
 '1992': 287.81,
 '1993': 292.756,
 '1994': 297.977,
 '1995': 300.427,
 '1996': 302.941,
 '1997': 305.579,
 '1998': 308.179,
 '1999': 310.603,
 '2000': 312.737,
 '2001': 314.556,
 '2002': 316.058,
 '2003': 317.389,
 '2004': 318.68,
 '2005': 320.042,
 '2006': 321.395,
 '2007': 322.609,
 '2008': 323.525,
 '2009': 324.029,
 '2010.1': 323.947,
 '2011.1': 323.268,
 '2012.1': 321.964,
 '2013.1': 330.07,
 '2014.1': 337.895,
 '2015.1': 345.376,
 '2016.1': 352.55,
 '2017.1': 359.435,
 '2018.1': 366.013,
 '2019.1': 372.296,
 '2020.1': 378.29,
 '2021.1': 383.99,
 '2022.1': 389.404,
 '2023.1': 394.576,
 '2024.1': 399.566,
 '2025.1': 404.409,
 '2026.1': 409.132,
 '2027.1': 413.732,
 '2028.1': 418.181,
 '2029.1': 422.444,
 '2030.1': 426.501,
 '2031.1': 430.351,
 '2032.1': 434.028,
 '2033.1': 437.591,
 '2034.1': 441.116,
 '2035.1': 444.652,
 '2036.1': 448.218,
 '2037.1': 451.805,
 '2038.1': 455.394,
 '2039.1': 458.955,
 '2040.1': 462.469,
 '2041.1': 465.943,
 '2042.1': 469.241,
 '2043.1': 472.364,
 '2044.1': 475.306,
 '2045.1': 478.067,
 '2046.1': 480.642,
 '2047.1': 483.033,
 '2048.1': 485.249,
 '2049.1': 487.303,
 '2050.1': 489.201},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '2010': 237.291,
 '2011': 236.029,
 '2012': 234.816,
 '2013': 233.402,
 '2014': 231.633,
 '2015': 229.341,
 '2016': 226.498,
 '2017': 223.245,
 '2018': 219.785,
 '2019': 216.365,
 '2020': 213.15,
 '2021': 210.171,
 '2022': 207.381,
 '2023': 204.764,
 '2024': 202.289,
 '2025': 199.935,
 '2026': 197.712,
 '2027': 195.635,
 '2028': 193.705,
 '2029': 191.925,
 '2030': 190.297,
 '2031': 188.819,
 '2032': 187.492,
 '2033': 186.318,
 '2034': 185.296,
 '2035': 184.428,
 '2036': 183.713,
 '2037': 183.151,
 '2038': 182.744,
 '2039': 182.49,
 '2040': 182.193,
 '2041': 181.854,
 '2042': 181.473,
 '2043': 181.048,
 '2044': 180.577,
 '2045': 180.057,
 '2046': 179.49,
 '2047': 178.875,
 '2048': 178.209,
 '2049': 177.493,
 '2050': 176.726,
 '1991': 288.95,
 '1992': 283.828,
 '1993': 278.519,
 '1994': 276.087,
 '1995': 273.738,
 '1996': 271.207,
 '1997': 268.565,
 '1998': 265.8,
 '1999': 262.948,
 '2000': 260.031,
 '2001': 257.087,
 '2002': 254.12,
 '2003': 251.249,
 '2004': 248.58,
 '2005': 246.218,
 '2006': 244.076,
 '2007': 242.107,
 '2008': 240.309,
 '2009': 238.727,
 '2010.1': 237.291,
 '2011.1': 236.029,
 '2012.1': 234.816,
 '2013.1': 233.402,
 '2014.1': 231.633,
 '2015.1': 229.341,
 '2016.1': 226.498,
 '2017.1': 223.245,
 '2018.1': 219.785,
 '2019.1': 216.365,
 '2020.1': 213.15,
 '2021.1': 210.171,
 '2022.1': 207.381,
 '2023.1': 204.764,
 '2024.1': 202.289,
 '2025.1': 199.935,
 '2026.1': 197.712,
 '2027.1': 195.635,
 '2028.1': 193.705,
 '2029.1': 191.925,
 '2030.1': 190.297,
 '2031.1': 188.819,
 '2032.1': 187.492,
 '2033.1': 186.318,
 '2034.1': 185.296,
 '2035.1': 184.428,
 '2036.1': 183.713,
 '2037.1': 183.151,
 '2038.1': 182.744,
 '2039.1': 182.49,
 '2040.1': 182.193,
 '2041.1': 181.854,
 '2042.1': 181.473,
 '2043.1': 181.048,
 '2044.1': 180.577,
 '2045.1': 180.057,
 '2046.1': 179.49,
 '2047.1': 178.875,
 '2048.1': 178.209,
 '2049.1': 177.493,
 '2050.1': 176.726},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '2010': 61.256,
 '2011': 60.678,
 '2012': 60.061,
 '2013': 59.465,
 '2014': 58.885,
 '2015': 58.325,
 '2016': 57.79,
 '2017': 57.276,
 '2018': 56.792,
 '2019': 56.336,
 '2020': 55.91,
 '2021': 55.517,
 '2022': 55.155,
 '2023': 54.83,
 '2024': 54.539,
 '2025': 54.288,
 '2026': 54.076,
 '2027': 53.903,
 '2028': 53.768,
 '2029': 53.669,
 '2030': 53.608,
 '2031': 53.581,
 '2032': 53.591,
 '2033': 53.639,
 '2034': 53.724,
 '2035': 53.846,
 '2036': 54.006,
 '2037': 54.206,
 '2038': 54.447,
 '2039': 54.67,
 '2040': 54.877,
 '2041': 55.066,
 '2042': 55.239,
 '2043': 55.396,
 '2044': 55.534,
 '2045': 55.654,
 '2046': 55.756,
 '2047': 55.841,
 '2048': 55.909,
 '2049': 55.96,
 '2050': 55.996,
 '1991': 64.202,
 '1992': 64.441,
 '1993': 64.69,
 '1994': 64.871,
 '1995': 64.958,
 '1996': 64.937,
 '1997': 64.833,
 '1998': 64.696,
 '1999': 64.591,
 '2000': 64.557,
 '2001': 64.613,
 '2002': 64.397,
 '2003': 64.146,
 '2004': 63.87,
 '2005': 63.552,
 '2006': 63.176,
 '2007': 62.761,
 '2008': 62.291,
 '2009': 61.795,
 '2010.1': 61.256,
 '2011.1': 60.678,
 '2012.1': 60.061,
 '2013.1': 59.465,
 '2014.1': 58.885,
 '2015.1': 58.325,
 '2016.1': 57.79,
 '2017.1': 57.276,
 '2018.1': 56.792,
 '2019.1': 56.336,
 '2020.1': 55.91,
 '2021.1': 55.517,
 '2022.1': 55.155,
 '2023.1': 54.83,
 '2024.1': 54.539,
 '2025.1': 54.288,
 '2026.1': 54.076,
 '2027.1': 53.903,
 '2028.1': 53.768,
 '2029.1': 53.669,
 '2030.1': 53.608,
 '2031.1': 53.581,
 '2032.1': 53.591,
 '2033.1': 53.639,
 '2034.1': 53.724,
 '2035.1': 53.846,
 '2036.1': 54.006,
 '2037.1': 54.206,
 '2038.1': 54.447,
 '2039.1': 54.67,
 '2040.1': 54.877,
 '2041.1': 55.066,
 '2042.1': 55.239,
 '2043.1': 55.396,
 '2044.1': 55.534,
 '2045.1': 55.654,
 '2046.1': 55.756,
 '2047.1': 55.841,
 '2048.1': 55.909,
 '2049.1': 55.96,
 '2050.1': 55.996}]},
'Rural Population': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035,
2040,
2045,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950': 1785371.7829999998,
 '1955': 1895233.6930000007,
 '1960': 2009367.0100000002,
 '1965': 2151123.4640000015,
 '1970': 2346362.154,
 '1975': 2540462.2040000013,
 '1980': 2704210.505000001,
 '1985': 2865842.7329999995,
 '1990': 3040715.363999998,
 '1995': 3175969.1809999985,
 '2000': 3276699.476000001,
 '2005': 3326253.5200000023,
 '2010': 3363301.0130000003,
 '2015': 3401511.1569999997,
 '2020': 3416488.3649999974,
 '2025': 3410967.454000002,
 '2030': 3383941.0979999993,
 '2035': 3336868.4630000014,
 '2040': 3272087.978000001,
 '2045': 3191664.7529999996,
 '2050': 3092066.591000001},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950': 368580.7009999998,
 '1955': 363958.1610000001,
 '1960': 356807.5369999998,
 '1965': 347679.3789999995,
 '1970': 334992.0890000004,
 '1975': 326952.8670000001,
 '1980': 322142.012,
 '1985': 319282.8999999993,
 '1990': 317122.4939999999,
 '1995': 312760.2290000003,
 '2000': 306624.8029999998,
 '2005': 292203.5139999997,
 '2010': 281051.5769999998,
 '2015': 274117.7410000005,
 '2020': 265636.8470000001,
 '2025': 254198.6809999997,
 '2030': 240237.0889999997,
 '2035': 224195.4039999999,
 '2040': 207063.1619999995,
 '2045': 190117.7700000012,
 '2050': 174096.318},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950': 1416791.082,
 '1955': 1531275.5320000001,
 '1960': 1652559.4730000002,
 '1965': 1803444.0850000014,
 '1970': 2011370.0649999992,
 '1975': 2213509.3370000017,
 '1980': 2382068.4930000007,
 '1985': 2546559.8330000006,
 '1990': 2723592.8699999987,
 '1995': 2863208.9519999987,
 '2000': 2970074.673000002,
 '2005': 3034050.0060000024,
 '2010': 3082249.4360000007,
 '2015': 3127393.416,
 '2020': 3150851.5179999974,
 '2025': 3156768.7730000005,
 '2030': 3143704.008999999,
 '2035': 3112673.059000003,
 '2040': 3065024.8160000024,
 '2045': 3001546.982999999,
 '2050': 2917970.273},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950': 180539.535,
 '1955': 197046.518,
 '1960': 217487.2080000001,
 '1965': 241395.898,
 '1970': 268860.068,
 '1975': 296659.927,
 '1980': 325891.978,
 '1985': 361115.232,
 '1990': 400989.0930000002,
 '1995': 448520.2860000001,
 '2000': 498490.034,
 '2005': 549498.8979999998,
 '2010': 598778.7309999999,
 '2015': 650680.3520000004,
 '2020': 701945.8219999997,
 '2025': 750942.655,
 '2030': 795666.8449999997,
 '2035': 834978.8399999996,
 '2040': 868062.2340000003,
 '2045': 893721.1190000003,
 '2050': 910979.5819999999},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950': 1236251.5469999998,
 '1955': 1334229.0140000002,
 '1960': 1435072.2650000004,
 '1965': 1562048.1870000004,
 '1970': 1742509.996999999,
 '1975': 1916849.4100000018,
 '1980': 2056176.5150000001,
 '1985': 2185444.6010000007,
 '1990': 2322603.776999999,
 '1995': 2414688.6659999983,
 '2000': 2471584.639000003,
 '2005': 2484551.108000002,
 '2010': 2483470.7050000015,
 '2015': 2476713.064,
 '2020': 2448905.695999999,
 '2025': 2405826.117999997,
 '2030': 2348037.163999999,
 '2035': 2277694.2189999977,
 '2040': 2196962.582000004,
 '2045': 2107825.864000002,
 '2050': 2006990.6909999987},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950': 921933.0420000001,
 '1955': 998306.0780000008,
 '1960': 1093633.426,
 '1965': 1202718.0279999992,
 '1970': 1320279.6730000004,
 '1975': 1442592.443,
 '1980': 1571075.0490000006,
 '1985': 1712176.6609999994,
 '1990': 1854287.2609999988,
 '1995': 2000458.0729999996,
 '2000': 2140671.3570000017,
 '2005': 2268146.9220000003,
 '2010': 2385999.873000001,
 '2015': 2500296.3739999994,
 '2020': 2596363.5799999987,
 '2025': 2669862.9590000003,
 '2030': 2716120.6680000015,
 '2035': 2734892.5599999977,
 '2040': 2727476.9570000055,
 '2045': 2696034.868999997,
 '2050': 2642608.101999998},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950': 279213.855,
 '1955': 277920.3110000001,
 '1960': 275974.927,
 '1965': 273022.3050000002,
 '1970': 266625.1790000001,
 '1975': 263873.319,
 '1980': 261801.8759999998,
 '1985': 259451.7280000001,
 '1990': 255759.3289999999,
 '1995': 251925.35,
 '2000': 248281.3129999995,
 '2005': 236896.456,
 '2010': 229169.4449999998,
 '2015': 224847.5889999995,
 '2020': 219189.17,
 '2025': 211092.9669999997,
 '2030': 201016.7110000006,
 '2035': 189109.0840000003,
 '2040': 175943.878,
 '2045': 162454.6880000001,
 '2050': 149462.6870000004},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950': 1389446.0429999996,
 '1955': 1491995.5150000006,
 '1960': 1596530.1140000003,
 '1965': 1727865.0119999996,
 '1970': 1913918.11,
 '1975': 2092768.2459999998,
 '1980': 2238923.932999999,
 '1985': 2382131.9640000006,
 '1990': 2535382.593,
 '1995': 2642634.335,
 '2000': 2712144.272,
 '2005': 2733259.3180000004,
 '2010': 2735698.954,
 '2015': 2733012.0890000006,
 '2020': 2707689.056999999,
 '2025': 2665236.7650000006,
 '2030': 2605466.8810000005,
 '2035': 2530919.465,
 '2040': 2444490.7919999985,
 '2045': 2348156.4459999977,
 '2050': 2238655.12},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950': 745116.1149999998,
 '1955': 794524.9020000002,
 '1960': 831617.5190000006,
 '1965': 883518.1679999998,
 '1970': 981853.3540000003,
 '1975': 1068633.3590000002,
 '1980': 1116042.4679999994,
 '1985': 1146136.209,
 '1990': 1187044.415,
 '1995': 1182603.5259999991,
 '2000': 1147787.352,
 '2005': 1078424.032999999,
 '2010': 1001692.9520000003,
 '2015': 928751.6570000013,
 '2020': 849086.1199999992,
 '2025': 770706.4850000001,
 '2030': 698422.7640000009,
 '2035': 634347.9699999997,
 '2040': 579147.2790000001,
 '2045': 531988.2859999985,
 '2050': 486573.7410000004},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950': 644329.928,
 '1955': 697470.613,
 '1960': 764912.595,
 '1965': 844346.844,
 '1970': 932064.756,
 '1975': 1024134.8869999996,
 '1980': 1122881.4649999996,
 '1985': 1235995.7550000001,
 '1990': 1348338.1779999998,
 '1995': 1460030.8089999994,
 '2000': 1564356.9200000006,
 '2005': 1654835.2849999992,
 '2010': 1734006.0019999999,
 '2015': 1804260.432,
 '2020': 1858602.9369999997,
 '2025': 1894530.279999999,
 '2030': 1907044.1169999996,
 '2035': 1896571.4950000003,
 '2040': 1865343.5129999986,
 '2045': 1816168.1600000006,
 '2050': 1752081.3790000002},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950': 116163.636,
 '1955': 124736.496,
 '1960': 136261.398,
 '1965': 149639.22,
 '1970': 165227.672,
 '1975': 183290.891,
 '1980': 203016.316,
 '1985': 223858.035,
 '1990': 249229.579,
 '1995': 281081.258,
 '2000': 315968.1300000001,
 '2005': 355796.2389999999,
 '2010': 398123.048,
 '2015': 443323.0090000002,
 '2020': 489255.442,
 '2025': 534258.6939999998,
 '2030': 577057.7839999998,
 '2035': 616424.4350000002,
 '2040': 651228.27,
 '2045': 680623.5870000002,
 '2050': 703517.0980000002},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950': 159678.7910000001,
 '1955': 172886.941,
 '1960': 188500.45,
 '1965': 208410.941,
 '1970': 231463.5739999999,
 '1975': 257595.362,
 '1980': 288191.2559999999,
 '1985': 322115.5220000001,
 '1990': 357792.1270000001,
 '1995': 397793.3959999999,
 '2000': 442366.6320000001,
 '2005': 488573.4420000001,
 '2010': 539628.588,
 '2015': 593407.7340000002,
 '2020': 647903.3059999996,
 '2025': 701116.9810000005,
 '2030': 752167.9250000002,
 '2035': 800173.0319999993,
 '2040': 843661.3430000002,
 '2045': 880556.5480000004,
 '2050': 909315.7570000002},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950': 196011.057,
 '1955': 212575.808,
 '1960': 232133.5810000001,
 '1965': 256122.057,
 '1970': 283821.5590000001,
 '1975': 314699.085,
 '1980': 351396.255,
 '1985': 392074.281,
 '1990': 434455.748,
 '1995': 481097.777,
 '2000': 531568.3920000001,
 '2005': 583724.1160000002,
 '2010': 640859.2990000001,
 '2015': 702838.816,
 '2020': 764884.396,
 '2025': 824101.1499999999,
 '2030': 879523.7029999997,
 '2035': 930373.8119999999,
 '2040': 975140.216,
 '2045': 1011608.0770000005,
 '2050': 1038636.716},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950': 62921.611,
 '1955': 69607.572,
 '1960': 77668.17,
 '1965': 87293.823,
 '1970': 98539.422,
 '1975': 111349.782,
 '1980': 126040.328,
 '1985': 143402.088,
 '1990': 162795.259,
 '1995': 181431.829,
 '2000': 206163.382,
 '2005': 232915.502,
 '2010': 262483.969,
 '2015': 293362.422,
 '2020': 324919.316,
 '2025': 355649.1919999999,
 '2030': 384750.9019999999,
 '2035': 411389.3309999998,
 '2040': 434903.8400000001,
 '2045': 454698.928,
 '2050': 469911.9730000001},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950': 2268.946,
 '1955': 2483.183,
 '1960': 2728.24,
 '1965': 3007.271,
 '1970': 3357.279,
 '1975': 3542.086,
 '1980': 3938.168,
 '1985': 4456.552,
 '1990': 5075.806,
 '1995': 5532.158,
 '2000': 5872.887,
 '2005': 6727.349,
 '2010': 7833.959,
 '2015': 8967.359,
 '2020': 10302.641,
 '2025': 11663.312,
 '2030': 13018.607,
 '2035': 14401.539,
 '2040': 15828.117,
 '2045': 17248.994,
 '2050': 18579.352},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950': 148.933,
 '1955': 159.808,
 '1960': 167.133,
 '1965': 172.207,
 '1970': 185.447,
 '1975': 202.643,
 '1980': 236.366,
 '1985': 264.837,
 '1990': 296.885,
 '1995': 340.851,
 '2000': 390.064,
 '2005': 441.134,
 '2010': 496.767,
 '2015': 556.09,
 '2020': 614.114,
 '2025': 668.246,
 '2030': 716.454,
 '2035': 759.914,
 '2040': 799.617,
 '2045': 834.588,
 '2050': 863.694},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950': 37.319,
 '1955': 38.266,
 '1960': 41.546,
 '1965': 50.459,
 '1970': 61.026,
 '1975': 73.662,
 '1980': 100.165,
 '1985': 106.723,
 '1990': 141.949,
 '1995': 149.401,
 '2000': 168.406,
 '2005': 182.018,
 '2010': 195.77,
 '2015': 209.442,
 '2020': 219.361,
 '2025': 225.352,
 '2030': 226.889,
 '2035': 223.725,
 '2040': 217.47,
 '2045': 209.48,
 '2050': 200.165},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950': 1061.055,
 '1955': 1144.875,
 '1960': 1260.547,
 '1965': 1406.956,
 '1970': 1582.16,
 '1975': 1795.472,
 '1980': 2042.251,
 '1985': 2319.335,
 '1990': 2524.735,
 '1995': 2394.438,
 '2000': 2490.747,
 '2005': 2734.684,
 '2010': 2846.355,
 '2015': 2995.125,
 '2020': 3186.178,
 '2025': 3358.128,
 '2030': 3507.555,
 '2035': 3638.874,
 '2040': 3745.623,
 '2045': 3811.254,
 '2050': 3830.298},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950': 17294.144,
 '1955': 18861.296,
 '1960': 20726.182,
 '1965': 23115.787,
 '1970': 25974.896,
 '1975': 29486.113,
 '1980': 31593.677,
 '1985': 36127.293,
 '1990': 42017.468,
 '1995': 49385.397,
 '2000': 56730.042,
 '2005': 64680.71,
 '2010': 72513.53,
 '2015': 80469.946,
 '2020': 88295.647,
 '2025': 95633.359,
 '2030': 102124.458,
 '2035': 107547.947,
 '2040': 111745.181,
 '2045': 114730.192,
 '2050': 116332.817},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950': 5737.091,
 '1955': 6531.88,
 '1960': 7508.683,
 '1965': 8686.795,
 '1970': 10094.027,
 '1975': 11744.9,
 '1980': 13733.732,
 '1985': 16491.493,
 '1990': 19483.07,
 '1995': 22352.157,
 '2000': 25194.298,
 '2005': 28234.834,
 '2010': 31603.483,
 '2015': 35116.503,
 '2020': 38516.638,
 '2025': 41691.191,
 '2030': 44577.009,
 '2035': 47060.114,
 '2040': 49044.98,
 '2045': 50458.808,
 '2050': 51282.416},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950': 3765.037,
 '1955': 4129.1,
 '1960': 4556.717,
 '1965': 5055.019,
 '1970': 5649.046,
 '1975': 6321.811,
 '1980': 7101.872,
 '1985': 7956.881,
 '1990': 8865.351,
 '1995': 9999.27,
 '2000': 11490.635,
 '2005': 13053.181,
 '2010': 14396.303,
 '2015': 15705.295,
 '2020': 17020.546,
 '2025': 18300.128,
 '2030': 19490.283,
 '2035': 20563.63,
 '2040': 21462.488,
 '2045': 22159.937,
 '2050': 22644.833},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950': 2850.311,
 '1955': 3124.711,
 '1960': 3459.747,
 '1965': 3859.485,
 '1970': 4325.077,
 '1975': 4887.822,
 '1980': 5605.309,
 '1985': 6478.244,
 '1990': 8346.561,
 '1995': 8594.81,
 '2000': 9714.122,
 '2005': 11076.729,
 '2010': 12809.514,
 '2015': 14706.907,
 '2020': 16748.855,
 '2025': 18870.1,
 '2030': 21027.123,
 '2035': 23088.127,
 '2040': 25028.032,
 '2045': 26802.535,
 '2050': 28344.777},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950': 348.597,
 '1955': 390.215,
 '1960': 428.284,
 '1965': 461.257,
 '1970': 474.742,
 '1975': 504.611,
 '1980': 556.904,
 '1985': 585.841,
 '1990': 592.342,
 '1995': 640.136,
 '2000': 679.44,
 '2005': 707.398,
 '2010': 729.371,
 '2015': 743.079,
 '2020': 754.784,
 '2025': 756.584,
 '2030': 748.346,
 '2035': 728.698,
 '2040': 697.188,
 '2045': 657.78,
 '2050': 616.682},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950': 13.851,
 '1955': 16.729,
 '1960': 20.093,
 '1965': 23.8,
 '1970': 27.673,
 '1975': 32.955,
 '1980': 38.552,
 '1985': 48.31,
 '1990': 60.608,
 '1995': 72.113,
 '2000': 78.577,
 '2005': 88.636,
 '2010': 106.542,
 '2015': 127.237,
 '2020': 148.158,
 '2025': 168.107,
 '2030': 186.567,
 '2035': 202.487,
 '2040': 214.511,
 '2045': 223.885,
 '2050': 231.009},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950': 5815.578,
 '1955': 6290.727,
 '1960': 6881.225,
 '1965': 7558.311,
 '1970': 8337.891,
 '1975': 9220.136,
 '1980': 10289.336,
 '1985': 10604.869,
 '1990': 9935.737,
 '1995': 11426.146,
 '2000': 12810.292,
 '2005': 14646.262,
 '2010': 16511.748,
 '2015': 18375.089,
 '2020': 20330.756,
 '2025': 22305.519,
 '2030': 24243.408,
 '2035': 26073.38,
 '2040': 27717.244,
 '2045': 29142.678,
 '2050': 30302.381},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950': 189.82,
 '1955': 210.208,
 '1960': 225.457,
 '1965': 241.68,
 '1970': 269.537,
 '1975': 269.248,
 '1980': 236.909,
 '1985': 179.256,
 '1990': 114.623,
 '1995': 93.496,
 '2000': 65.061,
 '2005': 29.275,
 '2010': 12.452,
 '2015': 5.704,
 '2020': 3.055,
 '2025': 1.917,
 '2030': 1.407,
 '2035': 1.208,
 '2040': 1.136,
 '2045': 1.06,
 '2050': 0.983},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950': 2139.977,
 '1955': 2466.316,
 '1960': 2857.159,
 '1965': 3139.75,
 '1970': 3634.605,
 '1975': 4184.835,
 '1980': 4898.034,
 '1985': 5810.608,
 '1990': 6843.9,
 '1995': 5344.914,
 '2000': 6827.783,
 '2005': 7471.017,
 '2010': 8511.644,
 '2015': 9652.086,
 '2020': 10805.843,
 '2025': 11884.021,
 '2030': 12880.409,
 '2035': 13773.761,
 '2040': 14503.076,
 '2045': 15051.973,
 '2050': 15402.615},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950': 26.372,
 '1955': 28.226,
 '1960': 30.044,
 '1965': 31.28,
 '1970': 31.907,
 '1975': 32.02,
 '1980': 33.567,
 '1985': 35.413,
 '1990': 35.828,
 '1995': 38.633,
 '2000': 40.224,
 '2005': 42.89,
 '2010': 42.653,
 '2015': 41.809,
 '2020': 40.804,
 '2025': 39.294,
 '2030': 37.494,
 '2035': 35.579,
 '2040': 33.603,
 '2045': 31.552,
 '2050': 29.389},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950': 1975.96,
 '1955': 2120.948,
 '1960': 2278.834,
 '1965': 2455.844,
 '1970': 2663.388,
 '1975': 2890.911,
 '1980': 4657.202,
 '1985': 4885.467,
 '1990': 5203.412,
 '1995': 5283.649,
 '2000': 6015.423,
 '2005': 6629.975,
 '2010': 7315.117,
 '2015': 7893.535,
 '2020': 8674.136,
 '2025': 9497.29,
 '2030': 10305.77,
 '2035': 11073.463,
 '2040': 11787.851,
 '2045': 12433.748,
 '2050': 12986.365},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950': 2353.956,
 '1955': 2481.874,
 '1960': 2696.628,
 '1965': 2980.012,
 '1970': 3332.8,
 '1975': 3766.156,
 '1980': 4304.375,
 '1985': 4913.865,
 '1990': 5002.653,
 '1995': 4592.949,
 '2000': 5594.806,
 '2005': 6717.865,
 '2010': 8269.201,
 '2015': 9642.116,
 '2020': 10860.946,
 '2025': 12017.223,
 '2030': 13090.758,
 '2035': 14045.927,
 '2040': 14899.365,
 '2045': 15637.175,
 '2050': 16234.641},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950': 5012.741,
 '1955': 5690.476,
 '1960': 6488.397,
 '1965': 7572.853,
 '1970': 8816.623,
 '1975': 10064.872,
 '1980': 11604.08,
 '1985': 13306.218,
 '1990': 15507.403,
 '1995': 17910.474,
 '2000': 20484.903,
 '2005': 23702.764,
 '2010': 27341.361,
 '2015': 31289.039,
 '2020': 35412.691,
 '2025': 39654.788,
 '2030': 43927.928,
 '2035': 48113.433,
 '2040': 52114.598,
 '2045': 55826.472,
 '2050': 59034.585},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950': 7382.698,
 '1955': 8355.597,
 '1960': 9546.009,
 '1965': 10979.055,
 '1970': 12537.177,
 '1975': 14199.091,
 '1980': 15963.916,
 '1985': 18175.518,
 '1990': 20651.764,
 '1995': 23805.808,
 '2000': 26553.317,
 '2005': 29619.018,
 '2010': 33138.622,
 '2015': 36844.744,
 '2020': 40661.266,
 '2025': 44436.083,
 '2030': 48172.997,
 '2035': 51860.581,
 '2040': 55480.323,
 '2045': 58766.734,
 '2050': 61539.425},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950': 2044.741,
 '1955': 2252.228,
 '1960': 2492.354,
 '1965': 2730.557,
 '1970': 2907.087,
 '1975': 3230.399,
 '1980': 3544.418,
 '1985': 4197.103,
 '1990': 4863.969,
 '1995': 5746.834,
 '2000': 6866.093,
 '2005': 7603.597,
 '2010': 8399.366,
 '2015': 9353.351,
 '2020': 10342.892,
 '2025': 11337.157,
 '2030': 12310.858,
 '2035': 13221.428,
 '2040': 14054.815,
 '2045': 14794.514,
 '2050': 15424.042},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950': 2454.484,
 '1955': 2830.909,
 '1960': 3274.891,
 '1965': 3765.445,
 '1970': 4277.034,
 '1975': 4900.039,
 '1980': 5561.495,
 '1985': 6458.262,
 '1990': 7231.195,
 '1995': 7728.195,
 '2000': 8096.262,
 '2005': 8526.166,
 '2010': 9410.211,
 '2015': 10667.966,
 '2020': 11980.005,
 '2025': 13141.393,
 '2030': 14156.582,
 '2035': 14975.516,
 '2040': 15528.622,
 '2045': 15875.569,
 '2050': 16031.504},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950': 22773.146,
 '1955': 24614.428,
 '1960': 26724.879,
 '1965': 29248.98,
 '1970': 32107.594,
 '1975': 34965.54,
 '1980': 38558.381,
 '1985': 42589.126,
 '1990': 47056.528,
 '1995': 53094.593,
 '2000': 57915.247,
 '2005': 64306.818,
 '2010': 72003.561,
 '2015': 80110.225,
 '2020': 88339.965,
 '2025': 96381.983,
 '2030': 104042.995,
 '2035': 111165.288,
 '2040': 117513.271,
 '2045': 122784.684,
 '2050': 126750.984},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950': 4203.48,
 '1955': 4660.643,
 '1960': 5054.34,
 '1965': 5427.632,
 '1970': 5762.85,
 '1975': 6212.964,
 '1980': 6760.09,
 '1985': 7390.475,
 '1990': 7650.444,
 '1995': 7966.516,
 '2000': 8206.1,
 '2005': 8603.118,
 '2010': 9398.277,
 '2015': 10183.56,
 '2020': 10890.448,
 '2025': 11583.321,
 '2030': 12275.15,
 '2035': 12973.415,
 '2040': 13692.603,
 '2045': 14362.123,
 '2050': 14914.474},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950': 3905.034,
 '1955': 4166.329,
 '1960': 4454.869,
 '1965': 4802.52,
 '1970': 5202.525,
 '1975': 5422.114,
 '1980': 5867.248,
 '1985': 6408.712,
 '1990': 7069.277,
 '1995': 7730.283,
 '2000': 8318.116,
 '2005': 8964.62,
 '2010': 9673.887,
 '2015': 10371.907,
 '2020': 11016.661,
 '2025': 11599.407,
 '2030': 12122.535,
 '2035': 12592.874,
 '2040': 12971.856,
 '2045': 13245.453,
 '2050': 13402.062},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950': 1135.374,
 '1955': 1160.57,
 '1960': 1201.303,
 '1965': 1261.043,
 '1970': 1325.957,
 '1975': 1372.394,
 '1980': 1507.558,
 '1985': 1698.236,
 '1990': 1857.21,
 '1995': 2104.505,
 '2000': 2341.659,
 '2005': 2556.449,
 '2010': 2717.873,
 '2015': 2715.046,
 '2020': 2844.355,
 '2025': 3037.223,
 '2030': 3205.976,
 '2035': 3342.843,
 '2040': 3441.997,
 '2045': 3500.576,
 '2050': 3521.444},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950': 2389.713,
 '1955': 2584.909,
 '1960': 2800.641,
 '1965': 3031.366,
 '1970': 3222.068,
 '1975': 3451.606,
 '1980': 3664.383,
 '1985': 4084.462,
 '1990': 4717.152,
 '1995': 5497.472,
 '2000': 6537.507,
 '2005': 7872.263,
 '2010': 9273.802,
 '2015': 10855.197,
 '2020': 12454.833,
 '2025': 14074.581,
 '2030': 15640.692,
 '2035': 17071.341,
 '2040': 18353.34,
 '2045': 19481.257,
 '2050': 20415.949},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950': 621.053,
 '1955': 661.245,
 '1960': 709.451,
 '1965': 766.57,
 '1970': 830.77,
 '1975': 902.13,
 '1980': 959.403,
 '1985': 1016.633,
 '1990': 1114.696,
 '1995': 1220.123,
 '2000': 1332.387,
 '2005': 1450.563,
 '2010': 1611.866,
 '2015': 1721.362,
 '2020': 1829.564,
 '2025': 1931.119,
 '2030': 2028.773,
 '2035': 2121.19,
 '2040': 2200.885,
 '2045': 2261.433,
 '2050': 2302.127},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950': 9856.58,
 '1955': 10725.609,
 '1960': 11847.891,
 '1965': 13299.411,
 '1970': 15085.912,
 '1975': 16988.786,
 '1980': 19221.94,
 '1985': 21362.869,
 '1990': 24011.202,
 '1995': 27936.571,
 '2000': 30542.153,
 '2005': 34229.993,
 '2010': 38705.362,
 '2015': 43630.111,
 '2020': 48656.754,
 '2025': 53497.7,
 '2030': 58099.463,
 '2035': 62380.699,
 '2040': 66153.051,
 '2045': 69220.064,
 '2050': 71473.005},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950': 190.662,
 '1955': 190.65,
 '1960': 190.121,
 '1965': 203.88,
 '1970': 223.897,
 '1975': 188.549,
 '1980': 184.161,
 '1985': 251.441,
 '1990': 278.54,
 '1995': 300.427,
 '2000': 312.737,
 '2005': 320.042,
 '2010': 323.947,
 '2015': 345.376,
 '2020': 378.29,
 '2025': 404.409,
 '2030': 426.501,
 '2035': 444.652,
 '2040': 462.469,
 '2045': 478.067,
 '2050': 489.201},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950': 419.342,
 '1955': 414.351,
 '1960': 412.337,
 '1965': 405.909,
 '1970': 401.28,
 '1975': 370.526,
 '1980': 330.44,
 '1985': 312.096,
 '1990': 293.827,
 '1995': 273.738,
 '2000': 260.031,
 '2005': 246.218,
 '2010': 237.291,
 '2015': 229.341,
 '2020': 213.15,
 '2025': 199.935,
 '2030': 190.297,
 '2035': 184.428,
 '2040': 182.193,
 '2045': 180.057,
 '2050': 176.726},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950': 51.908,
 '1955': 50.122,
 '1960': 53.926,
 '1965': 50.649,
 '1970': 52.335,
 '1975': 56.471,
 '1980': 63.158,
 '1985': 64.202,
 '1990': 64.18,
 '1995': 64.958,
 '2000': 64.557,
 '2005': 63.552,
 '2010': 61.256,
 '2015': 58.325,
 '2020': 55.91,
 '2025': 54.288,
 '2030': 53.608,
 '2035': 53.846,
 '2040': 54.877,
 '2045': 55.654,
 '2050': 55.996}]},
'Sex Ratio of Total Population': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950',
'1955',
'1960'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950': 99.6920174861,
 '1955': 99.8772261694,
 '1960': 100.0938636417},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1955': '...',
 '1960': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 91.0725812288,
 '1955': 91.7638107768,
 '1960': 92.4198348167},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 104.0485380935,
 '1955': 103.7822185968,
 '1960': 103.6060121162},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 100.2064322488,
 '1955': 99.9143263915,
 '1960': 99.9893460811},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 104.551196146,
 '1955': 104.2852596872,
 '1960': 104.0786534981},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 102.2410659116,
 '1955': 102.2098495859,
 '1960': 102.3580102275},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 97.6788403,
 '1955': 97.3314991529,
 '1960': 97.2318369395},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 102.2255330331,
 '1955': 101.7744135702,
 '1960': 101.2956625319},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1955': '...',
 '1960': '...'}]},
'Total fertility rates': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'2020-2025',
'2025-2030',
'2030-2035'],
'data': [{'Index': 1,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '2020-2025': 2.418,
 '2025-2030': 2.3758,
 '2030-2035': 2.3322},
{'Index': 2,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '2020-2025': '...',
 '2025-2030': '...',
 '2030-2035': '...'},
{'Index': 3,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '2020-2025': 1.647,
 '2025-2030': 1.6669,
 '2030-2035': 1.6914},
{'Index': 4,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '2020-2025': 2.5253,
 '2025-2030': 2.4692,
 '2030-2035': 2.4141},
{'Index': 5,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '2020-2025': 3.7429,
 '2025-2030': 3.5156,
 '2030-2035': 3.3208},
{'Index': 6,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '2020-2025': 2.2655,
 '2025-2030': 2.2203,
 '2030-2035': 2.1759},
{'Index': 7,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '2020-2025': 2.7214,
 '2025-2030': 2.6257,
 '2030-2035': 2.5398},
{'Index': 8,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '2020-2025': 3.6777,
 '2025-2030': 3.415,
 '2030-2035': 3.1983},
{'Index': 9,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '2020-2025': 2.3689,
 '2025-2030': 2.2945,
 '2030-2035': 2.2371},
{'Index': 10,
 'Variant': 'Median PI',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '2020-2025': '...',
 '2025-2030': '...',
 '2030-2035': '...'}]},
'Total Growth Rate': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
'1950-1955',
'1955-1960',
'1960-1965',
'1965-1970',
'1970-1975',
'1975-1980',
'1980-1985',
'1985-1990',
'1990-1995',
'1995-2000',
'2000-2005',
'2005-2010',
'2010-2015',
'2015-2020',
'2020-2025',
'2025-2030',
'2030-2035',
'2035-2040',
'2040-2045',
'2045-2050'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950-1955': 1.7792042582,
 '1955-1960': 1.7993145142,
 '1960-1965': 1.9245310411,
 '1965-1970': 2.0528015847,
 '1970-1975': 1.9476861664,
 '1975-1980': 1.7783861378,
 '1980-1985': 1.7815528185,
 '1985-1990': 1.7931609334,
 '1990-1995': 1.5185602044,
 '1995-2000': 1.323672765,
 '2000-2005': 1.2525482299,
 '2005-2010': 1.2329819203,
 '2010-2015': 1.1852973368,
 '2015-2020': 1.0872624007,
 '2020-2025': 0.976676377,
 '2025-2030': 0.8738654362,
 '2030-2035': 0.7831893641,
 '2035-2040': 0.7019101417,
 '2040-2045': 0.6281674522,
 '2045-2050': 0.5553640335},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950-1955': 1.1957449153,
 '1955-1960': 1.1674350267,
 '1960-1965': 1.0682152991,
 '1965-1970': 0.8440752909,
 '1970-1975': 0.7838162969,
 '1975-1980': 0.6530286587,
 '1980-1985': 0.5761920745,
 '1985-1990': 0.5491298737,
 '1990-1995': 0.419737119,
 '1995-2000': 0.3248275095,
 '2000-2005': 0.3338748998,
 '2005-2010': 0.402304873,
 '2010-2015': 0.2903830123,
 '2015-2020': 0.2548364437,
 '2020-2025': 0.1884923026,
 '2025-2030': 0.1344218524,
 '2030-2035': 0.0783465006,
 '2035-2040': 0.0385134861,
 '2040-2045': 0.0131491689,
 '2045-2050': -0.0043207071},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950-1955': 2.0495713669,
 '1955-1960': 2.0794752566,
 '1960-1965': 2.2845383655,
 '1965-1970': 2.525487104,
 '1970-1975': 2.3671548186,
 '1975-1980': 2.1538750081,
 '1980-1985': 2.1539502069,
 '1985-1990': 2.1481656007,
 '1990-1995': 1.8095422339,
 '1995-2000': 1.5713038223,
 '2000-2005': 1.4671453914,
 '2005-2010': 1.4168764313,
 '2010-2015': 1.3732938675,
 '2015-2020': 1.2532637494,
 '2020-2025': 1.1264263904,
 '2025-2030': 1.0081330902,
 '2030-2035': 0.9058445435,
 '2035-2040': 0.8128207384,
 '2040-2045': 0.7272335595,
 '2045-2050': 0.6425008821},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950-1955': 1.965347525,
 '1955-1960': 2.2226417865,
 '1960-1965': 2.3973792457,
 '1965-1970': 2.5616414701,
 '1970-1975': 2.3583089602,
 '1975-1980': 2.4985387104,
 '1980-1985': 2.5715500526,
 '1985-1990': 2.6586910375,
 '1990-1995': 2.7285508307,
 '1995-2000': 2.5406751588,
 '2000-2005': 2.5211108367,
 '2005-2010': 2.36530335,
 '2010-2015': 2.3920746528,
 '2015-2020': 2.3142557048,
 '2020-2025': 2.2262656119,
 '2025-2030': 2.1128000294,
 '2030-2035': 1.9955010274,
 '2035-2040': 1.8739083205,
 '2040-2045': 1.7503502289,
 '2045-2050': 1.6262006778},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950-1955': 2.0603216026,
 '1955-1960': 2.0611712141,
 '1960-1965': 2.2700069572,
 '1965-1970': 2.5208116077,
 '1970-1975': 2.3682996506,
 '1975-1980': 2.1088426002,
 '1980-1985': 2.0981978999,
 '1985-1990': 2.0781869089,
 '1990-1995': 1.6783224495,
 '1995-2000': 1.4251911248,
 '2000-2005': 1.298717207,
 '2005-2010': 1.2562205956,
 '2010-2015': 1.1904554631,
 '2015-2020': 1.0507440779,
 '2020-2025': 0.9024619193,
 '2025-2030': 0.7676641104,
 '2030-2035': 0.6521533651,
 '2035-2040': 0.548739825,
 '2040-2045': 0.4553674298,
 '2045-2050': 0.3638537144},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950-1955': 2.0895169401,
 '1955-1960': 2.3460709447,
 '1960-1965': 2.4565474769,
 '1965-1970': 2.4688011952,
 '1970-1975': 2.4433645743,
 '1975-1980': 2.4270420481,
 '1980-1985': 2.431948842,
 '1985-1990': 2.2891121539,
 '1990-1995': 2.0813797759,
 '1995-2000': 1.8989091839,
 '2000-2005': 1.7733249571,
 '2005-2010': 1.6973644737,
 '2010-2015': 1.633993944,
 '2015-2020': 1.5080127328,
 '2020-2025': 1.38431295,
 '2025-2030': 1.2632510418,
 '2030-2035': 1.154792919,
 '2035-2040': 1.0526419619,
 '2040-2045': 0.9563739922,
 '2045-2050': 0.8613590326},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950-1955': 1.2205805645,
 '1955-1960': 1.2549213982,
 '1960-1965': 1.2079567076,
 '1965-1970': 1.0204680284,
 '1970-1975': 0.9540913024,
 '1975-1980': 0.8125509326,
 '1980-1985': 0.7404450493,
 '1985-1990': 0.7144638702,
 '1990-1995': 0.6973353796,
 '1995-2000': 0.6560847948,
 '2000-2005': 0.6720786952,
 '2005-2010': 0.7430581216,
 '2010-2015': 0.5405781807,
 '2015-2020': 0.4642818184,
 '2020-2025': 0.3726783337,
 '2025-2030': 0.3129278849,
 '2030-2035': 0.2390063223,
 '2035-2040': 0.1693606039,
 '2040-2045': 0.1142897936,
 '2045-2050': 0.0748135584},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950-1955': 1.9999435907,
 '1955-1960': 1.9757934962,
 '1960-1965': 2.1535971206,
 '1965-1970': 2.3627946909,
 '1970-1975': 2.2155651484,
 '1975-1980': 2.0105313453,
 '1980-1985': 2.0199550111,
 '1985-1990': 2.0049309207,
 '1990-1995': 1.6107093547,
 '1995-2000': 1.3585609365,
 '2000-2005': 1.2389147725,
 '2005-2010': 1.1872188069,
 '2010-2015': 1.1530384737,
 '2015-2020': 1.0319221879,
 '2020-2025': 0.8990318387,
 '2025-2030': 0.7703547286,
 '2030-2035': 0.6615388112,
 '2035-2040': 0.566208083,
 '2040-2045': 0.4800619678,
 '2045-2050': 0.3941119703},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950-1955': 2.069845497,
 '1955-1960': 1.820998696,
 '1960-1965': 2.0257811836,
 '1965-1970': 2.3820960218,
 '1970-1975': 2.1113017973,
 '1975-1980': 1.6942631076,
 '1980-1985': 1.6664924049,
 '1985-1990': 1.7666354061,
 '1990-1995': 1.2001727232,
 '1995-2000': 0.8820706792,
 '2000-2005': 0.7657583125,
 '2005-2010': 0.7511950717,
 '2010-2015': 0.7795887221,
 '2015-2020': 0.6219710208,
 '2020-2025': 0.4283724353,
 '2025-2030': 0.2862057126,
 '2030-2035': 0.1741316056,
 '2035-2040': 0.0807488496,
 '2040-2045': -0.0011776899,
 '2045-2050': -0.0863788269},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950-1955': 1.9137251708,
 '1955-1960': 2.1658217421,
 '1960-1965': 2.3080650348,
 '1965-1970': 2.339608078,
 '1970-1975': 2.3402337938,
 '1975-1980': 2.3801443452,
 '1980-1985': 2.4184511415,
 '1985-1990': 2.2653176657,
 '1990-1995': 2.0444928922,
 '1995-2000': 1.8398541796,
 '2000-2005': 1.6948207403,
 '2005-2010': 1.5891906301,
 '2010-2015': 1.4842977188,
 '2015-2020': 1.3824804855,
 '2020-2025': 1.2855520844,
 '2025-2030': 1.1511987027,
 '2030-2035': 1.0288122015,
 '2035-2040': 0.9168735928,
 '2040-2045': 0.8136245512,
 '2045-2050': 0.7139757199},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950-1955': 1.6619709016,
 '1955-1960': 2.1082256464,
 '1960-1965': 2.2318348373,
 '1965-1970': 2.4954404206,
 '1970-1975': 2.5095439805,
 '1975-1980': 2.4438894262,
 '1980-1985': 2.3989898643,
 '1985-1990': 2.6280134376,
 '1990-1995': 2.8202181259,
 '1995-2000': 2.6940515438,
 '2000-2005': 2.7764911494,
 '2005-2010': 2.7346313664,
 '2010-2015': 2.7283593235,
 '2015-2020': 2.6318775119,
 '2020-2025': 2.5162388236,
 '2025-2030': 2.39481117,
 '2030-2035': 2.2674799761,
 '2035-2040': 2.1316397614,
 '2040-2045': 1.9913057945,
 '2045-2050': 1.8491749458},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950-1955': 1.9866901321,
 '1955-1960': 2.2038793848,
 '1960-1965': 2.3927549515,
 '1965-1970': 2.5305279078,
 '1970-1975': 2.6643189377,
 '1975-1980': 2.7993501157,
 '1980-1985': 2.8299502987,
 '1985-1990': 2.7990649949,
 '1990-1995': 2.7061425784,
 '1995-2000': 2.6555582694,
 '2000-2005': 2.6645072124,
 '2005-2010': 2.740220111,
 '2010-2015': 2.740171688,
 '2015-2020': 2.6503339159,
 '2020-2025': 2.5371036845,
 '2025-2030': 2.4271883057,
 '2030-2035': 2.3151807098,
 '2035-2040': 2.1913530454,
 '2040-2045': 2.0576974909,
 '2045-2050': 1.9190118373},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950-1955': 2.1006936182,
 '1955-1960': 2.3134528526,
 '1960-1965': 2.4604950377,
 '1965-1970': 2.5574875513,
 '1970-1975': 2.6270221679,
 '1975-1980': 2.7714795662,
 '1980-1985': 2.8235581998,
 '1985-1990': 2.7590699378,
 '1990-1995': 2.607166654,
 '1995-2000': 2.4606071955,
 '2000-2005': 2.4640025511,
 '2005-2010': 2.529724935,
 '2010-2015': 2.5871207802,
 '2015-2020': 2.4885259608,
 '2020-2025': 2.3628898775,
 '2025-2030': 2.2503481825,
 '2030-2035': 2.1482101891,
 '2035-2040': 2.0392706531,
 '2040-2045': 1.9168435816,
 '2045-2050': 1.7865986822},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950-1955': 2.2174455189,
 '1955-1960': 2.4207294382,
 '1960-1965': 2.6265326671,
 '1965-1970': 2.7763740513,
 '1970-1975': 2.8532438136,
 '1975-1980': 2.963240317,
 '1980-1985': 2.968536566,
 '1985-1990': 2.9828193063,
 '1990-1995': 2.5820807349,
 '1995-2000': 2.8865721312,
 '2000-2005': 2.8164565395,
 '2005-2010': 2.8701850241,
 '2010-2015': 2.8163988575,
 '2015-2020': 2.7107267135,
 '2020-2025': 2.5687240906,
 '2025-2030': 2.4301154467,
 '2030-2035': 2.2881737737,
 '2035-2040': 2.1404454673,
 '2040-2045': 1.9936297824,
 '2045-2050': 1.8483410496},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950-1955': 1.8381458944,
 '1955-1960': 1.9191548911,
 '1960-1965': 1.9918965338,
 '1965-1970': 2.3151618222,
 '1970-1975': 1.2120164777,
 '1975-1980': 2.2896325652,
 '1980-1985': 2.6584338928,
 '1985-1990': 2.8249505977,
 '1990-1995': 1.9233241401,
 '1995-2000': 1.4198514659,
 '2000-2005': 2.9642784728,
 '2005-2010': 3.3272893533,
 '2010-2015': 3.0265892203,
 '2015-2020': 3.150264328,
 '2020-2025': 2.9112807278,
 '2025-2030': 2.6908737478,
 '2030-2035': 2.5755492576,
 '2035-2040': 2.513919827,
 '2040-2045': 2.4204029733,
 '2045-2050': 2.2694310748},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950-1955': 1.9629174171,
 '1955-1960': 1.6594805715,
 '1960-1965': 1.637165444,
 '1965-1970': 2.0709811291,
 '1970-1975': 2.2377957884,
 '1975-1980': 3.5868116119,
 '1980-1985': 2.8704440193,
 '1985-1990': 2.9394158328,
 '1990-1995': 2.882130146,
 '1995-2000': 2.635610446,
 '2000-2005': 2.4039632677,
 '2005-2010': 2.4024500308,
 '2010-2015': 2.3948153791,
 '2015-2020': 2.2409719136,
 '2020-2025': 2.0733938308,
 '2025-2030': 1.919862753,
 '2030-2035': 1.7880163811,
 '2035-2040': 1.6661789849,
 '2040-2045': 1.5421649216,
 '2045-2050': 1.4109584125},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950-1955': 2.3091198985,
 '1955-1960': 3.6773508107,
 '1960-1965': 6.3627257611,
 '1965-1970': 6.5685990685,
 '1970-1975': 6.7884478344,
 '1975-1980': 9.4149655812,
 '1980-1985': 3.4063904201,
 '1985-1990': 6.5453280615,
 '1990-1995': 1.3107723417,
 '1995-2000': 2.5910902224,
 '2000-2005': 1.7513404559,
 '2005-2010': 1.6625327996,
 '2010-2015': 1.7163278217,
 '2015-2020': 1.5050841214,
 '2020-2025': 1.3366611238,
 '2025-2030': 1.1576188112,
 '2030-2035': 0.9700093421,
 '2035-2040': 0.7890873238,
 '2040-2045': 0.6274473855,
 '2045-2050': 0.4852934597},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950-1955': 1.7917408558,
 '1955-1960': 2.2436148626,
 '1960-1965': 2.5707808944,
 '1965-1970': 2.6229269152,
 '1970-1975': 2.7212445876,
 '1975-1980': 2.7799881598,
 '1980-1985': 2.8664112021,
 '1985-1990': 2.4588143238,
 '1990-1995': -0.1492848841,
 '1995-2000': 1.8686657605,
 '2000-2005': 3.137202071,
 '2005-2010': 2.0200923056,
 '2010-2015': 1.9766890518,
 '2015-2020': 2.2798429698,
 '2020-2025': 2.1769532438,
 '2025-2030': 2.0709816569,
 '2030-2035': 1.9908728601,
 '2035-2040': 1.8808398656,
 '2040-2045': 1.7274233412,
 '2045-2050': 1.5551264423},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950-1955': 1.9126762988,
 '1955-1960': 2.0960359514,
 '1960-1965': 2.4305104809,
 '1965-1970': 2.5499833639,
 '1970-1975': 2.7274824957,
 '1975-1980': 1.5918813781,
 '1980-1985': 2.9160481994,
 '1985-1990': 3.2862263387,
 '1990-1995': 3.5094245903,
 '1995-2000': 2.9858024778,
 '2000-2005': 2.8498318094,
 '2005-2010': 2.6739518913,
 '2010-2015': 2.5989473132,
 '2015-2020': 2.4270741866,
 '2020-2025': 2.2397164721,
 '2025-2030': 2.0337295844,
 '2030-2035': 1.8349524646,
 '2035-2040': 1.643076164,
 '2040-2045': 1.4707871428,
 '2045-2050': 1.3044826005},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950-1955': 2.7713540252,
 '1955-1960': 2.989928197,
 '1960-1965': 3.185025751,
 '1965-1970': 3.3760577298,
 '1970-1975': 3.6221826991,
 '1975-1980': 3.7512418335,
 '1980-1985': 3.7775767096,
 '1985-1990': 3.4940695208,
 '1990-1995': 3.1148757514,
 '1995-2000': 2.7965479958,
 '2000-2005': 2.7289006453,
 '2005-2010': 2.7443344879,
 '2010-2015': 2.6617139886,
 '2015-2020': 2.4872929753,
 '2020-2025': 2.3174039266,
 '2025-2030': 2.1739735943,
 '2030-2035': 2.0226537941,
 '2035-2040': 1.8551286008,
 '2040-2045': 1.6854762221,
 '2045-2050': 1.5304764118},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950-1955': 2.1347839281,
 '1955-1960': 2.3082141382,
 '1960-1965': 2.4683790349,
 '1965-1970': 2.6187298944,
 '1970-1975': 2.777447063,
 '1975-1980': 2.8575694199,
 '1980-1985': 2.8738131648,
 '1985-1990': 2.8394545299,
 '1990-1995': 2.9995710923,
 '1995-2000': 3.1408208609,
 '2000-2005': 3.0199796184,
 '2005-2010': 2.8562323788,
 '2010-2015': 2.7208558641,
 '2015-2020': 2.6667983754,
 '2020-2025': 2.5777966887,
 '2025-2030': 2.4425860349,
 '2030-2035': 2.2808233796,
 '2035-2040': 2.1270054902,
 '2040-2045': 1.9914917741,
 '2045-2050': 1.8647197135},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950-1955': 1.9251152788,
 '1955-1960': 2.1342710291,
 '1960-1965': 2.2954048789,
 '1965-1970': 2.5201850216,
 '1970-1975': 2.7896718784,
 '1975-1980': 3.0445546939,
 '1980-1985': 3.1409109266,
 '1985-1990': 5.3814906308,
 '1990-1995': 0.975111708,
 '1995-2000': 2.7613735329,
 '2000-2005': 2.7295680236,
 '2005-2010': 3.0225776994,
 '2010-2015': 2.9453979119,
 '2015-2020': 2.8683797978,
 '2020-2025': 2.7531641526,
 '2025-2030': 2.65235455,
 '2030-2035': 2.4951898793,
 '2035-2040': 2.333872518,
 '2040-2045': 2.1724367295,
 '2045-2050': 2.0090603609},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950-1955': 2.9149255104,
 '1955-1960': 2.9100425136,
 '1960-1965': 2.643379187,
 '1965-1970': 1.8536977421,
 '1970-1975': 1.5314824468,
 '1975-1980': 1.5898654621,
 '1980-1985': 1.0039684787,
 '1985-1990': 0.7744821545,
 '1990-1995': 1.3335885779,
 '1995-2000': 0.9764504721,
 '2000-2005': 0.6125237154,
 '2005-2010': 0.4202979173,
 '2010-2015': 0.183473402,
 '2015-2020': 0.2314230678,
 '2020-2025': 0.1432562089,
 '2025-2030': 0.0569759942,
 '2030-2035': -0.0658926864,
 '2035-2040': -0.211624604,
 '2040-2045': -0.3433335611,
 '2045-2050': -0.4305067564},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950-1955': 4.5248579532,
 '1955-1960': 4.7005888287,
 '1960-1965': 4.7980028875,
 '1965-1970': 3.8300188826,
 '1970-1975': 4.1451781229,
 '1975-1980': 3.8496473477,
 '1980-1985': 5.3657704821,
 '1985-1990': 5.4698219478,
 '1990-1995': 5.2410839956,
 '1995-2000': 3.9836942245,
 '2000-2005': 3.3898886187,
 '2005-2010': 3.1730019596,
 '2010-2015': 2.7947638927,
 '2015-2020': 2.5830478246,
 '2020-2025': 2.3731795537,
 '2025-2030': 2.23105297,
 '2030-2035': 2.093017168,
 '2035-2040': 1.9260597607,
 '2040-2045': 1.7402790865,
 '2045-2050': 1.5501849211},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950-1955': 1.7110556318,
 '1955-1960': 1.9516518455,
 '1960-1965': 2.09116153,
 '1965-1970': 2.2100885207,
 '1970-1975': 2.4288153114,
 '1975-1980': 2.7146523259,
 '1980-1985': 1.8312401637,
 '1985-1990': 0.4014216153,
 '1990-1995': 3.4719980809,
 '1995-2000': 2.7341017485,
 '2000-2005': 2.9345456751,
 '2005-2010': 2.927687368,
 '2010-2015': 2.9069902475,
 '2015-2020': 2.8553121182,
 '2020-2025': 2.7740322693,
 '2025-2030': 2.6801454877,
 '2030-2035': 2.5632873285,
 '2035-2040': 2.4186247891,
 '2040-2045': 2.2660162489,
 '2045-2050': 2.1147076711},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950-1955': 3.234193735,
 '1955-1960': 2.8123033771,
 '1960-1965': 3.0386978993,
 '1965-1970': 3.3497411078,
 '1970-1975': 0.9613997843,
 '1975-1980': 0.9855903674,
 '1980-1985': 1.8528471368,
 '1985-1990': 1.7760346814,
 '1990-1995': 1.9627253871,
 '1995-2000': 1.7929091525,
 '2000-2005': 1.4371871911,
 '2005-2010': 0.9599423876,
 '2010-2015': 0.7756884359,
 '2015-2020': 0.7540644006,
 '2020-2025': 0.6994754476,
 '2025-2030': 0.6051964444,
 '2030-2035': 0.4945811652,
 '2035-2040': 0.3587061679,
 '2040-2045': 0.2138757427,
 '2045-2050': 0.0818990952},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950-1955': 2.8858347637,
 '1955-1960': 2.994439024,
 '1960-1965': 1.9443675807,
 '1965-1970': 2.9915191334,
 '1970-1975': 2.9859547613,
 '1975-1980': 3.2985718117,
 '1980-1985': 3.4877442131,
 '1985-1990': 3.3492214227,
 '1990-1995': -3.9868121073,
 '1995-2000': 6.0589844125,
 '2000-2005': 2.273131113,
 '2005-2010': 2.6132747695,
 '2010-2015': 2.5315994032,
 '2015-2020': 2.36166119,
 '2020-2025': 2.1108708146,
 '2025-2030': 1.9385438742,
 '2030-2035': 1.8107441297,
 '2035-2040': 1.6649635018,
 '2040-2045': 1.4793664929,
 '2045-2050': 1.2798730071},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950-1955': 1.3743875375,
 '1955-1960': 1.3086246423,
 '1960-1965': 2.3725582966,
 '1965-1970': 2.2590739189,
 '1970-1975': 2.5849869107,
 '1975-1980': 2.132232412,
 '1980-1985': 1.0410048153,
 '1985-1990': 0.224407879,
 '1990-1995': 1.6514158193,
 '1995-2000': 1.1274159141,
 '2000-2005': 1.7888840739,
 '2005-2010': 0.5908872225,
 '2010-2015': 0.5049229263,
 '2015-2020': 0.4993570046,
 '2020-2025': 0.2691151876,
 '2025-2030': 0.1219915359,
 '2030-2035': 0.0470825844,
 '2035-2040': -0.011403786,
 '2040-2045': -0.0947394909,
 '2045-2050': -0.2218540581},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950-1955': 1.9144717447,
 '1955-1960': 2.0173631239,
 '1960-1965': 2.1481437847,
 '1965-1970': 2.312516627,
 '1970-1975': 2.3824696336,
 '1975-1980': 9.8794664413,
 '1980-1985': 1.3162537542,
 '1985-1990': 1.7083557636,
 '1990-1995': 0.8146857792,
 '1995-2000': 3.1328699543,
 '2000-2005': 2.885209378,
 '2005-2010': 2.9314483013,
 '2010-2015': 2.8628279257,
 '2015-2020': 2.9333419497,
 '2020-2025': 2.9511002143,
 '2025-2030': 2.8596960651,
 '2030-2035': 2.7421434941,
 '2035-2040': 2.6122816928,
 '2040-2045': 2.4848143874,
 '2045-2050': 2.3550234469},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950-1955': 1.0455068,
 '1955-1960': 1.6470144292,
 '1960-1965': 1.9858487263,
 '1965-1970': 2.2251355041,
 '1970-1975': 2.4323489399,
 '1975-1980': 2.6591326908,
 '1980-1985': 2.9404004597,
 '1985-1990': 1.1343076763,
 '1990-1995': -1.1009619398,
 '1995-2000': 4.0968948283,
 '2000-2005': 3.8150791093,
 '2005-2010': 4.3264486453,
 '2010-2015': 3.3150855194,
 '2015-2020': 2.7153847048,
 '2020-2025': 2.4653686798,
 '2025-2030': 2.2798301175,
 '2030-2035': 2.1190703433,
 '2035-2040': 1.9894613171,
 '2040-2045': 1.8622990615,
 '2045-2050': 1.736232002},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950-1955': 2.6833826205,
 '1955-1960': 2.8086599862,
 '1960-1965': 3.321043506,
 '1965-1970': 3.2871619682,
 '1970-1975': 2.729168892,
 '1975-1980': 2.9525484023,
 '1980-1985': 3.090517074,
 '1985-1990': 3.4898775856,
 '1990-1995': 3.2834271385,
 '1995-2000': 3.1362761624,
 '2000-2005': 3.4351148967,
 '2005-2010': 3.4483332316,
 '2010-2015': 3.3726669082,
 '2015-2020': 3.2327733523,
 '2020-2025': 3.09504937,
 '2025-2030': 2.9506224478,
 '2030-2035': 2.7864615024,
 '2035-2040': 2.6072573087,
 '2040-2045': 2.4301741623,
 '2045-2050': 2.2595260863},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950-1955': 2.6669718486,
 '1955-1960': 2.8397035137,
 '1960-1965': 2.963436259,
 '1965-1970': 3.0459253532,
 '1970-1975': 3.2176104393,
 '1975-1980': 3.125312932,
 '1980-1985': 3.1196662041,
 '1985-1990': 3.0697461238,
 '1990-1995': 3.2559204063,
 '1995-2000': 2.6338866314,
 '2000-2005': 2.8490005801,
 '2005-2010': 3.1349793091,
 '2010-2015': 3.1195233586,
 '2015-2020': 3.0558456452,
 '2020-2025': 2.9306025952,
 '2025-2030': 2.8236507956,
 '2030-2035': 2.7128251908,
 '2035-2040': 2.5797801018,
 '2040-2045': 2.4340610177,
 '2045-2050': 2.284962921},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950-1955': 2.6248179504,
 '1955-1960': 2.8954115886,
 '1960-1965': 3.1453356902,
 '1965-1970': 3.1628089837,
 '1970-1975': 3.4704339957,
 '1975-1980': 3.4149200083,
 '1980-1985': 3.3273209502,
 '1985-1990': 2.867021414,
 '1990-1995': 2.5899630795,
 '1995-2000': 2.8400748517,
 '2000-2005': 2.6979858251,
 '2005-2010': 2.7808810042,
 '2010-2015': 3.011362313,
 '2015-2020': 2.9711756492,
 '2020-2025': 2.8998576155,
 '2025-2030': 2.8165518203,
 '2030-2035': 2.692216196,
 '2035-2040': 2.5609024134,
 '2040-2045': 2.4375519396,
 '2045-2050': 2.3164720526},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950-1955': 3.0664954086,
 '1955-1960': 3.1454738922,
 '1960-1965': 3.2573753424,
 '1965-1970': 3.2007198289,
 '1970-1975': 3.336930439,
 '1975-1980': 3.1657443717,
 '1980-1985': 3.7898046975,
 '1985-1990': 3.2429606467,
 '1990-1995': 2.1174175525,
 '1995-2000': 1.5331301064,
 '2000-2005': 1.1413523805,
 '2005-2010': 1.6975627733,
 '2010-2015': 2.267557362,
 '2015-2020': 2.2775717797,
 '2020-2025': 2.0319277942,
 '2025-2030': 1.9048951341,
 '2030-2035': 1.801603293,
 '2035-2040': 1.6845010164,
 '2040-2045': 1.5408615381,
 '2045-2050': 1.3821478992},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950-1955': 1.9572120343,
 '1955-1960': 2.1157476254,
 '1960-1965': 2.2931006257,
 '1965-1970': 2.456792069,
 '1970-1975': 2.5567312987,
 '1975-1980': 2.7497526402,
 '1980-1985': 2.8046995326,
 '1985-1990': 2.9046973784,
 '1990-1995': 3.3162327756,
 '1995-2000': 2.6446171741,
 '2000-2005': 3.0542192976,
 '2005-2010': 3.1957533123,
 '2010-2015': 3.1480882996,
 '2015-2020': 3.0375525624,
 '2020-2025': 2.9074165204,
 '2025-2030': 2.7755410125,
 '2030-2035': 2.6394794213,
 '2035-2040': 2.485737026,
 '2040-2045': 2.316113805,
 '2045-2050': 2.1456336983},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950-1955': 2.3538825721,
 '1955-1960': 1.9612265833,
 '1960-1965': 1.8926631299,
 '1965-1970': 1.7672387264,
 '1970-1975': 2.509981958,
 '1975-1980': 3.0092583017,
 '1980-1985': 3.4460291951,
 '1985-1990': 2.7477129907,
 '1990-1995': 3.179932511,
 '1995-2000': 2.8336932194,
 '2000-2005': 3.4666342225,
 '2005-2010': 3.5662131976,
 '2010-2015': 3.5150211689,
 '2015-2020': 3.281930822,
 '2020-2025': 3.1521254975,
 '2025-2030': 3.0275678224,
 '2030-2035': 2.8905941668,
 '2035-2040': 2.7394199734,
 '2040-2045': 2.5776688179,
 '2045-2050': 2.4141348081},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950-1955': 1.7643205532,
 '1955-1960': 1.9124318322,
 '1960-1965': 2.1988907735,
 '1965-1970': 2.4403166228,
 '1970-1975': 2.6631405853,
 '1975-1980': 2.8938476558,
 '1980-1985': 3.0736161579,
 '1985-1990': 3.066275147,
 '1990-1995': 2.7781497904,
 '1995-2000': 2.5274237314,
 '2000-2005': 2.6299450216,
 '2005-2010': 2.7318265344,
 '2010-2015': 2.6803515868,
 '2015-2020': 2.5642684395,
 '2020-2025': 2.448671647,
 '2025-2030': 2.3394000937,
 '2030-2035': 2.237547055,
 '2035-2040': 2.1262466094,
 '2040-2045': 2.0070571814,
 '2045-2050': 1.8786210984},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950-1955': 1.0689453122,
 '1955-1960': 1.433906069,
 '1960-1965': 1.845334412,
 '1965-1970': 2.0708497693,
 '1970-1975': 1.9637084175,
 '1975-1980': 2.4460251364,
 '1980-1985': 2.8898949459,
 '1985-1990': 2.1948614042,
 '1990-1995': 2.6290245288,
 '1995-2000': 2.2659716357,
 '2000-2005': 1.8937333754,
 '2005-2010': 1.4960270989,
 '2010-2015': 0.4339428398,
 '2015-2020': 1.5843896538,
 '2020-2025': 2.1847587433,
 '2025-2030': 2.1885093202,
 '2030-2035': 2.0881016851,
 '2035-2040': 1.9173705962,
 '2040-2045': 1.7505401756,
 '2045-2050': 1.6110471894},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950-1955': 1.7798076302,
 '1955-1960': 1.8587132713,
 '1960-1965': 1.9535206062,
 '1965-1970': 1.922780572,
 '1970-1975': 2.3016985204,
 '1975-1980': 1.9741338,
 '1980-1985': 2.4165906829,
 '1985-1990': 3.1392794385,
 '1990-1995': 3.2293991572,
 '1995-2000': 3.5071343449,
 '2000-2005': 3.7578727584,
 '2005-2010': 3.323974349,
 '2010-2015': 3.2853420324,
 '2015-2020': 3.0104137732,
 '2020-2025': 2.8461228184,
 '2025-2030': 2.6726544531,
 '2030-2035': 2.4999877648,
 '2035-2040': 2.3294574525,
 '2040-2045': 2.1614343737,
 '2045-2050': 1.9971566936},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950-1955': 2.1300246809,
 '1955-1960': 2.3937747534,
 '1960-1965': 2.6524267113,
 '1965-1970': 2.8370259494,
 '1970-1975': 3.0548370804,
 '1975-1980': 2.9194340135,
 '1980-1985': 2.9068847604,
 '1985-1990': 2.7422166784,
 '1990-1995': 2.74335987,
 '1995-2000': 2.836100817,
 '2000-2005': 2.8418578737,
 '2005-2010': 3.3064879074,
 '2010-2015': 2.5998298633,
 '2015-2020': 2.5920228022,
 '2020-2025': 2.5348906753,
 '2025-2030': 2.5109091988,
 '2030-2035': 2.4600717981,
 '2035-2040': 2.3495970974,
 '2040-2045': 2.1960109601,
 '2045-2050': 2.048872816},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950-1955': 2.0778095263,
 '1955-1960': 2.4095740792,
 '1960-1965': 2.6054607305,
 '1965-1970': 2.8298211147,
 '1970-1975': 2.7001854319,
 '1975-1980': 2.8102650189,
 '1980-1985': 2.5110651768,
 '1985-1990': 2.9394065577,
 '1990-1995': 3.6744568973,
 '1995-2000': 2.4754736678,
 '2000-2005': 3.0206557901,
 '2005-2010': 3.2844299641,
 '2010-2015': 3.3258253237,
 '2015-2020': 3.2195928739,
 '2020-2025': 3.044253364,
 '2025-2030': 2.8933347039,
 '2030-2035': 2.7437572918,
 '2035-2040': 2.5721530639,
 '2040-2045': 2.3791389986,
 '2045-2050': 2.1864961414},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950-1955': 1.1909426926,
 '1955-1960': 1.2899610069,
 '1960-1965': 1.6583335577,
 '1965-1970': 1.9964121131,
 '1970-1975': -3.3111722695,
 '1975-1980': -0.3434167376,
 '1980-1985': 6.8099081892,
 '1985-1990': 3.4678127903,
 '1990-1995': 3.3575931732,
 '1995-2000': 3.9243579472,
 '2000-2005': 4.1852215116,
 '2005-2010': 4.5568298219,
 '2010-2015': 4.2346204096,
 '2015-2020': 3.5869752688,
 '2020-2025': 3.0337288289,
 '2025-2030': 2.6791252607,
 '2030-2035': 2.3519123615,
 '2035-2040': 2.1936340339,
 '2040-2045': 2.0070995721,
 '2045-2050': 1.8250031635},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950-1955': 0.3876010825,
 '1955-1960': 0.6773899976,
 '1960-1965': 1.2925757878,
 '1965-1970': 2.0543792451,
 '1970-1975': 1.9242565486,
 '1975-1980': 2.3071294178,
 '1980-1985': 2.5927257993,
 '1985-1990': 2.7451918778,
 '1990-1995': 2.6318988895,
 '1995-2000': 2.5059716828,
 '2000-2005': 2.6155331187,
 '2005-2010': 3.1224335555,
 '2010-2015': 3.2557277992,
 '2015-2020': 2.1691304999,
 '2020-2025': 1.9460477913,
 '2025-2030': 1.7928825193,
 '2030-2035': 1.6801931165,
 '2035-2040': 1.5837562721,
 '2040-2045': 1.4761158164,
 '2045-2050': 1.346942165},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950-1955': -0.4105039509,
 '1955-1960': 1.7795143567,
 '1960-1965': 0.1683091553,
 '1965-1970': 2.724686157,
 '1970-1975': 2.1323248358,
 '1975-1980': 2.7849096529,
 '1980-1985': 1.7505111194,
 '1985-1990': 1.8878789967,
 '1990-1995': 2.0923838905,
 '1995-2000': 1.8351354038,
 '2000-2005': 2.3169203871,
 '2005-2010': 2.3204751761,
 '2010-2015': 2.2465257681,
 '2015-2020': 2.1742815561,
 '2020-2025': 2.1111363352,
 '2025-2030': 2.0528112735,
 '2030-2035': 1.9431397723,
 '2035-2040': 1.8053877519,
 '2040-2045': 1.6636690174,
 '2045-2050': 1.5231556083}]},
'Total Population - Both Sexes': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950',
'1951',
'1952'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950': 2536431.018,
 '1951': 2584034.227,
 '1952': 2630861.69},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 814818.913,
 '1951': 824003.512,
 '1952': 833720.173},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 1721612.105,
 '1951': 1760030.715,
 '1952': 1797141.517},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 195427.785,
 '1951': 199180.385,
 '1952': 203015.198},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 1526184.32,
 '1951': 1560850.33,
 '1952': 1594126.319},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 1157420.006,
 '1951': 1179932.723,
 '1952': 1203962.856},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 103803.462,
 '1951': 105870.275,
 '1952': 108079.453},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 23771.12,
 '1951': 24209.068,
 '1952': 24684.57},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'}]},
'Total Population - Female': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950',
'1951',
'1952'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950': 1270171.462,
 '1951': 1293796.589,
 '1952': 1317007.125},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 426444.709,
 '1951': 430968.91,
 '1952': 435736.259},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 843726.753,
 '1951': 862827.679,
 '1952': 881270.866},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 97613.14,
 '1951': 99536.724,
 '1952': 101495.846},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 746113.613,
 '1951': 763290.955,
 '1952': 779775.02},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 572297.224,
 '1951': 583533.468,
 '1952': 595475.056},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 52511.165,
 '1951': 53583.904,
 '1952': 54724.909},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 11754.757,
 '1951': 11975.29,
 '1952': 12216.047},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'}]},
'Total Population - Male': {'headers': ['Index',
'Variant',
'Region, subregion, country or area *',
'Notes',
'Country code',
'Type',
'Parent code',
'1950',
'1951',
'1952'],
'data': [{'Index': 1,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'WORLD',
 'Notes': '',
 'Country code': 900,
 'Type': 'World',
 'Parent code': 0,
 '1950': 1266259.556,
 '1951': 1290237.638,
 '1952': 1313854.565},
{'Index': 2,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'UN development groups',
 'Notes': 'a',
 'Country code': 1803,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'},
{'Index': 3,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'More developed regions',
 'Notes': 'b',
 'Country code': 901,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 388374.204,
 '1951': 393034.602,
 '1952': 397983.914},
{'Index': 4,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions',
 'Notes': 'c',
 'Country code': 902,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 877885.352,
 '1951': 897203.036,
 '1952': 915870.651},
{'Index': 5,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Least developed countries',
 'Notes': 'd',
 'Country code': 941,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 97814.645,
 '1951': 99643.661,
 '1952': 101519.352},
{'Index': 6,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding least developed countries',
 'Notes': 'e',
 'Country code': 934,
 'Type': 'Development Group',
 'Parent code': 902,
 '1950': 780070.707,
 '1951': 797559.375,
 '1952': 814351.299},
{'Index': 7,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Less developed regions, excluding China',
 'Notes': '',
 'Country code': 948,
 'Type': 'Development Group',
 'Parent code': 1803,
 '1950': 585122.781999999,
 '1951': 596399.255,
 '1952': 608487.8},
{'Index': 8,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Land-locked Developing Countries (LLDC)',
 'Notes': 'f',
 'Country code': 1636,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 51292.297,
 '1951': 52286.371,
 '1952': 53354.544},
{'Index': 9,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'Small Island Developing States (SIDS)',
 'Notes': 'g',
 'Country code': 1637,
 'Type': 'Special other',
 'Parent code': 1803,
 '1950': 12016.363,
 '1951': 12233.778,
 '1952': 12468.523},
{'Index': 10,
 'Variant': 'Estimates',
 'Region, subregion, country or area *': 'World Bank income groups',
 'Notes': '',
 'Country code': 1802,
 'Type': 'Label/Separator',
 'Parent code': 900,
 '1950': '...',
 '1951': '...',
 '1952': '...'}]},
'Total Population Annual': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
2020,
2021,
2022,
2023,
2024,
2025,
2026,
2027,
2028,
2029,
2030,
2031,
2032,
2033,
2034,
2035,
2036,
2037,
2038,
2039,
2040,
2041,
2042,
2043,
2044,
2045,
2046,
2047,
2048,
2049,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '2020': 7795482.3089999985,
 '2021': 7875464.634,
 '2022': 7954468.981999999,
 '2023': 8032487.474999999,
 '2024': 8109532.823000002,
 '2025': 8185613.757000002,
 '2026': 8260710.124,
 '2027': 8334801.642999999,
 '2028': 8407900.352000004,
 '2029': 8480027.356000002,
 '2030': 8551198.644,
 '2031': 8621415.775,
 '2032': 8690673.506,
 '2033': 8758973.113999998,
 '2034': 8826315.616000004,
 '2035': 8892701.94,
 '2036': 8958126.691000002,
 '2037': 9022590.075,
 '2038': 9086103.797,
 '2039': 9148683.648999998,
 '2040': 9210337.004000004,
 '2041': 9271063.272999996,
 '2042': 9330845.890000002,
 '2043': 9389655.928999996,
 '2044': 9447454.648999996,
 '2045': 9504209.572,
 '2046': 9559909.195000004,
 '2047': 9614545.440000003,
 '2048': 9668093.432,
 '2049': 9720525.978999998,
 '2050': 9771822.752999999},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '2020': 1269276.8460000001,
 '2021': 1272012.8169999998,
 '2022': 1274562.777,
 '2023': 1276943.1770000001,
 '2024': 1279181.0,
 '2025': 1281295.8399999999,
 '2026': 1283293.654,
 '2027': 1285167.279,
 '2028': 1286907.4109999998,
 '2029': 1288500.032,
 '2030': 1289936.5529999998,
 '2031': 1291216.8979999998,
 '2032': 1292350.314,
 '2033': 1293348.3429999999,
 '2034': 1294226.9109999998,
 '2035': 1294999.5639999998,
 '2036': 1295672.4220000003,
 '2037': 1296249.509,
 '2038': 1296739.679,
 '2039': 1297152.387,
 '2040': 1297495.7139999997,
 '2041': 1297774.8399999996,
 '2042': 1297994.139,
 '2043': 1298159.433,
 '2044': 1298276.3820000002,
 '2045': 1298349.0439999998,
 '2046': 1298382.2019999998,
 '2047': 1298376.623,
 '2048': 1298327.412,
 '2049': 1298226.5620000002,
 '2050': 1298068.585},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '2020': 6526205.462999999,
 '2021': 6603451.817,
 '2022': 6679906.204999999,
 '2023': 6755544.297999999,
 '2024': 6830351.823000002,
 '2025': 6904317.917000002,
 '2026': 6977416.47,
 '2027': 7049634.363999999,
 '2028': 7120992.941000004,
 '2029': 7191527.324000002,
 '2030': 7261262.090999999,
 '2031': 7330198.877,
 '2032': 7398323.191999999,
 '2033': 7465624.770999998,
 '2034': 7532088.705000004,
 '2035': 7597702.375999999,
 '2036': 7662454.269000001,
 '2037': 7726340.565999999,
 '2038': 7789364.118000001,
 '2039': 7851531.261999998,
 '2040': 7912841.290000006,
 '2041': 7973288.432999997,
 '2042': 8032851.751000002,
 '2043': 8091496.495999997,
 '2044': 8149178.266999997,
 '2045': 8205860.528,
 '2046': 8261526.993000004,
 '2047': 8316168.817000003,
 '2048': 8369766.02,
 '2049': 8422299.416999998,
 '2050': 8473754.167999998},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '2020': 1073984.2769999998,
 '2021': 1098590.7319999998,
 '2022': 1123562.7339999997,
 '2023': 1148879.1480000003,
 '2024': 1174512.5539999998,
 '2025': 1200440.5770000005,
 '2026': 1226649.541,
 '2027': 1253133.575,
 '2028': 1279887.684,
 '2029': 1306909.8719999995,
 '2030': 1334195.6999999997,
 '2031': 1361735.455,
 '2032': 1389516.137,
 '2033': 1417526.0030000003,
 '2034': 1445752.2929999996,
 '2035': 1474182.6339999998,
 '2036': 1502805.358,
 '2037': 1531609.1750000005,
 '2038': 1560581.908,
 '2039': 1589711.2009999997,
 '2040': 1618984.5080000001,
 '2041': 1648390.5969999996,
 '2042': 1677916.8569999994,
 '2043': 1707547.9109999994,
 '2044': 1737266.9440000006,
 '2045': 1767059.0609999998,
 '2046': 1796910.6929999997,
 '2047': 1826811.7000000002,
 '2048': 1856754.4839999995,
 '2049': 1886733.5199999996,
 '2050': 1916741.5810000005},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '2020': 5452221.186,
 '2021': 5504861.084999998,
 '2022': 5556343.470999999,
 '2023': 5606665.149999996,
 '2024': 5655839.268999999,
 '2025': 5703877.339999999,
 '2026': 5750766.929000003,
 '2027': 5796500.788999998,
 '2028': 5841105.257000004,
 '2029': 5884617.452000001,
 '2030': 5927066.391,
 '2031': 5968463.421999999,
 '2032': 6008807.055000001,
 '2033': 6048098.767999999,
 '2034': 6086336.412000003,
 '2035': 6123519.741999997,
 '2036': 6159648.911000001,
 '2037': 6194731.391000001,
 '2038': 6228782.210000001,
 '2039': 6261820.060999997,
 '2040': 6293856.782000003,
 '2041': 6324897.8359999955,
 '2042': 6354934.893999999,
 '2043': 6383948.585,
 '2044': 6411911.323000001,
 '2045': 6438801.467000002,
 '2046': 6464616.300000002,
 '2047': 6489357.1170000015,
 '2048': 6513011.5359999975,
 '2049': 6535565.897,
 '2050': 6557012.586999998},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '2020': 5069639.764999999,
 '2021': 5142838.576,
 '2022': 5215818.712999999,
 '2023': 5288533.445999999,
 '2024': 5360930.250000002,
 '2025': 5432967.091,
 '2026': 5504610.138000002,
 '2027': 5575845.982000001,
 '2028': 5646679.391000003,
 '2029': 5717127.011000001,
 '2030': 5787196.413000002,
 '2031': 5856875.962999997,
 '2032': 5926139.509,
 '2033': 5994963.359999997,
 '2034': 6063319.409000002,
 '2035': 6131182.335999997,
 '2036': 6198530.537000004,
 '2037': 6265349.187999999,
 '2038': 6331627.093000001,
 '2039': 6397355.771,
 '2040': 6462522.403000004,
 '2041': 6527110.246999994,
 '2042': 6591093.224999998,
 '2043': 6654437.857000001,
 '2044': 6717104.820999996,
 '2045': 6779059.706999999,
 '2046': 6840278.198000001,
 '2047': 6900741.972000003,
 '2048': 6960429.596000001,
 '2049': 7019321.437,
 '2050': 7077398.223999999},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '2020': 1207775.438,
 '2021': 1212691.461,
 '2022': 1217383.6490000002,
 '2023': 1221885.0580000007,
 '2024': 1226243.3019999997,
 '2025': 1230492.0170000002,
 '2026': 1234642.8729999994,
 '2027': 1238683.3539999998,
 '2028': 1242592.3659999997,
 '2029': 1246337.8130000003,
 '2030': 1249896.1870000004,
 '2031': 1253263.841,
 '2032': 1256448.2680000002,
 '2033': 1259450.3619999997,
 '2034': 1262273.728,
 '2035': 1264922.4470000002,
 '2036': 1267397.6830000002,
 '2037': 1269702.2360000003,
 '2038': 1271844.054,
 '2039': 1273833.353,
 '2040': 1275679.329,
 '2041': 1277386.6559999997,
 '2042': 1278960.4,
 '2043': 1280411.217,
 '2044': 1281751.2200000002,
 '2045': 1282990.054,
 '2046': 1284135.4819999998,
 '2047': 1285190.3669999999,
 '2048': 1286154.31,
 '2049': 1287024.0140000002,
 '2050': 1287798.294},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '2020': 5852576.168,
 '2021': 5908592.6219999995,
 '2022': 5963545.543999999,
 '2023': 6017395.536999999,
 '2024': 6070108.456000001,
 '2025': 6121661.379000001,
 '2026': 6172027.489999998,
 '2027': 6221205.282,
 '2028': 6269232.43,
 '2029': 6316166.865999997,
 '2030': 6362053.886,
 '2031': 6406905.254,
 '2032': 6450716.669,
 '2033': 6493498.728000001,
 '2034': 6535260.566,
 '2035': 6576010.166999999,
 '2036': 6615750.953999998,
 '2037': 6654489.743999999,
 '2038': 6692241.025,
 '2039': 6729021.316,
 '2040': 6764839.984999999,
 '2041': 6799701.8429999985,
 '2042': 6833596.523999999,
 '2043': 6866497.698000002,
 '2044': 6898369.077000001,
 '2045': 6929181.567999998,
 '2046': 6958928.067000001,
 '2047': 6987607.3719999995,
 '2048': 7015202.952,
 '2049': 7041697.383000001,
 '2050': 7067079.456},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '2020': 2670122.0229999996,
 '2021': 2683562.154,
 '2022': 2695962.4229999995,
 '2023': 2707408.5970000005,
 '2024': 2718030.192000001,
 '2025': 2727929.2220000005,
 '2026': 2737136.543999999,
 '2027': 2745647.7299999995,
 '2028': 2753489.1,
 '2029': 2760681.9099999988,
 '2030': 2767247.3240000005,
 '2031': 2773210.1419999995,
 '2032': 2778594.588,
 '2033': 2783418.4700000007,
 '2034': 2787697.295000001,
 '2035': 2791445.775,
 '2036': 2794676.3939999994,
 '2037': 2797403.5479999995,
 '2038': 2799644.930000001,
 '2039': 2801418.871999999,
 '2040': 2802738.8590000006,
 '2041': 2803615.8159999987,
 '2042': 2804050.6149999998,
 '2043': 2804032.671000001,
 '2044': 2803544.6990000005,
 '2045': 2802573.825999999,
 '2046': 2801123.4290000014,
 '2047': 2799198.9319999996,
 '2048': 2796792.151,
 '2049': 2793892.5270000002,
 '2050': 2790495.775000001},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '2020': 3182454.145,
 '2021': 3225030.468,
 '2022': 3267583.1209999993,
 '2023': 3309986.9399999985,
 '2024': 3352078.264,
 '2025': 3393732.1569999997,
 '2026': 3434890.945999999,
 '2027': 3475557.5519999997,
 '2028': 3515743.3299999996,
 '2029': 3555484.9559999984,
 '2030': 3594806.5619999995,
 '2031': 3633695.112,
 '2032': 3672122.0810000002,
 '2033': 3710080.2580000004,
 '2034': 3747563.2709999993,
 '2035': 3784564.392,
 '2036': 3821074.559999999,
 '2037': 3857086.196,
 '2038': 3892596.0949999997,
 '2039': 3927602.444000001,
 '2040': 3962101.125999999,
 '2041': 3996086.0270000002,
 '2042': 4029545.9089999995,
 '2043': 4062465.0270000007,
 '2044': 4094824.3780000005,
 '2045': 4126607.741999999,
 '2046': 4157804.6379999993,
 '2047': 4188408.4399999995,
 '2048': 4218410.801,
 '2049': 4247804.856000002,
 '2050': 4276583.681},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '2020': 732132.7999999999,
 '2021': 751147.588,
 '2022': 770472.075,
 '2023': 790104.6420000001,
 '2024': 810044.2969999999,
 '2025': 830289.022,
 '2026': 850833.773,
 '2027': 871672.4689999999,
 '2028': 892800.5819999999,
 '2029': 914213.4709999999,
 '2030': 935905.4139999998,
 '2031': 957869.7960000001,
 '2032': 980098.336,
 '2033': 1002580.8220000002,
 '2034': 1025305.5929999999,
 '2035': 1048261.5629999998,
 '2036': 1071438.8079999997,
 '2037': 1094827.9479999999,
 '2038': 1118418.2869999998,
 '2039': 1142198.8969999999,
 '2040': 1166158.631,
 '2041': 1190287.4209999999,
 '2042': 1214574.0379999997,
 '2043': 1239005.19,
 '2044': 1263566.348,
 '2045': 1288244.4700000002,
 '2046': 1313027.345,
 '2047': 1337905.256,
 '2048': 1362870.257,
 '2049': 1387915.7980000002,
 '2050': 1413033.9960000003},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '2020': 1106572.8809999998,
 '2021': 1135527.1509999998,
 '2022': 1164963.7009999997,
 '2023': 1194888.529,
 '2024': 1225311.6519999998,
 '2025': 1256239.7440000002,
 '2026': 1287669.1779999998,
 '2027': 1319593.4489999998,
 '2028': 1352012.591,
 '2029': 1384926.7360000003,
 '2030': 1418333.1500000001,
 '2031': 1452225.7140000002,
 '2032': 1486593.828,
 '2033': 1521423.307,
 '2034': 1556697.1219999995,
 '2035': 1592398.515,
 '2036': 1628513.8149999997,
 '2037': 1665029.4309999999,
 '2038': 1701927.1730000002,
 '2039': 1739187.486,
 '2040': 1776791.1840000001,
 '2041': 1814721.903,
 '2042': 1852962.5769999993,
 '2043': 1891492.3229999996,
 '2044': 1930288.654,
 '2045': 1969331.0299999993,
 '2046': 2008600.249,
 '2047': 2048080.3090000001,
 '2048': 2087757.3289999992,
 '2049': 2127619.105,
 '2050': 2167651.879},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '2020': 1352622.189,
 '2021': 1385654.615,
 '2022': 1419122.3960000002,
 '2023': 1453034.2709999997,
 '2024': 1487406.129,
 '2025': 1522250.0929999999,
 '2026': 1557562.575,
 '2027': 1593338.261,
 '2028': 1629585.987,
 '2029': 1666317.064,
 '2030': 1703537.5039999997,
 '2031': 1741243.659,
 '2032': 1779425.239,
 '2033': 1818071.7289999998,
 '2034': 1857169.6029999997,
 '2035': 1896703.697,
 '2036': 1936661.446,
 '2037': 1977026.733,
 '2038': 2017774.3730000001,
 '2039': 2058875.145,
 '2040': 2100301.731,
 '2041': 2142034.0319999997,
 '2042': 2184052.732,
 '2043': 2226331.727,
 '2044': 2268843.05,
 '2045': 2311561.3260000004,
 '2046': 2354463.8220000006,
 '2047': 2397531.5439999998,
 '2048': 2440746.9390000002,
 '2049': 2484094.2,
 '2050': 2527556.761},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '2020': 457439.6800000001,
 '2021': 469613.839,
 '2022': 481967.931,
 '2023': 494503.3589999999,
 '2024': 507223.871,
 '2025': 520131.276,
 '2026': 533222.585,
 '2027': 546492.095,
 '2028': 559936.157,
 '2029': 573550.3599999999,
 '2030': 587330.0959999999,
 '2031': 601271.135,
 '2032': 615368.353,
 '2033': 629614.3799999999,
 '2034': 644001.0089999998,
 '2035': 658520.5279999999,
 '2036': 673166.5100000001,
 '2037': 687933.5499999998,
 '2038': 702816.126,
 '2039': 717808.9220000001,
 '2040': 732906.3770000001,
 '2041': 748102.4249999999,
 '2042': 763390.1709999999,
 '2043': 778762.3609999999,
 '2044': 794211.036,
 '2045': 809728.8650000001,
 '2046': 825308.7000000002,
 '2047': 840944.27,
 '2048': 856629.804,
 '2049': 872359.8680000001,
 '2050': 888128.5620000002},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '2020': 11939.227,
 '2021': 12305.457,
 '2022': 12675.47,
 '2023': 13049.303,
 '2024': 13427.343,
 '2025': 13810.006,
 '2026': 14197.139,
 '2027': 14588.733,
 '2028': 14985.535,
 '2029': 15388.616,
 '2030': 15798.849,
 '2031': 16216.487,
 '2032': 16641.716,
 '2033': 17075.25,
 '2034': 17517.888,
 '2035': 17970.195,
 '2036': 18432.401,
 '2037': 18904.397,
 '2038': 19386.058,
 '2039': 19877.068,
 '2040': 20377.076,
 '2041': 20885.948,
 '2042': 21403.341,
 '2043': 21928.513,
 '2044': 22460.525,
 '2045': 22998.539,
 '2046': 23542.141,
 '2047': 24090.95,
 '2048': 24644.319,
 '2049': 25201.545,
 '2050': 25762.044},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '2020': 869.601,
 '2021': 888.407,
 '2022': 907.306,
 '2023': 926.312,
 '2024': 945.406,
 '2025': 964.591,
 '2026': 983.86,
 '2027': 1003.211,
 '2028': 1022.641,
 '2029': 1042.164,
 '2030': 1061.775,
 '2031': 1081.47,
 '2032': 1101.26,
 '2033': 1121.119,
 '2034': 1141.054,
 '2035': 1161.071,
 '2036': 1181.144,
 '2037': 1201.284,
 '2038': 1221.477,
 '2039': 1241.703,
 '2040': 1261.942,
 '2041': 1282.209,
 '2042': 1302.467,
 '2043': 1322.72,
 '2044': 1342.933,
 '2045': 1363.098,
 '2046': 1383.2,
 '2047': 1403.227,
 '2048': 1423.17,
 '2049': 1443.013,
 '2050': 1462.735},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '2020': 999.899,
 '2021': 1014.025,
 '2022': 1028.031,
 '2023': 1041.88,
 '2024': 1055.552,
 '2025': 1069.009,
 '2026': 1082.248,
 '2027': 1095.262,
 '2028': 1108.021,
 '2029': 1120.511,
 '2030': 1132.71,
 '2031': 1144.609,
 '2032': 1156.203,
 '2033': 1167.462,
 '2034': 1178.401,
 '2035': 1189.001,
 '2036': 1199.256,
 '2037': 1209.17,
 '2038': 1218.739,
 '2039': 1227.967,
 '2040': 1236.85,
 '2041': 1245.401,
 '2042': 1253.614,
 '2043': 1261.491,
 '2044': 1269.036,
 '2045': 1276.268,
 '2046': 1283.179,
 '2047': 1289.766,
 '2048': 1296.038,
 '2049': 1301.978,
 '2050': 1307.615},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '2020': 5432.216,
 '2021': 5555.141,
 '2022': 5678.798,
 '2023': 5803.376,
 '2024': 5929.298,
 '2025': 6056.88,
 '2026': 6186.016,
 '2027': 6316.482,
 '2028': 6448.451,
 '2029': 6582.129,
 '2030': 6717.687,
 '2031': 6855.107,
 '2032': 6994.25,
 '2033': 7135.034,
 '2034': 7277.273,
 '2035': 7420.805,
 '2036': 7565.543,
 '2037': 7711.344,
 '2038': 7857.969,
 '2039': 8005.125,
 '2040': 8152.54,
 '2041': 8300.073,
 '2042': 8447.599,
 '2043': 8594.901,
 '2044': 8741.756,
 '2045': 8887.988,
 '2046': 9033.461,
 '2047': 9178.086,
 '2048': 9321.828,
 '2049': 9464.689,
 '2050': 9606.664},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '2020': 112759.07,
 '2021': 115403.326,
 '2022': 118065.225,
 '2023': 120741.324,
 '2024': 123427.617,
 '2025': 126120.682,
 '2026': 128817.98,
 '2027': 131517.867,
 '2028': 134218.92,
 '2029': 136920.107,
 '2030': 139620.178,
 '2031': 142317.586,
 '2032': 145010.282,
 '2033': 147695.897,
 '2034': 150371.875,
 '2035': 153036.024,
 '2036': 155686.416,
 '2037': 158322.006,
 '2038': 160942.553,
 '2039': 163548.404,
 '2040': 166139.393,
 '2041': 168714.421,
 '2042': 171271.652,
 '2043': 173809.294,
 '2044': 176325.273,
 '2045': 178817.639,
 '2046': 181284.897,
 '2047': 183725.643,
 '2048': 186137.98,
 '2049': 188519.926,
 '2050': 190869.632},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '2020': 53491.697,
 '2021': 54780.852,
 '2022': 56081.772,
 '2023': 57395.145,
 '2024': 58722.068,
 '2025': 60063.158,
 '2026': 61418.176,
 '2027': 62786.272,
 '2028': 64166.647,
 '2029': 65558.242,
 '2030': 66959.993,
 '2031': 68371.214,
 '2032': 69791.017,
 '2033': 71217.897,
 '2034': 72650.119,
 '2035': 74086.106,
 '2036': 75524.882,
 '2037': 76965.577,
 '2038': 78406.959,
 '2039': 79847.748,
 '2040': 81286.865,
 '2041': 82723.272,
 '2042': 84156.324,
 '2043': 85585.822,
 '2044': 87011.808,
 '2045': 88434.154,
 '2046': 89852.235,
 '2047': 91265.247,
 '2048': 92672.52,
 '2049': 94073.394,
 '2050': 95467.137},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '2020': 27690.798,
 '2021': 28426.106,
 '2022': 29175.412,
 '2023': 29938.052,
 '2024': 30713.196,
 '2025': 31500.077,
 '2026': 32298.311,
 '2027': 33107.434,
 '2028': 33926.654,
 '2029': 34755.062,
 '2030': 35591.943,
 '2031': 36436.782,
 '2032': 37289.343,
 '2033': 38149.373,
 '2034': 39016.761,
 '2035': 39891.388,
 '2036': 40772.971,
 '2037': 41661.283,
 '2038': 42556.397,
 '2039': 43458.494,
 '2040': 44367.656,
 '2041': 45283.723,
 '2042': 46206.441,
 '2043': 47135.665,
 '2044': 48071.248,
 '2045': 49012.988,
 '2046': 49960.619,
 '2047': 50913.785,
 '2048': 51872.127,
 '2049': 52835.205,
 '2050': 53802.574},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '2020': 20283.691,
 '2021': 20859.191,
 '2022': 21445.468,
 '2023': 22043.258,
 '2024': 22653.625,
 '2025': 23277.224,
 '2026': 23914.217,
 '2027': 24564.021,
 '2028': 25225.545,
 '2029': 25897.347,
 '2030': 26578.247,
 '2031': 27267.73,
 '2032': 27965.73,
 '2033': 28672.108,
 '2034': 29386.842,
 '2035': 30109.857,
 '2036': 30840.793,
 '2037': 31579.218,
 '2038': 32324.869,
 '2039': 33077.454,
 '2040': 33836.707,
 '2041': 34602.3,
 '2042': 35373.855,
 '2043': 36150.88,
 '2044': 36932.805,
 '2045': 37719.155,
 '2046': 38509.466,
 '2047': 39303.412,
 '2048': 40100.768,
 '2049': 40901.375,
 '2050': 41705.002},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '2020': 1274.114,
 '2021': 1276.475,
 '2022': 1278.528,
 '2023': 1280.313,
 '2024': 1281.882,
 '2025': 1283.273,
 '2026': 1284.502,
 '2027': 1285.507,
 '2028': 1286.275,
 '2029': 1286.76,
 '2030': 1286.934,
 '2031': 1286.778,
 '2032': 1286.302,
 '2033': 1285.475,
 '2034': 1284.273,
 '2035': 1282.701,
 '2036': 1280.74,
 '2037': 1278.396,
 '2038': 1275.684,
 '2039': 1272.612,
 '2040': 1269.2,
 '2041': 1265.448,
 '2042': 1261.389,
 '2043': 1257.038,
 '2044': 1252.432,
 '2045': 1247.598,
 '2046': 1242.572,
 '2047': 1237.352,
 '2048': 1231.995,
 '2049': 1226.541,
 '2050': 1221.03},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '2020': 273.11,
 '2021': 279.874,
 '2022': 286.689,
 '2023': 293.554,
 '2024': 300.493,
 '2025': 307.518,
 '2026': 314.623,
 '2027': 321.799,
 '2028': 329.066,
 '2029': 336.396,
 '2030': 343.809,
 '2031': 351.278,
 '2032': 358.821,
 '2033': 366.418,
 '2034': 374.06,
 '2035': 381.739,
 '2036': 389.43,
 '2037': 397.148,
 '2038': 404.876,
 '2039': 412.607,
 '2040': 420.33,
 '2041': 428.032,
 '2042': 435.713,
 '2043': 443.368,
 '2044': 450.985,
 '2045': 458.543,
 '2046': 466.059,
 '2047': 473.509,
 '2048': 480.897,
 '2049': 488.235,
 '2050': 495.498},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '2020': 32309.195,
 '2021': 33229.664,
 '2022': 34170.326,
 '2023': 35131.42,
 '2024': 36113.311,
 '2025': 37116.198,
 '2026': 38139.962,
 '2027': 39184.31,
 '2028': 40249.062,
 '2029': 41333.97,
 '2030': 42438.703,
 '2031': 43562.982,
 '2032': 44706.339,
 '2033': 45867.925,
 '2034': 47046.694,
 '2035': 48241.764,
 '2036': 49452.538,
 '2037': 50678.58,
 '2038': 51919.357,
 '2039': 53174.368,
 '2040': 54443.113,
 '2041': 55725.109,
 '2042': 57019.852,
 '2043': 58326.75,
 '2044': 59645.171,
 '2045': 60974.587,
 '2046': 62314.434,
 '2047': 63664.382,
 '2048': 65024.388,
 '2049': 66394.596,
 '2050': 67774.943},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '2020': 896.536,
 '2021': 903.082,
 '2022': 909.57,
 '2023': 915.978,
 '2024': 922.279,
 '2025': 928.446,
 '2026': 934.472,
 '2027': 940.343,
 '2028': 946.051,
 '2029': 951.595,
 '2030': 956.97,
 '2031': 962.184,
 '2032': 967.197,
 '2033': 972.0,
 '2034': 976.589,
 '2035': 980.93,
 '2036': 985.014,
 '2037': 988.849,
 '2038': 992.402,
 '2039': 995.683,
 '2040': 998.682,
 '2041': 1001.399,
 '2042': 1003.824,
 '2043': 1005.966,
 '2044': 1007.823,
 '2045': 1009.419,
 '2046': 1010.731,
 '2047': 1011.789,
 '2048': 1012.598,
 '2049': 1013.183,
 '2050': 1013.561},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '2020': 13087.173,
 '2021': 13378.967,
 '2022': 13669.913,
 '2023': 13960.532,
 '2024': 14251.666,
 '2025': 14543.965,
 '2026': 14837.434,
 '2027': 15131.882,
 '2028': 15427.633,
 '2029': 15725.021,
 '2030': 16024.252,
 '2031': 16325.334,
 '2032': 16628.034,
 '2033': 16932.098,
 '2034': 17237.133,
 '2035': 17542.746,
 '2036': 17848.704,
 '2037': 18154.671,
 '2038': 18459.997,
 '2039': 18763.878,
 '2040': 19065.658,
 '2041': 19364.953,
 '2042': 19661.478,
 '2043': 19954.727,
 '2044': 20244.161,
 '2045': 20529.38,
 '2046': 20810.047,
 '2047': 21086.028,
 '2048': 21357.305,
 '2049': 21623.956,
 '2050': 21886.077},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '2020': 96.112,
 '2021': 96.464,
 '2022': 96.76,
 '2023': 97.011,
 '2024': 97.217,
 '2025': 97.414,
 '2026': 97.58,
 '2027': 97.717,
 '2028': 97.833,
 '2029': 97.93,
 '2030': 98.01,
 '2031': 98.082,
 '2032': 98.136,
 '2033': 98.185,
 '2034': 98.219,
 '2035': 98.241,
 '2036': 98.254,
 '2037': 98.258,
 '2038': 98.252,
 '2039': 98.223,
 '2040': 98.185,
 '2041': 98.131,
 '2042': 98.061,
 '2043': 97.972,
 '2044': 97.855,
 '2045': 97.721,
 '2046': 97.553,
 '2047': 97.359,
 '2048': 97.145,
 '2049': 96.909,
 '2050': 96.643},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '2020': 16105.174,
 '2021': 16589.196,
 '2022': 17088.214,
 '2023': 17601.387,
 '2024': 18127.56,
 '2025': 18665.849,
 '2026': 19215.918,
 '2027': 19777.797,
 '2028': 20351.526,
 '2029': 20937.235,
 '2030': 21535.019,
 '2031': 22144.759,
 '2032': 22766.243,
 '2033': 23399.316,
 '2034': 24043.828,
 '2035': 24699.613,
 '2036': 25366.549,
 '2037': 26044.595,
 '2038': 26733.772,
 '2039': 27434.193,
 '2040': 28145.899,
 '2041': 28868.76,
 '2042': 29602.596,
 '2043': 30347.355,
 '2044': 31102.953,
 '2045': 31869.275,
 '2046': 32646.129,
 '2047': 33433.209,
 '2048': 34230.143,
 '2049': 35036.488,
 '2050': 35851.792},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '2020': 13610.007,
 '2021': 13960.428,
 '2022': 14314.458,
 '2023': 14671.974,
 '2024': 15032.44,
 '2025': 15395.477,
 '2026': 15761.305,
 '2027': 16130.267,
 '2028': 16502.233,
 '2029': 16876.974,
 '2030': 17254.367,
 '2031': 17634.307,
 '2032': 18016.908,
 '2033': 18402.372,
 '2034': 18790.97,
 '2035': 19182.891,
 '2036': 19578.154,
 '2037': 19976.625,
 '2038': 20378.119,
 '2039': 20782.386,
 '2040': 21189.205,
 '2041': 21598.427,
 '2042': 22009.951,
 '2043': 22423.66,
 '2044': 22839.397,
 '2045': 23257.015,
 '2046': 23676.336,
 '2047': 24097.135,
 '2048': 24519.204,
 '2049': 24942.321,
 '2050': 25366.221},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '2020': 47187.703,
 '2021': 48698.086,
 '2022': 50242.802,
 '2023': 51822.128,
 '2024': 53436.321,
 '2025': 55085.46,
 '2026': 56769.412,
 '2027': 58487.747,
 '2028': 60239.885,
 '2029': 62025.011,
 '2030': 63842.36,
 '2031': 65691.4,
 '2032': 67571.502,
 '2033': 69481.538,
 '2034': 71420.257,
 '2035': 73386.5,
 '2036': 75379.412,
 '2037': 77398.346,
 '2038': 79442.649,
 '2039': 81511.732,
 '2040': 83604.961,
 '2041': 85721.545,
 '2042': 87860.635,
 '2043': 90021.613,
 '2044': 92203.851,
 '2045': 94406.655,
 '2046': 96629.12,
 '2047': 98870.311,
 '2048': 101129.434,
 '2049': 103405.702,
 '2050': 105698.201},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '2020': 62774.619,
 '2021': 64673.854,
 '2022': 66612.147,
 '2023': 68591.196,
 '2024': 70613.532,
 '2025': 72681.07,
 '2026': 74794.078,
 '2027': 76952.218,
 '2028': 79155.997,
 '2029': 81405.88,
 '2030': 83702.053,
 '2031': 86044.557,
 '2032': 88432.938,
 '2033': 90866.132,
 '2034': 93342.754,
 '2035': 95861.531,
 '2036': 98421.696,
 '2037': 101022.629,
 '2038': 103663.322,
 '2039': 106342.632,
 '2040': 109059.518,
 '2041': 111813.197,
 '2042': 114602.781,
 '2043': 117426.994,
 '2044': 120284.409,
 '2045': 123173.856,
 '2046': 126094.341,
 '2047': 129045.371,
 '2048': 132026.85,
 '2049': 135038.935,
 '2050': 138081.621},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '2020': 18679.273,
 '2021': 19234.791,
 '2022': 19803.619,
 '2023': 20386.125,
 '2024': 20982.764,
 '2025': 21593.825,
 '2026': 22219.44,
 '2027': 22859.363,
 '2028': 23513.109,
 '2029': 24179.963,
 '2030': 24859.376,
 '2031': 25551.178,
 '2032': 26255.378,
 '2033': 26971.852,
 '2034': 27700.551,
 '2035': 28441.399,
 '2036': 29194.278,
 '2037': 29959.107,
 '2038': 30736.002,
 '2039': 31525.138,
 '2040': 32326.616,
 '2041': 33140.423,
 '2042': 33966.44,
 '2043': 34804.573,
 '2044': 35654.689,
 '2045': 36516.657,
 '2046': 37390.29,
 '2047': 38275.489,
 '2048': 39172.28,
 '2049': 40080.735,
 '2050': 41000.822},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '2020': 17680.465,
 '2021': 18060.453,
 '2022': 18437.423,
 '2023': 18813.091,
 '2024': 19190.301,
 '2025': 19571.154,
 '2026': 19955.912,
 '2027': 20343.863,
 '2028': 20735.073,
 '2029': 21129.447,
 '2030': 21526.861,
 '2031': 21927.311,
 '2032': 22330.754,
 '2033': 22736.929,
 '2034': 23145.468,
 '2035': 23556.026,
 '2036': 23968.335,
 '2037': 24382.067,
 '2038': 24796.673,
 '2039': 25211.507,
 '2040': 25625.981,
 '2041': 26039.654,
 '2042': 26452.158,
 '2043': 26863.059,
 '2044': 27271.926,
 '2045': 27678.33,
 '2046': 28081.89,
 '2047': 28482.22,
 '2048': 28878.815,
 '2049': 29271.142,
 '2050': 29658.75},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '2020': 178959.265,
 '2021': 184336.506,
 '2022': 189824.352,
 '2023': 195423.65,
 '2024': 201135.544,
 '2025': 206960.724,
 '2026': 212898.415,
 '2027': 218947.848,
 '2028': 225109.391,
 '2029': 231383.703,
 '2030': 237770.539,
 '2031': 244268.617,
 '2032': 250875.407,
 '2033': 257587.867,
 '2034': 264402.288,
 '2035': 271314.878,
 '2036': 278322.814,
 '2037': 285422.821,
 '2038': 292609.6610000001,
 '2039': 299877.459,
 '2040': 307220.862,
 '2041': 314635.962,
 '2042': 322119.469,
 '2043': 329667.382,
 '2044': 337275.695,
 '2045': 344940.728,
 '2046': 352658.617,
 '2047': 360426.084,
 '2048': 368240.817,
 '2049': 376101.037,
 '2050': 384004.505},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '2020': 32827.401,
 '2021': 33894.484,
 '2022': 34988.302,
 '2023': 36109.078,
 '2024': 37256.728,
 '2025': 38431.208,
 '2026': 39632.777,
 '2027': 40861.741,
 '2028': 42118.066,
 '2029': 43401.63,
 '2030': 44712.282,
 '2031': 46049.888,
 '2032': 47414.284,
 '2033': 48805.159,
 '2034': 50222.155,
 '2035': 51664.864,
 '2036': 53132.953,
 '2037': 54626.019,
 '2038': 56143.48,
 '2039': 57684.681,
 '2040': 59249.002,
 '2041': 60835.954,
 '2042': 62445.07,
 '2043': 64075.73,
 '2044': 65727.293,
 '2045': 67399.148,
 '2046': 69090.764,
 '2047': 70801.659,
 '2048': 72531.421,
 '2049': 74279.686,
 '2050': 76046.053},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '2020': 25958.184,
 '2021': 26613.765,
 '2022': 27279.608,
 '2023': 27955.755,
 '2024': 28642.234,
 '2025': 29339.083,
 '2026': 30046.222,
 '2027': 30763.659,
 '2028': 31491.572,
 '2029': 32230.19,
 '2030': 32979.644,
 '2031': 33739.916,
 '2032': 34510.776,
 '2033': 35291.925,
 '2034': 36083.001,
 '2035': 36883.632,
 '2036': 37693.541,
 '2037': 38512.499,
 '2038': 39340.228,
 '2039': 40176.449,
 '2040': 41020.839,
 '2041': 41873.089,
 '2042': 42732.805,
 '2043': 43599.435,
 '2044': 44472.363,
 '2045': 45351.038,
 '2046': 46235.002,
 '2047': 47123.91,
 '2048': 48017.458,
 '2049': 48915.384,
 '2050': 49817.39},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '2020': 4920.889,
 '2021': 5022.853,
 '2022': 5132.27,
 '2023': 5247.586,
 '2024': 5366.949,
 '2025': 5488.896,
 '2026': 5612.532,
 '2027': 5737.657,
 '2028': 5864.322,
 '2029': 5992.915,
 '2030': 6123.615,
 '2031': 6256.23,
 '2032': 6390.254,
 '2033': 6525.376,
 '2034': 6661.223,
 '2035': 6797.519,
 '2036': 6934.059,
 '2037': 7070.78,
 '2038': 7207.592,
 '2039': 7344.487,
 '2040': 7481.447,
 '2041': 7618.398,
 '2042': 7755.269,
 '2043': 7892.097,
 '2044': 8028.923,
 '2045': 8165.788,
 '2046': 8302.674,
 '2047': 8439.545,
 '2048': 8576.467,
 '2049': 8713.528,
 '2050': 8850.78},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '2020': 16285.093,
 '2021': 16765.714,
 '2022': 17255.546,
 '2023': 17754.22,
 '2024': 18261.067,
 '2025': 18775.565,
 '2026': 19297.583,
 '2027': 19827.182,
 '2028': 20364.197,
 '2029': 20908.51,
 '2030': 21459.963,
 '2031': 22018.36,
 '2032': 22583.505,
 '2033': 23155.184,
 '2034': 23733.187,
 '2035': 24317.309,
 '2036': 24907.304,
 '2037': 25502.961,
 '2038': 26103.996,
 '2039': 26710.161,
 '2040': 27321.154,
 '2041': 27936.751,
 '2042': 28556.669,
 '2043': 29180.61,
 '2044': 29808.24,
 '2045': 30439.253,
 '2046': 31073.358,
 '2047': 31710.307,
 '2048': 32349.847,
 '2049': 32991.754,
 '2050': 33635.795},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '2020': 5686.917,
 '2021': 5834.089,
 '2022': 5984.189,
 '2023': 6137.528,
 '2024': 6294.495,
 '2025': 6455.373,
 '2026': 6620.218,
 '2027': 6788.982,
 '2028': 6961.681,
 '2029': 7138.328,
 '2030': 7318.887,
 '2031': 7503.338,
 '2032': 7691.584,
 '2033': 7883.415,
 '2034': 8078.586,
 '2035': 8276.845,
 '2036': 8478.096,
 '2037': 8682.197,
 '2038': 8888.864,
 '2039': 9097.765,
 '2040': 9308.628,
 '2041': 9521.302,
 '2042': 9735.722,
 '2043': 9951.83,
 '2044': 10169.58,
 '2045': 10388.945,
 '2046': 10609.847,
 '2047': 10832.271,
 '2048': 11056.291,
 '2049': 11282.052,
 '2050': 11509.651},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '2020': 89505.201,
 '2021': 92336.045,
 '2022': 95220.379,
 '2023': 98160.404,
 '2024': 101159.625,
 '2025': 104220.558,
 '2026': 107343.095,
 '2027': 110526.199,
 '2028': 113770.328,
 '2029': 117075.937,
 '2030': 120442.943,
 '2031': 123870.684,
 '2032': 127357.745,
 '2033': 130902.18,
 '2034': 134501.533,
 '2035': 138153.309,
 '2036': 141855.797,
 '2037': 145606.856,
 '2038': 149402.912,
 '2039': 153239.842,
 '2040': 157114.0,
 '2041': 161022.796,
 '2042': 164964.224,
 '2043': 168935.876,
 '2044': 172935.478,
 '2045': 176960.865,
 '2046': 181009.643,
 '2047': 185079.729,
 '2048': 189169.665,
 '2049': 193278.289,
 '2050': 197404.202},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '2020': 1406.28,
 '2021': 1452.35,
 '2022': 1498.287,
 '2023': 1544.203,
 '2024': 1590.279,
 '2025': 1636.622,
 '2026': 1683.298,
 '2027': 1730.26,
 '2028': 1777.358,
 '2029': 1824.393,
 '2030': 1871.22,
 '2031': 1917.787,
 '2032': 1964.178,
 '2033': 2010.61,
 '2034': 2057.392,
 '2035': 2104.728,
 '2036': 2152.689,
 '2037': 2201.208,
 '2038': 2250.162,
 '2039': 2299.375,
 '2040': 2348.714,
 '2041': 2398.149,
 '2042': 2447.695,
 '2043': 2497.32,
 '2044': 2546.981,
 '2045': 2596.652,
 '2046': 2646.294,
 '2047': 2695.886,
 '2048': 2745.462,
 '2049': 2795.078,
 '2050': 2844.744},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '2020': 2151.289,
 '2021': 2194.488,
 '2022': 2238.282,
 '2023': 2282.534,
 '2024': 2326.901,
 '2025': 2371.137,
 '2026': 2415.315,
 '2027': 2459.617,
 '2028': 2504.065,
 '2029': 2548.693,
 '2030': 2593.514,
 '2031': 2638.542,
 '2032': 2683.764,
 '2033': 2729.214,
 '2034': 2774.89,
 '2035': 2820.808,
 '2036': 2866.951,
 '2037': 2913.301,
 '2038': 2959.83,
 '2039': 3006.498,
 '2040': 3053.264,
 '2041': 3100.094,
 '2042': 3146.962,
 '2043': 3193.804,
 '2044': 3240.543,
 '2045': 3287.137,
 '2046': 3333.54,
 '2047': 3379.697,
 '2048': 3425.558,
 '2049': 3471.063,
 '2050': 3516.141},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '2020': 218.011,
 '2021': 222.718,
 '2022': 227.489,
 '2023': 232.342,
 '2024': 237.266,
 '2025': 242.282,
 '2026': 247.375,
 '2027': 252.551,
 '2028': 257.802,
 '2029': 263.107,
 '2030': 268.471,
 '2031': 273.872,
 '2032': 279.317,
 '2033': 284.804,
 '2034': 290.321,
 '2035': 295.864,
 '2036': 301.424,
 '2037': 307.0,
 '2038': 312.597,
 '2039': 318.201,
 '2040': 323.814,
 '2041': 329.429,
 '2042': 335.053,
 '2043': 340.68,
 '2044': 346.294,
 '2045': 351.902,
 '2046': 357.495,
 '2047': 363.08,
 '2048': 368.648,
 '2049': 374.203,
 '2050': 379.749}]},
'Total Population': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035,
2040,
2045,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950': 2536274.721,
 '1955': 2772242.535000001,
 '1960': 3033212.527,
 '1965': 3339592.688000002,
 '1970': 3700577.6499999994,
 '1975': 4079087.1980000013,
 '1980': 4458411.534,
 '1985': 4873781.795999999,
 '1990': 5330943.459999999,
 '1995': 5751474.415999999,
 '2000': 6145006.989,
 '2005': 6542159.383000003,
 '2010': 6958169.158999999,
 '2015': 7383008.819999998,
 '2020': 7795482.3089999985,
 '2025': 8185613.757000002,
 '2030': 8551198.644,
 '2035': 8892701.94,
 '2040': 9210337.004000004,
 '2045': 9504209.572,
 '2050': 9771822.752999999},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950': 814865.0689999999,
 '1955': 865069.4440000004,
 '1960': 917067.9199999997,
 '1965': 967380.886,
 '1970': 1009081.7790000003,
 '1975': 1049413.674,
 '1980': 1084244.071,
 '1985': 1115935.023,
 '1990': 1146999.1909999999,
 '1995': 1171325.471,
 '2000': 1190504.7349999999,
 '2005': 1210545.53,
 '2010': 1235142.506,
 '2015': 1253206.5459999996,
 '2020': 1269276.8460000001,
 '2025': 1281295.8399999999,
 '2030': 1289936.5529999998,
 '2035': 1294999.5639999998,
 '2040': 1297495.7139999997,
 '2045': 1298349.0439999998,
 '2050': 1298068.585},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950': 1721409.6519999998,
 '1955': 1907173.0910000005,
 '1960': 2116144.607,
 '1965': 2372211.802000002,
 '1970': 2691495.870999999,
 '1975': 3029673.524000001,
 '1980': 3374167.463,
 '1985': 3757846.772999999,
 '1990': 4183944.2689999994,
 '1995': 4580148.944999999,
 '2000': 4954502.254000001,
 '2005': 5331613.853000003,
 '2010': 5723026.652999999,
 '2015': 6129802.273999998,
 '2020': 6526205.462999999,
 '2025': 6904317.917000002,
 '2030': 7261262.090999999,
 '2035': 7597702.375999999,
 '2040': 7912841.290000006,
 '2045': 8205860.528,
 '2050': 8473754.167999998},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950': 195259.056,
 '1955': 215421.063,
 '1960': 240742.1960000001,
 '1965': 271400.502,
 '1970': 308486.373,
 '1975': 347093.126,
 '1980': 393279.303,
 '1985': 447240.9810000001,
 '1990': 510827.5760000002,
 '1995': 585496.1749999999,
 '2000': 664804.763,
 '2005': 754118.0719999999,
 '2010': 848791.9619999999,
 '2015': 956631.108,
 '2020': 1073984.2769999998,
 '2025': 1200440.5770000005,
 '2030': 1334195.6999999997,
 '2035': 1474182.6339999998,
 '2040': 1618984.5080000001,
 '2045': 1767059.0609999998,
 '2050': 1916741.5810000005},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950': 1526150.596,
 '1955': 1691752.0280000002,
 '1960': 1875402.411,
 '1965': 2100811.3000000003,
 '1970': 2383009.497999999,
 '1975': 2682580.398,
 '1980': 2980888.1599999997,
 '1985': 3310605.7920000004,
 '1990': 3673116.692999999,
 '1995': 3994652.769999998,
 '2000': 4289697.491000002,
 '2005': 4577495.7809999995,
 '2010': 4874234.691000001,
 '2015': 5173171.165999997,
 '2020': 5452221.186,
 '2025': 5703877.339999999,
 '2030': 5927066.391,
 '2035': 6123519.741999997,
 '2040': 6293856.782000003,
 '2045': 6438801.467000002,
 '2050': 6557012.586999998},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950': 1157196.536,
 '1955': 1284636.9480000008,
 '1960': 1444523.768,
 '1965': 1633307.449,
 '1970': 1847894.9540000004,
 '1975': 2088018.1389999997,
 '1980': 2357419.196,
 '1985': 2662232.0879999995,
 '1990': 2985061.976999999,
 '1995': 3312454.642,
 '2000': 3642371.4160000007,
 '2005': 3980077.1570000015,
 '2010': 4332606.954999999,
 '2015': 4701441.323,
 '2020': 5069639.764999999,
 '2025': 5432967.091,
 '2030': 5787196.413000002,
 '2035': 6131182.335999997,
 '2040': 6462522.403000004,
 '2045': 6779059.706999999,
 '2050': 7077398.223999999},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950': 672895.9580000001,
 '1955': 715241.1450000003,
 '1960': 761557.6089999998,
 '1965': 808971.4749999999,
 '1970': 851319.1250000001,
 '1975': 892915.2070000002,
 '1980': 929939.165,
 '1985': 965012.855,
 '1990': 1000109.3429999998,
 '1995': 1035594.9639999997,
 '2000': 1070130.2240000002,
 '2005': 1106701.8439999996,
 '2010': 1148592.3929999997,
 '2015': 1180060.9569999997,
 '2020': 1207775.438,
 '2025': 1230492.0170000002,
 '2030': 1249896.1870000004,
 '2035': 1264922.4470000002,
 '2040': 1275679.329,
 '2045': 1282990.054,
 '2050': 1287798.294},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950': 1734480.8419999997,
 '1955': 1916892.3780000005,
 '1960': 2115931.194,
 '1965': 2356493.8379999995,
 '1970': 2652001.365,
 '1975': 2962675.7939999998,
 '1980': 3275987.7009999985,
 '1985': 3624140.5200000005,
 '1990': 4006282.317,
 '1995': 4342278.351,
 '2000': 4647489.693,
 '2005': 4944485.729,
 '2010': 5246881.509,
 '2015': 5558263.979,
 '2020': 5852576.168,
 '2025': 6121661.379000001,
 '2030': 6362053.886,
 '2035': 6576010.166999999,
 '2040': 6764839.984999999,
 '2045': 6929181.567999998,
 '2050': 7067079.456},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950': 956203.6559999998,
 '1955': 1060465.4500000002,
 '1960': 1161552.9390000005,
 '1965': 1285370.3789999997,
 '1970': 1447954.2680000004,
 '1975': 1609167.2359999998,
 '1980': 1751425.373999999,
 '1985': 1903614.745,
 '1990': 2079414.4640000002,
 '1995': 2208017.3419999997,
 '2000': 2307578.062,
 '2005': 2397643.6249999995,
 '2010': 2489411.123,
 '2015': 2588362.9800000004,
 '2020': 2670122.0229999996,
 '2025': 2727929.2220000005,
 '2030': 2767247.3240000005,
 '2035': 2791445.775,
 '2040': 2802738.8590000006,
 '2045': 2802573.825999999,
 '2050': 2790495.775000001},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950': 778277.186,
 '1955': 856426.9280000002,
 '1960': 954378.2549999999,
 '1965': 1071123.4589999996,
 '1970': 1204047.097,
 '1975': 1353508.5580000002,
 '1980': 1524562.3269999996,
 '1985': 1720525.7750000001,
 '1990': 1926867.8529999997,
 '1995': 2134261.0090000005,
 '2000': 2339911.6310000005,
 '2005': 2546842.1040000003,
 '2010': 2757470.386,
 '2015': 2969900.999,
 '2020': 3182454.145,
 '2025': 3393732.1569999997,
 '2030': 3594806.5619999995,
 '2035': 3784564.392,
 '2040': 3962101.125999999,
 '2045': 4126607.741999999,
 '2050': 4276583.681},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950': 128096.648,
 '1955': 139196.08,
 '1960': 154670.163,
 '1965': 172929.952,
 '1970': 195910.639,
 '1975': 222101.799,
 '1980': 250969.22,
 '1985': 282952.714,
 '1990': 322686.243,
 '1995': 371552.946,
 '2000': 425129.5520000001,
 '2005': 488440.9129999999,
 '2010': 560007.4439999999,
 '2015': 641858.6080000001,
 '2020': 732132.7999999999,
 '2025': 830289.022,
 '2030': 935905.4139999998,
 '2035': 1048261.5629999998,
 '2040': 1166158.631,
 '2045': 1288244.4700000002,
 '2050': 1413033.9960000003},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950': 179621.0760000001,
 '1955': 198379.925,
 '1960': 221490.118,
 '1965': 249638.962,
 '1970': 283310.1169999999,
 '1975': 323680.8709999999,
 '1980': 372309.5269999999,
 '1985': 428899.6970000001,
 '1990': 493329.0200000001,
 '1995': 564806.652,
 '2000': 645007.1340000002,
 '2005': 736925.4529999999,
 '2010': 845136.1540000001,
 '2015': 969234.2509999999,
 '2020': 1106572.8809999998,
 '2025': 1256239.7440000002,
 '2030': 1418333.1500000001,
 '2035': 1592398.515,
 '2040': 1776791.1840000001,
 '2045': 1969331.0299999993,
 '2050': 2167651.879},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950': 228670.019,
 '1955': 253995.025,
 '1960': 285142.0060000001,
 '1965': 322470.634,
 '1970': 366458.9290000001,
 '1975': 417898.0740000001,
 '1980': 480012.209,
 '1985': 552796.228,
 '1990': 634567.044,
 '1995': 722921.961,
 '2000': 817566.0040000001,
 '2005': 924757.7080000001,
 '2010': 1049446.344,
 '2015': 1194369.908,
 '2020': 1352622.189,
 '2025': 1522250.0929999999,
 '2030': 1703537.5039999997,
 '2035': 1896703.697,
 '2040': 2100301.731,
 '2045': 2311561.3260000004,
 '2050': 2527556.761},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950': 66758.254,
 '1955': 74585.806,
 '1960': 84182.469,
 '1965': 95996.653,
 '1970': 110292.07,
 '1975': 127204.27,
 '1980': 147518.89,
 '1985': 171123.08,
 '1990': 198645.937,
 '1995': 226021.034,
 '2000': 261113.89,
 '2005': 300599.7060000001,
 '2010': 346987.498,
 '2015': 399458.026,
 '2020': 457439.6800000001,
 '2025': 520131.276,
 '2030': 587330.0959999999,
 '2035': 658520.5279999999,
 '2040': 732906.3770000001,
 '2045': 809728.8650000001,
 '2050': 888128.5620000002},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950': 2308.92,
 '1955': 2531.184,
 '1960': 2786.106,
 '1965': 3077.876,
 '1970': 3455.606,
 '1975': 3671.494,
 '1980': 4116.817,
 '1985': 4702.066,
 '1990': 5415.415,
 '1995': 5962.058,
 '2000': 6400.706,
 '2005': 7423.289,
 '2010': 8766.93,
 '2015': 10199.27,
 '2020': 11939.227,
 '2025': 13810.006,
 '2030': 15798.849,
 '2035': 17970.195,
 '2040': 20377.076,
 '2045': 22998.539,
 '2050': 25762.044},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950': 159.459,
 '1955': 175.903,
 '1960': 191.121,
 '1965': 207.424,
 '1970': 230.054,
 '1975': 257.29,
 '1980': 307.829,
 '1985': 355.337,
 '1990': 411.594,
 '1995': 475.394,
 '2000': 542.357,
 '2005': 611.627,
 '2010': 689.692,
 '2015': 777.424,
 '2020': 869.601,
 '2025': 964.591,
 '2030': 1061.775,
 '2035': 1161.071,
 '2040': 1261.942,
 '2045': 1363.098,
 '2050': 1462.735},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950': 62.001,
 '1955': 69.589,
 '1960': 83.636,
 '1965': 114.963,
 '1970': 159.659,
 '1975': 224.183,
 '1980': 358.96,
 '1985': 425.613,
 '1990': 590.398,
 '1995': 630.388,
 '2000': 717.584,
 '2005': 783.254,
 '2010': 851.146,
 '2015': 927.414,
 '2020': 999.899,
 '2025': 1069.009,
 '2030': 1132.71,
 '2035': 1189.001,
 '2040': 1236.85,
 '2045': 1276.268,
 '2050': 1307.615},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950': 1142.148,
 '1955': 1249.193,
 '1960': 1397.491,
 '1965': 1589.179,
 '1970': 1811.878,
 '1975': 2075.965,
 '1980': 2385.54,
 '1985': 2753.151,
 '1990': 3113.311,
 '1995': 3090.159,
 '2000': 3392.801,
 '2005': 3969.007,
 '2010': 4390.84,
 '2015': 4846.976,
 '2020': 5432.216,
 '2025': 6056.88,
 '2030': 6717.687,
 '2035': 7420.805,
 '2040': 8152.54,
 '2045': 8887.988,
 '2050': 9606.664},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950': 18128.034,
 '1955': 19947.292,
 '1960': 22151.278,
 '1965': 25013.626,
 '1970': 28415.077,
 '1975': 32566.821,
 '1980': 35264.898,
 '1985': 40800.343,
 '1990': 48086.516,
 '1995': 57309.88,
 '2000': 66537.331,
 '2005': 76727.083,
 '2010': 87702.67,
 '2015': 99873.033,
 '2020': 112759.07,
 '2025': 126120.682,
 '2030': 139620.178,
 '2035': 153036.024,
 '2040': 166139.393,
 '2045': 178817.639,
 '2050': 190869.632},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950': 6076.758,
 '1955': 6979.931,
 '1960': 8105.44,
 '1965': 9504.703,
 '1970': 11252.492,
 '1975': 13486.629,
 '1980': 16268.99,
 '1985': 19651.225,
 '1990': 23402.507,
 '1995': 27346.456,
 '2000': 31450.483,
 '2005': 36048.288,
 '2010': 41350.152,
 '2015': 47236.259,
 '2020': 53491.697,
 '2025': 60063.158,
 '2030': 66959.993,
 '2035': 74086.106,
 '2040': 81286.865,
 '2045': 88434.154,
 '2050': 95467.137},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950': 4083.554,
 '1955': 4543.542,
 '1960': 5099.373,
 '1965': 5769.218,
 '1970': 6576.305,
 '1975': 7556.026,
 '1980': 8716.553,
 '1985': 10063.495,
 '1990': 11598.633,
 '1995': 13475.4,
 '2000': 15766.806,
 '2005': 18336.724,
 '2010': 21151.64,
 '2015': 24234.088,
 '2020': 27690.798,
 '2025': 31500.077,
 '2030': 35591.943,
 '2035': 39891.388,
 '2040': 44367.656,
 '2045': 49012.988,
 '2050': 53802.574},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950': 2953.871,
 '1955': 3252.332,
 '1960': 3618.595,
 '1965': 4058.673,
 '1970': 4603.723,
 '1975': 5292.808,
 '1980': 6163.08,
 '1985': 7211.105,
 '1990': 9437.553,
 '1995': 9909.088,
 '2000': 11376.172,
 '2005': 13039.711,
 '2010': 15167.095,
 '2015': 17573.607,
 '2020': 20283.691,
 '2025': 23277.224,
 '2030': 26578.247,
 '2035': 30109.857,
 '2040': 33836.707,
 '2045': 37719.155,
 '2050': 41705.002},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950': 493.255,
 '1955': 570.648,
 '1960': 660.023,
 '1965': 753.285,
 '1970': 826.441,
 '1975': 892.211,
 '1980': 966.031,
 '1985': 1015.762,
 '1990': 1055.868,
 '1995': 1128.673,
 '2000': 1185.145,
 '2005': 1222.003,
 '2010': 1247.955,
 '2015': 1259.456,
 '2020': 1274.114,
 '2025': 1283.273,
 '2030': 1286.934,
 '2035': 1282.701,
 '2040': 1269.2,
 '2045': 1247.598,
 '2050': 1221.03},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950': 15.141,
 '1955': 18.985,
 '1960': 24.015,
 '1965': 30.526,
 '1970': 36.969,
 '1975': 45.483,
 '1980': 55.137,
 '1985': 72.104,
 '1990': 94.784,
 '1995': 123.181,
 '2000': 150.331,
 '2005': 178.098,
 '2010': 208.718,
 '2015': 240.02,
 '2020': 273.11,
 '2025': 307.518,
 '2030': 343.809,
 '2035': 381.739,
 '2040': 420.33,
 '2045': 458.543,
 '2050': 495.498},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950': 6152.237,
 '1955': 6701.749,
 '1960': 7388.695,
 '1965': 8203.076,
 '1970': 9161.534,
 '1975': 10344.494,
 '1980': 11848.331,
 '1985': 12984.405,
 '1990': 13247.649,
 '1995': 15759.132,
 '2000': 18067.687,
 '2005': 20923.07,
 '2010': 24221.405,
 '2015': 28010.691,
 '2020': 32309.195,
 '2025': 37116.198,
 '2030': 42438.703,
 '2035': 48241.764,
 '2040': 54443.113,
 '2045': 60974.587,
 '2050': 67774.943},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950': 248.11,
 '1955': 291.658,
 '1960': 335.693,
 '1965': 390.775,
 '1970': 462.025,
 '1975': 484.777,
 '1980': 509.265,
 '1985': 558.699,
 '1990': 610.582,
 '1995': 673.541,
 '2000': 736.71,
 '2005': 791.598,
 '2010': 830.519,
 '2015': 863.363,
 '2020': 896.536,
 '2025': 928.446,
 '2030': 956.97,
 '2035': 980.93,
 '2040': 998.682,
 '2045': 1009.419,
 '2050': 1013.561},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950': 2186.185,
 '1955': 2525.527,
 '1960': 2933.428,
 '1965': 3232.934,
 '1970': 3754.541,
 '1975': 4359.092,
 '1980': 5140.716,
 '1985': 6120.107,
 '1990': 7235.798,
 '1995': 5928.078,
 '2000': 8025.703,
 '2005': 8991.735,
 '2010': 10246.842,
 '2015': 11629.553,
 '2020': 13087.173,
 '2025': 14543.965,
 '2030': 16024.252,
 '2035': 17542.746,
 '2040': 19065.658,
 '2045': 20529.38,
 '2050': 21886.077},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950': 36.325,
 '1955': 38.909,
 '1960': 41.54,
 '1965': 46.772,
 '1970': 52.365,
 '1975': 59.59,
 '1980': 66.294,
 '1985': 69.836,
 '1990': 70.624,
 '1995': 76.703,
 '2000': 81.151,
 '2005': 88.744,
 '2010': 91.405,
 '2015': 93.742,
 '2020': 96.112,
 '2025': 97.414,
 '2030': 98.01,
 '2035': 98.241,
 '2040': 98.185,
 '2045': 97.721,
 '2050': 96.643},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950': 2264.082,
 '1955': 2491.52,
 '1960': 2755.947,
 '1965': 3068.437,
 '1970': 3444.553,
 '1975': 3880.32,
 '1980': 6359.126,
 '1985': 6791.716,
 '1990': 7397.347,
 '1995': 7704.894,
 '2000': 9011.479,
 '2005': 10409.925,
 '2010': 12053.223,
 '2015': 13908.129,
 '2020': 16105.174,
 '2025': 18665.849,
 '2030': 21535.019,
 '2035': 24699.613,
 '2040': 28145.899,
 '2045': 31869.275,
 '2050': 35851.792},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950': 2582.929,
 '1955': 2721.544,
 '1960': 2955.152,
 '1965': 3263.638,
 '1970': 3647.709,
 '1975': 4119.438,
 '1980': 4705.224,
 '1985': 5450.424,
 '1990': 5768.481,
 '1995': 5459.519,
 '2000': 6700.656,
 '2005': 8108.877,
 '2010': 10067.192,
 '2015': 11882.136,
 '2020': 13610.007,
 '2025': 15395.477,
 '2030': 17254.367,
 '2035': 19182.891,
 '2040': 21189.205,
 '2045': 23257.015,
 '2050': 25366.221},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950': 5158.19,
 '1955': 5898.835,
 '1960': 6788.214,
 '1965': 8014.401,
 '1970': 9446.064,
 '1975': 10827.147,
 '1980': 12549.54,
 '1985': 14646.624,
 '1990': 17438.907,
 '1995': 20550.291,
 '2000': 24039.274,
 '2005': 28543.94,
 '2010': 33915.133,
 '2015': 40144.87,
 '2020': 47187.703,
 '2025': 55085.46,
 '2030': 63842.36,
 '2035': 73386.5,
 '2040': 83604.961,
 '2045': 94406.655,
 '2050': 105698.201},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950': 7649.761,
 '1955': 8740.986,
 '1960': 10074.507,
 '1965': 11683.528,
 '1970': 13605.529,
 '1975': 15980.301,
 '1980': 18683.157,
 '1985': 21836.999,
 '1990': 25459.604,
 '1995': 29960.776,
 '2000': 34178.042,
 '2005': 39410.545,
 '2010': 46098.591,
 '2015': 53879.957,
 '2020': 62774.619,
 '2025': 72681.07,
 '2030': 83702.053,
 '2035': 95861.531,
 '2040': 109059.518,
 '2045': 123173.856,
 '2050': 138081.621},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950': 2310.442,
 '1955': 2634.464,
 '1960': 3044.846,
 '1965': 3563.407,
 '1970': 4173.928,
 '1975': 4964.831,
 '1980': 5889.23,
 '1985': 6955.212,
 '1990': 8027.253,
 '1995': 9137.077,
 '2000': 10531.221,
 '2005': 12052.156,
 '2010': 13850.033,
 '2015': 16100.587,
 '2020': 18679.273,
 '2025': 21593.825,
 '2030': 24859.376,
 '2035': 28441.399,
 '2040': 32326.616,
 '2045': 36516.657,
 '2050': 41000.822},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950': 2746.852,
 '1955': 3202.015,
 '1960': 3747.369,
 '1965': 4410.212,
 '1970': 5175.618,
 '1975': 6115.37,
 '1980': 7164.172,
 '1985': 8658.857,
 '1990': 10183.113,
 '1995': 11320.346,
 '2000': 12222.251,
 '2005': 12940.032,
 '2010': 14086.317,
 '2015': 15777.451,
 '2020': 17680.465,
 '2025': 19571.154,
 '2030': 21526.861,
 '2035': 23556.026,
 '2040': 25625.981,
 '2045': 27678.33,
 '2050': 29658.75},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950': 26453.762,
 '1955': 29173.448,
 '1960': 32428.782,
 '1965': 36368.441,
 '1970': 41121.907,
 '1975': 46729.589,
 '1980': 53616.947,
 '1985': 61688.663,
 '1990': 71331.287,
 '1995': 84195.938,
 '2000': 96098.868,
 '2005': 111954.048,
 '2010': 131351.399,
 '2015': 153742.724,
 '2020': 178959.265,
 '2025': 206960.724,
 '2030': 237770.539,
 '2035': 271314.878,
 '2040': 307220.862,
 '2045': 344940.728,
 '2050': 384004.505},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950': 4548.023,
 '1955': 5116.071,
 '1960': 5643.182,
 '1965': 6203.299,
 '1970': 6776.381,
 '1975': 7682.479,
 '1980': 8929.9,
 '1985': 10609.042,
 '1990': 12171.441,
 '1995': 14268.994,
 '2000': 16440.924,
 '2005': 19552.542,
 '2010': 23369.131,
 '2015': 27859.305,
 '2020': 32827.401,
 '2025': 38431.208,
 '2030': 44712.282,
 '2035': 51664.864,
 '2040': 59249.002,
 '2045': 67399.148,
 '2050': 76046.053},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950': 4307.022,
 '1955': 4704.233,
 '1960': 5176.268,
 '1965': 5777.834,
 '1970': 6527.635,
 '1975': 7457.362,
 '1980': 8618.354,
 '1985': 10050.023,
 '1990': 11715.218,
 '1995': 13460.994,
 '2000': 15274.234,
 '2005': 17420.795,
 '2010': 19970.495,
 '2015': 22834.522,
 '2020': 25958.184,
 '2025': 29339.083,
 '2030': 32979.644,
 '2035': 36883.632,
 '2040': 41020.839,
 '2045': 45351.038,
 '2050': 49817.39},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950': 1326.652,
 '1955': 1399.487,
 '1960': 1503.508,
 '1965': 1648.833,
 '1970': 1828.709,
 '1975': 2017.372,
 '1980': 2279.821,
 '1985': 2634.232,
 '1990': 2939.78,
 '1995': 3352.767,
 '2000': 3754.986,
 '2005': 4127.91,
 '2010': 4448.525,
 '2015': 4546.1,
 '2020': 4920.889,
 '2025': 5488.896,
 '2030': 6123.615,
 '2035': 6797.519,
 '2040': 7481.447,
 '2045': 8165.788,
 '2050': 8850.78},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950': 2502.317,
 '1955': 2735.208,
 '1960': 3001.593,
 '1965': 3309.573,
 '1970': 3643.549,
 '1975': 4087.948,
 '1980': 4512.042,
 '1985': 5091.535,
 '1990': 5956.859,
 '1995': 7000.722,
 '2000': 8342.559,
 '2005': 10067.009,
 '2010': 11887.202,
 '2015': 14009.413,
 '2020': 16285.093,
 '2025': 18775.565,
 '2030': 21459.963,
 '2035': 24317.309,
 '2040': 27321.154,
 '2045': 30439.253,
 '2050': 33635.795},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950': 827.252,
 '1955': 920.218,
 '1960': 1037.22,
 '1965': 1184.316,
 '1970': 1364.812,
 '1975': 1590.039,
 '1980': 1839.935,
 '1985': 2127.77,
 '1990': 2440.457,
 '1995': 2799.255,
 '2000': 3225.727,
 '2005': 3718.243,
 '2010': 4386.693,
 '2015': 4995.648,
 '2020': 5686.917,
 '2025': 6455.373,
 '2030': 7318.887,
 '2035': 8276.845,
 '2040': 9308.628,
 '2045': 10388.945,
 '2050': 11509.651},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950': 12183.659,
 '1955': 13517.513,
 '1960': 15248.251,
 '1965': 17369.883,
 '1970': 20009.935,
 '1975': 22902.319,
 '1980': 26357.462,
 '1985': 29883.446,
 '1990': 34614.581,
 '1995': 41595.744,
 '2000': 47076.387,
 '2005': 54751.476,
 '2010': 64523.263,
 '2015': 76196.619,
 '2020': 89505.201,
 '2025': 104220.558,
 '2030': 120442.943,
 '2035': 138153.309,
 '2040': 157114.0,
 '2045': 176960.865,
 '2050': 197404.202},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950': 225.537,
 '1955': 239.375,
 '1960': 255.323,
 '1965': 277.396,
 '1970': 306.515,
 '1975': 259.747,
 '1980': 255.325,
 '1985': 358.896,
 '1990': 426.846,
 '1995': 504.871,
 '2000': 614.323,
 '2005': 757.317,
 '2010': 951.104,
 '2015': 1175.389,
 '2020': 1406.28,
 '2025': 1636.622,
 '2030': 1871.22,
 '2035': 2104.728,
 '2040': 2348.714,
 '2045': 2596.652,
 '2050': 2844.744},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950': 473.298,
 '1955': 482.56,
 '1960': 499.184,
 '1965': 532.511,
 '1970': 590.118,
 '1975': 649.716,
 '1980': 729.159,
 '1985': 830.085,
 '1990': 952.212,
 '1995': 1086.137,
 '2000': 1231.122,
 '2005': 1403.126,
 '2010': 1640.21,
 '2015': 1930.175,
 '2020': 2151.289,
 '2025': 2371.137,
 '2030': 2593.514,
 '2035': 2820.808,
 '2040': 3053.264,
 '2045': 3287.137,
 '2050': 3516.141},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950': 60.002,
 '1955': 58.783,
 '1960': 64.253,
 '1965': 64.796,
 '1970': 74.253,
 '1975': 82.607,
 '1980': 94.949,
 '1985': 103.634,
 '1990': 113.893,
 '1995': 126.454,
 '2000': 138.606,
 '2005': 155.63,
 '2010': 174.776,
 '2015': 195.553,
 '2020': 218.011,
 '2025': 242.282,
 '2030': 268.471,
 '2035': 295.864,
 '2040': 323.814,
 '2045': 351.902,
 '2050': 379.749}]},
'Total Urban Rural': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
'Urban',
'Rural',
'Total',
'Percentage urban'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 'Urban': 4219817.318000001,
 'Rural': 3413002.007000001,
 'Total': 7632819.325000002,
 'Percentage urban': 55.285172337},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 'Urban': 993837.0900000001,
 'Rural': 269362.5870000001,
 'Total': 1263199.6770000001,
 'Percentage urban': 78.6761672042},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 'Urban': 3225980.228000001,
 'Rural': 3143639.420000001,
 'Total': 6369619.648000002,
 'Percentage urban': 50.6463557681},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 'Urban': 344291.4320000001,
 'Rural': 681645.3019999997,
 'Total': 1025936.7339999998,
 'Percentage urban': 33.5587391103},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 'Urban': 2881688.7960000006,
 'Rural': 2461994.118000003,
 'Total': 5343682.914000004,
 'Percentage urban': 53.9270170476},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 'Urban': 2362378.5370000014,
 'Rural': 2560439.789,
 'Total': 4922818.326000001,
 'Percentage urban': 47.9883347416},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 'Urban': 975461.275,
 'Rural': 221729.7570000002,
 'Total': 1197191.0320000004,
 'Percentage urban': 81.4791665596},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 'Urban': 3017642.113,
 'Rural': 2719999.603,
 'Total': 5737641.716,
 'Percentage urban': 52.5937704438},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 'Urban': 1759117.8090000001,
 'Rural': 881117.0099999991,
 'Total': 2640234.818999999,
 'Percentage urban': 66.6273240676},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 'Urban': 1258524.3039999995,
 'Rural': 1838882.5930000008,
 'Total': 3097406.8970000003,
 'Percentage urban': 40.6315458656},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 'Urban': 224131.434,
 'Rural': 470928.666,
 'Total': 695060.1,
 'Percentage urban': 32.2463386979},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 'Urban': 423958.0149999998,
 'Rural': 626177.8259999999,
 'Total': 1050135.8409999998,
 'Percentage urban': 40.3717308226},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 'Urban': 547602.182,
 'Rural': 740318.3359999999,
 'Total': 1287920.518,
 'Percentage urban': 42.51832115},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 'Urban': 121315.521,
 'Rural': 312327.611,
 'Total': 433643.132,
 'Percentage urban': 27.975888939},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 'Urban': 1461.704,
 'Rural': 9754.746,
 'Total': 11216.45,
 'Percentage urban': 13.0317881326},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 'Urban': 241.092,
 'Rural': 591.255,
 'Total': 832.347,
 'Percentage urban': 28.9653233567},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 'Urban': 755.533,
 'Rural': 215.875,
 'Total': 971.408,
 'Percentage urban': 77.7771029269},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 'Urban': 2079.314,
 'Rural': 3108.634,
 'Total': 5187.948,
 'Percentage urban': 40.0797001049},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 'Urban': 22327.769,
 'Rural': 85207.113,
 'Total': 107534.882,
 'Percentage urban': 20.763280328},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 'Urban': 13771.805,
 'Rural': 37179.074,
 'Total': 50950.879,
 'Percentage urban': 27.0295729344},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 'Urban': 9767.285,
 'Rural': 16495.525,
 'Total': 26262.81,
 'Percentage urban': 37.1905557707},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 'Urban': 3245.933,
 'Rural': 15918.795,
 'Total': 19164.728,
 'Percentage urban': 16.937015751},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 'Urban': 517.387,
 'Rural': 750.928,
 'Total': 1268.315,
 'Percentage urban': 40.7932571956},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 'Urban': 119.837,
 'Rural': 139.845,
 'Total': 259.682,
 'Percentage urban': 46.1475959058},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 'Urban': 10986.62,
 'Rural': 19542.053,
 'Total': 30528.673,
 'Percentage urban': 35.9878727778},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 'Urban': 879.399,
 'Rural': 3.848,
 'Total': 883.247,
 'Percentage urban': 99.5643347784},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 'Urban': 2151.557,
 'Rural': 10349.599,
 'Total': 12501.156,
 'Percentage urban': 17.2108643393},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 'Urban': 53.989,
 'Rural': 41.246,
 'Total': 95.235,
 'Percentage urban': 56.6902924345},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 'Urban': 6827.415,
 'Rural': 8354.51,
 'Total': 15181.925,
 'Percentage urban': 44.9706805955},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 'Urban': 2534.064,
 'Rural': 10384.989,
 'Total': 12919.053,
 'Percentage urban': 19.6149361722},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 'Urban': 10525.083,
 'Rural': 33745.48,
 'Total': 44270.563,
 'Percentage urban': 23.7744503046},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 'Urban': 19958.545,
 'Rural': 39132.847,
 'Total': 59091.392,
 'Percentage urban': 33.7757232052},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 'Urban': 7663.677,
 'Rural': 9945.501,
 'Total': 17609.178,
 'Percentage urban': 43.5209241454},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 'Urban': 5447.513,
 'Rural': 11465.748,
 'Total': 16913.261,
 'Percentage urban': 32.2085315186},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 'Urban': 83483.558,
 'Rural': 85054.645,
 'Total': 168538.203,
 'Percentage urban': 49.5339077515},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 'Urban': 20161.538,
 'Rural': 10612.667,
 'Total': 30774.205,
 'Percentage urban': 65.5144072771},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 'Urban': 13912.132,
 'Rural': 10766.102,
 'Total': 24678.234,
 'Percentage urban': 56.3740987301},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 'Urban': 1959.587,
 'Rural': 2777.836,
 'Total': 4737.423,
 'Percentage urban': 41.3639862854},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 'Urban': 3540.279,
 'Rural': 11812.905,
 'Total': 15353.184,
 'Percentage urban': 23.0589238037},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 'Urban': 3613.4,
 'Rural': 1786.495,
 'Total': 5399.895,
 'Percentage urban': 66.9161159615},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 'Urban': 37348.939,
 'Rural': 46656.05,
 'Total': 84004.989,
 'Percentage urban': 44.4603819899},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 'Urban': 947.881,
 'Rural': 366.013,
 'Total': 1313.894,
 'Percentage urban': 72.1428821503},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 'Urban': 1847.776,
 'Rural': 219.785,
 'Total': 2067.561,
 'Percentage urban': 89.3698420506},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 'Urban': 152.026,
 'Rural': 56.792,
 'Total': 208.818,
 'Percentage urban': 72.8031108429},
{'Index': 45,
 'Region, subregion, country or area': 'Northern Africa',
 'Note': '',
 'Country\ncode': 912,
 'Urban': 123644.167,
 'Rural': 114140.51,
 'Total': 237784.677,
 'Percentage urban': 51.9983745631},
{'Index': 46,
 'Region, subregion, country or area': 'Algeria',
 'Note': '',
 'Country\ncode': 12,
 'Urban': 30510.016,
 'Rural': 11498.038,
 'Total': 42008.054,
 'Percentage urban': 72.6289677689},
{'Index': 47,
 'Region, subregion, country or area': 'Egypt',
 'Note': '',
 'Country\ncode': 818,
 'Urban': 42437.529,
 'Rural': 56938.212,
 'Total': 99375.741,
 'Percentage urban': 42.7041132705},
{'Index': 48,
 'Region, subregion, country or area': 'Libya',
 'Note': '',
 'Country\ncode': 434,
 'Urban': 5183.363,
 'Rural': 1287.593,
 'Total': 6470.956,
 'Percentage urban': 80.1019663864},
{'Index': 49,
 'Region, subregion, country or area': 'Morocco',
 'Note': '',
 'Country\ncode': 504,
 'Urban': 22602.743,
 'Rural': 13589.062,
 'Total': 36191.805,
 'Percentage urban': 62.4526546825},
{'Index': 50,
 'Region, subregion, country or area': 'Sudan',
 'Note': '',
 'Country\ncode': 729,
 'Urban': 14380.217,
 'Rural': 27131.309,
 'Total': 41511.526,
 'Percentage urban': 34.6415041451},
{'Index': 51,
 'Region, subregion, country or area': 'Tunisia',
 'Note': '',
 'Country\ncode': 788,
 'Urban': 8038.426,
 'Rural': 3620.748,
 'Total': 11659.174,
 'Percentage urban': 68.9450727813},
{'Index': 52,
 'Region, subregion, country or area': 'Western Sahara',
 'Note': '',
 'Country\ncode': 732,
 'Urban': 491.873,
 'Rural': 75.548,
 'Total': 567.421,
 'Percentage urban': 86.6857236514},
{'Index': 53,
 'Region, subregion, country or area': 'Southern Africa',
 'Note': '',
 'Country\ncode': 913,
 'Urban': 41970.076,
 'Rural': 24003.742,
 'Total': 65973.818,
 'Percentage urban': 63.6162606202},
{'Index': 54,
 'Region, subregion, country or area': 'Botswana',
 'Note': '',
 'Country\ncode': 72,
 'Urban': 1620.326,
 'Rural': 712.875,
 'Total': 2333.201,
 'Percentage urban': 69.4464814647},
{'Index': 55,
 'Region, subregion, country or area': 'Lesotho',
 'Note': '',
 'Country\ncode': 426,
 'Urban': 637.101,
 'Rural': 1625.909,
 'Total': 2263.01,
 'Percentage urban': 28.1528141723},
{'Index': 56,
 'Region, subregion, country or area': 'Namibia',
 'Note': '',
 'Country\ncode': 516,
 'Urban': 1294.741,
 'Rural': 1293.06,
 'Total': 2587.801,
 'Percentage urban': 50.0324793135},
{'Index': 57,
 'Region, subregion, country or area': 'South Africa',
 'Note': '',
 'Country\ncode': 710,
 'Urban': 38086.769,
 'Rural': 19311.652,
 'Total': 57398.421,
 'Percentage urban': 66.3550814403},
{'Index': 58,
 'Region, subregion, country or area': 'Swaziland',
 'Note': '',
 'Country\ncode': 748,
 'Urban': 331.139,
 'Rural': 1060.246,
 'Total': 1391.385,
 'Percentage urban': 23.799236013}]},
'URBAN FLOODING OF GREATER DHAKA IN A CHANGING CLIMATE - BUILDING RESILIENCE TO DISASTER RISK': {'headers': ['Unnamed: 0',
'Ward/Thana',
'Area in model (sq. km)',
'<0.25m',
'0.25-0.75m',
'0.75-1.5m',
'>1.5m',
'0.25-0.75m.1',
'0.75-1.5m.1',
'>1.5m.1'],
'data': [{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-56',
 'Area in model (sq. km)': 0.97,
 '<0.25m': 0.97,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 0,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-57',
 'Area in model (sq. km)': 0.13,
 '<0.25m': 0.13,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 3,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-59',
 'Area in model (sq. km)': 0.1,
 '<0.25m': 0.09,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 2,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-60',
 'Area in model (sq. km)': 0.46,
 '<0.25m': 0.3,
 '0.25-0.75m': 0.1,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 6,
 '0.75-1.5m.1': 3,
 '>1.5m.1': 1},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-61',
 'Area in model (sq. km)': 0.38,
 '<0.25m': 0.38,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 0,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-62',
 'Area in model (sq. km)': 0.63,
 '<0.25m': 0.63,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 0,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-63',
 'Area in model (sq. km)': 0.45,
 '<0.25m': 0.39,
 '0.25-0.75m': 0.1,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 1,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-64',
 'Area in model (sq. km)': 0.15,
 '<0.25m': 0.15,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 0,
 '0.75-1.5m.1': 0,
 '>1.5m.1': 0},
{'Unnamed: 0': 'Old Dhaka',
 'Ward/Thana': 'W-65',
 'Area in model (sq. km)': 0.3,
 '<0.25m': 0.23,
 '0.25-0.75m': 0.0,
 '0.75-1.5m': 0,
 '>1.5m': 0,
 '0.25-0.75m.1': 8,
 '0.75-1.5m.1': 5,
 '>1.5m.1': 5}]},
'Urban Growth Rate': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
'1950-1955',
'1955-1960',
'1960-1965',
'1965-1970',
'1970-1975',
'1975-1980',
'1980-1985',
'1985-1990',
'1990-1995',
'1995-2000',
'2000-2005',
'2005-2010',
'2010-2015',
'2015-2020',
'2020-2025',
'2025-2030',
'2030-2035',
'2035-2040',
'2040-2045',
'2045-2050'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950-1955': 3.1048134937,
 '1955-1960': 3.0960771499,
 '1960-1965': 2.9820091945,
 '1965-1970': 2.6111240853,
 '1970-1975': 2.5533367925,
 '1975-1980': 2.6224868516,
 '1980-1985': 2.7019071026,
 '1985-1990': 2.6308512718,
 '1990-1995': 2.3478860958,
 '1995-2000': 2.1535283292,
 '2000-2005': 2.2877388068,
 '2005-2010': 2.2279646803,
 '2010-2015': 2.043014646,
 '2015-2020': 1.9032191821,
 '2020-2025': 1.7300178733,
 '2025-2030': 1.5804438788,
 '2030-2035': 1.4501272048,
 '2035-2040': 1.331317209,
 '2040-2045': 1.2224916293,
 '2045-2050': 1.1308517914},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950-1955': 2.3174370584,
 '1955-1960': 2.2314689426,
 '1960-1965': 2.0167255296,
 '1965-1970': 1.6825050298,
 '1970-1975': 1.3859999775,
 '1975-1980': 1.0683462053,
 '1980-1985': 0.8867523606,
 '1985-1990': 0.8171806296,
 '1990-1995': 0.6797108173,
 '1995-2000': 0.5811711419,
 '2000-2005': 0.764973156,
 '2005-2010': 0.7637818528,
 '2010-2015': 0.51726736,
 '2015-2020': 0.4953264179,
 '2020-2025': 0.4620628182,
 '2025-2030': 0.4353473458,
 '2030-2035': 0.3981203833,
 '2035-2040': 0.3632907323,
 '2040-2045': 0.3238168674,
 '2045-2050': 0.2820756018},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950-1955': 4.20512506,
 '1955-1960': 4.1934677543,
 '1960-1965': 4.0896415207,
 '1965-1970': 3.5761133866,
 '1970-1975': 3.646755088,
 '1975-1980': 3.9041465234,
 '1980-1985': 3.9923157941,
 '1985-1990': 3.7398741966,
 '1990-1995': 3.237330831,
 '1995-2000': 2.8957373541,
 '2000-2005': 2.9303772875,
 '2005-2010': 2.7844781915,
 '2010-2015': 2.5668328986,
 '2015-2020': 2.3417054456,
 '2020-2025': 2.092037466,
 '2025-2030': 1.8831644877,
 '2030-2035': 1.7096948613,
 '2035-2040': 1.5556671972,
 '2040-2045': 1.4191883515,
 '2045-2050': 1.3070343749},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950-1955': 4.4358342175,
 '1955-1960': 4.7110672754,
 '1960-1965': 5.0966237979,
 '1965-1970': 5.5628465771,
 '1970-1975': 4.8231300626,
 '1975-1980': 5.7961455063,
 '1980-1985': 4.9070296421,
 '1985-1990': 4.8640504882,
 '1990-1995': 4.4158793454,
 '1995-2000': 3.8815406698,
 '2000-2005': 4.1453722513,
 '2005-2010': 4.0072655354,
 '2010-2015': 4.0382064087,
 '2015-2020': 3.9114612338,
 '2020-2025': 3.782680168,
 '2025-2030': 3.6141969641,
 '2030-2035': 3.4276450158,
 '2035-2040': 3.2215763952,
 '2040-2045': 3.0204087087,
 '2045-2050': 2.8235631197},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950-1955': 4.1933395881,
 '1955-1960': 4.1665008497,
 '1960-1965': 4.0350240685,
 '1965-1970': 3.4594472292,
 '1970-1975': 3.571651504,
 '1975-1980': 3.7730207264,
 '1980-1985': 3.9239926297,
 '1985-1990': 3.6511630358,
 '1990-1995': 3.1383533945,
 '1995-2000': 2.8079388169,
 '2000-2005': 2.8154588035,
 '2005-2010': 2.6608193094,
 '2010-2015': 2.4065224695,
 '2015-2020': 2.1555548801,
 '2020-2025': 1.8722982698,
 '2025-2030': 1.635196855,
 '2030-2035': 1.4379336461,
 '2035-2040': 1.2648178831,
 '2040-2045': 1.111273093,
 '2045-2050': 0.986784323},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950-1955': 3.9288378635,
 '1955-1960': 4.0665145689,
 '1960-1965': 4.0936251577,
 '1965-1970': 4.0642473414,
 '1970-1975': 4.0308541848,
 '1975-1980': 3.9496889953,
 '1980-1985': 3.7825156889,
 '1985-1990': 3.4827587815,
 '1990-1995': 2.9729417646,
 '1995-2000': 2.7009552713,
 '2000-2005': 2.6204737462,
 '2005-2010': 2.5693274567,
 '2010-2015': 2.4577951442,
 '2015-2020': 2.331320122,
 '2020-2025': 2.216221416,
 '2025-2030': 2.1134634502,
 '2030-2035': 2.0131137534,
 '2035-2040': 1.9015278537,
 '2040-2045': 1.7815621895,
 '2045-2050': 1.6528439188},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950-1955': 2.1024672238,
 '1955-1960': 2.0936495275,
 '1960-1965': 1.9737949694,
 '1965-1970': 1.7409843323,
 '1970-1975': 1.4621861595,
 '1975-1980': 1.2059165159,
 '1980-1985': 1.0899947236,
 '1985-1990': 1.0703592415,
 '1990-1995': 1.0295229537,
 '1995-2000': 0.9513810155,
 '2000-2005': 1.1342584616,
 '2005-2010': 1.1095349629,
 '2010-2015': 0.763769894,
 '2015-2020': 0.6868234582,
 '2020-2025': 0.6138531112,
 '2025-2030': 0.5701828325,
 '2030-2035': 0.5070912721,
 '2035-2040': 0.4398531911,
 '2040-2045': 0.3747384933,
 '2045-2050': 0.3152125052},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950-1955': 4.1640237114,
 '1955-1960': 4.0165982874,
 '1960-1965': 3.8172920445,
 '1965-1970': 3.2103129824,
 '1970-1975': 3.2866061889,
 '1975-1980': 3.5152351954,
 '1980-1985': 3.606729045,
 '1985-1990': 3.3828879665,
 '1990-1995': 2.8908911216,
 '1995-2000': 2.5973399183,
 '2000-2005': 2.6652295204,
 '2005-2010': 2.5441296186,
 '2010-2015': 2.3568749116,
 '2015-2020': 2.1436093906,
 '2020-2025': 1.8891342297,
 '2025-2030': 1.6655225501,
 '2030-2035': 1.479862795,
 '2035-2040': 1.3166451441,
 '2040-2045': 1.1717313629,
 '2045-2050': 1.0519478233},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950-1955': 4.619996927,
 '1955-1960': 4.312483166,
 '1960-1965': 3.9437489671,
 '1965-1970': 2.9663555527,
 '1970-1975': 2.9631029587,
 '1975-1980': 3.2334101294,
 '1980-1985': 3.5153476587,
 '1985-1990': 3.2777139605,
 '1990-1995': 2.7794126667,
 '1995-2000': 2.4628662477,
 '2000-2005': 2.576015543,
 '2005-2010': 2.4040634737,
 '2010-2015': 2.1867982984,
 '2015-2020': 1.8564416892,
 '2020-2025': 1.4424196166,
 '2025-2030': 1.1090820622,
 '2030-2035': 0.8356621773,
 '2035-2040': 0.6072001598,
 '2040-2045': 0.4182805586,
 '2045-2050': 0.2915031497},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950-1955': 3.4236658117,
 '1955-1960': 3.5115675668,
 '1960-1965': 3.5951532738,
 '1965-1970': 3.6354336664,
 '1970-1975': 3.8291148596,
 '1975-1980': 3.9693002668,
 '1980-1985': 3.7504298497,
 '1985-1990': 3.5462090316,
 '1990-1995': 3.061635077,
 '1995-2000': 2.8001386765,
 '2000-2005': 2.7979049544,
 '2005-2010': 2.7494965817,
 '2010-2015': 2.6015490311,
 '2015-2020': 2.5454858341,
 '2020-2025': 2.4877562793,
 '2025-2030': 2.3694154027,
 '2030-2035': 2.242213018,
 '2035-2040': 2.097557044,
 '2040-2045': 1.9409128787,
 '2045-2050': 1.7721226702},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950-1955': 3.8409754059,
 '1955-1960': 4.8293892518,
 '1960-1965': 4.7045720663,
 '1965-1970': 5.5130433315,
 '1970-1975': 4.6998732273,
 '1975-1980': 4.2303604289,
 '1980-1985': 4.1784304787,
 '1985-1990': 4.3510948075,
 '1990-1995': 4.1668267018,
 '1995-2000': 3.7558152105,
 '2000-2005': 3.89692413,
 '2005-2010': 3.984170931,
 '2010-2015': 4.0817189708,
 '2015-2020': 4.031763845,
 '2020-2025': 3.9581058437,
 '2025-2030': 3.8487192178,
 '2030-2035': 3.7030125843,
 '2035-2040': 3.5196634305,
 '2040-2045': 3.3103893924,
 '2045-2050': 3.1006634661},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950-1955': 4.9112185061,
 '1955-1960': 5.1558228896,
 '1960-1965': 4.4584745001,
 '1965-1970': 4.5834022564,
 '1970-1975': 4.8532247005,
 '1975-1980': 4.8254860454,
 '1980-1985': 4.7717188947,
 '1985-1990': 4.7686826987,
 '1990-1995': 4.1765862038,
 '1995-2000': 3.8672059296,
 '2000-2005': 4.0682731195,
 '2005-2010': 4.142548106,
 '2010-2015': 4.1430620339,
 '2015-2020': 3.9840484938,
 '2020-2025': 3.8171842647,
 '2025-2030': 3.6469688295,
 '2030-2035': 3.4661665339,
 '2035-2040': 3.2739660834,
 '2040-2045': 3.0852731606,
 '2045-2050': 2.8947514984},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950-1955': 4.7525129367,
 '1955-1960': 4.9341182261,
 '1960-1965': 4.4894290098,
 '1965-1970': 4.3907937169,
 '1970-1975': 4.4439411393,
 '1975-1980': 4.4034361344,
 '1980-1985': 4.4568994292,
 '1985-1990': 4.383957142,
 '1990-1995': 3.786745159,
 '1995-2000': 3.3554502283,
 '2000-2005': 3.5199504312,
 '2005-2010': 3.6144798672,
 '2010-2015': 3.6964044188,
 '2015-2020': 3.5751144235,
 '2020-2025': 3.4430309443,
 '2025-2030': 3.3150962634,
 '2030-2035': 3.1863598644,
 '2035-2040': 3.0435320289,
 '2040-2045': 2.8880341455,
 '2045-2050': 2.7144550727},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950-1955': 5.2095488835,
 '1955-1960': 5.3784879453,
 '1960-1965': 5.7929730637,
 '1965-1970': 6.0086063356,
 '1970-1975': 5.9874807583,
 '1975-1980': 6.0720541317,
 '1980-1985': 5.1026927743,
 '1985-1990': 5.1434503777,
 '1990-1995': 4.3625862074,
 '1995-2000': 4.1788227241,
 '2000-2005': 4.1683980727,
 '2005-2010': 4.4388093519,
 '2010-2015': 4.5509463069,
 '2015-2020': 4.4479142406,
 '2020-2025': 4.3213065647,
 '2025-2030': 4.1665847831,
 '2030-2035': 3.9757693196,
 '2035-2040': 3.7436528467,
 '2040-2045': 3.5020023121,
 '2045-2050': 3.2759467667},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950-1955': 3.659852025,
 '1955-1960': 3.7381629746,
 '1960-1965': 3.9794194153,
 '1965-1970': 6.6239539059,
 '1970-1975': 5.4934309028,
 '1975-1980': 6.4490556592,
 '1980-1985': 6.3586197034,
 '1985-1990': 6.4888196754,
 '1990-1995': 4.715153353,
 '1995-2000': 4.1040159681,
 '2000-2005': 5.5302005563,
 '2005-2010': 5.8622133623,
 '2010-2015': 5.5589556678,
 '2015-2020': 5.6809148502,
 '2020-2025': 5.4263323906,
 '2025-2030': 5.1721797997,
 '2030-2035': 4.9930216009,
 '2035-2040': 4.8541872251,
 '2040-2045': 4.6844461133,
 '2045-2050': 4.4510704382},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950-1955': 8.4932055564,
 '1955-1960': 7.9809008111,
 '1960-1965': 7.6795043052,
 '1965-1970': 4.7272375364,
 '1970-1975': 4.060070419,
 '1975-1980': 5.3657102982,
 '1980-1985': 4.7234003493,
 '1985-1990': 4.7409727183,
 '1990-1995': 3.1897072786,
 '1995-2000': 2.4784489275,
 '2000-2005': 2.2577588647,
 '2005-2010': 2.4721454436,
 '2010-2015': 2.7474272102,
 '2015-2020': 2.8699730974,
 '2020-2025': 2.9670557685,
 '2025-2030': 3.0590020616,
 '2030-2035': 2.997569053,
 '2035-2040': 2.8383047018,
 '2040-2045': 2.6758723927,
 '2045-2050': 2.5053663316},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950-1955': 4.7655683789,
 '1955-1960': 5.9091506161,
 '1960-1965': 8.538341092,
 '1965-1970': 8.4935730766,
 '1970-1975': 8.4539343625,
 '1975-1980': 10.8386726633,
 '1980-1985': 4.1761994646,
 '1985-1990': 6.8189749385,
 '1990-1995': 1.4009056011,
 '1995-2000': 2.6516474422,
 '2000-2005': 1.81129843,
 '2005-2010': 1.7244316082,
 '2010-2015': 1.8244290868,
 '2015-2020': 1.6710570887,
 '2020-2025': 1.5552517676,
 '2025-2030': 1.4219140178,
 '2030-2035': 1.2714471206,
 '2035-2040': 1.0907161504,
 '2040-2045': 0.9091533064,
 '2045-2050': 0.7481562105},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950-1955': 5.0369456403,
 '1955-1960': 5.4425631385,
 '1960-1965': 5.7131825725,
 '1965-1970': 4.6324251588,
 '1970-1975': 3.9939259902,
 '1975-1980': 4.0404777758,
 '1980-1985': 4.6809564613,
 '1985-1990': 6.1017115836,
 '1990-1995': 3.344853153,
 '1995-2000': 5.1945133467,
 '2000-2005': 6.2720707077,
 '2005-2010': 4.4833575962,
 '2010-2015': 3.6299031595,
 '2015-2020': 3.8596419143,
 '2020-2025': 3.6724333758,
 '2025-2030': 3.4704522772,
 '2030-2035': 3.2784533593,
 '2035-2040': 3.0588125251,
 '2040-2045': 2.8298557888,
 '2045-2050': 2.5821324757},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950-1955': 5.2830263614,
 '1955-1960': 5.4348328322,
 '1960-1965': 5.7295338117,
 '1965-1970': 5.0271269285,
 '1970-1975': 4.6617444764,
 '1975-1980': 3.5072972717,
 '1980-1985': 4.8257531829,
 '1985-1990': 5.2277958489,
 '1990-1995': 5.3351065035,
 '1995-2000': 4.2633760736,
 '2000-2005': 4.1127546811,
 '2005-2010': 4.6363416006,
 '2010-2015': 4.8970295662,
 '2015-2020': 4.6349377222,
 '2020-2025': 4.4026378927,
 '2025-2030': 4.1383167052,
 '2030-2035': 3.8644690906,
 '2035-2040': 3.5761500696,
 '2040-2045': 3.2798151795,
 '2045-2050': 3.0208930857},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950-1955': 5.5388267863,
 '1955-1960': 5.7320586027,
 '1960-1965': 6.3047973097,
 '1965-1970': 6.9620254219,
 '1970-1975': 8.1556489012,
 '1975-1980': 7.5083421799,
 '1980-1985': 4.4038361373,
 '1985-1990': 4.3092161433,
 '1990-1995': 4.8469808175,
 '1995-2000': 4.5054702501,
 '2000-2005': 4.4455309038,
 '2005-2010': 4.4215693201,
 '2010-2015': 4.3582252563,
 '2015-2020': 4.2309847094,
 '2020-2025': 4.0887977271,
 '2025-2030': 3.9495011416,
 '2030-2035': 3.7699608455,
 '2035-2040': 3.5293462813,
 '2040-2045': 3.2734155205,
 '2045-2050': 3.0288378178},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950-1955': 5.2651437675,
 '1955-1960': 5.3908512904,
 '1960-1965': 5.4937206662,
 '1965-1970': 5.221425749,
 '1970-1975': 5.7191499398,
 '1975-1980': 5.3740454698,
 '1980-1985': 5.3188901047,
 '1985-1990': 5.2084233152,
 '1990-1995': 4.8083304215,
 '1995-2000': 4.1427675399,
 '2000-2005': 4.230778248,
 '2005-2010': 4.9147192746,
 '2010-2015': 4.6622998353,
 '2015-2020': 4.480236635,
 '2020-2025': 4.2550656659,
 '2025-2030': 3.9741881263,
 '2030-2035': 3.6523985743,
 '2035-2040': 3.3964052195,
 '2040-2045': 3.1803376766,
 '2045-2050': 2.973665516},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950-1955': 4.1782755858,
 '1955-1960': 4.3776567194,
 '1960-1965': 4.5260266446,
 '1965-1970': 6.7138611323,
 '1970-1975': 7.4782067924,
 '1975-1980': 6.4019197055,
 '1980-1985': 5.4601513674,
 '1985-1990': 7.9577320166,
 '1990-1995': 3.7240018263,
 '1995-2000': 4.695286296,
 '2000-2005': 3.3282593079,
 '2005-2010': 3.663426955,
 '2010-2015': 3.9105089813,
 '2015-2020': 4.1901072526,
 '2020-2025': 4.4111083491,
 '2025-2030': 4.6155621451,
 '2030-2035': 4.7001839329,
 '2035-2040': 4.5345480988,
 '2040-2045': 4.2909873447,
 '2045-2050': 4.0399122138},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950-1955': 4.4197436385,
 '1955-1960': 5.005044413,
 '1960-1965': 4.6247589941,
 '1965-1970': 3.7185201612,
 '1970-1975': 1.9439636775,
 '1975-1980': 1.0810348255,
 '1980-1985': 0.9915169918,
 '1985-1990': 1.5052201497,
 '1990-1995': 1.0510546464,
 '1995-2000': 0.6907656928,
 '2000-2005': 0.3489224153,
 '2005-2010': 0.154048085,
 '2010-2015': -0.0852980294,
 '2015-2020': 0.1140480079,
 '2020-2025': 0.2814144452,
 '2025-2030': 0.4468131725,
 '2030-2035': 0.564384035,
 '2035-2040': 0.6397973657,
 '2040-2045': 0.6130808911,
 '2045-2050': 0.4867235245},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950-1955': 11.1790223052,
 '1955-1960': 11.0601678828,
 '1960-1965': 10.7875777109,
 '1965-1970': 6.4720717358,
 '1970-1975': 5.9676387828,
 '1975-1980': 5.610650663,
 '1980-1985': 7.2186955131,
 '1985-1990': 7.2418039057,
 '1990-1995': 8.0326886924,
 '1995-2000': 6.8017104851,
 '2000-2005': 4.411407038,
 '2005-2010': 2.6576572483,
 '2010-2015': 1.9753760391,
 '2015-2020': 2.0492809014,
 '2020-2025': 2.1899348254,
 '2025-2030': 2.4071923011,
 '2030-2035': 2.6201323427,
 '2035-2040': 2.7640900953,
 '2040-2045': 2.6226398642,
 '2045-2050': 2.3934105508},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950-1955': 3.9915238483,
 '1955-1960': 4.2158170965,
 '1960-1965': 4.7889662691,
 '1965-1970': 4.8970254856,
 '1970-1975': 6.2246060296,
 '1975-1980': 6.5365835358,
 '1980-1985': 8.4572825561,
 '1985-1990': 6.6124031086,
 '1990-1995': 5.3746249123,
 '1995-2000': 3.8675749038,
 '2000-2005': 3.5445182816,
 '2005-2010': 4.112242558,
 '2010-2015': 4.4598216309,
 '2015-2020': 4.3528700648,
 '2020-2025': 4.2448038187,
 '2025-2030': 4.116291391,
 '2030-2035': 3.95008171,
 '2035-2040': 3.7392968615,
 '2040-2045': 3.4967448322,
 '2045-2050': 3.2627954161},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950-1955': 6.6911756598,
 '1955-1960': 6.0526837418,
 '1960-1965': 6.0392032906,
 '1965-1970': 5.1090025491,
 '1970-1975': 2.2612331427,
 '1975-1980': 4.6802912561,
 '1980-1985': 6.6318870773,
 '1985-1990': 5.3557774818,
 '1990-1995': 3.1322484944,
 '1995-2000': 2.932603918,
 '2000-2005': 2.532689355,
 '2005-2010': 1.411477799,
 '2010-2015': 0.9452468851,
 '2015-2020': 0.8183697018,
 '2020-2025': 0.7264055229,
 '2025-2030': 0.6171069949,
 '2030-2035': 0.4993632476,
 '2035-2040': 0.3605881007,
 '2040-2045': 0.2156254606,
 '2045-2050': 0.0835059406},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950-1955': 4.9590878434,
 '1955-1960': 5.0631845867,
 '1960-1965': 4.0061893672,
 '1965-1970': 5.0476446808,
 '1970-1975': 7.4714590765,
 '1975-1980': 6.6244144669,
 '1980-1985': 4.8640583351,
 '1985-1990': 4.720934815,
 '1990-1995': 7.9493369709,
 '1995-2000': 14.3974709618,
 '2000-2005': 4.771917445,
 '2005-2010': 2.6387787235,
 '2010-2015': 2.6139040972,
 '2015-2020': 2.8588374689,
 '2020-2025': 3.0709292743,
 '2025-2030': 3.3428173399,
 '2030-2035': 3.6271959502,
 '2035-2040': 3.8216591382,
 '2040-2045': 3.6548624489,
 '2045-2050': 3.3724562633},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950-1955': 1.415593594,
 '1955-1960': 1.4669091163,
 '1960-1965': 5.9664922575,
 '1965-1970': 5.5610048476,
 '1970-1975': 5.96708442,
 '1975-1980': 3.429444005,
 '1980-1985': 1.0104904066,
 '1985-1990': 0.2155498406,
 '1990-1995': 1.798482655,
 '1995-2000': 1.4472684311,
 '2000-2005': 2.2734488791,
 '2005-2010': 1.2256757269,
 '2010-2015': 1.2641640804,
 '2015-2020': 1.2592627453,
 '2020-2025': 0.9918455035,
 '2025-2030': 0.8079590836,
 '2030-2035': 0.6969482084,
 '2035-2040': 0.6036106177,
 '2040-2045': 0.4855268226,
 '2045-2050': 0.3252884189},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950-1955': 5.0332751258,
 '1955-1960': 5.0541120453,
 '1960-1965': 4.9989481504,
 '1965-1970': 4.8617125501,
 '1970-1975': 4.7264280009,
 '1975-1980': 10.8481371923,
 '1980-1985': 2.2675612196,
 '1985-1990': 2.8111859675,
 '1990-1995': 1.9717027105,
 '1995-2000': 4.2602977276,
 '2000-2005': 4.6482804992,
 '2005-2010': 4.5185339153,
 '2010-2015': 4.7710274286,
 '2015-2020': 4.229534073,
 '2020-2025': 4.2022915638,
 '2025-2030': 4.0548352202,
 '2030-2035': 3.8693769717,
 '2035-2040': 3.6545853599,
 '2040-2045': 3.4476534262,
 '2045-2050': 3.250467036},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950-1955': 0.9131776898,
 '1955-1960': 1.5145111161,
 '1960-1965': 1.8533587182,
 '1965-1970': 2.0925447865,
 '1970-1975': 2.2996579333,
 '1975-1980': 2.5263638585,
 '1980-1985': 5.8318346056,
 '1985-1990': 7.1156214676,
 '1990-1995': 2.4717057843,
 '1995-2000': 4.8765331671,
 '2000-2005': 4.5883453952,
 '2005-2010': 5.1327678137,
 '2010-2015': 4.3962972785,
 '2015-2020': 4.0954920885,
 '2020-2025': 4.1219921831,
 '2025-2030': 4.1804647653,
 '2030-2035': 4.2015999446,
 '2035-2040': 4.0494677942,
 '2040-2045': 3.8363947783,
 '2045-2050': 3.6196672678},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950-1955': 7.1887408755,
 '1955-1960': 7.278194701,
 '1960-1965': 7.7422889175,
 '1965-1970': 7.0909077901,
 '1970-1975': 3.8295051811,
 '1975-1980': 4.3072839715,
 '1980-1985': 6.9811250117,
 '1985-1990': 7.3065284181,
 '1990-1995': 6.2482124504,
 '1995-2000': 5.9493703426,
 '2000-2005': 6.1795910543,
 '2005-2010': 6.1186025228,
 '2010-2015': 5.9597663911,
 '2015-2020': 5.6980709379,
 '2020-2025': 5.4075511588,
 '2025-2030': 5.1017495612,
 '2030-2035': 4.7658917647,
 '2035-2040': 4.3988455854,
 '2040-2045': 4.0611437668,
 '2045-2050': 3.8045201904},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950-1955': 7.3353725635,
 '1955-1960': 6.3157161442,
 '1960-1965': 5.7482196909,
 '1965-1970': 8.3284509536,
 '1970-1975': 10.2235126878,
 '1975-1980': 8.4611977722,
 '1980-1985': 5.9502982625,
 '1985-1990': 5.4476041687,
 '1990-1995': 4.9402328358,
 '1995-2000': 4.2827339134,
 '2000-2005': 5.0024232719,
 '2005-2010': 5.6069575816,
 '2010-2015': 5.4683451152,
 '2015-2020': 5.2179815901,
 '2020-2025': 4.8946871262,
 '2025-2030': 4.5886970013,
 '2030-2035': 4.2772076802,
 '2035-2040': 3.9389923029,
 '2040-2045': 3.6812675463,
 '2045-2050': 3.4523590682},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950-1955': 7.2733320498,
 '1955-1960': 7.3680146951,
 '1960-1965': 8.2082920055,
 '1965-1970': 8.3885625046,
 '1970-1975': 6.2830716421,
 '1975-1980': 6.0305049166,
 '1980-1985': 3.2468014375,
 '1985-1990': 2.7413085697,
 '1990-1995': 1.3858174354,
 '1995-2000': 1.5592331891,
 '2000-2005': 3.8743392764,
 '2005-2010': 4.0631552599,
 '2010-2015': 4.2678990607,
 '2015-2020': 4.229924996,
 '2020-2025': 4.1459768264,
 '2025-2030': 4.0334908059,
 '2030-2035': 3.8601175218,
 '2035-2040': 3.6550099078,
 '2040-2045': 3.4594642518,
 '2045-2050': 3.2670550722},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950-1955': 4.7694890664,
 '1955-1960': 4.8300689784,
 '1960-1965': 6.2179565244,
 '1965-1970': 6.6386235956,
 '1970-1975': 6.0390311131,
 '1975-1980': 5.5331777691,
 '1980-1985': 6.3410484442,
 '1985-1990': 5.8745470046,
 '1990-1995': 3.9259211769,
 '1995-2000': 2.7710912241,
 '2000-2005': 1.3489040159,
 '2005-2010': 1.1542952576,
 '2010-2015': 1.7726580811,
 '2015-2020': 2.1889651396,
 '2020-2025': 2.407809894,
 '2025-2030': 2.7303638724,
 '2030-2035': 3.0407558127,
 '2035-2040': 3.2556110443,
 '2040-2045': 3.1211916529,
 '2045-2050': 2.874753677},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950-1955': 4.2805511734,
 '1955-1960': 4.4808597842,
 '1960-1965': 4.4336268591,
 '1965-1970': 4.7196325424,
 '1970-1975': 5.3246907701,
 '1975-1980': 4.9379762556,
 '1980-1985': 4.7543419041,
 '1985-1990': 4.795459846,
 '1990-1995': 4.9562795924,
 '1995-2000': 4.1031117639,
 '2000-2005': 4.4283568433,
 '2005-2010': 4.3918239245,
 '2010-2015': 4.313415967,
 '2015-2020': 4.1516144774,
 '2020-2025': 3.9812128156,
 '2025-2030': 3.8015324186,
 '2030-2035': 3.606076792,
 '2035-2040': 3.3875115201,
 '2040-2045': 3.157922878,
 '2045-2050': 2.9336405168},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950-1955': 5.5803746981,
 '1955-1960': 5.1384052049,
 '1960-1965': 5.5113081596,
 '1965-1970': 5.3494449625,
 '1970-1975': 7.4298428172,
 '1975-1980': 7.7941438347,
 '1980-1985': 7.8859324666,
 '1985-1990': 6.795926306,
 '1990-1995': 6.6442068931,
 '1995-2000': 5.3485820363,
 '2000-2005': 5.6982972186,
 '2005-2010': 4.8737290051,
 '2010-2015': 4.7044011686,
 '2015-2020': 4.3195841124,
 '2020-2025': 4.0402910991,
 '2025-2030': 3.7823338914,
 '2030-2035': 3.5262960716,
 '2035-2040': 3.2666495455,
 '2040-2045': 3.0407831547,
 '2045-2050': 2.8407663869},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950-1955': 5.825157363,
 '1955-1960': 5.8702455339,
 '1960-1965': 6.0313417632,
 '1965-1970': 6.1298256682,
 '1970-1975': 8.5824440786,
 '1975-1980': 6.027706677,
 '1980-1985': 5.6068153799,
 '1985-1990': 4.8730030706,
 '1990-1995': 4.1969134325,
 '1995-2000': 3.8756390664,
 '2000-2005': 3.905507672,
 '2005-2010': 3.9383515378,
 '2010-2015': 3.8183768464,
 '2015-2020': 3.6282150536,
 '2020-2025': 3.4331919459,
 '2025-2030': 3.2378227292,
 '2030-2035': 3.0480219884,
 '2035-2040': 2.8771285168,
 '2040-2045': 2.7015525583,
 '2045-2050': 2.5191956473},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950-1955': 4.4477668812,
 '1955-1960': 4.6997876751,
 '1960-1965': 4.987167219,
 '1965-1970': 5.1926610155,
 '1970-1975': 4.9823840184,
 '1975-1980': 3.6021791579,
 '1980-1985': 3.8457207476,
 '1985-1990': 2.909638399,
 '1990-1995': 2.8482867976,
 '1995-2000': 2.4838863124,
 '2000-2005': 2.1211852092,
 '2005-2010': 1.9298491246,
 '2010-2015': 1.1278708243,
 '2015-2020': 2.5161680064,
 '2020-2025': 3.32140982,
 '2025-2030': 3.4800815783,
 '2030-2035': 3.3790789623,
 '2035-2040': 3.1275973681,
 '2040-2045': 2.8804946795,
 '2045-2050': 2.6618674898},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950-1955': 5.7749880865,
 '1955-1960': 5.8087886039,
 '1960-1965': 6.5059873471,
 '1965-1970': 8.3081851679,
 '1970-1975': 8.2392291068,
 '1975-1980': 5.7348455523,
 '1980-1985': 3.4464990073,
 '1985-1990': 4.1565391542,
 '1990-1995': 3.8550873913,
 '1995-2000': 3.6591993859,
 '2000-2005': 3.9095384411,
 '2005-2010': 3.4917146656,
 '2010-2015': 3.7617583017,
 '2015-2020': 3.8838543069,
 '2020-2025': 4.09678325,
 '2025-2030': 4.2680629532,
 '2030-2035': 4.3854036014,
 '2035-2040': 4.2639353782,
 '2040-2045': 4.0085494588,
 '2045-2050': 3.7529953451},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950-1955': 4.557641745,
 '1955-1960': 4.7117056563,
 '1960-1965': 4.8512900069,
 '1965-1970': 4.9120179046,
 '1970-1975': 5.0636414838,
 '1975-1980': 4.9373941704,
 '1980-1985': 4.6522564821,
 '1985-1990': 3.5320563761,
 '1990-1995': 3.497773896,
 '1995-2000': 3.6293427239,
 '2000-2005': 3.608296345,
 '2005-2010': 4.0366224095,
 '2010-2015': 3.3102285428,
 '2015-2020': 3.2776273379,
 '2020-2025': 3.1894300947,
 '2025-2030': 3.127741881,
 '2030-2035': 3.0306275158,
 '2035-2040': 2.8762716335,
 '2040-2045': 2.6814019294,
 '2045-2050': 2.4953225248},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950-1955': 3.6421993464,
 '1955-1960': 3.9431501603,
 '1960-1965': 3.5975530975,
 '1965-1970': 3.8073383213,
 '1970-1975': 3.6623514767,
 '1975-1980': 3.7568391117,
 '1980-1985': 3.5479730565,
 '1985-1990': 4.3737732471,
 '1990-1995': 5.0647717335,
 '1995-2000': 3.8204341761,
 '2000-2005': 4.3207853852,
 '2005-2010': 4.5919159979,
 '2010-2015': 4.6443261954,
 '2015-2020': 4.5316881027,
 '2020-2025': 4.3301570735,
 '2025-2030': 4.1256487713,
 '2030-2035': 3.9015557203,
 '2035-2040': 3.6538680169,
 '2040-2045': 3.3859613849,
 '2045-2050': 3.1201470093},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950-1955': 6.688440105,
 '1955-1960': 5.8259579583,
 '1960-1965': 2.4002585259,
 '1965-1970': 2.3344900972,
 '1970-1975': -2.9752569265,
 '1975-1980': -0.0095531113,
 '1980-1985': 8.2417016541,
 '1985-1990': 6.4441110316,
 '1990-1995': 6.4203278499,
 '1995-2000': 7.7752223321,
 '2000-2005': 7.4301414367,
 '2005-2010': 7.2126924044,
 '2010-2015': 5.6048891061,
 '2015-2020': 4.2783871005,
 '2020-2025': 3.6241260084,
 '2025-2030': 3.1820619842,
 '2030-2035': 2.7789709093,
 '2035-2040': 2.5544939176,
 '2040-2045': 2.3232066535,
 '2045-2050': 2.1204572226},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950-1955': 4.6881524269,
 '1955-1960': 4.8314285765,
 '1960-1965': 7.5380071519,
 '1965-1970': 7.9968239454,
 '1970-1975': 7.8200609796,
 '1975-1980': 7.12728709,
 '1980-1985': 5.2339419677,
 '1985-1990': 4.7967172018,
 '1990-1995': 4.2040346437,
 '1995-2000': 3.5685716586,
 '2000-2005': 3.5017205265,
 '2005-2010': 3.8560827393,
 '2010-2015': 3.8512730595,
 '2015-2020': 2.6121903065,
 '2020-2025': 2.2710539385,
 '2025-2030': 2.0305465043,
 '2030-2035': 1.851970152,
 '2035-2040': 1.7055673365,
 '2040-2045': 1.5799649499,
 '2045-2050': 1.4422452712},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950-1955': 1.3541428579,
 '1955-1960': 3.5186327068,
 '1960-1965': 6.2948152558,
 '1965-1970': 8.7561125913,
 '1970-1975': 3.5201091452,
 '1975-1980': 3.9173911312,
 '1980-1985': 4.3078887708,
 '1985-1990': 4.6337759783,
 '1990-1995': 4.2541132746,
 '1995-2000': 3.7150980837,
 '2000-2005': 4.358180154,
 '2005-2010': 4.1868597783,
 '2010-2015': 3.793294865,
 '2015-2020': 3.331516433,
 '2020-2025': 2.9638089935,
 '2025-2030': 2.6718113659,
 '2030-2035': 2.3802297567,
 '2035-2040': 2.1093009575,
 '2040-2045': 1.9343957989,
 '2045-2050': 1.7756787602}]},
'Urban Population Annual': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
2000,
2001,
2002,
2003,
2004,
2005,
2006,
2007,
2008,
2009,
2010,
2011,
2012,
2013,
2014,
2015,
2016,
2017,
2018,
2019,
2020,
2021,
2022,
2023,
2024,
2025,
2026,
2027,
2028,
2029,
2030,
2031,
2032,
2033,
2034,
2035,
2036,
2037,
2038,
2039,
2040,
2041,
2042,
2043,
2044,
2045,
2046,
2047,
2048,
2049,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '2000': 2868307.512999999,
 '2001': 2933078.51,
 '2002': 3001808.223000001,
 '2003': 3071743.997000001,
 '2004': 3143044.892000001,
 '2005': 3215905.863000001,
 '2006': 3289446.2259999984,
 '2007': 3363609.560000001,
 '2008': 3439719.127999999,
 '2009': 3516830.262999999,
 '2010': 3594868.145999999,
 '2011': 3671423.8719999995,
 '2012': 3747842.5860000006,
 '2013': 3824990.328999999,
 '2014': 3902831.9340000018,
 '2015': 3981497.662999999,
 '2016': 4060652.683000001,
 '2017': 4140188.5940000014,
 '2018': 4219817.318000001,
 '2019': 4299438.617999998,
 '2020': 4378993.944000001,
 '2021': 4458417.152999999,
 '2022': 4537671.316999998,
 '2023': 4616769.9410000015,
 '2024': 4695752.643,
 '2025': 4774646.303,
 '2026': 4853440.041999999,
 '2027': 4932106.155,
 '2028': 5010636.794000001,
 '2029': 5089023.789,
 '2030': 5167257.546,
 '2031': 5245333.710999999,
 '2032': 5323244.862000001,
 '2033': 5400979.916,
 '2034': 5478518.637,
 '2035': 5555833.476999998,
 '2036': 5632877.619999996,
 '2037': 5709649.218000001,
 '2038': 5786163.111000001,
 '2039': 5862368.1049999995,
 '2040': 5938249.026000003,
 '2041': 6013773.229999998,
 '2042': 6088940.515,
 '2043': 6163655.296,
 '2044': 6238212.208999999,
 '2045': 6312544.819000001,
 '2046': 6386625.322000001,
 '2047': 6460427.625000002,
 '2048': 6533911.568999997,
 '2049': 6607033.749000002,
 '2050': 6679756.161999998},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '2000': 883879.932,
 '2001': 890091.1059999999,
 '2002': 897039.491,
 '2003': 904042.3930000003,
 '2004': 911130.4480000001,
 '2005': 918342.0160000001,
 '2006': 925585.7050000001,
 '2007': 932935.5720000002,
 '2008': 940278.0829999996,
 '2009': 947392.8119999999,
 '2010': 954090.9290000002,
 '2011': 959723.6109999998,
 '2012': 964742.765,
 '2013': 969571.493,
 '2014': 974309.491,
 '2015': 979088.8050000002,
 '2016': 983955.158,
 '2017': 988878.7890000001,
 '2018': 993837.0900000001,
 '2019': 998771.644,
 '2020': 1003639.9990000001,
 '2021': 1008431.3729999999,
 '2022': 1013159.5790000001,
 '2023': 1017835.203,
 '2024': 1022476.827,
 '2025': 1027097.159,
 '2026': 1031698.148,
 '2027': 1036271.0920000001,
 '2028': 1040805.0329999999,
 '2029': 1045284.847,
 '2030': 1049699.4640000002,
 '2031': 1054044.1739999999,
 '2032': 1058321.874,
 '2033': 1062536.6420000002,
 '2034': 1066695.6449999998,
 '2035': 1070804.1600000001,
 '2036': 1074860.9919999999,
 '2037': 1078855.669,
 '2038': 1082780.316,
 '2039': 1086638.285,
 '2040': 1090432.5520000001,
 '2041': 1094159.188,
 '2042': 1097804.944,
 '2043': 1101364.577,
 '2044': 1104839.1690000002,
 '2045': 1108231.2740000002,
 '2046': 1111544.994,
 '2047': 1114780.9559999998,
 '2048': 1117935.0410000002,
 '2049': 1121000.402,
 '2050': 1123972.267},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '2000': 1984427.5809999988,
 '2001': 2042987.404,
 '2002': 2104768.7320000012,
 '2003': 2167701.6040000007,
 '2004': 2231914.4440000006,
 '2005': 2297563.8470000005,
 '2006': 2363860.5209999983,
 '2007': 2430673.988000001,
 '2008': 2499441.0449999995,
 '2009': 2569437.450999999,
 '2010': 2640777.2169999983,
 '2011': 2711700.2609999995,
 '2012': 2783099.8210000005,
 '2013': 2855418.835999999,
 '2014': 2928522.443000002,
 '2015': 3002408.8579999986,
 '2016': 3076697.525000001,
 '2017': 3151309.805000001,
 '2018': 3225980.228000001,
 '2019': 3300666.9739999976,
 '2020': 3375353.945000001,
 '2021': 3449985.779999999,
 '2022': 3524511.737999998,
 '2023': 3598934.7380000018,
 '2024': 3673275.816,
 '2025': 3747549.1440000003,
 '2026': 3821741.894,
 '2027': 3895835.063,
 '2028': 3969831.7610000004,
 '2029': 4043738.942,
 '2030': 4117558.082,
 '2031': 4191289.5369999995,
 '2032': 4264922.988000001,
 '2033': 4338443.274,
 '2034': 4411822.992000001,
 '2035': 4485029.316999998,
 '2036': 4558016.627999997,
 '2037': 4630793.5490000015,
 '2038': 4703382.795000001,
 '2039': 4775729.819999999,
 '2040': 4847816.474000003,
 '2041': 4919614.041999998,
 '2042': 4991135.5709999995,
 '2043': 5062290.719,
 '2044': 5133373.039999999,
 '2045': 5204313.545000001,
 '2046': 5275080.328000001,
 '2047': 5345646.669000003,
 '2048': 5415976.527999997,
 '2049': 5486033.347000002,
 '2050': 5555783.894999998},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '2000': 166314.7290000001,
 '2001': 173225.9829999999,
 '2002': 180623.79,
 '2003': 188378.5329999999,
 '2004': 196357.903,
 '2005': 204619.174,
 '2006': 213008.476,
 '2007': 221245.97,
 '2008': 230432.6169999999,
 '2009': 240005.381,
 '2010': 250013.231,
 '2011': 260477.981,
 '2012': 271243.375,
 '2013': 282410.3259999999,
 '2014': 293982.795,
 '2015': 305950.7559999999,
 '2016': 318314.785,
 '2017': 331089.2349999999,
 '2018': 344291.4320000001,
 '2019': 357936.884,
 '2020': 372038.455,
 '2021': 386603.2160000001,
 '2022': 401632.51,
 '2023': 417126.5219999999,
 '2024': 433082.3280000001,
 '2025': 449497.9220000001,
 '2026': 466373.687,
 '2027': 483712.416,
 '2028': 501516.63,
 '2029': 519789.0169999998,
 '2030': 538528.855,
 '2031': 557739.726,
 '2032': 577419.488,
 '2033': 597563.1209999997,
 '2034': 618162.839,
 '2035': 639203.7940000001,
 '2036': 660677.785,
 '2037': 682572.1989999998,
 '2038': 704920.3859999998,
 '2039': 727703.9620000002,
 '2040': 750922.2739999999,
 '2041': 774564.3109999998,
 '2042': 798637.907,
 '2043': 823124.0479999998,
 '2044': 848026.598,
 '2045': 873337.9419999998,
 '2046': 899048.6970000002,
 '2047': 925152.0779999999,
 '2048': 951642.3110000001,
 '2049': 978514.3760000002,
 '2050': 1005761.9990000005},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '2000': 1818112.851999999,
 '2001': 1869761.4210000003,
 '2002': 1924144.9420000007,
 '2003': 1979323.0710000005,
 '2004': 2035556.5409999995,
 '2005': 2092944.6730000004,
 '2006': 2150852.045,
 '2007': 2209428.0180000006,
 '2008': 2269008.4280000003,
 '2009': 2329432.0699999994,
 '2010': 2390763.985999999,
 '2011': 2451222.2800000007,
 '2012': 2511856.4460000005,
 '2013': 2573008.5100000002,
 '2014': 2634539.648,
 '2015': 2696458.1019999995,
 '2016': 2758382.7400000016,
 '2017': 2820220.5700000003,
 '2018': 2881688.7960000006,
 '2019': 2942730.089999998,
 '2020': 3003315.4900000007,
 '2021': 3063382.5639999993,
 '2022': 3122879.227999999,
 '2023': 3181808.216000001,
 '2024': 3240193.4879999994,
 '2025': 3298051.222,
 '2026': 3355368.2069999995,
 '2027': 3412122.647,
 '2028': 3468315.131,
 '2029': 3523949.9250000007,
 '2030': 3579029.227000001,
 '2031': 3633549.8110000007,
 '2032': 3687503.500000001,
 '2033': 3740880.153000001,
 '2034': 3793660.1530000004,
 '2035': 3845825.5229999986,
 '2036': 3897338.8430000017,
 '2037': 3948221.350000001,
 '2038': 3998462.409000001,
 '2039': 4048025.8579999995,
 '2040': 4096894.1999999993,
 '2041': 4145049.730999999,
 '2042': 4192497.663999998,
 '2043': 4239166.671000002,
 '2044': 4285346.442000001,
 '2045': 4330975.602999999,
 '2046': 4376031.631000001,
 '2047': 4420494.590999999,
 '2048': 4464334.217000003,
 '2049': 4507518.970999999,
 '2050': 4550021.896},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '2000': 1501700.058999999,
 '2001': 1541534.5609999995,
 '2002': 1582874.7620000008,
 '2003': 1624945.2340000006,
 '2004': 1667877.223,
 '2005': 1711930.2349999992,
 '2006': 1756871.791,
 '2007': 1802323.4000000001,
 '2008': 1849403.015,
 '2009': 1897476.354,
 '2010': 1946607.081999999,
 '2011': 1995937.9350000003,
 '2012': 2045975.7989999999,
 '2013': 2096885.1649999989,
 '2014': 2148567.927,
 '2015': 2201144.9490000005,
 '2016': 2254274.865000001,
 '2017': 2307995.0219999994,
 '2018': 2362378.5370000014,
 '2019': 2417462.0370000005,
 '2020': 2473276.185,
 '2021': 2529811.905999998,
 '2022': 2587050.314999998,
 '2023': 2645002.961,
 '2024': 2703684.682999999,
 '2025': 2763104.132,
 '2026': 2823255.4710000004,
 '2027': 2884129.51,
 '2028': 2945725.7180000003,
 '2029': 3008043.6350000007,
 '2030': 3071075.745,
 '2031': 3134813.5950000007,
 '2032': 3199237.282000002,
 '2033': 3264319.426000001,
 '2034': 3330019.2350000003,
 '2035': 3396289.7759999996,
 '2036': 3463072.4770000004,
 '2037': 3530361.7670000005,
 '2038': 3598162.1370000024,
 '2039': 3666401.2989999996,
 '2040': 3735045.4459999977,
 '2041': 3804051.851,
 '2042': 3873425.959999999,
 '2043': 3943080.357000002,
 '2044': 4012963.6419999995,
 '2045': 4083024.8380000005,
 '2046': 4153228.0730000013,
 '2047': 4223541.330999998,
 '2048': 4293929.423000002,
 '2049': 4364357.337999998,
 '2050': 4434790.122000001},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '2000': 821848.9110000004,
 '2001': 830817.9740000003,
 '2002': 840485.3009999999,
 '2003': 850092.9850000003,
 '2004': 859842.3890000001,
 '2005': 869805.3880000002,
 '2006': 879834.7099999998,
 '2007': 890013.3990000002,
 '2008': 900198.6019999998,
 '2009': 910076.8929999999,
 '2010': 919422.9479999999,
 '2011': 927484.0819999996,
 '2012': 934764.2559999999,
 '2013': 941715.7119999998,
 '2014': 948477.334,
 '2015': 955213.3680000001,
 '2016': 961978.2269999998,
 '2017': 968736.7500000001,
 '2018': 975461.275,
 '2019': 982091.8160000002,
 '2020': 988586.2680000002,
 '2021': 994935.3910000001,
 '2022': 1001161.5770000004,
 '2023': 1007290.7600000002,
 '2024': 1013361.033,
 '2025': 1019399.05,
 '2026': 1025413.3220000002,
 '2027': 1031391.7739999999,
 '2028': 1037314.323,
 '2029': 1043151.1660000002,
 '2030': 1048879.4759999998,
 '2031': 1054493.125,
 '2032': 1059995.317,
 '2033': 1065383.4950000003,
 '2034': 1070656.4789999998,
 '2035': 1075813.363,
 '2036': 1080849.856,
 '2037': 1085755.7829999998,
 '2038': 1090535.6450000003,
 '2039': 1095194.058,
 '2040': 1099735.4509999997,
 '2041': 1104158.5980000002,
 '2042': 1108450.0920000002,
 '2043': 1112604.6890000002,
 '2044': 1116630.7380000004,
 '2045': 1120535.366,
 '2046': 1124324.8649999998,
 '2047': 1128001.2659999998,
 '2048': 1131563.7700000003,
 '2049': 1135009.0500000003,
 '2050': 1138335.6069999996},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '2000': 1935345.4209999999,
 '2001': 1986742.901,
 '2002': 2041247.9369999995,
 '2003': 2096821.2060000005,
 '2004': 2153474.1870000004,
 '2005': 2211226.411,
 '2006': 2269397.6020000004,
 '2007': 2328233.8200000003,
 '2008': 2388135.1219999995,
 '2009': 2449076.6720000003,
 '2010': 2511182.5549999997,
 '2011': 2572793.5409999997,
 '2012': 2634892.088999999,
 '2013': 2697775.6269999994,
 '2014': 2761241.217,
 '2015': 2825251.8899999997,
 '2016': 2889408.5930000003,
 '2017': 2953628.9909999995,
 '2018': 3017642.113,
 '2019': 3081402.2629999993,
 '2020': 3144887.1110000005,
 '2021': 3208033.8599999994,
 '2022': 3270776.2679999997,
 '2023': 3333093.723,
 '2024': 3394979.035,
 '2025': 3456424.614,
 '2026': 3517405.3239999996,
 '2027': 3577901.028,
 '2028': 3637919.0530000003,
 '2029': 3697477.1030000006,
 '2030': 3756587.0049999994,
 '2031': 3815242.011999999,
 '2032': 3873432.4789999994,
 '2033': 3931149.793999999,
 '2034': 3988377.5150000006,
 '2035': 4045090.7019999996,
 '2036': 4101247.034000001,
 '2037': 4156858.153999999,
 '2038': 4211938.16,
 '2039': 4266440.647,
 '2040': 4320349.193000001,
 '2041': 4373643.296,
 '2042': 4426326.021,
 '2043': 4478322.312,
 '2044': 4529911.9969999995,
 '2045': 4581025.122,
 '2046': 4631633.818,
 '2047': 4681714.032000001,
 '2048': 4731229.811000001,
 '2049': 4780144.028000001,
 '2050': 4828424.336},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '2000': 1159790.71,
 '2001': 1189768.1589999998,
 '2002': 1221357.3279999997,
 '2003': 1253488.5270000005,
 '2004': 1286139.999,
 '2005': 1319219.5919999997,
 '2006': 1352177.8200000005,
 '2007': 1385248.9899999998,
 '2008': 1418811.6429999992,
 '2009': 1452907.7760000003,
 '2010': 1487718.1709999999,
 '2011': 1522004.505,
 '2012': 1556320.4719999996,
 '2013': 1590859.2109999994,
 '2014': 1625391.464,
 '2015': 1659611.3229999999,
 '2016': 1693419.2140000004,
 '2017': 1726705.617999999,
 '2018': 1759117.8090000001,
 '2019': 1790576.145,
 '2020': 1821035.9030000004,
 '2021': 1850421.1179999998,
 '2022': 1878685.5049999997,
 '2023': 1905862.298,
 '2024': 1932022.6730000002,
 '2025': 1957222.737,
 '2026': 1981469.9599999995,
 '2027': 2004747.0739999998,
 '2028': 2027061.2479999997,
 '2029': 2048417.7960000006,
 '2030': 2068824.5599999996,
 '2031': 2088294.5939999996,
 '2032': 2106845.323,
 '2033': 2124487.969999999,
 '2034': 2141233.1350000007,
 '2035': 2157097.8049999997,
 '2036': 2172090.794,
 '2037': 2186224.877999999,
 '2038': 2199503.908,
 '2039': 2211955.487,
 '2040': 2223591.5800000005,
 '2041': 2234419.6040000003,
 '2042': 2244442.168,
 '2043': 2253643.341,
 '2044': 2262368.25,
 '2045': 2270585.5400000005,
 '2046': 2278293.4810000006,
 '2047': 2285492.0930000003,
 '2048': 2292170.6290000007,
 '2049': 2298316.4609999997,
 '2050': 2303922.0340000005},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '2000': 775554.7109999999,
 '2001': 796974.7420000002,
 '2002': 819890.6089999996,
 '2003': 843332.679,
 '2004': 867334.1880000002,
 '2005': 892006.8190000001,
 '2006': 917219.7819999998,
 '2007': 942984.8300000003,
 '2008': 969323.4790000002,
 '2009': 996168.8960000001,
 '2010': 1023464.384,
 '2011': 1050789.0359999998,
 '2012': 1078571.6169999996,
 '2013': 1106916.416,
 '2014': 1135849.753,
 '2015': 1165640.567,
 '2016': 1195989.379,
 '2017': 1226923.3730000001,
 '2018': 1258524.3039999995,
 '2019': 1290826.1179999993,
 '2020': 1323851.2080000003,
 '2021': 1357612.7419999999,
 '2022': 1392090.763,
 '2023': 1427231.4250000003,
 '2024': 1462956.362,
 '2025': 1499201.8770000003,
 '2026': 1535935.364,
 '2027': 1573153.9540000004,
 '2028': 1610857.8050000006,
 '2029': 1649059.307,
 '2030': 1687762.4449999998,
 '2031': 1726947.4179999994,
 '2032': 1766587.1559999993,
 '2033': 1806661.824,
 '2034': 1847144.3800000001,
 '2035': 1887992.897,
 '2036': 1929156.2400000005,
 '2037': 1970633.2759999998,
 '2038': 2012434.2519999999,
 '2039': 2054485.1599999995,
 '2040': 2096757.6130000006,
 '2041': 2139223.6920000003,
 '2042': 2181883.853,
 '2043': 2224678.971,
 '2044': 2267543.747,
 '2045': 2310439.582,
 '2046': 2353340.337,
 '2047': 2396221.9390000002,
 '2048': 2439059.1820000005,
 '2049': 2481827.5670000007,
 '2050': 2524502.3019999997},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '2000': 109161.422,
 '2001': 113507.289,
 '2002': 118004.269,
 '2003': 122701.176,
 '2004': 127546.001,
 '2005': 132644.674,
 '2006': 137944.887,
 '2007': 143060.254,
 '2008': 149055.885,
 '2009': 155322.451,
 '2010': 161884.396,
 '2011': 168744.45,
 '2012': 175761.496,
 '2013': 183051.243,
 '2014': 190641.769,
 '2015': 198535.599,
 '2016': 206742.138,
 '2017': 215270.399,
 '2018': 224131.434,
 '2019': 233331.59,
 '2020': 242877.3579999999,
 '2021': 252774.777,
 '2022': 263030.603,
 '2023': 273652.9010000001,
 '2024': 284650.231,
 '2025': 296030.328,
 '2026': 307798.9139999999,
 '2027': 319960.632,
 '2028': 332520.421,
 '2029': 345482.261,
 '2030': 358847.63,
 '2031': 372625.003,
 '2032': 386813.513,
 '2033': 401413.264,
 '2034': 416421.689,
 '2035': 431837.128,
 '2036': 447659.417,
 '2037': 463885.2340000001,
 '2038': 480510.87,
 '2039': 497526.92,
 '2040': 514930.361,
 '2041': 532710.284,
 '2042': 550876.9019999999,
 '2043': 569414.9090000001,
 '2044': 588330.7799999999,
 '2045': 607620.8830000001,
 '2046': 627278.975,
 '2047': 647300.9870000001,
 '2048': 667683.5040000001,
 '2049': 688423.5130000002,
 '2050': 709516.898},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '2000': 202640.5020000001,
 '2001': 210982.408,
 '2002': 219727.514,
 '2003': 228838.923,
 '2004': 238354.685,
 '2005': 248352.011,
 '2006': 258726.552,
 '2007': 269186.171,
 '2008': 280784.737,
 '2009': 292877.99,
 '2010': 305507.566,
 '2011': 318670.5960000001,
 '2012': 332216.42,
 '2013': 346248.216,
 '2014': 360789.0130000001,
 '2015': 375826.517,
 '2016': 391361.6850000001,
 '2017': 407401.2999999999,
 '2018': 423958.0149999998,
 '2019': 441043.857,
 '2020': 458669.5750000002,
 '2021': 476840.2970000001,
 '2022': 495560.575,
 '2023': 514840.4379999998,
 '2024': 534691.2030000001,
 '2025': 555122.7630000002,
 '2026': 576140.4699999999,
 '2027': 597748.184,
 '2028': 619952.0399999999,
 '2029': 642757.2799999999,
 '2030': 666165.225,
 '2031': 690182.0730000001,
 '2032': 714802.159,
 '2033': 740022.9809999999,
 '2034': 765834.4189999999,
 '2035': 792225.4830000002,
 '2036': 819183.338,
 '2037': 846763.844,
 '2038': 874955.669,
 '2039': 903747.0619999999,
 '2040': 933129.8409999999,
 '2041': 963097.6410000001,
 '2042': 993656.2479999998,
 '2043': 1024788.839,
 '2044': 1056497.952,
 '2045': 1088774.482,
 '2046': 1121607.1640000003,
 '2047': 1154987.4249999998,
 '2048': 1188907.437,
 '2049': 1223359.921,
 '2050': 1258336.122},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '2000': 285997.612,
 '2001': 296129.2939999999,
 '2002': 306701.76,
 '2003': 317674.047,
 '2004': 329075.105,
 '2005': 341033.592,
 '2006': 353403.5330000001,
 '2007': 365856.972,
 '2008': 379488.153,
 '2009': 393708.979,
 '2010': 408587.0449999999,
 '2011': 424130.04,
 '2012': 440145.1949999999,
 '2013': 456734.3809999999,
 '2014': 473878.1359999999,
 '2015': 491531.0920000001,
 '2016': 509683.886,
 '2017': 528371.3230000001,
 '2018': 547602.182,
 '2019': 567387.619,
 '2020': 587737.7930000001,
 '2021': 608654.401,
 '2022': 630139.7010000001,
 '2023': 652206.412,
 '2024': 674871.188,
 '2025': 698148.943,
 '2026': 722046.585,
 '2027': 746569.7959999999,
 '2028': 771730.984,
 '2029': 797543.035,
 '2030': 824013.801,
 '2031': 851152.7019999998,
 '2032': 878956.1730000001,
 '2033': 907425.527,
 '2034': 936553.5160000002,
 '2035': 966329.885,
 '2036': 996741.915,
 '2037': 1027845.3499999999,
 '2038': 1059626.4919999999,
 '2039': 1092069.379,
 '2040': 1125161.5150000001,
 '2041': 1158893.094,
 '2042': 1193268.358,
 '2043': 1228241.613,
 '2044': 1263807.666,
 '2045': 1299953.2489999998,
 '2046': 1336663.829,
 '2047': 1373927.679,
 '2048': 1411732.868,
 '2049': 1450067.812,
 '2050': 1488920.045},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '2000': 54950.508,
 '2001': 57288.639,
 '2002': 59739.587,
 '2003': 62252.62,
 '2004': 64874.159,
 '2005': 67684.204,
 '2006': 70638.244,
 '2007': 73364.499,
 '2008': 76912.459,
 '2009': 80619.009,
 '2010': 84503.529,
 '2011': 88571.068,
 '2012': 92682.877,
 '2013': 96959.877,
 '2014': 101429.642,
 '2015': 106095.604,
 '2016': 110963.377,
 '2017': 116034.318,
 '2018': 121315.521,
 '2019': 126809.813,
 '2020': 132520.364,
 '2021': 138450.877,
 '2022': 144606.311,
 '2023': 150992.469,
 '2024': 157615.812,
 '2025': 164482.084,
 '2026': 171595.414,
 '2027': 178958.77,
 '2028': 186575.463,
 '2029': 194448.182,
 '2030': 202579.194,
 '2031': 210970.322,
 '2032': 219622.57,
 '2033': 228535.143,
 '2034': 237705.229,
 '2035': 247131.197,
 '2036': 256808.314,
 '2037': 266737.352,
 '2038': 276914.9129999999,
 '2039': 287334.599,
 '2040': 298002.537,
 '2041': 308912.691,
 '2042': 320072.2290000001,
 '2043': 331473.026,
 '2044': 343125.93,
 '2045': 355029.937,
 '2046': 367181.3659999999,
 '2047': 379578.018,
 '2048': 392217.721,
 '2049': 405098.197,
 '2050': 418216.589},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '2000': 527.819,
 '2001': 554.716,
 '2002': 585.3,
 '2003': 619.362,
 '2004': 656.406,
 '2005': 695.94,
 '2006': 738.134,
 '2007': 783.189,
 '2008': 830.899,
 '2009': 880.843,
 '2010': 932.971,
 '2011': 987.065,
 '2012': 1043.294,
 '2013': 1102.259,
 '2014': 1164.881,
 '2015': 1231.911,
 '2016': 1303.761,
 '2017': 1380.418,
 '2018': 1461.704,
 '2019': 1547.197,
 '2020': 1636.586,
 '2021': 1729.9,
 '2022': 1827.394,
 '2023': 1929.218,
 '2024': 2035.578,
 '2025': 2146.694,
 '2026': 2262.7,
 '2027': 2383.752,
 '2028': 2510.132,
 '2029': 2642.186,
 '2030': 2780.242,
 '2031': 2924.524,
 '2032': 3075.236,
 '2033': 3232.668,
 '2034': 3397.098,
 '2035': 3568.656,
 '2036': 3748.205,
 '2037': 3935.79,
 '2038': 4131.648,
 '2039': 4335.976,
 '2040': 4548.959,
 '2041': 4770.827,
 '2042': 5001.763,
 '2043': 5241.848,
 '2044': 5491.101,
 '2045': 5749.545,
 '2046': 6017.295,
 '2047': 6294.464,
 '2048': 6581.084,
 '2049': 6877.155,
 '2050': 7182.692},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '2000': 152.293,
 '2001': 155.847,
 '2002': 159.406,
 '2003': 162.993,
 '2004': 166.647,
 '2005': 170.493,
 '2006': 174.541,
 '2007': 178.798,
 '2008': 183.275,
 '2009': 187.982,
 '2010': 192.925,
 '2011': 198.121,
 '2012': 203.575,
 '2013': 209.271,
 '2014': 215.196,
 '2015': 221.334,
 '2016': 227.69,
 '2017': 234.273,
 '2018': 241.092,
 '2019': 248.16,
 '2020': 255.487,
 '2021': 263.083,
 '2022': 270.954,
 '2023': 279.115,
 '2024': 287.574,
 '2025': 296.345,
 '2026': 305.44,
 '2027': 314.871,
 '2028': 324.651,
 '2029': 334.797,
 '2030': 345.321,
 '2031': 356.059,
 '2032': 367.014,
 '2033': 378.179,
 '2034': 389.559,
 '2035': 401.157,
 '2036': 412.967,
 '2037': 424.993,
 '2038': 437.232,
 '2039': 449.678,
 '2040': 462.325,
 '2041': 475.18,
 '2042': 488.229,
 '2043': 501.474,
 '2044': 514.902,
 '2045': 528.51,
 '2046': 542.292,
 '2047': 556.242,
 '2048': 570.355,
 '2049': 584.625,
 '2050': 599.041},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '2000': 549.178,
 '2001': 561.093,
 '2002': 571.782,
 '2003': 581.627,
 '2004': 591.287,
 '2005': 601.236,
 '2006': 611.545,
 '2007': 622.049,
 '2008': 632.825,
 '2009': 643.899,
 '2010': 655.376,
 '2011': 667.325,
 '2012': 679.729,
 '2013': 692.437,
 '2014': 705.235,
 '2015': 717.972,
 '2016': 730.569,
 '2017': 743.079,
 '2018': 755.533,
 '2019': 768.001,
 '2020': 780.538,
 '2021': 793.138,
 '2022': 805.774,
 '2023': 818.418,
 '2024': 831.056,
 '2025': 843.657,
 '2026': 856.22,
 '2027': 868.738,
 '2028': 881.187,
 '2029': 893.554,
 '2030': 905.821,
 '2031': 917.977,
 '2032': 930.017,
 '2033': 941.912,
 '2034': 953.672,
 '2035': 965.276,
 '2036': 976.623,
 '2037': 987.711,
 '2038': 998.534,
 '2039': 1009.093,
 '2040': 1019.38,
 '2041': 1029.403,
 '2042': 1039.155,
 '2043': 1048.634,
 '2044': 1057.841,
 '2045': 1066.788,
 '2046': 1075.467,
 '2047': 1083.873,
 '2048': 1092.01,
 '2049': 1099.862,
 '2050': 1107.45},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '2000': 902.054,
 '2001': 960.122,
 '2002': 1024.408,
 '2003': 1093.201,
 '2004': 1163.933,
 '2005': 1234.323,
 '2006': 1303.385,
 '2007': 1371.32,
 '2008': 1439.096,
 '2009': 1490.721,
 '2010': 1544.485,
 '2011': 1600.645,
 '2012': 1658.937,
 '2013': 1719.887,
 '2014': 1784.051,
 '2015': 1851.851,
 '2016': 1923.728,
 '2017': 1999.721,
 '2018': 2079.314,
 '2019': 2161.646,
 '2020': 2246.038,
 '2021': 2332.299,
 '2022': 2420.579,
 '2023': 2510.963,
 '2024': 2603.638,
 '2025': 2698.752,
 '2026': 2796.265,
 '2027': 2896.081,
 '2028': 2998.273,
 '2029': 3102.932,
 '2030': 3210.132,
 '2031': 3319.852,
 '2032': 3432.002,
 '2033': 3546.504,
 '2034': 3663.207,
 '2035': 3781.931,
 '2036': 3902.437,
 '2037': 4025.432,
 '2038': 4150.616,
 '2039': 4277.83,
 '2040': 4406.917,
 '2041': 4537.785,
 '2042': 4670.347,
 '2043': 4804.457,
 '2044': 4939.964,
 '2045': 5076.734,
 '2046': 5214.653,
 '2047': 5353.63,
 '2048': 5493.603,
 '2049': 5634.53,
 '2050': 5776.366},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '2000': 9807.289,
 '2001': 10224.181,
 '2002': 10657.558,
 '2003': 11106.588,
 '2004': 11570.036,
 '2005': 12046.373,
 '2006': 12536.077,
 '2007': 13054.22,
 '2008': 13733.823,
 '2009': 14444.161,
 '2010': 15189.14,
 '2011': 15970.018,
 '2012': 16787.864,
 '2013': 17625.298,
 '2014': 18497.411,
 '2015': 19403.087,
 '2016': 20343.215,
 '2017': 21316.856,
 '2018': 22327.769,
 '2019': 23376.34,
 '2020': 24463.423,
 '2021': 25589.582,
 '2022': 26755.042,
 '2023': 27959.894,
 '2024': 29204.015,
 '2025': 30487.323,
 '2026': 31809.855,
 '2027': 33171.794,
 '2028': 34573.307,
 '2029': 36014.593,
 '2030': 37495.72,
 '2031': 39016.596,
 '2032': 40576.89,
 '2033': 42176.062,
 '2034': 43813.383,
 '2035': 45488.077,
 '2036': 47199.288,
 '2037': 48946.253,
 '2038': 50728.279,
 '2039': 52544.649,
 '2040': 54394.212,
 '2041': 56275.08,
 '2042': 58184.332,
 '2043': 60116.968,
 '2044': 62086.216,
 '2045': 64087.447,
 '2046': 66119.729,
 '2047': 68182.089,
 '2048': 70273.297,
 '2049': 72392.002,
 '2050': 74536.815},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '2000': 6256.185,
 '2001': 6541.648,
 '2002': 6839.247,
 '2003': 7149.767,
 '2004': 7474.389,
 '2005': 7813.454,
 '2006': 8168.189,
 '2007': 8538.821,
 '2008': 8925.701,
 '2009': 9328.13,
 '2010': 9746.669,
 '2011': 10183.601,
 '2012': 10639.429,
 '2013': 11114.158,
 '2014': 11607.614,
 '2015': 12119.756,
 '2016': 12650.834,
 '2017': 13201.347,
 '2018': 13771.805,
 '2019': 14362.838,
 '2020': 14975.059,
 '2021': 15608.844,
 '2022': 16264.626,
 '2023': 16943.167,
 '2024': 17645.362,
 '2025': 18371.967,
 '2026': 19123.471,
 '2027': 19900.146,
 '2028': 20702.233,
 '2029': 21529.836,
 '2030': 22382.984,
 '2031': 23261.753,
 '2032': 24166.047,
 '2033': 25095.413,
 '2034': 26049.091,
 '2035': 27025.992,
 '2036': 28024.256,
 '2037': 29046.382,
 '2038': 30090.33,
 '2039': 31155.64,
 '2040': 32241.885,
 '2041': 33348.612,
 '2042': 34475.483,
 '2043': 35622.314,
 '2044': 36788.999,
 '2045': 37975.346,
 '2046': 39180.924,
 '2047': 40405.19,
 '2048': 41647.623,
 '2049': 42907.673,
 '2050': 44184.721},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '2000': 4276.171,
 '2001': 4454.036,
 '2002': 4637.69,
 '2003': 4827.118,
 '2004': 5022.492,
 '2005': 5283.543,
 '2006': 5555.506,
 '2007': 5838.483,
 '2008': 6132.917,
 '2009': 6438.271,
 '2010': 6755.337,
 '2011': 7084.135,
 '2012': 7425.048,
 '2013': 7778.842,
 '2014': 8146.486,
 '2015': 8528.793,
 '2016': 8926.246,
 '2017': 9339.025,
 '2018': 9767.285,
 '2019': 10211.029,
 '2020': 10670.252,
 '2021': 11145.081,
 '2022': 11635.629,
 '2023': 12141.777,
 '2024': 12663.299,
 '2025': 13199.949,
 '2026': 13751.596,
 '2027': 14318.035,
 '2028': 14898.866,
 '2029': 15493.576,
 '2030': 16101.66,
 '2031': 16722.618,
 '2032': 17355.954,
 '2033': 18000.969,
 '2034': 18656.512,
 '2035': 19327.758,
 '2036': 20013.718,
 '2037': 20714.338,
 '2038': 21429.706,
 '2039': 22159.955,
 '2040': 22905.168,
 '2041': 23665.293,
 '2042': 24440.22,
 '2043': 25229.882,
 '2044': 26034.199,
 '2045': 26853.051,
 '2046': 27686.271,
 '2047': 28533.626,
 '2048': 29394.868,
 '2049': 30269.683,
 '2050': 31157.741},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '2000': 1662.05,
 '2001': 1719.028,
 '2002': 1776.361,
 '2003': 1835.073,
 '2004': 1896.881,
 '2005': 1962.982,
 '2006': 2033.728,
 '2007': 2108.614,
 '2008': 2187.171,
 '2009': 2270.272,
 '2010': 2357.581,
 '2011': 2449.138,
 '2012': 2545.363,
 '2013': 2646.671,
 '2014': 2753.615,
 '2015': 2866.7,
 '2016': 2986.276,
 '2017': 3112.59,
 '2018': 3245.933,
 '2019': 3386.573,
 '2020': 3534.836,
 '2021': 3691.081,
 '2022': 3855.794,
 '2023': 4029.578,
 '2024': 4213.135,
 '2025': 4407.124,
 '2026': 4612.145,
 '2027': 4828.682,
 '2028': 5057.131,
 '2029': 5297.82,
 '2030': 5551.124,
 '2031': 5817.545,
 '2032': 6097.66,
 '2033': 6391.979,
 '2034': 6700.822,
 '2035': 7021.73,
 '2036': 7354.532,
 '2037': 7699.413,
 '2038': 8056.593,
 '2039': 8426.279,
 '2040': 8808.675,
 '2041': 9203.963,
 '2042': 9612.3,
 '2043': 10033.802,
 '2044': 10468.546,
 '2045': 10916.62,
 '2046': 11378.098,
 '2047': 11853.081,
 '2048': 12341.686,
 '2049': 12844.036,
 '2050': 13360.225},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '2000': 505.705,
 '2001': 508.114,
 '2002': 510.129,
 '2003': 511.826,
 '2004': 513.296,
 '2005': 514.605,
 '2006': 515.802,
 '2007': 516.868,
 '2008': 517.74,
 '2009': 518.334,
 '2010': 518.584,
 '2011': 518.469,
 '2012': 518.048,
 '2013': 517.451,
 '2014': 516.852,
 '2015': 516.377,
 '2016': 516.339,
 '2017': 516.698,
 '2018': 517.387,
 '2019': 518.289,
 '2020': 519.33,
 '2021': 520.48,
 '2022': 521.772,
 '2023': 523.224,
 '2024': 524.857,
 '2025': 526.689,
 '2026': 528.727,
 '2027': 530.946,
 '2028': 533.34,
 '2029': 535.891,
 '2030': 538.588,
 '2031': 541.419,
 '2032': 544.39,
 '2033': 547.484,
 '2034': 550.688,
 '2035': 554.003,
 '2036': 557.414,
 '2037': 560.921,
 '2038': 564.524,
 '2039': 568.22,
 '2040': 572.012,
 '2041': 575.889,
 '2042': 579.605,
 '2043': 583.157,
 '2044': 586.559,
 '2045': 589.818,
 '2046': 592.949,
 '2047': 595.946,
 '2048': 598.833,
 '2049': 601.628,
 '2050': 604.348},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '2000': 71.754,
 '2001': 76.317,
 '2002': 81.036,
 '2003': 83.905,
 '2004': 86.651,
 '2005': 89.462,
 '2006': 92.355,
 '2007': 95.31,
 '2008': 97.709,
 '2009': 99.971,
 '2010': 102.176,
 '2011': 104.326,
 '2012': 106.421,
 '2013': 108.481,
 '2014': 110.594,
 '2015': 112.783,
 '2016': 115.05,
 '2017': 117.401,
 '2018': 119.837,
 '2019': 122.357,
 '2020': 124.952,
 '2021': 127.63,
 '2022': 130.404,
 '2023': 133.282,
 '2024': 136.281,
 '2025': 139.411,
 '2026': 142.679,
 '2027': 146.086,
 '2028': 149.649,
 '2029': 153.362,
 '2030': 157.242,
 '2031': 161.285,
 '2032': 165.507,
 '2033': 169.906,
 '2034': 174.486,
 '2035': 179.252,
 '2036': 184.198,
 '2037': 189.341,
 '2038': 194.68,
 '2039': 200.216,
 '2040': 205.819,
 '2041': 211.481,
 '2042': 217.201,
 '2043': 222.976,
 '2044': 228.798,
 '2045': 234.658,
 '2046': 240.561,
 '2047': 246.496,
 '2048': 252.462,
 '2049': 258.464,
 '2050': 264.489},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '2000': 5257.395,
 '2001': 5442.245,
 '2002': 5637.914,
 '2003': 5843.407,
 '2004': 6056.875,
 '2005': 6276.808,
 '2006': 6503.378,
 '2007': 6737.381,
 '2008': 7044.072,
 '2009': 7369.706,
 '2010': 7709.657,
 '2011': 8064.212,
 '2012': 8433.845,
 '2013': 8818.444,
 '2014': 9218.957,
 '2015': 9635.602,
 '2016': 10069.035,
 '2017': 10519.046,
 '2018': 10986.62,
 '2019': 11472.938,
 '2020': 11978.439,
 '2021': 12503.542,
 '2022': 13048.749,
 '2023': 13614.614,
 '2024': 14201.743,
 '2025': 14810.679,
 '2026': 15441.834,
 '2027': 16095.537,
 '2028': 16772.147,
 '2029': 17471.98,
 '2030': 18195.295,
 '2031': 18942.349,
 '2032': 19713.291,
 '2033': 20508.067,
 '2034': 21326.488,
 '2035': 22168.384,
 '2036': 23033.664,
 '2037': 23922.259,
 '2038': 24833.993,
 '2039': 25768.635,
 '2040': 26725.869,
 '2041': 27705.269,
 '2042': 28706.234,
 '2043': 29727.82,
 '2044': 30768.272,
 '2045': 31831.909,
 '2046': 32917.11,
 '2047': 34023.745,
 '2048': 35151.82,
 '2049': 36301.434,
 '2050': 37472.562},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '2000': 671.649,
 '2001': 692.868,
 '2002': 712.576,
 '2003': 730.749,
 '2004': 747.337,
 '2005': 762.323,
 '2006': 775.785,
 '2007': 787.841,
 '2008': 798.736,
 '2009': 808.725,
 '2010': 818.067,
 '2011': 826.778,
 '2012': 834.957,
 '2013': 842.745,
 '2014': 850.28,
 '2015': 857.659,
 '2016': 864.954,
 '2017': 872.202,
 '2018': 879.399,
 '2019': 886.5,
 '2020': 893.481,
 '2021': 900.334,
 '2022': 907.082,
 '2023': 913.712,
 '2024': 920.201,
 '2025': 926.529,
 '2026': 932.693,
 '2027': 938.681,
 '2028': 944.489,
 '2029': 950.117,
 '2030': 955.563,
 '2031': 960.836,
 '2032': 965.898,
 '2033': 970.74,
 '2034': 975.359,
 '2035': 979.722,
 '2036': 983.82,
 '2037': 987.669,
 '2038': 991.237,
 '2039': 994.532,
 '2040': 997.546,
 '2041': 1000.278,
 '2042': 1002.718,
 '2043': 1004.875,
 '2044': 1006.748,
 '2045': 1008.359,
 '2046': 1009.686,
 '2047': 1010.76,
 '2048': 1011.584,
 '2049': 1012.185,
 '2050': 1012.578},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '2000': 1197.92,
 '2001': 1318.469,
 '2002': 1432.147,
 '2003': 1467.306,
 '2004': 1491.029,
 '2005': 1520.718,
 '2006': 1557.451,
 '2007': 1598.597,
 '2008': 1643.141,
 '2009': 1689.148,
 '2010': 1735.198,
 '2011': 1781.243,
 '2012': 1827.915,
 '2013': 1875.204,
 '2014': 1925.003,
 '2015': 1977.467,
 '2016': 2032.707,
 '2017': 2090.744,
 '2018': 2151.557,
 '2019': 2215.085,
 '2020': 2281.33,
 '2021': 2350.389,
 '2022': 2422.469,
 '2023': 2497.854,
 '2024': 2576.901,
 '2025': 2659.944,
 '2026': 2747.216,
 '2027': 2838.924,
 '2028': 2935.379,
 '2029': 3036.912,
 '2030': 3143.843,
 '2031': 3256.468,
 '2032': 3375.044,
 '2033': 3499.832,
 '2034': 3631.067,
 '2035': 3768.985,
 '2036': 3913.846,
 '2037': 4065.873,
 '2038': 4225.172,
 '2039': 4391.656,
 '2040': 4562.582,
 '2041': 4737.634,
 '2042': 4916.764,
 '2043': 5099.857,
 '2044': 5286.777,
 '2045': 5477.407,
 '2046': 5671.633,
 '2047': 5869.387,
 '2048': 6070.624,
 '2049': 6275.322,
 '2050': 6483.462},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '2000': 40.927,
 '2001': 41.817,
 '2002': 42.839,
 '2003': 43.92,
 '2004': 44.956,
 '2005': 45.854,
 '2006': 46.595,
 '2007': 47.204,
 '2008': 47.718,
 '2009': 48.22,
 '2010': 48.752,
 '2011': 49.333,
 '2012': 49.945,
 '2013': 50.591,
 '2014': 51.261,
 '2015': 51.933,
 '2016': 52.609,
 '2017': 53.3,
 '2018': 53.989,
 '2019': 54.664,
 '2020': 55.308,
 '2021': 55.922,
 '2022': 56.504,
 '2023': 57.062,
 '2024': 57.593,
 '2025': 58.12,
 '2026': 58.628,
 '2027': 59.119,
 '2028': 59.597,
 '2029': 60.062,
 '2030': 60.516,
 '2031': 60.964,
 '2032': 61.4,
 '2033': 61.831,
 '2034': 62.251,
 '2035': 62.662,
 '2036': 63.066,
 '2037': 63.462,
 '2038': 63.849,
 '2039': 64.219,
 '2040': 64.582,
 '2041': 64.931,
 '2042': 65.266,
 '2043': 65.587,
 '2044': 65.885,
 '2045': 66.169,
 '2046': 66.427,
 '2047': 66.663,
 '2048': 66.881,
 '2049': 67.08,
 '2050': 67.254},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '2000': 2996.056,
 '2001': 3123.322,
 '2002': 3250.86,
 '2003': 3418.72,
 '2004': 3594.364,
 '2005': 3779.95,
 '2006': 3976.468,
 '2007': 3797.757,
 '2008': 4094.183,
 '2009': 4407.467,
 '2010': 4738.106,
 '2011': 5085.937,
 '2012': 5304.4,
 '2013': 5530.965,
 '2014': 5767.236,
 '2015': 6014.594,
 '2016': 6273.587,
 '2017': 6544.404,
 '2018': 6827.415,
 '2019': 7122.882,
 '2020': 7431.038,
 '2021': 7752.272,
 '2022': 8086.843,
 '2023': 8434.61,
 '2024': 8795.255,
 '2025': 9168.559,
 '2026': 9554.546,
 '2027': 9953.409,
 '2028': 10365.336,
 '2029': 10790.55,
 '2030': 11229.249,
 '2031': 11681.506,
 '2032': 12147.325,
 '2033': 12626.719,
 '2034': 13119.677,
 '2035': 13626.15,
 '2036': 14146.077,
 '2037': 14679.394,
 '2038': 15226.002,
 '2039': 15785.733,
 '2040': 16358.048,
 '2041': 16945.129,
 '2042': 17546.369,
 '2043': 18161.829,
 '2044': 18791.546,
 '2045': 19435.527,
 '2046': 20093.729,
 '2047': 20766.024,
 '2048': 21452.234,
 '2049': 22152.121,
 '2050': 22865.427},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '2000': 1105.85,
 '2001': 1159.988,
 '2002': 1213.064,
 '2003': 1267.138,
 '2004': 1325.663,
 '2005': 1391.012,
 '2006': 1463.869,
 '2007': 1542.867,
 '2008': 1626.098,
 '2009': 1711.789,
 '2010': 1797.991,
 '2011': 1884.11,
 '2012': 1970.718,
 '2013': 2058.305,
 '2014': 2147.809,
 '2015': 2240.02,
 '2016': 2335.056,
 '2017': 2432.887,
 '2018': 2534.064,
 '2019': 2639.257,
 '2020': 2749.061,
 '2021': 2863.9,
 '2022': 2984.03,
 '2023': 3109.689,
 '2024': 3241.033,
 '2025': 3378.254,
 '2026': 3521.678,
 '2027': 3671.668,
 '2028': 3828.489,
 '2029': 3992.383,
 '2030': 4163.609,
 '2031': 4342.422,
 '2032': 4529.108,
 '2033': 4723.924,
 '2034': 4926.983,
 '2035': 5136.964,
 '2036': 5353.707,
 '2037': 5577.305,
 '2038': 5807.828,
 '2039': 6045.324,
 '2040': 6289.84,
 '2041': 6541.437,
 '2042': 6800.184,
 '2043': 7066.141,
 '2044': 7339.348,
 '2045': 7619.84,
 '2046': 7907.635,
 '2047': 8202.726,
 '2048': 8505.102,
 '2049': 8814.738,
 '2050': 9131.58},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '2000': 3554.371,
 '2001': 3778.166,
 '2002': 4018.758,
 '2003': 4276.263,
 '2004': 4550.589,
 '2005': 4841.176,
 '2006': 5149.166,
 '2007': 5475.481,
 '2008': 5821.225,
 '2009': 6186.778,
 '2010': 6573.772,
 '2011': 6982.895,
 '2012': 7415.196,
 '2013': 7870.626,
 '2014': 8350.673,
 '2015': 8855.831,
 '2016': 9386.309,
 '2017': 9942.312,
 '2018': 10525.083,
 '2019': 11135.655,
 '2020': 11775.012,
 '2021': 12443.945,
 '2022': 13143.166,
 '2023': 13873.5,
 '2024': 14635.755,
 '2025': 15430.672,
 '2026': 16258.91,
 '2027': 17121.008,
 '2028': 18017.417,
 '2029': 18948.465,
 '2030': 19914.432,
 '2031': 20915.607,
 '2032': 21952.176,
 '2033': 23024.088,
 '2034': 24131.144,
 '2035': 25273.067,
 '2036': 26449.553,
 '2037': 27660.227,
 '2038': 28904.529,
 '2039': 30181.661,
 '2040': 31490.363,
 '2041': 32828.192,
 '2042': 34206.98,
 '2043': 35625.097,
 '2044': 37082.775,
 '2045': 38580.183,
 '2046': 40117.367,
 '2047': 41694.321,
 '2048': 43311.05,
 '2049': 44967.525,
 '2050': 46663.616},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '2000': 7624.725,
 '2001': 7962.437,
 '2002': 8320.186,
 '2003': 8771.273,
 '2004': 9265.478,
 '2005': 9791.527,
 '2006': 10352.917,
 '2007': 10951.022,
 '2008': 11586.042,
 '2009': 12255.552,
 '2010': 12959.969,
 '2011': 13699.408,
 '2012': 14476.019,
 '2013': 15290.084,
 '2014': 16142.777,
 '2015': 17035.213,
 '2016': 17968.436,
 '2017': 18942.828,
 '2018': 19958.545,
 '2019': 21015.391,
 '2020': 22113.353,
 '2021': 23252.74,
 '2022': 24434.383,
 '2023': 25659.393,
 '2024': 26929.194,
 '2025': 28244.987,
 '2026': 29607.318,
 '2027': 31016.429,
 '2028': 32472.831,
 '2029': 33976.958,
 '2030': 35529.056,
 '2031': 37129.226,
 '2032': 38777.25,
 '2033': 40472.518,
 '2034': 42214.107,
 '2035': 44000.95,
 '2036': 45831.964,
 '2037': 47705.808,
 '2038': 49620.39,
 '2039': 51572.12,
 '2040': 53579.195,
 '2041': 55639.244,
 '2042': 57752.308,
 '2043': 59918.186,
 '2044': 62136.544,
 '2045': 64407.122,
 '2046': 66729.703,
 '2047': 69104.287,
 '2048': 71531.054,
 '2049': 74010.296,
 '2050': 76542.196},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '2000': 3665.128,
 '2001': 3788.69,
 '2002': 3944.99,
 '2003': 4106.321,
 '2004': 4273.908,
 '2005': 4448.559,
 '2006': 4630.766,
 '2007': 4820.757,
 '2008': 5019.867,
 '2009': 5229.35,
 '2010': 5450.667,
 '2011': 5684.592,
 '2012': 5932.069,
 '2013': 6192.319,
 '2014': 6464.31,
 '2015': 6747.236,
 '2016': 7041.082,
 '2017': 7346.421,
 '2018': 7663.677,
 '2019': 7993.486,
 '2020': 8336.381,
 '2021': 8692.602,
 '2022': 9062.291,
 '2023': 9445.888,
 '2024': 9843.878,
 '2025': 10256.668,
 '2026': 10684.59,
 '2027': 11127.784,
 '2028': 11586.254,
 '2029': 12059.861,
 '2030': 12548.518,
 '2031': 13052.294,
 '2032': 13571.318,
 '2033': 14105.614,
 '2034': 14655.192,
 '2035': 15219.971,
 '2036': 15799.703,
 '2037': 16393.779,
 '2038': 17004.012,
 '2039': 17629.958,
 '2040': 18271.801,
 '2041': 18929.659,
 '2042': 19603.581,
 '2043': 20293.621,
 '2044': 20999.804,
 '2045': 21722.143,
 '2046': 22460.611,
 '2047': 23215.224,
 '2048': 23986.064,
 '2049': 24773.237,
 '2050': 25576.78},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '2000': 4125.989,
 '2001': 4225.535,
 '2002': 4323.336,
 '2003': 4356.063,
 '2004': 4381.942,
 '2005': 4413.866,
 '2006': 4452.587,
 '2007': 4497.92,
 '2008': 4550.221,
 '2009': 4609.69,
 '2010': 4676.106,
 '2011': 4749.717,
 '2012': 4830.105,
 '2013': 4915.839,
 '2014': 5009.401,
 '2015': 5109.485,
 '2016': 5215.894,
 '2017': 5328.766,
 '2018': 5447.513,
 '2019': 5571.525,
 '2020': 5700.46,
 '2021': 5834.113,
 '2022': 5972.826,
 '2023': 6117.511,
 '2024': 6269.464,
 '2025': 6429.761,
 '2026': 6598.903,
 '2027': 6777.08,
 '2028': 6964.755,
 '2029': 7162.347,
 '2030': 7370.279,
 '2031': 7589.022,
 '2032': 7819.043,
 '2033': 8060.734,
 '2034': 8314.443,
 '2035': 8580.51,
 '2036': 8859.276,
 '2037': 9151.002,
 '2038': 9455.759,
 '2039': 9773.225,
 '2040': 10097.359,
 '2041': 10427.405,
 '2042': 10763.19,
 '2043': 11104.501,
 '2044': 11451.106,
 '2045': 11802.761,
 '2046': 12159.226,
 '2047': 12520.244,
 '2048': 12885.487,
 '2049': 13254.601,
 '2050': 13627.246},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '2000': 38183.621,
 '2001': 39852.568,
 '2002': 41638.018,
 '2003': 43537.151,
 '2004': 45541.954,
 '2005': 47647.23,
 '2006': 49776.953,
 '2007': 52013.555,
 '2008': 54355.905,
 '2009': 56800.328,
 '2010': 59347.838,
 '2011': 61998.67,
 '2012': 64754.955,
 '2013': 67606.919,
 '2014': 70566.315,
 '2015': 73632.499,
 '2016': 76806.314,
 '2017': 80089.141,
 '2018': 83483.558,
 '2019': 86992.671,
 '2020': 90619.3,
 '2021': 94365.2,
 '2022': 98231.845,
 '2023': 102221.505,
 '2024': 106336.483,
 '2025': 110578.741,
 '2026': 114949.366,
 '2027': 119449.139,
 '2028': 124078.93,
 '2029': 128839.037,
 '2030': 133727.544,
 '2031': 138749.892,
 '2032': 143902.395,
 '2033': 149187.451,
 '2034': 154603.701,
 '2035': 160149.59,
 '2036': 165820.777,
 '2037': 171615.298,
 '2038': 177530.279,
 '2039': 183562.211,
 '2040': 189707.591,
 '2041': 195970.888,
 '2042': 202349.841,
 '2043': 208842.033,
 '2044': 215444.913,
 '2045': 222156.044,
 '2046': 228972.755,
 '2047': 235892.646,
 '2048': 242913.861,
 '2049': 250034.812,
 '2050': 257253.521},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '2000': 8234.824,
 '2001': 8708.018,
 '2002': 9218.798,
 '2003': 9765.241,
 '2004': 10343.495,
 '2005': 10949.424,
 '2006': 11501.699,
 '2007': 12078.776,
 '2008': 12681.905,
 '2009': 13312.002,
 '2010': 13970.854,
 '2011': 14658.951,
 '2012': 15375.981,
 '2013': 16119.397,
 '2014': 16887.357,
 '2015': 17675.745,
 '2016': 18483.603,
 '2017': 19311.639,
 '2018': 20161.538,
 '2019': 21035.94,
 '2020': 21936.953,
 '2021': 22865.158,
 '2022': 23820.261,
 '2023': 24802.445,
 '2024': 25811.665,
 '2025': 26847.887,
 '2026': 27911.269,
 '2027': 29001.994,
 '2028': 30119.989,
 '2029': 31265.1,
 '2030': 32437.132,
 '2031': 33635.882,
 '2032': 34861.101,
 '2033': 36112.409,
 '2034': 37389.363,
 '2035': 38691.449,
 '2036': 40018.172,
 '2037': 41368.933,
 '2038': 42742.931,
 '2039': 44139.178,
 '2040': 45556.399,
 '2041': 47000.838,
 '2042': 48471.579,
 '2043': 49968.173,
 '2044': 51490.145,
 '2045': 53037.025,
 '2046': 54608.399,
 '2047': 56203.877,
 '2048': 57823.115,
 '2049': 59465.799,
 '2050': 61131.579},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '2000': 6956.118,
 '2001': 7230.841,
 '2002': 7517.761,
 '2003': 7817.348,
 '2004': 8130.181,
 '2005': 8456.175,
 '2006': 8796.32,
 '2007': 9150.924,
 '2008': 9519.622,
 '2009': 9901.705,
 '2010': 10296.608,
 '2011': 10704.283,
 '2012': 11124.88,
 '2013': 11558.235,
 '2014': 12004.187,
 '2015': 12462.615,
 '2016': 12933.405,
 '2017': 13416.537,
 '2018': 13912.132,
 '2019': 14420.409,
 '2020': 14941.523,
 '2021': 15475.489,
 '2022': 16022.262,
 '2023': 16581.877,
 '2024': 17154.348,
 '2025': 17739.676,
 '2026': 18337.769,
 '2027': 18948.565,
 '2028': 19572.072,
 '2029': 20208.294,
 '2030': 20857.109,
 '2031': 21518.177,
 '2032': 22190.687,
 '2033': 22877.402,
 '2034': 23577.496,
 '2035': 24290.758,
 '2036': 25017.029,
 '2037': 25756.173,
 '2038': 26508.012,
 '2039': 27272.357,
 '2040': 28048.983,
 '2041': 28837.661,
 '2042': 29638.097,
 '2043': 30449.875,
 '2044': 31272.518,
 '2045': 32105.585,
 '2046': 32948.687,
 '2047': 33801.503,
 '2048': 34663.737,
 '2049': 35535.114,
 '2050': 36415.328},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '2000': 1413.327,
 '2001': 1445.52,
 '2002': 1477.162,
 '2003': 1508.417,
 '2004': 1539.542,
 '2005': 1571.461,
 '2006': 1604.798,
 '2007': 1639.301,
 '2008': 1673.231,
 '2009': 1704.182,
 '2010': 1730.652,
 '2011': 1751.753,
 '2012': 1768.692,
 '2013': 1784.688,
 '2014': 1804.315,
 '2015': 1831.054,
 '2016': 1866.228,
 '2017': 1909.283,
 '2018': 1959.587,
 '2019': 2015.708,
 '2020': 2076.534,
 '2021': 2142.171,
 '2022': 2213.06,
 '2023': 2288.695,
 '2024': 2368.409,
 '2025': 2451.673,
 '2026': 2538.181,
 '2027': 2627.916,
 '2028': 2720.959,
 '2029': 2817.52,
 '2030': 2917.639,
 '2031': 3020.531,
 '2032': 3125.832,
 '2033': 3233.402,
 '2034': 3343.063,
 '2035': 3454.676,
 '2036': 3568.129,
 '2037': 3683.378,
 '2038': 3800.362,
 '2039': 3919.062,
 '2040': 4039.45,
 '2041': 4161.467,
 '2042': 4285.053,
 '2043': 4410.207,
 '2044': 4536.926,
 '2045': 4665.212,
 '2046': 4795.031,
 '2047': 4926.336,
 '2048': 5059.141,
 '2049': 5193.472,
 '2050': 5329.336},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '2000': 1805.052,
 '2001': 1877.232,
 '2002': 1953.584,
 '2003': 2032.953,
 '2004': 2113.721,
 '2005': 2194.746,
 '2006': 2275.496,
 '2007': 2356.38,
 '2008': 2438.393,
 '2009': 2523.0,
 '2010': 2613.4,
 '2011': 2710.171,
 '2012': 2813.137,
 '2013': 2921.903,
 '2014': 3035.742,
 '2015': 3154.216,
 '2016': 3277.402,
 '2017': 3405.873,
 '2018': 3540.279,
 '2019': 3681.488,
 '2020': 3830.26,
 '2021': 3987.074,
 '2022': 4152.209,
 '2023': 4326.026,
 '2024': 4508.833,
 '2025': 4700.984,
 '2026': 4902.946,
 '2027': 5115.253,
 '2028': 5338.398,
 '2029': 5572.899,
 '2030': 5819.271,
 '2031': 6078.023,
 '2032': 6349.655,
 '2033': 6634.636,
 '2034': 6933.359,
 '2035': 7245.968,
 '2036': 7569.308,
 '2037': 7903.07,
 '2038': 8247.348,
 '2039': 8602.239,
 '2040': 8967.814,
 '2041': 9344.155,
 '2042': 9731.317,
 '2043': 10129.338,
 '2044': 10538.228,
 '2045': 10957.996,
 '2046': 11388.64,
 '2047': 11830.163,
 '2048': 12282.552,
 '2049': 12745.79,
 '2050': 13219.846},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '2000': 1893.34,
 '2001': 1961.513,
 '2002': 2031.256,
 '2003': 2104.163,
 '2004': 2182.494,
 '2005': 2267.68,
 '2006': 2360.797,
 '2007': 2461.001,
 '2008': 2565.811,
 '2009': 2671.341,
 '2010': 2774.827,
 '2011': 2875.145,
 '2012': 2973.18,
 '2013': 3070.663,
 '2014': 3170.336,
 '2015': 3274.286,
 '2016': 3383.087,
 '2017': 3496.228,
 '2018': 3613.4,
 '2019': 3733.933,
 '2020': 3857.353,
 '2021': 3983.698,
 '2022': 4113.312,
 '2023': 4246.426,
 '2024': 4383.333,
 '2025': 4524.254,
 '2026': 4669.254,
 '2027': 4818.318,
 '2028': 4971.477,
 '2029': 5128.749,
 '2030': 5290.114,
 '2031': 5455.551,
 '2032': 5624.964,
 '2033': 5798.117,
 '2034': 5975.104,
 '2035': 6155.655,
 '2036': 6339.708,
 '2037': 6527.164,
 '2038': 6717.815,
 '2039': 6911.412,
 '2040': 7107.743,
 '2041': 7306.687,
 '2042': 7508.186,
 '2043': 7712.184,
 '2044': 7918.637,
 '2045': 8127.512,
 '2046': 8338.736,
 '2047': 8552.284,
 '2048': 8768.202,
 '2049': 8986.594,
 '2050': 9207.524},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '2000': 16534.234,
 '2001': 17222.057,
 '2002': 17968.327,
 '2003': 18770.684,
 '2004': 19622.66,
 '2005': 20521.483,
 '2006': 21470.101,
 '2007': 22473.029,
 '2008': 23531.326,
 '2009': 24645.971,
 '2010': 25817.901,
 '2011': 27048.151,
 '2012': 28337.627,
 '2013': 29686.908,
 '2014': 31096.388,
 '2015': 32566.508,
 '2016': 34098.241,
 '2017': 35692.384,
 '2018': 37348.939,
 '2019': 39067.608,
 '2020': 40848.447,
 '2021': 42691.732,
 '2022': 44598.623,
 '2023': 46571.127,
 '2024': 48611.843,
 '2025': 50722.858,
 '2026': 52904.879,
 '2027': 55157.935,
 '2028': 57482.464,
 '2029': 59878.32,
 '2030': 62343.48,
 '2031': 64884.278,
 '2032': 67498.008,
 '2033': 70184.405,
 '2034': 72942.849,
 '2035': 75772.61,
 '2036': 78673.304,
 '2037': 81644.233,
 '2038': 84683.807,
 '2039': 87790.004,
 '2040': 90960.949,
 '2041': 94195.271,
 '2042': 97491.852,
 '2043': 100849.26,
 '2044': 104266.058,
 '2045': 107740.801,
 '2046': 111271.821,
 '2047': 114857.569,
 '2048': 118496.813,
 '2049': 122188.455,
 '2050': 125931.197},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '2000': 301.586,
 '2001': 325.206,
 '2002': 350.349,
 '2003': 377.222,
 '2004': 406.137,
 '2005': 437.275,
 '2006': 470.822,
 '2007': 506.718,
 '2008': 544.893,
 '2009': 585.082,
 '2010': 627.157,
 '2011': 671.022,
 '2012': 716.629,
 '2013': 753.676,
 '2014': 791.529,
 '2015': 830.013,
 '2016': 868.94,
 '2017': 908.254,
 '2018': 947.881,
 '2019': 987.808,
 '2020': 1027.99,
 '2021': 1068.36,
 '2022': 1108.883,
 '2023': 1149.627,
 '2024': 1190.713,
 '2025': 1232.213,
 '2026': 1274.166,
 '2027': 1316.528,
 '2028': 1359.177,
 '2029': 1401.949,
 '2030': 1444.719,
 '2031': 1487.436,
 '2032': 1530.15,
 '2033': 1573.019,
 '2034': 1616.276,
 '2035': 1660.076,
 '2036': 1704.471,
 '2037': 1749.403,
 '2038': 1794.768,
 '2039': 1840.42,
 '2040': 1886.245,
 '2041': 1932.206,
 '2042': 1978.454,
 '2043': 2024.956,
 '2044': 2071.675,
 '2045': 2118.585,
 '2046': 2165.652,
 '2047': 2212.853,
 '2048': 2260.213,
 '2049': 2307.775,
 '2050': 2355.543},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '2000': 971.091,
 '2001': 1005.172,
 '2002': 1040.289,
 '2003': 1076.897,
 '2004': 1115.625,
 '2005': 1156.908,
 '2006': 1200.768,
 '2007': 1247.086,
 '2008': 1296.102,
 '2009': 1348.027,
 '2010': 1402.919,
 '2011': 1461.072,
 '2012': 1522.001,
 '2013': 1583.869,
 '2014': 1644.08,
 '2015': 1700.834,
 '2016': 1753.288,
 '2017': 1801.892,
 '2018': 1847.776,
 '2019': 1892.734,
 '2020': 1938.139,
 '2021': 1984.317,
 '2022': 2030.901,
 '2023': 2077.77,
 '2024': 2124.612,
 '2025': 2171.202,
 '2026': 2217.603,
 '2027': 2263.982,
 '2028': 2310.36,
 '2029': 2356.768,
 '2030': 2403.217,
 '2031': 2449.723,
 '2032': 2496.272,
 '2033': 2542.896,
 '2034': 2589.594,
 '2035': 2636.38,
 '2036': 2683.238,
 '2037': 2730.15,
 '2038': 2777.086,
 '2039': 2824.008,
 '2040': 2871.071,
 '2041': 2918.24,
 '2042': 2965.489,
 '2043': 3012.756,
 '2044': 3059.966,
 '2045': 3107.08,
 '2046': 3154.05,
 '2047': 3200.822,
 '2048': 3247.349,
 '2049': 3293.57,
 '2050': 3339.415},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '2000': 74.049,
 '2001': 77.009,
 '2002': 80.492,
 '2003': 84.226,
 '2004': 88.099,
 '2005': 92.078,
 '2006': 96.152,
 '2007': 100.34,
 '2008': 104.622,
 '2009': 109.018,
 '2010': 113.52,
 '2011': 118.122,
 '2012': 122.828,
 '2013': 127.58,
 '2014': 132.381,
 '2015': 137.228,
 '2016': 142.12,
 '2017': 147.051,
 '2018': 152.026,
 '2019': 157.043,
 '2020': 162.101,
 '2021': 167.201,
 '2022': 172.334,
 '2023': 177.512,
 '2024': 182.727,
 '2025': 187.994,
 '2026': 193.299,
 '2027': 198.648,
 '2028': 204.034,
 '2029': 209.438,
 '2030': 214.863,
 '2031': 220.291,
 '2032': 225.726,
 '2033': 231.165,
 '2034': 236.597,
 '2035': 242.018,
 '2036': 247.418,
 '2037': 252.794,
 '2038': 258.15,
 '2039': 263.531,
 '2040': 268.937,
 '2041': 274.363,
 '2042': 279.814,
 '2043': 285.284,
 '2044': 290.76,
 '2045': 296.248,
 '2046': 301.739,
 '2047': 307.239,
 '2048': 312.739,
 '2049': 318.243,
 '2050': 323.753}]},
'Urban Population': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
1950,
1955,
1960,
1965,
1970,
1975,
1980,
1985,
1990,
1995,
2000,
2005,
2010,
2015,
2020,
2025,
2030,
2035,
2040,
2045,
2050],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950': 750902.938,
 '1955': 877008.8420000004,
 '1960': 1023845.5169999995,
 '1965': 1188469.2240000002,
 '1970': 1354215.4959999996,
 '1975': 1538624.994,
 '1980': 1754201.0289999994,
 '1985': 2007939.0629999996,
 '1990': 2290228.096000001,
 '1995': 2575505.235000001,
 '2000': 2868307.512999999,
 '2005': 3215905.863000001,
 '2010': 3594868.145999999,
 '2015': 3981497.662999999,
 '2020': 4378993.944000001,
 '2025': 4774646.303,
 '2030': 5167257.546,
 '2035': 5555833.476999998,
 '2040': 5938249.026000003,
 '2045': 6312544.819000001,
 '2050': 6679756.161999998},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950': 446284.3680000001,
 '1955': 501111.2830000001,
 '1960': 560260.3829999999,
 '1965': 619701.5070000002,
 '1970': 674089.69,
 '1975': 722460.807,
 '1980': 762102.059,
 '1985': 796652.123,
 '1990': 829876.6969999999,
 '1995': 858565.242,
 '2000': 883879.932,
 '2005': 918342.0160000001,
 '2010': 954090.9290000002,
 '2015': 979088.8050000002,
 '2020': 1003639.9990000001,
 '2025': 1027097.159,
 '2030': 1049699.4640000002,
 '2035': 1070804.1600000001,
 '2040': 1090432.5520000001,
 '2045': 1108231.2740000002,
 '2050': 1123972.267},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950': 304618.5699999999,
 '1955': 375897.5590000003,
 '1960': 463585.1339999996,
 '1965': 568767.717,
 '1970': 680125.8059999996,
 '1975': 816164.1869999998,
 '1980': 992098.9699999994,
 '1985': 1211286.9399999997,
 '1990': 1460351.3990000007,
 '1995': 1716939.9930000007,
 '2000': 1984427.5809999988,
 '2005': 2297563.8470000005,
 '2010': 2640777.2169999983,
 '2015': 3002408.8579999986,
 '2020': 3375353.945000001,
 '2025': 3747549.1440000003,
 '2030': 4117558.082,
 '2035': 4485029.316999998,
 '2040': 4847816.474000003,
 '2045': 5204313.545000001,
 '2050': 5555783.894999998},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950': 14719.521,
 '1955': 18374.545,
 '1960': 23254.988,
 '1965': 30004.604,
 '1970': 39626.305,
 '1975': 50433.199,
 '1980': 67387.325,
 '1985': 86125.749,
 '1990': 109838.483,
 '1995': 136975.889,
 '2000': 166314.7290000001,
 '2005': 204619.174,
 '2010': 250013.231,
 '2015': 305950.7559999999,
 '2020': 372038.455,
 '2025': 449497.9220000001,
 '2030': 538528.855,
 '2035': 639203.7940000001,
 '2040': 750922.2739999999,
 '2045': 873337.9419999998,
 '2050': 1005761.9990000005},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950': 289899.049,
 '1955': 357523.0140000003,
 '1960': 440330.1459999997,
 '1965': 538763.1129999999,
 '1970': 640499.501,
 '1975': 765730.9879999997,
 '1980': 924711.6449999996,
 '1985': 1125161.1909999999,
 '1990': 1350512.9160000002,
 '1995': 1579964.1040000007,
 '2000': 1818112.851999999,
 '2005': 2092944.6730000004,
 '2010': 2390763.985999999,
 '2015': 2696458.1019999995,
 '2020': 3003315.4900000007,
 '2025': 3298051.222,
 '2030': 3579029.227000001,
 '2035': 3845825.5229999986,
 '2040': 4096894.1999999993,
 '2045': 4330975.602999999,
 '2050': 4550021.896},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950': 235263.4939999999,
 '1955': 286330.8699999999,
 '1960': 350890.3419999998,
 '1965': 430589.4210000001,
 '1970': 527615.2810000001,
 '1975': 645425.6959999998,
 '1980': 786344.1469999994,
 '1985': 950055.4269999997,
 '1990': 1130774.7160000002,
 '1995': 1311996.5690000006,
 '2000': 1501700.058999999,
 '2005': 1711930.2349999992,
 '2010': 1946607.081999999,
 '2015': 2201144.9490000005,
 '2020': 2473276.185,
 '2025': 2763104.132,
 '2030': 3071075.745,
 '2035': 3396289.7759999996,
 '2040': 3735045.4459999977,
 '2045': 4083024.8380000005,
 '2050': 4434790.122000001},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950': 393682.1030000001,
 '1955': 437320.834,
 '1960': 485582.6819999999,
 '1965': 535949.1700000003,
 '1970': 584693.946,
 '1975': 629041.888,
 '1980': 668137.2890000003,
 '1985': 705561.1269999999,
 '1990': 744350.0139999999,
 '1995': 783669.6139999998,
 '2000': 821848.9110000004,
 '2005': 869805.3880000002,
 '2010': 919422.9479999999,
 '2015': 955213.3680000001,
 '2020': 988586.2680000002,
 '2025': 1019399.05,
 '2030': 1048879.4759999998,
 '2035': 1075813.363,
 '2040': 1099735.4509999997,
 '2045': 1120535.366,
 '2050': 1138335.6069999996},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950': 345034.7990000001,
 '1955': 424896.863,
 '1960': 519401.0799999999,
 '1965': 628628.8259999999,
 '1970': 738083.2550000001,
 '1975': 869907.548,
 '1980': 1037063.7679999997,
 '1985': 1242008.5559999996,
 '1990': 1470899.724,
 '1995': 1699644.0159999998,
 '2000': 1935345.4209999999,
 '2005': 2211226.411,
 '2010': 2511182.5549999997,
 '2015': 2825251.8899999997,
 '2020': 3144887.1110000005,
 '2025': 3456424.614,
 '2030': 3756587.0049999994,
 '2035': 4045090.7019999996,
 '2040': 4320349.193000001,
 '2045': 4581025.122,
 '2050': 4828424.336},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950': 211087.541,
 '1955': 265940.548,
 '1960': 329935.42,
 '1965': 401852.2109999998,
 '1970': 466100.914,
 '1975': 540533.877,
 '1980': 635382.9059999996,
 '1985': 757478.5359999996,
 '1990': 892370.049,
 '1995': 1025413.8159999998,
 '2000': 1159790.71,
 '2005': 1319219.5919999997,
 '2010': 1487718.1709999999,
 '2015': 1659611.3229999999,
 '2020': 1821035.9030000004,
 '2025': 1957222.737,
 '2030': 2068824.5599999996,
 '2035': 2157097.8049999997,
 '2040': 2223591.5800000005,
 '2045': 2270585.5400000005,
 '2050': 2303922.0340000005},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950': 133947.258,
 '1955': 158956.315,
 '1960': 189465.6599999999,
 '1965': 226776.615,
 '1970': 271982.3410000001,
 '1975': 329373.6709999999,
 '1980': 401680.862,
 '1985': 484530.0200000001,
 '1990': 578529.6749999998,
 '1995': 674230.2,
 '2000': 775554.7109999999,
 '2005': 892006.8190000001,
 '2010': 1023464.384,
 '2015': 1165640.567,
 '2020': 1323851.2080000003,
 '2025': 1499201.8770000003,
 '2030': 1687762.4449999998,
 '2035': 1887992.897,
 '2040': 2096757.6130000006,
 '2045': 2310439.582,
 '2050': 2524502.3019999997},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950': 11933.012,
 '1955': 14459.584,
 '1960': 18408.765,
 '1965': 23290.732,
 '1970': 30682.967,
 '1975': 38810.908,
 '1980': 47952.904,
 '1985': 59094.679,
 '1990': 73456.664,
 '1995': 90471.688,
 '2000': 109161.422,
 '2005': 132644.674,
 '2010': 161884.396,
 '2015': 198535.599,
 '2020': 242877.3579999999,
 '2025': 296030.328,
 '2030': 358847.63,
 '2035': 431837.128,
 '2040': 514930.361,
 '2045': 607620.8830000001,
 '2050': 709516.898},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950': 19942.285,
 '1955': 25492.984,
 '1960': 32989.668,
 '1965': 41228.021,
 '1970': 51846.543,
 '1975': 66085.509,
 '1980': 84118.271,
 '1985': 106784.175,
 '1990': 135536.893,
 '1995': 167013.2560000001,
 '2000': 202640.5020000001,
 '2005': 248352.011,
 '2010': 305507.566,
 '2015': 375826.517,
 '2020': 458669.5750000002,
 '2025': 555122.7630000002,
 '2030': 666165.225,
 '2035': 792225.4830000002,
 '2040': 933129.8409999999,
 '2045': 1088774.482,
 '2050': 1258336.122},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950': 32658.962,
 '1955': 41419.217,
 '1960': 53008.425,
 '1965': 66348.577,
 '1970': 82637.37,
 '1975': 103198.989,
 '1980': 128615.954,
 '1985': 160721.947,
 '1990': 200111.296,
 '1995': 241824.184,
 '2000': 285997.612,
 '2005': 341033.592,
 '2010': 408587.0449999999,
 '2015': 491531.0920000001,
 '2020': 587737.7930000001,
 '2025': 698148.943,
 '2030': 824013.801,
 '2035': 966329.885,
 '2040': 1125161.5150000001,
 '2045': 1299953.2489999998,
 '2050': 1488920.045},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950': 3836.643,
 '1955': 4978.234,
 '1960': 6514.299,
 '1965': 8702.83,
 '1970': 11752.648,
 '1975': 15854.488,
 '1980': 21478.562,
 '1985': 27720.992,
 '1990': 35850.678,
 '1995': 44589.205,
 '2000': 54950.508,
 '2005': 67684.204,
 '2010': 84503.529,
 '2015': 106095.604,
 '2020': 132520.364,
 '2025': 164482.084,
 '2030': 202579.194,
 '2035': 247131.197,
 '2040': 298002.537,
 '2045': 355029.937,
 '2050': 418216.589},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950': 39.974,
 '1955': 48.001,
 '1960': 57.866,
 '1965': 70.605,
 '1970': 98.327,
 '1975': 129.408,
 '1980': 178.649,
 '1985': 245.514,
 '1990': 339.609,
 '1995': 429.9,
 '2000': 527.819,
 '2005': 695.94,
 '2010': 932.971,
 '2015': 1231.911,
 '2020': 1636.586,
 '2025': 2146.694,
 '2030': 2780.242,
 '2035': 3568.656,
 '2040': 4548.959,
 '2045': 5749.545,
 '2050': 7182.692},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950': 10.526,
 '1955': 16.095,
 '1960': 23.988,
 '1965': 35.217,
 '1970': 44.607,
 '1975': 54.647,
 '1980': 71.463,
 '1985': 90.5,
 '1990': 114.709,
 '1995': 134.543,
 '2000': 152.293,
 '2005': 170.493,
 '2010': 192.925,
 '2015': 221.334,
 '2020': 255.487,
 '2025': 296.345,
 '2030': 345.321,
 '2035': 401.157,
 '2040': 462.325,
 '2045': 528.51,
 '2050': 599.041},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950': 24.682,
 '1955': 31.323,
 '1960': 42.09,
 '1965': 64.504,
 '1970': 98.633,
 '1975': 150.521,
 '1980': 258.795,
 '1985': 318.89,
 '1990': 448.449,
 '1995': 480.987,
 '2000': 549.178,
 '2005': 601.236,
 '2010': 655.376,
 '2015': 717.972,
 '2020': 780.538,
 '2025': 843.657,
 '2030': 905.821,
 '2035': 965.276,
 '2040': 1019.38,
 '2045': 1066.788,
 '2050': 1107.45},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950': 81.093,
 '1955': 104.318,
 '1960': 136.944,
 '1965': 182.223,
 '1970': 229.718,
 '1975': 280.493,
 '1980': 343.289,
 '1985': 433.816,
 '1990': 588.576,
 '1995': 695.721,
 '2000': 902.054,
 '2005': 1234.323,
 '2010': 1544.485,
 '2015': 1851.851,
 '2020': 2246.038,
 '2025': 2698.752,
 '2030': 3210.132,
 '2035': 3781.931,
 '2040': 4406.917,
 '2045': 5076.734,
 '2050': 5776.366},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950': 833.89,
 '1955': 1085.996,
 '1960': 1425.096,
 '1965': 1897.839,
 '1970': 2440.181,
 '1975': 3080.708,
 '1980': 3671.221,
 '1985': 4673.05,
 '1990': 6069.048,
 '1995': 7924.483,
 '2000': 9807.289,
 '2005': 12046.373,
 '2010': 15189.14,
 '2015': 19403.087,
 '2020': 24463.423,
 '2025': 30487.323,
 '2030': 37495.72,
 '2035': 45488.077,
 '2040': 54394.212,
 '2045': 64087.447,
 '2050': 74536.815},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950': 339.667,
 '1955': 448.051,
 '1960': 596.757,
 '1965': 817.908,
 '1970': 1158.465,
 '1975': 1741.729,
 '1980': 2535.258,
 '1985': 3159.732,
 '1990': 3919.437,
 '1995': 4994.299,
 '2000': 6256.185,
 '2005': 7813.454,
 '2010': 9746.669,
 '2015': 12119.756,
 '2020': 14975.059,
 '2025': 18371.967,
 '2030': 22382.984,
 '2035': 27025.992,
 '2040': 32241.885,
 '2045': 37975.346,
 '2050': 44184.721},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950': 318.517,
 '1955': 414.442,
 '1960': 542.656,
 '1965': 714.199,
 '1970': 927.259,
 '1975': 1234.215,
 '1980': 1614.681,
 '1985': 2106.614,
 '1990': 2733.282,
 '1995': 3476.13,
 '2000': 4276.171,
 '2005': 5283.543,
 '2010': 6755.337,
 '2015': 8528.793,
 '2020': 10670.252,
 '2025': 13199.949,
 '2030': 16101.66,
 '2035': 19327.758,
 '2040': 22905.168,
 '2045': 26853.051,
 '2050': 31157.741},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950': 103.56,
 '1955': 127.621,
 '1960': 158.848,
 '1965': 199.188,
 '1970': 278.646,
 '1975': 404.986,
 '1980': 557.771,
 '1985': 732.861,
 '1990': 1090.992,
 '1995': 1314.278,
 '2000': 1662.05,
 '2005': 1962.982,
 '2010': 2357.581,
 '2015': 2866.7,
 '2020': 3534.836,
 '2025': 4407.124,
 '2030': 5551.124,
 '2035': 7021.73,
 '2040': 8808.675,
 '2045': 10916.62,
 '2050': 13360.225},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950': 144.658,
 '1955': 180.433,
 '1960': 231.739,
 '1965': 292.028,
 '1970': 351.699,
 '1975': 387.6,
 '1980': 409.127,
 '1985': 429.921,
 '1990': 463.526,
 '1995': 488.537,
 '2000': 505.705,
 '2005': 514.605,
 '2010': 518.584,
 '2015': 516.377,
 '2020': 519.33,
 '2025': 526.689,
 '2030': 538.588,
 '2035': 554.003,
 '2040': 572.012,
 '2045': 589.818,
 '2050': 604.348},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950': 1.29,
 '1955': 2.256,
 '1960': 3.922,
 '1965': 6.726,
 '1970': 9.296,
 '1975': 12.528,
 '1980': 16.585,
 '1985': 23.794,
 '1990': 34.176,
 '1995': 51.068,
 '2000': 71.754,
 '2005': 89.462,
 '2010': 102.176,
 '2015': 112.783,
 '2020': 124.952,
 '2025': 139.411,
 '2030': 157.242,
 '2035': 179.252,
 '2040': 205.819,
 '2045': 234.658,
 '2050': 264.489},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950': 336.659,
 '1955': 411.022,
 '1960': 507.47,
 '1965': 644.765,
 '1970': 823.643,
 '1975': 1124.358,
 '1980': 1558.995,
 '1985': 2379.536,
 '1990': 3311.912,
 '1995': 4332.986,
 '2000': 5257.395,
 '2005': 6276.808,
 '2010': 7709.657,
 '2015': 9635.602,
 '2020': 11978.439,
 '2025': 14810.679,
 '2030': 18195.295,
 '2035': 22168.384,
 '2040': 26725.869,
 '2045': 31831.909,
 '2050': 37472.562},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950': 58.29,
 '1955': 81.45,
 '1960': 110.236,
 '1965': 149.095,
 '1970': 192.488,
 '1975': 215.529,
 '1980': 272.356,
 '1985': 379.443,
 '1990': 495.959,
 '1995': 580.045,
 '2000': 671.649,
 '2005': 762.323,
 '2010': 818.067,
 '2015': 857.659,
 '2020': 893.481,
 '2025': 926.529,
 '2030': 955.563,
 '2035': 979.722,
 '2040': 997.546,
 '2045': 1008.359,
 '2050': 1012.578},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950': 46.208,
 '1955': 59.211,
 '1960': 76.269,
 '1965': 93.184,
 '1970': 119.936,
 '1975': 174.257,
 '1980': 242.682,
 '1985': 309.499,
 '1990': 391.898,
 '1995': 583.164,
 '2000': 1197.92,
 '2005': 1520.718,
 '2010': 1735.198,
 '2015': 1977.467,
 '2020': 2281.33,
 '2025': 2659.944,
 '2030': 3143.843,
 '2035': 3768.985,
 '2040': 4562.582,
 '2045': 5477.407,
 '2050': 6483.462},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950': 9.953,
 '1955': 10.683,
 '1960': 11.496,
 '1965': 15.492,
 '1970': 20.458,
 '1975': 27.57,
 '1980': 32.727,
 '1985': 34.423,
 '1990': 34.796,
 '1995': 38.07,
 '2000': 40.927,
 '2005': 45.854,
 '2010': 48.752,
 '2015': 51.933,
 '2020': 55.308,
 '2025': 58.12,
 '2030': 60.516,
 '2035': 62.662,
 '2040': 64.582,
 '2045': 66.169,
 '2050': 67.254},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950': 288.122,
 '1955': 370.572,
 '1960': 477.113,
 '1965': 612.593,
 '1970': 781.165,
 '1975': 989.409,
 '1980': 1701.924,
 '1985': 1906.249,
 '1990': 2193.935,
 '1995': 2421.245,
 '2000': 2996.056,
 '2005': 3779.95,
 '2010': 4738.106,
 '2015': 6014.594,
 '2020': 7431.038,
 '2025': 9168.559,
 '2030': 11229.249,
 '2035': 13626.15,
 '2040': 16358.048,
 '2045': 19435.527,
 '2050': 22865.427},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950': 228.973,
 '1955': 239.67,
 '1960': 258.524,
 '1965': 283.626,
 '1970': 314.909,
 '1975': 353.282,
 '1980': 400.849,
 '1985': 536.559,
 '1990': 765.828,
 '1995': 866.57,
 '2000': 1105.85,
 '2005': 1391.012,
 '2010': 1797.991,
 '2015': 2240.02,
 '2020': 2749.061,
 '2025': 3378.254,
 '2030': 4163.609,
 '2035': 5136.964,
 '2040': 6289.84,
 '2045': 7619.84,
 '2050': 9131.58},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950': 145.449,
 '1955': 208.359,
 '1960': 299.817,
 '1965': 441.548,
 '1970': 629.441,
 '1975': 762.275,
 '1980': 945.46,
 '1985': 1340.406,
 '1990': 1931.504,
 '1995': 2639.817,
 '2000': 3554.371,
 '2005': 4841.176,
 '2010': 6573.772,
 '2015': 8855.831,
 '2020': 11775.012,
 '2025': 15430.672,
 '2030': 19914.432,
 '2035': 25273.067,
 '2040': 31490.363,
 '2045': 38580.183,
 '2050': 46663.616},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950': 267.063,
 '1955': 385.389,
 '1960': 528.498,
 '1965': 704.473,
 '1970': 1068.352,
 '1975': 1781.21,
 '1980': 2719.241,
 '1985': 3661.481,
 '1990': 4807.84,
 '1995': 6154.968,
 '2000': 7624.725,
 '2005': 9791.527,
 '2010': 12959.969,
 '2015': 17035.213,
 '2020': 22113.353,
 '2025': 28244.987,
 '2030': 35529.056,
 '2035': 44000.95,
 '2040': 53579.195,
 '2045': 64407.122,
 '2050': 76542.196},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950': 265.701,
 '1955': 382.236,
 '1960': 552.492,
 '1965': 832.85,
 '1970': 1266.841,
 '1975': 1734.432,
 '1980': 2344.812,
 '1985': 2758.109,
 '1990': 3163.284,
 '1995': 3390.243,
 '2000': 3665.128,
 '2005': 4448.559,
 '2010': 5450.667,
 '2015': 6747.236,
 '2020': 8336.381,
 '2025': 10256.668,
 '2030': 12548.518,
 '2035': 15219.971,
 '2040': 18271.801,
 '2045': 21722.143,
 '2050': 25576.78},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950': 292.368,
 '1955': 371.106,
 '1960': 472.478,
 '1965': 644.767,
 '1970': 898.584,
 '1975': 1215.331,
 '1980': 1602.677,
 '1985': 2200.595,
 '1990': 2951.918,
 '1995': 3592.151,
 '2000': 4125.989,
 '2005': 4413.866,
 '2010': 4676.106,
 '2015': 5109.485,
 '2020': 5700.46,
 '2025': 6429.761,
 '2030': 7370.279,
 '2035': 8580.51,
 '2040': 10097.359,
 '2045': 11802.761,
 '2050': 13627.246},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950': 3680.616,
 '1955': 4559.02,
 '1960': 5703.903,
 '1965': 7119.461,
 '1970': 9014.313,
 '1975': 11764.049,
 '1980': 15058.566,
 '1985': 19099.537,
 '1990': 24274.759,
 '1995': 31101.345,
 '2000': 38183.621,
 '2005': 47647.23,
 '2010': 59347.838,
 '2015': 73632.499,
 '2020': 90619.3,
 '2025': 110578.741,
 '2030': 133727.544,
 '2035': 160149.59,
 '2040': 189707.591,
 '2045': 222156.044,
 '2050': 257253.521},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950': 344.543,
 '1955': 455.428,
 '1960': 588.842,
 '1965': 775.667,
 '1970': 1013.531,
 '1975': 1469.515,
 '1980': 2169.81,
 '1985': 3218.567,
 '1990': 4520.997,
 '1995': 6302.478,
 '2000': 8234.824,
 '2005': 10949.424,
 '2010': 13970.854,
 '2015': 17675.745,
 '2020': 21936.953,
 '2025': 26847.887,
 '2030': 32437.132,
 '2035': 38691.449,
 '2040': 45556.399,
 '2045': 53037.025,
 '2050': 61131.579},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950': 401.988,
 '1955': 537.904,
 '1960': 721.399,
 '1965': 975.314,
 '1970': 1325.11,
 '1975': 2035.248,
 '1980': 2751.106,
 '1985': 3641.311,
 '1990': 4645.941,
 '1995': 5730.711,
 '2000': 6956.118,
 '2005': 8456.175,
 '2010': 10296.608,
 '2015': 12462.615,
 '2020': 14941.523,
 '2025': 17739.676,
 '2030': 20857.109,
 '2035': 24290.758,
 '2040': 28048.983,
 '2045': 32105.585,
 '2050': 36415.328},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950': 191.278,
 '1955': 238.917,
 '1960': 302.205,
 '1965': 387.79,
 '1970': 502.752,
 '1975': 644.978,
 '1980': 772.263,
 '1985': 935.996,
 '1990': 1082.57,
 '1995': 1248.262,
 '2000': 1413.327,
 '2005': 1571.461,
 '2010': 1730.652,
 '2015': 1831.054,
 '2020': 2076.534,
 '2025': 2451.673,
 '2030': 2917.639,
 '2035': 3454.676,
 '2040': 4039.45,
 '2045': 4665.212,
 '2050': 5329.336},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950': 112.604,
 '1955': 150.299,
 '1960': 200.952,
 '1965': 278.207,
 '1970': 421.481,
 '1975': 636.342,
 '1980': 847.659,
 '1985': 1007.073,
 '1990': 1239.707,
 '1995': 1503.25,
 '2000': 1805.052,
 '2005': 2194.746,
 '2010': 2613.4,
 '2015': 3154.216,
 '2020': 3830.26,
 '2025': 4700.984,
 '2030': 5819.271,
 '2035': 7245.968,
 '2040': 8967.814,
 '2045': 10957.996,
 '2050': 13219.846},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950': 206.199,
 '1955': 258.973,
 '1960': 327.769,
 '1965': 417.746,
 '1970': 534.042,
 '1975': 687.909,
 '1980': 880.532,
 '1985': 1111.137,
 '1990': 1325.761,
 '1995': 1579.132,
 '2000': 1893.34,
 '2005': 2267.68,
 '2010': 2774.827,
 '2015': 3274.286,
 '2020': 3857.353,
 '2025': 4524.254,
 '2030': 5290.114,
 '2035': 6155.655,
 '2040': 7107.743,
 '2045': 8127.512,
 '2050': 9207.524},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950': 2327.079,
 '1955': 2791.904,
 '1960': 3400.36,
 '1965': 4070.472,
 '1970': 4924.023,
 '1975': 5913.533,
 '1980': 7135.522,
 '1985': 8520.577,
 '1990': 10603.379,
 '1995': 13659.173,
 '2000': 16534.234,
 '2005': 20521.483,
 '2010': 25817.901,
 '2015': 32566.508,
 '2020': 40848.447,
 '2025': 50722.858,
 '2030': 62343.48,
 '2035': 75772.61,
 '2040': 90960.949,
 '2045': 107740.801,
 '2050': 125931.197},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950': 34.875,
 '1955': 48.725,
 '1960': 65.202,
 '1965': 73.516,
 '1970': 82.618,
 '1975': 71.198,
 '1980': 71.164,
 '1985': 107.455,
 '1990': 148.306,
 '1995': 204.444,
 '2000': 301.586,
 '2005': 437.275,
 '2010': 627.157,
 '2015': 830.013,
 '2020': 1027.99,
 '2025': 1232.213,
 '2030': 1444.719,
 '2035': 1660.076,
 '2040': 1886.245,
 '2045': 2118.585,
 '2050': 2355.543},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950': 53.956,
 '1955': 68.209,
 '1960': 86.847,
 '1965': 126.602,
 '1970': 188.838,
 '1975': 279.19,
 '1980': 398.719,
 '1985': 517.989,
 '1990': 658.385,
 '1995': 812.399,
 '2000': 971.091,
 '2005': 1156.908,
 '2010': 1402.919,
 '2015': 1700.834,
 '2020': 1938.139,
 '2025': 2171.202,
 '2030': 2403.217,
 '2035': 2636.38,
 '2040': 2871.071,
 '2045': 3107.08,
 '2050': 3339.415},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950': 8.094,
 '1955': 8.661,
 '1960': 10.327,
 '1965': 14.147,
 '1970': 21.918,
 '1975': 26.136,
 '1980': 31.791,
 '1985': 39.432,
 '1990': 49.713,
 '1995': 61.496,
 '2000': 74.049,
 '2005': 92.078,
 '2010': 113.52,
 '2015': 137.228,
 '2020': 162.101,
 '2025': 187.994,
 '2030': 214.863,
 '2035': 242.018,
 '2040': 268.937,
 '2045': 296.248,
 '2050': 323.753},
{'Index': 45,
 'Region, subregion, country or area': 'Northern Africa',
 'Note': '',
 'Country\ncode': 912,
 '1950': 12716.677,
 '1955': 15926.233,
 '1960': 20018.757,
 '1965': 25120.556,
 '1970': 30790.827,
 '1975': 37113.48,
 '1980': 44497.683,
 '1985': 53937.772,
 '1990': 64574.403,
 '1995': 74810.928,
 '2000': 83357.11,
 '2005': 92681.581,
 '2010': 103079.479,
 '2015': 115704.575,
 '2020': 129068.218,
 '2025': 143026.18,
 '2030': 157848.576,
 '2035': 174104.402,
 '2040': 192031.674,
 '2045': 211178.767,
 '2050': 230583.923},
{'Index': 46,
 'Region, subregion, country or area': 'Algeria',
 'Note': '',
 'Country\ncode': 12,
 '1950': 1970.81,
 '1955': 2570.392,
 '1960': 3394.238,
 '1965': 4753.122,
 '1970': 5747.203,
 '1975': 6738.763,
 '1980': 8419.984,
 '1985': 10824.4,
 '1990': 13496.502,
 '1995': 16185.664,
 '2000': 18684.813,
 '2005': 21247.946,
 '2010': 24393.696,
 '2015': 28248.247,
 '2020': 31950.91,
 '2025': 35291.973,
 '2030': 38231.625,
 '2035': 40881.593,
 '2040': 43466.952,
 '2045': 46053.277,
 '2050': 48531.498},
{'Index': 47,
 'Region, subregion, country or area': 'Egypt',
 'Note': '',
 'Country\ncode': 818,
 '1950': 6613.383,
 '1955': 8194.766,
 '1960': 10221.871,
 '1965': 12253.382,
 '1970': 14536.071,
 '1975': 16964.582,
 '1980': 19340.901,
 '1985': 22059.0,
 '1990': 24961.581,
 '1995': 27278.501,
 '2000': 29917.321,
 '2005': 33035.354,
 '2010': 36182.597,
 '2015': 40123.329,
 '2020': 44041.052,
 '2025': 48427.431,
 '2030': 53613.464,
 '2035': 59988.198,
 '2040': 67730.752,
 '2045': 76439.477,
 '2050': 85320.777},
{'Index': 48,
 'Region, subregion, country or area': 'Libya',
 'Note': '',
 'Country\ncode': 434,
 '1950': 219.815,
 '1955': 289.027,
 '1960': 395.754,
 '1965': 583.541,
 '1970': 1059.737,
 '1975': 1660.757,
 '1980': 2256.637,
 '1985': 2922.777,
 '1990': 3359.579,
 '1995': 3760.787,
 '2000': 4091.103,
 '2005': 4465.029,
 '2010': 4815.154,
 '2015': 4942.479,
 '2020': 5375.771,
 '2025': 5780.434,
 '2030': 6140.466,
 '2035': 6460.474,
 '2040': 6745.93,
 '2045': 6992.221,
 '2050': 7184.097},
{'Index': 49,
 'Region, subregion, country or area': 'Morocco',
 'Note': '',
 'Country\ncode': 504,
 '1950': 2352.9,
 '1955': 2913.419,
 '1960': 3619.334,
 '1965': 4533.672,
 '1970': 5516.314,
 '1975': 6714.483,
 '1980': 8250.172,
 '1985': 10091.997,
 '1990': 12039.279,
 '1995': 13995.788,
 '2000': 15386.939,
 '2005': 16839.654,
 '2010': 18803.302,
 '2015': 21163.594,
 '2020': 23551.599,
 '2025': 25869.035,
 '2030': 28068.51,
 '2035': 30126.912,
 '2040': 32017.574,
 '2045': 33725.978,
 '2050': 35257.592},
{'Index': 50,
 'Region, subregion, country or area': 'Sudan',
 'Note': '',
 'Country\ncode': 729,
 '1950': 391.254,
 '1955': 562.183,
 '1960': 810.765,
 '1965': 1172.787,
 '1970': 1698.802,
 '1975': 2300.428,
 '1980': 2895.483,
 '1985': 3947.451,
 '1990': 5764.212,
 '1995': 7768.8,
 '2000': 8855.115,
 '2005': 10126.64,
 '2010': 11378.101,
 '2015': 13099.314,
 '2020': 15349.424,
 '2025': 18220.482,
 '2030': 21775.077,
 '2035': 26089.178,
 '2040': 30993.999,
 '2045': 36393.69,
 '2050': 42261.243},
{'Index': 51,
 'Region, subregion, country or area': 'Tunisia',
 'Note': '',
 'Country\ncode': 788,
 '1950': 1164.248,
 '1955': 1389.87,
 '1960': 1566.577,
 '1965': 1805.609,
 '1970': 2200.342,
 '1975': 2689.901,
 '1980': 3220.311,
 '1985': 3942.049,
 '1990': 4770.561,
 '1995': 5602.764,
 '2000': 6152.385,
 '2005': 6590.593,
 '2010': 7092.304,
 '2015': 7672.383,
 '2020': 8280.799,
 '2025': 8853.818,
 '2030': 9372.398,
 '2035': 9847.992,
 '2040': 10304.596,
 '2045': 10741.9,
 '2050': 11138.512},
{'Index': 52,
 'Region, subregion, country or area': 'Western Sahara',
 'Note': '',
 'Country\ncode': 732,
 '1950': 4.267,
 '1955': 6.576,
 '1960': 10.218,
 '1965': 18.443,
 '1970': 32.358,
 '1975': 44.566,
 '1980': 114.195,
 '1985': 150.098,
 '1990': 182.689,
 '1995': 218.624,
 '2000': 269.434,
 '2005': 376.365,
 '2010': 414.325,
 '2015': 455.229,
 '2020': 518.663,
 '2025': 583.007,
 '2030': 647.036,
 '2035': 710.055,
 '2040': 771.871,
 '2045': 832.224,
 '2050': 890.204}]},
'Urbanization Rate': {'headers': ['Index',
'Region, subregion, country or area',
'Note',
'Country\ncode',
'1950-1955',
'1955-1960',
'1960-1965',
'1965-1970',
'1970-1975',
'1975-1980',
'1980-1985',
'1985-1990',
'1990-1995',
'1995-2000',
'2000-2005',
'2005-2010',
'2010-2015',
'2015-2020',
'2020-2025',
'2025-2030',
'2030-2035',
'2035-2040',
'2040-2045',
'2045-2050'],
'data': [{'Index': 1,
 'Region, subregion, country or area': 'WORLD',
 'Note': '',
 'Country\ncode': 900,
 '1950-1955': 1.3256092354,
 '1955-1960': 1.2967626357,
 '1960-1965': 1.0574781534,
 '1965-1970': 0.5583225006,
 '1970-1975': 0.6056506261,
 '1975-1980': 0.8441007137,
 '1980-1985': 0.9203542841,
 '1985-1990': 0.8376903383,
 '1990-1995': 0.8293258914,
 '1995-2000': 0.8298555641,
 '2000-2005': 1.0351905769,
 '2005-2010': 0.99498276,
 '2010-2015': 0.8577173093,
 '2015-2020': 0.8159567814,
 '2020-2025': 0.7533414963,
 '2025-2030': 0.7065784427,
 '2030-2035': 0.6669378407,
 '2035-2040': 0.6294070673,
 '2040-2045': 0.5943241771,
 '2045-2050': 0.5754877579},
{'Index': 2,
 'Region, subregion, country or area': 'More developed regions',
 'Note': 'a',
 'Country\ncode': 901,
 '1950-1955': 1.1216921431,
 '1955-1960': 1.0640339159,
 '1960-1965': 0.9485102305,
 '1965-1970': 0.8384297389,
 '1970-1975': 0.6021836805,
 '1975-1980': 0.4153175466,
 '1980-1985': 0.3105602861,
 '1985-1990': 0.268050756,
 '1990-1995': 0.2599736983,
 '1995-2000': 0.2563436323,
 '2000-2005': 0.4310982562,
 '2005-2010': 0.3614769798,
 '2010-2015': 0.2268843478,
 '2015-2020': 0.2404899742,
 '2020-2025': 0.2735705156,
 '2025-2030': 0.3009254935,
 '2030-2035': 0.3197738827,
 '2035-2040': 0.3247772462,
 '2040-2045': 0.3106676985,
 '2045-2050': 0.2863963089},
{'Index': 3,
 'Region, subregion, country or area': 'Less developed regions',
 'Note': 'b',
 'Country\ncode': 902,
 '1950-1955': 2.1555536931,
 '1955-1960': 2.1139924977,
 '1960-1965': 1.8051031552,
 '1965-1970': 1.0506262827,
 '1970-1975': 1.2796002694,
 '1975-1980': 1.7502715153,
 '1980-1985': 1.8383655872,
 '1985-1990': 1.5917085959,
 '1990-1995': 1.4277885971,
 '1995-2000': 1.3244335317,
 '2000-2005': 1.4632318961,
 '2005-2010': 1.3676017603,
 '2010-2015': 1.1935390311,
 '2015-2020': 1.0884416962,
 '2020-2025': 0.9656110756,
 '2025-2030': 0.8750313975,
 '2030-2035': 0.8038503178,
 '2035-2040': 0.7428464588,
 '2040-2045': 0.6919547921,
 '2045-2050': 0.6645334928},
{'Index': 4,
 'Region, subregion, country or area': 'Least developed countries',
 'Note': 'c',
 'Country\ncode': 941,
 '1950-1955': 2.4704866925,
 '1955-1960': 2.4884254889,
 '1960-1965': 2.6992445523,
 '1965-1970': 3.001205107,
 '1970-1975': 2.4648211024,
 '1975-1980': 3.2976067958,
 '1980-1985': 2.3354795895,
 '1985-1990': 2.2053594507,
 '1990-1995': 1.6873285148,
 '1995-2000': 1.340865511,
 '2000-2005': 1.6242614145,
 '2005-2010': 1.6419621854,
 '2010-2015': 1.6461317559,
 '2015-2020': 1.597205529,
 '2020-2025': 1.5564145561,
 '2025-2030': 1.5013969347,
 '2030-2035': 1.4321439883,
 '2035-2040': 1.3476680747,
 '2040-2045': 1.2700584798,
 '2045-2050': 1.1973624419},
{'Index': 5,
 'Region, subregion, country or area': 'Less developed regions, excluding least developed countries',
 'Note': 'd',
 'Country\ncode': 934,
 '1950-1955': 2.1330179855,
 '1955-1960': 2.1053296356,
 '1960-1965': 1.7650171113,
 '1965-1970': 0.9386356215,
 '1970-1975': 1.2033518534,
 '1975-1980': 1.6641781262,
 '1980-1985': 1.8257947298,
 '1985-1990': 1.5729761268,
 '1990-1995': 1.460030945,
 '1995-2000': 1.3827476921,
 '2000-2005': 1.5167415965,
 '2005-2010': 1.4045987137,
 '2010-2015': 1.2160670065,
 '2015-2020': 1.1048108022,
 '2020-2025': 0.9698363505,
 '2025-2030': 0.8675327446,
 '2030-2035': 0.785780281,
 '2035-2040': 0.7160780581,
 '2040-2045': 0.6559056632,
 '2045-2050': 0.6229306086},
{'Index': 6,
 'Region, subregion, country or area': 'Less developed regions, excluding China',
 'Note': '',
 'Country\ncode': 948,
 '1950-1955': 1.8393209234,
 '1955-1960': 1.7204436242,
 '1960-1965': 1.6370776808,
 '1965-1970': 1.5954461462,
 '1970-1975': 1.5874896106,
 '1975-1980': 1.5226469472,
 '1980-1985': 1.3505668469,
 '1985-1990': 1.1936466276,
 '1990-1995': 0.8915619887,
 '1995-2000': 0.8020460874,
 '2000-2005': 0.8471487891,
 '2005-2010': 0.8719629831,
 '2010-2015': 0.8238012002,
 '2015-2020': 0.8233073892,
 '2020-2025': 0.8319084661,
 '2025-2030': 0.8502124083,
 '2030-2035': 0.8583208345,
 '2035-2040': 0.8488858918,
 '2040-2045': 0.8251881974,
 '2045-2050': 0.7914848862},
{'Index': 7,
 'Region, subregion, country or area': 'High-income countries',
 'Note': 'e',
 'Country\ncode': 1503,
 '1950-1955': 0.8818866592,
 '1955-1960': 0.8387281294,
 '1960-1965': 0.7658382618,
 '1965-1970': 0.7205163039,
 '1970-1975': 0.5080948571,
 '1975-1980': 0.3933655834,
 '1980-1985': 0.3495496743,
 '1985-1990': 0.3558953713,
 '1990-1995': 0.3321875741,
 '1995-2000': 0.2952962207,
 '2000-2005': 0.4621797664,
 '2005-2010': 0.3664768413,
 '2010-2015': 0.2231917132,
 '2015-2020': 0.2225416398,
 '2020-2025': 0.2411747775,
 '2025-2030': 0.2572549476,
 '2030-2035': 0.2680849498,
 '2035-2040': 0.2704925872,
 '2040-2045': 0.2604486997,
 '2045-2050': 0.2403989468},
{'Index': 8,
 'Region, subregion, country or area': 'Middle-income countries',
 'Note': 'e',
 'Country\ncode': 1517,
 '1950-1955': 2.1640801207,
 '1955-1960': 2.0408047911,
 '1960-1965': 1.6636949239,
 '1965-1970': 0.8475182914,
 '1970-1975': 1.0710410405,
 '1975-1980': 1.5047038502,
 '1980-1985': 1.586774034,
 '1985-1990': 1.3779570458,
 '1990-1995': 1.2801817669,
 '1995-2000': 1.2387789818,
 '2000-2005': 1.4263147478,
 '2005-2010': 1.3569108117,
 '2010-2015': 1.203836438,
 '2015-2020': 1.1116872027,
 '2020-2025': 0.9901023911,
 '2025-2030': 0.8951678215,
 '2030-2035': 0.8183239838,
 '2035-2040': 0.7504370611,
 '2040-2045': 0.691669395,
 '2045-2050': 0.657835853},
{'Index': 9,
 'Region, subregion, country or area': 'Upper-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1502,
 '1950-1955': 2.55015143,
 '1955-1960': 2.4914844699,
 '1960-1965': 1.9179677835,
 '1965-1970': 0.5842595308,
 '1970-1975': 0.8518011614,
 '1975-1980': 1.5391470218,
 '1980-1985': 1.8488552538,
 '1985-1990': 1.5110785543,
 '1990-1995': 1.5792399435,
 '1995-2000': 1.5807955685,
 '2000-2005': 1.8102572305,
 '2005-2010': 1.652868402,
 '2010-2015': 1.4072095762,
 '2015-2020': 1.2344706684,
 '2020-2025': 1.0140471813,
 '2025-2030': 0.8228763496,
 '2030-2035': 0.6615305717,
 '2035-2040': 0.5264513102,
 '2040-2045': 0.4194582485,
 '2045-2050': 0.3778819766},
{'Index': 10,
 'Region, subregion, country or area': 'Lower-middle-income countries',
 'Note': 'e',
 'Country\ncode': 1501,
 '1950-1955': 1.5099406409,
 '1955-1960': 1.3457458247,
 '1960-1965': 1.2870882391,
 '1965-1970': 1.2958255885,
 '1970-1975': 1.4888810658,
 '1975-1980': 1.5891559216,
 '1980-1985': 1.3319787082,
 '1985-1990': 1.2808913659,
 '1990-1995': 1.0171421848,
 '1995-2000': 0.9602844969,
 '2000-2005': 1.103084214,
 '2005-2010': 1.1603059516,
 '2010-2015': 1.1172513123,
 '2015-2020': 1.1630053487,
 '2020-2025': 1.202204195,
 '2025-2030': 1.2182167,
 '2030-2035': 1.2134008165,
 '2035-2040': 1.1806834512,
 '2040-2045': 1.1272883275,
 '2045-2050': 1.0581469503},
{'Index': 11,
 'Region, subregion, country or area': 'Low-income countries',
 'Note': 'e',
 'Country\ncode': 1500,
 '1950-1955': 2.1790045043,
 '1955-1960': 2.7211636053,
 '1960-1965': 2.472737229,
 '1965-1970': 3.017602911,
 '1970-1975': 2.1903292467,
 '1975-1980': 1.7864710027,
 '1980-1985': 1.7794406145,
 '1985-1990': 1.7230813699,
 '1990-1995': 1.3466085759,
 '1995-2000': 1.0617636666,
 '2000-2005': 1.1204329806,
 '2005-2010': 1.2495395647,
 '2010-2015': 1.3533596473,
 '2015-2020': 1.3998863331,
 '2020-2025': 1.4418670201,
 '2025-2030': 1.4539080478,
 '2030-2035': 1.4355326082,
 '2035-2040': 1.3880236691,
 '2040-2045': 1.3190835979,
 '2045-2050': 1.2514885204},
{'Index': 12,
 'Region, subregion, country or area': 'Sub-Saharan Africa',
 'Note': 'f',
 'Country\ncode': 947,
 '1950-1955': 2.9245283739,
 '1955-1960': 2.9519435049,
 '1960-1965': 2.0657195486,
 '1965-1970': 2.0528743486,
 '1970-1975': 2.1889057628,
 '1975-1980': 2.0261359297,
 '1980-1985': 1.9417685961,
 '1985-1990': 1.9696177038,
 '1990-1995': 1.4704436254,
 '1995-2000': 1.2116476602,
 '2000-2005': 1.4037659071,
 '2005-2010': 1.4023279949,
 '2010-2015': 1.4028903459,
 '2015-2020': 1.3337145779,
 '2020-2025': 1.2800805801,
 '2025-2030': 1.2197805238,
 '2030-2035': 1.1509858241,
 '2035-2040': 1.0826130381,
 '2040-2045': 1.0275756697,
 '2045-2050': 0.9757396611},
{'Index': 13,
 'Region, subregion, country or area': 'AFRICA',
 'Note': '',
 'Country\ncode': 903,
 '1950-1955': 2.6518193185,
 '1955-1960': 2.6206653735,
 '1960-1965': 2.0289339722,
 '1965-1970': 1.8333061656,
 '1970-1975': 1.8169189714,
 '1975-1980': 1.6319565682,
 '1980-1985': 1.6333412294,
 '1985-1990': 1.6248872042,
 '1990-1995': 1.1795785051,
 '1995-2000': 0.8948430327,
 '2000-2005': 1.0559478802,
 '2005-2010': 1.0847549322,
 '2010-2015': 1.1092836386,
 '2015-2020': 1.0865884627,
 '2020-2025': 1.0801410668,
 '2025-2030': 1.0647480809,
 '2030-2035': 1.0381496753,
 '2035-2040': 1.0042613758,
 '2040-2045': 0.9711905638,
 '2045-2050': 0.9278563905},
{'Index': 14,
 'Region, subregion, country or area': 'Eastern Africa',
 'Note': '',
 'Country\ncode': 910,
 '1950-1955': 2.9921033646,
 '1955-1960': 2.9577585071,
 '1960-1965': 3.1664403966,
 '1965-1970': 3.2322322843,
 '1970-1975': 3.1342369446,
 '1975-1980': 3.1088138147,
 '1980-1985': 2.1341562083,
 '1985-1990': 2.1606310713,
 '1990-1995': 1.7805054725,
 '1995-2000': 1.2922505929,
 '2000-2005': 1.3519415331,
 '2005-2010': 1.5686243278,
 '2010-2015': 1.7345474494,
 '2015-2020': 1.7371875271,
 '2020-2025': 1.7525824741,
 '2025-2030': 1.7364693364,
 '2030-2035': 1.6875955459,
 '2035-2040': 1.6032073794,
 '2040-2045': 1.5083725297,
 '2045-2050': 1.4276057171},
{'Index': 15,
 'Region, subregion, country or area': 'Burundi',
 'Note': '',
 'Country\ncode': 108,
 '1950-1955': 1.8209425528,
 '1955-1960': 1.8235628212,
 '1960-1965': 1.9874494763,
 '1965-1970': 4.3053209774,
 '1970-1975': 4.2863473737,
 '1975-1980': 4.155269411,
 '1980-1985': 3.7009009522,
 '1985-1990': 3.6649375426,
 '1990-1995': 2.7934361275,
 '1995-2000': 2.682411927,
 '2000-2005': 2.5663667514,
 '2005-2010': 2.5352372864,
 '2010-2015': 2.5315435942,
 '2015-2020': 2.5318797625,
 '2020-2025': 2.5139021613,
 '2025-2030': 2.482210943,
 '2030-2035': 2.4174409132,
 '2035-2040': 2.3401005609,
 '2040-2045': 2.2642698388,
 '2045-2050': 2.1813925677},
{'Index': 16,
 'Region, subregion, country or area': 'Comoros',
 'Note': '',
 'Country\ncode': 174,
 '1950-1955': 6.5306545316,
 '1955-1960': 6.3209292878,
 '1960-1965': 6.0423608927,
 '1965-1970': 2.6567816188,
 '1970-1975': 1.8216329006,
 '1975-1980': 1.7791901437,
 '1980-1985': 1.8532680974,
 '1985-1990': 1.8010586726,
 '1990-1995': 0.3076435948,
 '1995-2000': -0.1567912111,
 '2000-2005': -0.1465469875,
 '2005-2010': 0.0701905892,
 '2010-2015': 0.352222841,
 '2015-2020': 0.6292653891,
 '2020-2025': 0.8932967916,
 '2025-2030': 1.1393704204,
 '2030-2035': 1.2097792402,
 '2035-2040': 1.1718974037,
 '2040-2045': 1.1338552913,
 '2045-2050': 1.0945071504},
{'Index': 17,
 'Region, subregion, country or area': 'Djibouti',
 'Note': '',
 'Country\ncode': 262,
 '1950-1955': 2.4557753466,
 '1955-1960': 2.2319013437,
 '1960-1965': 2.1758851189,
 '1965-1970': 1.9246979888,
 '1970-1975': 1.6655730541,
 '1975-1980': 1.4237756928,
 '1980-1985': 0.7697809791,
 '1985-1990': 0.2735955498,
 '1990-1995': 0.0901109519,
 '1995-2000': 0.0607203146,
 '2000-2005': 0.059754893,
 '2005-2010': 0.0619147217,
 '2010-2015': 0.1082791993,
 '2015-2020': 0.1659397604,
 '2020-2025': 0.2186259683,
 '2025-2030': 0.2640875684,
 '2030-2035': 0.3015824768,
 '2035-2040': 0.301470858,
 '2040-2045': 0.2819255858,
 '2045-2050': 0.2626628117},
{'Index': 18,
 'Region, subregion, country or area': 'Eritrea',
 'Note': '',
 'Country\ncode': 232,
 '1950-1955': 3.2457301625,
 '1955-1960': 3.1979809497,
 '1960-1965': 3.1421158967,
 '1965-1970': 2.0096414675,
 '1970-1975': 1.2727192123,
 '1975-1980': 1.2605870484,
 '1980-1985': 1.8150238016,
 '1985-1990': 3.6428345273,
 '1990-1995': 3.4942180118,
 '1995-2000': 3.3257007317,
 '2000-2005': 3.1350657962,
 '2005-2010': 2.4631987735,
 '2010-2015': 1.6531393668,
 '2015-2020': 1.5801459221,
 '2020-2025': 1.495388019,
 '2025-2030': 1.3992688234,
 '2030-2035': 1.287735831,
 '2035-2040': 1.1780209026,
 '2040-2045': 1.1023252925,
 '2045-2050': 1.0271088681},
{'Index': 19,
 'Region, subregion, country or area': 'Ethiopia',
 'Note': '',
 'Country\ncode': 231,
 '1950-1955': 3.3691556259,
 '1955-1960': 3.3385381528,
 '1960-1965': 3.2999052785,
 '1965-1970': 2.4785924732,
 '1970-1975': 1.9341300609,
 '1975-1980': 1.9138899913,
 '1980-1985': 1.9096964358,
 '1985-1990': 1.9422077772,
 '1990-1995': 1.8252221826,
 '1995-2000': 1.2788336871,
 '2000-2005': 1.2619165119,
 '2005-2010': 1.9628690479,
 '2010-2015': 2.2982231947,
 '2015-2020': 2.2073298953,
 '2020-2025': 2.1630897715,
 '2025-2030': 2.1050590371,
 '2030-2035': 2.0293108123,
 '2035-2040': 1.932855433,
 '2040-2045': 1.8093403233,
 '2045-2050': 1.7160779209},
{'Index': 20,
 'Region, subregion, country or area': 'Kenya',
 'Note': '',
 'Country\ncode': 404,
 '1950-1955': 2.7656611033,
 '1955-1960': 2.7413858525,
 '1960-1965': 3.1202358941,
 '1965-1970': 3.5862982163,
 '1970-1975': 4.5330730745,
 '1975-1980': 3.7573716452,
 '1980-1985': 0.626669926,
 '1985-1990': 0.8152955079,
 '1990-1995': 1.7319661411,
 '1995-2000': 1.7088097129,
 '2000-2005': 1.7168376363,
 '2005-2010': 1.6771524039,
 '2010-2015': 1.6967654193,
 '2015-2020': 1.7434101795,
 '2020-2025': 1.7716370476,
 '2025-2030': 1.7751236294,
 '2030-2035': 1.747455918,
 '2035-2040': 1.6741444549,
 '2040-2045': 1.5881278538,
 '2045-2050': 1.4984871012},
{'Index': 21,
 'Region, subregion, country or area': 'Madagascar',
 'Note': '',
 'Country\ncode': 450,
 '1950-1955': 3.1313068919,
 '1955-1960': 3.0823871577,
 '1960-1965': 3.0238610475,
 '1965-1970': 2.6034661767,
 '1970-1975': 2.941480551,
 '1975-1980': 2.5163672736,
 '1980-1985': 2.4451934499,
 '1985-1990': 2.3695626836,
 '1990-1995': 1.8082889171,
 '1995-2000': 1.001777888,
 '2000-2005': 1.2110608918,
 '2005-2010': 2.0587028656,
 '2010-2015': 1.9410135155,
 '2015-2020': 1.8138753853,
 '2020-2025': 1.6768063861,
 '2025-2030': 1.5320072697,
 '2030-2035': 1.3714265342,
 '2035-2040': 1.2694488719,
 '2040-2045': 1.1889154064,
 '2045-2050': 1.1087231478},
{'Index': 22,
 'Region, subregion, country or area': 'Malawi',
 'Note': '',
 'Country\ncode': 454,
 '1950-1955': 2.2527151041,
 '1955-1960': 2.2443537077,
 '1960-1965': 2.2307459952,
 '1965-1970': 4.1937498012,
 '1970-1975': 4.6882606934,
 '1975-1980': 3.3559541227,
 '1980-1985': 2.3197783289,
 '1985-1990': 2.5759437818,
 '1990-1995': 2.7485468054,
 '1995-2000': 1.934560445,
 '2000-2005': 0.598750217,
 '2005-2010': 0.6406195093,
 '2010-2015': 0.9657524776,
 '2015-2020': 1.3211678345,
 '2020-2025': 1.6577140718,
 '2025-2030': 1.9634529357,
 '2030-2035': 2.2046456685,
 '2035-2040': 2.2010720503,
 '2040-2045': 2.1185772664,
 '2045-2050': 2.0307045555},
{'Index': 23,
 'Region, subregion, country or area': 'Mauritius',
 'Note': 1,
 'Country\ncode': 480,
 '1950-1955': 1.5049922464,
 '1955-1960': 2.0951253192,
 '1960-1965': 1.9810979517,
 '1965-1970': 1.8650297276,
 '1970-1975': 0.4125775672,
 '1975-1980': -0.5091540089,
 '1980-1985': -0.012282111,
 '1985-1990': 0.7307278412,
 '1990-1995': -0.2826253674,
 '1995-2000': -0.2857390902,
 '2000-2005': -0.2632672299,
 '2005-2010': -0.266297694,
 '2010-2015': -0.268915686,
 '2015-2020': -0.117417167,
 '2020-2025': 0.138381785,
 '2025-2030': 0.3894299866,
 '2030-2035': 0.6303438007,
 '2035-2040': 0.8517132355,
 '2040-2045': 0.956162368,
 '2045-2050': 0.9173777444},
{'Index': 24,
 'Region, subregion, country or area': 'Mayotte',
 'Note': '',
 'Country\ncode': 175,
 '1950-1955': 6.6504828927,
 '1955-1960': 6.3649423119,
 '1960-1965': 5.9870745682,
 '1965-1970': 2.6431501738,
 '1970-1975': 1.8217177573,
 '1975-1980': 1.7615154609,
 '1980-1985': 1.8523351779,
 '1985-1990': 1.7724752332,
 '1990-1995': 2.7915969388,
 '1995-2000': 2.8180043081,
 '2000-2005': 1.0214238366,
 '2005-2010': -0.5154238427,
 '2010-2015': -0.8193509982,
 '2015-2020': -0.5339976472,
 '2020-2025': -0.1831269313,
 '2025-2030': 0.1761313253,
 '2030-2035': 0.5273684043,
 '2035-2040': 0.8378778079,
 '2040-2045': 0.8824990366,
 '2045-2050': 0.8433255729},
{'Index': 25,
 'Region, subregion, country or area': 'Mozambique',
 'Note': '',
 'Country\ncode': 508,
 '1950-1955': 2.2807969265,
 '1955-1960': 2.2637783278,
 '1960-1965': 2.6982732681,
 '1965-1970': 2.6865248408,
 '1970-1975': 3.796037042,
 '1975-1980': 3.8223047617,
 '1980-1985': 6.6258175576,
 '1985-1990': 6.2111001665,
 '1990-1995': 1.9025669018,
 '1995-2000': 1.1333054667,
 '2000-2005': 0.6098920896,
 '2005-2010': 1.1849038704,
 '2010-2015': 1.5529464617,
 '2015-2020': 1.4971870186,
 '2020-2025': 1.4712130838,
 '2025-2030': 1.435780242,
 '2030-2035': 1.3870710686,
 '2035-2040': 1.3207242609,
 '2040-2045': 1.2304585534,
 '2045-2050': 1.1482756922},
{'Index': 26,
 'Region, subregion, country or area': 'Réunion',
 'Note': '',
 'Country\ncode': 638,
 '1950-1955': 3.4571130017,
 '1955-1960': 3.2405645374,
 '1960-1965': 3.0008844025,
 '1965-1970': 1.759176817,
 '1970-1975': 1.2995594759,
 '1975-1980': 3.6948067216,
 '1980-1985': 4.7792779044,
 '1985-1990': 3.5795211352,
 '1990-1995': 1.1696471302,
 '1995-2000': 1.1396973258,
 '2000-2005': 1.0954832001,
 '2005-2010': 0.4515522678,
 '2010-2015': 0.1694308556,
 '2015-2020': 0.0643223099,
 '2020-2025': 0.0270740517,
 '2025-2030': 0.0118208642,
 '2030-2035': 0.0048064888,
 '2035-2040': 0.0018021355,
 '2040-2045': 0.0018019732,
 '2045-2050': 0.0016016176},
{'Index': 27,
 'Region, subregion, country or area': 'Rwanda',
 'Note': '',
 'Country\ncode': 646,
 '1950-1955': 2.074070289,
 '1955-1960': 2.0645208626,
 '1960-1965': 2.059461051,
 '1965-1970': 2.0557910443,
 '1970-1975': 4.4904037257,
 '1975-1980': 3.3245281097,
 '1980-1985': 1.3750556107,
 '1985-1990': 1.3716822702,
 '1990-1995': 11.9358650184,
 '1995-2000': 8.3390774436,
 '2000-2005': 2.4983754084,
 '2005-2010': 0.0260001218,
 '2010-2015': 0.0825035055,
 '2015-2020': 0.4971797429,
 '2020-2025': 0.9598437716,
 '2025-2030': 1.4039739643,
 '2030-2035': 1.8171306558,
 '2035-2040': 2.1563934474,
 '2040-2045': 2.1755402401,
 '2045-2050': 2.0926628401},
{'Index': 28,
 'Region, subregion, country or area': 'Seychelles',
 'Note': '',
 'Country\ncode': 690,
 '1950-1955': 0.0408356871,
 '1955-1960': 0.1581781573,
 '1960-1965': 3.5954139306,
 '1965-1970': 3.3015162492,
 '1970-1975': 3.3820726499,
 '1975-1980': 1.2970915609,
 '1980-1985': -0.030002641,
 '1985-1990': -0.0089283904,
 '1990-1995': 0.1468111705,
 '1995-2000': 0.3197957527,
 '2000-2005': 0.4846323916,
 '2005-2010': 0.6346836603,
 '2010-2015': 0.7593613687,
 '2015-2020': 0.7601006844,
 '2020-2025': 0.7225486959,
 '2025-2030': 0.686018756,
 '2030-2035': 0.6497874926,
 '2035-2040': 0.6147490345,
 '2040-2045': 0.5804717974,
 '2045-2050': 0.5471492412},
{'Index': 29,
 'Region, subregion, country or area': 'Somalia',
 'Note': '',
 'Country\ncode': 706,
 '1950-1955': 3.118006876,
 '1955-1960': 3.0370482811,
 '1960-1965': 2.8506149789,
 '1965-1970': 2.5492927988,
 '1970-1975': 2.3440945233,
 '1975-1980': 0.9684063777,
 '1980-1985': 0.9514834479,
 '1985-1990': 1.1027478912,
 '1990-1995': 1.1574370185,
 '1995-2000': 1.1272156598,
 '2000-2005': 1.763123764,
 '2005-2010': 1.5871642753,
 '2010-2015': 1.9080536065,
 '2015-2020': 1.2964061184,
 '2020-2025': 1.2508799929,
 '2025-2030': 1.1952639354,
 '2030-2035': 1.1271165266,
 '2035-2040': 1.0425536869,
 '2040-2045': 0.9627059904,
 '2045-2050': 0.8956074201},
{'Index': 30,
 'Region, subregion, country or area': 'South Sudan',
 'Note': '',
 'Country\ncode': 728,
 '1950-1955': -0.1335526439,
 '1955-1960': -0.1321640904,
 '1960-1965': -0.1330432707,
 '1965-1970': -0.1316174005,
 '1970-1975': -0.1324892985,
 '1975-1980': -0.1333728254,
 '1980-1985': 2.8912633894,
 '1985-1990': 5.9819152266,
 '1990-1995': 3.5732331746,
 '1995-2000': 0.7796644636,
 '2000-2005': 0.772572136,
 '2005-2010': 0.8066438576,
 '2010-2015': 1.0811086723,
 '2015-2020': 1.3802817834,
 '2020-2025': 1.6563016764,
 '2025-2030': 1.9009827783,
 '2030-2035': 2.082413546,
 '2035-2040': 2.0598036368,
 '2040-2045': 1.9744434309,
 '2045-2050': 1.8832161728},
{'Index': 31,
 'Region, subregion, country or area': 'Uganda',
 'Note': '',
 'Country\ncode': 800,
 '1950-1955': 4.5025479558,
 '1955-1960': 4.4719289975,
 '1960-1965': 4.4184477175,
 '1965-1970': 3.8067357275,
 '1970-1975': 1.0977653061,
 '1975-1980': 1.356358782,
 '1980-1985': 3.8909265074,
 '1985-1990': 3.8161634134,
 '1990-1995': 2.9650374705,
 '1995-2000': 2.812966166,
 '2000-2005': 2.7435368646,
 '2005-2010': 2.6707752576,
 '2010-2015': 2.5873924116,
 '2015-2020': 2.4653623233,
 '2020-2025': 2.3119771961,
 '2025-2030': 2.1512144175,
 '2030-2035': 1.9793379039,
 '2035-2040': 1.7919444982,
 '2040-2045': 1.6308118143,
 '2045-2050': 1.5449840885},
{'Index': 32,
 'Region, subregion, country or area': 'United Republic of Tanzania',
 'Note': 2,
 'Country\ncode': 834,
 '1950-1955': 4.6691935651,
 '1955-1960': 3.4763595014,
 '1960-1965': 2.7856225859,
 '1965-1970': 5.2804253135,
 '1970-1975': 7.0062482547,
 '1975-1980': 5.337077761,
 '1980-1985': 2.8295618352,
 '1985-1990': 2.3780466746,
 '1990-1995': 1.6841049525,
 '1995-2000': 1.6493986836,
 '2000-2005': 2.1533268113,
 '2005-2010': 2.4722229571,
 '2010-2015': 2.3485455542,
 '2015-2020': 2.1623576682,
 '2020-2025': 1.964081508,
 '2025-2030': 1.7647865891,
 '2030-2035': 1.5646132888,
 '2035-2040': 1.3588446741,
 '2040-2045': 1.2475202235,
 '2045-2050': 1.1673987217},
{'Index': 33,
 'Region, subregion, country or area': 'Zambia',
 'Note': '',
 'Country\ncode': 894,
 '1950-1955': 4.6484422233,
 '1955-1960': 4.4725178826,
 '1960-1965': 5.0628736805,
 '1965-1970': 5.225814824,
 '1970-1975': 2.8126220223,
 '1975-1980': 2.6156631741,
 '1980-1985': -0.0805336435,
 '1985-1990': -0.1254715607,
 '1990-1995': -1.2043736997,
 '1995-2000': -1.2809984824,
 '2000-2005': 1.1766950642,
 '2005-2010': 1.2822684398,
 '2010-2015': 1.2565969164,
 '2015-2020': 1.2586198905,
 '2020-2025': 1.2460746591,
 '2025-2030': 1.2169998581,
 '2030-2035': 1.1677403448,
 '2035-2040': 1.0941065571,
 '2040-2045': 1.0222209571,
 '2045-2050': 0.9503950216},
{'Index': 34,
 'Region, subregion, country or area': 'Zimbabwe',
 'Note': '',
 'Country\ncode': 716,
 '1950-1955': 1.7029260847,
 '1955-1960': 1.6837775153,
 '1960-1965': 2.9611784241,
 '1965-1970': 3.437869113,
 '1970-1975': 2.7015623315,
 '1975-1980': 2.3680690137,
 '1980-1985': 2.5506945211,
 '1985-1990': 2.6316349593,
 '1990-1995': 1.8088736839,
 '1995-2000': 1.2378358165,
 '2000-2005': 0.2074634033,
 '2005-2010': -0.5432241939,
 '2010-2015': -0.494680682,
 '2015-2020': -0.0885080436,
 '2020-2025': 0.3754622902,
 '2025-2030': 0.8258614678,
 '2030-2035': 1.2389333405,
 '2035-2040': 1.5711830032,
 '2040-2045': 1.5804235664,
 '2045-2050': 1.4925084892},
{'Index': 35,
 'Region, subregion, country or area': 'Middle Africa',
 'Note': '',
 'Country\ncode': 911,
 '1950-1955': 2.3233391392,
 '1955-1960': 2.3651121588,
 '1960-1965': 2.1405262334,
 '1965-1970': 2.2628404734,
 '1970-1975': 2.7679594714,
 '1975-1980': 2.1882236154,
 '1980-1985': 1.9496423715,
 '1985-1990': 1.8907624675,
 '1990-1995': 1.6400468168,
 '1995-2000': 1.4584945897,
 '2000-2005': 1.3741375457,
 '2005-2010': 1.1960706122,
 '2010-2015': 1.1653276674,
 '2015-2020': 1.114061915,
 '2020-2025': 1.0737962951,
 '2025-2030': 1.0259914061,
 '2030-2035': 0.9665973707,
 '2035-2040': 0.901774494,
 '2040-2045': 0.841809073,
 '2045-2050': 0.7880068185},
{'Index': 36,
 'Region, subregion, country or area': 'Angola',
 'Note': '',
 'Country\ncode': 24,
 '1950-1955': 3.2258122942,
 '1955-1960': 3.1777913987,
 '1960-1965': 3.6176610518,
 '1965-1970': 3.5826164912,
 '1970-1975': 4.9194762496,
 '1975-1980': 4.7848162455,
 '1980-1985': 4.4401401947,
 '1985-1990': 4.048023971,
 '1990-1995': 3.4644186967,
 '1995-2000': 2.5147661566,
 '2000-2005': 2.2318039471,
 '2005-2010': 1.3073929774,
 '2010-2015': 1.1893562161,
 '2015-2020': 1.0377622323,
 '2020-2025': 0.8883195471,
 '2025-2030': 0.7545520808,
 '2030-2035': 0.6357234767,
 '2035-2040': 0.5273762358,
 '2040-2045': 0.4630592303,
 '2045-2050': 0.4267224151},
{'Index': 37,
 'Region, subregion, country or area': 'Cameroon',
 'Note': '',
 'Country\ncode': 120,
 '1950-1955': 4.0606973252,
 '1955-1960': 3.9591160259,
 '1960-1965': 3.8316463006,
 '1965-1970': 3.6898279376,
 '1970-1975': 5.9194546581,
 '1975-1980': 3.1334096292,
 '1980-1985': 2.5335721168,
 '1985-1990': 1.8064954202,
 '1990-1995': 1.4190554451,
 '1995-2000': 1.3482945517,
 '2000-2005': 1.2754764909,
 '2005-2010': 1.206359627,
 '2010-2015': 1.1380817629,
 '2015-2020': 1.0639402174,
 '2020-2025': 0.9844052918,
 '2025-2030': 0.8984098158,
 '2030-2035': 0.8106454329,
 '2035-2040': 0.7507120346,
 '2040-2045': 0.6944722997,
 '2045-2050': 0.6408176169},
{'Index': 38,
 'Region, subregion, country or area': 'Central African Republic',
 'Note': '',
 'Country\ncode': 140,
 '1950-1955': 3.3792453715,
 '1955-1960': 3.2656024101,
 '1960-1965': 3.1417758011,
 '1965-1970': 3.1217289628,
 '1970-1975': 3.018683773,
 '1975-1980': 1.1563703312,
 '1980-1985': 0.9557188088,
 '1985-1990': 0.7148652688,
 '1990-1995': 0.2192957047,
 '1995-2000': 0.217979986,
 '2000-2005': 0.2271911153,
 '2005-2010': 0.4339354091,
 '2010-2015': 0.6936702665,
 '2015-2020': 0.9318448025,
 '2020-2025': 1.1367951849,
 '2025-2030': 1.2917219069,
 '2030-2035': 1.2910065377,
 '2035-2040': 1.2101080101,
 '2040-2045': 1.1298493598,
 '2045-2050': 1.0508279865},
{'Index': 39,
 'Region, subregion, country or area': 'Chad',
 'Note': '',
 'Country\ncode': 148,
 '1950-1955': 3.9952238216,
 '1955-1960': 3.9504478258,
 '1960-1965': 4.5516951488,
 '1965-1970': 6.3859385767,
 '1970-1975': 5.9369276624,
 '1975-1980': 3.761521855,
 '1980-1985': 1.0291125503,
 '1985-1990': 1.0172184854,
 '1990-1995': 0.6262927783,
 '1995-2000': 0.1521696044,
 '2000-2005': 0.1510205619,
 '2005-2010': 0.1680912466,
 '2010-2015': 0.4764270224,
 '2015-2020': 0.8733873855,
 '2020-2025': 1.2508709561,
 '2025-2030': 1.5953233329,
 '2030-2035': 1.8856087936,
 '2035-2040': 1.9343735595,
 '2040-2045': 1.8471796663,
 '2045-2050': 1.7556382677},
{'Index': 40,
 'Region, subregion, country or area': 'Congo',
 'Note': '',
 'Country\ncode': 178,
 '1950-1955': 2.4277444082,
 '1955-1960': 2.317802197,
 '1960-1965': 2.1985806618,
 '1965-1970': 2.074921626,
 '1970-1975': 2.0091400073,
 '1975-1980': 2.0179303454,
 '1980-1985': 1.745346303,
 '1985-1990': 0.7896281081,
 '1990-1995': 0.7546702031,
 '1995-2000': 0.7930983187,
 '2000-2005': 0.7664515836,
 '2005-2010': 0.7302572252,
 '2010-2015': 0.7103286206,
 '2015-2020': 0.6856683263,
 '2020-2025': 0.6543791801,
 '2025-2030': 0.6167734922,
 '2030-2035': 0.5706412239,
 '2035-2040': 0.5268036717,
 '2040-2045': 0.4851812102,
 '2045-2050': 0.446457267},
{'Index': 41,
 'Region, subregion, country or area': 'Democratic Republic of the Congo',
 'Note': '',
 'Country\ncode': 180,
 '1950-1955': 1.5644134039,
 '1955-1960': 1.5335534643,
 '1960-1965': 0.9920256156,
 '1965-1970': 0.9776726815,
 '1970-1975': 0.9623304202,
 '1975-1980': 0.9462373818,
 '1980-1985': 1.037202804,
 '1985-1990': 1.4343547123,
 '1990-1995': 1.390170443,
 '1995-2000': 1.3448266673,
 '2000-2005': 1.3001284631,
 '2005-2010': 1.307405268,
 '2010-2015': 1.3186169716,
 '2015-2020': 1.3121090587,
 '2020-2025': 1.2860314854,
 '2025-2030': 1.2322802445,
 '2030-2035': 1.1578240256,
 '2035-2040': 1.0816706892,
 '2040-2045': 1.0067877871,
 '2045-2050': 0.9337745525},
{'Index': 42,
 'Region, subregion, country or area': 'Equatorial Guinea',
 'Note': '',
 'Country\ncode': 226,
 '1950-1955': 5.4975301692,
 '1955-1960': 4.5360359789,
 '1960-1965': 0.7418364188,
 '1965-1970': 0.3382301501,
 '1970-1975': 0.3355240194,
 '1975-1980': 0.3342938071,
 '1980-1985': 1.4314555664,
 '1985-1990': 2.9768059555,
 '1990-1995': 3.0623627645,
 '1995-2000': 3.8508454749,
 '2000-2005': 3.24508171,
 '2005-2010': 2.6559012682,
 '2010-2015': 1.3702302015,
 '2015-2020': 0.6914323808,
 '2020-2025': 0.5903791421,
 '2025-2030': 0.5028560527,
 '2030-2035': 0.4272303199,
 '2035-2040': 0.3608500742,
 '2040-2045': 0.3160060552,
 '2045-2050': 0.2953968731},
{'Index': 43,
 'Region, subregion, country or area': 'Gabon',
 'Note': '',
 'Country\ncode': 266,
 '1950-1955': 4.3008127149,
 '1955-1960': 4.1540253188,
 '1960-1965': 6.2455870269,
 '1965-1970': 5.9420258874,
 '1970-1975': 5.8957913353,
 '1975-1980': 4.8201823613,
 '1980-1985': 2.6412547702,
 '1985-1990': 2.0515899526,
 '1990-1995': 1.572019069,
 '1995-2000': 1.0627451101,
 '2000-2005': 0.8860254622,
 '2005-2010': 0.7337192111,
 '2010-2015': 0.5954911793,
 '2015-2020': 0.4430909017,
 '2020-2025': 0.3250099046,
 '2025-2030': 0.2377478046,
 '2030-2035': 0.1717136136,
 '2035-2040': 0.1218169584,
 '2040-2045': 0.1037365429,
 '2045-2050': 0.0954111659},
{'Index': 44,
 'Region, subregion, country or area': 'Sao Tome and Principe',
 'Note': '',
 'Country\ncode': 678,
 '1950-1955': 1.7655389194,
 '1955-1960': 1.7383045879,
 '1960-1965': 6.1256348219,
 '1965-1970': 6.0315532016,
 '1970-1975': 1.3878058016,
 '1975-1980': 1.1323488831,
 '1980-1985': 2.5573364352,
 '1985-1990': 2.7456531894,
 '1990-1995': 2.1620745084,
 '1995-2000': 1.8799779112,
 '2000-2005': 2.0414013527,
 '2005-2010': 1.8663676945,
 '2010-2015': 1.5465867299,
 '2015-2020': 1.15719198,
 '2020-2025': 0.8527949176,
 '2025-2030': 0.6189867552,
 '2030-2035': 0.4370137783,
 '2035-2040': 0.3040342923,
 '2040-2045': 0.2707559977,
 '2045-2050': 0.2526001472}]},
'allDocs': ['30 Largest Cities in 2018',
'30 Largest Cities',
'Age-specific fertility rates (births per 1,000 women)',
'Capital Cities',
'CITIES IN EUROPE AND CENTRAL ASIA_ A SHIFTING STORY OF URBAN GROWTH AND DECLINE DATABASE',
'Cities Over 300K Annual',
'Cities Over 300K',
'CITY PERSPECTIVE INITIATIVE',
'City Size Class-Number',
'City Size Class-Percentage',
'City Size Class-Population',
'City Size Class',
'Crude birth rate (CBR)',
'Data Source Urban Agglomeration and Capital Cities  ',
'Data Source Urban Population  ',
'Growth Rate Cities',
'LEARNING POVERTY_HISTORICAL DATA AND SUB-COMPONENTS',
'Locations ',
'Median Age of Population',
'Number of births',
'Percentage Total in Cities',
'Percentage Urban in Cities',
'Population Density',
'Population Growth Rate',
'Proportion Ubran Annual',
'Proportion Urban',
'Rate of Natural Population Increase',
'Rate Proportion Rural',
'Rural Growth Rate',
'Rural Population Annual',
'Rural Population',
'Sex Ratio of Total Population',
'Total fertility rates',
'Total Growth Rate',
'Total Population - Both Sexes',
'Total Population - Female',
'Total Population - Male',
'Total Population Annual',
'Total Population',
'Total Urban Rural',
'URBAN FLOODING OF GREATER DHAKA IN A CHANGING CLIMATE - BUILDING RESILIENCE TO DISASTER RISK',
'Urban Growth Rate',
'Urban Population Annual',
'Urban Population',
'Urbanization Rate']}